(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired320"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired320"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3hKcV", function(module, exports) {

$parcel$export(module.exports, "InvoiceApprovingFilter", () => $e3dd6085cfbe4448$export$18a674718e7f3a8e);

var $e0mX2 = parcelRequire("e0mX2");

var $9QECq = parcelRequire("9QECq");
class $e3dd6085cfbe4448$export$18a674718e7f3a8e extends (0, $e0mX2.UiBaseFilter) {
    beforeIndex() {
        this.wrapFilter((0, $9QECq.formGroup)("number", "\u010C\xedslo dokladu", `<input type="search" class="form-control" mu-bind="number" />`, true) + (0, $9QECq.formGroup)("vendorId", "Subjekt", `<div mu-widget="UiTomSelect" mu-id="vendorId" mu-bind="vendorId"></div>`, true) + (0, $9QECq.formGroup)("buSubjectId", "Na\u0161e firma", `<div mu-widget="UiTomSelect" mu-id="buSubjectId" mu-bind="buSubjectId"></div>`, true) + (0, $9QECq.formGroup)("orgDivisionId", "St\u0159edisko", `<div mu-widget="TreeSelector" mu-id="orgDivisionId" mu-bind="orgDivisionId" mu-params='{"inModal":true,"multiple":true,"useModalClass":false}'></div>`, true) + (0, $9QECq.formGroup)("orgProjectId", "Projekt", `<div mu-widget="UiTomSelect" mu-id="orgProjectId" mu-bind="orgProjectId"></div>`, true) + (0, $9QECq.formGroup)("orgProductId", "Produkt", `<div mu-widget="UiTomSelect" mu-id="orgProductId" mu-bind="orgProductId"></div>`, true) + (0, $9QECq.formGroup)("dtTax", "DUZP", `<div mu-widget="UiDateFilter" mu-bind="dtTax"></div>`, true) + (0, $9QECq.formGroup)("dtDue", "Splatnost", `<div mu-widget="UiDateFilter" mu-bind="dtDue"></div>`, true) + (0, $9QECq.formGroup)("amountWT", "\u010C\xe1stka s DPH", `<div mu-widget="UiNumberRange" mu-bind="amountWT"></div>`, true) + (0, $9QECq.formGroup)("amountNT", "\u010C\xe1stka bez DPH", `<div mu-widget="UiNumberRange" mu-bind="amountNT"></div>`, true) + (0, $9QECq.formGroup)("orgProjectId", "Kategorie", `<div mu-widget="UiTomSelect" mu-id="ticketTypeId" mu-bind="ticketTypeId"></div>`, true) + (0, $9QECq.formGroup)("orgProjectId", "Typ dokladu", `<div mu-widget="UiTomSelect" mu-id="accountingDocumentTypeId" mu-bind="accountingDocumentTypeId"></div>`, true));
    }
    async afterIndex() {
        await Promise.all([
            this.orgDivisionPromise.fetch().then((ls)=>{
                this.muNamedWidget.orgDivisionId.bindTree(ls);
            }),
            this.orgProductPromise.fetch().then((ls)=>this.muNamedWidget.orgProductId.init({
                    labelField: "title",
                    multiple: true
                }).bindItems(ls)),
            this.orgProjectPromise.fetch().then((ls)=>this.muNamedWidget.orgProjectId.init({
                    labelField: "title",
                    multiple: true
                }).bindItems(ls)),
            this.vendorPromise.fetch().then((ls)=>this.muNamedWidget.vendorId.init({
                    labelField: "name",
                    multiple: true,
                    searchField: [
                        "name",
                        "identificationNumber"
                    ]
                }).bindItems(ls)),
            this.myBuSubjectPromise.fetch().then((ls)=>this.muNamedWidget.buSubjectId.init({
                    labelField: "name",
                    multiple: true
                }).bindItems([
                    {
                        name: "Nezad\xe1no",
                        value: "null"
                    },
                    ...ls
                ])),
            this.ticketTypePromise.fetch().then((ls)=>this.muNamedWidget.ticketTypeId.init({
                    labelField: "name",
                    multiple: true
                }).bindItems(ls)),
            this.accountingDocumentTypePromise.fetch().then((ls)=>this.muNamedWidget.accountingDocumentTypeId.init({
                    labelField: "name",
                    multiple: true
                }).bindItems([
                    {
                        name: "Nezad\xe1no",
                        value: "null"
                    },
                    ...ls
                ]))
        ]);
        super.afterIndex();
    }
}

});
parcelRegister("e0mX2", function(module, exports) {

$parcel$export(module.exports, "UiBaseFilter", () => $e4b81f67eb03085d$export$48a593a775a080cb);

var $dMN2n = parcelRequire("dMN2n");
function $e4b81f67eb03085d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e4b81f67eb03085d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4b81f67eb03085d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e4b81f67eb03085d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e4b81f67eb03085d$var$_arrayLikeToArray(o, minLen);
}
function $e4b81f67eb03085d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $e4b81f67eb03085d$export$48a593a775a080cb extends (0, $dMN2n.MuWidget) {
    wrapFilter(src) {
        this.muAppendContent('<div mu-id="searchFields">' + src + `</div><div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zru\u{161}it filtr</span>
			</div>`);
    }
    afterIndex() {
        this.muBindData(this.getFilter());
    }
    showByField(field) {
        const res = [];
        // @ts-ignore
        for(var _iterator = $e4b81f67eb03085d$var$_createForOfIteratorHelperLoose(this.ui.searchFields.children), _step; !(_step = _iterator()).done;){
            const el = _step.value;
            const vis = !field || field == el.dataset.field;
            el.style.display = vis ? "" : "none";
            if (vis) res.push(el);
        }
        this.muVisible(!field, "bClearFilter");
        return res;
    }
    bFilter_click() {
        this.setFilter(this.muFetchData());
        this.muRemoveSelf();
    }
    bClearFilter_click() {
        this.setFilter({});
        this.muRemoveSelf();
    }
    eraseFilterField(ev, field) {
        this.muBindData({
            [field]: null
        });
    }
    muFetchData() {
        const filter = super.muFetchData();
        for(const k in filter)// prázdný seznam - nefiltruje se
        if (Array.isArray(filter[k]) && filter[k].length === 0) filter[k] = null;
        return filter;
    }
}

});
parcelRegister("dMN2n", function(module, exports) {
"use strict";
/*	This file is part of MuWidget.

    MuWidget is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    MuWidget is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with MuWidget.  If not, see <https://www.gnu.org/licenses/>. */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetAttributes = module.exports.MuWidget = void 0;

var $bjpdy = parcelRequire("bjpdy");

var $iDhgR = parcelRequire("iDhgR");
// export class MuWidget<TP extends MuWidget = MuWidget<any,{},{}>, TU extends Record<string, any&AnyElement> = {}, TW extends Record<string, any&AnyElement> = {}> {
class $a095cbd63e7a1f3b$var$MuWidget {
    muWidgetFromTemplate(templateName, container, params = null, position = "last", ref = null) {
        let finalContainer;
        if (typeof container == "string") {
            var containerName = container;
            finalContainer = this.ui[container];
            if (!finalContainer) throw new Error("Container with mu-id='" + containerName + "' not exists.");
        } else finalContainer = container;
        var tmpElemementType = "div";
        let templateContent;
        if (typeof templateName === "string") {
            templateContent = this.muFindTemplate(templateName);
            if (!templateContent) throw "No template named '" + templateName + "'.";
        } else templateContent = templateName.html;
        var tmpTemplate = templateContent;
        tmpTemplate = tmpTemplate.toLowerCase();
        if (tmpTemplate.startsWith("<tr")) tmpElemementType = "tbody";
        if (tmpTemplate.startsWith("<td") || tmpTemplate.startsWith("<th")) tmpElemementType = "tr";
        if (tmpTemplate.startsWith("<tbody") || tmpTemplate.startsWith("<thead") || tmpTemplate.startsWith("<tfoot")) tmpElemementType = "table";
        var element = document.createElementNS((finalContainer || this.container).namespaceURI, tmpElemementType);
        element.innerHTML = templateContent;
        element = element.firstElementChild;
        // const element = this.createElementFromHTML(templateContent, container || this.container);
        // if (params) element.setAttribute('mu-params', JSON.stringify(params));
        if (finalContainer) switch(position){
            case "first":
                if (finalContainer.firstElementChild) finalContainer.insertBefore(element, finalContainer.firstElementChild);
                else finalContainer.appendChild(element);
                break;
            case "before":
                finalContainer.insertBefore(element, ref);
                break;
            case "after":
                if (ref.nextElementSibling) finalContainer.insertBefore(element, ref.nextElementSibling);
                else finalContainer.appendChild(element);
                break;
            case "last":
                finalContainer.appendChild(element);
                break;
        }
        let widget = this.muActivateWidget(element, null, params || {}, typeof templateName === "string" ? null : templateName);
        let opts = this.muGetElementOpts(element);
        if (!opts.id) opts.id = typeof templateName === "string" ? templateName : null;
        this.muAddEvents(opts, element, widget);
        return widget;
    }
    muAppendContent(html) {
        this.container.innerHTML += html;
    }
    createElementFromHTML(src, container) {
        let lSrc = src.toLowerCase();
        let tmpElemementType = "div";
        if (lSrc.startsWith("<tr")) tmpElemementType = "tbody";
        if (lSrc.startsWith("<td") || lSrc.startsWith("<th")) tmpElemementType = "tr";
        if (lSrc.startsWith("<tbody") || lSrc.startsWith("<thead") || lSrc.startsWith("<tfoot")) tmpElemementType = "table";
        let element = document.createElementNS(container.namespaceURI, tmpElemementType);
        element.innerHTML = src;
        element = element.firstElementChild;
        return element;
    }
    muRemoveSelf() {
        if (this.container.parentNode) this.container.parentNode.removeChild(this.container);
    }
    muGetChildWidgets(container) {
        return $a095cbd63e7a1f3b$var$MuWidget.getChildWidgets(typeof container === "string" ? this.ui[container] : container);
    }
    muBindList(list, templateName, container, commonParams = {}, finalCalback = null) {
        var res = [];
        for (const item of list){
            var params = Object.assign(Object.assign({}, item), typeof commonParams === "function" ? commonParams(item) : commonParams);
            var widget = this.muWidgetFromTemplate(templateName, container, params);
            if (finalCalback) finalCalback(widget, item);
            res.push(widget);
        }
        return res;
    }
    muVisible(state, control) {
        if (Array.isArray(control)) for (const controlItem of control)this.muVisible(state, controlItem);
        else {
            let neg = false;
            if (typeof control === "string") {
                if (control.startsWith("!")) {
                    neg = true;
                    control = control.substring(1);
                }
                if (control === ".") control = this.container;
                else if (!(control in this.ui)) throw new Error("Control with mu-id='" + control + "' not found.");
                else control = this.ui[control];
            }
            //@ts-ignore
            if (state === "toggle") state = control.style.display === "none";
            //@ts-ignore
            control.style.display = state !== neg ? null : "none";
        }
    }
    muBindData(srcData) {
        //@ts-ignore
        $bjpdy.MuBinder.bindData(this.muBindOpts, srcData, this);
        this.muAfterBindData(srcData);
    }
    muFetchData() {
        //@ts-ignore
        return $bjpdy.MuBinder.fetchData(this.muBindOpts, this);
    }
    // protected muRegisterEvent(...args) { }
    // public addEventListener(name : string, handler : (...args)=>void) { }
    // public muEventNames() : string[] { return []; }
    muAfterBindData(data) {}
    constructor(container){
        this.ui = {}; //Record<string, AnyElementA> = {};
        this.muOpts = {};
        this.muWidgetEventHandlers = {};
        this.muIndexOpts = null;
        this.muSubWidgets = [];
        this.muNamedWidget = {}; // Record<string, MuWidget> = {};
        //@ts-ignore
        this.muRoot = this;
        this.muTemplates = {};
        this.muTemplateParents = {};
        this.muOnAfterIndex = [];
        this.muBindOpts = {};
        this.container = container;
    }
    // public constructor(container : AnyElement)
    muInit(container) {
        this.muOnAfterIndex = [];
        this.ui = {};
        this.muOpts = {
            attributePrefix: "mu-",
            bindEvents: [
                "click",
                "dblclick",
                "mouseenter",
                "mouseleave",
                "mousemove",
                "mouseout",
                "mouseover",
                "mouseup",
                "blur",
                "change",
                "focus",
                "select",
                "submit",
                "keyup",
                "keydown",
                "keypress",
                "scroll",
                "drag",
                "dragstart",
                "dragend",
                "dragover",
                "dragenter",
                "dragleave",
                "drop",
                "input",
                "touchstart",
                "touchmove",
                "touchend",
                "touchcancel"
            ],
            autoMethodNameSeparator: "_"
        };
        /*	opts ? opts : {}
        );*/ this.container = container;
        //@ts-ignore
        this.container.widget = this;
        this.muSubWidgets = [];
        this.muNamedWidget = {};
        this.muTemplates = {};
        this.muTemplateParents = {};
        //@ts-ignore
        this.muRoot = this;
        this.muWidgetEventHandlers = {};
        this.beforeIndex();
        this.muAddEvents({
            id: "container"
        }, this.container);
        this.muIndexTree(this.container, true);
    }
    beforeIndex() {}
    muDispatchEvent(name, ...args) {
        if (!(name in this.muWidgetEventHandlers)) throw new Error("Unknown event '" + name + "' on class '" + this.constructor.name + "'.");
        if (this.muWidgetEventHandlers[name]) {
            // const args = Array.from(arguments);
            // args[0] = <MuEvent>{
            const ev = {
                sender: this,
                originalEvent: event,
                args: Array.from(arguments).slice(1)
            };
            //console.log(args, arguments);
            /* for(const handler of this.muWidgetEventHandlers[name])
                handler.apply(this, args); */ for(let i = 0, l = this.muWidgetEventHandlers[name].length; i < l; i++){
                const handler = this.muWidgetEventHandlers[name][i];
                handler.call(this, ev);
            }
        }
    }
    muRegisterEvent(...args) {
        // for(var i = 0; i < arguments.length; i++) this.muWidgetEventHandlers[arguments[i]] = [];
        for (const eventName of args)this.muWidgetEventHandlers[eventName] = [];
    }
    addEventListener(name, handler) {
        if (!(name in this.muWidgetEventHandlers)) throw new Error("Unknown event '" + name + "' on class '" + this.constructor.name + "'.");
        this.muWidgetEventHandlers[name].push(handler);
    }
    muEventNames() {
        return Object.keys(this.muWidgetEventHandlers);
    }
    muActivateWidget(element, opts, extraParams = {}, widgetDef = null) {
        if (!opts) opts = this.muGetElementOpts(element);
        const widgetName = opts.widget;
        let widget;
        if (widgetDef) {
            if (widgetDef.classInstance) {
                widget = widgetDef.classInstance;
                widget.container = element;
            } else if (widgetDef.classType) widget = new widgetDef.classType(element, opts);
        }
        let c = null;
        if (!widget) {
            c = $a095cbd63e7a1f3b$var$MuWidget.widgetClasses[widgetName] || window[widgetName];
            if (!c) throw "Class '" + opts.widget + "' is not defined.";
            widget = new c(element, opts);
        }
        if (!(widget instanceof $a095cbd63e7a1f3b$var$MuWidget)) {
            if ($a095cbd63e7a1f3b$var$MuWidget.fixOldWidgets) {
                if ($a095cbd63e7a1f3b$var$MuWidget.fixOldWidgets !== "silent") console.error("Widget '" + widgetName + "' is not a descendant of the MuWidget class.");
                // extends prototype, class.prototype can not be enumarated
                //@ts-ignore
                if (c === null) c = {
                    prototype: widget.__proto__
                };
                for (var k of [
                    "addEventListener",
                    "addEventListener(name, handler)",
                    "beforeIndex",
                    "createElementFromHTML",
                    "muActivateWidget",
                    "muAddEvent",
                    "muAddEvents",
                    "muAddUi",
                    "muAfterBindData",
                    "muBindData",
                    "muBindList",
                    "muCallPlugin",
                    "muDispatchEvent",
                    "muEventNames",
                    "muFetchData",
                    "muFindMethod",
                    "muFindTemplate",
                    "muGetChildWidgets",
                    "muGetElementOpts",
                    "muGetMethodCallback",
                    "muIndexTree",
                    "muInit",
                    "muRegisterEvent",
                    "muRemoveSelf",
                    "muVisible",
                    "muWidgetFromTemplate",
                    "muGetRoot"
                ])if (!c.prototype[k]) c.prototype[k] = $a095cbd63e7a1f3b$var$MuWidget.prototype[k];
                c.prototype.muIndexForm = function(form) {
                    if (!form) {
                        if (this.container.tagName == "FORM") form = this.container;
                        else form = this.container.querySelector("form");
                    }
                    if (form) {
                        this.muAddUi("form", form);
                        this.muAddEvents({
                            id: "form"
                        }, form);
                        for(var i = 0, l = form.elements.length; i < l; i++){
                            var element = form.elements[i];
                            this.muAddUi(element.name, element);
                            this.muAddEvents({
                                id: element.name
                            }, element);
                        }
                    }
                };
            } else throw "Widget '" + widgetName + "' is not a descendant of the MuWidget class.";
        }
        widget.muParent = this;
        //@ts-ignore
        widget.muRoot = this.muRoot || this;
        if (opts.params) {
            const params = typeof opts.params === "string" ? $a095cbd63e7a1f3b$var$MuWidget.paramJsonS ? $iDhgR.JSONS.parse(opts.params) : JSON.parse(opts.params) : opts.params;
            for(const k in params)widget[k] = params[k];
        }
        if (extraParams) for(const k in extraParams)widget[k] = extraParams[k];
        // MuWidget.extendPrototype(widget);
        this.muSubWidgets.push(widget);
        //@ts-ignore
        if (opts.id) this.muNamedWidget[opts.id] = widget;
        // MuWidget.call(widget, element, /*opts.opts || this.muOpts */);
        widget.muInit(element);
        return widget;
    }
    muGetElementOpts(element) {
        var res = {};
        // Convert simplified syntax id:widget@template
        const simpleAttributeName = this.muOpts.attributePrefix.substring(0, this.muOpts.attributePrefix.length - 1);
        const simpleAttributeValue = element.getAttribute(simpleAttributeName);
        const ire = $a095cbd63e7a1f3b$var$MuWidget.identifierRe;
        if (simpleAttributeValue) {
            const m = simpleAttributeValue.match("(" + ire + ")? *(:(" + ire + "))? *(@(" + ire + "))? *(#(.*))?");
            if (m) {
                if (m[1]) element.setAttribute(this.muOpts.attributePrefix + "id", m[1]);
                if (m[3]) element.setAttribute(this.muOpts.attributePrefix + "widget", m[3]);
                if (m[5]) element.setAttribute(this.muOpts.attributePrefix + "template", m[5]);
                if (m[7]) element.setAttribute(this.muOpts.attributePrefix + "bind", m[7]);
                element.removeAttribute(simpleAttributeName);
            }
        }
        // other mu- parameters
        for(var i = 0, attributes = element.attributes, n = attributes.length, arr = []; i < n; i++){
            var name = attributes[i].nodeName;
            if (name.startsWith(this.muOpts.attributePrefix)) {
                var optName = name.substr(this.muOpts.attributePrefix.length);
                res[optName] = attributes[i].nodeValue;
            }
        }
        return res;
    }
    muFindTemplate(templateName) {
        let tmpTemplate = null;
        if (templateName.startsWith("shared:")) {
            let aTemplateName = templateName.substr(7);
            tmpTemplate = $a095cbd63e7a1f3b$var$MuWidget.sharedTemplates[aTemplateName];
        } else if (templateName.startsWith("ancestor:")) {
            let aTemplateName = templateName.substr(9);
            //@ts-ignore
            let w = this;
            while(w){
                if (w.muTemplates[aTemplateName]) {
                    tmpTemplate = w.muTemplates[aTemplateName];
                    break;
                }
                w = w.muParent;
            }
        } else tmpTemplate = this.muTemplates[templateName];
        return tmpTemplate;
    }
    muIndexTree(element, indexWidget, useName = null) {
        var _a;
        //@ts-ignore
        var ev = {
            element: element,
            widget: this,
            opts: this.muGetElementOpts(element)
        };
        if (indexWidget) this.muMetaData = {
            id: ev.opts.id,
            widget: this.constructor.name
        };
        //TODO: MuBinder
        // this.muCallPlugin("indexPrepareElement", ev);
        if (!ev.element) return;
        element = ev.element;
        var opts = ev.opts;
        if (opts.usetemplate) {
            var src = this.muFindTemplate(opts.usetemplate);
            // element.outerHTML = src;
            if (typeof src === "undefined") throw new Error("Template '" + opts.usetemplate + "' not exists.");
            var newElement = this.createElementFromHTML(src, element.parentNode);
            element.parentNode.insertBefore(newElement, element);
            element.parentNode.removeChild(element);
            element = newElement;
            if (opts.id) element.setAttribute(this.muOpts.attributePrefix + "id", opts.id);
            if (opts.params) element.setAttribute(this.muOpts.attributePrefix + "params", opts.params);
            if (opts.widget) element.setAttribute(this.muOpts.attributePrefix + "widget", opts.widget);
            if (opts.template) element.setAttribute(this.muOpts.attributePrefix + "template", opts.template);
            opts = this.muGetElementOpts(element);
        }
        if (opts.preproc) this.preproc(element, opts.preproc);
        this.muIndexOpts = opts;
        useName = useName || opts.usename;
        if (useName) {
            const n = (_a = element.attributes.getNamedItem("name")) === null || _a === void 0 ? void 0 : _a.value;
            if (n) opts.id = n;
        }
        if (opts.noindex) return;
        if (opts.template) {
            element.removeAttribute(this.muOpts.attributePrefix + "template");
            if (opts.template.startsWith("shared:")) {
                const name = opts.template.substring(7);
                if (name in $a095cbd63e7a1f3b$var$MuWidget.sharedTemplates) console.error("The widget already contains template '" + opts.template + "'.");
                $a095cbd63e7a1f3b$var$MuWidget.sharedTemplates[name] = element.outerHTML;
            } else {
                if (opts.template in this.muTemplates) console.error("The widget already contains template '" + opts.template + "'.");
                this.muTemplates[opts.template] = element.outerHTML;
                this.muTemplateParents[opts.template] = element.parentNode;
            }
            if (element.parentNode) element.parentNode.removeChild(element);
            return;
        }
        if (opts.id && element != this.container) this.muAddUi(opts.id, element);
        // if (opts.bind) this.muParseBinds(opts.bind, element);
        ev.opts = opts;
        this.muCallPlugin("beforeIndexElement", ev);
        if ((!opts.widget || indexWidget) && !opts.nocontent && element.children) {
            // Index children
            var elements = [];
            // Create copy, template modify children
            for (const el of element.children)elements.push(el);
            for (const el of elements)// if (elements[i])
            this.muIndexTree(el, false, useName);
        }
        var widget = null;
        if (opts.widget && !indexWidget) // Initialize widget
        widget = this.muActivateWidget(element, opts);
        this.muAddEvents(opts, element, widget);
        if (indexWidget) {
            this.afterIndex();
            for(var i = 0, l = this.muOnAfterIndex.length; i < l; i++)this.muOnAfterIndex[i](this);
        }
        this.muCallPlugin("afterIndexElement", ev);
    }
    muAddUi(id, element) {
        if (id in this.ui) console.error("The widget '" + /*this.muGetIdentification()*/ this.muIndexOpts.widget + "#" + this.muIndexOpts.id + "' already contains an element with mu-id '" + id + "'.");
        //@ts-ignore
        this.ui[id] = element;
    }
    /* muGetIdentification() {
        return this.muIndexOpts.widget + (this.muIndexOpts.id ? "#" + this.muIndexOpts.id : "");
    } */ muCallPlugin(eventName, eventArgs) {
        for (var plugin of $a095cbd63e7a1f3b$var$MuWidget.plugIns)if (plugin[eventName]) plugin[eventName](eventArgs);
    }
    afterIndex() {}
    preproc(element, preproc) {
        var p = preproc.indexOf(" ");
        var name = preproc;
        var paramsStr = "";
        if (p >= 0) {
            var name = preproc.substr(0, p);
            var paramsStr = preproc.substr(p);
        }
        if (!(name in $a095cbd63e7a1f3b$var$MuWidget.preproc)) throw new Error("Preproc '" + name + '" not defined.');
        var pp = $a095cbd63e7a1f3b$var$MuWidget.preproc[name];
        const mode = pp.prototype.preproc ? "class" : "function";
        if (mode === "function") paramsStr = "[" + paramsStr + "]";
        else paramsStr = "{" + paramsStr + "}";
        try {
            var params = paramsStr ? $a095cbd63e7a1f3b$var$MuWidget.paramJsonS ? $iDhgR.JSONS.parse(paramsStr) : JSON.parse(paramsStr) : null;
        } catch (exc) {
            throw new Error(exc.toString() + "\n" + paramsStr);
        }
        if (mode === "function") {
            params.unshift(element);
            pp.call(null, params);
        } else {
            var inst = new pp();
            for(var k in params)inst[k] = params[k];
            inst.preproc(element);
        }
    }
    muAddEvents(opts, element, widget = null) {
        var autoMethodName;
        var eventNames = [
            ...this.muOpts.bindEvents
        ];
        var wEvents = [];
        if (widget) {
            wEvents = widget.muEventNames();
            eventNames = [
                ...new Set([
                    ...eventNames,
                    ...wEvents
                ])
            ];
        }
        var tags = opts.tag ? opts.tag.split(" ") : null;
        for(var i = 0, l = eventNames.length; i < l; i++){
            const eventName = eventNames[i];
            const eventTarget = widget && wEvents.indexOf(eventName) >= 0 ? widget : element;
            let methodName = opts[eventName];
            if (methodName === undefined) {
                if (opts.id) {
                    autoMethodName = opts.id + this.muOpts.autoMethodNameSeparator + eventName;
                    if (autoMethodName in this) methodName = autoMethodName;
                }
            }
            if (methodName) this.muAddEvent(eventName, eventTarget, this.muGetMethodCallback(methodName));
            if (tags) for(var i1 = 0, l1 = tags.length; i1 < l1; i1++){
                autoMethodName = tags[i1] + this.muOpts.autoMethodNameSeparator + eventName;
                if (autoMethodName in this) this.muAddEvent(eventName, eventTarget, this.muGetMethodCallback(autoMethodName));
            }
        }
        // init
        if (tags) {
            const eventTarget = element;
            for(var i = 0, l = tags.length; i < l; i++){
                autoMethodName = tags[i] + this.muOpts.autoMethodNameSeparator + "init";
                if (autoMethodName in this) this.muGetMethodCallback(autoMethodName)(eventTarget);
            }
        }
    }
    muFindMethod(name, context) {
        var obj = context || this;
        //todo: blbne
        while(name.startsWith("parent.")){
            if (!obj.muParent) throw "Widget of class '" + obj.constructor.name + "' has not parent.";
            obj = obj.muParent;
            name = name.substr(7);
        }
        var params = [];
        var p = null;
        if (-1 != (p = name.indexOf(":"))) {
            const jsrc = "[" + name.substr(p + 1) + "]";
            params = $a095cbd63e7a1f3b$var$MuWidget.paramJsonS ? $iDhgR.JSONS.parse(jsrc) : JSON.parse(jsrc);
            name = name.substr(0, p);
        }
        var method = obj[name];
        if (method === undefined) throw "Undefined method '" + name + "' in class '" + obj.constructor.name + "'.";
        return {
            method: method,
            args: params,
            context: obj
        };
    }
    muGetMethodCallback(name, context = null) {
        const methodInfo = this.muFindMethod(name, context);
        return (ev /* , event : Event */ )=>{
            const callparams = [
                ev,
                ...methodInfo.args,
                ...ev.args || []
            ];
            return methodInfo.method.apply(methodInfo.context, callparams);
        };
    }
    muAddEvent(eventName, element, callback) {
        element.addEventListener(eventName, callback);
    /* (element as any).addEventListener(eventName, (/*ev : Event* /) => {
            // return callback(this, ev);
            // return callback.apply(null, arguments);
            console.log("muAddEvent:wrapper", arguments);
            return callback(...Array.from(arguments));
            // return callback.apply(null, [this].concat(Array.from(arguments)));
        }); */ }
    muGetRoot() {
        //@ts-ignore
        return this.muParent ? this.muParent.muGetRoot() : this;
    }
    muDebugGetClasses() {
        const uniqueClasses = new Set();
        this.container.querySelectorAll("[class]").forEach(function(element) {
            element.classList.forEach(function(className) {
                uniqueClasses.add(className);
            });
        });
        return Array.from(uniqueClasses);
    }
    static getChildWidgets(container) {
        const ls = [];
        for (const item of container.children)if (item.widget) ls.push(item.widget);
        return ls;
    }
    static registerAll() {
        for(var i = 0; i < arguments.length; i++){
            var classes = arguments[i];
            for(var k in classes)$a095cbd63e7a1f3b$var$MuWidget.widgetClasses[k] = classes[k];
        }
    }
    static registerAs(c, n) {
        $a095cbd63e7a1f3b$var$MuWidget.widgetClasses[n] = c;
    }
    static startup(startElement = null, onSucces = null, onBefore = null) {
        var fn = window.addEventListener || window.attachEvent || function(type, listener) {
            if (window.onload) {
                var curronload = window.onload;
                var newonload = function(evt) {
                    curronload(evt);
                    listener(evt);
                };
                window.onload = newonload;
            } else window.onload = listener;
        };
        fn("load", function() {
            if (onBefore) onBefore();
            var element = startElement || document.documentElement;
            var muRoot = new $a095cbd63e7a1f3b$var$MuWidget(element);
            muRoot.muInit(element);
            $a095cbd63e7a1f3b$var$MuWidget.root = muRoot;
            if (onSucces) onSucces(muRoot);
        });
    }
    static getWidget(el) {
        while(el){
            if (el.widget) return el.widget;
            //@ts-ignore
            el = el.parentElement;
        }
        return null;
    }
}
module.exports.MuWidget = $a095cbd63e7a1f3b$var$MuWidget;
$a095cbd63e7a1f3b$var$MuWidget.fixOldWidgets = false;
$a095cbd63e7a1f3b$var$MuWidget.sharedTemplates = {};
/*
use json simplified in params
true - always
false - newer
string - if content begining defined string
 */ $a095cbd63e7a1f3b$var$MuWidget.paramJsonS = "!";
$a095cbd63e7a1f3b$var$MuWidget.identifierRe = "[a-zA-Z_.][0-9a-zA-Z_.]*";
// statics
$a095cbd63e7a1f3b$var$MuWidget.widgetClasses = {};
$a095cbd63e7a1f3b$var$MuWidget.plugIns = [];
$a095cbd63e7a1f3b$var$MuWidget.eventLegacy = false;
function $a095cbd63e7a1f3b$var$SetAttributes(element, attrs) {
    for(const n in attrs)element.setAttribute(n, attrs[n].toString());
}
module.exports.SetAttributes = $a095cbd63e7a1f3b$var$SetAttributes; // export class MuWidget extends MuWidgetTyped<MuWidget, {}, {}> { }

});
parcelRegister("bjpdy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MuBinder = void 0;

var $6UZdI = parcelRequire("6UZdI");

var $iDhgR = parcelRequire("iDhgR");
class $022014c519811a95$var$MuBinder {
    static parse(src, element) {
        /*
        source
        source:target
        source::target
        source;target
        sourcer|filter():target
        */ let mode = "source";
        const optsList = [];
        const sp = new $6UZdI.StrParser(src);
        let p;
        let lastP = 0;
        function parseFetchBind(chunk, opts) {
            switch(chunk){
                case ":":
                case "::":
                case "^":
                    opts.forBind = chunk != "^";
                    opts.forFetch = chunk != ":";
                    return true;
                case ";":
                    mode = "complete";
                    opts.forBind = true;
                    opts.forFetch = false;
                    return true;
                default:
                    return false;
            }
        }
        function parseFilter(sp, bindPart, opts) {
            p = sp.findNext([
                "::",
                ":",
                "|",
                "^",
                ";",
                "("
            ]);
            let filter = {
                methodName: sp.substring(lastP, p).trim(),
                args: []
            };
            if (!p) mode = "end";
            else if (p.chunk === ";") {
                mode = "complete";
                sp.toEndChunk();
            } else {
                sp.toEndChunk();
                lastP = sp.position;
                if (p.chunk === "(") {
                    const argStart = sp.pos();
                    while(true){
                        p = sp.findNext([
                            ")",
                            '"'
                        ]);
                        if (p === null) throw "missing ')' after argument(s) '" + src + "'";
                        if (p.chunk == ")") {
                            sp.toEndChunk();
                            lastP = sp.position;
                            break;
                        }
                        // skoč na konec stringu
                        sp.toEndChunk();
                        do {
                            p = sp.findNext([
                                '\\"',
                                '"'
                            ]);
                            if (p === null) throw "unterminated string '" + src + "'";
                            sp.toEndChunk();
                        }while (p.chunk === '\\"');
                    }
                    const sArgs = sp.substring(argStart, p);
                    try {
                        filter.args = $022014c519811a95$var$MuBinder.useJsonS ? $iDhgR.JSONS.parse("[" + sArgs + "]") : JSON.parse("[" + sArgs + "]");
                    } catch (exc) {
                        throw "Invalid arguments - " + exc.toString() + " '" + sArgs + "'";
                    }
                }
                mode = parseFetchBind(p.chunk, opts) ? "target" : bindPart ? "bindFilter" : "fetchFilter";
                // sp.toEndChunk();
                lastP = sp.position;
            }
            return filter.methodName ? filter : null;
        }
        //@ts-ignore
        while(!sp.isEnd() && mode != "end"){
            mode = "source";
            const opts = {
                element: element,
                source: null,
                target: null,
                bindFilters: [],
                fetchFilters: [],
                forBind: null,
                forFetch: null
            };
            // sp.debugMode = true;
            while(mode != "complete" && mode != "end")switch(mode){
                case "source":
                    p = sp.findNext([
                        "::",
                        ":",
                        "|",
                        ";",
                        "^"
                    ]);
                    opts.source = sp.substring(lastP, p).trim();
                    if (!p) mode = "end";
                    else if (p.chunk == ";") mode = "complete";
                    else {
                        mode = parseFetchBind(p.chunk, opts) ? "target" : "bindFilter";
                        sp.toEndChunk();
                        lastP = sp.position;
                    }
                    break;
                case "target":
                    p = sp.findNext([
                        "|",
                        ";"
                    ]);
                    opts.target = sp.substring(lastP, p).trim();
                    if (!p) mode = "end";
                    else if (p.chunk == ";") mode = "complete";
                    else {
                        mode = "fetchFilter";
                        sp.toEndChunk();
                        lastP = sp.position;
                    }
                    break;
                case "bindFilter":
                    var f = parseFilter(sp, true, opts);
                    if (f) opts.bindFilters.push(f);
                    break;
                case "fetchFilter":
                    f = parseFilter(sp, false, opts);
                    if (f) opts.fetchFilters.push(f);
                    break;
            }
            optsList.push(opts);
            sp.toEndChunk();
            lastP = sp.position;
        }
        return optsList;
    }
    static setDefaults(mbo) {
        const defaults = {};
        // mbo.element.hasAttribute("mu-widget")
        if (mbo.element.hasAttribute("mu-widget")) {
            defaults.forBind = true;
            defaults.forFetch = true;
            defaults.target = "@widget";
        } else if (mbo.element instanceof HTMLInputElement || mbo.element instanceof HTMLTextAreaElement || mbo.element instanceof HTMLSelectElement) {
            if (mbo.element.type === "file") {
                defaults.forBind = false;
                defaults.forFetch = true;
                defaults.target = "files";
            } else {
                defaults.forBind = true;
                defaults.forFetch = true;
                if (mbo.element.type === "checkbox") defaults.target = "checked";
                else defaults.target = "value";
            }
        } else if (mbo.element instanceof HTMLImageElement || mbo.element instanceof HTMLAudioElement || mbo.element instanceof HTMLVideoElement) {
            defaults.forBind = true;
            defaults.forFetch = false;
            defaults.target = "src";
        } else {
            defaults.forBind = true;
            defaults.forFetch = false;
            defaults.target = "text";
        }
        for(const k in defaults)if (mbo[k] === null) mbo[k] = defaults[k];
        const targetAlias = {
            text: "innerText",
            html: "innerHTML"
        };
        if (targetAlias[mbo.target]) mbo.target = targetAlias[mbo.target];
    }
    static beforeIndexElement(ev) {
        if (ev.opts.bind) {
            const bindSrc = ev.opts.bind;
            for (var mbo of $022014c519811a95$var$MuBinder.parse(bindSrc, ev.element)){
                $022014c519811a95$var$MuBinder.setDefaults(mbo);
                if (!ev.widget.muBindOpts) ev.widget.muBindOpts = {};
                if (!ev.widget.muBindOpts[mbo.source]) ev.widget.muBindOpts[mbo.source] = [];
                ev.widget.muBindOpts[mbo.source].push(mbo);
            }
        }
    }
    static register(muWidget) {
        // @ts-ignore
        muWidget.plugIns.push({
            beforeIndexElement: $022014c519811a95$var$MuBinder.beforeIndexElement
        });
    }
    static bindData(bindOpts, srcData, widget) {
        //todo: . stack overflow
        if (srcData === null) return;
        let bindedWidget = false;
        let bindedWidgetParam = false;
        for (const k of [
            /*'.',*/ ...Object.keys(srcData)
        ])if (bindOpts[k]) {
            for (const mbo of bindOpts[k])if (mbo.forBind) {
                let val = $022014c519811a95$var$MuBinder.UseFilters(k === "." ? srcData : srcData[k], mbo.bindFilters, widget, {
                    dataset: srcData
                });
                if (k === "@widget") bindedWidget = true;
                else if (k[0] === ".") bindedWidgetParam = true;
                $022014c519811a95$var$MuBinder.setValue(val, mbo.target, mbo.element, widget);
            }
        }
    }
    static fetchData(bindOpts, widget) {
        let resData = {};
        //todo: . stack overflow
        for (const k of [
            /*'.',*/ ...Object.keys(bindOpts)
        ])if (bindOpts[k]) {
            for (const mbo of bindOpts[k])if (mbo.forFetch) {
                /* resData[k] = mbo.element[mbo.target];
                        let val = MuBinder.UseFilters(srcData[k], mbo.bindFilters, widget);
                        ; */ const values = $022014c519811a95$var$MuBinder.UseFilters($022014c519811a95$var$MuBinder.GetValue(mbo.target, mbo.element, widget), mbo.fetchFilters, widget, {
                    originalValue: resData[k],
                    dataset: resData
                });
                if (k === ".") resData = Object.assign({
                    resData: resData
                }, values);
                else resData[k] = values;
            }
        }
        return resData;
    }
    static UseFilters(val, filters, widget, ev) {
        var _a, _b;
        for (const filter of filters){
            let obj = null;
            let fn;
            if (filter.methodName in widget) obj = widget; // fn = <MuBindFilterCallback>widget[filter.methodName];
            else if (widget.muParent && filter.methodName in widget.muParent) obj = widget.muParent; // fn = <MuBindFilterCallback>widget.muParent[filter.methodName];
            else if (filter.methodName in $022014c519811a95$var$MuBinder.filters) obj = $022014c519811a95$var$MuBinder.filters; //fn = MuBinder.filters[filter.methodName];
            else {
                // Parent widgets
                let w = (_a = widget.muParent) === null || _a === void 0 ? void 0 : _a.muParent;
                while(w){
                    if (filter.methodName in w) {
                        obj = w;
                        break;
                    }
                    w = w.muParent;
                }
            }
            if (!obj) throw new Error("Unknown filter '" + filter.methodName + "'. Source widget: '" + ((_b = widget === null || widget === void 0 ? void 0 : widget.costructor) === null || _b === void 0 ? void 0 : _b.name) + "'");
            fn = obj[filter.methodName];
            val = fn.call(obj, val, Object.assign({}, ev), ...filter.args);
        }
        return val;
    }
    static setValue(val, target, element, widget) {
        if (target === "@widget") element["widget"].muBindData(val);
        else if (target === "foreach" || target === "@foreach") {
            element.innerHTML = "";
            for(const k in widget.muTemplateParents)if (element === widget.muTemplateParents[k]) {
                let arr = [];
                if (!Array.isArray(val)) for(const k in val)arr.push({
                    key: k,
                    value: val[k]
                });
                else arr = val;
                for (const data of arr){
                    const widgetParams = {};
                    for(const k in data)if (k.startsWith(".")) widgetParams[k.substr(1)] = data[k];
                    const itemWidget = widget.muWidgetFromTemplate(k, element, widgetParams);
                    itemWidget.muBindData(data);
                    if ("AferBind" in itemWidget) itemWidget.AferBind();
                }
                break;
            }
        } else if (target.startsWith(".")) this.setDeep(val, element["widget"], target.substr(1));
        else if (target.startsWith("@attr.")) element.setAttribute(target.substr(6), val);
        else if (target == "@visible") element.style.display = val ? "" : "none";
        else if (target == "@options") {
            const addOpt = function(val, text) {
                const opt = document.createElement("option");
                opt.text = text;
                opt.value = val;
                element.add(opt);
            };
            element.innerHTML = "";
            if (Array.isArray(val)) {
                for (const item of val)if (typeof item === "string") addOpt(item, item);
                else addOpt(item.value, item.text);
            } else if (typeof val === "object") for(const v in val)addOpt(v, val[v]);
        } else this.setDeep(val, element, target); // element[target] = val;
    }
    static setDeep(value, object, path) {
        let obj = object;
        const fields = path.split(".");
        const lastI = fields.length - 1;
        let i = 0;
        for (const f of fields){
            if (i < lastI) obj = obj[f];
            else obj[f] = value;
            if (!obj) throw "Can not set value to path'" + path + "'";
            i++;
        }
    }
    static getDeep(object, path) {
        let obj = object;
        const fields = path.split(".");
        for (const f of fields){
            if (!(f in obj)) return undefined;
            obj = obj[f];
        }
        return obj;
    }
    static GetValue(target, element, widget) {
        switch(target){
            case "@widget":
                return element.widget == widget ? null : element["widget"].muFetchData();
            case "foreach":
            case "@foreach":
                return widget.muGetChildWidgets(element).map((itemWidget)=>itemWidget.muFetchData());
            default:
                if (target.startsWith(".")) return this.getDeep(element["widget"], target.substr(1));
                else if (target.startsWith("@attr.")) return element.getAttribute(target.substr(6));
                else if (target == "@visible") return element.style.display != "none";
                else return this.getDeep(element, target); // element[target] = val;
                break;
        }
    }
}
module.exports.MuBinder = $022014c519811a95$var$MuBinder;
$022014c519811a95$var$MuBinder.useJsonS = true;
$022014c519811a95$var$MuBinder.filters = {
    toLower: (val)=>{
        return val === null || val === void 0 ? void 0 : val.toString().toLocaleLowerCase();
    },
    toUpper: (val)=>val === null || val === void 0 ? void 0 : val.toString().toLocaleUpperCase(),
    short: (val, ev, maxLen, sufix = "...")=>{
        let str = val.toString();
        if (str.length >= maxLen - sufix.length) str = str.substr(0, maxLen) + sufix;
        return str;
    },
    tern: (val, ev, onTrue, onFalse)=>val ? onTrue : onFalse,
    prepend: (val, ev, prefix, ifAny = false)=>!ifAny || val ? prefix + val : val,
    append: (val, ev, prefix, ifAny = false)=>!ifAny || val ? val + prefix : val,
    map: (val, ev, map)=>map[val]
};

});
parcelRegister("6UZdI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StrParser = void 0;
class $5097761b3084370a$var$StrParser {
    constructor(str){
        this.position = 0;
        this.lastMark = null;
        this.debugMode = false;
        this.storedPositions = {};
        this._onEndChunk = false;
        this.str = str;
    }
    findNext(chunk, skipChunk = false) {
        if (typeof chunk === "string") chunk = [
            chunk
        ];
        // let firstPos : number|null = null;
        let firstPos = null;
        let firstChunk = null;
        let firstChunkNum = 0;
        let i = 0;
        for (const ch of chunk){
            const pos = this.str.indexOf(ch, this.position);
            if (pos > 0 && (firstPos === null || pos < firstPos)) {
                firstPos = pos;
                firstChunk = ch;
                firstChunkNum = i;
            }
            i++;
        }
        if (firstChunk) {
            if (skipChunk) firstPos += firstChunk.length;
            this.position = firstPos;
            this.lastMark = {
                chunk: firstChunk,
                chunkNum: firstChunkNum,
                position: firstPos
            };
            this._onEndChunk = false;
            this.debug("findNext(", chunk, ") > '" + firstChunk + "', " + this.position);
            return this.lastMark;
        } else {
            this.debug("findNext(", chunk, ") not found " + this.position);
            return null;
        }
    }
    substring(start = null, stop = null) {
        if (start === null) start = this.position;
        else if (typeof start === "string") start = this.loadPos(start);
        else if (typeof start !== "number") start = start.position;
        if (stop === null) stop = this.str.length;
        else if (typeof stop === "string") stop = this.loadPos(stop);
        else if (typeof stop !== "number") stop = stop.position;
        const res = this.str.substring(start, stop);
        this.debug("substr " + start + ":" + stop + " > " + res);
        return res;
    }
    moverel(mov) {
        const newPos = this.position + mov;
        this.position = Math.min(this.str.length, Math.max(0, newPos));
        return {
            position: this.position
        };
    }
    pos() {
        return {
            position: this.position
        };
    }
    loadPos(name) {
        if (name === ".") return this.position;
        else if (name === ">") return this.str.length;
        return this.storedPositions[name];
    }
    savePos(name) {
        this.storedPositions[name] = this.position;
    }
    toEndChunk() {
        var _a, _b;
        const l = this._onEndChunk ? 0 : ((_b = (_a = this.lastMark) === null || _a === void 0 ? void 0 : _a.chunk) === null || _b === void 0 ? void 0 : _b.length) || 0;
        this.moverel(l);
        this._onEndChunk = true;
        this.debug("toEndChunk +" + l.toString());
    }
    debug(...msgs) {
        if (this.debugMode) {
            const msg = msgs.map((ch)=>typeof ch === "string" ? ch : JSON.stringify(ch)).join("");
            // console.log(msg + "\n	" + this.position + "	%c" + this.str.substring(0, this.position) + "%c" + this.str.substring(this.position), "background: green; color: white", "color: blue");
            console.log(msg + "\n	" + this.position + "	" + this.str.substring(0, this.position) + "|" + this.str.substring(this.position));
        }
    }
    isEnd() {
        return this.position >= this.str.length;
    }
    startsWith(chunk, skipChunk = false, saveLast = true) {
        if (typeof chunk === "string") chunk = [
            chunk
        ];
        // let firstPos : number|null = null;
        let firstPos = null;
        let firstChunk = null;
        let firstChunkNum = 0;
        let i = 0;
        for (const ch of chunk){
            const stw = this.str.startsWith(ch, this.position);
            if (stw) {
                const mark = {
                    chunk: ch,
                    chunkNum: i,
                    position: this.position
                };
                if (saveLast) this.lastMark = mark;
                if (skipChunk) this.position += ch.length;
                this.debug("startsWith(", chunk, ") > '" + ch + "'");
                return mark;
            }
            i++;
        }
        this.debug("startsWith(", chunk, ") > not found");
        return null;
    }
    skipChunks(chunks) {
        while(this.startsWith(chunks, true, false));
    }
}
module.exports.StrParser = $5097761b3084370a$var$StrParser;

});

parcelRegister("iDhgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONSError = module.exports.JSONS = void 0;

var $6UZdI = parcelRequire("6UZdI");
class $d90944264987a074$var$JSONS {
    static parse(src) {
        const par = new $d90944264987a074$var$JSONS();
        par.tokenize(src);
        return par.parseCollection();
    }
    constructor(){
        this.chunkToType = {
            ":": "colon",
            ",": "comma",
            "\n": "newLine",
            "{": "oOpen",
            "}": "oClose",
            "[": "aOpen",
            "]": "aClose"
        };
        this.specValues = {
            "null": null,
            "true": true,
            "false": false,
            "undefined": undefined
        };
        this.stringTermChunks = [
            ...Object.keys(this.chunkToType),
            "\\",
            "#",
            "/*"
        ];
        this.tokens = [];
        this.tokenI = 0;
        this.collectionDeep = 0;
    }
    tokenize(src) {
        const res = [];
        src = src.replace(/\r\n/g, "\n");
        const sp = new $6UZdI.StrParser(src);
        // sp.debugMode = true;
        let lastPos = 0;
        while(!sp.isEnd()){
            sp.skipChunks([
                " ",
                "	"
            ]);
            if (sp.startsWith([
                "#",
                "//"
            ], true)) sp.findNext("\n", true);
            else if (sp.startsWith("/*", true)) {
                let d = 1;
                while(d){
                    const ch = sp.findNext([
                        "/*",
                        "*/"
                    ], true);
                    if (!ch) throw new $d90944264987a074$var$JSONSError("Incomplete block comment"); // EXC uncosed comment
                    if (ch.chunk === "/*") d++;
                    else d--;
                }
            } else if (sp.startsWith(Object.keys(this.chunkToType), true)) {
                const t = this.chunkToType[sp.lastMark.chunk];
                if (t !== "newLine") res.push({
                    type: t,
                    value: null,
                    pos: sp.lastMark.position
                });
            } else if (sp.startsWith([
                "'",
                '"'
            ], true)) {
                const q = sp.lastMark.chunk;
                const strBegin = sp.position;
                sp.savePos("stringBegin");
                let str = "";
                let strEnd = false;
                while(!strEnd){
                    if (sp.findNext([
                        '\\"',
                        "\\'",
                        q
                    ])) {
                        const strPart = sp.substring("stringBegin", ".");
                        // console.log(['++', strPart, str]);
                        str += strPart;
                        sp.toEndChunk();
                        sp.savePos("stringBegin");
                        // console.log('Str chunk: ' + sp.lastMark.chunk);
                        switch(sp.lastMark.chunk){
                            case '\\"':
                                str += '\\"';
                                break;
                            case "\\'":
                                str += "'";
                                break;
                            default:
                                strEnd = true;
                                break;
                        }
                    } else throw new $d90944264987a074$var$JSONSError("missing the right quotation mark"); // EXC unclosed quote
                }
                let i = 0;
                str = str.replace(/\n/g, "\\n");
                // console.log(["JSSTR [" + str + "]", ...[...str].map(c=>(i++) + ": " + c)]);
                res.push({
                    type: "value",
                    value: JSON.parse('"' + str + '"'),
                    pos: strBegin
                });
            } else {
                sp.savePos("stringBegin");
                const ch = sp.findNext(this.stringTermChunks, false);
                const valStr = sp.substring("stringBegin", ch ? "." : ">").trim();
                const valStrL = valStr.toLowerCase();
                res.push({
                    type: "value",
                    value: Object.keys(this.specValues).includes(valStrL) ? this.specValues[valStrL] : !isNaN(valStr) ? parseFloat(valStr) : valStr,
                    pos: sp.loadPos("stringBegin")
                });
                if (!ch) break;
            }
            if (lastPos === sp.position) // console.log(["Zacyklilo se.", ...res]);
            throw Error("The parsing is looping. Please create an issue and attach the source text for parsing. https://github.com/murdej/MuWidget2/issues");
            lastPos = sp.position;
        }
        this.tokens = res;
        return res;
    }
    curToken(shift = 0) {
        var _a;
        return (_a = this.tokens[this.tokenI + shift]) !== null && _a !== void 0 ? _a : null;
    }
    nextToken() {
        var _a;
        this.tokenI++;
        return (_a = this.tokens[this.tokenI]) !== null && _a !== void 0 ? _a : null;
    }
    parseCollection() {
        let type;
        const t = this.curToken();
        if (t.type === "aOpen") {
            type = "array";
            this.nextToken();
        } else if (t.type === "oOpen") {
            type = "object";
            this.nextToken();
        } else if (t.type === "value") {
            const nt = this.curToken(1);
            if (nt === null) return t.value;
            type = nt.type === "colon" ? "object" : "array";
        }
        if (type === "object") {
            const res = {};
            while(this.curToken()){
                let ct = this.curToken();
                // end of collection
                if (ct.type === "oClose") // this.nextToken();
                return res;
                // key : ....
                if (ct.type === "value") {
                    const key = ct.value;
                    ct = this.nextToken();
                    // collon
                    if (ct.type !== "colon") throw new $d90944264987a074$var$JSONSError("Expected ':' ", ct);
                    ct = this.nextToken();
                    switch(ct.type){
                        case "value":
                            res[key] = ct.value;
                            break;
                        case "aOpen":
                        case "oOpen":
                            res[key] = this.parseCollection();
                            break;
                        default:
                            throw new $d90944264987a074$var$JSONSError("Expected value or [ or { or }", ct);
                    }
                    // optional comma
                    ct = this.nextToken();
                    if (ct.type === "comma") this.nextToken();
                } else throw new $d90944264987a074$var$JSONSError("Expected property name ", ct);
            }
            return res;
        } else {
            const res = [];
            while(this.curToken()){
                let ct = this.curToken();
                // end of collection
                if (ct.type === "aClose") // this.nextToken();
                return res;
                switch(ct.type){
                    case "value":
                        res.push(ct.value);
                        break;
                    case "aOpen":
                    case "oOpen":
                        res.push(this.parseCollection());
                        break;
                    default:
                        throw new $d90944264987a074$var$JSONSError("Expected value or [ or { or }", ct);
                }
                // optional comma
                ct = this.nextToken();
                if (ct && ct.type === "comma") this.nextToken();
            }
            return res;
        }
    }
}
module.exports.JSONS = $d90944264987a074$var$JSONS;
class $d90944264987a074$var$JSONSError extends Error {
    constructor(message, token = null){
        super(message + (token ? " position: " + token.pos + " [" + token.type + (token.type === "value" ? ": " + JSON.stringify(token.value) + "]" : "") : ""));
        this.name = "JSONSError";
    // this.token = token;
    }
}
module.exports.JSONSError = $d90944264987a074$var$JSONSError;

});




parcelRegister("9QECq", function(module, exports) {

$parcel$export(module.exports, "BaseEditor", () => $e94f8ffb051764f7$export$bb302f561a601904);
$parcel$export(module.exports, "formGroup", () => $e94f8ffb051764f7$export$d2297815c52203ee);

var $dMN2n = parcelRequire("dMN2n");

var $75oRH = parcelRequire("75oRH");
class $e94f8ffb051764f7$export$bb302f561a601904 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.savedPromise = new Promise((res)=>this.onSaved = res);
        // @ts-ignore
        this.errorMarker = new (0, $75oRH.ErrorMarker)(this);
    }
    muRemoveSelf() {
        super.muRemoveSelf();
        this.muDispatchEvent("close");
    }
    beforeIndex() {
        super.beforeIndex();
        this.muRegisterEvent("close");
    }
    container_keypress(ev) {
        if (ev.key === "Enter") {
            ev.preventDefault();
            ev.cancelBubble = true;
            this.ui.bSave?.click();
        }
    }
    constructor(...args){
        super(...args);
        this.id = null;
    }
}
function $e94f8ffb051764f7$export$d2297815c52203ee(name, label, input, dataFilter = null) {
    if (dataFilter === true) dataFilter = name;
    return `<div class="form-group row" mu-id="block_${name}"` + (dataFilter ? ' data-field="' + dataFilter + '"' : "") + `>
		<label mu-for="` + name + `" class="col-sm-3 control-label with-cleaner" mu-id="label_${name}">` + (dataFilter ? `<span class="label-text">${label}</span><span class="icon-erase cursor-pointer" mu-click='eraseFilterField: "${dataFilter}"'></span>` : label) + `</label>
		<div class="col-sm-9">${input}</div>
	</div>`;
}

});
parcelRegister("75oRH", function(module, exports) {

$parcel$export(module.exports, "ErrorMarker", () => $6c29cfb33a8cf923$export$cd497ff60fb4727c);
$parcel$export(module.exports, "ErrorMarkerErrors", () => $6c29cfb33a8cf923$export$15cf62d5553dfe1b);
function $6c29cfb33a8cf923$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6c29cfb33a8cf923$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6c29cfb33a8cf923$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6c29cfb33a8cf923$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6c29cfb33a8cf923$var$_arrayLikeToArray(o, minLen);
}
function $6c29cfb33a8cf923$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $6c29cfb33a8cf923$export$cd497ff60fb4727c {
    constructor(rootWidget, pathSeparator = "/"){
        this.errorLabel = {
            containerTag: "div",
            containerClassName: "",
            itemTag: "div",
            itemClassName: "form-error"
        };
        this.pathControl = {};
        this.rootWidget = rootWidget;
        this.pathSeparator = pathSeparator;
    }
    findControl(path) {
        if (!this.pathControl[path]) {
            const pathParts = path.split(this.pathSeparator);
            let i = 0, c = pathParts.length;
            let src = this.rootWidget;
            let cbd;
            for(var _iterator = $6c29cfb33a8cf923$var$_createForOfIteratorHelperLoose(pathParts), _step; !(_step = _iterator()).done;){
                const pathPart = _step.value;
                i++;
                if (!src.muBindOpts[pathPart]) return null;
                const bd = src.muBindOpts[pathPart][0];
                if (!bd) return null;
                if (i === c) cbd = bd;
                else src = bd.element.widget;
            }
            if (cbd) this.pathControl[path] = cbd.element;
        }
        return this.pathControl[path];
    }
    markErrors(messages) {
        const notShowed = [];
        for(const k in this.pathControl){
            const el = this.pathControl[k].errorLabel;
            if (el) el.innerHTML = "";
            el.style.display = "none";
        }
        for(var _iterator2 = $6c29cfb33a8cf923$var$_createForOfIteratorHelperLoose(messages), _step2; !(_step2 = _iterator2()).done;){
            const message = _step2.value;
            const el = this.findControl(message.field);
            if (!el) notShowed.push(message);
            else {
                // console.log(el);
                let errorLabel;
                if (!el.errorLabel) {
                    errorLabel = document.createElement(this.errorLabel.containerTag);
                    errorLabel.className = this.errorLabel.containerClassName;
                    el.parentElement?.appendChild(errorLabel);
                    el.errorLabel = errorLabel;
                } else errorLabel = el.errorLabel;
                const elMessage = document.createElement(this.errorLabel.itemTag);
                elMessage.innerText = message.message;
                elMessage.className = this.errorLabel.itemClassName;
                errorLabel.appendChild(elMessage);
                errorLabel.style.display = "";
            }
        }
        return notShowed;
    }
    clearErrors() {
        //todo:
        for(var _i = 0, _Array$from = Array.from(this.rootWidget.container.querySelectorAll('[class="' + this.errorLabel.itemClassName + '"]')); _i < _Array$from.length; _i++){
            const el = _Array$from[_i];
            // @ts-ignore
            el.parentElement.removeChild(el);
        }
    }
}
class $6c29cfb33a8cf923$export$15cf62d5553dfe1b extends Array {
    add(field, message) {
        this.push({
            field: Array.isArray(field) ? field.join(this.pathSeparator) : field,
            message: message
        });
    }
    merge(errors, ...fields) {
        for(var _i2 = 0, _errors = errors; _i2 < _errors.length; _i2++){
            const err = _errors[_i2];
            this.add((fields.length ? fields.join(this.pathSeparator) + this.pathSeparator : "") + err.field, err.message);
        }
    }
    isValid() {
        return this.length === 0;
    }
    constructor(...args){
        super(...args);
        this.pathSeparator = "/";
    }
}

});



parcelRegister("fdJlN", function(module, exports) {

$parcel$export(module.exports, "PqmFieldCompany", () => $5fbd8796d2aa2701$export$eefbbabc7c441149);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");
class $5fbd8796d2aa2701$export$eefbbabc7c441149 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "company:company_company"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent(`<div mu="value:BaseCompanyForm#value"></div>`);
    }
    isFilled() {
        const v = this.getValue();
        return v && !!v.ic;
    }
    container_change() {
        this.onChange();
    }
    setDisabled(disabled) {
        this.muNamedWidget.value.setDisabled(disabled);
    }
}
(0, $cnflh.PqmFieldRegister).register($5fbd8796d2aa2701$export$eefbbabc7c441149);

});
parcelRegister("3XMts", function(module, exports) {

$parcel$export(module.exports, "BasePqmFieldValue", () => $9659a20216e0bf58$export$d757dd84801e4652);

var $6Taw3 = parcelRequire("6Taw3");
class $9659a20216e0bf58$export$d757dd84801e4652 extends (0, $6Taw3.BaseMuWidget) {
    static getValueTypes() {
        return [];
    }
    isFilled() {
        const val = this.getValue();
        if (Array.isArray(val)) return val.length > 0;
        return !!val;
    }
    getValue() {
        return this.muFetchData().value;
    }
    setValue(value) {
        this.muBindData({
            value: value
        });
    }
    value_change() {
        this.onChange();
    }
    async afterSave(res) {
        return null;
    }
    setDisabled(disabled) {
        if (this.ui.value) this.ui.value.disabled = disabled;
        else console.error("Failed sedDisable", this);
    }
    constructor(...args){
        super(...args);
        this.paramType = "";
        this.control = "";
        this.numberingId = null;
        this.pqmPacketId = -1;
        // @ts-ignore
        this.onChange = ()=>null;
    }
}

});
parcelRegister("6Taw3", function(module, exports) {

$parcel$export(module.exports, "BaseMuWidget", () => $209430f4b41b05e1$export$754b09b0d37a981d);

var $dMN2n = parcelRequire("dMN2n");

var $5OSdp = parcelRequire("5OSdp");

var $drdLe = parcelRequire("drdLe");
class $209430f4b41b05e1$export$754b09b0d37a981d extends (0, $dMN2n.MuWidget) {
    getRouter() {
        if (this.router) return this.router;
        let w = this.muParent;
        while(w){
            if ("getRouter" in w) // @ts-ignore
            return w.getRouter();
            w = w.muParent;
        }
        throw "No router";
    }
    closeModal(ev) {
        //todo: Nové MuWidget
        let sender;
        if (typeof ev === "string") sender = this.ui[ev];
        else sender = ev.currentTarget;
        while(sender && !sender.classList.contains("modal-b"))sender = sender.parentElement;
        if (sender) sender.style.display = "none";
        else console.error("No modal", ev);
    }
    muClear(container) {
        if (typeof container === "string") container = this.ui[container];
        container.innerHTML = "";
    }
    callMethodInFirstAncestors(methodName, ...args) {
        let w = this;
        while(w){
            if (methodName in w) return w[methodName](...args);
            w = w.muParent;
        }
    }
    getPropertyInAncestors(propertyName) {
        let w = this;
        while(w){
            if (propertyName in w) return w[propertyName];
            w = w.muParent;
        }
    }
    openInModal(widget, title = null, params = {}, focusFirstInput = true) {
        const w = (0, $5OSdp.UiModalContainer).open(widget, title, params, focusFirstInput);
        // @ts-ignore
        w.muParent = params.muParent || this;
        return w;
    }
    setPageTitle(title) {
        if (this.muParent.ui.pageTitle) this.muParent.ui.pageTitle.innerText = title;
        const p = document.title.indexOf("|");
        const sufix = p > -1 ? " " + document.title.substring(p) : "";
        document.title = title + sufix;
    }
    addFlash(message, type = "default") {
        (0, $drdLe.UiFlashMessageContainer).instance.add(type, type);
    }
    init() {
        if (!this.initPromise) this.initPromise = this.doInit();
        return this.initPromise;
    }
    /** @virtual */ async doInit() {}
    createWidgetIn(widget, container, params = {}, tagName = "div") {
        const el = document.createElement(tagName);
        if (typeof container === "string") {
            if (!(container in this.ui)) throw "Container '" + container + "' not exist.";
            container = this.ui[container];
        }
        container.append(el);
        el.setAttribute("mu-widget", widget);
        const w = this.muActivateWidget(el, {
            widget: widget,
            params: params // JSON.stringify(params)
        }, params);
        // @ts-ignore
        el.widget = w;
        // @ts-ignore
        return w;
    }
    eventPromise(name, removeValue) {
        return new Promise((resolve, reject)=>{
            this.addEventListener(name, (ev)=>resolve(ev.args[0]));
            this.container.addEventListener("DOMNodeRemoved", ()=>removeValue !== undefined ? resolve(removeValue) : reject());
        });
    }
    constructor(...args){
        super(...args);
        this.rawUploadUrl = "/ticket/upload-raw-attach";
        this.router = null;
        this.initPromise = null;
    }
}

});
parcelRegister("5OSdp", function(module, exports) {

$parcel$export(module.exports, "UiModalContainer", () => $bcaf7cf7e795e311$export$453a22d7efe0ec6d);

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");
class $bcaf7cf7e795e311$export$453a22d7efe0ec6d extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.container.classList.add("modal-b");
    }
    afterIndex() {
        $bcaf7cf7e795e311$export$453a22d7efe0ec6d.instance = this;
        // @ts-ignore
        this.ui.modals = this.container;
        this.ui.modals.addEventListener("DOMNodeRemoved", (ev)=>setTimeout(()=>this.updateModals(ev), 1));
        this.updateModals();
    }
    openModal(widget, title = null, params = {}, focusFirstInput = true) {
        const el = document.createElement("div");
        this.ui.modals.appendChild(el);
        this.updateModals();
        el.classList.add("modal-i");
        el.setAttribute("mu-widget", widget);
        if (title) el.innerHTML = `<div class="modal-title"><h2 mu-id="modalTitle"></h2><span class="close" mu-id="btCloseModal" mu-click="muRemoveSelf">\xd7</span> </div>`;
        const w = this.muActivateWidget(el, {
            widget: widget,
            params: params // JSON.stringify(params)
        }, params);
        if (title) // @ts-ignore
        w.ui.modalTitle.innerText = title;
        if (focusFirstInput) (0, $kwZWC.focusFirstVisibleControl)(el);
        // @ts-ignore
        el.widget = w;
        // @ts-ignore
        setTimeout(()=>w.container.scrollIntoView(), 200);
        return w;
    }
    static open(widget, title = null, params = {}, focusFirstInput = true) {
        return this.instance.openModal(widget, title, params, focusFirstInput);
    }
    updateModals(ev = null) {
        const isAny = this.ui.modals.children.length > 0;
        this.muVisible(isAny, "modals");
        document.documentElement.style.overflow = isAny ? "hidden" : "";
    }
}

});
parcelRegister("kwZWC", function(module, exports) {

$parcel$export(module.exports, "getBaseCL", () => getBaseCL);
$parcel$export(module.exports, "Arrays", () => Arrays);
$parcel$export(module.exports, "Objects", () => Objects);
$parcel$export(module.exports, "copyToClipoard", () => copyToClipoard);
$parcel$export(module.exports, "formatDateTime", () => formatDateTime);
$parcel$export(module.exports, "flashError", () => flashError);
$parcel$export(module.exports, "flashInfo", () => flashInfo);
$parcel$export(module.exports, "changeElementOrder", () => changeElementOrder);
$parcel$export(module.exports, "indexBy", () => indexBy);
$parcel$export(module.exports, "isOpenInNew", () => isOpenInNew);
$parcel$export(module.exports, "formatDate", () => formatDate);
$parcel$export(module.exports, "wrapElement", () => wrapElement);
$parcel$export(module.exports, "focusFirstVisibleControl", () => focusFirstVisibleControl);
$parcel$export(module.exports, "arrayDiff", () => arrayDiff);
$parcel$export(module.exports, "formatNumber", () => formatNumber);
$parcel$export(module.exports, "getSelectedValue", () => getSelectedValue);
$parcel$export(module.exports, "isHTMLStringEmpty", () => isHTMLStringEmpty);
$parcel$export(module.exports, "setSelectedValue", () => setSelectedValue);
$parcel$export(module.exports, "TCFormatDate", () => TCFormatDate);
$parcel$export(module.exports, "webalizeString", () => webalizeString);
$parcel$export(module.exports, "escapeHtml", () => escapeHtml);
$parcel$export(module.exports, "Utils", () => Utils);
$parcel$export(module.exports, "createHtmlElement", () => createHtmlElement);
$parcel$export(module.exports, "reviveLoadedElement", () => reviveLoadedElement);
$parcel$export(module.exports, "jsNextCycle", () => jsNextCycle);
$parcel$export(module.exports, "pairsToList", () => pairsToList);
$parcel$export(module.exports, "getRadioListSelectedValue", () => getRadioListSelectedValue);
$parcel$export(module.exports, "sleepPromise", () => sleepPromise);
$parcel$export(module.exports, "changeClassStartsWith", () => changeClassStartsWith);
$parcel$export(module.exports, "changeIconBefore", () => changeIconBefore);
$parcel$export(module.exports, "toDate", () => toDate);
$parcel$export(module.exports, "emptyToNull", () => emptyToNull);
$parcel$export(module.exports, "YMPeriod", () => YMPeriod);
$parcel$export(module.exports, "getBrightness", () => getBrightness);
$parcel$export(module.exports, "oneShotHandler", () => oneShotHandler);

var $3cBch = parcelRequire("3cBch");

var $3v8ea = parcelRequire("3v8ea");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function getBaseCL() {
    // @ts-ignore
    const url = conf.baseCLUrl;
    return new (0, $3v8ea.CommonCL)(url);
}
class Arrays {
    static diff(a1, a2) {
        return a1.filter((item)=>!a2.includes(item));
    }
    static intersect(arr1, arr2) {
        return arr1.filter((value)=>arr2.includes(value));
    }
    static groupBy(all, getByField) {
        const res = {};
        for(var _i = 0, _all = all; _i < _all.length; _i++){
            const item = _all[_i];
            const k = getByField(item);
            if (!(k in res)) res[k] = [];
            res[k].push(item);
        }
        return res;
    }
    static ToObject(data, key, val = null) {
        const res = {};
        for(var _i2 = 0, _data = data; _i2 < _data.length; _i2++){
            const item = _data[_i2];
            const k = typeof key === "string" ? item[key] : key(item);
            if (val === null) res[k] = item;
            else if (typeof item === "string") res[k] = item[key];
            else res[k] = key(item);
        }
        return res;
    }
    static unique(items) {
        return Array.from(new Set(items));
    }
    static ooaToArray(items) {
        return Array.isArray(items) ? items : [
            items
        ];
    }
}
class Objects {
    static swapKeysValues(obj) {
        const swapped = {};
        for(const key in obj)if (obj.hasOwnProperty(key)) swapped[obj[key]] = key;
        return swapped;
    }
}
function copyToClipoard(content, type = "text") {
    const sx = window.scrollX;
    const sy = window.scrollY;
    const contentElement = document.createElement("div");
    if (type == "html") contentElement.innerHTML = content;
    else contentElement.innerText = content;
    // @ts-ignore
    document.getRootNode().firstElementChild.appendChild(contentElement);
    contentElement.contentEditable = "true";
    contentElement.setAttribute("contenteditable", "true");
    contentElement.focus();
    document.execCommand("selectAll");
    document.execCommand("copy");
    contentElement.parentElement.removeChild(contentElement);
    window.scrollTo(sx, sy);
    (0, $3cBch.UiFlashMessage).instance.add("Zkop\xedrov\xe1no do schr\xe1nky");
// alert("Zkopírováno do schránky");
}
function strPadL(str, count, pad) {
    return str.length < count ? pad.repeat(count - str.length) + str : str;
}
function formatDateTime(d, nullReplace = "") {
    return d ? strPadL(d.getDate().toString(), 2, "0") + "." + strPadL((d.getMonth() + 1).toString(), 2, "0") + "." + d.getFullYear().toString() + " " + strPadL(d.getHours().toString(), 2, "0") + ":" + strPadL(d.getMinutes().toString(), 2, "0") : nullReplace;
}
function flashError(message) {
    (0, $3cBch.UiFlashMessage).instance.add(message);
}
function flashInfo(message) {
    (0, $3cBch.UiFlashMessage).instance.add(message);
}
function changeElementOrder(element, rel) {
    if (rel < 0 && element.previousElementSibling) element.parentElement.insertBefore(element, element.previousElementSibling);
    else if (rel > 0 && element.nextElementSibling) // element.parentElement.aft(element, element.nextElementSibling);
    element.nextElementSibling.after(element);
}
function indexBy(arr, keyCallback) {
    let res = {};
    if (typeof keyCallback === "string") {
        const key = keyCallback;
        keyCallback = (item)=>item[key];
    }
    for(var _i3 = 0, _arr = arr; _i3 < _arr.length; _i3++){
        let item = _arr[_i3];
        res[keyCallback(item)] = item;
    }
    return res;
}
function isOpenInNew(ev) {
    return ev.ctrlKey || ev.shiftKey || ev.metaKey || // apple
    ev.button && ev.button == 1;
}
function formatDate(format, timestamp) {
    var that = this;
    var jsdate;
    var f;
    // Keep this here (works, but for code commented-out below for file size reasons)
    // var tal= [];
    var txt_words = [
        "Sun",
        "Mon",
        "Tues",
        "Wednes",
        "Thurs",
        "Fri",
        "Satur",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    // trailing backslash -> (dropped)
    // a backslash followed by any character (including backslash) -> the character
    // empty string -> empty string
    var formatChr = /\\?(.?)/gi;
    var formatChrCb = function(t, s) {
        return f[t] ? f[t]() : s;
    };
    var _pad = function(n, c) {
        n = String(n);
        while(n.length < c)n = "0" + n;
        return n;
    };
    f = {
        // Day
        d: function() {
            // Day of month w/leading 0; 01..31
            return _pad(f.j(), 2);
        },
        D: function() {
            // Shorthand day name; Mon...Sun
            return f.l().slice(0, 3);
        },
        j: function() {
            // Day of month; 1..31
            return jsdate.getDate();
        },
        l: function() {
            // Full day name; Monday...Sunday
            return txt_words[f.w()] + "day";
        },
        N: function() {
            // ISO-8601 day of week; 1[Mon]..7[Sun]
            return f.w() || 7;
        },
        S: function() {
            // Ordinal suffix for day of month; st, nd, rd, th
            var j = f.j();
            var i = j % 10;
            if (i <= 3 && parseInt(j % 100 / 10, 10) == 1) i = 0;
            return [
                "st",
                "nd",
                "rd"
            ][i - 1] || "th";
        },
        w: function() {
            // Day of week; 0[Sun]..6[Sat]
            return jsdate.getDay();
        },
        z: function() {
            // Day of year; 0..365
            var a = new Date(f.Y(), f.n() - 1, f.j());
            var b = new Date(f.Y(), 0, 1);
            return Math.round((a - b) / 864e5);
        },
        // Week
        W: function() {
            // ISO-8601 week number
            var a = new Date(f.Y(), f.n() - 1, f.j() - f.N() + 3);
            var b = new Date(a.getFullYear(), 0, 4);
            return _pad(1 + Math.round((a - b) / 864e5 / 7), 2);
        },
        // Month
        F: function() {
            // Full month name; January...December
            return txt_words[6 + f.n()];
        },
        m: function() {
            // Month w/leading 0; 01...12
            return _pad(f.n(), 2);
        },
        M: function() {
            // Shorthand month name; Jan...Dec
            return f.F().slice(0, 3);
        },
        n: function() {
            // Month; 1...12
            return jsdate.getMonth() + 1;
        },
        t: function() {
            // Days in month; 28...31
            return new Date(f.Y(), f.n(), 0).getDate();
        },
        // Year
        L: function() {
            // Is leap year?; 0 or 1
            var j = f.Y();
            return j % 4 === 0 & j % 100 !== 0 | j % 400 === 0;
        },
        o: function() {
            // ISO-8601 year
            var n = f.n();
            var W = f.W();
            var Y = f.Y();
            return Y + (n === 12 && W < 9 ? 1 : n === 1 && W > 9 ? -1 : 0);
        },
        Y: function() {
            // Full year; e.g. 1980...2010
            return jsdate.getFullYear();
        },
        y: function() {
            // Last two digits of year; 00...99
            return f.Y().toString().slice(-2);
        },
        // Time
        a: function() {
            // am or pm
            return jsdate.getHours() > 11 ? "pm" : "am";
        },
        A: function() {
            // AM or PM
            return f.a().toUpperCase();
        },
        B: function() {
            // Swatch Internet time; 000..999
            var H = jsdate.getUTCHours() * 36e2;
            // Hours
            var i = jsdate.getUTCMinutes() * 60;
            // Minutes
            // Seconds
            var s = jsdate.getUTCSeconds();
            return _pad(Math.floor((H + i + s + 36e2) / 86.4) % 1e3, 3);
        },
        g: function() {
            // 12-Hours; 1..12
            return f.G() % 12 || 12;
        },
        G: function() {
            // 24-Hours; 0..23
            return jsdate.getHours();
        },
        h: function() {
            // 12-Hours w/leading 0; 01..12
            return _pad(f.g(), 2);
        },
        H: function() {
            // 24-Hours w/leading 0; 00..23
            return _pad(f.G(), 2);
        },
        i: function() {
            // Minutes w/leading 0; 00..59
            return _pad(jsdate.getMinutes(), 2);
        },
        s: function() {
            // Seconds w/leading 0; 00..59
            return _pad(jsdate.getSeconds(), 2);
        },
        u: function() {
            // Microseconds; 000000-999000
            return _pad(jsdate.getMilliseconds() * 1000, 6);
        },
        // Timezone
        e: function() {
            // Timezone identifier; e.g. Atlantic/Azores, ...
            // The following works, but requires inclusion of the very large
            // timezone_abbreviations_list() function.
            /*              return that.date_default_timezone_get();
       */ throw "Not supported (see source code of date() for timezone on how to add support)";
        },
        I: function() {
            // DST observed?; 0 or 1
            // Compares Jan 1 minus Jan 1 UTC to Jul 1 minus Jul 1 UTC.
            // If they are not equal, then DST is observed.
            var a = new Date(f.Y(), 0);
            // Jan 1
            var c = Date.UTC(f.Y(), 0);
            // Jan 1 UTC
            var b = new Date(f.Y(), 6);
            // Jul 1
            // Jul 1 UTC
            var d = Date.UTC(f.Y(), 6);
            return a - c !== b - d ? 1 : 0;
        },
        O: function() {
            // Difference to GMT in hour format; e.g. +0200
            var tzo = jsdate.getTimezoneOffset();
            var a = Math.abs(tzo);
            return (tzo > 0 ? "-" : "+") + _pad(Math.floor(a / 60) * 100 + a % 60, 4);
        },
        P: function() {
            // Difference to GMT w/colon; e.g. +02:00
            var O = f.O();
            return O.substr(0, 3) + ":" + O.substr(3, 2);
        },
        T: function() {
            // Timezone abbreviation; e.g. EST, MDT, ...
            // The following works, but requires inclusion of the very
            // large timezone_abbreviations_list() function.
            /*              var abbr, i, os, _default;
      if (!tal.length) {
        tal = that.timezone_abbreviations_list();
      }
      if (that.php_js && that.php_js.default_timezone) {
        _default = that.php_js.default_timezone;
        for (abbr in tal) {
      	for (i = 0; i < tal[abbr].length; i++) {
      	  if (tal[abbr][i].timezone_id === _default) {
      		return abbr.toUpperCase();
      	  }
      	}
        }
      }
      for (abbr in tal) {
        for (i = 0; i < tal[abbr].length; i++) {
      	os = -jsdate.getTimezoneOffset() * 60;
      	if (tal[abbr][i].offset === os) {
      	  return abbr.toUpperCase();
      	}
        }
      }
      */ return "UTC";
        },
        Z: function() {
            // Timezone offset in seconds (-43200...50400)
            return -jsdate.getTimezoneOffset() * 60;
        },
        // Full Date/Time
        c: function() {
            // ISO-8601 date.
            return "Y-m-d\\TH:i:sP".replace(formatChr, formatChrCb);
        },
        r: function() {
            // RFC 2822
            return "D, d M Y H:i:s O".replace(formatChr, formatChrCb);
        },
        U: function() {
            // Seconds since UNIX epoch
            return jsdate / 1000 | 0;
        }
    };
    this.date = function(format, timestamp) {
        that = this;
        if (timestamp === undefined) jsdate = new Date();
        else if (timestamp instanceof Date || typeof timestamp === "string") jsdate = new Date(timestamp);
        else jsdate = new Date(timestamp * 1000); // UNIX timestamp (auto-convert to int)
        return format.replace(formatChr, formatChrCb);
    };
    return this.date(format, timestamp);
}
function wrapElement(el, tag) {
    const res = {
        original: el,
        wrapper: document.createElement(tag)
    };
    // @ts-ignore
    res.original.parentElement.insertBefore(res.wrapper, res.original);
    // @ts-ignore
    res.original.parentElement.removeChild(res.original);
    res.wrapper.appendChild(res.original);
    return res;
}
function focusFirstVisibleControl(el) {
    const firstInput = el.querySelector("input,[tabindex],textarea,select");
    firstInput?.focus();
}
function arrayDiff(a, b) {
    return a.filter((x)=>!b.includes(x));
}
function formatNumber(value, decNumns = null, zeroPad = 0, decPoint = ",", nullText = "", thousandSeparator = "\xa0", thousandNums = 3) {
    //todo: decNums, zeroPad, decPoint, nullText, thousandSeparator
    if (value === null || value === undefined) return nullText;
    var s;
    if (decNumns !== null) {
        var dd = Math.pow(10, decNumns);
        value = Math.round(value * dd) / dd;
        s = value.toString();
    } else {
        s = value.toString();
        var p = s.indexOf(".");
        if (p > -1) decNumns = s.length - (p + 1);
        else decNumns = 0;
    }
    var ip, dp = "";
    var p = s.indexOf(".");
    if (p > -1) {
        ip = s.substr(0, p);
        dp = s.substr(p + 1);
    } else ip = s;
    var ipl = ip.length;
    var dpl = dp.length;
    if (ipl < zeroPad) {
        ip = ip.padStart(zeroPad, "0"); // "0".repeat(zeroPad - ipl) + ip;
        ipl = zeroPad;
    }
    ip = " ".repeat(Math.ceil(ipl / thousandNums) * thousandNums - ipl) + ip;
    if (dpl < decNumns) {
        dp = dp.padEnd(decNumns, "0");
        dpl = decNumns;
    }
    function chunkStr(s, sep, size) {
        var l = s.length;
        if (l <= size) return s;
        var res = "";
        for(var i = 0; i < l; i += size){
            if (res) res += sep;
            res += s.substr(i, size);
        }
        return res;
    }
    return chunkStr(ip, thousandSeparator, thousandNums).trim() + (dpl > 0 ? decPoint + chunkStr(dp, thousandSeparator, thousandNums) : "");
}
function removeEmptyProperties(src) {
    const res = {};
    for(const k in src)if (src[k]) res[k] = src[k];
    return res;
}
function getSelectedValue(el) {
    const form = el.form || document;
    // @ts-ignore
    for(var _iterator = _createForOfIteratorHelperLoose(form.querySelectorAll('[name="' + el.name + '"]')), _step; !(_step = _iterator()).done;){
        const inEl = _step.value;
        if (inEl.checked) return inEl.value;
    }
    return null;
}
function isHTMLStringEmpty(htmlString) {
    const tempDiv = document.createElement("div");
    if (tempDiv.querySelector("img,picture")) return true;
    tempDiv.innerHTML = htmlString;
    const textContent = tempDiv.textContent || tempDiv.innerText;
    return /^\s*$/.test(textContent);
}
function setSelectedValue(el, value) {
    const form = el.form || document;
    // @ts-ignore
    for(var _iterator2 = _createForOfIteratorHelperLoose(form.querySelectorAll('[name="' + el.name + '"]')), _step2; !(_step2 = _iterator2()).done;){
        const inEl = _step2.value;
        inEl.checked = inEl.value == value;
    }
}
function TCFormatDate(value, columnInf, cell) {
    if (value) {
        cell.container.title = formatDate("d.m.Y H:i", value);
        return formatDate("d.m.Y", value);
    }
    return "";
}
function webalizeString(str) {
    const charlist = [
        [
            "\xc1",
            "A"
        ],
        [
            "\xc4",
            "A"
        ],
        [
            "\u010C",
            "C"
        ],
        [
            "\xc7",
            "C"
        ],
        [
            "\u010E",
            "D"
        ],
        [
            "\xc9",
            "E"
        ],
        [
            "\u011A",
            "E"
        ],
        [
            "\xcb",
            "E"
        ],
        [
            "\xcd",
            "I"
        ],
        [
            "\u0147",
            "N"
        ],
        [
            "\xd3",
            "O"
        ],
        [
            "\xd6",
            "O"
        ],
        [
            "\u0158",
            "R"
        ],
        [
            "\u0160",
            "S"
        ],
        [
            "\u0164",
            "T"
        ],
        [
            "\xda",
            "U"
        ],
        [
            "\u016E",
            "U"
        ],
        [
            "\xdc",
            "U"
        ],
        [
            "\xdd",
            "Y"
        ],
        [
            "\u017D",
            "Z"
        ],
        [
            "\xe1",
            "a"
        ],
        [
            "\xe4",
            "a"
        ],
        [
            "\u010D",
            "c"
        ],
        [
            "\xe7",
            "c"
        ],
        [
            "\u010F",
            "d"
        ],
        [
            "\xe9",
            "e"
        ],
        [
            "\u011B",
            "e"
        ],
        [
            "\xeb",
            "e"
        ],
        [
            "\xed",
            "i"
        ],
        [
            "\u0148",
            "n"
        ],
        [
            "\xf3",
            "o"
        ],
        [
            "\xf6",
            "o"
        ],
        [
            "\u0159",
            "r"
        ],
        [
            "\u0161",
            "s"
        ],
        [
            "\u0165",
            "t"
        ],
        [
            "\xfa",
            "u"
        ],
        [
            "\u016F",
            "u"
        ],
        [
            "\xfc",
            "u"
        ],
        [
            "\xfd",
            "y"
        ],
        [
            "\u017E",
            "z"
        ]
    ];
    for(var i in charlist){
        var re = new RegExp(charlist[i][0], "g");
        str = str.replace(re, charlist[i][1]);
    }
    str = str.replace(/[^a-z0-9]/ig, "-");
    str = str.replace(/\-+/g, "-");
    if (str[0] == "-") str = str.substring(1, str.length);
    if (str[str.length - 1] == "-") str = str.substring(0, str.length - 1);
    return str.toLowerCase();
}
function escapeHtml(src) {
    return Utils.escapeHtml(src);
}
function createHtmlElement(name, attributes, innerText = "") {
    const el = document.createElement(name);
    for(const an in attributes)el.setAttribute(an, attributes[an]);
    if (innerText) el.innerText = innerText;
    return el;
}
class Utils {
    static htmlOptions(values) {
        var html = "";
        for(var k in values)html += '<option value="' + Utils.escapeHtml(k) + '">' + Utils.escapeHtml(values[k]) + "</option>\n";
        return html;
    }
    static escapeHtml(src) {
        return src.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }
    static htmlListText(values) {
        var html = "";
        for(var i = 0, l = values.length; i < l; i++)html += "<li>" + Utils.escapeHtml(values[i]) + "</li>\n";
        return html;
    }
    /* static getRecursiveItems(value: string | string[] | undefined, all: any[]) {
  	const itemsByParentId = Arrays.groupBy(all, item => item.parentId);
  	let res: any[] = [];
  	let newIds = Array.isArray(value) ? value : [ value ];
  	while (newIds.length > 0) {
  		res = [ ...res, ...newIds ];
  		let newNewIds = [];
  		for(const id of newIds) {
  			if (id in itemsByParentId) {
  				newNewIds = [ ...newIds, ...itemsByParentId.map((item:any) => item.id) ]
  			}
  		}
  	}
  } */ static getRecursiveItems(arr, id) {
        const result = [];
        function findRecursively(parentId) {
            for(var _i4 = 0, _arr2 = arr; _i4 < _arr2.length; _i4++){
                const item = _arr2[_i4];
                if (item.parentId === parentId) {
                    result.push(item.id);
                    findRecursively(item.id);
                }
            }
        }
        findRecursively(id);
        return result;
    }
    static ajax(cmd, data, success, postData, error) {
        success = Utils.prepareCallback(success, this);
        if (error) error = Utils.prepareCallback(error, this);
        var ajaxOpts = {
            success: success,
            error: error
        };
        if (postData) {
            /* ajaxOpts.data = new FormData();
      for(var k in postData)
      {
      	ajaxOpts.data.append(k, postData[k]);
      } */ ajaxOpts.type = "post";
            ajaxOpts.data = postData;
        }
        $.ajax(this.getUrl(cmd, data), ajaxOpts);
    }
    getUrl(cmd, params) {
        var url = this.url[cmd];
        url = url.replace(/__([a-zA-Z0-9]+)__/g, (m, n)=>params[n] ? params[n] : "");
        return url;
    }
    ajaxForm(form, done, prepare, opts) {
        done = Utils.prepareCallback(done, this);
        prepare = Utils.prepareCallback(prepare, this);
        form.addEventListener("submit", function() {
            if (opts == undefined) opts = {};
            event.preventDefault();
            var ajaxOpts = {
                url: opts.action || $(form).attr("action"),
                type: opts.method || $(form).attr("method"),
                data: new FormData(form),
                contentType: false,
                cache: false,
                processData: false
            };
            if (prepare) prepare(ajaxOpts);
            var ajaxRes = $.ajax(ajaxOpts);
            if (done) ajaxRes.done(done);
        });
    }
}
async function loadUrlContent(url) {
    const f = fetch(url);
    return await (await f).text();
}
function reviveLoadedElement(element) {
    // init legacy parts
    element.querySelectorAll("script").forEach((el)=>eval(el.innerHTML));
    // @ts-ignore
    window.initAllSelectize(element);
    // @ts-ignore
    window.initInvoiceCreator();
}
function jsNextCycle() {
    return new Promise((resolve)=>setTimeout(()=>resolve(), 1));
}
function pairsToList(o, kField = "id", vField = "name") {
    const res = [];
    for(const k in o)res.push({
        [kField]: k,
        [vField]: o[k]
    });
    return res;
}
function getRadioListSelectedValue(el) {
    const container = el.form || document.documentElement;
    for(var _i5 = 0, _Array$from = Array.from(container.querySelectorAll('input[name="' + el.name + '"]')); _i5 < _Array$from.length; _i5++){
        const iel = _Array$from[_i5];
        const ri = iel;
        if (ri.checked) return ri.value;
    }
    return null;
}
function sleepPromise(ms) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), ms));
}
function changeClassStartsWith(classList, start, name) {
    for(var _iterator3 = _createForOfIteratorHelperLoose(classList), _step3; !(_step3 = _iterator3()).done;){
        const t = _step3.value;
        if (t.startsWith(start)) classList.remove(t);
    }
    if (name) classList.add(start + name);
}
function changeIconBefore(classList, icon) {
    if (classList instanceof HTMLElement) classList = classList.classList;
    changeClassStartsWith(classList, "icon-before-", icon);
}
function toDate(value) {
    if (typeof value === "string") return new Date(value);
    if (typeof value === "number") throw "TODO: toDate/number";
    if (value instanceof Date) return value;
    throw "toDate: invalid value type";
}
function emptyToNull(val) {
    return val ? val : null;
}
class YMPeriod {
    static toNum(y, m) {
        return y * 12 + m;
    }
    static toInput(y, m = null) {
        if (m === null) [y, m] = YMPeriod.toYM(y);
        return y.toString().padStart(4, "0") + "-" + (m + 1).toString().padStart(2, "0");
    }
    static toYM(p) {
        return [
            Math.floor(p / 12),
            // @ts-ignore
            p % 12
        ];
    }
    static inputToNum(value) {
        let [y, m] = value.split("-").map((a)=>parseInt(a));
        m--;
        return value ? YMPeriod.toNum(y, m) : null;
    }
    static inputToYM(value) {
        const n = YMPeriod.inputToNum(value);
        return n !== null ? YMPeriod.toYM(n) : null;
    }
    static ymShift(y, m, shift) {
        return YMPeriod.toYM(YMPeriod.toNum(y, m) + shift);
    }
    static shift(value, change) {
        if (typeof value === "string") {
            const p = this.toNum(...this.inputToYM(value)) + change;
            return this.toInput(p);
        } else if (typeof value === "number") return value + change;
        else if (Array.isArray(value)) return YMPeriod.ymShift(value, change);
        throw "Invalid value";
    }
}
function getBrightness(color) {
    if (!color) return null;
    if (color[0] === "#") {
        color = color.substring(1);
        const bigint = parseInt(color, 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        color = `rgb(${r}, ${g}, ${b})`;
    }
    const values = color.match(/\d+/g).map(Number);
    const [r, g, b] = values;
    return (r * 299 + g * 587 + b * 114) / 1000;
}
function oneShotHandler(element, eventType, callback = null) {
    return new Promise((resolve)=>{
        const handler = (ev)=>{
            element.removeEventListener(eventType, handler);
            resolve(callback ? callback(ev) : null);
        };
        element.addEventListener(eventType, handler);
    });
}

});
parcelRegister("3cBch", function(module, exports) {

$parcel$export(module.exports, "UiFlashMessage", () => $ca1a35af37a565d4$export$b106d1f79a36a020);
$parcel$export(module.exports, "UiLoaderItem", () => $ca1a35af37a565d4$export$ad74b12ccbbe2faa);

var $4hoex = parcelRequire("4hoex");

var $dMN2n = parcelRequire("dMN2n");
class $ca1a35af37a565d4$export$b106d1f79a36a020 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.updateVisibility();
        $ca1a35af37a565d4$export$b106d1f79a36a020.instance = this;
    }
    updateVisibility() {
        // @ts-ignore
        this.container.style.display = this.ui.items.firstElementChild ? null : "none";
    }
    add(text, template = "item") {
        // @ts-ignore
        var item = this.muWidgetFromTemplate(template, "items", {
            text: text,
            showDuration: template === "loader" ? null : 7000
        });
        this.updateVisibility();
        return item;
    }
}
class $ca1a35af37a565d4$export$ad74b12ccbbe2faa extends (0, $4hoex.IMuWidget) {
    afterIndex() {
        this.ui.text.innerText = this.text;
        if (this.showDuration) {
            setTimeout(()=>this.container.toggleAttribute("loader-item__removing"), this.showDuration);
            setTimeout(()=>this.muRemoveSelf(), this.showDuration + 3000);
        }
    }
    remove() {
        this.muRemoveSelf();
        this.muParent.updateVisibility();
    }
    bClose_click() {
        this.remove();
    }
    constructor(...args){
        super(...args);
        this.text = "";
        this.showDuration = 7000;
    }
}

});
parcelRegister("4hoex", function(module, exports) {

$parcel$export(module.exports, "IMuWidget", () => $ddecbfc9be424e6b$export$ceeecf65c453c74);

var $dMN2n = parcelRequire("dMN2n");
class $ddecbfc9be424e6b$export$ceeecf65c453c74 extends (0, $dMN2n.MuWidget) {
} /* import { MuWidget } from "./MuWidget";
import { MuBinder, MuBindOpts} from "./MuBinder";
import { ForkItemDialog } from "./InvoiceApproval";

export class IMuWidget // extends MuWidget
{
	public ui : Record<string, AnyElement|any> = {};

	public muAppendContent(html: string) {};

	public muWidgetFromTemplate(templateName : string, container : string|AnyElement|null, params : Record<string, any>|((IMuWidget)=>Record<string, any>) = null, addMethod : "first"|"before"|"after"|"last"|"appendChild" = "appendChild", ref : AnyElement = null) : IMuWidget { return null; };

	public muClear(container : string|AnyElement) {
		if (typeof container === "string") container = this.ui[container];
		(container as AnyElement).innerHTML = "";
	}

	public muRemoveSelf() : void {};

	public container : AnyElement;

	public muGetChildWidgets<T>(container : string|AnyElement) : T[]
	{
		if (typeof container === "string") container = this.ui[container];
		return MuWidget.getChildWidgets(container);
	}

	public muBindList(list: any[], templateName : string, container : string|AnyElement, commonParams : any = null, finalCalback : (widget : any) => void = null) { }

	public muVisible(state : boolean|"toggle", control : string|string[]) { }

	public muSubWidgets : IMuWidget[];

	public muNamedWidget : Record<string, IMuWidget>;

	public muRoot : IMuWidget;
	
	public muParent : IMuWidget|null;

	public muTemplates : Record<string, string>;

	public muTemplateParents : Record<string, AnyElement>;

	public muAddEvent(eventName : string, element : AnyElement, callback : any) : void {}

	public muOnAfterIndex : ((self) => void)[];

	public muBindOpts : Record<string, MuBindOpts[]> = {};

	public muBindData(srcData : any)
	{
		MuBinder.bindData(this.muBindOpts, srcData, this);
		this.muAferBindData();
		this.muAfterBindData(srcData);
	}

	public muFetchData() : any
	{
		return MuBinder.fetchData(this.muBindOpts, this);
	}

	public muDispatchEvent(name: string, ...args) { }

	protected muRegisterEvent(...args) { }

	public addEventListener(name : string, handler : (...args)=>void) { }

	public muEventNames() : string[] { return []; }

	/**
	 * @deprecated Typo error
	 * /
	protected muAferBindData() { }

	protected muAfterBindData(data : any) { }

	public afterIndex() { }

	public static getChildWidgets = function(list, fn = undefined)
	{
		var ls = [];
		for(var i = 0; i < list.children.length; i++)
		{
			var item = list.children[i].widget; // MuWidget.getWidget(list.children[i]);
			if (!item) continue;
			if (fn) item = fn(item);
			ls.push(item);
		};
		return ls;
	}

	// @ts-ignore
	public muActivateWidget(element : AnyElement, opts : MuOpts|null = null, extraParams : Record<string, any>|null = null) : IMuWidget { }

	public muGetMethodCallback(methodName: string) {}

}

export type AnyElement = HTMLElement|SVGElement;

export function SetAttributes(element : AnyElement, attrs : Record<string,any>)
{
	for(const n in attrs)
	{
		element.setAttribute(n, attrs[n].toString());
	}
}

export type MuOpts = Record<string, any>;

*/ 

});


parcelRegister("3v8ea", function(module, exports) {

$parcel$export(module.exports, "CommonCL", () => $1a36d6b925c5e77c$export$a66bf90b73ebef86);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $1a36d6b925c5e77c$export$a66bf90b73ebef86 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/common"){
        super(url);
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});
parcelRegister("eieyy", function(module, exports) {

$parcel$export(module.exports, "MyBaseCL", () => $7716977a7cd93e62$export$594fa5143707b69a);

var $kvYLA = parcelRequire("kvYLA");

var $3cBch = parcelRequire("3cBch");
function $7716977a7cd93e62$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7716977a7cd93e62$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7716977a7cd93e62$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7716977a7cd93e62$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7716977a7cd93e62$var$_arrayLikeToArray(o, minLen);
}
function $7716977a7cd93e62$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $7716977a7cd93e62$export$594fa5143707b69a extends (0, $kvYLA.BaseCL) {
    constructor(url){
        super();
        this.message = null;
        this.loadingElement = null;
        this.url = url;
        this.onLoading = ()=>{
            this.loadingElement?.classList.toggle("loading-data", true);
            const fm = (0, $3cBch.UiFlashMessage).instance.add(this.message ?? "Komunikuji se serverem.", "loader");
            return fm;
        };
        this.onLoaded = (l)=>{
            this.loadingElement?.classList.toggle("loading-data", false);
            l.remove();
        };
    }
    withMessage(message, loadingElement = null) {
        const newCl = new this.constructor(this.url);
        newCl.message = message;
        newCl.loadingElement = loadingElement;
        newCl.context = this.context;
        return newCl;
    }
    updateContext(context) {
        if (context.flashMessages) for(var _iterator = $7716977a7cd93e62$var$_createForOfIteratorHelperLoose(context.flashMessages), _step; !(_step = _iterator()).done;){
            const flashMessage = _step.value;
            (0, $3cBch.UiFlashMessage).instance.add(flashMessage);
        }
        return super.updateContext(context);
    }
    async loadRawData(url, data = null) {
        const fopt = {};
        if (data) {
            fopt.body = data;
            fopt.method = "POST";
        }
        const f = fetch(url, fopt);
        let loadingHandle = null;
        let response = null;
        try {
            if (this.onLoading) loadingHandle = this.onLoading(url);
            response = await (await f).text();
        } catch (exc) {
            throw exc;
        } finally{
            if (this.onLoaded) this.onLoaded(loadingHandle, response);
        }
        return response;
    }
}

});
parcelRegister("kvYLA", function(module, exports) {

$parcel$export(module.exports, "BaseCL", () => $01a1c70935fd119e$export$384891ea976c606a);

var $gCgmb = parcelRequire("gCgmb");
class $01a1c70935fd119e$export$384891ea976c606a {
    getContext() {
        return this.context;
    }
    updateContext(context) {
        return this.context = {
            ...this.context,
            ...context
        };
    }
    callMethod(methodName, args /* : IArguments*/ , callOpts = {
        rawResult: false
    }, newDataType = null) {
        const ajax = new (0, $gCgmb.Ajax)(this.url + (this.addCommandToUrlPrefix ? this.addCommandToUrlPrefix + methodName : ""));
        // if (this.ajaxXMLHttpRequestClass) ajax.XMLHttpRequestClass  = this.ajaxXMLHttpRequestClass;
        // ajax.requestContentType = "application/json";
        const srcData = {
            name: methodName,
            context: this.context,
            pars: [
                ...args
            ]
        };
        ajax.setData(srcData);
        // ajax.requestHeaders['Origin'] = document.location.toString();
        ajax.requestHeaders["X-Requested-With"] = "XMLHttpRequest";
        ajax.responseType = callOpts.rawResult ? "arraybuffer" : "json";
        const dispatchError = (err)=>{};
        return new Promise((resolve, reject)=>{
            let loadingHandle;
            if (this.onLoading) loadingHandle = this.onLoading(srcData);
            ajax.promise().then((response)=>{
                if (ajax.responseHeaders["Content-Type"] === "octed/stream") resolve(response);
                else {
                    if (typeof response === "string") response = JSON.parse(response);
                    if (response.context) this.updateContext(response.context);
                    if (response.status == "ok") {
                        if (this.onLoaded) this.onLoaded(loadingHandle, response);
                        if (newDataType) response.response = new newDataType(response.response);
                        resolve(response.response);
                    } else {
                        if (this.onLoaded) this.onLoaded(loadingHandle, response);
                        if (reject) reject(response.exception);
                        else {
                            // alert("Chyba aplikace: " + response.Exception.Message);
                            if (this.onError) this.onError(loadingHandle, response.exception);
                            throw new Error(response.exception);
                        }
                    }
                }
            }).catch((exc)=>{
                if (this.onLoaded) this.onLoaded(loadingHandle, exc);
                if (reject) reject(exc);
                else {
                    if (this.onError) this.onError(loadingHandle, exc);
                    throw new Error(exc);
                }
            });
        });
    }
    constructor(){
        this.context = {};
        this.url = "";
        this.onLoading = null;
        this.onLoaded = null;
        this.onError = null;
        this.useMethod = null;
        this.addCommandToUrlPrefix = "?c=";
    }
}

});
parcelRegister("gCgmb", function(module, exports) {

$parcel$export(module.exports, "Ajax", () => $f7955938a8dd513b$export$7a330199b2e76989);
// import axios, {AxiosRequestConfig} from "axios";
class $f7955938a8dd513b$export$7a330199b2e76989 {
    constructor(url){
        this.query = {};
        this.formData = null;
        this.method = null;
        this.thenCallback = null;
        this.errorCallback = null;
        this.requestContentType = "";
        this.requestHeaders = {};
        this.responseHeaders = {};
        this.jsonResult = false;
        this.responseType = "";
        this.url = url;
        this.useLibrary = typeof XMLHttpRequest !== "undefined" ? "XMLHttpRequest" : "axios";
    }
    setQuery(query) {
        this.query = query;
        return this;
    }
    setData(data) {
        this.data = data;
        return this;
    }
    setFormData(formData) {
        this.formData = formData;
        return this;
    }
    then(then) {
        this.thenCallback = then;
        return this;
    }
    error(error) {
        this.errorCallback = error;
        return this;
    }
    promise() {
        const prom = new Promise((resolve, reject)=>this._call(resolve, reject));
        if (this.errorCallback) prom.catch(this.errorCallback);
        if (this.thenCallback) prom.then(this.thenCallback);
        return prom;
    }
    call() {
        this._call(this.thenCallback || ((v)=>undefined), this.errorCallback || ((v)=>undefined));
    }
    _call(resolve, reject) {
        const postData = this.getPostData();
        switch(this.useLibrary){
            /* case "axios":
      	const config : AxiosRequestConfig = {
      		method: postData ? "POST" : "GET",
      		url: this.getFullUrl(),
      		headers: { ...this.requestHeaders }
      	};
      		if (postData) {
      		config.data = postData.data;
      		config.headers["Content-Type"] = this.requestContentType || postData.contentType;
      	}
      		axios.request(config)
      		.then(res => {
      			if (res.status >= 200 && res.status < 400) {
      				resolve(res.data);
      			} else {
      				reject(res);
      			}
      		})
      		.catch(exc => {
      			reject(exc);
      		});
      		break; */ case "XMLHttpRequest":
                const req = new XMLHttpRequest();
                req.open(this.getMethod(), this.getFullUrl(), true);
                req.responseType = this.responseType;
                req.onload = (e)=>{
                    this.responseHeaders = $f7955938a8dd513b$var$parseResponseHeaders(req.getAllResponseHeaders());
                    if (req.status >= 200 && req.status < 400) {
                        let resp = req.response;
                        if (this.jsonResult && typeof resp === "string") resp = JSON.parse(resp);
                        resolve(resp);
                    } else reject(req.response);
                };
                req.onerror = (e)=>reject(e);
                req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                const setHeaders = ()=>{
                    for(const hn in this.requestHeaders)req.setRequestHeader(hn, this.requestHeaders[hn]);
                };
                if (postData) {
                    req.setRequestHeader("Content-Type", this.requestContentType || postData.contentType || "application/octet-stream");
                    setHeaders();
                    req.send(postData.data);
                } else {
                    setHeaders();
                    req.send();
                }
                break;
        }
    }
    getMethod() {
        return this.method || (this.formData || this.data ? "POST" : "GET");
    }
    getPostData() {
        if (this.formData) {
            const fd = new FormData();
            this.prepareDataValues(this.formData, (k, v)=>fd.append(k, v));
            return {
                data: fd,
                contentType: "application/x-www-form-urlencoded"
            };
        }
        if (this.data) {
            if (typeof this.data === "object" || Array.isArray(this.data)) return {
                data: JSON.stringify(this.data),
                contentType: "application/json"
            };
            else return {
                data: this.data,
                contentType: "application/octet-stream"
            };
        }
        return null;
    }
    getFullUrl() {
        let query = this.url;
        if (this.query && Object.keys(this.query).length) {
            query += "?";
            this.prepareDataValues(this.query, (k, v)=>query += encodeURIComponent(k) + "=" + encodeURIComponent(v) + "&");
        }
        return query;
    }
    prepareDataValues(items, callback) {
        for(const p in items)if (items.hasOwnProperty(p)) {
            let v = items[p];
            if (v !== null) {
                if (v instanceof Date) v = v.toISOString();
                callback(p, v);
            }
        }
    }
}
function $f7955938a8dd513b$var$parseResponseHeaders(headerStr) {
    const headers = {};
    if (!headerStr) return headers;
    let headerPairs = headerStr.split("\r\n");
    for(let i = 0; i < headerPairs.length; i++){
        let headerPair = headerPairs[i];
        let index = headerPair.indexOf(": ");
        if (index > 0) {
            let key = headerPair.substring(0, index);
            let val = headerPair.substring(index + 2);
            headers[key] = val;
        }
    }
    return headers;
}

});






parcelRegister("drdLe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UiFlashMessage = module.exports.UiFlashMessageContainer = void 0;

var $dMN2n = parcelRequire("dMN2n");
class $9c8878936da300e3$var$UiFlashMessageContainer extends $dMN2n.MuWidget {
    afterIndex() {
        this.updateVisibility();
        $9c8878936da300e3$var$UiFlashMessageContainer.instance = this;
    }
    updateVisibility() {
        this.container.style.display = this.ui.items.firstElementChild ? null : "none";
    }
    add(text, template = "message") {
        var item = this.muWidgetFromTemplate(template, "items", {
            text: text
        });
        this.updateVisibility();
        return item;
    }
}
module.exports.UiFlashMessageContainer = $9c8878936da300e3$var$UiFlashMessageContainer;
class $9c8878936da300e3$var$UiFlashMessage extends $dMN2n.MuWidget {
    afterIndex() {
        if (this.text) this.ui.text.innerText = this.text;
    }
    remove() {
        this.muRemoveSelf();
        this.muParent.updateVisibility();
    }
    bClose_click() {
        this.remove();
    }
    static add() {}
}
module.exports.UiFlashMessage = $9c8878936da300e3$var$UiFlashMessage;

});



parcelRegister("cnflh", function(module, exports) {

$parcel$export(module.exports, "PqmFieldRegister", () => $169ced88b213ef4f$export$27e9b060fbd60eeb);

var $fg1OA = parcelRequire("fg1OA");
function $169ced88b213ef4f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $169ced88b213ef4f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $169ced88b213ef4f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $169ced88b213ef4f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $169ced88b213ef4f$var$_arrayLikeToArray(o, minLen);
}
function $169ced88b213ef4f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $169ced88b213ef4f$export$27e9b060fbd60eeb {
    static{
        this.registeredPqmFieldClass = {};
    }
    static register(inputFieldClass) {
        for(var _iterator = $169ced88b213ef4f$var$_createForOfIteratorHelperLoose(inputFieldClass.getValueTypes()), _step; !(_step = _iterator()).done;){
            const k = _step.value;
            $169ced88b213ef4f$export$27e9b060fbd60eeb.registeredPqmFieldClass[k] = inputFieldClass;
        }
    }
    static getClassFor(paramType, control) {
        if (!paramType) return null;
        const k1 = paramType + ":" + control;
        const k2 = paramType + ":*";
        return $169ced88b213ef4f$export$27e9b060fbd60eeb.registeredPqmFieldClass[k1] || $169ced88b213ef4f$export$27e9b060fbd60eeb.registeredPqmFieldClass[k2] || (0, $fg1OA.PqmFieldEmpty);
    }
}

});
parcelRegister("fg1OA", function(module, exports) {

$parcel$export(module.exports, "PqmFieldEmpty", () => $40ab73156e9ae334$export$d06d2411f4566f09);

var $3XMts = parcelRequire("3XMts");
class $40ab73156e9ae334$export$d06d2411f4566f09 extends (0, $3XMts.BasePqmFieldValue) {
    beforeIndex() {
        this.muAppendContent(`<span mu-id="message"></span>`);
    }
    afterIndex() {
        this.ui.message.innerText = this.message + " " + this.paramType + " " + this.control;
    }
    constructor(...args){
        super(...args);
        this.message = "";
    }
}

});



parcelRegister("1WNaB", function(module, exports) {

$parcel$export(module.exports, "UiScripting", () => $79a1a974c2f41841$export$8fd6d6e5ce1797d4);
$parcel$export(module.exports, "UiScriptingAction", () => $79a1a974c2f41841$export$42cbe367bc8a0dd3);
$parcel$export(module.exports, "UiScriptingActionList", () => $79a1a974c2f41841$export$65d9cb4769e77372);
$parcel$export(module.exports, "operationTitles", () => $79a1a974c2f41841$export$cdba7e66d0a93fe9);
$parcel$export(module.exports, "UiScriptingActionDefault", () => $79a1a974c2f41841$export$f81b68411de4d783);
$parcel$export(module.exports, "UiScriptingActionCall", () => $79a1a974c2f41841$export$9efe82e62f3bd97a);
$parcel$export(module.exports, "UiScriptingActionPHP", () => $79a1a974c2f41841$export$62a3047ed5b71e46);
$parcel$export(module.exports, "UiParameter", () => $79a1a974c2f41841$export$4c86f56f5c6f8447);
$parcel$export(module.exports, "UiScriptingActionIf", () => $79a1a974c2f41841$export$93dde62cfa6d375d);
$parcel$export(module.exports, "UiCondition", () => $79a1a974c2f41841$export$e759102cc5c69ea9);
$parcel$export(module.exports, "UiActionConditionList", () => $79a1a974c2f41841$export$2e106c23f7d70b87);
$parcel$export(module.exports, "UiActionCondition", () => $79a1a974c2f41841$export$4a71db546618170c);

var $4hoex = parcelRequire("4hoex");

var $gCgmb = parcelRequire("gCgmb");

var $92Ocn = parcelRequire("92Ocn");
function $79a1a974c2f41841$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $79a1a974c2f41841$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $79a1a974c2f41841$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $79a1a974c2f41841$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $79a1a974c2f41841$var$_arrayLikeToArray(o, minLen);
}
function $79a1a974c2f41841$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $79a1a974c2f41841$export$8fd6d6e5ce1797d4 extends (0, $4hoex.IMuWidget) {
    constructor(container){
        super();
        container.querySelector('[name="jsonSrc"]').setAttribute("mu-id", "jsonSrc");
    }
    afterIndex() {
        /* this.muNamedWidget.actions = this.muWidgetFromTemplate("ancestor:actionList", "actionListContainer");
    this.ui.actions = this.muNamedWidget.actions.container; */ this.bindFromSrc();
    }
    bindFromSrc() {
        const src = JSON.parse(this.ui.jsonSrc.value);
        this.bindActionList(src);
    }
    showCode_click() {
        const ajax = new (0, $gCgmb.Ajax)(this.url.preview);
        ajax.method = "POST";
        ajax.setData({
            code: this.ui.jsonSrc.value
        });
        ajax.jsonResult = true;
        ajax.then((data)=>{
            this.ui.code.innerText = data.code + "\n\n" + data.errors;
        });
        ajax.call();
    /* this.ajax(
    	"preview",
    	{"code": this.ui.jsonSrc.value },
    	function(data) {
    		this.ui.code.innerText = data.code + "\n\n" + data.errors;
    	}
    )*/ }
    bindActionList(actions) {
        const actionList = this.muNamedWidget.actions;
        actionList.clear();
        actionList.addRange(actions);
    // this.updateSortable();
    }
}
class $79a1a974c2f41841$export$42cbe367bc8a0dd3 extends (0, $4hoex.IMuWidget) {
    afterIndex() {
        this.bind(this.action);
    }
}
class $79a1a974c2f41841$export$65d9cb4769e77372 extends (0, $4hoex.IMuWidget) {
    static{
        this.commandToTemplate = {
            "=": "actionAssign",
            call: "actionCall",
            default: "actionDefault",
            if: "actionIf",
            php: "actionPhp",
            exit: "actionExit"
        };
    }
    add(src) {
        let operation = src[0];
        const useReturnValue = operation[0] == "=";
        if (useReturnValue) operation = operation.substr(1);
        let template;
        let callName = null;
        if ($79a1a974c2f41841$export$65d9cb4769e77372.commandToTemplate[operation]) template = $79a1a974c2f41841$export$65d9cb4769e77372.commandToTemplate[operation];
        else {
            template = "actionCall";
            callName = operation;
        }
        const wAction = this.muWidgetFromTemplate("ancestor:" + template, "actions", {
            action: src
        });
        // remove icon
        const hRemove = document.createElement("span");
        hRemove.innerHTML = "&#x1F5D1;";
        hRemove.className = "close";
        hRemove.addEventListener("click", ()=>{
            if (confirm("Opravdu odebrat tuto akci?")) wAction.muRemoveSelf();
        });
        wAction.container.querySelector("legend").appendChild(hRemove);
    }
    addRange(actionList) {
        for(var _i = 0, _actionList = actionList; _i < _actionList.length; _i++){
            const action = _actionList[_i];
            this.add(action);
        }
        this.updateSortable();
    }
    updateSortable() {
        const sortable = (0, $92Ocn.Sortable).create(this.ui.actions, {
            handle: "legend",
            animation: 75
        });
    }
    clear() {
        this.ui.actions.innerHTML = "";
    }
    bAdd_click() {
        if (this.ui.operationType.value) this.add([
            this.ui.operationType.value
        ]);
        else alert("Vyberte akci");
    }
    afterIndex() {
        const opts = {
            "": "Vyberte",
            ...$79a1a974c2f41841$export$cdba7e66d0a93fe9
        };
        this.muBindData({
            operationTypes: opts
        });
    }
    bind(actions) {
        this.ui.actions.innerHTML = "";
        if (actions) this.addRange(actions);
    // this.
    }
    fetch() {
        const res = [];
        for(var _iterator = $79a1a974c2f41841$var$_createForOfIteratorHelperLoose(this.ui.actions.childNodes), _step; !(_step = _iterator()).done;){
            const el = _step.value;
            res.push(el.widget.fetch());
        }
        return res;
    }
}
class $79a1a974c2f41841$export$f81b68411de4d783 extends $79a1a974c2f41841$export$42cbe367bc8a0dd3 {
    bind(action) {
        this.ui.variable.value = action[1];
        this.muNamedWidget.defaultValue.setValue(action[2]);
    }
    fetch() {
        return [
            "default",
            this.ui.variable.value,
            this.muNamedWidget.defaultValue.getValue()
        ];
    }
}
class $79a1a974c2f41841$export$9efe82e62f3bd97a extends $79a1a974c2f41841$export$42cbe367bc8a0dd3 {
    bind(action) {
        const urv = action[0][0] == "=";
        this.ui.useReturnValue.checked = urv;
        this.ui.operation.value = this.ui.useReturnValue.checked ? action[0].substr(1) : action[0];
        if (urv) this.ui.returnValueVariable.value = action[1];
        for(var _iterator2 = $79a1a974c2f41841$var$_createForOfIteratorHelperLoose(action.slice(urv ? 2 : 1)), _step2; !(_step2 = _iterator2()).done;){
            const param = _step2.value;
            const arg = this.muWidgetFromTemplate("argument", "arguments", {
                sortable: true,
                removable: true
            });
            arg.setValue(param);
        }
    // (this.muNamedWidget.defaultValue as UiParameter).setValue(action[2]);
    }
    fetch() {
        const urv = this.ui.useReturnValue.checked;
        const ret = [
            (urv ? "=" : "") + this.ui.operation.value
        ];
        if (urv) ret.push(this.ui.returnValueVariable.value);
        for(var _iterator3 = $79a1a974c2f41841$var$_createForOfIteratorHelperLoose((0, $4hoex.IMuWidget).getChildWidgets(this.ui.arguments)), _step3; !(_step3 = _iterator3()).done;){
            const el = _step3.value;
            ret.push(el.getValue());
        }
        return ret;
    }
    useReturnValue_change() {
        this.muVisible(this.ui.useReturnValue.checked, "returnValueVariable");
    }
    bAddArgument_click() {
        this.muWidgetFromTemplate("argument", "arguments", {
            sortable: true,
            removable: true
        });
    }
}
class $79a1a974c2f41841$export$62a3047ed5b71e46 extends $79a1a974c2f41841$export$42cbe367bc8a0dd3 {
    bind(action) {
        this.ui.phpSrc.value = action[1] || "";
    }
    fetch() {
        return [
            "php",
            this.ui.phpSrc.value
        ];
    }
}
class $79a1a974c2f41841$export$4c86f56f5c6f8447 extends (0, $4hoex.IMuWidget) {
    constructor(container){
        super();
        container.innerHTML += `
			<span mu-id="type" mu-widget="UiSelector" class="ui-selector">
				<span mu-template="item"></span>
			</span>
			<input type="text" mu-id="value" />			
			<span mu-id="hSortable" class="sortable-handler pull-left">&#x21C5;</span>
			<span mu-id="bRemove" class="close">&#x1F5D1;</span>
			<textarea mu-id="valueArea" class="form-control"></textarea>`;
    }
    afterIndex() {
        this.typeSelector = this.muNamedWidget.type;
        this.typeSelector.textField = "text";
        this.typeSelector.bindValues([
            {
                value: "variable",
                text: "prom\u011Bnn\xe1"
            },
            {
                value: "string",
                text: "text"
            },
            {
                value: "number",
                text: "\u010D\xedslo"
            },
            {
                value: "true",
                text: "ano"
            },
            {
                value: "false",
                text: "ne"
            },
            {
                value: "null",
                text: "nic"
            },
            {
                value: "json",
                text: "JSON"
            }
        ]);
        this.type_change();
        this.muVisible(this.sortable, "hSortable");
        this.muVisible(this.removable, "bRemove");
    }
    type_change() {
        const type = this.typeSelector.getActive();
        this.muVisible(type == "variable" || type == "number", "value");
        this.muVisible(type == "json" || type == "string", "valueArea");
    }
    setValue(value) {
        let type;
        if (value === null) type = "null";
        else switch(typeof value){
            case "string":
                switch(value[0]){
                    case "'":
                        type = "string";
                        break;
                    case "$":
                        type = "variable";
                        break;
                }
                value = value.substr(1);
                break;
            case "number":
                type = "number";
                value = "";
                break;
            case "boolean":
                type = value ? "true" : "false";
                value = "";
                break;
            case "object":
                type = "json";
                value = JSON.stringify(value, null, 4);
                break;
        }
        this.typeSelector.setActive(type);
        this.ui.value.value = this.ui.valueArea.value = value;
        this.ui.value.type = type == "number" ? "number" : "text";
        this.type_change();
    }
    getValue() {
        switch(this.typeSelector.getActive()){
            case "false":
                return false;
            case "true":
                return true;
            case "null":
                return null;
            case "string":
                return "'" + this.ui.valueArea.value;
            case "number":
                return parseFloat(this.ui.value.value);
            case "variable":
                return "$" + this.ui.value.value;
            case "json":
                return JSON.parse(this.ui.valueArea.value);
        }
    }
    bRemove_click() {
        if (confirm("Odebrat argument?")) this.muRemoveSelf();
    }
}
class $79a1a974c2f41841$export$93dde62cfa6d375d extends $79a1a974c2f41841$export$42cbe367bc8a0dd3 {
    afterIndex() {
        /* for(const n of ["then", "else"])
    {
    	this.muNamedWidget[n] = this.muWidgetFromTemplate("ancestor:actionList", n + "Container");
    	this.ui[n] = this.muNamedWidget[n].container;
    } */ super.afterIndex();
    }
    bind(action) {
        this.muNamedWidget.then.bind(action[2]);
        this.muNamedWidget.else.bind(action[3]);
    }
    fetch() {
        return undefined;
    }
}
class $79a1a974c2f41841$export$e759102cc5c69ea9 extends (0, $4hoex.IMuWidget) {
    bind(condition) {}
}
const $79a1a974c2f41841$export$cdba7e66d0a93fe9 = {
    "if": "Podm\xednka",
    "exit": "Ukon\u010Dit script",
    "php": "PHP k\xf3d",
    "=": "P\u0159i\u0159azen\xed",
    "default": "V\xfdchoz\xed hodnota",
    "call": "Prov\xe9st"
};
const $79a1a974c2f41841$var$ConditionOpts = {
    "": {
        name: "Je pravda",
        paramCount: 1
    },
    "!": {
        name: "Nen\xed pravda (NOT)",
        paramCount: 1
    },
    "!=": {
        name: "Nerovn\xe1 se",
        textBetween: "nerovn\xe1 se",
        paramCount: 2
    },
    "<": {
        name: "Je men\u0161\xed ne\u017E",
        textBetween: "je men\u0161\xed ne\u017E",
        paramCount: 2
    },
    "<=": {
        name: "Je men\u0161\xed nebo rovno",
        textBetween: "je men\u0161\xed nebo rovno",
        paramCount: 2
    },
    "==": {
        name: "Rovn\xe1 se",
        textBetween: "rovn\xe1 se",
        paramCount: 2
    },
    ">": {
        name: "Je v\u011Bt\u0161\xed ne\u017E",
        textBetween: "je v\u011Bt\u0161\xed ne\u017E",
        paramCount: 2
    },
    ">=": {
        name: "Je v\u011Bt\u0161\xed nebo rovno",
        textBetween: "je v\u011Bt\u0161\xed nebo rovno",
        paramCount: 2
    },
    in: {
        name: "Je jeden z",
        paramCount: 2
    },
    and: {
        name: "V\xedce podm\xednek: Je pravda v\u0161e (AND)",
        prefix: "Je pravda \u017Ee",
        textBetween: "a z\xe1rove\u0148",
        paramCount: "*"
    },
    nand: {
        name: "V\xedce podm\xednek: Nen\xed pravda nic (NAND)",
        prefix: "Nen\xed pravda \u017Ee",
        textBetween: "a z\xe1rove\u0148",
        paramCount: "*"
    },
    or: {
        name: "V\xedce podm\xednek: Je pravda n\u011Bco (OR)",
        prefix: "Je pravda \u017Ee",
        textBetween: "a nebo",
        paramCount: "*"
    },
    nor: {
        name: "V\xedce podm\xednek: Nen\xed pravda n\u011Bco (NOR)",
        prefix: "Nen\xed pravda \u017Ee",
        textBetween: "a nebo",
        paramCount: "*"
    }
};
class $79a1a974c2f41841$export$2e106c23f7d70b87 extends (0, $4hoex.IMuWidget) {
}
class $79a1a974c2f41841$export$4a71db546618170c extends (0, $4hoex.IMuWidget) {
}

});
parcelRegister("92Ocn", function(module, exports) {

$parcel$export(module.exports, "Sortable", () => $695b3d6025d5e530$export$31b3ca70d8f57423);
$parcel$export(module.exports, "default", () => $695b3d6025d5e530$export$2e2bcd8739ae039);
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $695b3d6025d5e530$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $695b3d6025d5e530$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $695b3d6025d5e530$var$ownKeys(Object(source), true).forEach(function(key) {
            $695b3d6025d5e530$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $695b3d6025d5e530$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $695b3d6025d5e530$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $695b3d6025d5e530$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $695b3d6025d5e530$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $695b3d6025d5e530$var$_typeof(obj);
}
function $695b3d6025d5e530$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $695b3d6025d5e530$var$_extends() {
    $695b3d6025d5e530$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $695b3d6025d5e530$var$_extends.apply(this, arguments);
}
function $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $695b3d6025d5e530$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $695b3d6025d5e530$var$_toConsumableArray(arr) {
    return $695b3d6025d5e530$var$_arrayWithoutHoles(arr) || $695b3d6025d5e530$var$_iterableToArray(arr) || $695b3d6025d5e530$var$_unsupportedIterableToArray(arr) || $695b3d6025d5e530$var$_nonIterableSpread();
}
function $695b3d6025d5e530$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $695b3d6025d5e530$var$_arrayLikeToArray(arr);
}
function $695b3d6025d5e530$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $695b3d6025d5e530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
}
function $695b3d6025d5e530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $695b3d6025d5e530$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $695b3d6025d5e530$var$version = "1.15.2";
function $695b3d6025d5e530$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $695b3d6025d5e530$var$IE11OrLess = $695b3d6025d5e530$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $695b3d6025d5e530$var$Edge = $695b3d6025d5e530$var$userAgent(/Edge/i);
var $695b3d6025d5e530$var$FireFox = $695b3d6025d5e530$var$userAgent(/firefox/i);
var $695b3d6025d5e530$var$Safari = $695b3d6025d5e530$var$userAgent(/safari/i) && !$695b3d6025d5e530$var$userAgent(/chrome/i) && !$695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$IOS = $695b3d6025d5e530$var$userAgent(/iP(ad|od|hone)/i);
var $695b3d6025d5e530$var$ChromeForAndroid = $695b3d6025d5e530$var$userAgent(/chrome/i) && $695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$captureMode = {
    capture: false,
    passive: false
};
function $695b3d6025d5e530$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $695b3d6025d5e530$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $695b3d6025d5e530$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $695b3d6025d5e530$var$matches(el, selector) : $695b3d6025d5e530$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $695b3d6025d5e530$var$getParentOrHost(el));
    }
    return null;
}
var $695b3d6025d5e530$var$R_SPACE = /\s+/g;
function $695b3d6025d5e530$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($695b3d6025d5e530$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($695b3d6025d5e530$var$R_SPACE, " ");
        }
    }
}
function $695b3d6025d5e530$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $695b3d6025d5e530$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $695b3d6025d5e530$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $695b3d6025d5e530$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $695b3d6025d5e530$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $695b3d6025d5e530$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $695b3d6025d5e530$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$695b3d6025d5e530$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($695b3d6025d5e530$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $695b3d6025d5e530$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($695b3d6025d5e530$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($695b3d6025d5e530$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $695b3d6025d5e530$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $695b3d6025d5e530$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $695b3d6025d5e530$var$getParentAutoScrollElement(el, true), elSideVal = $695b3d6025d5e530$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $695b3d6025d5e530$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $695b3d6025d5e530$var$getWindowScrollingElement()) break;
        parent = $695b3d6025d5e530$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $695b3d6025d5e530$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.dragged) && $695b3d6025d5e530$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $695b3d6025d5e530$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost || $695b3d6025d5e530$var$css(last, "display") === "none" || selector && !$695b3d6025d5e530$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $695b3d6025d5e530$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $695b3d6025d5e530$export$31b3ca70d8f57423.clone && (!selector || $695b3d6025d5e530$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $695b3d6025d5e530$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $695b3d6025d5e530$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $695b3d6025d5e530$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $695b3d6025d5e530$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $695b3d6025d5e530$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $695b3d6025d5e530$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $695b3d6025d5e530$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $695b3d6025d5e530$var$getWindowScrollingElement();
}
function $695b3d6025d5e530$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $695b3d6025d5e530$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $695b3d6025d5e530$var$_throttleTimeout;
function $695b3d6025d5e530$var$throttle(callback, ms) {
    return function() {
        if (!$695b3d6025d5e530$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $695b3d6025d5e530$var$_throttleTimeout = setTimeout(function() {
                $695b3d6025d5e530$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $695b3d6025d5e530$var$cancelThrottle() {
    clearTimeout($695b3d6025d5e530$var$_throttleTimeout);
    $695b3d6025d5e530$var$_throttleTimeout = void 0;
}
function $695b3d6025d5e530$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $695b3d6025d5e530$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $695b3d6025d5e530$var$setRect(el, rect) {
    $695b3d6025d5e530$var$css(el, "position", "absolute");
    $695b3d6025d5e530$var$css(el, "top", rect.top);
    $695b3d6025d5e530$var$css(el, "left", rect.left);
    $695b3d6025d5e530$var$css(el, "width", rect.width);
    $695b3d6025d5e530$var$css(el, "height", rect.height);
}
function $695b3d6025d5e530$var$unsetRect(el) {
    $695b3d6025d5e530$var$css(el, "position", "");
    $695b3d6025d5e530$var$css(el, "top", "");
    $695b3d6025d5e530$var$css(el, "left", "");
    $695b3d6025d5e530$var$css(el, "width", "");
    $695b3d6025d5e530$var$css(el, "height", "");
}
function $695b3d6025d5e530$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$695b3d6025d5e530$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $695b3d6025d5e530$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $695b3d6025d5e530$var$expando = "Sortable" + new Date().getTime();
function $695b3d6025d5e530$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($695b3d6025d5e530$var$css(child, "display") === "none" || child === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $695b3d6025d5e530$var$getRect(child)
                });
                var fromRect = $695b3d6025d5e530$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $695b3d6025d5e530$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($695b3d6025d5e530$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $695b3d6025d5e530$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $695b3d6025d5e530$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($695b3d6025d5e530$var$isRectEqual(prevFromRect, toRect) && !$695b3d6025d5e530$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $695b3d6025d5e530$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$695b3d6025d5e530$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $695b3d6025d5e530$var$css(target, "transition", "");
                $695b3d6025d5e530$var$css(target, "transform", "");
                var elMatrix = $695b3d6025d5e530$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $695b3d6025d5e530$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $695b3d6025d5e530$var$repaint(target); // repaint
                $695b3d6025d5e530$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $695b3d6025d5e530$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $695b3d6025d5e530$var$css(target, "transition", "");
                    $695b3d6025d5e530$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $695b3d6025d5e530$var$repaint(target) {
    return target.offsetWidth;
}
function $695b3d6025d5e530$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $695b3d6025d5e530$var$plugins = [];
var $695b3d6025d5e530$var$defaults = {
    initializeByDefault: true
};
var $695b3d6025d5e530$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $695b3d6025d5e530$var$defaults)if ($695b3d6025d5e530$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $695b3d6025d5e530$var$defaults[option];
        $695b3d6025d5e530$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $695b3d6025d5e530$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $695b3d6025d5e530$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $695b3d6025d5e530$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $695b3d6025d5e530$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$695b3d6025d5e530$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, extraEventProperties), $695b3d6025d5e530$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $695b3d6025d5e530$var$_excluded = [
    "evt"
];
var $695b3d6025d5e530$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $695b3d6025d5e530$var$_objectWithoutProperties(_ref, $695b3d6025d5e530$var$_excluded);
    $695b3d6025d5e530$var$PluginManager.pluginEvent.bind($695b3d6025d5e530$export$31b3ca70d8f57423)(eventName, sortable, $695b3d6025d5e530$var$_objectSpread2({
        dragEl: $695b3d6025d5e530$var$dragEl,
        parentEl: $695b3d6025d5e530$var$parentEl,
        ghostEl: $695b3d6025d5e530$var$ghostEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        nextEl: $695b3d6025d5e530$var$nextEl,
        lastDownEl: $695b3d6025d5e530$var$lastDownEl,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        cloneHidden: $695b3d6025d5e530$var$cloneHidden,
        dragStarted: $695b3d6025d5e530$var$moved,
        putSortable: $695b3d6025d5e530$var$putSortable,
        activeSortable: $695b3d6025d5e530$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
        hideGhostForTarget: $695b3d6025d5e530$var$_hideGhostForTarget,
        unhideGhostForTarget: $695b3d6025d5e530$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $695b3d6025d5e530$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $695b3d6025d5e530$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $695b3d6025d5e530$var$_dispatchEvent(info) {
    $695b3d6025d5e530$var$dispatchEvent($695b3d6025d5e530$var$_objectSpread2({
        putSortable: $695b3d6025d5e530$var$putSortable,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        targetEl: $695b3d6025d5e530$var$dragEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex
    }, info));
}
var $695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$parentEl, $695b3d6025d5e530$var$ghostEl, $695b3d6025d5e530$var$rootEl, $695b3d6025d5e530$var$nextEl, $695b3d6025d5e530$var$lastDownEl, $695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$cloneHidden, $695b3d6025d5e530$var$oldIndex, $695b3d6025d5e530$var$newIndex, $695b3d6025d5e530$var$oldDraggableIndex, $695b3d6025d5e530$var$newDraggableIndex, $695b3d6025d5e530$var$activeGroup, $695b3d6025d5e530$var$putSortable, $695b3d6025d5e530$var$awaitingDragStarted = false, $695b3d6025d5e530$var$ignoreNextClick = false, $695b3d6025d5e530$var$sortables = [], $695b3d6025d5e530$var$tapEvt, $695b3d6025d5e530$var$touchEvt, $695b3d6025d5e530$var$lastDx, $695b3d6025d5e530$var$lastDy, $695b3d6025d5e530$var$tapDistanceLeft, $695b3d6025d5e530$var$tapDistanceTop, $695b3d6025d5e530$var$moved, $695b3d6025d5e530$var$lastTarget, $695b3d6025d5e530$var$lastDirection, $695b3d6025d5e530$var$pastFirstInvertThresh = false, $695b3d6025d5e530$var$isCircumstantialInvert = false, $695b3d6025d5e530$var$targetMoveDistance, // For positioning ghost absolutely
$695b3d6025d5e530$var$ghostRelativeParent, $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = [], // (left, top)
$695b3d6025d5e530$var$_silent = false, $695b3d6025d5e530$var$savedInputChecked = [];
/** @const */ var $695b3d6025d5e530$var$documentExists = typeof document !== "undefined", $695b3d6025d5e530$var$PositionGhostAbsolutely = $695b3d6025d5e530$var$IOS, $695b3d6025d5e530$var$CSSFloatProperty = $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$695b3d6025d5e530$var$supportDraggable = $695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid && !$695b3d6025d5e530$var$IOS && "draggable" in document.createElement("div"), $695b3d6025d5e530$var$supportCssPointerEvents = function() {
    if (!$695b3d6025d5e530$var$documentExists) return;
    // false when <= IE11
    if ($695b3d6025d5e530$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $695b3d6025d5e530$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $695b3d6025d5e530$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $695b3d6025d5e530$var$getChild(el, 0, options), child2 = $695b3d6025d5e530$var$getChild(el, 1, options), firstChildCSS = child1 && $695b3d6025d5e530$var$css(child1), secondChildCSS = child2 && $695b3d6025d5e530$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === "none" || child2 && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $695b3d6025d5e530$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $695b3d6025d5e530$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $695b3d6025d5e530$var$sortables.some(function(sortable) {
        var threshold = sortable[$695b3d6025d5e530$var$expando].options.emptyInsertThreshold;
        if (!threshold || $695b3d6025d5e530$var$lastChild(sortable)) return;
        var rect = $695b3d6025d5e530$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $695b3d6025d5e530$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $695b3d6025d5e530$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $695b3d6025d5e530$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "display", "none");
}, $695b3d6025d5e530$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($695b3d6025d5e530$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $695b3d6025d5e530$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($695b3d6025d5e530$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $695b3d6025d5e530$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$695b3d6025d5e530$var$expando]._onDragOver(event);
        }
    }
};
var $695b3d6025d5e530$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($695b3d6025d5e530$var$dragEl) $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $695b3d6025d5e530$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $695b3d6025d5e530$var$_extends({}, options);
    // Export instance
    el[$695b3d6025d5e530$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $695b3d6025d5e530$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $695b3d6025d5e530$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$695b3d6025d5e530$var$Safari,
        emptyInsertThreshold: 5
    };
    $695b3d6025d5e530$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $695b3d6025d5e530$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $695b3d6025d5e530$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $695b3d6025d5e530$var$on(el, "pointerdown", this._onTapStart);
    else {
        $695b3d6025d5e530$var$on(el, "mousedown", this._onTapStart);
        $695b3d6025d5e530$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $695b3d6025d5e530$var$on(el, "dragover", this);
        $695b3d6025d5e530$var$on(el, "dragenter", this);
    }
    $695b3d6025d5e530$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $695b3d6025d5e530$var$_extends(this, $695b3d6025d5e530$var$AnimationStateManager());
}
$695b3d6025d5e530$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $695b3d6025d5e530$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $695b3d6025d5e530$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $695b3d6025d5e530$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $695b3d6025d5e530$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($695b3d6025d5e530$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $695b3d6025d5e530$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($695b3d6025d5e530$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$index(target);
        $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $695b3d6025d5e530$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $695b3d6025d5e530$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $695b3d6025d5e530$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$695b3d6025d5e530$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$695b3d6025d5e530$var$dragEl && target.parentNode === el) {
            var dragRect = $695b3d6025d5e530$var$getRect(target);
            $695b3d6025d5e530$var$rootEl = el;
            $695b3d6025d5e530$var$dragEl = target;
            $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode;
            $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$dragEl.nextSibling;
            $695b3d6025d5e530$var$lastDownEl = target;
            $695b3d6025d5e530$var$activeGroup = options.group;
            $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$var$dragEl;
            $695b3d6025d5e530$var$tapEvt = {
                target: $695b3d6025d5e530$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $695b3d6025d5e530$var$tapDistanceLeft = $695b3d6025d5e530$var$tapEvt.clientX - dragRect.left;
            $695b3d6025d5e530$var$tapDistanceTop = $695b3d6025d5e530$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $695b3d6025d5e530$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $695b3d6025d5e530$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$695b3d6025d5e530$var$FireFox && _this.nativeDraggable) $695b3d6025d5e530$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $695b3d6025d5e530$var$find($695b3d6025d5e530$var$dragEl, criteria.trim(), $695b3d6025d5e530$var$_disableDraggable);
            });
            $695b3d6025d5e530$var$on(ownerDocument, "dragover", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "mousemove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "touchmove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "mouseup", _this._onDrop);
            $695b3d6025d5e530$var$on(ownerDocument, "touchend", _this._onDrop);
            $695b3d6025d5e530$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($695b3d6025d5e530$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $695b3d6025d5e530$var$dragEl.draggable = true;
            }
            $695b3d6025d5e530$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess))) {
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $695b3d6025d5e530$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $695b3d6025d5e530$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $695b3d6025d5e530$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $695b3d6025d5e530$var$on(document, "touchmove", this._onTouchMove);
            else $695b3d6025d5e530$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$dragEl, "dragend", this);
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $695b3d6025d5e530$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        if ($695b3d6025d5e530$var$rootEl && $695b3d6025d5e530$var$dragEl) {
            $695b3d6025d5e530$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $695b3d6025d5e530$var$on(document, "dragover", $695b3d6025d5e530$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
            $695b3d6025d5e530$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($695b3d6025d5e530$var$touchEvt) {
            this._lastX = $695b3d6025d5e530$var$touchEvt.clientX;
            this._lastY = $695b3d6025d5e530$var$touchEvt.clientY;
            $695b3d6025d5e530$var$_hideGhostForTarget();
            var target = document.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$695b3d6025d5e530$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$695b3d6025d5e530$var$expando]._onDragOver({
                        clientX: $695b3d6025d5e530$var$touchEvt.clientX,
                        clientY: $695b3d6025d5e530$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $695b3d6025d5e530$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($695b3d6025d5e530$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$ghostEl, true), scaleX = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $695b3d6025d5e530$var$PositionGhostAbsolutely && $695b3d6025d5e530$var$ghostRelativeParent && $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent), dx = (touch.clientX - $695b3d6025d5e530$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $695b3d6025d5e530$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$695b3d6025d5e530$export$31b3ca70d8f57423.active && !$695b3d6025d5e530$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($695b3d6025d5e530$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($695b3d6025d5e530$var$lastDx || 0);
                    ghostMatrix.f += dy - ($695b3d6025d5e530$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "webkitTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "mozTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "msTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform", cssMatrix);
                $695b3d6025d5e530$var$lastDx = dx;
                $695b3d6025d5e530$var$lastDy = dy;
                $695b3d6025d5e530$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$695b3d6025d5e530$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $695b3d6025d5e530$var$rootEl, rect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl, true, $695b3d6025d5e530$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($695b3d6025d5e530$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $695b3d6025d5e530$var$ghostRelativeParent = container;
                while($695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, "position") === "static" && $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, "transform") === "none" && $695b3d6025d5e530$var$ghostRelativeParent !== document)$695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$ghostRelativeParent.parentNode;
                if ($695b3d6025d5e530$var$ghostRelativeParent !== document.body && $695b3d6025d5e530$var$ghostRelativeParent !== document.documentElement) {
                    if ($695b3d6025d5e530$var$ghostRelativeParent === document) $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                    rect.top += $695b3d6025d5e530$var$ghostRelativeParent.scrollTop;
                    rect.left += $695b3d6025d5e530$var$ghostRelativeParent.scrollLeft;
                } else $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent);
            }
            $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$dragEl.cloneNode(true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.ghostClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.fallbackClass, true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.dragClass, true);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transition", "");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform", "");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "box-sizing", "border-box");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "margin", 0);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "top", rect.top);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "left", rect.left);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "width", rect.width);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "height", rect.height);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "opacity", "0.8");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "position", $695b3d6025d5e530$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "zIndex", "100000");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "pointerEvents", "none");
            $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$var$ghostEl;
            container.appendChild($695b3d6025d5e530$var$ghostEl);
            // Set transform-origin
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform-origin", $695b3d6025d5e530$var$tapDistanceLeft / parseInt($695b3d6025d5e530$var$ghostEl.style.width) * 100 + "% " + $695b3d6025d5e530$var$tapDistanceTop / parseInt($695b3d6025d5e530$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $695b3d6025d5e530$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $695b3d6025d5e530$var$pluginEvent("setupClone", this);
        if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$clone($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$cloneEl.removeAttribute("id");
            $695b3d6025d5e530$var$cloneEl.draggable = false;
            $695b3d6025d5e530$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$cloneEl, this.options.chosenClass, false);
            $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $695b3d6025d5e530$var$_nextTick(function() {
            $695b3d6025d5e530$var$pluginEvent("clone", _this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            _this._hideClone();
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $695b3d6025d5e530$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $695b3d6025d5e530$var$off(document, "mouseup", _this._onDrop);
            $695b3d6025d5e530$var$off(document, "touchend", _this._onDrop);
            $695b3d6025d5e530$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $695b3d6025d5e530$var$dragEl);
            }
            $695b3d6025d5e530$var$on(document, "drop", _this);
            // #1276 fix:
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, "transform", "translateZ(0)");
        }
        $695b3d6025d5e530$var$awaitingDragStarted = true;
        _this._dragStartId = $695b3d6025d5e530$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $695b3d6025d5e530$var$on(document, "selectstart", _this);
        $695b3d6025d5e530$var$moved = true;
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $695b3d6025d5e530$export$31b3ca70d8f57423.active, isOwner = $695b3d6025d5e530$var$activeGroup === group, canSort = options.sort, fromSortable = $695b3d6025d5e530$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($695b3d6025d5e530$var$_silent) return;
        function dragOverEvent(name, extra) {
            $695b3d6025d5e530$var$pluginEvent(name, _this, $695b3d6025d5e530$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, $695b3d6025d5e530$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
                }
                if ($695b3d6025d5e530$var$putSortable !== _this && _this !== $695b3d6025d5e530$export$31b3ca70d8f57423.active) $695b3d6025d5e530$var$putSortable = _this;
                else if (_this === $695b3d6025d5e530$export$31b3ca70d8f57423.active && $695b3d6025d5e530$var$putSortable) $695b3d6025d5e530$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $695b3d6025d5e530$var$dragEl && !$695b3d6025d5e530$var$dragEl.animated || target === el && !target.animated) $695b3d6025d5e530$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $695b3d6025d5e530$var$newIndex,
                newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($695b3d6025d5e530$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $695b3d6025d5e530$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $695b3d6025d5e530$var$parentEl !== $695b3d6025d5e530$var$rootEl // Reverting item into the original list
        ) : $695b3d6025d5e530$var$putSortable === this || (this.lastPutMode = $695b3d6025d5e530$var$activeGroup.checkPull(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt)) && group.checkPut(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$nextEl);
                    else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $695b3d6025d5e530$var$lastChild(el, options.draggable);
            if (!elLastChild || $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($695b3d6025d5e530$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($695b3d6025d5e530$var$dragEl);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $695b3d6025d5e530$var$getChild(el, 0, options, true);
                if (firstChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($695b3d6025d5e530$var$dragEl, firstChild);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $695b3d6025d5e530$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $695b3d6025d5e530$var$dragEl.parentNode !== el, differentRowCol = !$695b3d6025d5e530$var$_dragElInRowColumn($695b3d6025d5e530$var$dragEl.animated && $695b3d6025d5e530$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $695b3d6025d5e530$var$isScrolledPast(target, "top", "top") || $695b3d6025d5e530$var$isScrolledPast($695b3d6025d5e530$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($695b3d6025d5e530$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $695b3d6025d5e530$var$pastFirstInvertThresh = false;
                    $695b3d6025d5e530$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $695b3d6025d5e530$var$isCircumstantialInvert, $695b3d6025d5e530$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $695b3d6025d5e530$var$parentEl.children[dragIndex];
                    }while (sibling && ($695b3d6025d5e530$var$css(sibling, "display") === "none" || sibling === $695b3d6025d5e530$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $695b3d6025d5e530$var$lastTarget = target;
                $695b3d6025d5e530$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $695b3d6025d5e530$var$_silent = true;
                    setTimeout($695b3d6025d5e530$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($695b3d6025d5e530$var$dragEl);
                    else target.parentNode.insertBefore($695b3d6025d5e530$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $695b3d6025d5e530$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$695b3d6025d5e530$var$isCircumstantialInvert) $695b3d6025d5e530$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $695b3d6025d5e530$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($695b3d6025d5e530$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $695b3d6025d5e530$var$off(document, "mousemove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "touchmove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "pointermove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "dragover", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, "mousemove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, "touchmove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, "mouseup", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "touchend", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "pointerup", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "touchcancel", this._onDrop);
        $695b3d6025d5e530$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        $695b3d6025d5e530$var$pluginEvent("drop", this, {
            evt: evt
        });
        $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$dragEl.parentNode;
        // Get again after plugin event
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        $695b3d6025d5e530$var$isCircumstantialInvert = false;
        $695b3d6025d5e530$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $695b3d6025d5e530$var$_cancelNextTick(this.cloneId);
        $695b3d6025d5e530$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(document, "drop", this);
            $695b3d6025d5e530$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, "user-select", "");
        $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, "transform", "");
        if (evt) {
            if ($695b3d6025d5e530$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$ghostEl.parentNode && $695b3d6025d5e530$var$ghostEl.parentNode.removeChild($695b3d6025d5e530$var$ghostEl);
            if ($695b3d6025d5e530$var$rootEl === $695b3d6025d5e530$var$parentEl || $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $695b3d6025d5e530$var$cloneEl && $695b3d6025d5e530$var$cloneEl.parentNode && $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            if ($695b3d6025d5e530$var$dragEl) {
                if (this.nativeDraggable) $695b3d6025d5e530$var$off($695b3d6025d5e530$var$dragEl, "dragend", this);
                $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
                $695b3d6025d5e530$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($695b3d6025d5e530$var$moved && !$695b3d6025d5e530$var$awaitingDragStarted) $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $695b3d6025d5e530$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($695b3d6025d5e530$var$rootEl !== $695b3d6025d5e530$var$parentEl) {
                    if ($695b3d6025d5e530$var$newIndex >= 0) {
                        // Add event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: "add",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: "sort",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.save();
                } else {
                    if ($695b3d6025d5e530$var$newIndex !== $695b3d6025d5e530$var$oldIndex) {
                        if ($695b3d6025d5e530$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($695b3d6025d5e530$var$newIndex == null || $695b3d6025d5e530$var$newIndex === -1) {
                        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$oldIndex;
                        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldDraggableIndex;
                    }
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $695b3d6025d5e530$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $695b3d6025d5e530$var$pluginEvent("nulling", this);
        $695b3d6025d5e530$var$rootEl = $695b3d6025d5e530$var$dragEl = $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$lastDownEl = $695b3d6025d5e530$var$cloneHidden = $695b3d6025d5e530$var$tapEvt = $695b3d6025d5e530$var$touchEvt = $695b3d6025d5e530$var$moved = $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$lastTarget = $695b3d6025d5e530$var$lastDirection = $695b3d6025d5e530$var$putSortable = $695b3d6025d5e530$var$activeGroup = $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$export$31b3ca70d8f57423.active = null;
        $695b3d6025d5e530$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $695b3d6025d5e530$var$savedInputChecked.length = $695b3d6025d5e530$var$lastDx = $695b3d6025d5e530$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($695b3d6025d5e530$var$dragEl) {
                    this._onDragOver(evt);
                    $695b3d6025d5e530$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($695b3d6025d5e530$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $695b3d6025d5e530$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($695b3d6025d5e530$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $695b3d6025d5e530$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $695b3d6025d5e530$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $695b3d6025d5e530$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $695b3d6025d5e530$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$695b3d6025d5e530$var$expando] = null;
        $695b3d6025d5e530$var$off(el, "mousedown", this._onTapStart);
        $695b3d6025d5e530$var$off(el, "touchstart", this._onTapStart);
        $695b3d6025d5e530$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(el, "dragover", this);
            $695b3d6025d5e530$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $695b3d6025d5e530$var$sortables.splice($695b3d6025d5e530$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent("hideClone", this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $695b3d6025d5e530$var$cloneEl.parentNode) $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent("showClone", this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($695b3d6025d5e530$var$dragEl.parentNode == $695b3d6025d5e530$var$rootEl && !this.options.group.revertClone) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            else if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$nextEl);
            else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$cloneEl);
            if (this.options.group.revertClone) this.animate($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, "display", "");
            $695b3d6025d5e530$var$cloneHidden = false;
        }
    }
};
function $695b3d6025d5e530$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $695b3d6025d5e530$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$695b3d6025d5e530$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $695b3d6025d5e530$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $695b3d6025d5e530$var$_disableDraggable(el) {
    el.draggable = false;
}
function $695b3d6025d5e530$var$_unsilent() {
    $695b3d6025d5e530$var$_silent = false;
}
function $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $695b3d6025d5e530$var$getChildContainingRectFromElement(sortable.el, sortable.options, $695b3d6025d5e530$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $695b3d6025d5e530$var$getChildContainingRectFromElement(sortable.el, sortable.options, $695b3d6025d5e530$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $695b3d6025d5e530$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh && ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $695b3d6025d5e530$var$pastFirstInvertThresh = true;
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $695b3d6025d5e530$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $695b3d6025d5e530$var$targetMoveDistance) return -$695b3d6025d5e530$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $695b3d6025d5e530$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $695b3d6025d5e530$var$_getInsertDirection(target) {
    if ($695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl) < $695b3d6025d5e530$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $695b3d6025d5e530$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $695b3d6025d5e530$var$_saveInputCheckedState(root) {
    $695b3d6025d5e530$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $695b3d6025d5e530$var$savedInputChecked.push(el);
    }
}
function $695b3d6025d5e530$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $695b3d6025d5e530$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($695b3d6025d5e530$var$documentExists) $695b3d6025d5e530$var$on(document, "touchmove", function(evt) {
    if (($695b3d6025d5e530$export$31b3ca70d8f57423.active || $695b3d6025d5e530$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$695b3d6025d5e530$export$31b3ca70d8f57423.utils = {
    on: $695b3d6025d5e530$var$on,
    off: $695b3d6025d5e530$var$off,
    css: $695b3d6025d5e530$var$css,
    find: $695b3d6025d5e530$var$find,
    is: function is(el, selector) {
        return !!$695b3d6025d5e530$var$closest(el, selector, el, false);
    },
    extend: $695b3d6025d5e530$var$extend,
    throttle: $695b3d6025d5e530$var$throttle,
    closest: $695b3d6025d5e530$var$closest,
    toggleClass: $695b3d6025d5e530$var$toggleClass,
    clone: $695b3d6025d5e530$var$clone,
    index: $695b3d6025d5e530$var$index,
    nextTick: $695b3d6025d5e530$var$_nextTick,
    cancelNextTick: $695b3d6025d5e530$var$_cancelNextTick,
    detectDirection: $695b3d6025d5e530$var$_detectDirection,
    getChild: $695b3d6025d5e530$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.get = function(element) {
    return element[$695b3d6025d5e530$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $695b3d6025d5e530$export$31b3ca70d8f57423.utils = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, $695b3d6025d5e530$export$31b3ca70d8f57423.utils), plugin.utils);
        $695b3d6025d5e530$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.create = function(el, options) {
    return new $695b3d6025d5e530$export$31b3ca70d8f57423(el, options);
};
// Export
$695b3d6025d5e530$export$31b3ca70d8f57423.version = $695b3d6025d5e530$var$version;
var $695b3d6025d5e530$var$autoScrolls = [], $695b3d6025d5e530$var$scrollEl, $695b3d6025d5e530$var$scrollRootEl, $695b3d6025d5e530$var$scrolling = false, $695b3d6025d5e530$var$lastAutoScrollX, $695b3d6025d5e530$var$lastAutoScrollY, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$pointerElemChangedInterval;
function $695b3d6025d5e530$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $695b3d6025d5e530$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $695b3d6025d5e530$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $695b3d6025d5e530$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $695b3d6025d5e530$var$clearPointerElemChangedInterval();
            $695b3d6025d5e530$var$clearAutoScrolls();
            $695b3d6025d5e530$var$cancelThrottle();
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$touchEvt$1 = $695b3d6025d5e530$var$scrollRootEl = $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$scrolling = $695b3d6025d5e530$var$pointerElemChangedInterval = $695b3d6025d5e530$var$lastAutoScrollX = $695b3d6025d5e530$var$lastAutoScrollY = null;
            $695b3d6025d5e530$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $695b3d6025d5e530$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess || $695b3d6025d5e530$var$Safari) {
                $695b3d6025d5e530$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true);
                if ($695b3d6025d5e530$var$scrolling && (!$695b3d6025d5e530$var$pointerElemChangedInterval || x !== $695b3d6025d5e530$var$lastAutoScrollX || y !== $695b3d6025d5e530$var$lastAutoScrollY)) {
                    $695b3d6025d5e530$var$pointerElemChangedInterval && $695b3d6025d5e530$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $695b3d6025d5e530$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $695b3d6025d5e530$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $695b3d6025d5e530$var$clearAutoScrolls();
                        }
                        $695b3d6025d5e530$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $695b3d6025d5e530$var$lastAutoScrollX = x;
                    $695b3d6025d5e530$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true) === $695b3d6025d5e530$var$getWindowScrollingElement()) {
                    $695b3d6025d5e530$var$clearAutoScrolls();
                    return;
                }
                $695b3d6025d5e530$var$autoScroll(evt, this.options, $695b3d6025d5e530$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $695b3d6025d5e530$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $695b3d6025d5e530$var$clearAutoScrolls() {
    $695b3d6025d5e530$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $695b3d6025d5e530$var$autoScrolls = [];
}
function $695b3d6025d5e530$var$clearPointerElemChangedInterval() {
    clearInterval($695b3d6025d5e530$var$pointerElemChangedInterval);
}
var $695b3d6025d5e530$var$autoScroll = $695b3d6025d5e530$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($695b3d6025d5e530$var$scrollRootEl !== rootEl) {
        $695b3d6025d5e530$var$scrollRootEl = rootEl;
        $695b3d6025d5e530$var$clearAutoScrolls();
        $695b3d6025d5e530$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($695b3d6025d5e530$var$scrollEl === true) $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $695b3d6025d5e530$var$scrollEl;
    do {
        var el = currentParent, rect = $695b3d6025d5e530$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $695b3d6025d5e530$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$695b3d6025d5e530$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$695b3d6025d5e530$var$autoScrolls[i]) $695b3d6025d5e530$var$autoScrolls[i] = {};
        }
        if ($695b3d6025d5e530$var$autoScrolls[layersOut].vx != vx || $695b3d6025d5e530$var$autoScrolls[layersOut].vy != vy || $695b3d6025d5e530$var$autoScrolls[layersOut].el !== el) {
            $695b3d6025d5e530$var$autoScrolls[layersOut].el = el;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vx = vx;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vy = vy;
            clearInterval($695b3d6025d5e530$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $695b3d6025d5e530$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $695b3d6025d5e530$export$31b3ca70d8f57423.active._onTouchMove($695b3d6025d5e530$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $695b3d6025d5e530$var$autoScrolls[this.layer].vy ? $695b3d6025d5e530$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $695b3d6025d5e530$var$autoScrolls[this.layer].vx ? $695b3d6025d5e530$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($695b3d6025d5e530$export$31b3ca70d8f57423.dragged.parentNode[$695b3d6025d5e530$var$expando], scrollOffsetX, scrollOffsetY, evt, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $695b3d6025d5e530$var$scrollBy($695b3d6025d5e530$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $695b3d6025d5e530$var$getParentAutoScrollElement(currentParent, false)));
    $695b3d6025d5e530$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $695b3d6025d5e530$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $695b3d6025d5e530$var$Revert() {}
$695b3d6025d5e530$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $695b3d6025d5e530$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Revert, {
    pluginName: "revertOnSpill"
});
function $695b3d6025d5e530$var$Remove() {}
$695b3d6025d5e530$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Remove, {
    pluginName: "removeOnSpill"
});
var $695b3d6025d5e530$var$lastSwapEl;
function $695b3d6025d5e530$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $695b3d6025d5e530$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $695b3d6025d5e530$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $695b3d6025d5e530$var$toggleClass(target, options.swapClass, true);
                    $695b3d6025d5e530$var$lastSwapEl = target;
                } else $695b3d6025d5e530$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $695b3d6025d5e530$var$lastSwapEl) $695b3d6025d5e530$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $695b3d6025d5e530$var$lastSwapEl && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$lastSwapEl, options.swapClass, false);
            if ($695b3d6025d5e530$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $695b3d6025d5e530$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $695b3d6025d5e530$var$swapNodes(dragEl, $695b3d6025d5e530$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$lastSwapEl = null;
        }
    };
    return $695b3d6025d5e530$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $695b3d6025d5e530$var$lastSwapEl
            };
        }
    });
}
function $695b3d6025d5e530$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $695b3d6025d5e530$var$index(n1);
    i2 = $695b3d6025d5e530$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $695b3d6025d5e530$var$multiDragElements = [], $695b3d6025d5e530$var$multiDragClones = [], $695b3d6025d5e530$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$695b3d6025d5e530$var$multiDragSortable, $695b3d6025d5e530$var$initialFolding = false, // Initial multi-drag fold when drag started
$695b3d6025d5e530$var$folding = false, // Folding any other time
$695b3d6025d5e530$var$dragStarted = false, $695b3d6025d5e530$var$dragEl$1, $695b3d6025d5e530$var$clonesFromRect, $695b3d6025d5e530$var$clonesHidden;
function $695b3d6025d5e530$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $695b3d6025d5e530$var$on(document, "mouseup", this._deselectMultiDrag);
                $695b3d6025d5e530$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $695b3d6025d5e530$var$on(document, "keydown", this._checkKeyDown);
        $695b3d6025d5e530$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $695b3d6025d5e530$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $695b3d6025d5e530$var$multiDragElements.length; i++){
                $695b3d6025d5e530$var$multiDragClones.push($695b3d6025d5e530$var$clone($695b3d6025d5e530$var$multiDragElements[i]));
                $695b3d6025d5e530$var$multiDragClones[i].sortableIndex = $695b3d6025d5e530$var$multiDragElements[i].sortableIndex;
                $695b3d6025d5e530$var$multiDragClones[i].draggable = false;
                $695b3d6025d5e530$var$multiDragClones[i].style["will-change"] = "";
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements[i] === $695b3d6025d5e530$var$dragEl$1 && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) {
                    $695b3d6025d5e530$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$insertMultiDragClones(false, rootEl);
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, "display", "");
            });
            cloneNowShown();
            $695b3d6025d5e530$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $695b3d6025d5e530$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $695b3d6025d5e530$var$multiDragSortable) $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $695b3d6025d5e530$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $695b3d6025d5e530$var$multiDragElements = $695b3d6025d5e530$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $695b3d6025d5e530$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRect);
                    });
                    $695b3d6025d5e530$var$folding = true;
                    $695b3d6025d5e530$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$initialFolding = false;
                if (_this2.options.animation) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $695b3d6025d5e530$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($695b3d6025d5e530$var$folding && ~$695b3d6025d5e530$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect
                    });
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $695b3d6025d5e530$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $695b3d6025d5e530$var$multiDragElements.length > 1 && ($695b3d6025d5e530$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $695b3d6025d5e530$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$695b3d6025d5e530$var$folding) $695b3d6025d5e530$var$removeMultiDragElements();
                    if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $695b3d6025d5e530$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$695b3d6025d5e530$var$clonesHidden && clonesHiddenBefore) $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $695b3d6025d5e530$var$clonesFromRect
                            });
                            clone.fromRect = $695b3d6025d5e530$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $695b3d6025d5e530$var$clonesFromRect = $695b3d6025d5e530$var$_extends({}, dragRect);
                var dragMatrix = $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$dragEl$1, true);
                $695b3d6025d5e530$var$clonesFromRect.top -= dragMatrix.f;
                $695b3d6025d5e530$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($695b3d6025d5e530$var$folding) {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$695b3d6025d5e530$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl$1, options.selectedClass, !~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1));
                if (!~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1)) {
                    $695b3d6025d5e530$var$multiDragElements.push($695b3d6025d5e530$var$dragEl$1);
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $695b3d6025d5e530$var$lastMultiDragSelect && sortable.el.contains($695b3d6025d5e530$var$lastMultiDragSelect)) {
                        var lastIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$lastMultiDragSelect), currentIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$695b3d6025d5e530$var$multiDragElements.indexOf(children[i])) continue;
                                $695b3d6025d5e530$var$toggleClass(children[i], options.selectedClass, true);
                                $695b3d6025d5e530$var$multiDragElements.push(children[i]);
                                $695b3d6025d5e530$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $695b3d6025d5e530$var$lastMultiDragSelect = $695b3d6025d5e530$var$dragEl$1;
                    $695b3d6025d5e530$var$multiDragSortable = toSortable;
                } else {
                    $695b3d6025d5e530$var$multiDragElements.splice($695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1), 1);
                    $695b3d6025d5e530$var$lastMultiDragSelect = null;
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($695b3d6025d5e530$var$dragStarted && this.isMultiDrag) {
                $695b3d6025d5e530$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$695b3d6025d5e530$var$expando].options.sort || parentEl !== rootEl) && $695b3d6025d5e530$var$multiDragElements.length > 1) {
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1), multiDragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$695b3d6025d5e530$var$initialFolding && options.animation) $695b3d6025d5e530$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$695b3d6025d5e530$var$initialFolding) {
                        if (options.animation) {
                            $695b3d6025d5e530$var$dragEl$1.fromRect = dragRect;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $695b3d6025d5e530$var$dragEl$1) {
                                    var rect = $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $695b3d6025d5e530$var$removeMultiDragElements();
                        $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1)) {
                            var update = false;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $695b3d6025d5e530$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $695b3d6025d5e530$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $695b3d6025d5e530$var$dragStarted = false;
            $695b3d6025d5e530$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $695b3d6025d5e530$var$off(document, "pointerup", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "mouseup", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "touchend", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "keydown", this._checkKeyDown);
            $695b3d6025d5e530$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $695b3d6025d5e530$var$dragStarted !== "undefined" && $695b3d6025d5e530$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($695b3d6025d5e530$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $695b3d6025d5e530$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($695b3d6025d5e530$var$multiDragElements.length){
                var el = $695b3d6025d5e530$var$multiDragElements[0];
                $695b3d6025d5e530$var$toggleClass(el, this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.shift();
                $695b3d6025d5e530$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $695b3d6025d5e530$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$695b3d6025d5e530$var$multiDragElements.indexOf(el)) return;
                if ($695b3d6025d5e530$var$multiDragSortable && $695b3d6025d5e530$var$multiDragSortable !== sortable) {
                    $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $695b3d6025d5e530$var$multiDragSortable = sortable;
                }
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, true);
                $695b3d6025d5e530$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando], index = $695b3d6025d5e530$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($695b3d6025d5e530$var$folding && multiDragElement !== $695b3d6025d5e530$var$dragEl$1) newIndex = -1;
                else if ($695b3d6025d5e530$var$folding) newIndex = $695b3d6025d5e530$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $695b3d6025d5e530$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $695b3d6025d5e530$var$_toConsumableArray($695b3d6025d5e530$var$multiDragElements),
                clones: [].concat($695b3d6025d5e530$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $695b3d6025d5e530$var$insertMultiDragElements(clonesInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $695b3d6025d5e530$var$insertMultiDragClones(elementsInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $695b3d6025d5e530$var$removeMultiDragElements() {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$695b3d6025d5e530$export$31b3ca70d8f57423.mount(new $695b3d6025d5e530$var$AutoScrollPlugin());
$695b3d6025d5e530$export$31b3ca70d8f57423.mount($695b3d6025d5e530$var$Remove, $695b3d6025d5e530$var$Revert);
var $695b3d6025d5e530$export$2e2bcd8739ae039 = $695b3d6025d5e530$export$31b3ca70d8f57423;

});


parcelRegister("1Svw2", function(module, exports) {

$parcel$export(module.exports, "Htmlarea", () => $5c40abe097501734$export$ce422d9b612100db);

var $4hoex = parcelRequire("4hoex");

var $kwZWC = parcelRequire("kwZWC");
class $5c40abe097501734$export$ce422d9b612100db extends (0, $4hoex.IMuWidget) {
    async setDisabled(disabled) {
        this.muVisible(disabled, [
            "!content",
            "roContent"
        ]);
        await this.editorPromise;
    }
    beforeIndex() {
        this.muRegisterEvent("change");
        this.container.innerHTML += `
			<div mu-id="content" class="html-area--content"></div>
			<div mu-id="roContent"  class="html-area--content html-area--content--readonly"></div>`;
        const heValue = this.container.querySelector("input"); // 'input'
        heValue?.setAttribute("mu-id", "value");
        // heValue.style.display = "none";
        this.container.classList.add("html-area");
    }
    afterIndex() {
        if (this.delayedInit) this.muParent?.muOnAfterIndex.push(()=>this.initCKEditor());
        else this.initCKEditor();
        this.setDisabled(false);
    }
    initCKEditor() {
        if (this.ui.value) this.ui.content.innerHTML = this.ui.value.value;
        if (this.ui.placeholder) this.ui.placeholder.innerHTML = "";
        if (!this.disabled) {
            const updateContent = (html)=>{
                if (this.ui.value) this.ui.value.value = html;
            };
            // @ts-ignore
            const _conf = conf;
            // @ts-ignore
            this.editorPromise = InlineEditor.create(this.ui.content, {
                licenseKey: "",
                // plugins: [ 'SimpleUploadAdapter' ],
                simpleUpload: {
                    // The URL that the images are uploaded to.
                    uploadUrl: this.uploadUrl ?? _conf.urlUploadPath
                },
                toolbar: {
                    items: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "strikethrough",
                        "underline",
                        "link",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "outdent",
                        "indent",
                        "|",
                        "imageUpload",
                        "blockQuote",
                        "insertTable",
                        "mediaEmbed",
                        "code",
                        "codeBlock",
                        "horizontalLine",
                        "|",
                        "fontColor",
                        "highlight",
                        "fontSize",
                        "|",
                        "undo",
                        "redo"
                    ]
                },
                resize_minHeight: 200
            }).then((editor)=>{
                editor.model.document.on("change:data", (evt, data)=>{
                    const content = editor.getData();
                    updateContent(content);
                    this.muDispatchEvent("change", content);
                });
                editor.ui.focusTracker.on("change:isFocused", (evt, name, isFocused)=>updateContent(editor.getData()));
                this.editor = editor;
            }).catch((error)=>{
                console.error("Oops, something went wrong!");
                console.error("Please, report the following error on https://github.com/ckeditor/ckeditor5/issues with the build id and the error stack trace:");
                console.warn("Build id: w19cfme1zfn4-77un9p80tfp5");
                console.error(error);
            });
        }
        this.editorPromise.then(()=>this.editorIsInitialized = true);
    }
    async muBindData(srcData) {
        // const doBindData = () => this.editor.setData(srcData);
        // if (this.editor) doBindData();
        // else this.editorPromise.then(() => doBindData()) ;
        await this.editorPromise;
        await (0, $kwZWC.sleepPromise)(10);
        this.editor.setData(srcData || "");
        this.ui.roContent.innerHTML = srcData;
    }
    muFetchData() {
        return this.editor?.getData();
    }
    focus() {
        this.ui.content.focus();
        if (this.editorPromise != null) this.editorPromise.then(()=>this.editor.focus());
    }
    async waitForInit() {
        return this.editorPromise;
    }
    isInitialized() {
        return this.editorIsInitialized;
    }
    constructor(...args){
        super(...args);
        this.disabled = false;
        this.delayedInit = false;
        this.uploadUrl = null;
        this.editorIsInitialized = false;
    }
}

});

parcelRegister("faZ90", function(module, exports) {

$parcel$export(module.exports, "UiSelector", () => $4833da5fd1abed50$export$3396cb0567a793b2);

var $4hoex = parcelRequire("4hoex");
class $4833da5fd1abed50$export$3396cb0567a793b2 extends (0, $4hoex.IMuWidget) {
    getActive() {
        return this.value;
    }
    setActive(value) {
        this.value = value;
        for(var _i = 0, _Array$from = Array.from(this.container.children); _i < _Array$from.length; _i++){
            const el = _Array$from[_i];
            if (el.value == value) el.classList.add(this.cssClassActive);
            else el.classList.remove(this.cssClassActive);
        }
    }
    bindValues(items) {
        this.container.innerHTML = "";
        for(var _i2 = 0, _items = items; _i2 < _items.length; _i2++){
            let item = _items[_i2];
            this.addItem(item);
            this.items[item[this.valueField]] = item;
        }
    }
    addItem(item, before = null) {
        const el = document.createElement(this.containerTag);
        const v = item[this.valueField];
        if (this.containerCssClass) el.className = this.containerCssClass;
        el.value = v;
        item.element = el;
        el.addEventListener("click", (ev)=>{
            this.setActive(v);
            const sev = {
                originalEvent: ev,
                item: item,
                value: v,
                sender: this
            };
            if (this.onchange) this.onchange(sev);
            this.muDispatchEvent("change", sev);
        });
        // el.innerText = item.text;
        const itemBinder = this.bindItemValues || ((item, container)=>container.innerText = item[this.textField]);
        itemBinder(item, el);
        if (before === null) this.container.appendChild(el);
        else {
            let bel;
            if (before === "first") bel = this.container.firstChild;
            else bel = this.items[before];
            this.container.insertBefore(el, bel);
        }
    }
    afterIndex() {
        this.muRegisterEvent("change");
    }
    constructor(...args){
        super(...args);
        this.items = {};
        this.cssClassActive = "active";
        this.containerTag = "span";
        this.containerCssClass = "";
        this.textField = "text";
        this.valueField = "value";
    }
}
 /*
export type SelectorBindOpts = {
	containerTag? : string,
	containerCssClass? : string,
	bindValues? : (item : SelectorItem, container : HTMLElement) => void,
	textField?: string,
	valueField?: string
} */ 
});

parcelRegister("ao0AT", function(module, exports) {

$parcel$export(module.exports, "TicketTree", () => $e68ef957111f4c23$export$51cf5d68b8a122d3);

var $4hoex = parcelRequire("4hoex");
class $e68ef957111f4c23$export$51cf5d68b8a122d3 extends (0, $4hoex.IMuWidget) {
    afterIndex() {
        this.tree = $(this.ui.tree).fancytree({
            source: this.treeData,
            // this.items,
            extensions: [
                "table"
            ],
            renderColumns: (event, data)=>{
                const rw = this.muActivateWidget(data.node.tr);
                rw.muBindData(data.node.data);
                if (this.ticketId == data.node.key) rw.ui.summary.classList.add("strong");
                rw.muVisible(!data.node.data.disabled, "summary");
                rw.muVisible(data.node.data.disabled, "summaryDisabled");
            },
            activate: (event, data)=>{}
        }).fancytree("getTree");
    }
    expandTo(el) {
        this.expandNode(this.tree.rootNode, el.attributes["data-level"].value);
    }
    expandNode(node, level) {
        node.setExpanded(level > 0);
        if (level > 0 && node.children) for(var i = 0; i < node.children.length; i++)this.expandNode(node.children[i], level - 1);
    }
}

});

parcelRegister("gpQZH", function(module, exports) {

$parcel$export(module.exports, "InvoiceApproval", () => $5f307996e167143f$export$4a10fe16e5e6ef1d);
$parcel$export(module.exports, "InvoiceApprovalItem", () => $5f307996e167143f$export$33ac4d6b94182e93);
$parcel$export(module.exports, "ApprovingSchemaListItem", () => $5f307996e167143f$export$d127fab1257e4f14);
$parcel$export(module.exports, "ApprovingSchemaGroupAccount", () => $5f307996e167143f$export$dfed28f04264fbb1);
$parcel$export(module.exports, "ForkItemDialog", () => $5f307996e167143f$export$f8f85d44d1939794);
$parcel$export(module.exports, "UiInvoiceSplitItem", () => $5f307996e167143f$export$d02b89ba6b20d688);
$parcel$export(module.exports, "UiInvoiceApprovingItemSelector", () => $5f307996e167143f$export$17231c6ca286ed18);

var $cJjA3 = parcelRequire("cJjA3");

var $3cBch = parcelRequire("3cBch");

var $fnX8e = parcelRequire("fnX8e");

var $6Taw3 = parcelRequire("6Taw3");

var $bjpdy = parcelRequire("bjpdy");

var $kwZWC = parcelRequire("kwZWC");
function $5f307996e167143f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5f307996e167143f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5f307996e167143f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5f307996e167143f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5f307996e167143f$var$_arrayLikeToArray(o, minLen);
}
function $5f307996e167143f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $5f307996e167143f$export$4a10fe16e5e6ef1d extends (0, $6Taw3.BaseMuWidget) {
    static{
        this.stateIcons = {
            accepted: "checked-on",
            noproduct: "question-blue",
            noschema: "question",
            wait: "checked-off",
            "my-wait": "checked-off",
            rejected: "no"
        };
    }
    async saveIfNew() {
        for(var _iterator = $5f307996e167143f$var$_createForOfIteratorHelperLoose(this.getItemWidgets()), _step; !(_step = _iterator()).done;){
            const widget = _step.value;
            if (!widget.muFetchData().id) {
                await this.doSave(false);
                return true;
            }
        }
        return false;
    }
    beforeIndex() {
    // this.container.innerHTML = '<div mu-widget="UiInvoiceSplitItem"></div>' + this.container.innerHTML;
    }
    afterIndex() {
        super.afterIndex();
        this.cl = new (0, $cJjA3.InvoiceApprovalCL)(); // this.clUrl);
        this.cl.context.invoiceId = this.invoiceId;
        this.cl.context.ticketId = this.ticketId;
        /* (this.muNamedWidget.cApprovers as AccountSelector).searchCallback = (term, resolve) => {
    	this.cl.findAccounts(term).then(data => {
    		resolve(data);
    	});
    };*/ this.reloadInvoice();
        this.openApproving(false);
        this.container.classList.remove("loading");
        this.muVisible(this.mode == "approving" || this.mode == "complete", "pInvoiceHeader");
        // this.bindAttachList();
        // this.bClosePreview_click();
        this.muNamedWidget.attaches.ticketId = this.ticketId;
        this.muNamedWidget.attaches.loadAttaches();
        this.openInvItemSelectSchema(false);
        this.callMethodInFirstAncestors("setFormChangedCallback", ()=>this.isChanged());
    }
    setIsSaved() {
        this.lastData = this.getStateHash();
    }
    isChanged() {
        return this.lastData !== this.getStateHash();
    }
    getStateHash() {
        return JSON.stringify(this.getItemWidgets().map((iiw)=>iiw.muFetchData()));
    }
    getAccountName(id) {
        return this.accounts[id].name;
    }
    async loadInvoice() {
        const checkedIds = this.getCheckedItemIds();
        this.container.classList.toggle("loading-data", true);
        if (this.invoiceId) {
            const data = await this.cl.withMessage("Na\u010D\xedt\xe1m fakturu").getInvoice(this.invoiceId);
            this.bindInvoiceData(data);
            this.container.classList.toggle("loading-data", false);
            if (this.lastTicketStateId !== null && this.lastTicketStateId !== data.ticketStateId) this.callMethodInFirstAncestors("onApprovingStateChange");
            this.lastTicketStateId = data.ticketStateId;
            this.updateForm();
            this.muBindData({
                rejectInfo: this.getRejectInfo()
            });
        }
        this.setIsSaved();
    }
    bindInvoiceData(data) {
        this.bindInvoice(data);
        this.ticketStateCode = data.ticketStateCode;
        //todo: Odprasit
        const accountIdsToNames = (ids)=>ids.map((id)=>data.accounts[id].name).join(", ");
        const infoData = {
            '[data-rolecode="approver"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverActiveIds),
            // '[data-rolecode="approver.inactive"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverInactiveIds),
            '[data-rolecode="approver.next"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverNextIds),
            '[data-rolecode="approver.prev"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverPrevIds),
            '[data-rolecode="approver.reject"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverRejectIds),
            ".detail-state strong": data.ticketStateName
        };
        for(var q in infoData){
            const el = document.querySelector(q);
            if (el) el.innerText = infoData[q];
        }
        // const el = document.querySelector(".detail-state strong") as HTMLElement;
        // if (el) el.innerText = data.ticketStateName;
        const mApproving = this.mode !== "schema";
        const mSchema = this.mode !== "approving";
    // Schvalování celé faktury
    /* this.muVisible(
    	data.invoice.approving.state === "wait" && data.invoice.approving.approverIds?.includes(this.myAccountId) && mApproving,
    	[ "bInvApprove", "bInvReject", "pInvComment" ]
    );
    this.muVisible(
    	data.invoice.approving.state !== "noschema",
    	"bInvApprovingDetail"
    );
    this.muVisible(
    	data.invoice.approving.state === "noschema" && mSchema,
    	"bInvSelectSchema"
    );
    */ }
    bindInvoice(data) {
        this.accounts = data.accounts;
        this.invoice = data.invoice;
        const ids = data.checkedIds;
        this.muBindData({
            ...data.invoice,
            ticketStateName: data.ticketStateName,
            returnInfo: data.returnInfo
        });
        if (ids?.length) this.selectAll(new Event(""), ids);
        this.approvingSchemas = data.approvingSchemas;
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        if ("items" in srcData) this.bindItems(srcData.items);
    }
    updateForm() {
        const formOptions = this.callMethodInFirstAncestors("getFormOptions");
        // vypnuté schvalování
        const noApproving = !!formOptions.noApproving || ![
            "new",
            "inProgress"
        ].includes(this.ticketStateCode);
        // zákaz všech úprav
        const readOnly = typeof formOptions.readOnly === "string" ? formOptions.readOnly !== this.ticketStateCode : formOptions.readOnly;
        const items = this.getCheckedItems();
        this.muVisible(false, "bApproving");
        const firstItem = items.length > 0 ? items[0] : null;
        const firstItemState = firstItem?.approving?.state;
        this.getItemWidgets().forEach((iiw)=>iiw.visibleCheckedIfState(firstItemState));
        // položky - schválit/zamítnout
        /* this.muVisible(
    	firstItemState === "wait"
    		&& firstItem.approving?.approverIds?.includes(this.myAccountId),
    	[
    		// 'bInvItemApprove',
    		// 'pInvComment',
    	]
    ); */ this.muVisible(false, "bReload");
        if (readOnly) this.muVisible(false, [
            "bInvItemRejectDialog",
            "bInvItemCancelDialog",
            "bInvItemReject",
            "bInvItemCancel",
            "pInvComment",
            "bInvItemApprove",
            "bInvStartApproving",
            "bSaveAndApprove",
            "bSave",
            "bReturn"
        ]);
        else {
            const anyMy = this.selectAll(null, "my-wait", false).length > 0;
            this.muVisible(anyMy && !noApproving, [
                "bInvItemRejectDialog",
                "bInvItemCancelDialog"
            ]);
            this.muVisible(false, [
                "bInvItemReject",
                "bInvItemCancel",
                "pInvComment",
                "bInvItemApprove"
            ]);
            this.muVisible(firstItemState === "noschema" && !this.getItemWidgets(true).some((iiw)=>!iiw.getOrgProjectId() || !iiw.getOrgProductId() && this.productRequired), "bInvStartApproving" // "bInvItemSelectSchema"
            );
            const isApproving = this.getItemWidgets(null).some((iiw)=>iiw.isEditable());
            this.muVisible(isApproving && !noApproving, "bSaveAndApprove");
            this.muVisible(false, // this.ticketStateCode === "rejected",
            "bReturn");
            const anyNoProduct = this.getItemWidgets(null).some((iiw)=>!iiw.getOrgProductId());
            /* this.muVisible(
      	anyNoProduct,
      	"bInvRequireProduct"
      ); */ const anyNoOldProduct = true; // dostupné furt pro možnost změny this.getItemWidgets(null).some(iiw => !iiw.oldOrgProductId);
            this.muVisible(isApproving || anyNoOldProduct, "bSave");
        }
    }
    getItemWidgets(checked = null) {
        return this.muGetChildWidgets("items").filter((iw)=>iw instanceof $5f307996e167143f$export$33ac4d6b94182e93 && (typeof checked !== "boolean" || iw.isChecked() === checked));
    }
    getCheckedItems() {
        return this.getItemWidgets().filter((ii)=>ii.isChecked()).map((ii)=>ii.invoiceItem);
    }
    getCheckedItemWidgets() {
        return this.getItemWidgets().filter((ii)=>ii.isChecked());
    }
    getCheckedItemIds() {
        return this.getCheckedItems().map((ii)=>ii.id);
    }
    getApprovingItemIds() {
        return this.getApprovingItem().map((ii)=>ii.invoiceItem.id);
    }
    getApprovingItem() {
        return this.muGetChildWidgets("approvingItems");
    }
    openInvItemSelectSchema(visible) {
        this.muVisible(visible, [
            "pInvItemApprovingSchemaList",
            "!pButtons"
        ]);
    }
    bInvItemSelectSchema_click() {
        this.openInvItemSelectSchema(true);
        this.loadApprovingSchemas();
    }
    async bInvStartApproving_click() {
        const items = this.getCheckedItemWidgets();
        const projectDivisionIds = items.map((iiw)=>{
            const opid = iiw.getOrgProjectId();
            return {
                orgProjectId: opid === "withoutProject" ? null : opid,
                orgDivisionId: iiw.getOrgDivisionId()
            };
        });
        this.schemaByProjectDivision = await this.cl.withMessage("Hled\xe1m schvalovac\xed sch\xe9mata").getApprovingSchemaForOrgProjectIds(projectDivisionIds);
        const anyNoSetting = Object.values(this.schemaByProjectDivision).some((n)=>n === null);
        // Uložit
        await this.doSave(false, false);
        // Spustit schvalování
        if (anyNoSetting) {
            this.openInvItemSelectSchema(true);
            this.loadApprovingSchemas();
        } else this.createApproving(null);
    }
    getRejectInfo() {
        const res = [];
        for(var _iterator2 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(this.invoice.items), _step2; !(_step2 = _iterator2()).done;){
            const item = _step2.value;
            if (item.approving.state === "rejected") for(var _iterator3 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(item.approving.approvals), _step3; !(_step3 = _iterator3()).done;){
                const approval = _step3.value;
                if (approval.state === "rejected") res.push({
                    account: this.accounts[approval.accountId].name,
                    note: approval.note,
                    dt: approval.createdAt
                });
            }
        }
        return res;
    }
    bInvItemCreateApprovingCancel_click() {
        this.openInvItemSelectSchema(false);
    }
    approveItems(invoiceItems) {
        let approving;
        let isItems = false; // = Array.isArray(invoiceItems);
        if (Array.isArray(invoiceItems)) {
            isItems = true;
            // Položky faktury
            this.muClear("approvingItems");
            for(var _iterator4 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(invoiceItems), _step4; !(_step4 = _iterator4()).done;){
                let item = _step4.value;
                const w = this.muWidgetFromTemplate("invoiceItem", "approvingItems", {
                    inApproving: true
                });
                w.muBindData(item);
                approving = item.approving;
            }
        } else // Celá faktura
        approving = invoiceItems.approving;
        this.currentEntity = isItems ? "invoiceItem" : "invoice";
        this.muVisible(isItems, [
            "invoiceItemTable",
            "!approvingInvoiceLabel"
        ]);
        this.setApprovingPhase("actions");
        const state = approving.state;
        const isMy = approving.approverIds?.includes(this.myAccountId);
        this.muVisible(state === "wait" && isMy, [
            "bAccept",
            "bReject",
            "bOpenSetApprover"
        ]);
        this.muVisible(state === "noschema", "bOpenSetApprovingSchemaList");
        this.muVisible(false, "bReopen");
        this.openApproving(true);
        // Přejít na výběr schématu pokud je bez schématu
        if (state === "noschema") this.bOpenSetApprovingSchemaList_click();
    }
    bApproving_click() {
        this.approveItems(this.getCheckedItems());
    }
    bAccept_click() {
        this.setState("accepted", "invoiceItem");
    }
    bReject_click() {
        this.setState("rejected", "invoiceItem");
    }
    bInvItemApprove_click() {
        this.doSave(false).then(()=>this.setState("accepted", "invoiceItem"));
    }
    bInvItemReject_click() {
        this.doSave(false).then(()=>this.setState("rejected", "invoiceItem"));
    }
    async bInvItemCancel_click() {
        await this.invoiceItemsCancel(await this.getCheckedItemWidgets());
    }
    async invoiceItemsCancel(items) {
        const itemIds = [];
        for(var _i = 0, _items = items; _i < _items.length; _i++){
            const item = _items[_i];
            const groupIds = this.checkRemoveApprover(item.invoiceItem, this.myAccountId);
            // zkus jen odebrat řešitele
            if (groupIds !== false) // odebrat řešitele
            itemIds.push({
                invoiceItemId: item.invoiceItem.id,
                groupIds: groupIds
            });
            else // zrušit schvalování
            item.setOrgProjectId(null);
        }
        // return;
        await this.doSave(false);
        if (itemIds) await this.cl.withMessage("Odeb\xedr\xe1m schvalovatele").removeApprover(this.myAccountId, this.invoiceId, itemIds);
        await this.reloadInvoice();
    }
    // Vrací seznam id schvalovacích skupin pokud je možné odebrat schvalovatele, nebo false pokud ne
    checkRemoveApprover(item, approverId) {
        const groupIds = [];
        const step = this.approvingSchemas[item.approving.approvingSchemaId].steps.find((s)=>s.id == item.approving.currentStepId);
        for(var _iterator5 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(step.groups), _step5; !(_step5 = _iterator5()).done;){
            const group = _step5.value;
            const cc = item.approving.approvers[group.id].filter((a)=>a != approverId).length;
            if (cc < group.minimalApprovers) return false;
            groupIds.push(group.id);
        }
        return groupIds;
    }
    async setState(state, entityType) {
        const entityIDs = entityType === "invoice" ? [
            {
                itemId: this.invoice.id,
                entity: "invoice",
                approvingId: this.invoice.approving.approvingId
            }
        ] : this.getCheckedItems().map((item)=>({
                itemId: item.approving.invoiceItemId,
                entity: "invoiceItem",
                approvingId: item.approving.approvingId
            }));
        await this.cl.setState(entityIDs, state, this.getComment());
        this.reloadInvoice();
    }
    async bSetApprover_click() {
        await this.cl.changeApprover(this.getApprovingItemIds(), this.muNamedWidget.cApprovers.muFetchData(), this.getComment());
        this.reloadInvoice();
    }
    /* public async bReopen_click() {
  	await this.cl.reopen(this.getApprovingItemIds(), this.getComment());
  	this.reloadInvoice();
  }
  	public bAddComment_click() {
  	}
  	public bCloseApproving_click() {
  	this.openApproving(false);
  } */ bReload_click() {
        this.reloadInvoice();
    }
    async reloadInvoice(id = null) {
        if (id) this.invoiceId = id;
        // this.openApproving(false);
        await this.loadInvoice();
        this.updateForm();
    }
    openApproving(visible) {
        this.muVisible(visible, "itemApproving");
        // this.muVisible(true, 'pActionDetail');
        this.muVisible(false, "approvingSchema");
    // this.openSetApprovingSchemaList(false);
    // this.openOrgDivision(false);
    }
    bOpenSetApprover_click() {
        this.setApprovingPhase("setApprover");
    }
    bCloseSetApprover_click() {
        this.setApprovingPhase("actions");
    }
    setApprovingPhase(phase) {
        this.muVisible(phase == "actions", "pActions");
        this.muVisible(phase == "setApprover", "pApproverSelector");
        this.muVisible(phase != "setApprover", "pComment");
    }
    selectAll(ev, filter, doCheck = true) {
        const res = [];
        this.getItemWidgets().forEach((iiw)=>{
            let checked = false;
            if (Array.isArray(filter)) checked = filter.includes(iiw.invoiceItem.id);
            else switch(filter){
                case "rejected":
                    checked = iiw.invoiceItem.approving.state == "rejected";
                    break;
                case "noschema":
                    checked = iiw.canRunApproving(); /* invoiceItem.approving.state == "noschema"
                                           && !!iiw.getOrgProjectId()
                                           && (!!iiw.getOrgProductId() || !this.productRequired); */ 
                    break;
                case "my-wait":
                    checked = iiw.invoiceItem?.approving?.state == "wait" && iiw.isMy;
                    break;
                case "noproduct":
                    checked = iiw.invoiceItem.approving.state == "noschema" && !iiw.getOrgProductId();
                    break;
                case "noproject":
                    checked = iiw.invoiceItem.approving.state == "noschema" && !iiw.getOrgProjectId();
                    break;
            }
            if (checked) res.push(iiw);
            if (doCheck) {
                iiw.ui.checked.checked = checked;
                iiw.checked_change();
            }
        });
        if (doCheck) this.updateForm();
        return res;
    }
    getComment() {
        return this.ui.cInvComment.value;
    }
    openSetApprovingSchemaList(isOpen) {
        if (isOpen) {
            this.muVisible(false, "pActions");
            this.muVisible(false, "pComment");
            this.cl.withMessage("Na\u010D\xedt\xe1m schvalovac\xed sch\xe9mata").getApprovingSchemaList(false, true).then((data)=>{
                this.muBindData({
                    approvingSchemaList: data
                });
                this.muVisible(true, "pApprovingSchemaList");
            });
        } else this.muVisible(false, "pApprovingSchemaList");
    }
    /* setApprovingSchemaId(id: number) {
  	this.approvingSchemaId = id;
  	this.muVisible(false, "pApprovingSchemaList");
  	this.cl.getOrgDivisions().then(data => {
  		const tree = this.muNamedWidget.cOrgDivision as TreeSelector;
  		tree.bindTree(data);
  		tree.collapseFromLevel(1);
  		this.openOrgDivision(true);
  	});
  	this.muVisible(false, "bRunApproving");
  }
  	cOrgDivision_change(ev, id) {
  	this.muVisible(!!id, "bRunApproving");
  } */ /* bRunApproving_click() {
  	this.setApprovingSchema(this.approvingSchemaId, parseInt((this.muNamedWidget.cOrgDivision as TreeSelector).getValue()));
  } */ createApproving(approvingSchemaId) {
        const data = this.getCheckedItemWidgets().map((iiw)=>{
            let opid = iiw.getOrgProjectId();
            opid = opid !== "withoutProject" ? opid : null;
            return {
                id: iiw.invoiceItem.id,
                approvingSchemaId: this.schemaByProjectDivision[iiw.getOrgDivisionId() + "-" + (opid ?? "")] || approvingSchemaId,
                orgDivisionId: iiw.getOrgDivisionId(),
                orgProjectId: opid,
                entityId: null,
                overheadCost: false
            };
        });
        // @ts-ignore
        this.cl.withMessage("Spou\u0161t\xedm schvalov\xe1n\xed").createApproving("invoiceItem", // this.currentEntity,
        data).then((res)=>{
            const allCount = res.length;
            let failedCount = 0;
            for(var _iterator6 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(res), _step6; !(_step6 = _iterator6()).done;){
                const resItem = _step6.value;
                if (resItem.errors) {
                    failedCount++;
                    (0, $3cBch.UiFlashMessage).instance.add("Nepovedlo se spustit schvalovani: " + resItem.errors.join(", "));
                }
            }
            if (allCount > failedCount) (0, $3cBch.UiFlashMessage).instance.add((failedCount ? "Ostatn\xedm" : "Vybran\xfdm") + " polo\u017Ek\xe1m bylo nastaveno schvalovac\xed sch\xe9ma.");
            this.openApproving(false);
            this.openInvItemSelectSchema(false);
            this.reloadInvoice();
        });
    }
    /* setApprovingSchema(id: number, orgDivisionId : number) {
  	//
  	this.cl.createApproving(
  		this.currentEntity,
  		this.currentEntity === "invoiceItem" ? this.getApprovingItemIds() : [ this.invoice.id ],
  		id,
  		null,
  		orgDivisionId
  	).then(() => {
  		UiFlashMessage.instance.add("Vybraným položkám bylo nastaveno schvalovací schéma.");
  		this.openApproving(false);
  		this.reloadInvoice();
  	});
  } */ bOpenSetApprovingSchemaList_click() {
        this.openSetApprovingSchemaList(true);
    }
    showApprovingSchema(schemaId, itemId, inApproving) {
        if (schemaId) {
            this.openApproving(true);
            this.muVisible(true, "approvingSchema");
            this.currentItemId = itemId;
            this.muNamedWidget.approvingSchema.muBindData(this.approvingSchemas[schemaId]);
        // this.set
        /* if (!inApproving) { // schovej zbytečnosti
      	this.muVisible(false, 'pActionDetail');
      } */ }
    }
    getCurrentApproving() {
        return this.currentItemId === "invoice" ? this.invoice.approving : this.invoice.items.find((inv)=>inv.id == this.currentItemId).approving;
    }
    getAccountsForGroupId(id) {
        /* const ids = this.currentItemId === "invoice"
    	? (this.invoice.approving.approvers[id] || [])
    	: this.invoice.items.find(inv => inv.id == this.currentItemId).approving.approvers[id]; */ const ids = this.getCurrentApproving()?.approvers[id] || [];
        const accounts = [];
        for(var _iterator7 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(ids), _step7; !(_step7 = _iterator7()).done;){
            let accountId = _step7.value;
            accounts.push(this.accounts[accountId.toString()]);
        }
        // console.log([ids, accounts]);
        return accounts;
    }
    isCurrentStep(stepNum) {
        const approving = this.currentItemId === "invoice" ? this.invoice.approving : this.invoice.items.find((inv)=>inv.id == this.currentItemId).approving;
        return approving.currentStep == stepNum && approving.state == "wait";
    }
    openOrgDivision(visible) {
        this.muVisible(visible, "pOrgDivision");
        visible;
    }
    bInvSelectSchema_click() {
        this.approveItems(this.invoice);
    }
    bInvApprove_click() {
        this.setState("accepted", "invoice");
    }
    bInvReject_click() {
        this.setState("rejected", "invoice");
    }
    bInvApprovingDetail_click() {
        this.showApprovingSchema(this.invoice.approving.approvingSchemaId, "invoice", false);
    }
    /* bindAttachList() {
  	this.cl.getAttachesFotTicketAndRelated(this.ticketId).then(
  		data => this.muBindData({attachList: data})
  	);
  }
  	showAttach(id: number) {
  	this.cl.getAttachDetail(id, this.ticketId).then(
  		data => {
  			this.ui.preview.innerHTML = data;
  			this.muVisible(true, 'bClosePreview');
  		}
  	);
  }
  	bClosePreview_click() {
  	this.ui.preview.innerHTML = '';
  	this.muVisible(false, 'bClosePreview');
  } */ bindItems(items) {
        this.muClear("items");
        // this.muWidgetFromTemplate("invoiceItemHeader", "items");
        for(var _i2 = 0, _items2 = items; _i2 < _items2.length; _i2++){
            const item = _items2[_i2];
            const w = this.muWidgetFromTemplate("invoiceItem", "items");
            w.initOrgProjectId = item.orgProjectId;
            w.muBindData(item);
        }
        this.sumWidget = this.muWidgetFromTemplate("invoiceItemFooter", "items");
        this.updateSums();
    }
    updateSelectedValues(values) {
        const selected = this.getItemWidgets().filter((iiw)=>iiw.isChecked());
        selected.map((iiw)=>iiw.updateValues(values, false));
    }
    forkItem(invoiceApprovalItem) {
        this.forkItemDialog(invoiceApprovalItem);
    }
    async forkItemDialog(invoiceApprovalItem) {
        // this.muVisible(true, "forkItemDialog");
        // (this.muNamedWidget.forkItemDialog as ForkItemDialog).loadItem(invoiceApprovalItem);
        const w = this.openInModal("UiInvoiceSplitItem", null, {
            fullPrice: invoiceApprovalItem.ui.cUnitPrice.valueAsNumber,
            fullQuantity: invoiceApprovalItem.ui.cQuantity.valueAsNumber,
            name: invoiceApprovalItem.ui.cName.value
        });
        invoiceApprovalItem.setMarked(true);
        const res = await w.savedPromise;
        invoiceApprovalItem.setMarked(false);
        // console.log(res);
        if (res && res.parts.length > 1) {
            const oldItemData = invoiceApprovalItem.muFetchData();
            let i = res.parts.length;
            for(var _iterator8 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(res.parts.reverse()), _step8; !(_step8 = _iterator8()).done;){
                const newValue = _step8.value;
                const k = res.type == "price" ? "unitPrice" : "quantity";
                const v = res.type == "price" ? newValue * 100 : newValue;
                i--;
                if (i) {
                    const newItemData = {
                        ...oldItemData,
                        id: null,
                        orgProjectId: null,
                        [k]: v
                    };
                    this.muWidgetFromTemplate("invoiceItem", "items", {}, "after", invoiceApprovalItem.container).muBindData(newItemData);
                } else invoiceApprovalItem.muBindData({
                    [k]: v
                });
            }
        }
    }
    doForkItem(invoiceApprovalItem, changes) {
        const oldItemData = invoiceApprovalItem.muFetchData();
        const newItemData = {
            ...oldItemData,
            name: changes.name,
            id: null,
            orgProjectId: null
        };
        if (changes.forkBy == "quantity") {
            newItemData.quantity = changes.value;
            oldItemData.quantity -= changes.value;
        } else {
            newItemData.unitPrice = changes.value * 100;
            oldItemData.unitPrice -= changes.value * 100;
        }
        invoiceApprovalItem.muBindData(oldItemData);
        this.muWidgetFromTemplate("invoiceItem", "items", {}, "after", invoiceApprovalItem.container).muBindData(newItemData);
        this.closeModal("forkItemDialog");
    }
    fetchInvoice() {
        return this.getItemWidgets().map((iiw)=>iiw.muFetchData());
    }
    async bSaveAndApprove_click() {
        const res = await this.doSave(true);
    }
    bSave_click() {
        this.doSave(false);
    }
    doSave(autoApprove, reload = true) {
        this.setIsSaved();
        return this.cl.withMessage("Ukl\xe1d\xe1m polo\u017Eky").updateInvoiceItems(this.getItemWidgets().map((iiw)=>iiw.muFetchData()), this.invoiceId, this.ticketId, autoApprove, true // vynutit spustení schvalování
        ).then((data)=>{
            const res = this.callMethodInFirstAncestors("invoiceChanges", data.changes);
            if (res?.action === "reloadNext") return;
            else {
                // reload bez změny požadavku
                this.setIsSaved();
                if (reload) this.callMethodInFirstAncestors("reloadTicketAndList");
            }
            this.bindInvoiceData(data);
            this.updateForm();
        });
    }
    loadApprovingSchemas() {
        this.ui.approvingSchemaList.classList.toggle("loading-data", true);
        this.cl.getApprovingSchemaList(false, true).then((data)=>{
            this.muBindData({
                approvingSchemaList: data
            });
            this.ui.approvingSchemaList.classList.toggle("loading-data", false);
        });
    }
    /* createApproving(approvingSchemaId: number) {
  	this.cl.createInvoiceItemApproving(
  		this.invoiceId,
  		this.getCheckedItems().map(ii => ii.id),
  		approvingSchemaId
  	).then(res => {
  		this.reloadInvoice();
  		this.openInvItemSelectSchema(false);
  	});
  } */ updateSums() {
        if (!this.sumWidget) return;
        const sums = this.getItemWidgets().reduce((previousValue, currentValue)=>{
            const data = currentValue.computePrices();
            previousValue.price += data.price;
            previousValue.vatPrice += data.vatPrice;
            previousValue.vatPriceCurrency += data.vatPriceCurrency;
            return previousValue;
        }, {
            price: 0,
            vatPrice: 0,
            vatPriceCurrency: 0
        });
        this.sumWidget.muBindData(sums);
        this.muBindData(sums);
    }
    async bInvRequireProduct_click() {
        await this.doSave(false);
        await this.cl.requireProducts(this.ticketId, this.invoiceId);
        await this.loadInvoice();
    }
    getMyWaitItems() {
        return this.selectAll(null, "my-wait", false);
    }
    async selectItems(title, operation) {
        await this.saveIfNew();
        const res = await this.openInModal("UiInvoiceApprovingItemSelector", title, {
            items: this.getMyWaitItems().map((w)=>w.muFetchData()),
            operationName: operation
        }).savedPromise;
        return res && res.itemIds.length ? {
            items: this.getItemWidgets().filter((item)=>res.itemIds.includes(item.muFetchData().id)),
            note: res.note
        } : null;
    }
    async bInvItemRejectDialog_click() {
        const res = await this.selectItems("Zam\xedtnut\xed polo\u017Eek", "Zam\xedtnout");
        if (res === null) return;
        await this.cl.setState(res.items.map((item)=>({
                itemId: item.invoiceItem.approving.invoiceItemId,
                entity: "invoiceItem",
                approvingId: item.invoiceItem.approving.approvingId
            })), "rejected", res.note);
        await this.reloadInvoice();
    }
    async bInvItemCancelDialog_click() {
        const res = await this.selectItems("P\u0159edat schvalov\xe1n\xed n\u011Bkomu jin\xe9mu", "Nen\xed moje");
        if (res && res.items.length) await this.invoiceItemsCancel(res.items);
    }
    constructor(...args){
        super(...args);
        this.accounts = {};
        this.lastData = "";
        /* public getOrgDivisions() : Promise<any> {
  	return new Promise<any>(resolve => {
  		if (this.orgDivisions) resolve(this.orgDivisions);
  		else {
  			if (!this.orgDivisionPromise) this.orgDivisionPromise = this.cl.getOrgDivisions();
  			this.orgDivisionPromise.then(res => {
  				this.orgDivisions = res;
  				resolve(this.orgDivisions);
  			});
  		}
  	});
  }
  protected orgDivisions = null;
  protected orgDivisionPromise = null; */ this.orgDivisionPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m organiza\u010Dn\xed jednotky").getOrgDivisions(this.buSubjectId, true));
        this.orgProjectPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m projekty").getOrgProjects(this.buSubjectId, true));
        this.orgProductPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m produkty").getOrgProducts(this.buSubjectId, true));
        this.lastTicketStateId = null;
    }
}
class $5f307996e167143f$export$33ac4d6b94182e93 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(/*html*/ `<div class="invoice-approval--item" mu-id="main">
			<div class="grid-column-s2">
				<input type="checkbox" mu-id="checked" mu-bind="checked" />
				<span mu-id="bApproving"></span>
				<span class="icon-info-b cursor-pointer" mu-id="bDetails"></span>
			</div>
			<div class="text-right">Mno\u{17E}stv\xed</div>
			<div class="text-right">Jedn.</div>
			<div class="text-right">Jedn. cena</div>
			<div class="text-right">DPH %</div>
			<div class="text-right">Z\xe1klad</div>
			<div class="text-right">DPH \u{10D}\xe1stka</div>
			<div class="text-right">Celkem</div>
		
			<div>N\xe1zev</div>
			<div><input type="text" mu-id="cName" mu-bind="name" class="form-control" /></div>
			<div><input type="number" mu-id="cQuantity" mu-bind="quantity" step="0.01" class="form-control" /></div>
			<div><input type="text" mu-id="cUnit" mu-bind="unit" class="form-control" /></div>
			<div><input type="number" mu-id="cUnitPrice" mu-bind="unitPrice|priceI100::value|priceI100r" step="0.01" class="form-control" /></div>
			<div><input type="number" mu-id="cVat" mu-bind="vat" class="form-control" /></div>
			<div mu-id="price" mu-bind="price|priceV" class="number"></div>
			<div mu-id="vatPrice" mu-bind="vatPrice|priceV" class="number"></div>
			<div mu-id="vatPriceCurrency" mu-bind="vatPriceCurrency|priceV" class="number"></div>
		
			<div>St\u{159}edisko</div>
			<div><div mu-widget="UiTomSelect" mu-id="cOrgDivision" mu-bind="orgDivisionId" mu-params='{"valueField":"id","labelField":"title"}'></div></div>
			<div class="grid-column-s5"></div>
			<div class="grid-column-s2 text-align-right">
				<span class="a" mu-id="bFork">Rozd\u{11B}lit polo\u{17E}ku</span>
			</div>
		
			<div>Projekt</div>
			<div>
				<!-- <div mu-widget="TreeSelector" mu-id="cOrgProject" mu-bind="orgProjectId" mu-params='{"inModal":true}'></div> -->
				<div mu-widget="UiTomSelect" mu-id="cOrgProject" mu-bind="orgProjectId" mu-params='{"valueField":"id","labelField":"title"}'></div>
				<span class="icon-before-alert" mu-id="changeProjectInfo" style="display: none">Zm\u{11B}nil se projekt, schvalov\xe1n\xed bude znovu spu\u{161}t\u{11B}no.</span>
			</div>
			<div><label class="checkbox-inline">
				<input type="checkbox" mu-bind="withoutProject" mu-id="cWithoutProject" />
				Bez projektu
			</label></div>
			<div class="grid-column-s3"></div>
			<div class="grid-column-s3 grid-row-s2">
				<div mu-bind="approving|getComments:@foreach">
					<div mu-widget="." mu-template="comment">
						<span mu-bind="note:@visible" class="icon-comment"></span>
						<span mu-bind='state|prepend("icon-"):className'></span>
						<span mu-bind="accountId|getAccountName"></span>
						<span mu-bind="note" class="invoice-approval--approving-schema--step--account--note"></span>
					</div>
				</div>
			</div>
		
			<div>Produkt</div>
			<!-- <div><div mu-widget="TreeSelector" mu-id="cOrgProduct" mu-bind="orgProductId" mu-params='{"inModal":true}'></div></div> -->
			<div><div mu-widget="UiTomSelect" mu-id="cOrgProduct" mu-bind="orgProductId" mu-params='{"valueField":"id","labelField":"title"}'></div></div>
		
		</div>`);
    }
    getOrgProjectId() {
        const v = this.ui.cWithoutProject.checked ? "withoutProject" : this.muNamedWidget.cOrgProject.getValue();
        // @ts-ignore
        return v === null || v === "withoutProject" ? v : parseInt(v);
    }
    setOrgProjectId(value) {
        this.updateValues({
            orgProjectId: value
        });
    }
    getOrgDivisionId() {
        const v = this.muNamedWidget.cOrgDivision.getValue();
        return v === null ? null : parseInt(v);
    }
    getOrgProductId() {
        const v = this.muNamedWidget.cOrgProduct.getValue();
        return v === null ? null : parseInt(v);
    }
    afterIndex() {
        this.approvingLayout(this.inApproving);
    }
    /* protected muAfterBindData(data: any) {
  	this.computePrices();
  } */ muBindData(invoiceItem) {
        const invoiceItemBindData = {
            ...invoiceItem
        };
        if (invoiceItemBindData.orgProjectId === "withoutProject") {
            invoiceItemBindData.orgProjectId = null;
            invoiceItemBindData.withoutProject = true;
        }
        if ("orgProductId" in invoiceItem) this.oldOrgProductId = invoiceItem.orgProductId;
        super.muBindData(invoiceItemBindData);
        this.invoiceItem = {
            ...this.invoiceItem,
            ...invoiceItem
        };
        if (!this.invoiceItem.approving) // @ts-ignore
        this.invoiceItem.approving = {
            state: "noschema",
            // invoiceItem.orgProductId ? "noschema" : "noproduct",
            approverIds: []
        };
        // Schvalování
        // this.ui.approvalIcon.className = 'icon-' + invoiceItem.approving.state;
        // (this.ui.bApproving as any).className = 'icon-' + invoiceItem.approving.state;
        this.isMy = this.invoiceItem.approving.approverIds?.includes(this.muParent.myAccountId);
        if (this.isMy) this.container.classList.add("for-approving");
        this.muParent.orgDivisionPromise.fetch().then((ls)=>{
            this.allOrgDivisions = ls;
            this.muNamedWidget.cOrgDivision.bindItems(ls);
            // (this.muNamedWidget.cOrgDivision as TreeSelector).bindTree(ls);
            // až po nabindování stredisek at zna strukturu
            setTimeout(()=>this.bindProjectTree(), 200);
        });
        this.muParent.orgProductPromise.fetch().then((ls)=>this.muNamedWidget.cOrgProduct.bindItems(ls));
        this.computePrices();
    }
    async bindProjectTree() {
        const projects = await this.muParent.orgProjectPromise.fetch();
        /* const orgDivisionId = this.muNamedWidget.cOrgDivision.value
    const orgDivisionIds = orgDivisionId ?
    	[ orgDivisionId, ...Utils.getRecursiveItems(
    		await this.muParent.orgDivisionPromise.fetch(),
    		orgDivisionId
    	) ] : null; */ const orgDivisionIds = null;
        // (this.muNamedWidget.cOrgDivision as TreeSelector).getSelectedItemRecursive().map(i => i.id);
        /* (this.muNamedWidget.cOrgProject as TreeSelector).bindTree(
    	!!orgDivisionIds.length
    	? ls.filter(od => orgDivisionIds.indexOf(od.orgDivisionId) > -1)
    	: ls
    ); */ this.muNamedWidget.cOrgProject.bindItems(orgDivisionIds && orgDivisionIds.length ? projects.filter((od)=>orgDivisionIds.indexOf(od.orgDivisionId) > -1) : projects, true);
    }
    muFetchData() {
        return {
            ...super.muFetchData(),
            id: this.invoiceItem.id,
            orgProjectId: this.getOrgProjectId()
        };
    }
    approvingLayout(inApproving) {
    // (this.container.firstElementChild as HTMLElement).style.visibility = inApproving ? "hidden" : null;
    // (this.container.lastElementChild.previousElementSibling as HTMLElement).style.visibility = inApproving ? "hidden" : null;
    }
    isChecked() {
        return this.ui.checked.checked;
    }
    checked_change() {
        this.muParent.updateForm();
        this.container.classList.toggle("selected", this.ui.checked.checked);
    }
    /* public bApproving_click() {
  	this.muParent.approveItems([this.invoiceItem]);
  } */ async bDetails_click() {
        if (this.invoiceItem.approving?.approvingSchemaId) this.muParent.showApprovingSchema(this.invoiceItem.approving?.approvingSchemaId, this.invoiceItem.id, this.inApproving);
        else {
            console.log(this.invoiceItem);
            const res = await this.muParent.cl.findApprovingSchemaForItem(this.invoiceItem);
            (0, $kwZWC.flashInfo)("Schvalov\xe1n\xed nen\xed je\u0161t\u011B spu\u0161t\u011Bno. " + (res ? "Bude pou\u017Eito schvalovac\xed sch\xe9ma " + res : "Pro tuto polo\u017Eku nebylo nalezeno vhodn\xe9 schvalovac\xed sch\xe9ma"));
        }
    }
    visibleCheckedIfState(state) {
        let vis = state == null || state == this.invoiceItem?.approving?.state;
        if (vis) switch(this.invoiceItem?.approving?.state){
            case "accepted":
                vis = false;
                break;
            case "wait":
                vis = this.isMy;
                break;
            case "rejected":
                vis = false;
        }
        this.ui.checked.style.visibility = vis ? "visible" : "hidden";
    /* this.muVisible(
    	vis,
    	'checked'
    ); */ }
    cOrgProduct_changeValue(ev) {
        //todo:Nová verze MuWidget
        const item = this.muNamedWidget.cOrgProduct.valueOption;
        if (item) {
            this.updateValues(item ? {
                orgProductId: item.id,
                vat: item.vat
            } : {
                orgProductId: item.id
            });
            this.muParent.updateForm();
            this.muParent.updateSums();
        }
    }
    cOrgProject_changeValue(ev) {
        const changes = {
            orgProjectId: this.getOrgProjectId()
        };
        if (this.muNamedWidget.cOrgProject.valueOption) changes.orgDivisionId = this.muNamedWidget.cOrgProject.valueOption.orgDivisionId;
        this.updateValues(changes);
        this.muParent.updateForm();
    }
    cWithoutProject_change() {
        this.updateValues({
            orgProjectId: this.getOrgProjectId()
        });
        this.muParent.updateForm();
    }
    cOrgDivision_changeValue(ev) {
        //todo:Nová verze MuWidget
        this.updateValues({
            orgDivisionId: this.muNamedWidget.cOrgDivision.value
        });
        this.bindProjectTree();
    }
    updateValues(values, updateOthers = true, updateSelf = true) {
        if (updateSelf) {
            if ("vat" in values) this.ui.cVat.value = values.vat;
            if ("orgProductId" in values) this.muNamedWidget.cOrgProduct.setSelected(values.orgProductId, false);
            if ("orgProjectId" in values) {
                if (values.orgProjectId !== "withoutProject") this.muNamedWidget.cOrgProject.setSelected(values.orgProjectId, false);
                this.ui.cWithoutProject.checked = values.orgProjectId === "withoutProject";
            }
            if ("orgDivisionId" in values) this.muNamedWidget.cOrgDivision.setSelected(values.orgDivisionId, false);
        }
        if (this.isChecked() && updateOthers) this.muParent.updateSelectedValues(values);
        this.computePrices();
    }
    cQuantity_change() {
        this.computePrices();
        this.muParent.updateSums();
    }
    cUnitPrice_change() {
        this.computePrices();
        this.muParent.updateSums();
    }
    cVat_change() {
        this.computePrices();
        this.muParent.updateSums();
    }
    computePrices() {
        // const values = this.muFetchData();
        const data = {};
        data.price = parseFloat(this.ui.cQuantity.value) * parseFloat(this.ui.cUnitPrice.value);
        data.vatPrice = data.price * (parseFloat(this.ui.cVat.value) / 100);
        data.vatPriceCurrency = data.vatPrice + data.price;
        this.ui.price.innerText = (0, $bjpdy.MuBinder).filters.priceV(data.price);
        this.ui.vatPrice.innerText = (0, $bjpdy.MuBinder).filters.priceV(data.vatPrice);
        this.ui.vatPriceCurrency.innerText = (0, $bjpdy.MuBinder).filters.priceV(data.vatPriceCurrency);
        if (this.invoiceItem) {
            const state = this.invoiceItem.approving.state == "noschema" ? this.canRunApproving() ? "noschema" : "noproject" : this.invoiceItem.approving.state;
            this.ui.bApproving.className = "icon-" + state;
            const disabled = !this.isEditable();
            this.ui.cName.disabled = disabled;
            this.ui.cQuantity.disabled = disabled;
            this.ui.cUnit.disabled = disabled;
            this.ui.cUnitPrice.disabled = disabled;
            this.ui.cVat.disabled = disabled;
            this.ui.cWithoutProject.disabled = disabled;
            // this.ui.cOverheadCost.disabled = disabled;
            this.muNamedWidget.cOrgDivision.setDisabled(disabled);
            this.muNamedWidget.cOrgProject.setDisabled(disabled || this.ui.cWithoutProject.checked);
            // this.muNamedWidget.cOrgProduct.setDisabled(disabled);
            /* console.log([
      	this.invoiceItem.id,
      	this.invoiceItem.approving.state,
      	this.getOrgProjectId(),
      	this.getOrgProductId(),
      	(this.ui.bApproving as any).className
      ]); */ this.muVisible(this.initOrgProjectId && this.invoiceItem.approving.state == "wait" && this.initOrgProjectId != this.getOrgProjectId(), "changeProjectInfo");
            this.container.classList.toggle("invoice-approval--item__no-project", !this.getOrgProjectId());
        /* (this.ui.cOrgProject as HTMLElement).style.visibility = this.ui.cWithoutProject.checked
      	? "hidden"
      	: "visible"; */ }
        return data;
    }
    isEditable() {
        return ![
            "accepted",
            "rejected"
        ].includes(this.invoiceItem?.approving?.state);
    }
    bFork_click() {
        this.muParent.forkItem(this);
    }
    canRunApproving() {
        return this.invoiceItem.approving.state == "noschema" && !!this.getOrgProjectId() && (!!this.getOrgProductId() || !this.muParent.productRequired);
    }
    getComments(approving) {
        return approving.approvals ? approving.approvals.filter((a)=>a.note || a.state === "rejected") : [];
    }
    setMarked(state) {
        this.ui.main.classList[state ? "add" : "remove"]("invoice-approval--item__marked");
    }
    constructor(...args){
        super(...args);
        this.inApproving = false;
        this.isMy = false;
        this.initOrgProjectId = null;
        this.name = "";
        this.oldOrgProductId = -1;
    }
}
class $5f307996e167143f$export$d127fab1257e4f14 extends (0, $6Taw3.BaseMuWidget) {
    name_click() {
        // (this.muParent as InvoiceApproval).setApprovingSchemaId(this.id);
        this.muParent.createApproving(this.id);
    }
    afterIndex() {}
    bEdit_click() {
        this.name_click();
    }
}
class $5f307996e167143f$export$dfed28f04264fbb1 extends (0, $6Taw3.BaseMuWidget) {
    master() {
        return this.muParent.muParent.muParent.muParent;
    }
    isMyAccount(id) {
        return this.master().myAccountId == id;
    }
    getAccountStateIcon(accountId) {
        //todo: reverse
        const approval = (this.master().getCurrentApproving()?.approvals || []).reverse().find((a)=>a.accountId == accountId && a.approvingSchemaStepGroupId);
        // this.muParent.muParent.stepId
        return "icon-" + $5f307996e167143f$export$4a10fe16e5e6ef1d.stateIcons[approval?.state ?? "wait"];
    }
    getAccountStateNote(accountId) {
        //todo: reverse
        const approval = (this.master().getCurrentApproving()?.approvals || []).reverse().find((a)=>a.accountId == accountId && a.approvingSchemaStepGroupId);
        // this.muParent.muParent.stepId
        return approval?.note ?? "";
    }
}
class $5f307996e167143f$export$f8f85d44d1939794 extends (0, $6Taw3.BaseMuWidget) {
    afterIndex() {
        this.muVisible(false, "itemsData");
    }
    changeForkBy() {
        const forkBy = this.getForkBy();
        this.muVisible(!!forkBy, "itemsData");
        this.bindForkBy(forkBy);
        this.ui.newValueV.focus();
    }
    getForkBy() {
        return this.ui.cForkByPrice.checked ? "price" : this.ui.cForkByQuantity.checked ? "quantity" : null;
    }
    loadItem(invoiceApprovalItem) {
        this.invoiceApprovalItem = invoiceApprovalItem;
        this.ui.unitPriceOriginal.innerText = (0, $bjpdy.MuBinder).filters.priceV(this.invoiceApprovalItem.ui.cUnitPrice.value);
        this.ui.quantityOriginal.innerText = (0, $bjpdy.MuBinder).filters.priceV(this.invoiceApprovalItem.ui.cQuantity.value);
        this.ui.cName.value = this.invoiceApprovalItem.ui.cName.value;
        this.muVisible(!!this.getForkBy(), "itemsData");
    }
    getOrignalValue() {
        return this.getForkBy() === "price" ? parseFloat(this.invoiceApprovalItem.ui.cUnitPrice.value) : parseFloat(this.invoiceApprovalItem.ui.cQuantity.value);
    }
    bindForkBy(forkBy) {
        const lastForkBy = this.getForkBy();
        if (!!lastForkBy) this.lastValue[lastForkBy] = this.ui.newValueV.value;
        this.ui.newValueR.max = this.ui.newValueV.max = this.getOrignalValue();
        this.ui.originalValue.innerText = (0, $bjpdy.MuBinder).filters.priceV(this.ui.newValueV.max);
        this.ui.newUnit.innerText = this.ui.oldUnit.innerText = forkBy === "price" ? "" : this.invoiceApprovalItem.ui.cUnit.value;
        this.setValue(this.lastValue[forkBy]);
    }
    newValueR_change(ev) {
        this.setValue(ev.target.value);
    }
    newValueV_change(ev) {
        this.setValue(ev.target.value);
    }
    setValue(value) {
        this.ui.newValueR.value = this.ui.newValueV.value = value;
        this.ui.oldValue.innerText = (0, $bjpdy.MuBinder).filters.priceV(this.getOrignalValue() - parseFloat(value));
    }
    constructor(...args){
        super(...args);
        this.lastValue = {
            price: 0,
            quantity: 0
        };
    }
}
class $5f307996e167143f$export$d02b89ba6b20d688 extends (0, $6Taw3.BaseMuWidget) {
    getFullValue() {
        return this.type === "price" ? this.fullPrice : this.fullQuantity;
    }
    beforeIndex() {
        this.muAppendContent(`<div class="invoice-split-item text-center">
			<strong>Rozd\u{11B}len\xed polo\u{17E}ky <span mu-id="name"></span></strong>
			<div class="checkbox">
				<label>
					<input type="radio" mu-id="cPrice" mu-name="splitBy" value="price" mu-change="onChangeType" /> Rozd\u{11B}lit \u{10D}\xe1stku za jednotku (<span mu-id="fullPrice"></span>).
				</label>
				<label>
					<input type="radio" mu-id="cQuantity" mu-name="splitBy" value="quantity" mu-change="onChangeType" /> Rozd\u{11B}lit mno\u{17E}stv\xed (<span mu-id="fullQuantity"></span>).
				</label>		
			</div>	
			<!-- <div mu-id="pPrice">
			</div>
			<div mu-id="pQuantity">
			</div> -->
		</div>
		<div class="display-grid-c2 gap-4px" mu-id="pSplit">
			<div class="text-right">
				Rozd\u{11B}lit <span mu-id="currentType"></spanmu>
			</div>
			<div mu-id="parts">
				<div mu-widget="." mu-template="item">
					<input type="number" mu-id="value" /><span class="icon-remove btn-icon" mu-id="bRemove"></span>
					<span class="invoice-split-item__inv-warning" mu-id="invWarning"></span>
				</div>
			</div>
			<div class="grid-column-s2 text-center">
				<span class="icon-before-add btn-icon" mu-id="bAdd">P\u{159}idat dal\u{161}\xed rozd\u{11B}len\xed</span>
			</div>
			<div class="grid-column-s2 buttons">
				<span class="btn btn-primary icon-before-add" mu-id="bSave">Ulo\u{17E}it rozd\u{11B}len\xed</span>
				<span class="btn btn-default icon-before-cancel" mu-id="bCancel">Storno</span>
			</div>
		</div></div>`);
    }
    afterIndex() {
        this.ui.fullPrice.innerText = (0, $bjpdy.MuBinder).filters.priceV(this.fullPrice);
        this.ui.fullQuantity.innerText = (0, $bjpdy.MuBinder).filters.priceV(this.fullQuantity);
        this.ui.name.innerText = this.name;
        this.setType(null);
    }
    addPart(first = false) {
        const w = this.muWidgetFromTemplate("item", "parts", {
            bRemove_click: ()=>{
                w.muRemoveSelf();
                this.calculate();
            },
            value_input: (ev)=>this.calculate(ev)
        });
        if (first) {
            w.ui.value.disabled = true;
            w.muVisible(false, "bRemove");
            this.firstPart = w;
        } else w.ui.value.focus();
        this.calculate();
    }
    bAdd_click() {
        this.addPart();
    }
    bCancel_click() {
        this.muRemoveSelf();
        this.spResolve(null);
    }
    bSave_click() {
        this.muRemoveSelf();
        if (this.type) this.spResolve({
            type: this.type,
            parts: this.getParts().filter((n)=>!!n)
        });
        else this.spResolve(null);
    }
    calculate(ev = null) {
        const partsSum = this.getParts().reduce((s, c)=>s + c);
        const diff = partsSum - this.getFullValue();
        this.firstPart.ui.value.valueAsNumber = (this.firstPart.ui.value.valueAsNumber || 0) - diff;
        for(var _iterator9 = $5f307996e167143f$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("parts")), _step9; !(_step9 = _iterator9()).done;){
            const part = _step9.value;
            part.muVisible(part.ui.value.valueAsNumber >= 0 != this.getFullValue() >= 0, "invWarning");
            part.ui.invWarning.innerText = "Hodnota by m\u011Bla b\xfdt " + (this.getFullValue() > 0 ? "kladn\xe1" : "z\xe1porn\xe1") + ".";
        }
    }
    getParts() {
        return this.muGetChildWidgets("parts").map((w)=>w.ui.value.valueAsNumber || 0);
    }
    pPrice_click() {
        this.setType("price");
    }
    pQuantity_click() {
        this.setType("quantity");
    }
    onChangeType(ev) {
        // @ts-ignore
        this.setType((0, $kwZWC.getRadioListSelectedValue)(this.ui.cPrice));
    }
    setType(type) {
        /* if (this.type === type) type = null;
    for (const t of ["Price", "Quantity"]) {
    	this.muVisible(type === t.toLowerCase() || type === null, "p" + t);
    	const newCh = type === t.toLowerCase();
    	if (this.ui["c" + t].checked !== newCh)
    		this.ui["c" + t].checked = newCh;
    } */ this.muVisible(!!type, "pSplit");
        if (type != this.type) {
            this.muClear("parts");
            this.addPart(true);
            this.addPart();
        }
        if (type) this.ui.currentType.innerText = ({
            price: "cenu",
            quantity: "mon\u017Estv\xed"
        })[type];
        this.type = type;
    }
    constructor(...args){
        super(...args);
        this.savedPromise = new Promise((resolve, reject)=>{
            this.spResolve = resolve;
            this.spReject = reject;
        });
        this.name = "";
        this.type = null;
    }
}
class $5f307996e167143f$export$17231c6ca286ed18 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<strong>Vyberte polo\u{17E}ky</strong>
			<div>
				<table class="table">
					<tbody mu-id="items" mu-bind="items::@foreach">
						<tr mu-template="item" mu-widget="." mu-bind="id::.id">
							<td>
								<div class="checkbox">
									<label>
										<input type="checkbox" mu-bind="checked" mu-id="checked" />
										<span mu-bind="name" class="flex-grow-1"></span>							
									</label>
								</div>
							</td>
							<td style="width: auto" class="number">
								<span mu-id="quantity" mu-bind="quantity"></span> &times;
								<span mu-id="unitPrice" mu-bind="unitPrice|priceV"></span>
							</td>
						</tr>
					</tbody>
				</table>
				<label mu-for="note">Koment\xe1\u{159}</label>
				<textarea mu-bind="note" mu-id="note" class="form-control"></textarea>
				<div class="buttons">
					<span class="btn btn-primary" mu-id="bSave" mu-bind="operationName"></span>
					<span class="btn btn-default icon-before-cancel" mu-id="bCancel">Storno</span>
				</div>
			</div>
		`);
    }
    afterIndex() {
        this.muBindData({
            items: this.items,
            operationName: this.operationName
        });
    }
    bCancel_click() {
        this.spResolve(null);
        this.muRemoveSelf();
    }
    bSave_click() {
        const data = this.muFetchData();
        const itemIds = data.items.filter((item)=>item.checked).map((item)=>item.id);
        if (!itemIds.length) {
            alert("Nen\xed vybr\xe1na ani jedna polo\u017Eka.");
            return;
        }
        this.spResolve({
            itemIds: itemIds,
            note: data.note
        });
        this.muRemoveSelf();
    }
    constructor(...args){
        super(...args);
        this.id = null;
        this.savedPromise = new Promise((resolve)=>this.spResolve = resolve);
    }
}

});
parcelRegister("cJjA3", function(module, exports) {

$parcel$export(module.exports, "InvoiceApprovalCL", () => $8f21a2b838d1357b$export$3894728763829392);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $8f21a2b838d1357b$export$3894728763829392 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/app-components-blackbox-invoiceapproval"){
        super(url);
    }
    getInvoice(id) {
        return this.callMethod("getInvoice", arguments, {
            "rawResult": false
        });
    }
    changeApprover(itemIds, approverIds, note) {
        return this.callMethod("changeApprover", arguments, {
            "rawResult": false
        });
    }
    setState(itemUids, state, note) {
        return this.callMethod("setState", arguments, {
            "rawResult": false
        });
    }
    createApproving(entityType, items, doCreateApproving = true, allApprovers = []) {
        return this.callMethod("createApproving", arguments, {
            "rawResult": false
        });
    }
    createInvoiceItemApproving(invoiceId, invoiceItemIds, approvingSchemaId) {
        return this.callMethod("createInvoiceItemApproving", arguments, {
            "rawResult": false
        });
    }
    findOrgProjects(term, buSubjectId = null, isEnabled = true) {
        return this.callMethod("findOrgProjects", arguments, {
            "rawResult": false
        });
    }
    updateInvoiceItems(invoiceItems, invoiceId, ticketId, autoApprove = false, forceRunApproving = false) {
        return this.callMethod("updateInvoiceItems", arguments, {
            "rawResult": false
        });
    }
    removeApprover(accountId, invoiceId, itemIds) {
        return this.callMethod("removeApprover", arguments, {
            "rawResult": false
        });
    }
    getOrgProducts(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProducts", arguments, {
            "rawResult": false
        });
    }
    getApprovingSchemaForOrgProjectId(orgProjectId, orgDivisionId) {
        return this.callMethod("getApprovingSchemaForOrgProjectId", arguments, {
            "rawResult": false
        });
    }
    getApprovingSchemaForOrgProjectIds(orgProjectIds) {
        return this.callMethod("getApprovingSchemaForOrgProjectIds", arguments, {
            "rawResult": false
        });
    }
    requireProducts(ticketId, invoiceId) {
        return this.callMethod("requireProducts", arguments, {
            "rawResult": false
        });
    }
    findVendor(query) {
        return this.callMethod("findVendor", arguments, {
            "rawResult": false
        });
    }
    createInvoice(data, ticketId, createApproving) {
        return this.callMethod("createInvoice", arguments, {
            "rawResult": false
        });
    }
    importDigitalInvoice(ticketId, path = null) {
        return this.callMethod("importDigitalInvoice", arguments, {
            "rawResult": false
        });
    }
    findApprovingSchemaForItem(invoiceItem) {
        return this.callMethod("findApprovingSchemaForItem", arguments, {
            "rawResult": false
        });
    }
    getAllCurrency() {
        return this.callMethod("getAllCurrency", arguments, {
            "rawResult": false
        });
    }
    getApprovingSchema(id, addNames) {
        return this.callMethod("getApprovingSchema", arguments, {
            "rawResult": false
        });
    }
    getApprovingSchemaList(addDrafts = false, active = null) {
        return this.callMethod("getApprovingSchemaList", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
    getAttachData(attachId, authByTicketId = null) {
        return this.callMethod("getAttachData", arguments, {
            "rawResult": false
        });
    }
    getAttachesFotTicketAndRelated(ticketId) {
        return this.callMethod("getAttachesFotTicketAndRelated", arguments, {
            "rawResult": false
        });
    }
    findAttachesFor(ids) {
        return this.callMethod("findAttachesFor", arguments, {
            "rawResult": false
        });
    }
    getBcmAttachesFor(ids) {
        return this.callMethod("getBcmAttachesFor", arguments, {
            "rawResult": false
        });
    }
    saveAttach(attachId, ids, data) {
        return this.callMethod("saveAttach", arguments, {
            "rawResult": false
        });
    }
    createFolder(ids, name, parentId) {
        return this.callMethod("createFolder", arguments, {
            "rawResult": false
        });
    }
    newTempFile() {
        return this.callMethod("newTempFile", arguments, {
            "rawResult": false
        });
    }
}

});

parcelRegister("fnX8e", function(module, exports) {

$parcel$export(module.exports, "CachedPromise", () => $239d12b99d5c7f33$export$20cf4713e48ea94e);
class $239d12b99d5c7f33$export$20cf4713e48ea94e {
    constructor(factory){
        this.dataLoaded = false;
        this.promise = null;
        this.factory = factory;
    }
    fetch() {
        return new Promise((resolve)=>{
            if (this.data) resolve(this.data);
            else {
                if (!this.promise) this.promise = new Promise((resolve)=>this.factory(resolve)?.then((data)=>resolve(data)));
                this.promise.then((res)=>{
                    this.data = res;
                    resolve(this.data);
                });
            }
        });
    }
}

});


parcelRegister("5l93r", function(module, exports) {

$parcel$export(module.exports, "AccountSelector", () => $adaab2a5345396be$export$80cedb8608fac73b);
$parcel$export(module.exports, "AccountSelectorItemSelected", () => $adaab2a5345396be$export$63eea2f14fabd78a);
$parcel$export(module.exports, "AccountSelectorItemSearched", () => $adaab2a5345396be$export$e789a28955d99a8b);

var $4hoex = parcelRequire("4hoex");
class $adaab2a5345396be$export$80cedb8608fac73b extends (0, $4hoex.IMuWidget) {
    muFetchData() {
        return this.muGetChildWidgets("lSelected").map((isw)=>isw.getId());
    }
    cTerm_keypress() {
        this.lastKeyPress = new Date();
        // console.count("keypress");
        setTimeout(()=>{
            // console.count("keypress on timer");
            const term = this.ui.cTerm.value.trim();
            if (term.length < this.minTermLength) return;
            const now = new Date();
            const diff = (now.getTime() - this.lastKeyPress.getTime()) / 1000;
            if (diff > this.searchAfterSec) {
                // console.count("loading");
                this.searchCallback(term, (items)=>{
                    this.muBindData({
                        searchResults: items
                    });
                });
                this.lastKeyPress = new Date();
            }
        }, (this.searchAfterSec + 0.1) * 1000);
    }
    addSelected(item) {
        this.muWidgetFromTemplate("itemSelected", "lSelected").muBindData(item);
    }
    cleanSearch_click() {
        this.ui.cTerm.value = "";
        this.muBindData({
            searchResults: []
        });
    }
    constructor(...args){
        super(...args);
        this.searchAfterSec = 1;
        this.minTermLength = 3;
    }
}
class $adaab2a5345396be$export$63eea2f14fabd78a extends (0, $4hoex.IMuWidget) {
    name_click() {
        this.muRemoveSelf();
    }
    getId() {
        return this.muFetchData().id;
    }
}
class $adaab2a5345396be$export$e789a28955d99a8b extends (0, $4hoex.IMuWidget) {
    name_click() {
        this.muParent.addSelected(this.muFetchData());
        this.muRemoveSelf();
    }
}

});

parcelRegister("9Oenc", function(module, exports) {

$parcel$export(module.exports, "SearchSelector", () => $f3490e60c003e617$export$8b529b0ae777f42d);
$parcel$export(module.exports, "SearchSelectorItemSelected", () => $f3490e60c003e617$export$e33140e782c0d5ae);
$parcel$export(module.exports, "SearchSelectorItemSearched", () => $f3490e60c003e617$export$d18b825625817278);

var $4hoex = parcelRequire("4hoex");
function $f3490e60c003e617$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f3490e60c003e617$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f3490e60c003e617$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f3490e60c003e617$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f3490e60c003e617$var$_arrayLikeToArray(o, minLen);
}
function $f3490e60c003e617$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $f3490e60c003e617$export$8b529b0ae777f42d extends (0, $4hoex.IMuWidget) {
    constructor(el){
        super();
        this.searchAfterSec = 1;
        this.minTermLength = 3;
        el.innerHTML = '<ul mu-id="lSelected" mu-bind="selected:@foreach" class="search-selector-selected">\n    <li mu-template="itemSelected" mu-widget="SearchSelectorItemSelected">\n        <span mu-id="name" mu-bind="id::@attr.id;name"></span>\n    </li>\n</ul>\n<div class="input-group">\n    <input type="text" class="form-control" mu-id="cTerm" />\n    <div class="input-group-addon">\n        <div class="input-group-text">\n            <span class="icon-erase" mu-id="cleanSearch"></span>\n        </div>\n    </div>\n</div>\n<ul mu-id="lSearchResults" mu-bind="searchResults:@foreach" class="search-selector-search-results">\n    <li mu-template="itemSearched" mu-widget="SearchSelectorItemSearched">\n        <span mu-id="name" mu-bind="id::@attr.id;name::text"></span>\n    </li>\n</ul>\n';
        el.classList.add("search-selector");
    }
    afterIndex() {
        this.muRegisterEvent("itemAdded");
        if (!this.layout) this.layout = "MultiSelected";
        this.setLayout(this.layout);
    }
    muFetchData() {
        return this.muGetChildWidgets("lSelected").map((isw)=>isw.getId());
    }
    cTerm_keypress() {
        this.lastKeyPress = new Date();
        // console.count("keypress");
        setTimeout(()=>{
            // console.count("keypress on timer");
            const term = this.ui.cTerm.value.trim();
            if (term.length < this.minTermLength) return;
            const now = new Date();
            const diff = (now.getTime() - this.lastKeyPress.getTime()) / 1000;
            if (diff > this.searchAfterSec) {
                // console.count("loading");
                this.doCallSearch(term);
                this.lastKeyPress = new Date();
            }
        }, (this.searchAfterSec + 0.1) * 1000);
    }
    doCallSearch(term, callback = null) {
        if (!term) return;
        const fillData = (items)=>{
            this.muBindData({
                searchResults: items
            });
            if (callback) callback(items);
        };
        if (this.searchPromiseCallback) this.searchPromiseCallback(term).then(fillData);
        else if (this.searchCallback) this.searchCallback(term, fillData);
        else throw "SearchSelector: search(Promise)Callback is not defined";
    }
    addSelected(item) {
        if (this.layout == "SingleSelected") this.ui.lSelected.innerHTML = "";
        if (this.layout != "NoSelected") this.muWidgetFromTemplate("itemSelected", "lSelected").muBindData(item);
        this.muDispatchEvent("itemAdded", item);
    }
    cleanSearch_click() {
        this.ui.cTerm.value = "";
        this.muBindData({
            searchResults: []
        });
    }
    setLayout(layout) {
        this.layout = layout;
        this.muVisible(layout !== "NoSelected", "lSelected");
    }
    /* public muBindData(srcData: any) {
  } */ getValue() {
        return this.muGetChildWidgets("lSelected").map((isw)=>isw.getId());
    }
    setValue(value) {
        this.clearValue();
        if (value.length && typeof value[0] === "object") // this.muBindData({ searchResults: value });
        for(var _iterator = $f3490e60c003e617$var$_createForOfIteratorHelperLoose(value), _step; !(_step = _iterator()).done;){
            const item = _step.value;
            this.addSelected(item);
        }
        else {
            const placeholders = value.map((id)=>({
                    id: id,
                    name: "..."
                }));
            // this.muBindData({ searchResults: placeholders });
            for(var _iterator2 = $f3490e60c003e617$var$_createForOfIteratorHelperLoose(placeholders), _step2; !(_step2 = _iterator2()).done;){
                const item = _step2.value;
                this.addSelected(item);
            }
            this.doCallSearch(value, (items)=>items.forEach((item)=>this.addSelected(item)));
        }
    }
    muBindData(srcData) {
        if (Array.isArray(srcData)) this.setValue(srcData);
        else super.muBindData(srcData);
    }
    clearValue() {
        this.ui.lSelected.innerHTML = "";
    }
}
class $f3490e60c003e617$export$e33140e782c0d5ae extends (0, $4hoex.IMuWidget) {
    name_click() {
        this.muRemoveSelf();
    }
    getId() {
        return this.muFetchData().id;
    }
}
class $f3490e60c003e617$export$d18b825625817278 extends (0, $4hoex.IMuWidget) {
    name_click() {
        this.muParent.addSelected(this.muFetchData());
        this.muRemoveSelf();
    }
}

});

parcelRegister("cgG2b", function(module, exports) {

$parcel$export(module.exports, "ApprovingSchemas", () => $048a3d518705bba0$export$3af6c0da802f2d44);
$parcel$export(module.exports, "ApprovingSchemaEditor", () => $048a3d518705bba0$export$2fd4465a1817dd28);
$parcel$export(module.exports, "ApprovingSchemaEditorStep", () => $048a3d518705bba0$export$ea32f0e418478980);
$parcel$export(module.exports, "ApprovingSchemaEditorGroup", () => $048a3d518705bba0$export$666c36d4a639b4d3);
$parcel$export(module.exports, "ApprovingSchemaEditorApprover", () => $048a3d518705bba0$export$8531c48eec7d4076);
$parcel$export(module.exports, "ApprovingSchemaEditorListItem", () => $048a3d518705bba0$export$702db9aea922e838);
$parcel$export(module.exports, "ApprovingSchemaTry", () => $048a3d518705bba0$export$ba993615eeae7ee0);
$parcel$export(module.exports, "ApprovingSchemaTryGroup", () => $048a3d518705bba0$export$d48a82713303d3f3);

var $4hoex = parcelRequire("4hoex");

var $9H4va = parcelRequire("9H4va");

var $kwZWC = parcelRequire("kwZWC");

var $3cBch = parcelRequire("3cBch");

var $9fwPo = parcelRequire("9fwPo");
function $048a3d518705bba0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $048a3d518705bba0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $048a3d518705bba0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $048a3d518705bba0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $048a3d518705bba0$var$_arrayLikeToArray(o, minLen);
}
function $048a3d518705bba0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $048a3d518705bba0$export$3af6c0da802f2d44 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.cl = new (0, $9H4va.ApprovingSchemaEditorCL)(this.clUrl);
    }
    afterIndex() {
        // this.openList();
        this.container.classList.remove("loading");
        this.openTry(false);
        const r = this.router = new (0, $9fwPo.MuRouter)();
        r.pathPrefix = this.baseUrl;
        r.addRoute("edit", "/edit/<id>", (rc)=>this.openEditor(rc.parameters.id));
        r.addRoute("try", "/try/<id>", (rc)=>this.openTry(rc.parameters.id));
        r.addRoute("list", "", (rc)=>this.openList());
        r.route();
    }
    openList() {
        this.cl.getApprovingSchemaList(true, null).then((list)=>this.muBindData({
                approvingSchemaList: list
            }));
        this.showPart("list");
    }
    static{
        this.draftPrefix = "draft:";
    }
    openEditor(id) {
        if (id) {
            if (typeof id === "string" && !id.startsWith($048a3d518705bba0$export$3af6c0da802f2d44.draftPrefix)) id = parseInt(id);
            this.cl.getApprovingSchema(id, true).then((data)=>{
                this.muNamedWidget.editor.muBindData({
                    ...data,
                    id: id
                });
                this.showPart("editor");
            });
        } else {
            this.muNamedWidget.editor.muBindData({
                name: "",
                steps: [
                    {
                        groups: [
                            {
                                minimalApprovers: "1",
                                organizationApprovers: [],
                                approvers: []
                            }
                        ]
                    }
                ]
            });
            this.showPart("editor");
        }
    }
    bAddNew_click() {
        // this.openEditor(null);
        this.router.navigate("edit", {
            id: null
        });
    }
    showPart(part) {
        for(var _i = 0, _arr = [
            "list",
            "editor"
        ]; _i < _arr.length; _i++){
            let p = _arr[_i];
            this.muVisible(part === p, "p_" + p);
        }
    }
    openTry(id) {
        if (id !== false) switch(typeof id){
            case "string":
                if (!id.startsWith($048a3d518705bba0$export$3af6c0da802f2d44.draftPrefix)) id = parseInt(id);
            case "number":
                this.cl.getApprovingSchema(id, true).then((data)=>this.muNamedWidget.approvingSchemaTry.bindSchema(data));
                break;
            case "object":
                this.muNamedWidget.approvingSchemaTry.bindSchema(id);
                break;
        }
        this.muVisible(!!id, "approvingSchemaTry");
    }
}
class $048a3d518705bba0$export$2fd4465a1817dd28 extends (0, $4hoex.IMuWidget) {
    muBindData(srcData) {
        super.muBindData(srcData);
        const id = srcData["id"];
        this.isNew = !id;
        this.isDraft = typeof id === "string" && id.startsWith($048a3d518705bba0$export$3af6c0da802f2d44.draftPrefix);
        this.id = this.isDraft ? parseInt(id.substr(6)) : id;
        this.originalId = srcData.originalId || null;
        this.ui.bSaveDraft.innerText = this.isDraft ? "Ulo\u017Eit koncept" : "Ulo\u017Eit jako nov\xfd koncept";
        this.muVisible(this.isDraft, "bSave");
        this.muVisible(!!this.originalId, [
            "bSaveReplace",
            "linkOriginal"
        ]);
        if (!!this.originalId) this.ui.linkOriginal.href = this.muParent.router.makeUrl("edit", {
            id: this.originalId.toString()
        });
        this.ui.category.innerText = this.isNew ? "Nov\xe9 schvalovac\xed sch\xe9ma" : this.isDraft ? "Koncept schvalovac\xedho sch\xe9matu" : "Aktivn\xed schvalovac\xed sch\xe9ma";
    }
    linkOriginal_click() {
        this.muParent.router.navigate("edit", {
            id: this.originalId.toString()
        });
    }
    bAdd_click() {
        this.muWidgetFromTemplate("step", "steps").muBindData({});
    }
    async afterIndex() {
        this.cl = this.muParent.cl;
    }
    async bSave_click() {
        await this.cl.saveApprovingSchema(this.muFetchData(), false, null, null);
        (0, $3cBch.UiFlashMessage).instance.add("Bylo vytvo\u0159eno nov\xe9 schvalovac\xed sch\xe9ma");
        this.muParent.router.navigate("list");
    // this.muParent.openList();
    }
    async bSaveReplace_click() {
        await this.cl.saveApprovingSchema(this.muFetchData(), false, null, this.originalId);
        (0, $3cBch.UiFlashMessage).instance.add("Bylo vytvo\u0159eno nahrazeno p\u016Fvodn\xed schvalovac\xed sch\xe9ma");
        this.muParent.router.navigate("list");
    // this.muParent.openList();
    }
    async bSaveDraft_click() {
        const data = this.muFetchData();
        if (!this.isDraft) data.originalId = this.id;
        await this.cl.saveApprovingSchema(data, true, this.isDraft ? this.id : null, null);
        (0, $3cBch.UiFlashMessage).instance.add("Schvalovac\xed sch\xe9ma bylo ulo\u017Eeno jako " + (this.isDraft ? "" : " nov\xfd ") + "koncept");
        // this.muParent.openList();
        this.muParent.router.navigate("list");
    }
    bCancel_click() {
        if (confirm("Opravdu m\xe1m zav\u0159\xedt editor bez ulo\u017Een\xed zm\u011Bn?")) this.muParent.router.navigate("list");
    // this.muParent.openList();
    }
    bTry_click() {
        this.muParent.openTry(this.muFetchData());
    }
    constructor(...args){
        super(...args);
        this.originalId = null;
    }
}
class $048a3d518705bba0$export$ea32f0e418478980 extends (0, $4hoex.IMuWidget) {
    muAfterBindData(data) {
        super.muAfterBindData(data);
        // this.name_blur();
        this.cl = this.muParent.cl;
    }
    /* public noname_click() {
  	this.muVisible(false, "noname");
  	this.ui.name.focus();
  }
  	public name_keyup() { this.name_blur(); }
  	public name_blur() {
  	this.muVisible(!this.ui.name.innerText.trim(), "noname");
  } */ bAdd_click() {
        this.muWidgetFromTemplate("item", "items").muBindData({
            minApprovers: 1
        });
    }
    bRemove_click() {
        const n = this.ui.name.innerText.trim();
        if (confirm("Opravdu chcete odebrat " + (n ? "kolo " + n : "toto kolo") + "?")) this.muRemoveSelf();
    }
    bUp_click() {
        (0, $kwZWC.changeElementOrder)(this.container, -1);
    }
    bDown_click() {
        (0, $kwZWC.changeElementOrder)(this.container, 1);
    }
}
class $048a3d518705bba0$export$666c36d4a639b4d3 extends (0, $4hoex.IMuWidget) {
    afterIndex() {
        this.cl = this.muParent.muParent.cl;
        this.muNamedWidget.accountSelector.searchCallback = (term, resolve)=>this.cl.findAccounts(term).then((data)=>resolve(data));
        this.muNamedWidget.orgRoleSelector.searchCallback = (term, resolve)=>this.cl.findOrgRoles(term).then((data)=>resolve(data));
        //todo: retype
        setTimeout(()=>this.muNamedWidget.orgDivisionSelector.reload(this.muParent.muParent.orgDivisions), 0);
        this.useOtherOrgDivision_change();
    }
    muAfterBindData(data) {
    // super.muAfterBindData(data);
    // this.name_blur();
    }
    /* public noname_click() {
  	this.muVisible(false, "noname");
  	this.ui.name.focus();
  }
  	public name_keyup() { this.name_blur(); }
  	public name_blur() {
  	this.muVisible(!this.ui.name.innerText.trim(), "noname");
  } */ bAdd_click() {
        this.muWidgetFromTemplate("item", "items").muBindData({});
    }
    bRemove_click() {
        const n = this.ui.name.innerText.trim();
        if (confirm("Opravdu chcete odebrat " + (n ? "skupinu " + n : "tuto skupinu") + "?")) this.muRemoveSelf();
    }
    bUp_click() {
        (0, $kwZWC.changeElementOrder)(this.container, -1);
    }
    bDown_click() {
        (0, $kwZWC.changeElementOrder)(this.container, 1);
    }
    accountSelector_itemAdded(ev, item) {
        this.addApprover({
            name: item.name,
            accountId: item.id,
            type: "account"
        });
    }
    orgRoleSelector_itemAdded(ev, item) {
        const newItem = {
            organizationApproverId: item.id,
            organizationApproverName: item.name,
            orgDivisionId: null,
            orgDivisionName: null,
            type: "orgRole"
        };
        if (this.ui.useOtherOrgDivision.checked) {
            //todo: type
            const nodes = this.muNamedWidget.orgDivisionSelector.getSelectedNodes();
            const node = nodes.length ? nodes[0] : null;
            newItem.orgDivisionId = node.key;
            newItem.orgDivisionName = node.title;
        }
        this.addApprover(newItem);
    }
    addApprover(item) {
        const field = item.type == "orgRole" ? "organizationApprover" : "approver";
        const newItem = {
            ...item
        };
        // newItem[item.type + "Id"] = item.id;
        this.muWidgetFromTemplate(field, field + "s").muBindData(newItem);
    }
    useOtherOrgDivision_change() {
        const useOther = this.ui.useOtherOrgDivision.checked;
        this.muVisible(useOther, "orgDivisionSelector");
        if (useOther) this.muNamedWidget.orgDivisionSelector.openModal();
    }
}
class $048a3d518705bba0$export$8531c48eec7d4076 extends (0, $4hoex.IMuWidget) {
    muAfterBindData(data) {
        this.data = data;
        let n;
        switch(this.type){
            case "orgRole":
                n = "Role " + data.organizationApproverName + (data.orgDivisionId ? " pro organiza\u010Dn\xed jednotku " + data.orgDivisionName : "");
                break;
            case "account":
                n = /* "Uživatel " + */ data.name;
                break;
        }
        this.ui.displayName.innerText = n;
    }
    muFetchData() {
        return this.data;
    }
    bRemove_click() {
        if (confirm("Opravdu chcete odebrat schvalovatele " + this.ui.displayName.innerText + "?")) this.muRemoveSelf();
    }
}
class $048a3d518705bba0$export$702db9aea922e838 extends (0, $4hoex.IMuWidget) {
    //todo: new mu widget
    bEdit_click(ev) {
        // this.muParent.openEditor(this.id);
        if (!(0, $kwZWC.isOpenInNew)(ev)) {
            this.muParent.router.navigate("edit", {
                id: this.id
            });
            ev.preventDefault();
            return false;
        }
        return true;
    }
    name_click(ev) {
        // this.muParent.openEditor(this.id);
        return this.bEdit_click(ev.target, ev);
    }
    bTry_click() {
        // this.muParent.openTry(this.id);
        this.muParent.router.navigate("try", {
            id: this.id
        });
    }
    async bRemove_click() {
        if (confirm("Opravdu m\xe1m smazat koncept " + this.ui.name.innerText + "?")) {
            await this.muParent.cl.removeDraft(this.id);
            this.muParent.openList();
        }
    }
    async bActivate_click() {
        await this.muParent.cl.setApprovingSchemaActive(this.id, true);
        this.muParent.openList();
    }
    async bDeactivate_click() {
        await this.muParent.cl.setApprovingSchemaActive(this.id, false);
        this.muParent.openList();
    }
    muAfterBindData(data) {
        let icon = "";
        let state = "";
        this.muVisible(false, [
            "bRemove",
            "bActivate",
            "bDeactivate"
        ]);
        if (data.id.toString().startsWith($048a3d518705bba0$export$3af6c0da802f2d44.draftPrefix)) {
            icon = "checked-off";
            this.ui.id.innerText = data.id.toString().substr(6);
            state = "Koncept";
            this.muVisible(true, "bRemove");
        } else if (data.active) {
            icon = "yes";
            state = "Aktivn\xed";
            this.muVisible(true, "bDeactivate");
        } else {
            icon = "no";
            state = "Neaktivn\xed";
            this.muVisible(true, "bActivate");
        }
        this.ui.icon.className = "icon-" + icon;
        this.ui.state.innerText = state;
    }
    getUrl(id, ev, name) {
        return this.muParent.router.makeUrl(name, {
            id: id
        });
    }
}
class $048a3d518705bba0$export$ba993615eeae7ee0 extends (0, $4hoex.IMuWidget) {
    bindSchema(schema) {
        this.doCheck = false;
        this.schema = schema;
        this.groupAccountIds = {};
        this.accounts = {};
        let newGroupId = -1;
        for(var _iterator = $048a3d518705bba0$var$_createForOfIteratorHelperLoose(schema.steps), _step; !(_step = _iterator()).done;){
            const step = _step.value;
            for(var _iterator2 = $048a3d518705bba0$var$_createForOfIteratorHelperLoose(step.groups), _step2; !(_step2 = _iterator2()).done;){
                const group = _step2.value;
                if (!group.id) group.id = newGroupId--;
            }
        }
        this.muBindData(schema);
    }
    afterIndex() {
        // odložit načtení ať se první načte seznam schémat
        setTimeout(()=>{
            this.muParent.cl.getOrgDivisions().then((data)=>this.muNamedWidget.orgDivision.bindTree(data));
            this.muParent.cl.getOrgProjects().then((data)=>this.muNamedWidget.orgProject.bindTree(data));
        }, 100);
    }
    getAccountsForGroupId(groupId) {
        if (this.groupAccountIds[groupId]) return this.groupAccountIds[groupId].map((accountId)=>this.accounts[accountId]);
        return [];
    }
    bTry_click() {
        this.doCheck = true;
        const orgDivisionId = parseInt(this.muNamedWidget.orgDivision.getValue());
        const orgProjectId = parseInt(this.muNamedWidget.orgProject.getValue());
        if (!orgDivisionId && !orgProjectId) {
            (0, $3cBch.UiFlashMessage).instance.add("Je pot\u0159eba vybrat organiza\u010Dn\xed jednotku a/nebo projekt.");
            return;
        }
        this.muParent.cl.getApproversForSchema(this.schema, orgDivisionId, orgProjectId).then((data)=>{
            this.accounts = (0, $kwZWC.indexBy)(data.accounts, "id");
            this.groupAccountIds = data.groupAccountIds;
            this.muBindData(this.schema);
        });
    }
    bClose_click() {
        this.muParent.openTry(false);
    }
}
class $048a3d518705bba0$export$d48a82713303d3f3 extends (0, $4hoex.IMuWidget) {
    muAfterBindData(data) {
        super.muAfterBindData(data);
        if (this.muParent.muParent.doCheck) this.ui.name.className = "approving-schema-editor-group__name" + (this.ui.approverAccounts.childElementCount < data.minimalApprovers ? "--invalid" : "--valid");
    }
} // export class Router extends Rou

});
parcelRegister("9H4va", function(module, exports) {

$parcel$export(module.exports, "ApprovingSchemaEditorCL", () => $3f6a3d01c8312fb4$export$5ada595cf9c1c10b);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $3f6a3d01c8312fb4$export$5ada595cf9c1c10b extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/app-components-blackbox-approvingschemaeditor"){
        super(url);
    }
    saveApprovingSchema(approvingSchema, asDraft, id, originalId) {
        return this.callMethod("saveApprovingSchema", arguments, {
            "rawResult": false
        });
    }
    getApproversForSchema(approvingSchema, orgDivisionId, orgProjectId) {
        return this.callMethod("getApproversForSchema", arguments, {
            "rawResult": false
        });
    }
    removeDraft(id) {
        return this.callMethod("removeDraft", arguments, {
            "rawResult": false
        });
    }
    setApprovingSchemaActive(id, active) {
        return this.callMethod("setApprovingSchemaActive", arguments, {
            "rawResult": false
        });
    }
    getApprovingSchema(id, addNames) {
        return this.callMethod("getApprovingSchema", arguments, {
            "rawResult": false
        });
    }
    getApprovingSchemaList(addDrafts = false, active = null) {
        return this.callMethod("getApprovingSchemaList", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});

parcelRegister("9fwPo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MuRouter = void 0;
class $01bce302e9718615$var$MuRouter {
    addRoute(name, re, callback) {
        const route = {
            callback: callback,
            name: name,
            reText: re
        };
        $01bce302e9718615$var$MuRouter.compileRe(route);
        this.routes[name] = route;
        return this;
    }
    static compileRe(route) {
        const defaultReChunk = "[^/?#]*";
        let p = 0;
        let lastP = 0;
        let re = "";
        let s;
        const rete = route.reText;
        route.chunks = [];
        route.paramNames = [];
        while(true){
            p = rete.indexOf("<", lastP);
            if (p < 0) {
                s = rete.substr(lastP);
                if (s) {
                    route.chunks.push(s);
                    re += s;
                }
                break;
            } else {
                s = rete.substring(lastP, p);
                if (s) {
                    route.chunks.push(s);
                    re += s;
                }
            }
            lastP = p + 1;
            p = rete.indexOf(">", lastP);
            if (p < 0) throw new Error("Missing parametr end");
            let chunk = rete.substring(lastP, p);
            const p1 = chunk.indexOf(" ");
            let reChunk;
            let name;
            if (p1 >= 0) {
                reChunk = chunk.substr(p1 + 1);
                name = chunk.substr(0, p1);
            } else {
                reChunk = defaultReChunk;
                name = chunk;
            }
            route.chunks.push({
                name: name
            });
            re += "(" + reChunk + ")";
            route.paramNames.push(name);
            lastP = p + 1;
        }
        /* const re = route.reText.replace(/<[^>]+>/, (chunk) => {
            const p = chunk.indexOf(" ");
            let reChunk;
            let name;
            if (p >= 0)
            {
                reChunk = chunk.substr(p + 1);
                name = chunk.substr(0, p);
            }
            else
            {
                reChunk = defaultReChunk;
                name = chunk;
            }
            route.chunkNames.push(name);
            return reChunk;
        }); */ route.re = new RegExp(re);
    }
    route(location = null) {
        if (!location) location = window.location;
        if (this.pathPrefix) {
            if (typeof location != "string") location = location.pathname + location.search + location.hash;
            location = location.substr(this.pathPrefix.length);
        }
        if (typeof location === "string") {
            let p = location.indexOf("?");
            location = {
                pathname: p >= 0 ? location.substr(0, p) : location,
                search: p >= 0 ? location.substr(p) : "",
                hash: ""
            };
        }
        for(let routeName in this.routes){
            const route = this.routes[routeName];
            const m = route.re.exec(location.pathname);
            if (!m) continue;
            const res = this.parseQueryString(location.search);
            for(let i = 0; i < m.length; i++)if (i > 0) res[route.paramNames[i - 1]] = decodeURIComponent(m[i]);
            this.updatePersistent(res);
            this.lastName = route.name;
            route.callback({
                parameters: res,
                routeName: routeName
            });
            return route;
        // console.log(m);
        }
        return null;
    }
    makeUrl(name, currParams) {
        let url = "";
        let used = [];
        const params = Object.assign({}, this.persistentValues);
        for(const k in currParams)if (currParams[k] !== null) params[k] = currParams[k];
        if (!(name in this.routes)) throw new Error("No route '" + name + "'");
        let route = this.routes[name];
        for (const chunk of route.chunks)if (typeof chunk == "string") url += chunk;
        else {
            url += chunk.name in params ? encodeURIComponent(params[chunk.name]) : "";
            used.push(chunk.name);
        }
        const q = Object.keys(params).filter((k)=>used.indexOf(k) < 0).sort().map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
        if (q) url += "?" + q;
        return this.pathPrefix + url;
    }
    getName(name) {
        if (name) this.lastName = name;
        return this.lastName;
    }
    push(name, params = {}) {
        name = this.getName(name);
        this.updatePersistent(params);
        history.pushState({}, null, this.makeUrl(name, params));
    }
    pushUpdate(name, params = {}) {
        name = this.getName(name);
        this.updatePersistent(params, true);
        history.pushState({}, null, this.makeUrl(name, Object.assign(Object.assign({}, this.lastParameters), params)));
    }
    replace(name, params = {}) {
        name = this.getName(name);
        this.updatePersistent(params);
        history.replaceState({}, null, this.makeUrl(name, params));
    }
    update(name, params = {}) {
        name = this.getName(name);
        this.updatePersistent(params, true);
        history.replaceState({}, null, this.makeUrl(name, Object.assign(Object.assign({}, this.lastParameters), params)));
    }
    navigate(name, params = {}) {
        name = this.getName(name);
        this.push(name, params);
        this.routes[name].callback({
            parameters: params,
            routeName: name
        });
    }
    parseQueryString(queryString) {
        var res = {};
        if (queryString.startsWith("?")) queryString = queryString.substr(1);
        for (let item of queryString.split("&")){
            if (!item) continue;
            const p = item.indexOf("=");
            let k;
            let v;
            if (p >= 0) {
                k = decodeURIComponent(item.substr(0, p));
                v = decodeURIComponent(item.substr(p + 1));
            } else {
                k = decodeURIComponent(item);
                v = true;
            }
            res[k] = v;
        }
        return res;
    }
    constructor(){
        this.routes = {};
        this.persistentKeys = [];
        this.persistentValues = {};
        this.pathPrefix = "";
        this.lastParameters = {};
        this.lastName = "";
        window.onpopstate = (ev)=>this.route(document.location);
    }
    updatePersistent(res, patch = false) {
        for (let k of this.persistentKeys)if (k in res) {
            const v = res[k];
            if (v !== null) this.persistentValues[k] = v;
            else delete this.persistentValues[k];
        }
        if (patch) for(let k in res){
            const v = res[k];
            if (v !== null) this.lastParameters[k] = v;
            else delete this.lastParameters[k];
        }
        else this.lastParameters = res;
    }
    getParameters() {
        return this.lastParameters;
    }
    prepareAnchor(a, name, params, cancelBubble = false) {
        const fullParams = Object.assign(Object.assign({}, this.persistentValues), params);
        if (a instanceof HTMLAnchorElement) a.href = this.makeUrl(name, params);
        a.addEventListener("click", (ev)=>{
            ev.preventDefault();
            if (cancelBubble) ev.stopPropagation();
            this.navigate(name, fullParams);
        });
    }
}
module.exports.MuRouter = $01bce302e9718615$var$MuRouter;

});


parcelRegister("aDZtI", function(module, exports) {

$parcel$export(module.exports, "AccountRoles", () => $b839b5b35ece93c0$export$4e83fe4b3d638ddd);
$parcel$export(module.exports, "AccountRolesUnderling", () => $b839b5b35ece93c0$export$3c6b46f7832496ea);

var $4hoex = parcelRequire("4hoex");

var $kwZWC = parcelRequire("kwZWC");

var $5d8um = parcelRequire("5d8um");
class $b839b5b35ece93c0$export$4e83fe4b3d638ddd extends (0, $5d8um.TicketFormField) {
    afterIndex() {
        setTimeout(()=>{
            this.ui.selected = this.ui.selectedContainer.getElementsByTagName("select")[0];
            if (!this.ui.selected) return;
            this.ui.cmd = this.container.querySelector('input[type="hidden"]');
            if (this.ui.selected) {
                // this.ui.selected.selectize.on('change', this.muGetMethodCallback('fillMainList'));
                this.ui.selected.selectize.on("change", ()=>{
                    this.fillMainList();
                    this.updateWidget();
                });
                if (this.useMainFlag) {
                    const val = this.ui.mainId.value;
                    this.fillMainList();
                    if (val) this.ui.mainIdSelect.value = "." + val;
                    this.ui.mainId.value = val;
                }
            }
            this.updateWidget();
        // console.log(await getBaseCL().getUnderlings(6));
        }, 200);
    }
    getSelected() {
        return this.ui.selected.selectize.getValue();
    }
    fillMainList() {
        if (!this.useMainFlag) return;
        var oldValue = this.ui.mainIdSelect.value;
        var ls = this.getSelected();
        for(var i = this.ui.mainIdSelect.options.length - 1; i >= 0; i--)this.ui.mainIdSelect.remove(i);
        var opt = document.createElement("option");
        opt.text = "Nevybr\xe1n";
        opt.value = "";
        this.ui.mainIdSelect.options.add(opt);
        for(var i = 0, l = ls.length; i < l; i++){
            opt = document.createElement("option");
            opt.text = this.ui.selected.selectize.options[ls[i]].name.name;
            opt.value = ls[i];
            opt.selected = oldValue == opt.value;
            this.ui.mainIdSelect.options.add(opt);
        }
        this.mainIdSelect_change();
    }
    mainIdSelect_change() {
        this.ui.mainId.value = this.ui.mainIdSelect.value ? this.ui.mainIdSelect.value.substr(1) : "";
    }
    callCmd(cmd, param = null) {
        this.ui.cmd.value = cmd + (param ? ":" + JSON.stringify(param) : "");
        this.ui.cmd.form.elements["btSubmit"].click();
    }
    bTake_click() {
        this.callCmd("take");
    }
    bLeave_click() {
        this.callCmd("leave");
    }
    updateWidget() {
        const selected = this.getSelected();
        const min2 = selected.length > 1;
        const inSelected = selected.some((id)=>id.substr(1) == this.loggedAccountId.toString());
        if (this.allowLeaveRole) this.muVisible(min2 && inSelected, "bLeave");
        if (this.allowTakeRole) this.muVisible(min2 && inSelected, "bTake");
        if (this.allowDelegate) this.muVisible(inSelected, "bDelegate");
    }
    bDelegate_click() {
        (0, $kwZWC.getBaseCL)().getOrgRelatedAccounts(this.loggedAccountId).then((data)=>{
            // if (!data.length) UiFlashMessage.instance.add("Nemáte podřízené");
            this.muBindData(data);
        });
    }
    delegateTo(accountId) {
        this.callCmd("delegate", accountId);
    }
    bCloseUnderlings_click() {
        this.muVisible(false, "mUnderlings");
    }
    constructor(...args){
        super(...args);
        this.allowLeaveRole = false;
        this.allowTakeRole = false;
        this.allowDelegate = false;
        this.useMainFlag = false;
    }
}
class $b839b5b35ece93c0$export$3c6b46f7832496ea extends (0, $4hoex.IMuWidget) {
    name_click() {
        this.muParent.delegateTo(this.accountId);
    }
}

});
parcelRegister("5d8um", function(module, exports) {

$parcel$export(module.exports, "TicketFormField", () => $9d66d480a631e40b$export$4d37a8894df96d37);

var $4hoex = parcelRequire("4hoex");
class $9d66d480a631e40b$export$4d37a8894df96d37 extends (0, $4hoex.IMuWidget) {
    static{
        this.CollapsedNo = 0;
    }
    static{
        this.CollapsedDefaultYes = 1;
    }
    static{
        this.CollapsedDefaultNo = 2;
    }
    beforeIndex() {
        if (this.collapsed !== $9d66d480a631e40b$export$4d37a8894df96d37.CollapsedNo) {
            const bExpand = this.container.querySelector('[mu-id="bExpand"]');
            if (!bExpand) {
                const label = this.container.querySelector('[mu-id="label"]');
                if (label) label.innerHTML = '<span mu-id="bExpand" class="ticket-form-field--expander"></span>' + label.innerHTML;
            }
        }
    }
    afterIndex() {
        super.afterIndex();
        if (this.collapsed !== $9d66d480a631e40b$export$4d37a8894df96d37.CollapsedNo) this.setOpen(this.collapsed !== $9d66d480a631e40b$export$4d37a8894df96d37.CollapsedDefaultYes);
    }
    setOpen(isOpen) {
        if (isOpen !== undefined) this.container.classList.toggle("ticket-form-field__collapsed", !isOpen);
        else this.container.classList.toggle("ticket-form-field__collapsed");
    }
    bExpand_click() {
        this.setOpen();
        // event.stopPropagation();
        event.preventDefault();
    }
    constructor(...args){
        super(...args);
        this.collapsed = $9d66d480a631e40b$export$4d37a8894df96d37.CollapsedDefaultYes;
    }
}

});


parcelRegister("5yCCu", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $c80b683ca6009a9c$export$e980dfbc2840e8bc);

var $4hoex = parcelRequire("4hoex");

var $kwZWC = parcelRequire("kwZWC");
class $c80b683ca6009a9c$export$e980dfbc2840e8bc extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.container.innerHTML += '<span class="icon" mu-id="bHtml">&nbsp;</span><span class="share-button--menu"><span mu-id="bMarkdown">Markdown</span>';
    }
    afterIndex() {
        if (!this.container.className) this.container.className = "share-button";
        if (!this.container.title) this.container.title = "Zkop\xedrovat odkaz na po\u017Eadavek";
    }
    bMarkdown_click() {
        this.copyLink("md");
        event.cancelBubble = true;
        event.preventDefault();
        return false;
    }
    bHtml_click() {
        this.copyLink("html");
        event.cancelBubble = true;
    }
    copyLink(mode) {
        const content = this.html || this.text || document.title;
        const type = this.html ? "html" : "text";
        const link = this.link || document.location.toString();
        let el;
        switch(mode){
            case "html":
                const a = document.createElement("a");
                a.href = link;
                if (type == "html") a.innerHTML = content;
                else a.innerText = content;
                el = a;
                break;
            case "md":
                el = document.createElement("span");
                el.innerText = "[" + content + "](" + link + ")";
                break;
        }
        (0, $kwZWC.copyToClipoard)(el.outerHTML, "html");
    }
}

});

parcelRegister("60pHU", function(module, exports) {

$parcel$export(module.exports, "TPFAttaches", () => $fdbf80648b17935d$export$ee29cfbfe3669188);
$parcel$export(module.exports, "TPFAttache", () => $fdbf80648b17935d$export$59da74e3ce627963);

var $4hoex = parcelRequire("4hoex");
class $fdbf80648b17935d$export$ee29cfbfe3669188 extends (0, $4hoex.IMuWidget) {
    addDeleted(id) {
        this.ui.deleteIds.value += "," + id;
    }
}
class $fdbf80648b17935d$export$59da74e3ce627963 extends (0, $4hoex.IMuWidget) {
    bDelete_click() {
        if (confirm("smazat vybran\xfd soubor?")) {
            this.muParent.addDeleted(this.id);
            this.muRemoveSelf();
        }
    }
}

});

parcelRegister("kvCpk", function(module, exports) {

$parcel$export(module.exports, "TreeSelector", () => $0dc006830766a361$export$2a645f9e68a39673);
$parcel$export(module.exports, "TreeSelectorItem", () => $0dc006830766a361$export$cc39f5c909f09949);

var $4hoex = parcelRequire("4hoex");
function $0dc006830766a361$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0dc006830766a361$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0dc006830766a361$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0dc006830766a361$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0dc006830766a361$var$_arrayLikeToArray(o, minLen);
}
function $0dc006830766a361$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $0dc006830766a361$export$2a645f9e68a39673 extends (0, $4hoex.IMuWidget) {
    setDisabled(val) {
        this._disabled = val;
        this.container.classList.toggle("tree-selector__disabled", val);
    }
    getDisabled() {
        return this._disabled;
    }
    beforeIndex() {
        this.container.innerHTML = (this.inModal ? '<div class="tree-selector--value" mu-id="value"></div><div class="' + (this.useModalClass ? "modal-b" : "") + '" mu-id="modal" style="display: none"><div class="' + (this.useModalClass ? "modal-i" : "") + '">' : "") + '<div class="tree-selector--search"><span>Hledat</span><input type="search" mu-id="searchText" />' + '<span mu-id="bSearchClear" class="icon-erase icon-24 cursor-pointer"></span>' + (this.inModal ? '<span class="icon-close icon-24 cursor-pointer" mu-id="bCloseModal"></span>' : "") + '</div><div class="tree-selector--list" mu-id="list" tabindex="0">' + '<div class="tree-selector--item" mu-template="item" mu-widget="TreeSelectorItem">' + '<span class="tree-selector--item--collapse-button" mu-id="bCollapse"></span> ' + '<span class="tree-selector--item--title" mu-id="title"></span>' + "</div></div>" + (this.inModal ? '<div class="buttons"><span class="btn btn-default" mu-id="bSelectNull">Zru\u0161it v\xfdb\u011Br</span></div></div></div>' : "");
        this.muRegisterEvent("change");
        this.container.className = "tree-selector";
    // this.container.tabIndex = 0;
    }
    afterIndex() {
        this.setSelected(this.value);
    }
    value_click() {
        if (!this._disabled) {
            this.openModal();
            this.ui.searchText.focus();
        }
    }
    collapseFromLevel(level) {
        for(var _iterator = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.items), _step; !(_step = _iterator()).done;){
            const item = _step.value;
            item.setCollapsed(item.level >= level);
        }
    }
    searchText_keypress() {
        const searchCallback = this.searchCallback;
        if (searchCallback) {
            this.lastKeyPress = new Date();
            setTimeout(()=>{
                // console.count("keypress on timer");
                const term = this.ui.searchText.value.trim();
                if (term.length < this.minTermLength) return;
                const now = new Date();
                const diff = (now.getTime() - this.lastKeyPress.getTime()) / 1000;
                if (diff > this.searchAfterSec) {
                    // console.count("loading");
                    searchCallback(term, (items)=>{
                        this.bindTree(items);
                        this.search(this.ui.searchText.value);
                    });
                    this.lastKeyPress = new Date();
                }
            }, (this.searchAfterSec + 0.1) * 1000);
        } else setTimeout(()=>this.search(this.ui.searchText.value));
    }
    bSearchClear_click() {
        this.ui.searchText.value = "";
        this.searchText_keypress();
    }
    modal_click(ev) {
        ev.stopPropagation();
    }
    list_keyup(ev) {
        let sp = true;
        switch(ev.code){
            case "ArrowUp":
                this.move(-1);
                break;
            case "ArrowDown":
                this.move(1);
                break;
            case "ArrowRight":
                this.getItem()?.setCollapsed(false);
                break;
            case "ArrowLeft":
                this.getItem()?.setCollapsed(true);
                break;
            default:
                sp = false;
                break;
        }
        if (sp) ev.stopPropagation();
    }
    bindTree(srcData) {
        this.ui.list.innerHTML = "";
        const rooItem = this.prepareData(srcData);
        const bindTreeNode = (item, level, parentWidget = null)=>{
            if (parentWidget) parentWidget.children = [];
            for(var _iterator2 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(item.children), _step2; !(_step2 = _iterator2()).done;){
                let child = _step2.value;
                const w = this.muWidgetFromTemplate("item", "list", {
                    ...child,
                    level: level
                });
                w.parent = parentWidget;
                w.update();
                if (parentWidget) parentWidget.children.push(w);
                this.items.push(w);
                // console.log(w.title);
                bindTreeNode(child, level + 1, w);
                if (this.afterItemRender) this.afterItemRender(w);
            }
        };
        bindTreeNode(rooItem, 0);
        this.setSelected(this.value, false);
    }
    prepareData(srcData) {
        let itemsById = {};
        this.items = [];
        const indexById = (items, parentId)=>{
            items.map((item)=>{
                itemsById[item.id] = item;
                if (!("parentId" in item)) item.parentId = parentId;
                if ("children" in item) indexById(item.children, item.id);
            });
        };
        indexById(srcData, null);
        let rootItem = {
            id: null,
            title: ""
        };
        let itemsByParentId = {};
        for(let k in itemsById){
            const item = itemsById[k];
            if (!(item.parentId in itemsByParentId)) itemsByParentId[item.parentId] = [];
            itemsByParentId[item.parentId].push(item);
        }
        const makeTreeNode = (item)=>{
            item.children = [];
            if (item.id in itemsByParentId) for(var _iterator3 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(itemsByParentId[item.id]), _step3; !(_step3 = _iterator3()).done;){
                let child = _step3.value;
                item.children.push(child);
                makeTreeNode(child);
            }
        };
        makeTreeNode(rootItem);
        return rootItem;
    }
    setSelected(id, fireEvent = true) {
        let selectedItem = null;
        for(var _iterator4 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.items), _step4; !(_step4 = _iterator4()).done;){
            let item = _step4.value;
            item.markSelected(item.id == id);
            if (item.id == id) selectedItem = item;
        }
        this.value = id;
        if (this.ui.value) {
            this.ui.value.innerText = id ? selectedItem?.title ?? this.unknownTitle : this.nullTitle;
            this.ui.value.classList.toggle("tree-selector--value__empty", !selectedItem);
        }
        this.openModal(false);
        if (fireEvent) this.muDispatchEvent("change", id, selectedItem);
    }
    getValue() {
        return this.value;
    }
    move(direction) {
        let p = this.getItemIndex();
        p += direction;
        while(p >= 0 && p < this.items.length){
            if (this.items[p].isVisible()) {
                this.setSelected(this.items[p].id);
                break;
            }
            p += direction;
        }
    }
    getItemIndex() {
        return this.items.findIndex((item)=>item.id == this.value);
    }
    getItem() {
        return this.items.find((item)=>item.id == this.value);
    }
    getSelectedItemRecursive() {
        let res = [];
        const startItem = this.getItem();
        const addSubItems = (item)=>{
            for(var _iterator5 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(item.children), _step5; !(_step5 = _iterator5()).done;){
                const subItem = _step5.value;
                res.push(subItem);
                addSubItems(subItem);
            }
        };
        if (startItem) {
            res.push(startItem);
            addSubItems(startItem);
        }
        return res;
    }
    search(term) {
        const matchItems = [];
        if (term) {
            for(var _iterator6 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.items), _step6; !(_step6 = _iterator6()).done;){
                const item = _step6.value;
                item.searchStatus = item.match(term) ? "match" : "no";
                if (item.searchStatus == "match") matchItems.push(item);
            }
            for(var _i = 0, _matchItems = matchItems; _i < _matchItems.length; _i++){
                const item = _matchItems[_i];
                let pItem = item.parent;
                while(pItem){
                    if (pItem.searchStatus === "no") pItem.searchStatus = "path";
                    pItem = pItem.parent;
                }
            }
            for(var _iterator7 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.items), _step7; !(_step7 = _iterator7()).done;){
                const item = _step7.value;
                item.update();
            }
        } else for(var _iterator8 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.items), _step8; !(_step8 = _iterator8()).done;){
            const item = _step8.value;
            item.searchStatus = null;
            item.hide(false);
            item.update(true);
        }
    }
    openModal(visible = true) {
        if (this.ui.modal) this.muVisible(visible, "modal");
    }
    bCloseModal_click(ev) {
        this.openModal(false);
    // ev.stopPropagation();
    }
    bSelectNull_click() {
        this.setSelected(null);
    }
    muFetchData() {
        return this.value;
    }
    muBindData(srcData) {
        this.setSelected(srcData);
    }
    constructor(...args){
        super(...args);
        this.items = [];
        // public itemsById : Record<string, TreeItem> = {};
        this.value = null;
        this.inModal = false;
        this.nullTitle = "Nen\xed vybr\xe1no";
        this.unknownTitle = "Nezn\xe1m\xe1 polo\u017Eka";
        this.searchCallback = null;
        this._disabled = false;
        this.useModalClass = true;
        this.afterItemRender = null;
        this.searchAfterSec = 1;
        this.minTermLength = 3;
    }
}
class $0dc006830766a361$export$cc39f5c909f09949 extends (0, $4hoex.IMuWidget) {
    match(term) {
        return this.title.toLowerCase().includes(term.toLowerCase());
    }
    update(force = false) {
        this.ui.title.innerText = this.title;
        this.container.style.marginLeft = this.level + "em";
        if (this.searchStatus) {
            this.container.style.display = this.searchStatus === "no" ? "none" : null;
            this.container.classList.toggle("tree-selector--item__search-match");
            this.ui.bCollapse.className = "tree-selector--item--collapse-button tree-selector--item--collapse-button__search-" + this.searchStatus;
        } else if (force) this.setCollapsed(this.collapsed, force);
        else this.updateCollapseIcon();
    }
    setCollapsed(collapsed, force = false) {
        if (this.collapsed != collapsed || force) {
            this.collapsed = collapsed;
            for(var _iterator9 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.children), _step9; !(_step9 = _iterator9()).done;){
                let child = _step9.value;
                child.hide(this.collapsed);
            }
            this.updateCollapseIcon();
        }
    }
    hide(hidden) {
        const isHidden = hidden; // || this.collapsed;
        //todo: class pro animaci
        this.container.style.display = isHidden ? "none" : null;
        for(var _iterator10 = $0dc006830766a361$var$_createForOfIteratorHelperLoose(this.children), _step10; !(_step10 = _iterator10()).done;){
            let child = _step10.value;
            child.hide(isHidden);
        }
    }
    updateCollapseIcon() {
        this.ui.bCollapse.className = "tree-selector--item--collapse-button" + (this.collapsed ? " tree-selector--item--collapse-button__collapsed" : "");
    }
    bCollapse_click() {
        if (this.searchStatus == null) this.setCollapsed(!this.collapsed);
    }
    title_click() {
        this.muParent.setSelected(this.id);
    }
    markSelected(isSelected) {
        this.container.classList.toggle("tree-selector--item__selected", isSelected);
    }
    isVisible() {
        return this.container.style.display != "none";
    }
    constructor(...args){
        super(...args);
        this.collapsed = false;
        this.children = [];
    }
}

});

parcelRegister("3n82a", function(module, exports) {

$parcel$export(module.exports, "MultiUpload", () => $2d4ebd2e76e197c2$export$7978cca95cd62e);
$parcel$export(module.exports, "MutiUploadItem", () => $2d4ebd2e76e197c2$export$c69e88c5f68cd974);

var $dMN2n = parcelRequire("dMN2n");
function $2d4ebd2e76e197c2$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2d4ebd2e76e197c2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2d4ebd2e76e197c2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2d4ebd2e76e197c2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2d4ebd2e76e197c2$var$_arrayLikeToArray(o, minLen);
}
function $2d4ebd2e76e197c2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $2d4ebd2e76e197c2$export$7978cca95cd62e extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        if (this.single) {
            this.container.classList.add("singleupload");
            this.container.innerHTML = `
				<label>
					<input type="file" mu-id="singleFile" />
					<div mu-id="prompt" class="singleupload--item--prompt">Klikn\u{11B}te nebo p\u{159}et\xe1hn\u{11B}te p\u{159}\xedlohy</div>
					<div mu-id="filename" class="singleupload--file-name">-</div>
					<progress mu-id="progress"></progress>
				</label>
			`;
        } else {
            this.container.innerHTML = '<div mu-id="items"><div mu-template="item" mu-widget="MutiUploadItem" class="multiupload--item"><span class="multiupload--item--remove btn btn-sm btn-danger" mu-id="bRemove">Odebrat</span><div mu-id="content" class="multiupload--item--content" mu-bind="content:@foreach"><div mu-template="." class="multiupload--item--content--file" mu-widget="."><span mu-bind="name"></span></div></div>' + (this.container.innerHTML || '<input type="file" multiple mu-id="input" />') + '<div mu-id="prompt" class="multiupload--item--prompt">Klikn\u011Bte nebo p\u0159et\xe1hn\u011Bte p\u0159\xedlohy</div>' + "</div></div>" + '<progress mu-id="progress"></progress>';
            this.container.classList.add("multiupload");
        }
        this.muRegisterEvent("uploadStatus", "change");
    }
    afterIndex() {
        if (!this.single) this.addItem();
        this.muVisible(false, "progress");
    }
    singleFile_change() {
        this.ui.filename.innerText = this.ui.singleFile.files.length > 0 ? this.ui.singleFile.files[0].name : "-";
    }
    addItem() {
        const current = this.ui.items.firstElementChild;
        // @ts-ignore
        if (current) current.widget.lock();
        this.muWidgetFromTemplate("item", "items", {}, "first");
        this.muDispatchEvent("change");
    }
    sendToBackend(prepareCallback) {
        this.muVisible(true, "progress");
        return new Promise((resolve, reject)=>{
            const uctxs = this.getAllFiles().map((file)=>({
                    url: "",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/octet-stream"
                    },
                    res: null,
                    status: "wait",
                    resIsJson: true,
                    file: file
                }));
            const checkFinal = ()=>{
                const res = {
                    total: uctxs.length,
                    done: uctxs.filter((uc)=>[
                            "ok",
                            "error"
                        ].includes(uc.status)).length,
                    contexts: uctxs
                };
                if (res.done == res.total) {
                    resolve(uctxs);
                    this.muVisible(false, "progress");
                }
                this.muDispatchEvent("uploadStatus", res);
                this.ui.progress.max = res.total.toString();
                this.ui.progress.value = res.done.toString();
            };
            checkFinal();
            for(var _iterator = $2d4ebd2e76e197c2$var$_createForOfIteratorHelperLoose(uctxs), _step; !(_step = _iterator()).done;){
                const uctx = _step.value;
                prepareCallback(uctx, ()=>new Promise((resolve, reject)=>{
                        fetch(uctx.url, {
                            method: uctx.method,
                            headers: uctx.headers,
                            body: uctx.file
                        }).then(async (res)=>{
                            uctx.status = "ok";
                            uctx.res = uctx.resIsJson ? await res.json() : await res.text();
                            resolve(uctx);
                            checkFinal();
                        }, (reason)=>{
                            uctx.status = "error";
                            uctx.error = reason;
                            reject(uctx);
                            checkFinal();
                        });
                        checkFinal();
                        uctx.status = "sending";
                    }));
            }
        });
    }
    getAllFiles() {
        return this.single ? Array.from(this.ui.singleFile.files) : this.muGetChildWidgets("items").reduce((p, n)=>[
                ...p,
                ...n.getAllFiles()
            ], []);
    }
    onRemove() {
        this.muDispatchEvent("change");
    }
    clear() {
        this.ui.items.innerHTML = "";
        this.addItem();
    }
    constructor(...args){
        super(...args);
        this.single = false;
    }
}
class $2d4ebd2e76e197c2$export$c69e88c5f68cd974 extends (0, $dMN2n.MuWidget) {
    lock(isLocked = true) {
        this.container.classList.toggle("multiupload--item__locked", isLocked);
    }
    afterIndex() {
        this.lock(false);
    }
    bRemove_click() {
        this.muRemoveSelf();
        this.muParent.onRemove();
    }
    input_change() {
        this.lock();
        this.muBindData({
            content: this.getAllFiles().map((file)=>({
                    name: file.name
                }))
        });
        this.muParent.addItem();
    }
    getAllFiles() {
        // @ts-ignore
        return Array.from(this.ui.input.files);
    }
}

});

parcelRegister("dxqmh", function(module, exports) {

$parcel$export(module.exports, "WorklogSimple", () => $94381f583512b532$export$5db998bd0ca70954);

var $5d8um = parcelRequire("5d8um");
class $94381f583512b532$export$5db998bd0ca70954 extends (0, $5d8um.TicketFormField) {
    afterIndex() {
        super.afterIndex();
        if (this.ui.customerId) //todo: vyhodit jquery
        this.ui.customerId.selectize.on("change", (value)=>// @ts-ignore
            $(this.ui.customerInfo).load(this.getContractResourceUsageUrl("", value.substr(1))));
    }
    getContractResourceUsageUrl(contractId, customerId) {
        return this.contractResourceUsageUrl.replace("__contractId__", contractId).replace("__customerId__", customerId);
    }
}

});

parcelRegister("5kIEs", function(module, exports) {

$parcel$export(module.exports, "ShowMore", () => $5fec6a34745cc984$export$ca7697601dcd7803);

var $4hoex = parcelRequire("4hoex");
class $5fec6a34745cc984$export$ca7697601dcd7803 extends (0, $4hoex.IMuWidget) {
    beforeIndex(container) {
        this.container.innerHTML = '<div mu-id="content" class="show-more--content">' + this.container.innerHTML + '</div><div mu-id="expander" class="show-more--expander">Uk\xe1zat v\xedce</div>';
    }
    afterIndex() {
        this.expander_click();
    }
    expander_click() {
        this.isSmall = !this.isSmall;
        this.container.classList.toggle("show-more__small", this.isSmall);
    }
    constructor(...args){
        super(...args);
        this.isSmall = false;
    }
}

});

parcelRegister("b1wkv", function(module, exports) {

$parcel$export(module.exports, "AccountRolesField", () => $b1eb3ffb422059a3$export$702192b892bcfeb5);

var $4hoex = parcelRequire("4hoex");
class $b1eb3ffb422059a3$export$702192b892bcfeb5 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        const childCount = this.container.childElementCount;
        if (childCount > 1) // const names =
        this.container.innerHTML += '<span class="account-roles__count-info">+' + (childCount - 1) + "</span>";
    }
    container_click() {
        this.container.classList.toggle("account-roles--collapsed");
    }
}

});

parcelRegister("jPK1g", function(module, exports) {

$parcel$export(module.exports, "UiBulkStateChangeGroup", () => $12ea76dc5583c9f2$export$a300866053a29d4b);
$parcel$export(module.exports, "UiBulkStateChangeTicket", () => $12ea76dc5583c9f2$export$d8cec06a1bf19731);

var $4hoex = parcelRequire("4hoex");
class $12ea76dc5583c9f2$export$a300866053a29d4b extends (0, $4hoex.IMuWidget) {
    toggleAll_change() {
        this.eachTicket().map((w)=>w.ui.use.checked = this.ui.toggleAll.checked);
    }
    markAllByState(stateId) {
        this.eachTicket().map((w)=>w.ui.use.checked = w.stateId == stateId);
    }
    eachTicket() {
        return this.muSubWidgets.filter((w)=>w instanceof $12ea76dc5583c9f2$export$d8cec06a1bf19731);
    }
}
class $12ea76dc5583c9f2$export$d8cec06a1bf19731 extends (0, $4hoex.IMuWidget) {
    markAllByState_click() {
        this.muParent.markAllByState(this.stateId);
    }
}

});

parcelRegister("l2pJa", function(module, exports) {

$parcel$export(module.exports, "UiBilling", () => $d0ec83e6b1e20db7$export$f12198c65a2cb7fa);
$parcel$export(module.exports, "UiBillingTicket", () => $d0ec83e6b1e20db7$export$e81a099ff3890fdc);
$parcel$export(module.exports, "UiBillingItem", () => $d0ec83e6b1e20db7$export$88256f2dc27c95e3);

var $4hoex = parcelRequire("4hoex");
function $d0ec83e6b1e20db7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d0ec83e6b1e20db7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d0ec83e6b1e20db7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d0ec83e6b1e20db7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d0ec83e6b1e20db7$var$_arrayLikeToArray(o, minLen);
}
function $d0ec83e6b1e20db7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $d0ec83e6b1e20db7$export$f12198c65a2cb7fa extends (0, $4hoex.IMuWidget) {
    forAllTickets(callback) {
        for(var _iterator = $d0ec83e6b1e20db7$var$_createForOfIteratorHelperLoose(this.muSubWidgets), _step; !(_step = _iterator()).done;){
            let sw = _step.value;
            if (sw.ui.cUse) callback(sw);
        }
    }
    selectAll(ev, what) {
        this.forAllTickets((bt)=>{
            let checked = false;
            switch(what){
                case "all":
                    checked = true;
                    break;
                case "none":
                    checked = false;
                    break;
                default:
                    checked = what == bt.type;
                    break;
            }
            bt.ui.cUse.checked = checked;
        });
    }
    updateVisible() {
        this.forAllTickets((bt)=>{
            let vis = false;
            switch(bt.type){
                case "V":
                    vis = this.ui.cViewV.checked;
                    break;
                case "O":
                    vis = this.ui.cViewO.checked;
                    break;
            }
            bt.container.style.display = vis ? null : "none";
        });
    }
    cDetailToggle_change() {
        //
        // ,
        //
        this.ui.table.classList.toggle("detail-hide", !this.ui.cDetailToggle.checked);
        this.ui.table.classList.toggle("detail-show", this.ui.cDetailToggle.checked);
    }
}
class $d0ec83e6b1e20db7$export$e81a099ff3890fdc extends (0, $4hoex.IMuWidget) {
}
class $d0ec83e6b1e20db7$export$88256f2dc27c95e3 extends (0, $4hoex.IMuWidget) {
}

});

parcelRegister("9fBpR", function(module, exports) {

$parcel$export(module.exports, "UiSavedFilters", () => $65146693149e44f2$export$c81ad60807920af5);

var $4hoex = parcelRequire("4hoex");

var $4wHj3 = parcelRequire("4wHj3");
class $65146693149e44f2$export$c81ad60807920af5 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.container.innerHTML = `
			<span mu-id="bOpen" class="saved-filters--opener">` + this.container.innerHTML + `</span>
			<span mu-id="content">
				<span class="saved-filters__content">
					<span class="modal-b--transparent" mu-id="modalBg" style="z-index: auto"></span>
					<span mu-id="tree"></span>
					<a mu-id="adminLink" class="display-block strong" style="position: relative">V\u{161}echny p\u{159}ehledy</a>					
				</span>
			</span>`;
        this.container.classList.add("saved-filters");
    }
    modalBg_click() {
        this.container.classList.remove("saved-filters--open");
    }
    bOpen_click() {
        this.container.classList.toggle("saved-filters--open");
    }
    async afterIndex() {
        this.cl = new (0, $4wHj3.SavedFiltersCL)(this.clUrl);
        const data = await this.cl.getMySavedFilters();
        this.ui.adminLink.href = this.adminUrl;
        this.tree = $(this.ui.tree).fancytree({
            source: data,
            activate: (event, data)=>{
                console.log(event);
                if (data.node.isFolder()) {
                    data.node.toggleExpanded();
                    return false;
                }
                const url = this.showLinkTemplate.replace("{id}", data.node.key.split("_")[1]);
                if (event.ctrlKey) window.open(url);
                else document.location = url;
            },
            keypress: (event, data)=>{}
        }).fancytree("getTree");
    }
}

});
parcelRegister("4wHj3", function(module, exports) {

$parcel$export(module.exports, "SavedFiltersCL", () => $171b1cc20bae3a83$export$5593c28f80a2a2d5);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $171b1cc20bae3a83$export$5593c28f80a2a2d5 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/savedfilters"){
        super(url);
    }
    getMySavedFilters() {
        return this.callMethod("getMySavedFilters", arguments, {
            "rawResult": false
        });
    }
    createFolder(name, parentFolderId) {
        return this.callMethod("createFolder", arguments, {
            "rawResult": false
        });
    }
    renameFolder(id, name) {
        return this.callMethod("renameFolder", arguments, {
            "rawResult": false
        });
    }
    renameFilter(id, name) {
        return this.callMethod("renameFilter", arguments, {
            "rawResult": false
        });
    }
    moveFolder(id, parentFolderId) {
        return this.callMethod("moveFolder", arguments, {
            "rawResult": false
        });
    }
    moveFilter(id, parentFolderId) {
        return this.callMethod("moveFilter", arguments, {
            "rawResult": false
        });
    }
    saveOrders(orders) {
        return this.callMethod("saveOrders", arguments, {
            "rawResult": false
        });
    }
    linkFilter(originalId, folderId) {
        return this.callMethod("linkFilter", arguments, {
            "rawResult": false
        });
    }
    copyFilter(originalId, folderId) {
        return this.callMethod("copyFilter", arguments, {
            "rawResult": false
        });
    }
    setFolderPlace(id, place) {
        return this.callMethod("setFolderPlace", arguments, {
            "rawResult": false
        });
    }
    deleteFilter(id) {
        return this.callMethod("deleteFilter", arguments, {
            "rawResult": false
        });
    }
    deleteFolder(id) {
        return this.callMethod("deleteFolder", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("9oBmL", function(module, exports) {

$parcel$export(module.exports, "UiSavedFiltersAdmin", () => $a7bf9dde7667c35f$export$8fa3d11b45d221ad);

var $4hoex = parcelRequire("4hoex");

var $4wHj3 = parcelRequire("4wHj3");

var $3cBch = parcelRequire("3cBch");

var $fykIr = parcelRequire("fykIr");
function $a7bf9dde7667c35f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a7bf9dde7667c35f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a7bf9dde7667c35f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a7bf9dde7667c35f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a7bf9dde7667c35f$var$_arrayLikeToArray(o, minLen);
}
function $a7bf9dde7667c35f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $a7bf9dde7667c35f$export$8fa3d11b45d221ad extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.container.classList.add("row", "saved-filter-admin");
        this.container.innerHTML = `<div class="col-md-6 saved-filter-admin__tree-container">
			<div mu-id="tree"></div>
		</div>
		<div class="col-md-6 saved-filter-admin__commands">
			<div class="jumbotron">
				Vybran\xe1 polo\u{17E}ka <strong mu-id="lSource"></strong><br />
				<span mu-id="pTarget">, c\xedlov\xe1 polo\u{17E}ka <strong mu-id="lTarget"></strong>.</span> 
			</div>

			<div mu-id="cButtons" class="buttons">
				<button class="btn btn-primary" mu-id="bEdit">Otev\u{159}\xedt</button>
				<button class="btn btn-primary" mu-id="bCopy">Kop\xedrovat</button>
				<button class="btn btn-primary" mu-id="bLink">Klonovat</button>
				<button class="btn btn-primary" mu-id="bMove">P\u{159}esunout</button>
				<button class="btn btn-danger" mu-id="bRemove">Odstrant</button>			
			</div>
			
			<div mu-id="pAddFolder" class="input-group">
				<input type="text" mu-id="cNewFolderName" class="form-control">
				<div class="input-group-btn">
					<button class="btn btn-primary" mu-id="bAddFolder">P\u{159}idat slo\u{17E}ku</button>
				</div>
			</div>
				
			<div mu-id="pRename" class="input-group">
				<input type="text" mu-id="cNewName" class="form-control">
				<div class="input-group-btn">
					<button class="btn btn-primary" mu-id="bRename">P\u{159}ejmenovat</button>
				</div>
			</div>
			
			<div mu-id="pFolderPlace" class="input-group">
				<select class="form-control" mu-id="cPlace" mu-bind="places:@options"></select>
				<div class="input-group-btn">
					<button class="btn btn-primary" mu-id="bSetPlace">Nastavit um\xedst\u{11B}n\xed</button>
				</div>
			</div>			
		</div>`;
    }
    afterIndex() {
        this.cl = new (0, $4wHj3.SavedFiltersCL)(this.clUrl);
        this.updateButtons();
        this.loadTree();
        this.saveOrdersDC = new (0, $fykIr.DelayedSingleLauncher)(3, ()=>this.doSaveOders());
        this.muBindData({
            places: this.places
        });
    }
    async loadTree() {
        const expandedKeys = this.getAllTreeNodes().filter((n)=>n.expanded).map((n)=>n.key);
        const data = await this.cl.getMySavedFilters();
        const pe = this.ui.tree.parentElement;
        this.ui.tree.remove();
        const de = this.ui.tree = document.createElement("div");
        pe.appendChild(this.ui.tree);
        this.tree = $(this.ui.tree).fancytree({
            source: data,
            extensions: [
                "dnd"
            ],
            activate: (event, data)=>{
                this.selectedNode = data.node;
                this.targetNode = null;
                console.log(event);
                this.updateButtons();
            /* if( data.node.isFolder() ){
        	data.node.toggleExpanded();
        } */ // document.location = this.showLinkTemplate.replace('{id}', data.node.key.split('_')[1]);
            },
            renderNode: (ev, data)=>{
                if (!data.node.data.isMy) data.node.span.classList.add("em");
            },
            dnd: {
                autoExpandMS: 400,
                focusOnClick: true,
                preventVoidMoves: true,
                // Prevent dropping nodes 'before self', etc.
                preventRecursiveMoves: true,
                // Prevent dropping nodes on own descendants
                dragStart: (node, data)=>{
                    this.lastReorder = new Date();
                    return node.data.isMy || node.data.type == "filter";
                },
                dragEnter: (node, data)=>{
                    console.log([
                        data.hitMode,
                        node.data.isMy,
                        node.data.type
                    ]);
                    this.lastReorder = new Date();
                    if (data.hitMode == "over") return node.data.isMy && node.data.type == "folder";
                    else return true;
                },
                dragDrop: (node, data)=>{
                    console.log([
                        node,
                        data
                    ]);
                    const isReorder = data.hitMode != "over" && node.parent.key == data.otherNode.parent.key;
                    this.lastReorder = new Date();
                    if (isReorder) {
                        // jen změna pořadí
                        this.targetNode = null;
                        this.selectedNode = null;
                        if (data.otherNode.data.isMy) {
                            this.saveOrders();
                            data.otherNode.moveTo(node, data.hitMode);
                            return true;
                        } else return false;
                    } else {
                        const target = data.hitMode == "over" ? node : node.parent;
                        if (data.otherNode.data.type === "folder") this.cl.moveFolder(data.otherNode.data.id, target.data.id).then(()=>this.loadTree());
                        else {
                            this.targetNode = target;
                            this.selectedNode = data.otherNode;
                        }
                    }
                    this.updateButtons();
                    return true;
                }
            }
        }).fancytree("getTree");
        this.selectedNode = null;
        this.targetNode = null;
        this.updateButtons();
        setTimeout(()=>{
            for(var _iterator = $a7bf9dde7667c35f$var$_createForOfIteratorHelperLoose(this.getAllTreeNodes()), _step; !(_step = _iterator()).done;){
                let n = _step.value;
                if (expandedKeys.includes(n.key)) n.setExpanded(true);
            }
        }, 50);
    // this.tree.setOption("source", data);
    // this.tree.clear();
    // this.tree.getRootNode().addChildren(data);
    // this.ui.tree.innerHTML = "";
    // this.ui.tree.className = "";
    }
    updateButtons() {
        if (this.targetNode && !this.targetNode.data.isMy && !this.targetNode.key.startsWith("root_")) this.targetNode = null;
        this.ui.lSource.innerText = this.selectedNode ? this.selectedNode.title : "nevybr\xe1n";
        if (this.targetNode) this.ui.lTarget.innerText = this.targetNode.key.startsWith("root_") ? "Nejvy\u0161\u0161\xed \xfarov\u011B\u0148" : this.targetNode.title;
        this.muVisible(!!this.targetNode, "pTarget");
        this.muVisible(false, [
            "bEdit",
            "bCopy",
            "bLink",
            "bMove",
            "pAddFolder",
            "bRemove",
            "pRename",
            "pFolderPlace"
        ]);
        if (this.targetNode) {
            // presun, kopie, link
            this.muVisible(this.selectedNode.data.isMy, "bMove");
            this.muVisible(true, [
                "bCopy",
                "bLink"
            ]);
        } else {
            // jeden vybraný
            if (this.selectedNode) {
                this.muVisible(this.selectedNode.data.type != "folder", "bEdit");
                this.muVisible(this.selectedNode.data.isMy, "bRemove");
                if (this.selectedNode.data.isMy && this.selectedNode.data.type == "folder") {
                    this.muVisible(true, "pFolderPlace");
                    this.ui.cPlace.value = this.selectedNode.data.place;
                }
            }
            this.ui.cNewName.value = this.selectedNode ? this.selectedNode.title : "";
            this.muVisible(!this.selectedNode || this.selectedNode.data.isMy, "pAddFolder");
            this.muVisible(this.selectedNode && this.selectedNode.data.isMy, "pRename");
        }
    }
    saveOrders() {
        this.saveOrdersDC.send();
    }
    bEdit_click() {
        document.location = this.showLinkTemplate.replace("{id}", this.selectedNode.data.id.toString());
    }
    async bCopy_click() {
        const parentId = this.getTargetId();
        const id = this.selectedNode.data.id;
        await this.cl.copyFilter(id, parentId);
        this.loadTree();
    }
    async bLink_click() {
        const parentId = this.getTargetId();
        const id = this.selectedNode.data.id;
        await this.cl.linkFilter(id, parentId);
        this.loadTree();
    }
    getTargetId() {
        return this.targetNode.key.startsWith("root_") ? null : this.targetNode.data.id;
    }
    async bMove_click() {
        const parentId = this.getTargetId();
        const id = this.selectedNode.data.id;
        if (this.selectedNode.data.type == "folder") await this.cl.moveFolder(id, parentId);
        else await this.cl.moveFilter(id, parentId);
        await this.loadTree();
    }
    async bRemove_click() {
        const id = this.selectedNode.data.id;
        if (!confirm("Opravdu chcete smazat " + (this.selectedNode.data.type == "folder" ? "slo\u017Eku" : "filtr") + this.selectedNode.title + (this.selectedNode.data.type == "folder" ? " v\u010Detn\u011B pod\u0159\xedzen\xfdch slo\u017Eek a filtr\u016F" : "") + "?")) return;
        if (this.selectedNode.data.type == "folder") await this.cl.deleteFolder(id);
        else await this.cl.deleteFilter(id);
        await this.loadTree();
    }
    async bSetPlace_click() {
        const id = this.selectedNode.data.id;
        await this.cl.setFolderPlace(id, this.ui.cPlace.value);
        await this.loadTree();
    }
    bAddFolder_click() {
        if (this.ui.cNewFolderName.value != "") {
            const parentFolderId = this.selectedNode ? this.selectedNode.data.type == "folder" ? this.selectedNode.data.id : this.selectedNode.parent ? this.selectedNode.parent.data.id : null : null;
            // alert("New folder in " + parentFolderId);
            this.cl.createFolder(this.ui.cNewFolderName.value, parentFolderId).then(()=>this.loadTree());
        } else (0, $3cBch.UiFlashMessage).instance.add("Zadejte n\xe1zev slo\u017Eky.");
    }
    async bRename_click() {
        if (this.selectedNode.data.type == "folder") await this.cl.renameFolder(this.selectedNode.data.id, this.ui.cNewName.value);
        else await this.cl.renameFilter(this.selectedNode.data.id, this.ui.cNewName.value);
        await this.loadTree();
    }
    getAllTreeNodes() {
        const res = [];
        if (!this.tree) return res;
        const addItems = (childs)=>{
            for(var _i = 0, _childs = childs; _i < _childs.length; _i++){
                let n = _childs[_i];
                res.push(n);
                if (n.children) addItems(n.children);
            }
        };
        addItems(this.tree.getRootNode().children);
        return res;
    }
    doSaveOders() {
        const ords = [];
        const addItems = (childs)=>{
            let i = 0;
            for(var _i2 = 0, _childs2 = childs; _i2 < _childs2.length; _i2++){
                let n = _childs2[_i2];
                if (!n.data.isMy) continue;
                ords.push({
                    id: n.data.id,
                    type: n.data.type,
                    numOrder: i++
                });
                if (n.children) addItems(n.children);
            }
        };
        addItems(this.tree.getRootNode().children);
        return this.cl.saveOrders(ords);
    }
    constructor(...args){
        super(...args);
        this.lastReorder = null;
    }
}

});
parcelRegister("fykIr", function(module, exports) {

$parcel$export(module.exports, "DelayedSingleLauncher", () => $b55f943fb42b0efe$export$ccf46f0df7f47f56);
class $b55f943fb42b0efe$export$ccf46f0df7f47f56 {
    constructor(timeout, callback){
        this.timeout = timeout;
        this.callback = callback;
    }
    send(...args) {
        this.lastSend = new Date();
        setTimeout(()=>{
            const diff = (new Date().getTime() - this.lastSend.getTime()) / 1000;
            if (diff >= this.timeout) // @ts-ignore
            this.callback(...args);
        }, this.timeout * 1000 + 1);
    }
}

});


parcelRegister("6avXl", function(module, exports) {

$parcel$export(module.exports, "UiNotify", () => $5f88057bf095237d$export$7a50231b4e5f84f9);
$parcel$export(module.exports, "UiNotifyItem", () => $5f88057bf095237d$export$873ca86afc6b5b6f);

var $4hoex = parcelRequire("4hoex");

var $3quvq = parcelRequire("3quvq");

var $kwZWC = parcelRequire("kwZWC");
function $5f88057bf095237d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5f88057bf095237d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5f88057bf095237d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5f88057bf095237d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5f88057bf095237d$var$_arrayLikeToArray(o, minLen);
}
function $5f88057bf095237d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $5f88057bf095237d$export$7a50231b4e5f84f9 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.muAppendContent(`<span class="simple-loader" mu-id="loader"></span> Upozorn\u{11B}n\xed
			<div class="notify__badgets" mu-id="badgets" mu-bind="badgets:@foreach">
				<span mu-bind='count|tern("notify__badget--active","")|prepend("notify__badget "):className' mu-template="budgetItem" mu-widget=".">
					<span mu-id="icon" mu-bind='icon|prepend("icon-"):className' class="icon-comment"></span> 
					<span mu-id="count" mu-bind="count">10</span>
				</span>
			</div>
			<div mu-id="sidebar" class="notify__sidebar">
				<div class="notify__sidebar__filters">
					<div mu-id="filterType" class="checkbox">
						<label mu-widget="." mu-template="filterTypeItem">
							<input type="checkbox" mu-id="visible" checked="checked">
							<span mu-bind='icon|prepend("icon-"):className'></span>
							<span mu-bind="name"></span>
						</label>
					</div>
				</div>
				<div mu-bind="items:@foreach" class="notify__sidebar__items" mu-id="items">
					<div class="notify__sidebar-item" mu-widget="UiNotifyItem" mu-template="itemItem">
						<div class="display-flex gap-4px em">
							<span class="notify__sidebar-item--icon" mu-id="icon"></span>
							<span class="notify__sidebar-item--dtAdd" mu-bind='dtAdd|dateTime("d.m.Y H:i")'></span>
							<span class="notify__sidebar-item--accountName flex-grow-1" mu-bind="accountName"></span>
							<span class="notify__sidebar-item--accountOrgDivisionCode" mu-bind="accountOrgDivisionCode"></span>
						</div>
						<div class="notify__sidebar-item--subject" mu-bind="subject"></div>
						<div class="notify__sidebar-item--messageShort" mu-bind="messageShort"></div>
						<div class="display-flex- strong">
							<span class="notify__sidebar-item--evidenceUid" mu-bind="evidenceUid"></span>
							<span class="notify__sidebar-item--summary flex-grow-1" mu-bind="summary"></span>
						</div>
					</div>				
				</div>
			</div>`);
    }
    badgets_click() {
        this.toggleSidebar();
    }
    toggleSidebar() {
        this.ui.sidebar.classList.toggle("notify__sidebar--open");
        if (this.ui.sidebar.classList.contains("notify__sidebar--open") && this.lastNotifyId) this.cl.markAsViewed(this.lastNotifyId).then(()=>{});
    }
    async afterIndex() {
        // return;
        if (!this.filter) this.filter = {
            type: Object.keys(this.typeOpts)
        };
        this.cl = new (0, $3quvq.NotifyCL)(this.clUrl);
        this.cl.onLoading = ()=>this.ui.loader.classList.toggle("simple-loader--loading", true);
        this.cl.onLoaded = ()=>this.ui.loader.classList.toggle("simple-loader--loading", false);
        for(const k in this.typeOpts){
            const tfi = this.muWidgetFromTemplate("filterTypeItem", "filterType", {
                visible_change: ()=>{
                    this.filterItems();
                    this.saveFilters();
                },
                type: k
            });
            tfi.muBindData(this.typeOpts[k]);
            tfi.ui.visible.checked = this.filter.type.includes(k);
        }
        await (0, $kwZWC.sleepPromise)(3000);
        this.reloadNotifies();
        setInterval(()=>this.reloadNotifies(), this.reloadInterval);
    }
    async reloadNotifies() {
        if (await this.bindBadgets()) await this.bindList();
    }
    async bindBadgets() {
        const cb = await this.cl.getNotifyCounts();
        const cbs = JSON.stringify(cb);
        if (cbs !== this.lastBadgets) {
            this.muBindData({
                badgets: cb
            });
            this.lastBadgets = cbs;
            this.lastNotifyId = Math.max(...cb.map((item)=>item.lastId));
            return true;
        }
        return false;
    }
    async bindList() {
        this.muBindData({
            items: await this.cl.getNotifies(null, false, 100)
        });
        this.filterItems();
    }
    getFilterTypes() {
        const visibleTypes = [];
        for(var _iterator = $5f88057bf095237d$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("filterType")), _step; !(_step = _iterator()).done;){
            const fti = _step.value;
            if (fti.ui.visible.checked) // @ts-ignore
            visibleTypes.push(fti.type);
        }
        return visibleTypes;
    }
    filterItems() {
        const visibleTypes = this.getFilterTypes();
        for(var _iterator2 = $5f88057bf095237d$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("items")), _step2; !(_step2 = _iterator2()).done;){
            const item = _step2.value;
            item.muVisible(visibleTypes.includes(item.item.type), ".");
        }
    }
    saveFilters() {
        this.filter.type = this.getFilterTypes();
        this.cl.saveFilter(this.filter);
    }
    constructor(...args){
        super(...args);
        this.reloadInterval = 300000;
        this.lastNotifyId = null;
        this.lastBadgets = null;
    }
}
class $5f88057bf095237d$export$873ca86afc6b5b6f extends (0, $4hoex.IMuWidget) {
    muAfterBindData(data) {
        this.ui.icon.className = "icon-" + this.muParent.typeOpts[data.type].icon;
        this.ui.icon.title = this.muParent.typeOpts[data.type].name;
        this.item = data;
        this.container.classList.toggle("notify__sidebar-item--is-new", !data.dtDesktop);
    }
    container_click(ev) {
        this.openLink(ev);
    }
    container_auxclick(ev) {
        this.openLink(true);
    }
    openLink(inNew = false) {
        if (inNew instanceof PointerEvent) inNew = inNew.ctrlKey;
        if (inNew) window.open(this.item.url);
        else document.location.href = this.item.url;
    }
}

});
parcelRegister("3quvq", function(module, exports) {

$parcel$export(module.exports, "NotifyCL", () => $0809721d95758e86$export$b691bdeb7994f571);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $0809721d95758e86$export$b691bdeb7994f571 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/notify"){
        super(url);
    }
    getNotifyCounts() {
        return this.callMethod("getNotifyCounts", arguments, {
            "rawResult": false
        });
    }
    getNotifies(lastId = null, fromMe = null, limitCount = 30) {
        return this.callMethod("getNotifies", arguments, {
            "rawResult": false
        });
    }
    saveFilter(filter) {
        return this.callMethod("saveFilter", arguments, {
            "rawResult": false
        });
    }
    markAsViewed(lastId) {
        return this.callMethod("markAsViewed", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("epeYa", function(module, exports) {

$parcel$export(module.exports, "UrlInput", () => $412fefbf5796866f$export$e94a5e0d272668a0);

var $4hoex = parcelRequire("4hoex");

var $kwZWC = parcelRequire("kwZWC");
class $412fefbf5796866f$export$e94a5e0d272668a0 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        const wrapped = (0, $kwZWC.wrapElement)(this.container, "div");
        this.container = wrapped.wrapper;
        wrapped.original.removeAttribute("mu-widget");
        wrapped.original.setAttribute("mu-id", "input");
        this.container.innerHTML += `<a mu-id="link" target="_blank">Otevr\xedt odkaz</a>`;
    }
    updateLink() {
        this.ui.link.href = this.ui.input.value;
        this.muVisible(!!this.ui.input.value, "link");
    }
    afterIndex() {
        this.updateLink();
    }
    input_change() {
        this.updateLink();
    }
}

});

parcelRegister("asW3g", function(module, exports) {

$parcel$export(module.exports, "Course", () => $d5f93d8ca698bd56$export$86972080aba92e19);
$parcel$export(module.exports, "CourseSlide", () => $d5f93d8ca698bd56$export$26f4cdc2d914fecf);

var $4hoex = parcelRequire("4hoex");

var $fJaE3 = parcelRequire("fJaE3");

var $kwZWC = parcelRequire("kwZWC");
function $d5f93d8ca698bd56$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d5f93d8ca698bd56$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d5f93d8ca698bd56$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d5f93d8ca698bd56$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d5f93d8ca698bd56$var$_arrayLikeToArray(o, minLen);
}
function $d5f93d8ca698bd56$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $d5f93d8ca698bd56$export$86972080aba92e19 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.container.innerHTML = `
			<span mu-id="bOpenCourse" class="course__open-course">
				<span class="icon-book-help"></span>
				<span mu-id="info"></span>
				<span mu-id="icon"></span>				
			</span>
			<div class="course_view" style="display: none" mu-id="details">
				<div mu-id="slides" mu-bind="slides:@foreach" class="course_view__slides">
					<div class="course_view__slide" mu-template="slide" mu-widget="CourseSlide">
						<div class="course_view__slide_course_info">
							<strong mu-bind="courseName"></strong>
							<span mu-bind="courseVersion" title="Aktu\xe1ln\u{11B} platn\xe1 verze \u{161}kolen\xed"></span> /
							<span mu-bind="completeVersion" title="Posledn\xed p\u{159}e\u{10D}ten\xe1 a odsouhlasen\xe1 verze \u{161}kolen\xed"></span> 
							<span mu-bind='statusIcon|prepend("icon-"):className'></span>
						</div>
						<h2 mu-id="name" mu-bind="name"></h2>
						<div mu-id="content" mu-bind="content:innerHTML"></div>
						<div mu-id="pConfirm" class="course_view__confirm">
							<label mu-for="confirmCheckbox">
								<input type="checkbox" mu-id="confirmCheckbox">
								P\u{159}e\u{10D}etl jsem, rozum\xedm a budu dodr\u{17E}ovat.
							</label>
							<div>
								<span class="btn-primary btn btn-lg" mu-id="bConfirm">Potvrzuji</span>
							</div>
							<div>
								<em mu-id="dtCompletion"></em>
							</div>
						</div>
					</div>
				</div>
				<span class="course_view__btn_close" mu-id="bClose">&times;</span>
				<span class="course_view__btn_prev" mu-id="bPrev">&lt;</span>
				<span class="course_view__btn_next" mu-id="bNext">&gt;</span>` + (this.editUrl ? '<a class="course_view__btn_edit" mu-id="bEdit">Upravit \u0161kolen\xed</a>' : "") + `</div>`;
        this.container.classList.add("course");
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        if (srcData.slides) this.slideCount = srcData.slides.length;
    }
    afterIndex() {
        if (this.isPreview) this.muVisible(false, "bOpenCourse");
        else {
            this.cl = new (0, $fJaE3.CourseCL)(this.clUrl);
            this.loadCurses();
            if (this.editUrl) this.ui.bEdit.href = this.editUrl;
        }
    }
    preview(slides) {
        this.muBindData({
            slides: slides
        });
        this.muVisible(true, "details");
        this.switchSlide(0);
    }
    loadCurses() {
        this.cl.getCoursesFor(this.place).then((data)=>{
            this.anyNotCompleted = data.some((c)=>c.diffPart === "major");
            const byPart = {
                major: 0,
                minor: 0,
                patch: 0,
                ok: 0
            };
            data.forEach((course)=>byPart[course.diffPart ?? "ok"]++);
            let icon = "";
            let info = "";
            const count = data.length;
            if (byPart.major) {
                icon = "warning";
                info = "Spln\u011Bno " + (count - byPart.major).toString() + " z " + count.toString();
            } else if (byPart.minor) {
                icon = "info-g";
                info = "Spln\u011Bno v\u0161e";
            } else if (count == 0) info = "\u017D\xe1dn\xe9 \u0161kolen\xed";
            else {
                icon = "ok";
                info = "Spln\u011Bno v\u0161e";
            }
            this.ui.info.innerText = info;
            this.ui.icon.className = "icon-" + icon;
            const slideData = [];
            for(var _iterator = $d5f93d8ca698bd56$var$_createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;){
                const course = _step.value;
                const courseMetadata = {
                    id: course.id,
                    courseName: course.name,
                    courseVersion: course.version,
                    completeVersion: course.completeVersion,
                    statusIcon: course.statusIcon,
                    dtCompletion: course.dtCompletion ? new Date(course.dtCompletion) : null
                };
                for(var _iterator2 = $d5f93d8ca698bd56$var$_createForOfIteratorHelperLoose(course.content.slides), _step2; !(_step2 = _iterator2()).done;){
                    const slide = _step2.value;
                    slideData.push({
                        ...courseMetadata,
                        name: slide.name,
                        content: slide.content,
                        showConfirm: false
                    });
                }
                slideData.push({
                    ...courseMetadata,
                    name: "Potvrzen\xed",
                    showConfirm: true
                });
            }
            this.muBindData({
                slides: slideData
            });
            this.switchSlide(this.currentSlideNum);
            if (this.forceCompletion && this.anyNotCompleted) this.bOpenCourse_click();
        });
    }
    bPrev_click() {
        this.switchSlide("prev");
    }
    bNext_click() {
        this.switchSlide("next");
    }
    switchSlide(slideNum) {
        if (slideNum === "next") slideNum = Math.min(this.currentSlideNum + 1, this.slideCount - 1);
        if (slideNum === "prev") slideNum = Math.max(this.currentSlideNum - 1, 0);
        let i = 0;
        this.currentSlideNum = slideNum;
        for(var _iterator3 = $d5f93d8ca698bd56$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("slides")), _step3; !(_step3 = _iterator3()).done;){
            const slide = _step3.value;
            const cl = slide.container.classList;
            cl.toggle("course_view__slide--pre", i < this.currentSlideNum);
            cl.toggle("course_view__slide--post", i > this.currentSlideNum);
            i++;
        }
    }
    bOpenCourse_click() {
        this.muVisible("toggle", "details");
    }
    bClose_click() {
        this.muVisible("toggle", "details");
    }
    constructor(...args){
        super(...args);
        this.currentSlideNum = 0;
        this.forceCompletion = true;
        this.anyNotCompleted = true;
        this.editUrl = null;
        this.isPreview = false;
    }
}
class $d5f93d8ca698bd56$export$26f4cdc2d914fecf extends (0, $4hoex.IMuWidget) {
    muBindData(srcData) {
        super.muBindData(srcData);
        this.muVisible(srcData.showConfirm, "pConfirm");
        if (srcData.showConfirm) {
            const completion = !!srcData.dtCompletion;
            this.ui.confirmCheckbox.disabled = completion;
            this.ui.confirmCheckbox.checked = completion;
            if (completion) this.ui.dtCompletion.innerText = "Potvrzeno " + (0, $kwZWC.formatDateTime)(srcData.dtCompletion);
        }
        this.courseId = srcData.id;
    }
    bConfirm_click() {
        if (this.ui.confirmCheckbox.checked) this.muParent.cl.confirmCourseCompletion(this.courseId).then(()=>this.muParent.loadCurses());
        else alert("Potr\u010Fte zakliknut\xedm");
    }
}

});
parcelRegister("fJaE3", function(module, exports) {

$parcel$export(module.exports, "CourseCL", () => $b9525c6f4687bf7b$export$1469b7a724db0787);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $b9525c6f4687bf7b$export$1469b7a724db0787 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/course"){
        super(url);
    }
    getCoursesFor(placePath) {
        return this.callMethod("getCoursesFor", arguments, {
            "rawResult": false
        });
    }
    confirmCourseCompletion(courseId) {
        return this.callMethod("confirmCourseCompletion", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("hjT8q", function(module, exports) {

$parcel$export(module.exports, "TrainingAdmin", () => $57e5d07ff229fbc2$export$95f4b5dd4fb9b5a2);
$parcel$export(module.exports, "CourseEditor", () => $57e5d07ff229fbc2$export$33f29d9174d7e55a);
$parcel$export(module.exports, "CourseContentEditor", () => $57e5d07ff229fbc2$export$f3f841c62c988b76);
$parcel$export(module.exports, "CourseContentEditorSlide", () => $57e5d07ff229fbc2$export$eaaedd43afa26056);

var $4hoex = parcelRequire("4hoex");

var $8Pjv2 = parcelRequire("8Pjv2");

var $3cBch = parcelRequire("3cBch");

var $92Ocn = parcelRequire("92Ocn");

var $kwZWC = parcelRequire("kwZWC");
function $57e5d07ff229fbc2$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $57e5d07ff229fbc2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $57e5d07ff229fbc2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $57e5d07ff229fbc2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $57e5d07ff229fbc2$var$_arrayLikeToArray(o, minLen);
}
function $57e5d07ff229fbc2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $57e5d07ff229fbc2$export$95f4b5dd4fb9b5a2 extends (0, $4hoex.IMuWidget) {
    beforeIndex() {
        this.container.innerHTML = `<div mu-id="courseList">
			<div mu-id="preview" mu-widget="Course" mu-params='{"isPreview":true}'></div>
			<h3>\u{160}kolen\xed pro m\xedsto <code mu-id="place"></code></h3>
			<ul mu-id="list">
				<li mu-template="item" mu-widget=".">
					<span class="icon-pack">
						<!-- <span class="icon-remove" title="\xdapln\u{11B} odstranit ze v\u{161}ech m\xedst" mu-id="bDelete"></span> -->
						<span class="icon-checked-off" title="Odpojit z tohoto m\xedsta" mu-id="bUnlink"></span>
						<span class="icon-book-help" title="N\xe1hled" mu-id="bPreview"></span>
					</span>
					<span mu-bind='name|defaultValue("(bez n\xe1zvu)")' mu-id="name" class="a"></span>
					<span mu-bind='version|field("name")'></span>
				</li>
			</ul>
			<div class="display-flex gap-4px">
				<span>P\u{159}ipojit existuj\xedc\xed \u{161}kolen\xed</span>
				<div mu-widget="SearchSelector" mu-id="cAddCourse" class="flex-grow-1"></div>		
				<span class="btn btn-primary" mu-id="bLinkSelected">P\u{159}ipojit vybran\xe9</span>
			</div>
			<div class="display-flex gap-4px">
				<span>N\xe1zev nov\xe9ho \u{161}kolen\xed</span>
				<input type="text" class="flex-grow-1 form-control" mu-id="cNewName" /> 
				<span class="btn btn-primary" mu-id="bCreateNew">Vytvo\u{159}it nov\xe9 \u{161}kolen\xed</span>
			</div>
		</div>
		<div mu-widget="CourseEditor" mu-id="editor" class="form-horizontal" mu-bind="id:.id">
			<h3>\xdaprava \u{161}kolen\xed</h3>
			<div class="row form-group">
				<label mu-for="bind:name" class="col-md-3 control-label">N\xe1zev kurzu</label>
				<div class="col-md-9">
					<input type="text" mu-bind="name" class="form-control" />
				</div>
			</div>
			<div class="row form-group">
				<label mu-for="bind:name" class="col-md-3 control-label">Z\xe1vis\xed na</label>
				<div class="col-md-9">
					<div mu-widget="SearchSelector" mu-id="cDependOn" mu-bind="dependOn" class="flex-grow-1"></div>
				</div>
			</div>
			<div class="panel">
				<div mu-bind="content" mu-widget="CourseContentEditor" class="course-content-editor">
					<h4>Kapitoly</h4>
					<ol mu-bind="slides::@foreach" mu-id="slides">
						<li mu-widget="CourseContentEditorSlide" mu-template="slide">
							<div class="display-flex gap-4px">
								<span class="icon-up-down handler"></span>
								<span class="icon-remove cursor-pointer" title="Smazat tuto kapitolu" mu-id="bRemove"></span>
								<input mu-bind="name" mu-id="name" class="editable flex-grow-1 " placeholder="N\xe1zev kapitoly" />
							</div>
							<div mu-id="details">
								<div mu-widget="Htmlarea" mu-bind="content" mu-id="content" mu-params='{"delayedInit":true}'></div>
							</div>
						</li>
					</ol>
					<span class="btn btn-link" mu-id="bAddSlide">P\u{159}idat kapitolu</span>
				</div>
				<div class="buttons">
					Ulo\u{17E}it jako:
					<span class="btn btn-default" mu-click='bSave_click:"draft"'>Koncept</span>
					<span mu-id="pVersionSaveButtons">
						<span class="btn btn-primary" mu-click='bSave_click:"patch"' title="U\u{17E}ivatel nebude upozorn\u{11B}n">Bezv\xfdznamn\xe1 zm\u{11B}na</span>
						<span class="btn btn-warning" mu-click='bSave_click:"minor"' title="U\u{17E}ivatel bude upozorn\u{11B}n">Mal\xe1 zm\u{11B}na</span>
						<span class="btn btn-danger" mu-click='bSave_click:"major"' title="U\u{17E}ivatel mus\xed znovu proj\xedt \u{161}kolen\xedm">Velk\xe1 zm\u{11B}na</span>					
					</span>
					<span mu-id="bFirstPublish" class="btn btn-primary" mu-click='bSave_click:"major"'>Uve\u{159}ejnit</span>
					<span> | </span>
					<span class="btn btn-default" mu-id="bPreview">N\xe1hled</span> 
					<span class="btn btn-danger" mu-id="bClose">Zav\u{159}\xedt bez ulo\u{17E}en\xed</span> 
				</div>
			</div>
		</div>`;
    }
    afterIndex() {
        this.cl = new (0, $8Pjv2.AdminTrainingCL)(this.clUrl);
        this.loadCourses();
        this.muNamedWidget.cAddCourse.searchPromiseCallback = this.courseFulltext;
        this.closeCourse();
    }
    loadCourses() {
        this.ui.place.innerText = this.place;
        this.ui.list.innerHTML = "";
        return this.cl.withMessage("Na\u010D\xedt\xe1m \u0161kolen\xed").getCoursesForPlace(this.place).then((data)=>{
            for(var _iterator = $57e5d07ff229fbc2$var$_createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;){
                const course = _step.value;
                this.muWidgetFromTemplate("item", "list", {
                    name_click: ()=>this.loadCourse(course.id),
                    bUnlink_click: ()=>confirm("Opravdu chcete odpojit kurz " + course.name) ? this.unlinkCourse(course.id) : undefined,
                    bPreview_click: ()=>{
                        // const slides = await this.cl.getCourse(co);
                        this.muNamedWidget.preview.preview(course.content.slides);
                    }
                }).muBindData(course);
            }
        });
    }
    bLinkSelected_click() {
        this.cl.withMessage("P\u0159ipojuji kurzy").addCoursesToPlace(this.muNamedWidget.cAddCourse.muFetchData().map((idStr)=>parseInt(idStr)), this.place).then(()=>{
            (0, $3cBch.UiFlashMessage).instance.add("Kurzy byly p\u0159i\u0159azeny na toto m\xedsto.");
            this.muNamedWidget.cAddCourse.muBindData([]);
            this.loadCourses();
        });
    }
    loadCourse(id) {
        this.cl.withMessage("Na\u010D\xedt\xe1m \u0161kolen\xed").getCourseDetail(id).then((course)=>{
            this.muNamedWidget.editor.muBindData(course);
            this.muVisible(true, "editor");
        });
    }
    closeCourse() {
        this.muVisible(false, "editor");
    }
    unlinkCourse(id) {
        this.cl.withMessage("Odpojuji kurzy").removeCoursesFromPlace([
            id
        ], this.place).then(()=>{
            (0, $3cBch.UiFlashMessage).instance.add("Kurzy byly odpojeny.");
            this.loadCourses();
        });
    }
    bCreateNew_click() {
        const newName = this.ui.cNewName.value.trim();
        if (newName == "") (0, $kwZWC.flashError)("Mus\xed b\xfdt zad\xe1n n\xe1zev");
        else this.cl.withMessage("Vytv\xe1\u0159\xedm \u0161kolen\xed").newCourse(newName, this.place).then((res)=>{
            if (res.success) {
                this.loadCourses();
                this.loadCourse(res.data.courseId);
                (0, $kwZWC.flashInfo)("Nov\xe9 \u0161kolen\xed " + newName + " bylo vytvo\u0159eno");
            } else (0, $kwZWC.flashError)(res.message);
        });
    }
    editor_saved() {
        this.closeCourse();
        this.loadCourses();
    }
    constructor(...args){
        super(...args);
        this.courseFulltext = (fulltext)=>this.cl.withMessage("Hled\xe1m \u0161kolen\xed").searchCourse(fulltext);
    }
}
class $57e5d07ff229fbc2$export$33f29d9174d7e55a extends (0, $4hoex.IMuWidget) {
    afterIndex() {
        this.muRegisterEvent("saved");
        this.muNamedWidget.cDependOn.searchPromiseCallback = this.muParent.courseFulltext;
    // (this.muNamedWidget.cDependOn as UiSelect).searchCallback = this.muParent.courseFulltext;
    }
    muBindData(srcData) {
        this.id = srcData.id;
        this.course = srcData;
        super.muBindData(srcData);
        this.muVisible(!!srcData.version.major, [
            "!bFirstPublish",
            "pVersionSaveButtons"
        ]);
    }
    bSave_click(ev, target) {
        this.muParent.cl.withMessage("Ukl\xe1d\xe1m \u0161kolen\xed").saveCourse(this.id, this.muFetchData(), target === "draft", target === "draft" ? null : target).then((res)=>{
            if (res.success) {
                (0, $kwZWC.flashInfo)(res.message || "Ulo\u017Eeno");
                this.muDispatchEvent("saved");
            } else (0, $kwZWC.flashError)(res.message);
        });
    }
    bPreview_click() {
        this.muParent.muNamedWidget.preview.preview(this.muFetchData().content.slides);
    }
}
class $57e5d07ff229fbc2$export$f3f841c62c988b76 extends (0, $4hoex.IMuWidget) {
    bAddSlide_click() {
        this.muWidgetFromTemplate("slide", "slides");
    }
    afterIndex() {
        this.setupSlidesDraggable();
    }
    setupSlidesDraggable() {
        this.slideSortable = $92Ocn.default.create(this.ui.slides, {
            handle: ".handler"
        });
    }
}
class $57e5d07ff229fbc2$export$eaaedd43afa26056 extends (0, $4hoex.IMuWidget) {
    afterIndex() {
        this.muNamedWidget.content.uploadUrl = this.muParent?.muParent.course.ckeUploadUrl;
    }
    bRemove_click() {
        if (confirm('Odstranit kapitolu "' + this.ui.name.value + "'?")) this.muRemoveSelf();
    }
}

});
parcelRegister("8Pjv2", function(module, exports) {

$parcel$export(module.exports, "AdminTrainingCL", () => $935213e72554f97e$export$b6864153b079369e);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $935213e72554f97e$export$b6864153b079369e extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/admintraining"){
        super(url);
    }
    saveCourse(courseId, data, asDraft, versionPart) {
        return this.callMethod("saveCourse", arguments, {
            "rawResult": false
        });
    }
    getCourse(courseId, version = "draft") {
        return this.callMethod("getCourse", arguments, {
            "rawResult": false
        });
    }
    getCoursesForPlace(place) {
        return this.callMethod("getCoursesForPlace", arguments, {
            "rawResult": false
        });
    }
    getCourseDetail(id, version = "draft") {
        return this.callMethod("getCourseDetail", arguments, {
            "rawResult": false
        });
    }
    searchCourse(text) {
        return this.callMethod("searchCourse", arguments, {
            "rawResult": false
        });
    }
    addCoursesToPlace(courseIds, placePath) {
        return this.callMethod("addCoursesToPlace", arguments, {
            "rawResult": false
        });
    }
    removeCoursesFromPlace(courseIds, placePath) {
        return this.callMethod("removeCoursesFromPlace", arguments, {
            "rawResult": false
        });
    }
    newCourse(newName, placePath) {
        return this.callMethod("newCourse", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("EetfQ", function(module, exports) {

$parcel$export(module.exports, "UiSelect", () => $765a58294435a7ed$export$bd17aa8cf318e84c);

var $aspqD = parcelRequire("aspqD");

var $4hoex = parcelRequire("4hoex");
function $765a58294435a7ed$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $765a58294435a7ed$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $765a58294435a7ed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $765a58294435a7ed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $765a58294435a7ed$var$_arrayLikeToArray(o, minLen);
}
function $765a58294435a7ed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $765a58294435a7ed$export$bd17aa8cf318e84c extends (0, $4hoex.IMuWidget) {
    set searchCallback(callback) {
        const reinit = !this.searchCallbackField;
        this.searchCallbackField = callback;
        if (reinit) this.initTomSelect();
    }
    set searchPromiseCallback(callback) {
        const reinit = !this.searchPromiseCallbackField;
        this.searchPromiseCallbackField = callback;
        if (reinit) this.initTomSelect();
    }
    beforeIndex() {
        this.muRegisterEvent("change", "input", "focus", "blur");
        this.container.innerHTML = '<select mu-id="input"' + (this.multiple ? ' multiple="multiple"' : "") + '><option value="foo">Foo</option></select>';
    }
    afterIndex() {
        this.initTomSelect();
    }
    initTomSelect() {
        if (this.tomSelect) this.tomSelect.destroy();
        const createHandler = (name)=>(evt)=>this.muDispatchEvent(name, evt);
        const setting = {
            valueField: "id",
            labelField: "name",
            create: this.canAddItem,
            onBlur: createHandler("blur"),
            onChange: createHandler("change"),
            onFocus: createHandler("focus")
        };
        this.useLoad = this.searchCallback != null || this.searchPromiseCallback != null;
        if (this.useLoad) setting.load = (query, callback)=>this.doSearch(query, callback);
        this.tomSelect = new (0, (/*@__PURE__*/$parcel$interopDefault($aspqD)))(this.ui.input, setting);
        this.setOptions(this.options);
    }
    addOption(option) {
        this.tomSelect.addOption(option);
    }
    setOptions(options) {
        this.tomSelect.clearOptions();
        this.tomSelect.addOptions(this.options);
    }
    get value() {
        return this.tomSelect.getValue();
    }
    set value(v) {
        if (this.useLoad) {
            // check and load missing
            const missing = [];
            for(var _iterator = $765a58294435a7ed$var$_createForOfIteratorHelperLoose(Array.isArray(v) ? v : [
                v
            ]), _step; !(_step = _iterator()).done;){
                const val = _step.value;
                if (!this.tomSelect.getOption(val)) missing.push(val);
            }
            if (missing.length) {
                this.doSearch(missing).then((data)=>{
                    this.tomSelect.setValue(v);
                });
                return;
            }
        }
        this.tomSelect.setValue(v);
    }
    muBindData(srcData) {
        this.value = srcData;
    }
    muFetchData() {
        return this.value;
    }
    doSearch(query, callback = null) {
        if (this.searchCallback) return new Promise((resolve, reject)=>{
            this.searchCallback(query, (data)=>{
                if (callback) callback(data);
                resolve(data);
            });
        });
        else if (this.searchPromiseCallback) {
            const prom = this.searchPromiseCallback(query);
            if (callback) prom.then((data)=>callback(data));
            return prom;
        } else throw "No callback";
    }
    constructor(...args){
        super(...args);
        this.canAddItem = true;
        this.multiple = true;
        this.options = [];
    }
}

});
parcelRegister("aspqD", function(module, exports) {
/**
* Tom Select v2.3.1
* Licensed under the Apache License, Version 2.0 (the "License");
*/ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
	 * MicroEvent - to make any js object an event emitter
	 *
	 * - pure javascript - server compatible, browser compatible
	 * - dont rely on the browser doms
	 * - super simple - you get it immediatly, no mistery, no magic involved
	 *
	 * @author Jerome Etienne (https://github.com/jeromeetienne)
	 */ /**
	 * Execute callback for each event in space separated list of event names
	 *
	 */ function forEvents(events, callback) {
        events.split(/\s+/).forEach((event)=>{
            callback(event);
        });
    }
    class MicroEvent {
        constructor(){
            this._events = void 0;
            this._events = {};
        }
        on(events, fct) {
            forEvents(events, (event)=>{
                const event_array = this._events[event] || [];
                event_array.push(fct);
                this._events[event] = event_array;
            });
        }
        off(events, fct) {
            var n = arguments.length;
            if (n === 0) {
                this._events = {};
                return;
            }
            forEvents(events, (event)=>{
                if (n === 1) {
                    delete this._events[event];
                    return;
                }
                const event_array = this._events[event];
                if (event_array === undefined) return;
                event_array.splice(event_array.indexOf(fct), 1);
                this._events[event] = event_array;
            });
        }
        trigger(events, ...args) {
            var self = this;
            forEvents(events, (event)=>{
                const event_array = self._events[event];
                if (event_array === undefined) return;
                event_array.forEach((fct)=>{
                    fct.apply(self, args);
                });
            });
        }
    }
    /**
	 * microplugin.js
	 * Copyright (c) 2013 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */ function MicroPlugin(Interface) {
        Interface.plugins = {};
        return class extends Interface {
            constructor(...args){
                super(...args);
                this.plugins = {
                    names: [],
                    settings: {},
                    requested: {},
                    loaded: {}
                };
            }
            /**
	     * Registers a plugin.
	     *
	     * @param {function} fn
	     */ static define(name, fn) {
                Interface.plugins[name] = {
                    "name": name,
                    "fn": fn
                };
            }
            /**
	     * Initializes the listed plugins (with options).
	     * Acceptable formats:
	     *
	     * List (without options):
	     *   ['a', 'b', 'c']
	     *
	     * List (with options):
	     *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
	     *
	     * Hash (with options):
	     *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
	     *
	     * @param {array|object} plugins
	     */ initializePlugins(plugins) {
                var key, name;
                const self = this;
                const queue = [];
                if (Array.isArray(plugins)) plugins.forEach((plugin)=>{
                    if (typeof plugin === "string") queue.push(plugin);
                    else {
                        self.plugins.settings[plugin.name] = plugin.options;
                        queue.push(plugin.name);
                    }
                });
                else if (plugins) {
                    for(key in plugins)if (plugins.hasOwnProperty(key)) {
                        self.plugins.settings[key] = plugins[key];
                        queue.push(key);
                    }
                }
                while(name = queue.shift())self.require(name);
            }
            loadPlugin(name) {
                var self = this;
                var plugins = self.plugins;
                var plugin = Interface.plugins[name];
                if (!Interface.plugins.hasOwnProperty(name)) throw new Error('Unable to find "' + name + '" plugin');
                plugins.requested[name] = true;
                plugins.loaded[name] = plugin.fn.apply(self, [
                    self.plugins.settings[name] || {}
                ]);
                plugins.names.push(name);
            }
            /**
	     * Initializes a plugin.
	     *
	     */ require(name) {
                var self = this;
                var plugins = self.plugins;
                if (!self.plugins.loaded.hasOwnProperty(name)) {
                    if (plugins.requested[name]) throw new Error('Plugin has circular dependency ("' + name + '")');
                    self.loadPlugin(name);
                }
                return plugins.loaded[name];
            }
        };
    }
    /*! @orchidjs/unicode-variants | https://github.com/orchidjs/unicode-variants | Apache License (v2) */ /**
	 * Convert array of strings to a regular expression
	 *	ex ['ab','a'] => (?:ab|a)
	 * 	ex ['a','b'] => [ab]
	 * @param {string[]} chars
	 * @return {string}
	 */ const arrayToPattern = (chars)=>{
        chars = chars.filter(Boolean);
        if (chars.length < 2) return chars[0] || "";
        return maxValueLength(chars) == 1 ? "[" + chars.join("") + "]" : "(?:" + chars.join("|") + ")";
    };
    /**
	 * @param {string[]} array
	 * @return {string}
	 */ const sequencePattern = (array)=>{
        if (!hasDuplicates(array)) return array.join("");
        let pattern = "";
        let prev_char_count = 0;
        const prev_pattern = ()=>{
            if (prev_char_count > 1) pattern += "{" + prev_char_count + "}";
        };
        array.forEach((char, i)=>{
            if (char === array[i - 1]) {
                prev_char_count++;
                return;
            }
            prev_pattern();
            pattern += char;
            prev_char_count = 1;
        });
        prev_pattern();
        return pattern;
    };
    /**
	 * Convert array of strings to a regular expression
	 *	ex ['ab','a'] => (?:ab|a)
	 * 	ex ['a','b'] => [ab]
	 * @param {Set<string>} chars
	 * @return {string}
	 */ const setToPattern = (chars)=>{
        let array = toArray(chars);
        return arrayToPattern(array);
    };
    /**
	 *
	 * https://stackoverflow.com/questions/7376598/in-javascript-how-do-i-check-if-an-array-has-duplicate-values
	 * @param {any[]} array
	 */ const hasDuplicates = (array)=>{
        return new Set(array).size !== array.length;
    };
    /**
	 * https://stackoverflow.com/questions/63006601/why-does-u-throw-an-invalid-escape-error
	 * @param {string} str
	 * @return {string}
	 */ const escape_regex = (str)=>{
        return (str + "").replace(/([\$\(\)\*\+\.\?\[\]\^\{\|\}\\])/gu, "\\$1");
    };
    /**
	 * Return the max length of array values
	 * @param {string[]} array
	 *
	 */ const maxValueLength = (array)=>{
        return array.reduce((longest, value)=>Math.max(longest, unicodeLength(value)), 0);
    };
    /**
	 * @param {string} str
	 */ const unicodeLength = (str)=>{
        return toArray(str).length;
    };
    /**
	 * @param {any} p
	 * @return {any[]}
	 */ const toArray = (p)=>Array.from(p);
    /*! @orchidjs/unicode-variants | https://github.com/orchidjs/unicode-variants | Apache License (v2) */ /**
	 * Get all possible combinations of substrings that add up to the given string
	 * https://stackoverflow.com/questions/30169587/find-all-the-combination-of-substrings-that-add-up-to-the-given-string
	 * @param {string} input
	 * @return {string[][]}
	 */ const allSubstrings = (input)=>{
        if (input.length === 1) return [
            [
                input
            ]
        ];
        /** @type {string[][]} */ let result = [];
        const start = input.substring(1);
        const suba = allSubstrings(start);
        suba.forEach(function(subresult) {
            let tmp = subresult.slice(0);
            tmp[0] = input.charAt(0) + tmp[0];
            result.push(tmp);
            tmp = subresult.slice(0);
            tmp.unshift(input.charAt(0));
            result.push(tmp);
        });
        return result;
    };
    /*! @orchidjs/unicode-variants | https://github.com/orchidjs/unicode-variants | Apache License (v2) */ /**
	 * @typedef {{[key:string]:string}} TUnicodeMap
	 * @typedef {{[key:string]:Set<string>}} TUnicodeSets
	 * @typedef {[[number,number]]} TCodePoints
	 * @typedef {{folded:string,composed:string,code_point:number}} TCodePointObj
	 * @typedef {{start:number,end:number,length:number,substr:string}} TSequencePart
	 */ /** @type {TCodePoints} */ const code_points = [
        [
            0,
            65535
        ]
    ];
    const accent_pat = "[\u0300-\u036F\xb7\u02BE\u02BC]";
    /** @type {TUnicodeMap} */ let unicode_map;
    /** @type {RegExp} */ let multi_char_reg;
    const max_char_length = 3;
    /** @type {TUnicodeMap} */ const latin_convert = {};
    /** @type {TUnicodeMap} */ const latin_condensed = {
        "/": "\u2044\u2215",
        "0": "\u07C0",
        "a": "\u2C65\u0250\u0251",
        "aa": "\uA733",
        "ae": "\xe6\u01FD\u01E3",
        "ao": "\uA735",
        "au": "\uA737",
        "av": "\uA739\uA73B",
        "ay": "\uA73D",
        "b": "\u0180\u0253\u0183",
        "c": "\uA73F\u0188\u023C\u2184",
        "d": "\u0111\u0257\u0256\u1D05\u018C\uABB7\u0501\u0266",
        "e": "\u025B\u01DD\u1D07\u0247",
        "f": "\uA77C\u0192",
        "g": "\u01E5\u0260\uA7A1\u1D79\uA77F\u0262",
        "h": "\u0127\u2C68\u2C76\u0265",
        "i": "\u0268\u0131",
        "j": "\u0249\u0237",
        "k": "\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
        "l": "\u0142\u019A\u026B\u2C61\uA749\uA747\uA781\u026D",
        "m": "\u0271\u026F\u03FB",
        "n": "\uA7A5\u019E\u0272\uA791\u1D0E\u043B\u0509",
        "o": "\xf8\u01FF\u0254\u0275\uA74B\uA74D\u1D11",
        "oe": "\u0153",
        "oi": "\u01A3",
        "oo": "\uA74F",
        "ou": "\u0223",
        "p": "\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
        "q": "\uA757\uA759\u024B",
        "r": "\u024D\u027D\uA75B\uA7A7\uA783",
        "s": "\xdf\u023F\uA7A9\uA785\u0282",
        "t": "\u0167\u01AD\u0288\u2C66\uA787",
        "th": "\xfe",
        "tz": "\uA729",
        "u": "\u0289",
        "v": "\u028B\uA75F\u028C",
        "vy": "\uA761",
        "w": "\u2C73",
        "y": "\u01B4\u024F\u1EFF",
        "z": "\u01B6\u0225\u0240\u2C6C\uA763",
        "hv": "\u0195"
    };
    for(let latin in latin_condensed){
        let unicode = latin_condensed[latin] || "";
        for(let i = 0; i < unicode.length; i++){
            let char = unicode.substring(i, i + 1);
            latin_convert[char] = latin;
        }
    }
    const convert_pat = new RegExp(Object.keys(latin_convert).join("|") + "|" + accent_pat, "gu");
    /**
	 * Initialize the unicode_map from the give code point ranges
	 *
	 * @param {TCodePoints=} _code_points
	 */ const initialize = (_code_points)=>{
        if (unicode_map !== undefined) return;
        unicode_map = generateMap(_code_points || code_points);
    };
    /**
	 * Helper method for normalize a string
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
	 * @param {string} str
	 * @param {string} form
	 */ const normalize = (str, form = "NFKD")=>str.normalize(form);
    /**
	 * Remove accents without reordering string
	 * calling str.normalize('NFKD') on \u{594}\u{595}\u{596} becomes \u{596}\u{594}\u{595}
	 * via https://github.com/krisk/Fuse/issues/133#issuecomment-318692703
	 * @param {string} str
	 * @return {string}
	 */ const asciifold = (str)=>{
        return toArray(str).reduce(/**
	   * @param {string} result
	   * @param {string} char
	   */ (result, char)=>{
            return result + _asciifold(char);
        }, "");
    };
    /**
	 * @param {string} str
	 * @return {string}
	 */ const _asciifold = (str)=>{
        str = normalize(str).toLowerCase().replace(convert_pat, (/** @type {string} */ char)=>{
            return latin_convert[char] || "";
        }); //return str;
        return normalize(str, "NFC");
    };
    /**
	 * Generate a list of unicode variants from the list of code points
	 * @param {TCodePoints} code_points
	 * @yield {TCodePointObj}
	 */ function* generator(code_points) {
        for (const [code_point_min, code_point_max] of code_points)for(let i = code_point_min; i <= code_point_max; i++){
            let composed = String.fromCharCode(i);
            let folded = asciifold(composed);
            if (folded == composed.toLowerCase()) continue;
             // skip when folded is a string longer than 3 characters long
            // bc the resulting regex patterns will be long
            // eg:
            // folded صلى الله عليه وسلم length 18 code point 65018
            // folded جل جلاله length 8 code point 65019
            if (folded.length > max_char_length) continue;
            if (folded.length == 0) continue;
            yield {
                folded: folded,
                composed: composed,
                code_point: i
            };
        }
    }
    /**
	 * Generate a unicode map from the list of code points
	 * @param {TCodePoints} code_points
	 * @return {TUnicodeSets}
	 */ const generateSets = (code_points)=>{
        /** @type {{[key:string]:Set<string>}} */ const unicode_sets = {};
        /**
	   * @param {string} folded
	   * @param {string} to_add
	   */ const addMatching = (folded, to_add)=>{
            /** @type {Set<string>} */ const folded_set = unicode_sets[folded] || new Set();
            const patt = new RegExp("^" + setToPattern(folded_set) + "$", "iu");
            if (to_add.match(patt)) return;
            folded_set.add(escape_regex(to_add));
            unicode_sets[folded] = folded_set;
        };
        for (let value of generator(code_points)){
            addMatching(value.folded, value.folded);
            addMatching(value.folded, value.composed);
        }
        return unicode_sets;
    };
    /**
	 * Generate a unicode map from the list of code points
	 * ae => (?:(?:ae|Æ|Ǽ|Ǣ)|(?:A|Ⓐ|Ａ...)(?:E|ɛ|Ⓔ...))
	 *
	 * @param {TCodePoints} code_points
	 * @return {TUnicodeMap}
	 */ const generateMap = (code_points)=>{
        /** @type {TUnicodeSets} */ const unicode_sets = generateSets(code_points);
        /** @type {TUnicodeMap} */ const unicode_map = {};
        /** @type {string[]} */ let multi_char = [];
        for(let folded in unicode_sets){
            let set = unicode_sets[folded];
            if (set) unicode_map[folded] = setToPattern(set);
            if (folded.length > 1) multi_char.push(escape_regex(folded));
        }
        multi_char.sort((a, b)=>b.length - a.length);
        const multi_char_patt = arrayToPattern(multi_char);
        multi_char_reg = new RegExp("^" + multi_char_patt, "u");
        return unicode_map;
    };
    /**
	 * Map each element of an array from it's folded value to all possible unicode matches
	 * @param {string[]} strings
	 * @param {number} min_replacement
	 * @return {string}
	 */ const mapSequence = (strings, min_replacement = 1)=>{
        let chars_replaced = 0;
        strings = strings.map((str)=>{
            if (unicode_map[str]) chars_replaced += str.length;
            return unicode_map[str] || str;
        });
        if (chars_replaced >= min_replacement) return sequencePattern(strings);
        return "";
    };
    /**
	 * Convert a short string and split it into all possible patterns
	 * Keep a pattern only if min_replacement is met
	 *
	 * 'abc'
	 * 		=> [['abc'],['ab','c'],['a','bc'],['a','b','c']]
	 *		=> ['abc-pattern','ab-c-pattern'...]
	 *
	 *
	 * @param {string} str
	 * @param {number} min_replacement
	 * @return {string}
	 */ const substringsToPattern = (str, min_replacement = 1)=>{
        min_replacement = Math.max(min_replacement, str.length - 1);
        return arrayToPattern(allSubstrings(str).map((sub_pat)=>{
            return mapSequence(sub_pat, min_replacement);
        }));
    };
    /**
	 * Convert an array of sequences into a pattern
	 * [{start:0,end:3,length:3,substr:'iii'}...] => (?:iii...)
	 *
	 * @param {Sequence[]} sequences
	 * @param {boolean} all
	 */ const sequencesToPattern = (sequences, all = true)=>{
        let min_replacement = sequences.length > 1 ? 1 : 0;
        return arrayToPattern(sequences.map((sequence)=>{
            let seq = [];
            const len = all ? sequence.length() : sequence.length() - 1;
            for(let j = 0; j < len; j++)seq.push(substringsToPattern(sequence.substrs[j] || "", min_replacement));
            return sequencePattern(seq);
        }));
    };
    /**
	 * Return true if the sequence is already in the sequences
	 * @param {Sequence} needle_seq
	 * @param {Sequence[]} sequences
	 */ const inSequences = (needle_seq, sequences)=>{
        for (const seq of sequences){
            if (seq.start != needle_seq.start || seq.end != needle_seq.end) continue;
            if (seq.substrs.join("") !== needle_seq.substrs.join("")) continue;
            let needle_parts = needle_seq.parts;
            /**
	     * @param {TSequencePart} part
	     */ const filter = (part)=>{
                for (const needle_part of needle_parts){
                    if (needle_part.start === part.start && needle_part.substr === part.substr) return false;
                    if (part.length == 1 || needle_part.length == 1) continue;
                     // check for overlapping parts
                    // a = ['::=','==']
                    // b = ['::','===']
                    // a = ['r','sm']
                    // b = ['rs','m']
                    if (part.start < needle_part.start && part.end > needle_part.start) return true;
                    if (needle_part.start < part.start && needle_part.end > part.start) return true;
                }
                return false;
            };
            let filtered = seq.parts.filter(filter);
            if (filtered.length > 0) continue;
            return true;
        }
        return false;
    };
    class Sequence {
        constructor(){
            /** @type {TSequencePart[]} */ this.parts = [];
            /** @type {string[]} */ this.substrs = [];
            this.start = 0;
            this.end = 0;
        }
        /**
	   * @param {TSequencePart|undefined} part
	   */ add(part) {
            if (part) {
                this.parts.push(part);
                this.substrs.push(part.substr);
                this.start = Math.min(part.start, this.start);
                this.end = Math.max(part.end, this.end);
            }
        }
        last() {
            return this.parts[this.parts.length - 1];
        }
        length() {
            return this.parts.length;
        }
        /**
	   * @param {number} position
	   * @param {TSequencePart} last_piece
	   */ clone(position, last_piece) {
            let clone = new Sequence();
            let parts = JSON.parse(JSON.stringify(this.parts));
            let last_part = parts.pop();
            for (const part of parts)clone.add(part);
            let last_substr = last_piece.substr.substring(0, position - last_part.start);
            let clone_last_len = last_substr.length;
            clone.add({
                start: last_part.start,
                end: last_part.start + clone_last_len,
                length: clone_last_len,
                substr: last_substr
            });
            return clone;
        }
    }
    /**
	 * Expand a regular expression pattern to include unicode variants
	 * 	eg /a/ becomes /aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑAⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ/
	 *
	 * Issue:
	 *  ﺊﺋ [ 'ﺊ = \\u{fe8a}', 'ﺋ = \\u{fe8b}' ]
	 *	becomes:	ئئ [ 'ي = \\u{64a}', 'ٔ = \\u{654}', 'ي = \\u{64a}', 'ٔ = \\u{654}' ]
	 *
	 *	İĲ = IIJ = ⅡJ
	 *
	 * 	1/2/4
	 *
	 * @param {string} str
	 * @return {string|undefined}
	 */ const getPattern = (str)=>{
        initialize();
        str = asciifold(str);
        let pattern = "";
        let sequences = [
            new Sequence()
        ];
        for(let i = 0; i < str.length; i++){
            let substr = str.substring(i);
            let match = substr.match(multi_char_reg);
            const char = str.substring(i, i + 1);
            const match_str = match ? match[0] : null; // loop through sequences
            // add either the char or multi_match
            let overlapping = [];
            let added_types = new Set();
            for (const sequence of sequences){
                const last_piece = sequence.last();
                if (!last_piece || last_piece.length == 1 || last_piece.end <= i) {
                    // if we have a multi match
                    if (match_str) {
                        const len = match_str.length;
                        sequence.add({
                            start: i,
                            end: i + len,
                            length: len,
                            substr: match_str
                        });
                        added_types.add("1");
                    } else {
                        sequence.add({
                            start: i,
                            end: i + 1,
                            length: 1,
                            substr: char
                        });
                        added_types.add("2");
                    }
                } else if (match_str) {
                    let clone = sequence.clone(i, last_piece);
                    const len = match_str.length;
                    clone.add({
                        start: i,
                        end: i + len,
                        length: len,
                        substr: match_str
                    });
                    overlapping.push(clone);
                } else // don't add char
                // adding would create invalid patterns: 234 => [2,34,4]
                added_types.add("3");
            } // if we have overlapping
            if (overlapping.length > 0) {
                // ['ii','iii'] before ['i','i','iii']
                overlapping = overlapping.sort((a, b)=>{
                    return a.length() - b.length();
                });
                for (let clone of overlapping){
                    // don't add if we already have an equivalent sequence
                    if (inSequences(clone, sequences)) continue;
                    sequences.push(clone);
                }
                continue;
            } // if we haven't done anything unique
            // clean up the patterns
            // helps keep patterns smaller
            // if str = 'r₨㎧aarss', pattern will be 446 instead of 655
            if (i > 0 && added_types.size == 1 && !added_types.has("3")) {
                pattern += sequencesToPattern(sequences, false);
                let new_seq = new Sequence();
                const old_seq = sequences[0];
                if (old_seq) new_seq.add(old_seq.last());
                sequences = [
                    new_seq
                ];
            }
        }
        pattern += sequencesToPattern(sequences, true);
        return pattern;
    };
    /*! sifter.js | https://github.com/orchidjs/sifter.js | Apache License (v2) */ /**
	 * A property getter resolving dot-notation
	 * @param  {Object}  obj     The root object to fetch property on
	 * @param  {String}  name    The optionally dotted property name to fetch
	 * @return {Object}          The resolved property value
	 */ const getAttr = (obj, name)=>{
        if (!obj) return;
        return obj[name];
    };
    /**
	 * A property getter resolving dot-notation
	 * @param  {Object}  obj     The root object to fetch property on
	 * @param  {String}  name    The optionally dotted property name to fetch
	 * @return {Object}          The resolved property value
	 */ const getAttrNesting = (obj, name)=>{
        if (!obj) return;
        var part, names = name.split(".");
        while((part = names.shift()) && (obj = obj[part]));
        return obj;
    };
    /**
	 * Calculates how close of a match the
	 * given value is against a search token.
	 *
	 */ const scoreValue = (value, token, weight)=>{
        var score, pos;
        if (!value) return 0;
        value = value + "";
        if (token.regex == null) return 0;
        pos = value.search(token.regex);
        if (pos === -1) return 0;
        score = token.string.length / value.length;
        if (pos === 0) score += 0.5;
        return score * weight;
    };
    /**
	 * Cast object property to an array if it exists and has a value
	 *
	 */ const propToArray = (obj, key)=>{
        var value = obj[key];
        if (typeof value == "function") return value;
        if (value && !Array.isArray(value)) obj[key] = [
            value
        ];
    };
    /**
	 * Iterates over arrays and hashes.
	 *
	 * ```
	 * iterate(this.items, function(item, id) {
	 *    // invoked for each item
	 * });
	 * ```
	 *
	 */ const iterate$1 = (object, callback)=>{
        if (Array.isArray(object)) object.forEach(callback);
        else {
            for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
        }
    };
    const cmp = (a, b)=>{
        if (typeof a === "number" && typeof b === "number") return a > b ? 1 : a < b ? -1 : 0;
        a = asciifold(a + "").toLowerCase();
        b = asciifold(b + "").toLowerCase();
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
    };
    /*! sifter.js | https://github.com/orchidjs/sifter.js | Apache License (v2) */ /**
	 * sifter.js
	 * Copyright (c) 2013–2020 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */ class Sifter {
        // []|{};
        /**
	   * Textually searches arrays and hashes of objects
	   * by property (or multiple properties). Designed
	   * specifically for autocomplete.
	   *
	   */ constructor(items, settings){
            this.items = void 0;
            this.settings = void 0;
            this.items = items;
            this.settings = settings || {
                diacritics: true
            };
        }
        /**
	   * Splits a search string into an array of individual
	   * regexps to be used to match results.
	   *
	   */ tokenize(query, respect_word_boundaries, weights) {
            if (!query || !query.length) return [];
            const tokens = [];
            const words = query.split(/\s+/);
            var field_regex;
            if (weights) field_regex = new RegExp("^(" + Object.keys(weights).map(escape_regex).join("|") + "):(.*)$");
            words.forEach((word)=>{
                let field_match;
                let field = null;
                let regex = null; // look for "field:query" tokens
                if (field_regex && (field_match = word.match(field_regex))) {
                    field = field_match[1];
                    word = field_match[2];
                }
                if (word.length > 0) {
                    if (this.settings.diacritics) regex = getPattern(word) || null;
                    else regex = escape_regex(word);
                    if (regex && respect_word_boundaries) regex = "\\b" + regex;
                }
                tokens.push({
                    string: word,
                    regex: regex ? new RegExp(regex, "iu") : null,
                    field: field
                });
            });
            return tokens;
        }
        /**
	   * Returns a function to be used to score individual results.
	   *
	   * Good matches will have a higher score than poor matches.
	   * If an item is not a match, 0 will be returned by the function.
	   *
	   * @returns {T.ScoreFn}
	   */ getScoreFunction(query, options) {
            var search = this.prepareSearch(query, options);
            return this._getScoreFunction(search);
        }
        /**
	   * @returns {T.ScoreFn}
	   *
	   */ _getScoreFunction(search) {
            const tokens = search.tokens, token_count = tokens.length;
            if (!token_count) return function() {
                return 0;
            };
            const fields = search.options.fields, weights = search.weights, field_count = fields.length, getAttrFn = search.getAttrFn;
            if (!field_count) return function() {
                return 1;
            };
            /**
	     * Calculates the score of an object
	     * against the search query.
	     *
	     */ const scoreObject = function() {
                if (field_count === 1) return function(token, data) {
                    const field = fields[0].field;
                    return scoreValue(getAttrFn(data, field), token, weights[field] || 1);
                };
                return function(token, data) {
                    var sum = 0; // is the token specific to a field?
                    if (token.field) {
                        const value = getAttrFn(data, token.field);
                        if (!token.regex && value) sum += 1 / field_count;
                        else sum += scoreValue(value, token, 1);
                    } else iterate$1(weights, (weight, field)=>{
                        sum += scoreValue(getAttrFn(data, field), token, weight);
                    });
                    return sum / field_count;
                };
            }();
            if (token_count === 1) return function(data) {
                return scoreObject(tokens[0], data);
            };
            if (search.options.conjunction === "and") return function(data) {
                var score, sum = 0;
                for (let token of tokens){
                    score = scoreObject(token, data);
                    if (score <= 0) return 0;
                    sum += score;
                }
                return sum / token_count;
            };
            else return function(data) {
                var sum = 0;
                iterate$1(tokens, (token)=>{
                    sum += scoreObject(token, data);
                });
                return sum / token_count;
            };
        }
        /**
	   * Returns a function that can be used to compare two
	   * results, for sorting purposes. If no sorting should
	   * be performed, `null` will be returned.
	   *
	   * @return function(a,b)
	   */ getSortFunction(query, options) {
            var search = this.prepareSearch(query, options);
            return this._getSortFunction(search);
        }
        _getSortFunction(search) {
            var implicit_score, sort_flds = [];
            const self = this, options = search.options, sort = !search.query && options.sort_empty ? options.sort_empty : options.sort;
            if (typeof sort == "function") return sort.bind(this);
            /**
	     * Fetches the specified sort field value
	     * from a search result item.
	     *
	     */ const get_field = function get_field(name, result) {
                if (name === "$score") return result.score;
                return search.getAttrFn(self.items[result.id], name);
            }; // parse options
            if (sort) {
                for (let s of sort)if (search.query || s.field !== "$score") sort_flds.push(s);
            } // the "$score" field is implied to be the primary
            // sort field, unless it's manually specified
            if (search.query) {
                implicit_score = true;
                for (let fld of sort_flds)if (fld.field === "$score") {
                    implicit_score = false;
                    break;
                }
                if (implicit_score) sort_flds.unshift({
                    field: "$score",
                    direction: "desc"
                });
                 // without a search.query, all items will have the same score
            } else sort_flds = sort_flds.filter((fld)=>fld.field !== "$score");
             // build function
            const sort_flds_count = sort_flds.length;
            if (!sort_flds_count) return null;
            return function(a, b) {
                var result, field;
                for (let sort_fld of sort_flds){
                    field = sort_fld.field;
                    let multiplier = sort_fld.direction === "desc" ? -1 : 1;
                    result = multiplier * cmp(get_field(field, a), get_field(field, b));
                    if (result) return result;
                }
                return 0;
            };
        }
        /**
	   * Parses a search query and returns an object
	   * with tokens and fields ready to be populated
	   * with results.
	   *
	   */ prepareSearch(query, optsUser) {
            const weights = {};
            var options = Object.assign({}, optsUser);
            propToArray(options, "sort");
            propToArray(options, "sort_empty"); // convert fields to new format
            if (options.fields) {
                propToArray(options, "fields");
                const fields = [];
                options.fields.forEach((field)=>{
                    if (typeof field == "string") field = {
                        field: field,
                        weight: 1
                    };
                    fields.push(field);
                    weights[field.field] = "weight" in field ? field.weight : 1;
                });
                options.fields = fields;
            }
            return {
                options: options,
                query: query.toLowerCase().trim(),
                tokens: this.tokenize(query, options.respect_word_boundaries, weights),
                total: 0,
                items: [],
                weights: weights,
                getAttrFn: options.nesting ? getAttrNesting : getAttr
            };
        }
        /**
	   * Searches through all items and returns a sorted array of matches.
	   *
	   */ search(query, options) {
            var self = this, score, search;
            search = this.prepareSearch(query, options);
            options = search.options;
            query = search.query; // generate result scoring function
            const fn_score = options.score || self._getScoreFunction(search); // perform search and sort
            if (query.length) iterate$1(self.items, (item, id)=>{
                score = fn_score(item);
                if (options.filter === false || score > 0) search.items.push({
                    "score": score,
                    "id": id
                });
            });
            else iterate$1(self.items, (_, id)=>{
                search.items.push({
                    "score": 1,
                    "id": id
                });
            });
            const fn_sort = self._getSortFunction(search);
            if (fn_sort) search.items.sort(fn_sort); // apply limits
            search.total = search.items.length;
            if (typeof options.limit === "number") search.items = search.items.slice(0, options.limit);
            return search;
        }
    }
    /**
	 * Iterates over arrays and hashes.
	 *
	 * ```
	 * iterate(this.items, function(item, id) {
	 *    // invoked for each item
	 * });
	 * ```
	 *
	 */ const iterate = (object, callback)=>{
        if (Array.isArray(object)) object.forEach(callback);
        else {
            for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
        }
    };
    /**
	 * Return a dom element from either a dom query string, jQuery object, a dom element or html string
	 * https://stackoverflow.com/questions/494143/creating-a-new-dom-element-from-an-html-string-using-built-in-dom-methods-or-pro/35385518#35385518
	 *
	 * param query should be {}
	 */ const getDom = (query)=>{
        if (query.jquery) return query[0];
        if (query instanceof HTMLElement) return query;
        if (isHtmlString(query)) {
            var tpl = document.createElement("template");
            tpl.innerHTML = query.trim(); // Never return a text node of whitespace as the result
            return tpl.content.firstChild;
        }
        return document.querySelector(query);
    };
    const isHtmlString = (arg)=>{
        if (typeof arg === "string" && arg.indexOf("<") > -1) return true;
        return false;
    };
    const escapeQuery = (query)=>{
        return query.replace(/['"\\]/g, "\\$&");
    };
    /**
	 * Dispatch an event
	 *
	 */ const triggerEvent = (dom_el, event_name)=>{
        var event = document.createEvent("HTMLEvents");
        event.initEvent(event_name, true, false);
        dom_el.dispatchEvent(event);
    };
    /**
	 * Apply CSS rules to a dom element
	 *
	 */ const applyCSS = (dom_el, css)=>{
        Object.assign(dom_el.style, css);
    };
    /**
	 * Add css classes
	 *
	 */ const addClasses = (elmts, ...classes)=>{
        var norm_classes = classesArray(classes);
        elmts = castAsArray(elmts);
        elmts.map((el)=>{
            norm_classes.map((cls)=>{
                el.classList.add(cls);
            });
        });
    };
    /**
	 * Remove css classes
	 *
	 */ const removeClasses = (elmts, ...classes)=>{
        var norm_classes = classesArray(classes);
        elmts = castAsArray(elmts);
        elmts.map((el)=>{
            norm_classes.map((cls)=>{
                el.classList.remove(cls);
            });
        });
    };
    /**
	 * Return arguments
	 *
	 */ const classesArray = (args)=>{
        var classes = [];
        iterate(args, (_classes)=>{
            if (typeof _classes === "string") _classes = _classes.trim().split(/[\11\12\14\15\40]/);
            if (Array.isArray(_classes)) classes = classes.concat(_classes);
        });
        return classes.filter(Boolean);
    };
    /**
	 * Create an array from arg if it's not already an array
	 *
	 */ const castAsArray = (arg)=>{
        if (!Array.isArray(arg)) arg = [
            arg
        ];
        return arg;
    };
    /**
	 * Get the closest node to the evt.target matching the selector
	 * Stops at wrapper
	 *
	 */ const parentMatch = (target, selector, wrapper)=>{
        if (wrapper && !wrapper.contains(target)) return;
        while(target && target.matches){
            if (target.matches(selector)) return target;
            target = target.parentNode;
        }
    };
    /**
	 * Get the first or last item from an array
	 *
	 * > 0 - right (last)
	 * <= 0 - left (first)
	 *
	 */ const getTail = (list, direction = 0)=>{
        if (direction > 0) return list[list.length - 1];
        return list[0];
    };
    /**
	 * Return true if an object is empty
	 *
	 */ const isEmptyObject = (obj)=>{
        return Object.keys(obj).length === 0;
    };
    /**
	 * Get the index of an element amongst sibling nodes of the same type
	 *
	 */ const nodeIndex = (el, amongst)=>{
        if (!el) return -1;
        amongst = amongst || el.nodeName;
        var i = 0;
        while(el = el.previousElementSibling)if (el.matches(amongst)) i++;
        return i;
    };
    /**
	 * Set attributes of an element
	 *
	 */ const setAttr = (el, attrs)=>{
        iterate(attrs, (val, attr)=>{
            if (val == null) el.removeAttribute(attr);
            else el.setAttribute(attr, "" + val);
        });
    };
    /**
	 * Replace a node
	 */ const replaceNode = (existing, replacement)=>{
        if (existing.parentNode) existing.parentNode.replaceChild(replacement, existing);
    };
    /**
	 * highlight v3 | MIT license | Johann Burkard <jb@eaio.com>
	 * Highlights arbitrary terms in a node.
	 *
	 * - Modified by Marshal <beatgates@gmail.com> 2011-6-24 (added regex)
	 * - Modified by Brian Reavis <brian@thirdroute.com> 2012-8-27 (cleanup)
	 */ const highlight = (element, regex)=>{
        if (regex === null) return;
        // convet string to regex
        if (typeof regex === "string") {
            if (!regex.length) return;
            regex = new RegExp(regex, "i");
        }
        // Wrap matching part of text node with highlighting <span>, e.g.
        // Soccer  ->  <span class="highlight">Soc</span>cer  for regex = /soc/i
        const highlightText = (node)=>{
            var match = node.data.match(regex);
            if (match && node.data.length > 0) {
                var spannode = document.createElement("span");
                spannode.className = "highlight";
                var middlebit = node.splitText(match.index);
                middlebit.splitText(match[0].length);
                var middleclone = middlebit.cloneNode(true);
                spannode.appendChild(middleclone);
                replaceNode(middlebit, spannode);
                return 1;
            }
            return 0;
        };
        // Recurse element node, looking for child text nodes to highlight, unless element
        // is childless, <script>, <style>, or already highlighted: <span class="hightlight">
        const highlightChildren = (node)=>{
            if (node.nodeType === 1 && node.childNodes && !/(script|style)/i.test(node.tagName) && (node.className !== "highlight" || node.tagName !== "SPAN")) Array.from(node.childNodes).forEach((element)=>{
                highlightRecursive(element);
            });
        };
        const highlightRecursive = (node)=>{
            if (node.nodeType === 3) return highlightText(node);
            highlightChildren(node);
            return 0;
        };
        highlightRecursive(element);
    };
    /**
	 * removeHighlight fn copied from highlight v5 and
	 * edited to remove with(), pass js strict mode, and use without jquery
	 */ const removeHighlight = (el)=>{
        var elements = el.querySelectorAll("span.highlight");
        Array.prototype.forEach.call(elements, function(el) {
            var parent = el.parentNode;
            parent.replaceChild(el.firstChild, el);
            parent.normalize();
        });
    };
    const KEY_A = 65;
    const KEY_RETURN = 13;
    const KEY_ESC = 27;
    const KEY_LEFT = 37;
    const KEY_UP = 38;
    const KEY_RIGHT = 39;
    const KEY_DOWN = 40;
    const KEY_BACKSPACE = 8;
    const KEY_DELETE = 46;
    const KEY_TAB = 9;
    const IS_MAC = typeof navigator === "undefined" ? false : /Mac/.test(navigator.userAgent);
    const KEY_SHORTCUT = IS_MAC ? "metaKey" : "ctrlKey"; // ctrl key or apple key for ma
    var defaults = {
        options: [],
        optgroups: [],
        plugins: [],
        delimiter: ",",
        splitOn: null,
        // regexp or string for splitting up values from a paste command
        persist: true,
        diacritics: true,
        create: null,
        createOnBlur: false,
        createFilter: null,
        highlight: true,
        openOnFocus: true,
        shouldOpen: null,
        maxOptions: 50,
        maxItems: null,
        hideSelected: null,
        duplicates: false,
        addPrecedence: false,
        selectOnTab: false,
        preload: null,
        allowEmptyOption: false,
        //closeAfterSelect: false,
        refreshThrottle: 300,
        loadThrottle: 300,
        loadingClass: "loading",
        dataAttr: null,
        //'data-data',
        optgroupField: "optgroup",
        valueField: "value",
        labelField: "text",
        disabledField: "disabled",
        optgroupLabelField: "label",
        optgroupValueField: "value",
        lockOptgroupOrder: false,
        sortField: "$order",
        searchField: [
            "text"
        ],
        searchConjunction: "and",
        mode: null,
        wrapperClass: "ts-wrapper",
        controlClass: "ts-control",
        dropdownClass: "ts-dropdown",
        dropdownContentClass: "ts-dropdown-content",
        itemClass: "item",
        optionClass: "option",
        dropdownParent: null,
        controlInput: '<input type="text" autocomplete="off" size="1" />',
        copyClassesToDropdown: false,
        placeholder: null,
        hidePlaceholder: null,
        shouldLoad: function(query) {
            return query.length > 0;
        },
        /*
	  load                 : null, // function(query, callback) { ... }
	  score                : null, // function(search) { ... }
	  onInitialize         : null, // function() { ... }
	  onChange             : null, // function(value) { ... }
	  onItemAdd            : null, // function(value, $item) { ... }
	  onItemRemove         : null, // function(value) { ... }
	  onClear              : null, // function() { ... }
	  onOptionAdd          : null, // function(value, data) { ... }
	  onOptionRemove       : null, // function(value) { ... }
	  onOptionClear        : null, // function() { ... }
	  onOptionGroupAdd     : null, // function(id, data) { ... }
	  onOptionGroupRemove  : null, // function(id) { ... }
	  onOptionGroupClear   : null, // function() { ... }
	  onDropdownOpen       : null, // function(dropdown) { ... }
	  onDropdownClose      : null, // function(dropdown) { ... }
	  onType               : null, // function(str) { ... }
	  onDelete             : null, // function(values) { ... }
	  */ render: {
        }
    };
    /**
	 * Converts a scalar to its best string representation
	 * for hash keys and HTML attribute values.
	 *
	 * Transformations:
	 *   'str'     -> 'str'
	 *   null      -> ''
	 *   undefined -> ''
	 *   true      -> '1'
	 *   false     -> '0'
	 *   0         -> '0'
	 *   1         -> '1'
	 *
	 */ const hash_key = (value)=>{
        if (typeof value === "undefined" || value === null) return null;
        return get_hash(value);
    };
    const get_hash = (value)=>{
        if (typeof value === "boolean") return value ? "1" : "0";
        return value + "";
    };
    /**
	 * Escapes a string for use within HTML.
	 *
	 */ const escape_html = (str)=>{
        return (str + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    };
    /**
	 * use setTimeout if timeout > 0 
	 */ const timeout = (fn, timeout)=>{
        if (timeout > 0) return setTimeout(fn, timeout);
        fn.call(null);
        return null;
    };
    /**
	 * Debounce the user provided load function
	 *
	 */ const loadDebounce = (fn, delay)=>{
        var timeout;
        return function(value, callback) {
            var self = this;
            if (timeout) {
                self.loading = Math.max(self.loading - 1, 0);
                clearTimeout(timeout);
            }
            timeout = setTimeout(function() {
                timeout = null;
                self.loadedSearches[value] = true;
                fn.call(self, value, callback);
            }, delay);
        };
    };
    /**
	 * Debounce all fired events types listed in `types`
	 * while executing the provided `fn`.
	 *
	 */ const debounce_events = (self, types, fn)=>{
        var type;
        var trigger = self.trigger;
        var event_args = {};
        // override trigger method
        self.trigger = function() {
            var type = arguments[0];
            if (types.indexOf(type) !== -1) event_args[type] = arguments;
            else return trigger.apply(self, arguments);
        };
        // invoke provided function
        fn.apply(self, []);
        self.trigger = trigger;
        // trigger queued events
        for (type of types)if (type in event_args) trigger.apply(self, event_args[type]);
    };
    /**
	 * Determines the current selection within a text input control.
	 * Returns an object containing:
	 *   - start
	 *   - length
	 *
	 * Note: "selectionStart, selectionEnd ... apply only to inputs of types text, search, URL, tel and password"
	 * 	- https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
	 */ const getSelection = (input)=>{
        return {
            start: input.selectionStart || 0,
            length: (input.selectionEnd || 0) - (input.selectionStart || 0)
        };
    };
    /**
	 * Prevent default
	 *
	 */ const preventDefault = (evt, stop = false)=>{
        if (evt) {
            evt.preventDefault();
            if (stop) evt.stopPropagation();
        }
    };
    /**
	 * Add event helper
	 *
	 */ const addEvent = (target, type, callback, options)=>{
        target.addEventListener(type, callback, options);
    };
    /**
	 * Return true if the requested key is down
	 * Will return false if more than one control character is pressed ( when [ctrl+shift+a] != [ctrl+a] )
	 * The current evt may not always set ( eg calling advanceSelection() )
	 *
	 */ const isKeyDown = (key_name, evt)=>{
        if (!evt) return false;
        if (!evt[key_name]) return false;
        var count = (evt.altKey ? 1 : 0) + (evt.ctrlKey ? 1 : 0) + (evt.shiftKey ? 1 : 0) + (evt.metaKey ? 1 : 0);
        if (count === 1) return true;
        return false;
    };
    /**
	 * Get the id of an element
	 * If the id attribute is not set, set the attribute with the given id
	 *
	 */ const getId = (el, id)=>{
        const existing_id = el.getAttribute("id");
        if (existing_id) return existing_id;
        el.setAttribute("id", id);
        return id;
    };
    /**
	 * Returns a string with backslashes added before characters that need to be escaped.
	 */ const addSlashes = (str)=>{
        return str.replace(/[\\"']/g, "\\$&");
    };
    /**
	 *
	 */ const append = (parent, node)=>{
        if (node) parent.append(node);
    };
    function getSettings(input, settings_user) {
        var settings = Object.assign({}, defaults, settings_user);
        var attr_data = settings.dataAttr;
        var field_label = settings.labelField;
        var field_value = settings.valueField;
        var field_disabled = settings.disabledField;
        var field_optgroup = settings.optgroupField;
        var field_optgroup_label = settings.optgroupLabelField;
        var field_optgroup_value = settings.optgroupValueField;
        var tag_name = input.tagName.toLowerCase();
        var placeholder = input.getAttribute("placeholder") || input.getAttribute("data-placeholder");
        if (!placeholder && !settings.allowEmptyOption) {
            let option = input.querySelector('option[value=""]');
            if (option) placeholder = option.textContent;
        }
        var settings_element = {
            placeholder: placeholder,
            options: [],
            optgroups: [],
            items: [],
            maxItems: null
        };
        /**
	   * Initialize from a <select> element.
	   *
	   */ var init_select = ()=>{
            var tagName;
            var options = settings_element.options;
            var optionsMap = {};
            var group_count = 1;
            let $order = 0;
            var readData = (el)=>{
                var data = Object.assign({}, el.dataset); // get plain object from DOMStringMap
                var json = attr_data && data[attr_data];
                if (typeof json === "string" && json.length) data = Object.assign(data, JSON.parse(json));
                return data;
            };
            var addOption = (option, group)=>{
                var value = hash_key(option.value);
                if (value == null) return;
                if (!value && !settings.allowEmptyOption) return;
                // if the option already exists, it's probably been
                // duplicated in another optgroup. in this case, push
                // the current group to the "optgroup" property on the
                // existing option so that it's rendered in both places.
                if (optionsMap.hasOwnProperty(value)) {
                    if (group) {
                        var arr = optionsMap[value][field_optgroup];
                        if (!arr) optionsMap[value][field_optgroup] = group;
                        else if (!Array.isArray(arr)) optionsMap[value][field_optgroup] = [
                            arr,
                            group
                        ];
                        else arr.push(group);
                    }
                } else {
                    var option_data = readData(option);
                    option_data[field_label] = option_data[field_label] || option.textContent;
                    option_data[field_value] = option_data[field_value] || value;
                    option_data[field_disabled] = option_data[field_disabled] || option.disabled;
                    option_data[field_optgroup] = option_data[field_optgroup] || group;
                    option_data.$option = option;
                    option_data.$order = option_data.$order || ++$order;
                    optionsMap[value] = option_data;
                    options.push(option_data);
                }
                if (option.selected) settings_element.items.push(value);
            };
            var addGroup = (optgroup)=>{
                var id, optgroup_data;
                optgroup_data = readData(optgroup);
                optgroup_data[field_optgroup_label] = optgroup_data[field_optgroup_label] || optgroup.getAttribute("label") || "";
                optgroup_data[field_optgroup_value] = optgroup_data[field_optgroup_value] || group_count++;
                optgroup_data[field_disabled] = optgroup_data[field_disabled] || optgroup.disabled;
                optgroup_data.$order = optgroup_data.$order || ++$order;
                settings_element.optgroups.push(optgroup_data);
                id = optgroup_data[field_optgroup_value];
                iterate(optgroup.children, (option)=>{
                    addOption(option, id);
                });
            };
            settings_element.maxItems = input.hasAttribute("multiple") ? null : 1;
            iterate(input.children, (child)=>{
                tagName = child.tagName.toLowerCase();
                if (tagName === "optgroup") addGroup(child);
                else if (tagName === "option") addOption(child);
            });
        };
        /**
	   * Initialize from a <input type="text"> element.
	   *
	   */ var init_textbox = ()=>{
            const data_raw = input.getAttribute(attr_data);
            if (!data_raw) {
                var value = input.value.trim() || "";
                if (!settings.allowEmptyOption && !value.length) return;
                const values = value.split(settings.delimiter);
                iterate(values, (value)=>{
                    const option = {};
                    option[field_label] = value;
                    option[field_value] = value;
                    settings_element.options.push(option);
                });
                settings_element.items = values;
            } else {
                settings_element.options = JSON.parse(data_raw);
                iterate(settings_element.options, (opt)=>{
                    settings_element.items.push(opt[field_value]);
                });
            }
        };
        if (tag_name === "select") init_select();
        else init_textbox();
        return Object.assign({}, defaults, settings_element, settings_user);
    }
    var instance_i = 0;
    class TomSelect1 extends MicroPlugin(MicroEvent) {
        constructor(input_arg, user_settings){
            super();
            this.control_input = void 0;
            this.wrapper = void 0;
            this.dropdown = void 0;
            this.control = void 0;
            this.dropdown_content = void 0;
            this.focus_node = void 0;
            this.order = 0;
            this.settings = void 0;
            this.input = void 0;
            this.tabIndex = void 0;
            this.is_select_tag = void 0;
            this.rtl = void 0;
            this.inputId = void 0;
            this._destroy = void 0;
            this.sifter = void 0;
            this.isOpen = false;
            this.isDisabled = false;
            this.isReadOnly = false;
            this.isRequired = void 0;
            this.isInvalid = false;
            // @deprecated 1.8
            this.isValid = true;
            this.isLocked = false;
            this.isFocused = false;
            this.isInputHidden = false;
            this.isSetup = false;
            this.ignoreFocus = false;
            this.ignoreHover = false;
            this.hasOptions = false;
            this.currentResults = void 0;
            this.lastValue = "";
            this.caretPos = 0;
            this.loading = 0;
            this.loadedSearches = {};
            this.activeOption = null;
            this.activeItems = [];
            this.optgroups = {};
            this.options = {};
            this.userOptions = {};
            this.items = [];
            this.refreshTimeout = null;
            instance_i++;
            var dir;
            var input = getDom(input_arg);
            if (input.tomselect) throw new Error("Tom Select already initialized on this element");
            input.tomselect = this;
            // detect rtl environment
            var computedStyle = window.getComputedStyle && window.getComputedStyle(input, null);
            dir = computedStyle.getPropertyValue("direction");
            // setup default state
            const settings = getSettings(input, user_settings);
            this.settings = settings;
            this.input = input;
            this.tabIndex = input.tabIndex || 0;
            this.is_select_tag = input.tagName.toLowerCase() === "select";
            this.rtl = /rtl/i.test(dir);
            this.inputId = getId(input, "tomselect-" + instance_i);
            this.isRequired = input.required;
            // search system
            this.sifter = new Sifter(this.options, {
                diacritics: settings.diacritics
            });
            // option-dependent defaults
            settings.mode = settings.mode || (settings.maxItems === 1 ? "single" : "multi");
            if (typeof settings.hideSelected !== "boolean") settings.hideSelected = settings.mode === "multi";
            if (typeof settings.hidePlaceholder !== "boolean") settings.hidePlaceholder = settings.mode !== "multi";
            // set up createFilter callback
            var filter = settings.createFilter;
            if (typeof filter !== "function") {
                if (typeof filter === "string") filter = new RegExp(filter);
                if (filter instanceof RegExp) settings.createFilter = (input)=>filter.test(input);
                else settings.createFilter = (value)=>{
                    return this.settings.duplicates || !this.options[value];
                };
            }
            this.initializePlugins(settings.plugins);
            this.setupCallbacks();
            this.setupTemplates();
            // Create all elements
            const wrapper = getDom("<div>");
            const control = getDom("<div>");
            const dropdown = this._render("dropdown");
            const dropdown_content = getDom(`<div role="listbox" tabindex="-1">`);
            const classes = this.input.getAttribute("class") || "";
            const inputMode = settings.mode;
            var control_input;
            addClasses(wrapper, settings.wrapperClass, classes, inputMode);
            addClasses(control, settings.controlClass);
            append(wrapper, control);
            addClasses(dropdown, settings.dropdownClass, inputMode);
            if (settings.copyClassesToDropdown) addClasses(dropdown, classes);
            addClasses(dropdown_content, settings.dropdownContentClass);
            append(dropdown, dropdown_content);
            getDom(settings.dropdownParent || wrapper).appendChild(dropdown);
            // default controlInput
            if (isHtmlString(settings.controlInput)) {
                control_input = getDom(settings.controlInput);
                // set attributes
                var attrs = [
                    "autocorrect",
                    "autocapitalize",
                    "autocomplete",
                    "spellcheck"
                ];
                iterate$1(attrs, (attr)=>{
                    if (input.getAttribute(attr)) setAttr(control_input, {
                        [attr]: input.getAttribute(attr)
                    });
                });
                control_input.tabIndex = -1;
                control.appendChild(control_input);
                this.focus_node = control_input;
            // dom element
            } else if (settings.controlInput) {
                control_input = getDom(settings.controlInput);
                this.focus_node = control_input;
            } else {
                control_input = getDom("<input/>");
                this.focus_node = control;
            }
            this.wrapper = wrapper;
            this.dropdown = dropdown;
            this.dropdown_content = dropdown_content;
            this.control = control;
            this.control_input = control_input;
            this.setup();
        }
        /**
	   * set up event bindings.
	   *
	   */ setup() {
            const self = this;
            const settings = self.settings;
            const control_input = self.control_input;
            const dropdown = self.dropdown;
            const dropdown_content = self.dropdown_content;
            const wrapper = self.wrapper;
            const control = self.control;
            const input = self.input;
            const focus_node = self.focus_node;
            const passive_event = {
                passive: true
            };
            const listboxId = self.inputId + "-ts-dropdown";
            setAttr(dropdown_content, {
                id: listboxId
            });
            setAttr(focus_node, {
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-expanded": "false",
                "aria-controls": listboxId
            });
            const control_id = getId(focus_node, self.inputId + "-ts-control");
            const query = "label[for='" + escapeQuery(self.inputId) + "']";
            const label = document.querySelector(query);
            const label_click = self.focus.bind(self);
            if (label) {
                addEvent(label, "click", label_click);
                setAttr(label, {
                    for: control_id
                });
                const label_id = getId(label, self.inputId + "-ts-label");
                setAttr(focus_node, {
                    "aria-labelledby": label_id
                });
                setAttr(dropdown_content, {
                    "aria-labelledby": label_id
                });
            }
            wrapper.style.width = input.style.width;
            if (self.plugins.names.length) {
                const classes_plugins = "plugin-" + self.plugins.names.join(" plugin-");
                addClasses([
                    wrapper,
                    dropdown
                ], classes_plugins);
            }
            if ((settings.maxItems === null || settings.maxItems > 1) && self.is_select_tag) setAttr(input, {
                multiple: "multiple"
            });
            if (settings.placeholder) setAttr(control_input, {
                placeholder: settings.placeholder
            });
            // if splitOn was not passed in, construct it from the delimiter to allow pasting universally
            if (!settings.splitOn && settings.delimiter) settings.splitOn = new RegExp("\\s*" + escape_regex(settings.delimiter) + "+\\s*");
            // debounce user defined load() if loadThrottle > 0
            // after initializePlugins() so plugins can create/modify user defined loaders
            if (settings.load && settings.loadThrottle) settings.load = loadDebounce(settings.load, settings.loadThrottle);
            addEvent(dropdown, "mousemove", ()=>{
                self.ignoreHover = false;
            });
            addEvent(dropdown, "mouseenter", (e)=>{
                var target_match = parentMatch(e.target, "[data-selectable]", dropdown);
                if (target_match) self.onOptionHover(e, target_match);
            }, {
                capture: true
            });
            // clicking on an option should select it
            addEvent(dropdown, "click", (evt)=>{
                const option = parentMatch(evt.target, "[data-selectable]");
                if (option) {
                    self.onOptionSelect(evt, option);
                    preventDefault(evt, true);
                }
            });
            addEvent(control, "click", (evt)=>{
                var target_match = parentMatch(evt.target, "[data-ts-item]", control);
                if (target_match && self.onItemSelect(evt, target_match)) {
                    preventDefault(evt, true);
                    return;
                }
                // retain focus (see control_input mousedown)
                if (control_input.value != "") return;
                self.onClick();
                preventDefault(evt, true);
            });
            // keydown on focus_node for arrow_down/arrow_up
            addEvent(focus_node, "keydown", (e)=>self.onKeyDown(e));
            // keypress and input/keyup
            addEvent(control_input, "keypress", (e)=>self.onKeyPress(e));
            addEvent(control_input, "input", (e)=>self.onInput(e));
            addEvent(focus_node, "blur", (e)=>self.onBlur(e));
            addEvent(focus_node, "focus", (e)=>self.onFocus(e));
            addEvent(control_input, "paste", (e)=>self.onPaste(e));
            const doc_mousedown = (evt)=>{
                // blur if target is outside of this instance
                // dropdown is not always inside wrapper
                const target = evt.composedPath()[0];
                if (!wrapper.contains(target) && !dropdown.contains(target)) {
                    if (self.isFocused) self.blur();
                    self.inputState();
                    return;
                }
                // retain focus by preventing native handling. if the
                // event target is the input it should not be modified.
                // otherwise, text selection within the input won't work.
                // Fixes bug #212 which is no covered by tests
                if (target == control_input && self.isOpen) evt.stopPropagation();
                else preventDefault(evt, true);
            };
            const win_scroll = ()=>{
                if (self.isOpen) self.positionDropdown();
            };
            addEvent(document, "mousedown", doc_mousedown);
            addEvent(window, "scroll", win_scroll, passive_event);
            addEvent(window, "resize", win_scroll, passive_event);
            this._destroy = ()=>{
                document.removeEventListener("mousedown", doc_mousedown);
                window.removeEventListener("scroll", win_scroll);
                window.removeEventListener("resize", win_scroll);
                if (label) label.removeEventListener("click", label_click);
            };
            // store original html and tab index so that they can be
            // restored when the destroy() method is called.
            this.revertSettings = {
                innerHTML: input.innerHTML,
                tabIndex: input.tabIndex
            };
            input.tabIndex = -1;
            input.insertAdjacentElement("afterend", self.wrapper);
            self.sync(false);
            settings.items = [];
            delete settings.optgroups;
            delete settings.options;
            addEvent(input, "invalid", ()=>{
                if (self.isValid) {
                    self.isValid = false;
                    self.isInvalid = true;
                    self.refreshState();
                }
            });
            self.updateOriginalInput();
            self.refreshItems();
            self.close(false);
            self.inputState();
            self.isSetup = true;
            if (input.disabled) self.disable();
            else if (input.readOnly) self.setReadOnly(true);
            else self.enable(); //sets tabIndex
            self.on("change", this.onChange);
            addClasses(input, "tomselected", "ts-hidden-accessible");
            self.trigger("initialize");
            // preload options
            if (settings.preload === true) self.preload();
        }
        /**
	   * Register options and optgroups
	   *
	   */ setupOptions(options = [], optgroups = []) {
            // build options table
            this.addOptions(options);
            // build optgroup table
            iterate$1(optgroups, (optgroup)=>{
                this.registerOptionGroup(optgroup);
            });
        }
        /**
	   * Sets up default rendering functions.
	   */ setupTemplates() {
            var self = this;
            var field_label = self.settings.labelField;
            var field_optgroup = self.settings.optgroupLabelField;
            var templates = {
                "optgroup": (data)=>{
                    let optgroup = document.createElement("div");
                    optgroup.className = "optgroup";
                    optgroup.appendChild(data.options);
                    return optgroup;
                },
                "optgroup_header": (data, escape)=>{
                    return '<div class="optgroup-header">' + escape(data[field_optgroup]) + "</div>";
                },
                "option": (data, escape)=>{
                    return "<div>" + escape(data[field_label]) + "</div>";
                },
                "item": (data, escape)=>{
                    return "<div>" + escape(data[field_label]) + "</div>";
                },
                "option_create": (data, escape)=>{
                    return '<div class="create">Add <strong>' + escape(data.input) + "</strong>&hellip;</div>";
                },
                "no_results": ()=>{
                    return '<div class="no-results">No results found</div>';
                },
                "loading": ()=>{
                    return '<div class="spinner"></div>';
                },
                "not_loading": ()=>{},
                "dropdown": ()=>{
                    return "<div></div>";
                }
            };
            self.settings.render = Object.assign({}, templates, self.settings.render);
        }
        /**
	   * Maps fired events to callbacks provided
	   * in the settings used when creating the control.
	   */ setupCallbacks() {
            var key, fn;
            var callbacks = {
                "initialize": "onInitialize",
                "change": "onChange",
                "item_add": "onItemAdd",
                "item_remove": "onItemRemove",
                "item_select": "onItemSelect",
                "clear": "onClear",
                "option_add": "onOptionAdd",
                "option_remove": "onOptionRemove",
                "option_clear": "onOptionClear",
                "optgroup_add": "onOptionGroupAdd",
                "optgroup_remove": "onOptionGroupRemove",
                "optgroup_clear": "onOptionGroupClear",
                "dropdown_open": "onDropdownOpen",
                "dropdown_close": "onDropdownClose",
                "type": "onType",
                "load": "onLoad",
                "focus": "onFocus",
                "blur": "onBlur"
            };
            for(key in callbacks){
                fn = this.settings[callbacks[key]];
                if (fn) this.on(key, fn);
            }
        }
        /**
	   * Sync the Tom Select instance with the original input or select
	   *
	   */ sync(get_settings = true) {
            const self = this;
            const settings = get_settings ? getSettings(self.input, {
                delimiter: self.settings.delimiter
            }) : self.settings;
            self.setupOptions(settings.options, settings.optgroups);
            self.setValue(settings.items || [], true); // silent prevents recursion
            self.lastQuery = null; // so updated options will be displayed in dropdown
        }
        /**
	   * Triggered when the main control element
	   * has a click event.
	   *
	   */ onClick() {
            var self = this;
            if (self.activeItems.length > 0) {
                self.clearActiveItems();
                self.focus();
                return;
            }
            if (self.isFocused && self.isOpen) self.blur();
            else self.focus();
        }
        /**
	   * @deprecated v1.7
	   *
	   */ onMouseDown() {}
        /**
	   * Triggered when the value of the control has been changed.
	   * This should propagate the event to the original DOM
	   * input / select element.
	   */ onChange() {
            triggerEvent(this.input, "input");
            triggerEvent(this.input, "change");
        }
        /**
	   * Triggered on <input> paste.
	   *
	   */ onPaste(e) {
            var self = this;
            if (self.isInputHidden || self.isLocked) {
                preventDefault(e);
                return;
            }
            // If a regex or string is included, this will split the pasted
            // input and create Items for each separate value
            if (!self.settings.splitOn) return;
            // Wait for pasted text to be recognized in value
            setTimeout(()=>{
                var pastedText = self.inputValue();
                if (!pastedText.match(self.settings.splitOn)) return;
                var splitInput = pastedText.trim().split(self.settings.splitOn);
                iterate$1(splitInput, (piece)=>{
                    const hash = hash_key(piece);
                    if (hash) {
                        if (this.options[piece]) self.addItem(piece);
                        else self.createItem(piece);
                    }
                });
            }, 0);
        }
        /**
	   * Triggered on <input> keypress.
	   *
	   */ onKeyPress(e) {
            var self = this;
            if (self.isLocked) {
                preventDefault(e);
                return;
            }
            var character = String.fromCharCode(e.keyCode || e.which);
            if (self.settings.create && self.settings.mode === "multi" && character === self.settings.delimiter) {
                self.createItem();
                preventDefault(e);
                return;
            }
        }
        /**
	   * Triggered on <input> keydown.
	   *
	   */ onKeyDown(e) {
            var self = this;
            self.ignoreHover = true;
            if (self.isLocked) {
                if (e.keyCode !== KEY_TAB) preventDefault(e);
                return;
            }
            switch(e.keyCode){
                // ctrl+A: select all
                case KEY_A:
                    if (isKeyDown(KEY_SHORTCUT, e)) {
                        if (self.control_input.value == "") {
                            preventDefault(e);
                            self.selectAll();
                            return;
                        }
                    }
                    break;
                // esc: close dropdown
                case KEY_ESC:
                    if (self.isOpen) {
                        preventDefault(e, true);
                        self.close();
                    }
                    self.clearActiveItems();
                    return;
                // down: open dropdown or move selection down
                case KEY_DOWN:
                    if (!self.isOpen && self.hasOptions) self.open();
                    else if (self.activeOption) {
                        let next = self.getAdjacent(self.activeOption, 1);
                        if (next) self.setActiveOption(next);
                    }
                    preventDefault(e);
                    return;
                // up: move selection up
                case KEY_UP:
                    if (self.activeOption) {
                        let prev = self.getAdjacent(self.activeOption, -1);
                        if (prev) self.setActiveOption(prev);
                    }
                    preventDefault(e);
                    return;
                // return: select active option
                case KEY_RETURN:
                    if (self.canSelect(self.activeOption)) {
                        self.onOptionSelect(e, self.activeOption);
                        preventDefault(e);
                    // if the option_create=null, the dropdown might be closed
                    } else if (self.settings.create && self.createItem()) preventDefault(e);
                    else if (document.activeElement == self.control_input && self.isOpen) preventDefault(e);
                    return;
                // left: modifiy item selection to the left
                case KEY_LEFT:
                    self.advanceSelection(-1, e);
                    return;
                // right: modifiy item selection to the right
                case KEY_RIGHT:
                    self.advanceSelection(1, e);
                    return;
                // tab: select active option and/or create item
                case KEY_TAB:
                    if (self.settings.selectOnTab) {
                        if (self.canSelect(self.activeOption)) {
                            self.onOptionSelect(e, self.activeOption);
                            // prevent default [tab] behaviour of jump to the next field
                            // if select isFull, then the dropdown won't be open and [tab] will work normally
                            preventDefault(e);
                        }
                        if (self.settings.create && self.createItem()) preventDefault(e);
                    }
                    return;
                // delete|backspace: delete items
                case KEY_BACKSPACE:
                case KEY_DELETE:
                    self.deleteSelection(e);
                    return;
            }
            // don't enter text in the control_input when active items are selected
            if (self.isInputHidden && !isKeyDown(KEY_SHORTCUT, e)) preventDefault(e);
        }
        /**
	   * Triggered on <input> keyup.
	   *
	   */ onInput(e) {
            if (this.isLocked) return;
            const value = this.inputValue();
            if (this.lastValue === value) return;
            this.lastValue = value;
            if (value == "") {
                this._onInput();
                return;
            }
            if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
            this.refreshTimeout = timeout(()=>{
                this.refreshTimeout = null;
                this._onInput();
            }, this.settings.refreshThrottle);
        }
        _onInput() {
            const value = this.lastValue;
            if (this.settings.shouldLoad.call(this, value)) this.load(value);
            this.refreshOptions();
            this.trigger("type", value);
        }
        /**
	   * Triggered when the user rolls over
	   * an option in the autocomplete dropdown menu.
	   *
	   */ onOptionHover(evt, option) {
            if (this.ignoreHover) return;
            this.setActiveOption(option, false);
        }
        /**
	   * Triggered on <input> focus.
	   *
	   */ onFocus(e) {
            var self = this;
            var wasFocused = self.isFocused;
            if (self.isDisabled || self.isReadOnly) {
                self.blur();
                preventDefault(e);
                return;
            }
            if (self.ignoreFocus) return;
            self.isFocused = true;
            if (self.settings.preload === "focus") self.preload();
            if (!wasFocused) self.trigger("focus");
            if (!self.activeItems.length) {
                self.inputState();
                self.refreshOptions(!!self.settings.openOnFocus);
            }
            self.refreshState();
        }
        /**
	   * Triggered on <input> blur.
	   *
	   */ onBlur(e) {
            if (document.hasFocus() === false) return;
            var self = this;
            if (!self.isFocused) return;
            self.isFocused = false;
            self.ignoreFocus = false;
            var deactivate = ()=>{
                self.close();
                self.setActiveItem();
                self.setCaret(self.items.length);
                self.trigger("blur");
            };
            if (self.settings.create && self.settings.createOnBlur) self.createItem(null, deactivate);
            else deactivate();
        }
        /**
	   * Triggered when the user clicks on an option
	   * in the autocomplete dropdown menu.
	   *
	   */ onOptionSelect(evt, option) {
            var value, self = this;
            // should not be possible to trigger a option under a disabled optgroup
            if (option.parentElement && option.parentElement.matches("[data-disabled]")) return;
            if (option.classList.contains("create")) self.createItem(null, ()=>{
                if (self.settings.closeAfterSelect) self.close();
            });
            else {
                value = option.dataset.value;
                if (typeof value !== "undefined") {
                    self.lastQuery = null;
                    self.addItem(value);
                    if (self.settings.closeAfterSelect) self.close();
                    if (!self.settings.hideSelected && evt.type && /click/.test(evt.type)) self.setActiveOption(option);
                }
            }
        }
        /**
	   * Return true if the given option can be selected
	   *
	   */ canSelect(option) {
            if (this.isOpen && option && this.dropdown_content.contains(option)) return true;
            return false;
        }
        /**
	   * Triggered when the user clicks on an item
	   * that has been selected.
	   *
	   */ onItemSelect(evt, item) {
            var self = this;
            if (!self.isLocked && self.settings.mode === "multi") {
                preventDefault(evt);
                self.setActiveItem(item, evt);
                return true;
            }
            return false;
        }
        /**
	   * Determines whether or not to invoke
	   * the user-provided option provider / loader
	   *
	   * Note, there is a subtle difference between
	   * this.canLoad() and this.settings.shouldLoad();
	   *
	   *	- settings.shouldLoad() is a user-input validator.
	   *	When false is returned, the not_loading template
	   *	will be added to the dropdown
	   *
	   *	- canLoad() is lower level validator that checks
	   * 	the Tom Select instance. There is no inherent user
	   *	feedback when canLoad returns false
	   *
	   */ canLoad(value) {
            if (!this.settings.load) return false;
            if (this.loadedSearches.hasOwnProperty(value)) return false;
            return true;
        }
        /**
	   * Invokes the user-provided option provider / loader.
	   *
	   */ load(value) {
            const self = this;
            if (!self.canLoad(value)) return;
            addClasses(self.wrapper, self.settings.loadingClass);
            self.loading++;
            const callback = self.loadCallback.bind(self);
            self.settings.load.call(self, value, callback);
        }
        /**
	   * Invoked by the user-provided option provider
	   *
	   */ loadCallback(options, optgroups) {
            const self = this;
            self.loading = Math.max(self.loading - 1, 0);
            self.lastQuery = null;
            self.clearActiveOption(); // when new results load, focus should be on first option
            self.setupOptions(options, optgroups);
            self.refreshOptions(self.isFocused && !self.isInputHidden);
            if (!self.loading) removeClasses(self.wrapper, self.settings.loadingClass);
            self.trigger("load", options, optgroups);
        }
        preload() {
            var classList = this.wrapper.classList;
            if (classList.contains("preloaded")) return;
            classList.add("preloaded");
            this.load("");
        }
        /**
	   * Sets the input field of the control to the specified value.
	   *
	   */ setTextboxValue(value = "") {
            var input = this.control_input;
            var changed = input.value !== value;
            if (changed) {
                input.value = value;
                triggerEvent(input, "update");
                this.lastValue = value;
            }
        }
        /**
	   * Returns the value of the control. If multiple items
	   * can be selected (e.g. <select multiple>), this returns
	   * an array. If only one item can be selected, this
	   * returns a string.
	   *
	   */ getValue() {
            if (this.is_select_tag && this.input.hasAttribute("multiple")) return this.items;
            return this.items.join(this.settings.delimiter);
        }
        /**
	   * Resets the selected items to the given value.
	   *
	   */ setValue(value, silent) {
            var events = silent ? [] : [
                "change"
            ];
            debounce_events(this, events, ()=>{
                this.clear(silent);
                this.addItems(value, silent);
            });
        }
        /**
	   * Resets the number of max items to the given value
	   *
	   */ setMaxItems(value) {
            if (value === 0) value = null; //reset to unlimited items.
            this.settings.maxItems = value;
            this.refreshState();
        }
        /**
	   * Sets the selected item.
	   *
	   */ setActiveItem(item, e) {
            var self = this;
            var eventName;
            var i, begin, end, swap;
            var last;
            if (self.settings.mode === "single") return;
            // clear the active selection
            if (!item) {
                self.clearActiveItems();
                if (self.isFocused) self.inputState();
                return;
            }
            // modify selection
            eventName = e && e.type.toLowerCase();
            if (eventName === "click" && isKeyDown("shiftKey", e) && self.activeItems.length) {
                last = self.getLastActive();
                begin = Array.prototype.indexOf.call(self.control.children, last);
                end = Array.prototype.indexOf.call(self.control.children, item);
                if (begin > end) {
                    swap = begin;
                    begin = end;
                    end = swap;
                }
                for(i = begin; i <= end; i++){
                    item = self.control.children[i];
                    if (self.activeItems.indexOf(item) === -1) self.setActiveItemClass(item);
                }
                preventDefault(e);
            } else if (eventName === "click" && isKeyDown(KEY_SHORTCUT, e) || eventName === "keydown" && isKeyDown("shiftKey", e)) {
                if (item.classList.contains("active")) self.removeActiveItem(item);
                else self.setActiveItemClass(item);
            } else {
                self.clearActiveItems();
                self.setActiveItemClass(item);
            }
            // ensure control has focus
            self.inputState();
            if (!self.isFocused) self.focus();
        }
        /**
	   * Set the active and last-active classes
	   *
	   */ setActiveItemClass(item) {
            const self = this;
            const last_active = self.control.querySelector(".last-active");
            if (last_active) removeClasses(last_active, "last-active");
            addClasses(item, "active last-active");
            self.trigger("item_select", item);
            if (self.activeItems.indexOf(item) == -1) self.activeItems.push(item);
        }
        /**
	   * Remove active item
	   *
	   */ removeActiveItem(item) {
            var idx = this.activeItems.indexOf(item);
            this.activeItems.splice(idx, 1);
            removeClasses(item, "active");
        }
        /**
	   * Clears all the active items
	   *
	   */ clearActiveItems() {
            removeClasses(this.activeItems, "active");
            this.activeItems = [];
        }
        /**
	   * Sets the selected item in the dropdown menu
	   * of available options.
	   *
	   */ setActiveOption(option, scroll = true) {
            if (option === this.activeOption) return;
            this.clearActiveOption();
            if (!option) return;
            this.activeOption = option;
            setAttr(this.focus_node, {
                "aria-activedescendant": option.getAttribute("id")
            });
            setAttr(option, {
                "aria-selected": "true"
            });
            addClasses(option, "active");
            if (scroll) this.scrollToOption(option);
        }
        /**
	   * Sets the dropdown_content scrollTop to display the option
	   *
	   */ scrollToOption(option, behavior) {
            if (!option) return;
            const content = this.dropdown_content;
            const height_menu = content.clientHeight;
            const scrollTop = content.scrollTop || 0;
            const height_item = option.offsetHeight;
            const y = option.getBoundingClientRect().top - content.getBoundingClientRect().top + scrollTop;
            if (y + height_item > height_menu + scrollTop) this.scroll(y - height_menu + height_item, behavior);
            else if (y < scrollTop) this.scroll(y, behavior);
        }
        /**
	   * Scroll the dropdown to the given position
	   *
	   */ scroll(scrollTop, behavior) {
            const content = this.dropdown_content;
            if (behavior) content.style.scrollBehavior = behavior;
            content.scrollTop = scrollTop;
            content.style.scrollBehavior = "";
        }
        /**
	   * Clears the active option
	   *
	   */ clearActiveOption() {
            if (this.activeOption) {
                removeClasses(this.activeOption, "active");
                setAttr(this.activeOption, {
                    "aria-selected": null
                });
            }
            this.activeOption = null;
            setAttr(this.focus_node, {
                "aria-activedescendant": null
            });
        }
        /**
	   * Selects all items (CTRL + A).
	   */ selectAll() {
            const self = this;
            if (self.settings.mode === "single") return;
            const activeItems = self.controlChildren();
            if (!activeItems.length) return;
            self.inputState();
            self.close();
            self.activeItems = activeItems;
            iterate$1(activeItems, (item)=>{
                self.setActiveItemClass(item);
            });
        }
        /**
	   * Determines if the control_input should be in a hidden or visible state
	   *
	   */ inputState() {
            var self = this;
            if (!self.control.contains(self.control_input)) return;
            setAttr(self.control_input, {
                placeholder: self.settings.placeholder
            });
            if (self.activeItems.length > 0 || !self.isFocused && self.settings.hidePlaceholder && self.items.length > 0) {
                self.setTextboxValue();
                self.isInputHidden = true;
            } else {
                if (self.settings.hidePlaceholder && self.items.length > 0) setAttr(self.control_input, {
                    placeholder: ""
                });
                self.isInputHidden = false;
            }
            self.wrapper.classList.toggle("input-hidden", self.isInputHidden);
        }
        /**
	   * Get the input value
	   */ inputValue() {
            return this.control_input.value.trim();
        }
        /**
	   * Gives the control focus.
	   */ focus() {
            var self = this;
            if (self.isDisabled || self.isReadOnly) return;
            self.ignoreFocus = true;
            if (self.control_input.offsetWidth) self.control_input.focus();
            else self.focus_node.focus();
            setTimeout(()=>{
                self.ignoreFocus = false;
                self.onFocus();
            }, 0);
        }
        /**
	   * Forces the control out of focus.
	   *
	   */ blur() {
            this.focus_node.blur();
            this.onBlur();
        }
        /**
	   * Returns a function that scores an object
	   * to show how good of a match it is to the
	   * provided query.
	   *
	   * @return {function}
	   */ getScoreFunction(query) {
            return this.sifter.getScoreFunction(query, this.getSearchOptions());
        }
        /**
	   * Returns search options for sifter (the system
	   * for scoring and sorting results).
	   *
	   * @see https://github.com/orchidjs/sifter.js
	   * @return {object}
	   */ getSearchOptions() {
            var settings = this.settings;
            var sort = settings.sortField;
            if (typeof settings.sortField === "string") sort = [
                {
                    field: settings.sortField
                }
            ];
            return {
                fields: settings.searchField,
                conjunction: settings.searchConjunction,
                sort: sort,
                nesting: settings.nesting
            };
        }
        /**
	   * Searches through available options and returns
	   * a sorted array of matches.
	   *
	   */ search(query) {
            var result, calculateScore;
            var self = this;
            var options = this.getSearchOptions();
            // validate user-provided result scoring function
            if (self.settings.score) {
                calculateScore = self.settings.score.call(self, query);
                if (typeof calculateScore !== "function") throw new Error('Tom Select "score" setting must be a function that returns a function');
            }
            // perform search
            if (query !== self.lastQuery) {
                self.lastQuery = query;
                result = self.sifter.search(query, Object.assign(options, {
                    score: calculateScore
                }));
                self.currentResults = result;
            } else result = Object.assign({}, self.currentResults);
            // filter out selected items
            if (self.settings.hideSelected) result.items = result.items.filter((item)=>{
                let hashed = hash_key(item.id);
                return !(hashed && self.items.indexOf(hashed) !== -1);
            });
            return result;
        }
        /**
	   * Refreshes the list of available options shown
	   * in the autocomplete dropdown menu.
	   *
	   */ refreshOptions(triggerDropdown = true) {
            var i, j, k, n, optgroup, optgroups, html, has_create_option, active_group;
            var create;
            const groups = {};
            const groups_order = [];
            var self = this;
            var query = self.inputValue();
            const same_query = query === self.lastQuery || query == "" && self.lastQuery == null;
            var results = self.search(query);
            var active_option = null;
            var show_dropdown = self.settings.shouldOpen || false;
            var dropdown_content = self.dropdown_content;
            if (same_query) {
                active_option = self.activeOption;
                if (active_option) active_group = active_option.closest("[data-group]");
            }
            // build markup
            n = results.items.length;
            if (typeof self.settings.maxOptions === "number") n = Math.min(n, self.settings.maxOptions);
            if (n > 0) show_dropdown = true;
            // get fragment for group and the position of the group in group_order
            const getGroupFragment = (optgroup, order)=>{
                let group_order_i = groups[optgroup];
                if (group_order_i !== undefined) {
                    let order_group = groups_order[group_order_i];
                    if (order_group !== undefined) return [
                        group_order_i,
                        order_group.fragment
                    ];
                }
                let group_fragment = document.createDocumentFragment();
                group_order_i = groups_order.length;
                groups_order.push({
                    fragment: group_fragment,
                    order: order,
                    optgroup: optgroup
                });
                return [
                    group_order_i,
                    group_fragment
                ];
            };
            // render and group available options individually
            for(i = 0; i < n; i++){
                // get option dom element
                let item = results.items[i];
                if (!item) continue;
                let opt_value = item.id;
                let option = self.options[opt_value];
                if (option === undefined) continue;
                let opt_hash = get_hash(opt_value);
                let option_el = self.getOption(opt_hash, true);
                // toggle 'selected' class
                if (!self.settings.hideSelected) option_el.classList.toggle("selected", self.items.includes(opt_hash));
                optgroup = option[self.settings.optgroupField] || "";
                optgroups = Array.isArray(optgroup) ? optgroup : [
                    optgroup
                ];
                for(j = 0, k = optgroups && optgroups.length; j < k; j++){
                    optgroup = optgroups[j];
                    let order = option.$order;
                    let self_optgroup = self.optgroups[optgroup];
                    if (self_optgroup === undefined) optgroup = "";
                    else order = self_optgroup.$order;
                    const [group_order_i, group_fragment] = getGroupFragment(optgroup, order);
                    // nodes can only have one parent, so if the option is in mutple groups, we need a clone
                    if (j > 0) {
                        option_el = option_el.cloneNode(true);
                        setAttr(option_el, {
                            id: option.$id + "-clone-" + j,
                            "aria-selected": null
                        });
                        option_el.classList.add("ts-cloned");
                        removeClasses(option_el, "active");
                        // make sure we keep the activeOption in the same group
                        if (self.activeOption && self.activeOption.dataset.value == opt_value) {
                            if (active_group && active_group.dataset.group === optgroup.toString()) active_option = option_el;
                        }
                    }
                    group_fragment.appendChild(option_el);
                    if (optgroup != "") groups[optgroup] = group_order_i;
                }
            }
            // sort optgroups
            if (self.settings.lockOptgroupOrder) groups_order.sort((a, b)=>{
                return a.order - b.order;
            });
            // render optgroup headers & join groups
            html = document.createDocumentFragment();
            iterate$1(groups_order, (group_order)=>{
                let group_fragment = group_order.fragment;
                let optgroup = group_order.optgroup;
                if (!group_fragment || !group_fragment.children.length) return;
                let group_heading = self.optgroups[optgroup];
                if (group_heading !== undefined) {
                    let group_options = document.createDocumentFragment();
                    let header = self.render("optgroup_header", group_heading);
                    append(group_options, header);
                    append(group_options, group_fragment);
                    let group_html = self.render("optgroup", {
                        group: group_heading,
                        options: group_options
                    });
                    append(html, group_html);
                } else append(html, group_fragment);
            });
            dropdown_content.innerHTML = "";
            append(dropdown_content, html);
            // highlight matching terms inline
            if (self.settings.highlight) {
                removeHighlight(dropdown_content);
                if (results.query.length && results.tokens.length) iterate$1(results.tokens, (tok)=>{
                    highlight(dropdown_content, tok.regex);
                });
            }
            // helper method for adding templates to dropdown
            var add_template = (template)=>{
                let content = self.render(template, {
                    input: query
                });
                if (content) {
                    show_dropdown = true;
                    dropdown_content.insertBefore(content, dropdown_content.firstChild);
                }
                return content;
            };
            // add loading message
            if (self.loading) add_template("loading");
            else if (!self.settings.shouldLoad.call(self, query)) add_template("not_loading");
            else if (results.items.length === 0) add_template("no_results");
            // add create option
            has_create_option = self.canCreate(query);
            if (has_create_option) create = add_template("option_create");
            // activate
            self.hasOptions = results.items.length > 0 || has_create_option;
            if (show_dropdown) {
                if (results.items.length > 0) {
                    if (!active_option && self.settings.mode === "single" && self.items[0] != undefined) active_option = self.getOption(self.items[0]);
                    if (!dropdown_content.contains(active_option)) {
                        let active_index = 0;
                        if (create && !self.settings.addPrecedence) active_index = 1;
                        active_option = self.selectable()[active_index];
                    }
                } else if (create) active_option = create;
                if (triggerDropdown && !self.isOpen) {
                    self.open();
                    self.scrollToOption(active_option, "auto");
                }
                self.setActiveOption(active_option);
            } else {
                self.clearActiveOption();
                if (triggerDropdown && self.isOpen) self.close(false); // if create_option=null, we want the dropdown to close but not reset the textbox value
            }
        }
        /**
	   * Return list of selectable options
	   *
	   */ selectable() {
            return this.dropdown_content.querySelectorAll("[data-selectable]");
        }
        /**
	   * Adds an available option. If it already exists,
	   * nothing will happen. Note: this does not refresh
	   * the options list dropdown (use `refreshOptions`
	   * for that).
	   *
	   * Usage:
	   *
	   *   this.addOption(data)
	   *
	   */ addOption(data, user_created = false) {
            const self = this;
            // @deprecated 1.7.7
            // use addOptions( array, user_created ) for adding multiple options
            if (Array.isArray(data)) {
                self.addOptions(data, user_created);
                return false;
            }
            const key = hash_key(data[self.settings.valueField]);
            if (key === null || self.options.hasOwnProperty(key)) return false;
            data.$order = data.$order || ++self.order;
            data.$id = self.inputId + "-opt-" + data.$order;
            self.options[key] = data;
            self.lastQuery = null;
            if (user_created) {
                self.userOptions[key] = user_created;
                self.trigger("option_add", key, data);
            }
            return key;
        }
        /**
	   * Add multiple options
	   *
	   */ addOptions(data, user_created = false) {
            iterate$1(data, (dat)=>{
                this.addOption(dat, user_created);
            });
        }
        /**
	   * @deprecated 1.7.7
	   */ registerOption(data) {
            return this.addOption(data);
        }
        /**
	   * Registers an option group to the pool of option groups.
	   *
	   * @return {boolean|string}
	   */ registerOptionGroup(data) {
            var key = hash_key(data[this.settings.optgroupValueField]);
            if (key === null) return false;
            data.$order = data.$order || ++this.order;
            this.optgroups[key] = data;
            return key;
        }
        /**
	   * Registers a new optgroup for options
	   * to be bucketed into.
	   *
	   */ addOptionGroup(id, data) {
            var hashed_id;
            data[this.settings.optgroupValueField] = id;
            if (hashed_id = this.registerOptionGroup(data)) this.trigger("optgroup_add", hashed_id, data);
        }
        /**
	   * Removes an existing option group.
	   *
	   */ removeOptionGroup(id) {
            if (this.optgroups.hasOwnProperty(id)) {
                delete this.optgroups[id];
                this.clearCache();
                this.trigger("optgroup_remove", id);
            }
        }
        /**
	   * Clears all existing option groups.
	   */ clearOptionGroups() {
            this.optgroups = {};
            this.clearCache();
            this.trigger("optgroup_clear");
        }
        /**
	   * Updates an option available for selection. If
	   * it is visible in the selected items or options
	   * dropdown, it will be re-rendered automatically.
	   *
	   */ updateOption(value, data) {
            const self = this;
            var item_new;
            var index_item;
            const value_old = hash_key(value);
            const value_new = hash_key(data[self.settings.valueField]);
            // sanity checks
            if (value_old === null) return;
            const data_old = self.options[value_old];
            if (data_old == undefined) return;
            if (typeof value_new !== "string") throw new Error("Value must be set in option data");
            const option = self.getOption(value_old);
            const item = self.getItem(value_old);
            data.$order = data.$order || data_old.$order;
            delete self.options[value_old];
            // invalidate render cache
            // don't remove existing node yet, we'll remove it after replacing it
            self.uncacheValue(value_new);
            self.options[value_new] = data;
            // update the option if it's in the dropdown
            if (option) {
                if (self.dropdown_content.contains(option)) {
                    const option_new = self._render("option", data);
                    replaceNode(option, option_new);
                    if (self.activeOption === option) self.setActiveOption(option_new);
                }
                option.remove();
            }
            // update the item if we have one
            if (item) {
                index_item = self.items.indexOf(value_old);
                if (index_item !== -1) self.items.splice(index_item, 1, value_new);
                item_new = self._render("item", data);
                if (item.classList.contains("active")) addClasses(item_new, "active");
                replaceNode(item, item_new);
            }
            // invalidate last query because we might have updated the sortField
            self.lastQuery = null;
        }
        /**
	   * Removes a single option.
	   *
	   */ removeOption(value, silent) {
            const self = this;
            value = get_hash(value);
            self.uncacheValue(value);
            delete self.userOptions[value];
            delete self.options[value];
            self.lastQuery = null;
            self.trigger("option_remove", value);
            self.removeItem(value, silent);
        }
        /**
	   * Clears all options.
	   */ clearOptions(filter) {
            const boundFilter = (filter || this.clearFilter).bind(this);
            this.loadedSearches = {};
            this.userOptions = {};
            this.clearCache();
            const selected = {};
            iterate$1(this.options, (option, key)=>{
                if (boundFilter(option, key)) selected[key] = option;
            });
            this.options = this.sifter.items = selected;
            this.lastQuery = null;
            this.trigger("option_clear");
        }
        /**
	   * Used by clearOptions() to decide whether or not an option should be removed
	   * Return true to keep an option, false to remove
	   *
	   */ clearFilter(option, value) {
            if (this.items.indexOf(value) >= 0) return true;
            return false;
        }
        /**
	   * Returns the dom element of the option
	   * matching the given value.
	   *
	   */ getOption(value, create = false) {
            const hashed = hash_key(value);
            if (hashed === null) return null;
            const option = this.options[hashed];
            if (option != undefined) {
                if (option.$div) return option.$div;
                if (create) return this._render("option", option);
            }
            return null;
        }
        /**
	   * Returns the dom element of the next or previous dom element of the same type
	   * Note: adjacent options may not be adjacent DOM elements (optgroups)
	   *
	   */ getAdjacent(option, direction, type = "option") {
            var self = this, all;
            if (!option) return null;
            if (type == "item") all = self.controlChildren();
            else all = self.dropdown_content.querySelectorAll("[data-selectable]");
            for(let i = 0; i < all.length; i++){
                if (all[i] != option) continue;
                if (direction > 0) return all[i + 1];
                return all[i - 1];
            }
            return null;
        }
        /**
	   * Returns the dom element of the item
	   * matching the given value.
	   *
	   */ getItem(item) {
            if (typeof item == "object") return item;
            var value = hash_key(item);
            return value !== null ? this.control.querySelector(`[data-value="${addSlashes(value)}"]`) : null;
        }
        /**
	   * "Selects" multiple items at once. Adds them to the list
	   * at the current caret position.
	   *
	   */ addItems(values, silent) {
            var self = this;
            var items = Array.isArray(values) ? values : [
                values
            ];
            items = items.filter((x)=>self.items.indexOf(x) === -1);
            const last_item = items[items.length - 1];
            items.forEach((item)=>{
                self.isPending = item !== last_item;
                self.addItem(item, silent);
            });
        }
        /**
	   * "Selects" an item. Adds it to the list
	   * at the current caret position.
	   *
	   */ addItem(value, silent) {
            var events = silent ? [] : [
                "change",
                "dropdown_close"
            ];
            debounce_events(this, events, ()=>{
                var item, wasFull;
                const self = this;
                const inputMode = self.settings.mode;
                const hashed = hash_key(value);
                if (hashed && self.items.indexOf(hashed) !== -1) {
                    if (inputMode === "single") self.close();
                    if (inputMode === "single" || !self.settings.duplicates) return;
                }
                if (hashed === null || !self.options.hasOwnProperty(hashed)) return;
                if (inputMode === "single") self.clear(silent);
                if (inputMode === "multi" && self.isFull()) return;
                item = self._render("item", self.options[hashed]);
                if (self.control.contains(item)) // duplicates
                item = item.cloneNode(true);
                wasFull = self.isFull();
                self.items.splice(self.caretPos, 0, hashed);
                self.insertAtCaret(item);
                if (self.isSetup) {
                    // update menu / remove the option (if this is not one item being added as part of series)
                    if (!self.isPending && self.settings.hideSelected) {
                        let option = self.getOption(hashed);
                        let next = self.getAdjacent(option, 1);
                        if (next) self.setActiveOption(next);
                    }
                    // refreshOptions after setActiveOption(),
                    // otherwise setActiveOption() will be called by refreshOptions() with the wrong value
                    if (!self.isPending && !self.settings.closeAfterSelect) self.refreshOptions(self.isFocused && inputMode !== "single");
                    // hide the menu if the maximum number of items have been selected or no options are left
                    if (self.settings.closeAfterSelect != false && self.isFull()) self.close();
                    else if (!self.isPending) self.positionDropdown();
                    self.trigger("item_add", hashed, item);
                    if (!self.isPending) self.updateOriginalInput({
                        silent: silent
                    });
                }
                if (!self.isPending || !wasFull && self.isFull()) {
                    self.inputState();
                    self.refreshState();
                }
            });
        }
        /**
	   * Removes the selected item matching
	   * the provided value.
	   *
	   */ removeItem(item = null, silent) {
            const self = this;
            item = self.getItem(item);
            if (!item) return;
            var i, idx;
            const value = item.dataset.value;
            i = nodeIndex(item);
            item.remove();
            if (item.classList.contains("active")) {
                idx = self.activeItems.indexOf(item);
                self.activeItems.splice(idx, 1);
                removeClasses(item, "active");
            }
            self.items.splice(i, 1);
            self.lastQuery = null;
            if (!self.settings.persist && self.userOptions.hasOwnProperty(value)) self.removeOption(value, silent);
            if (i < self.caretPos) self.setCaret(self.caretPos - 1);
            self.updateOriginalInput({
                silent: silent
            });
            self.refreshState();
            self.positionDropdown();
            self.trigger("item_remove", value, item);
        }
        /**
	   * Invokes the `create` method provided in the
	   * TomSelect options that should provide the data
	   * for the new item, given the user input.
	   *
	   * Once this completes, it will be added
	   * to the item list.
	   *
	   */ createItem(input = null, callback = ()=>{}) {
            // triggerDropdown parameter @deprecated 2.1.1
            if (arguments.length === 3) callback = arguments[2];
            if (typeof callback != "function") callback = ()=>{};
            var self = this;
            var caret = self.caretPos;
            var output;
            input = input || self.inputValue();
            if (!self.canCreate(input)) {
                callback();
                return false;
            }
            self.lock();
            var created = false;
            var create = (data)=>{
                self.unlock();
                if (!data || typeof data !== "object") return callback();
                var value = hash_key(data[self.settings.valueField]);
                if (typeof value !== "string") return callback();
                self.setTextboxValue();
                self.addOption(data, true);
                self.setCaret(caret);
                self.addItem(value);
                callback(data);
                created = true;
            };
            if (typeof self.settings.create === "function") output = self.settings.create.call(this, input, create);
            else output = {
                [self.settings.labelField]: input,
                [self.settings.valueField]: input
            };
            if (!created) create(output);
            return true;
        }
        /**
	   * Re-renders the selected item lists.
	   */ refreshItems() {
            var self = this;
            self.lastQuery = null;
            if (self.isSetup) self.addItems(self.items);
            self.updateOriginalInput();
            self.refreshState();
        }
        /**
	   * Updates all state-dependent attributes
	   * and CSS classes.
	   */ refreshState() {
            const self = this;
            self.refreshValidityState();
            const isFull = self.isFull();
            const isLocked = self.isLocked;
            self.wrapper.classList.toggle("rtl", self.rtl);
            const wrap_classList = self.wrapper.classList;
            wrap_classList.toggle("focus", self.isFocused);
            wrap_classList.toggle("disabled", self.isDisabled);
            wrap_classList.toggle("readonly", self.isReadOnly);
            wrap_classList.toggle("required", self.isRequired);
            wrap_classList.toggle("invalid", !self.isValid);
            wrap_classList.toggle("locked", isLocked);
            wrap_classList.toggle("full", isFull);
            wrap_classList.toggle("input-active", self.isFocused && !self.isInputHidden);
            wrap_classList.toggle("dropdown-active", self.isOpen);
            wrap_classList.toggle("has-options", isEmptyObject(self.options));
            wrap_classList.toggle("has-items", self.items.length > 0);
        }
        /**
	   * Update the `required` attribute of both input and control input.
	   *
	   * The `required` property needs to be activated on the control input
	   * for the error to be displayed at the right place. `required` also
	   * needs to be temporarily deactivated on the input since the input is
	   * hidden and can't show errors.
	   */ refreshValidityState() {
            var self = this;
            if (!self.input.validity) return;
            self.isValid = self.input.validity.valid;
            self.isInvalid = !self.isValid;
        }
        /**
	   * Determines whether or not more items can be added
	   * to the control without exceeding the user-defined maximum.
	   *
	   * @returns {boolean}
	   */ isFull() {
            return this.settings.maxItems !== null && this.items.length >= this.settings.maxItems;
        }
        /**
	   * Refreshes the original <select> or <input>
	   * element to reflect the current state.
	   *
	   */ updateOriginalInput(opts = {}) {
            const self = this;
            var option, label;
            const empty_option = self.input.querySelector('option[value=""]');
            if (self.is_select_tag) {
                const selected = [];
                const has_selected = self.input.querySelectorAll("option:checked").length;
                function AddSelected(option_el, value, label) {
                    if (!option_el) option_el = getDom('<option value="' + escape_html(value) + '">' + escape_html(label) + "</option>");
                    // don't move empty option from top of list
                    // fixes bug in firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1725293
                    if (option_el != empty_option) self.input.append(option_el);
                    selected.push(option_el);
                    // marking empty option as selected can break validation
                    // fixes https://github.com/orchidjs/tom-select/issues/303
                    if (option_el != empty_option || has_selected > 0) option_el.selected = true;
                    return option_el;
                }
                // unselect all selected options
                self.input.querySelectorAll("option:checked").forEach((option_el)=>{
                    option_el.selected = false;
                });
                // nothing selected?
                if (self.items.length == 0 && self.settings.mode == "single") AddSelected(empty_option, "", "");
                else self.items.forEach((value)=>{
                    option = self.options[value];
                    label = option[self.settings.labelField] || "";
                    if (selected.includes(option.$option)) {
                        const reuse_opt = self.input.querySelector(`option[value="${addSlashes(value)}"]:not(:checked)`);
                        AddSelected(reuse_opt, value, label);
                    } else option.$option = AddSelected(option.$option, value, label);
                });
            } else self.input.value = self.getValue();
            if (self.isSetup) {
                if (!opts.silent) self.trigger("change", self.getValue());
            }
        }
        /**
	   * Shows the autocomplete dropdown containing
	   * the available options.
	   */ open() {
            var self = this;
            if (self.isLocked || self.isOpen || self.settings.mode === "multi" && self.isFull()) return;
            self.isOpen = true;
            setAttr(self.focus_node, {
                "aria-expanded": "true"
            });
            self.refreshState();
            applyCSS(self.dropdown, {
                visibility: "hidden",
                display: "block"
            });
            self.positionDropdown();
            applyCSS(self.dropdown, {
                visibility: "visible",
                display: "block"
            });
            self.focus();
            self.trigger("dropdown_open", self.dropdown);
        }
        /**
	   * Closes the autocomplete dropdown menu.
	   */ close(setTextboxValue = true) {
            var self = this;
            var trigger = self.isOpen;
            if (setTextboxValue) {
                // before blur() to prevent form onchange event
                self.setTextboxValue();
                if (self.settings.mode === "single" && self.items.length) self.inputState();
            }
            self.isOpen = false;
            setAttr(self.focus_node, {
                "aria-expanded": "false"
            });
            applyCSS(self.dropdown, {
                display: "none"
            });
            if (self.settings.hideSelected) self.clearActiveOption();
            self.refreshState();
            if (trigger) self.trigger("dropdown_close", self.dropdown);
        }
        /**
	   * Calculates and applies the appropriate
	   * position of the dropdown if dropdownParent = 'body'.
	   * Otherwise, position is determined by css
	   */ positionDropdown() {
            if (this.settings.dropdownParent !== "body") return;
            var context = this.control;
            var rect = context.getBoundingClientRect();
            var top = context.offsetHeight + rect.top + window.scrollY;
            var left = rect.left + window.scrollX;
            applyCSS(this.dropdown, {
                width: rect.width + "px",
                top: top + "px",
                left: left + "px"
            });
        }
        /**
	   * Resets / clears all selected items
	   * from the control.
	   *
	   */ clear(silent) {
            var self = this;
            if (!self.items.length) return;
            var items = self.controlChildren();
            iterate$1(items, (item)=>{
                self.removeItem(item, true);
            });
            self.inputState();
            if (!silent) self.updateOriginalInput();
            self.trigger("clear");
        }
        /**
	   * A helper method for inserting an element
	   * at the current caret position.
	   *
	   */ insertAtCaret(el) {
            const self = this;
            const caret = self.caretPos;
            const target = self.control;
            target.insertBefore(el, target.children[caret] || null);
            self.setCaret(caret + 1);
        }
        /**
	   * Removes the current selected item(s).
	   *
	   */ deleteSelection(e) {
            var direction, selection, caret, tail;
            var self = this;
            direction = e && e.keyCode === KEY_BACKSPACE ? -1 : 1;
            selection = getSelection(self.control_input);
            // determine items that will be removed
            const rm_items = [];
            if (self.activeItems.length) {
                tail = getTail(self.activeItems, direction);
                caret = nodeIndex(tail);
                if (direction > 0) caret++;
                iterate$1(self.activeItems, (item)=>rm_items.push(item));
            } else if ((self.isFocused || self.settings.mode === "single") && self.items.length) {
                const items = self.controlChildren();
                let rm_item;
                if (direction < 0 && selection.start === 0 && selection.length === 0) rm_item = items[self.caretPos - 1];
                else if (direction > 0 && selection.start === self.inputValue().length) rm_item = items[self.caretPos];
                if (rm_item !== undefined) rm_items.push(rm_item);
            }
            if (!self.shouldDelete(rm_items, e)) return false;
            preventDefault(e, true);
            // perform removal
            if (typeof caret !== "undefined") self.setCaret(caret);
            while(rm_items.length)self.removeItem(rm_items.pop());
            self.inputState();
            self.positionDropdown();
            self.refreshOptions(false);
            return true;
        }
        /**
	   * Return true if the items should be deleted
	   */ shouldDelete(items, evt) {
            const values = items.map((item)=>item.dataset.value);
            // allow the callback to abort
            if (!values.length || typeof this.settings.onDelete === "function" && this.settings.onDelete(values, evt) === false) return false;
            return true;
        }
        /**
	   * Selects the previous / next item (depending on the `direction` argument).
	   *
	   * > 0 - right
	   * < 0 - left
	   *
	   */ advanceSelection(direction, e) {
            var last_active, adjacent, self = this;
            if (self.rtl) direction *= -1;
            if (self.inputValue().length) return;
            // add or remove to active items
            if (isKeyDown(KEY_SHORTCUT, e) || isKeyDown("shiftKey", e)) {
                last_active = self.getLastActive(direction);
                if (last_active) {
                    if (!last_active.classList.contains("active")) adjacent = last_active;
                    else adjacent = self.getAdjacent(last_active, direction, "item");
                } else if (direction > 0) adjacent = self.control_input.nextElementSibling;
                else adjacent = self.control_input.previousElementSibling;
                if (adjacent) {
                    if (adjacent.classList.contains("active")) self.removeActiveItem(last_active);
                    self.setActiveItemClass(adjacent); // mark as last_active !! after removeActiveItem() on last_active
                }
            // move caret to the left or right
            } else self.moveCaret(direction);
        }
        moveCaret(direction) {}
        /**
	   * Get the last active item
	   *
	   */ getLastActive(direction) {
            let last_active = this.control.querySelector(".last-active");
            if (last_active) return last_active;
            var result = this.control.querySelectorAll(".active");
            if (result) return getTail(result, direction);
        }
        /**
	   * Moves the caret to the specified index.
	   *
	   * The input must be moved by leaving it in place and moving the
	   * siblings, due to the fact that focus cannot be restored once lost
	   * on mobile webkit devices
	   *
	   */ setCaret(new_pos) {
            this.caretPos = this.items.length;
        }
        /**
	   * Return list of item dom elements
	   *
	   */ controlChildren() {
            return Array.from(this.control.querySelectorAll("[data-ts-item]"));
        }
        /**
	   * Disables user input on the control. Used while
	   * items are being asynchronously created.
	   */ lock() {
            this.setLocked(true);
        }
        /**
	   * Re-enables user input on the control.
	   */ unlock() {
            this.setLocked(false);
        }
        /**
	   * Disable or enable user input on the control
	   */ setLocked(lock = this.isReadOnly || this.isDisabled) {
            this.isLocked = lock;
            this.refreshState();
        }
        /**
	   * Disables user input on the control completely.
	   * While disabled, it cannot receive focus.
	   */ disable() {
            this.setDisabled(true);
            this.close();
        }
        /**
	   * Enables the control so that it can respond
	   * to focus and user input.
	   */ enable() {
            this.setDisabled(false);
        }
        setDisabled(disabled) {
            this.focus_node.tabIndex = disabled ? -1 : this.tabIndex;
            this.isDisabled = disabled;
            this.input.disabled = disabled;
            this.control_input.disabled = disabled;
            this.setLocked();
        }
        setReadOnly(isReadOnly) {
            this.isReadOnly = isReadOnly;
            this.input.readOnly = isReadOnly;
            this.control_input.readOnly = isReadOnly;
            this.setLocked();
        }
        /**
	   * Completely destroys the control and
	   * unbinds all event listeners so that it can
	   * be garbage collected.
	   */ destroy() {
            var self = this;
            var revertSettings = self.revertSettings;
            self.trigger("destroy");
            self.off();
            self.wrapper.remove();
            self.dropdown.remove();
            self.input.innerHTML = revertSettings.innerHTML;
            self.input.tabIndex = revertSettings.tabIndex;
            removeClasses(self.input, "tomselected", "ts-hidden-accessible");
            self._destroy();
            delete self.input.tomselect;
        }
        /**
	   * A helper method for rendering "item" and
	   * "option" templates, given the data.
	   *
	   */ render(templateName, data) {
            var id, html;
            const self = this;
            if (typeof this.settings.render[templateName] !== "function") return null;
            // render markup
            html = self.settings.render[templateName].call(this, data, escape_html);
            if (!html) return null;
            html = getDom(html);
            // add mandatory attributes
            if (templateName === "option" || templateName === "option_create") {
                if (data[self.settings.disabledField]) setAttr(html, {
                    "aria-disabled": "true"
                });
                else setAttr(html, {
                    "data-selectable": ""
                });
            } else if (templateName === "optgroup") {
                id = data.group[self.settings.optgroupValueField];
                setAttr(html, {
                    "data-group": id
                });
                if (data.group[self.settings.disabledField]) setAttr(html, {
                    "data-disabled": ""
                });
            }
            if (templateName === "option" || templateName === "item") {
                const value = get_hash(data[self.settings.valueField]);
                setAttr(html, {
                    "data-value": value
                });
                // make sure we have some classes if a template is overwritten
                if (templateName === "item") {
                    addClasses(html, self.settings.itemClass);
                    setAttr(html, {
                        "data-ts-item": ""
                    });
                } else {
                    addClasses(html, self.settings.optionClass);
                    setAttr(html, {
                        role: "option",
                        id: data.$id
                    });
                    // update cache
                    data.$div = html;
                    self.options[value] = data;
                }
            }
            return html;
        }
        /**
	   * Type guarded rendering
	   *
	   */ _render(templateName, data) {
            const html = this.render(templateName, data);
            if (html == null) throw "HTMLElement expected";
            return html;
        }
        /**
	   * Clears the render cache for a template. If
	   * no template is given, clears all render
	   * caches.
	   *
	   */ clearCache() {
            iterate$1(this.options, (option)=>{
                if (option.$div) {
                    option.$div.remove();
                    delete option.$div;
                }
            });
        }
        /**
	   * Removes a value from item and option caches
	   *
	   */ uncacheValue(value) {
            const option_el = this.getOption(value);
            if (option_el) option_el.remove();
        }
        /**
	   * Determines whether or not to display the
	   * create item prompt, given a user input.
	   *
	   */ canCreate(input) {
            return this.settings.create && input.length > 0 && this.settings.createFilter.call(this, input);
        }
        /**
	   * Wraps this.`method` so that `new_fn` can be invoked 'before', 'after', or 'instead' of the original method
	   *
	   * this.hook('instead','onKeyDown',function( arg1, arg2 ...){
	   *
	   * });
	   */ hook(when, method, new_fn) {
            var self = this;
            var orig_method = self[method];
            self[method] = function() {
                var result, result_new;
                if (when === "after") result = orig_method.apply(self, arguments);
                result_new = new_fn.apply(self, arguments);
                if (when === "instead") return result_new;
                if (when === "before") result = orig_method.apply(self, arguments);
                return result;
            };
        }
    }
    /**
	 * Plugin: "change_listener" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function change_listener() {
        addEvent(this.input, "change", ()=>{
            this.sync();
        });
    }
    /**
	 * Plugin: "checkbox_options" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function checkbox_options(userOptions) {
        var self = this;
        var orig_onOptionSelect = self.onOptionSelect;
        self.settings.hideSelected = false;
        const cbOptions = Object.assign({
            // so that the user may add different ones as well
            className: "tomselect-checkbox",
            // the following default to the historic plugin's values
            checkedClassNames: undefined,
            uncheckedClassNames: undefined
        }, userOptions);
        var UpdateChecked = function UpdateChecked(checkbox, toCheck) {
            if (toCheck) {
                checkbox.checked = true;
                if (cbOptions.uncheckedClassNames) checkbox.classList.remove(...cbOptions.uncheckedClassNames);
                if (cbOptions.checkedClassNames) checkbox.classList.add(...cbOptions.checkedClassNames);
            } else {
                checkbox.checked = false;
                if (cbOptions.checkedClassNames) checkbox.classList.remove(...cbOptions.checkedClassNames);
                if (cbOptions.uncheckedClassNames) checkbox.classList.add(...cbOptions.uncheckedClassNames);
            }
        };
        // update the checkbox for an option
        var UpdateCheckbox = function UpdateCheckbox(option) {
            setTimeout(()=>{
                var checkbox = option.querySelector("input." + cbOptions.className);
                if (checkbox instanceof HTMLInputElement) UpdateChecked(checkbox, option.classList.contains("selected"));
            }, 1);
        };
        // add checkbox to option template
        self.hook("after", "setupTemplates", ()=>{
            var orig_render_option = self.settings.render.option;
            self.settings.render.option = (data, escape_html)=>{
                var rendered = getDom(orig_render_option.call(self, data, escape_html));
                var checkbox = document.createElement("input");
                if (cbOptions.className) checkbox.classList.add(cbOptions.className);
                checkbox.addEventListener("click", function(evt) {
                    preventDefault(evt);
                });
                checkbox.type = "checkbox";
                const hashed = hash_key(data[self.settings.valueField]);
                UpdateChecked(checkbox, !!(hashed && self.items.indexOf(hashed) > -1));
                rendered.prepend(checkbox);
                return rendered;
            };
        });
        // uncheck when item removed
        self.on("item_remove", (value)=>{
            var option = self.getOption(value);
            if (option) {
                // if dropdown hasn't been opened yet, the option won't exist
                option.classList.remove("selected"); // selected class won't be removed yet
                UpdateCheckbox(option);
            }
        });
        // check when item added
        self.on("item_add", (value)=>{
            var option = self.getOption(value);
            if (option) // if dropdown hasn't been opened yet, the option won't exist
            UpdateCheckbox(option);
        });
        // remove items when selected option is clicked
        self.hook("instead", "onOptionSelect", (evt, option)=>{
            if (option.classList.contains("selected")) {
                option.classList.remove("selected");
                self.removeItem(option.dataset.value);
                self.refreshOptions();
                preventDefault(evt, true);
                return;
            }
            orig_onOptionSelect.call(self, evt, option);
            UpdateCheckbox(option);
        });
    }
    /**
	 * Plugin: "dropdown_header" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function clear_button(userOptions) {
        const self = this;
        const options = Object.assign({
            className: "clear-button",
            title: "Clear All",
            html: (data)=>{
                return `<div class="${data.className}" title="${data.title}">&#10799;</div>`;
            }
        }, userOptions);
        self.on("initialize", ()=>{
            var button = getDom(options.html(options));
            button.addEventListener("click", (evt)=>{
                if (self.isLocked) return;
                self.clear();
                if (self.settings.mode === "single" && self.settings.allowEmptyOption) self.addItem("");
                evt.preventDefault();
                evt.stopPropagation();
            });
            self.control.appendChild(button);
        });
    }
    /**
	 * Plugin: "drag_drop" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ const insertAfter = (referenceNode, newNode)=>{
        var _referenceNode$parent;
        (_referenceNode$parent = referenceNode.parentNode) == null || _referenceNode$parent.insertBefore(newNode, referenceNode.nextSibling);
    };
    const insertBefore = (referenceNode, newNode)=>{
        var _referenceNode$parent2;
        (_referenceNode$parent2 = referenceNode.parentNode) == null || _referenceNode$parent2.insertBefore(newNode, referenceNode);
    };
    const isBefore = (referenceNode, newNode)=>{
        do {
            var _newNode;
            newNode = (_newNode = newNode) == null ? void 0 : _newNode.previousElementSibling;
            if (referenceNode == newNode) return true;
        }while (newNode && newNode.previousElementSibling);
        return false;
    };
    function drag_drop() {
        var self = this;
        if (self.settings.mode !== "multi") return;
        var orig_lock = self.lock;
        var orig_unlock = self.unlock;
        let sortable = true;
        let drag_item;
        /**
	   * Add draggable attribute to item
	   */ self.hook("after", "setupTemplates", ()=>{
            var orig_render_item = self.settings.render.item;
            self.settings.render.item = (data, escape)=>{
                const item = getDom(orig_render_item.call(self, data, escape));
                setAttr(item, {
                    "draggable": "true"
                });
                // prevent doc_mousedown (see tom-select.ts)
                const mousedown = (evt)=>{
                    if (!sortable) preventDefault(evt);
                    evt.stopPropagation();
                };
                const dragStart = (evt)=>{
                    drag_item = item;
                    setTimeout(()=>{
                        item.classList.add("ts-dragging");
                    }, 0);
                };
                const dragOver = (evt)=>{
                    evt.preventDefault();
                    item.classList.add("ts-drag-over");
                    moveitem(item, drag_item);
                };
                const dragLeave = ()=>{
                    item.classList.remove("ts-drag-over");
                };
                const moveitem = (targetitem, dragitem)=>{
                    if (dragitem === undefined) return;
                    if (isBefore(dragitem, item)) insertAfter(targetitem, dragitem);
                    else insertBefore(targetitem, dragitem);
                };
                const dragend = ()=>{
                    var _drag_item;
                    document.querySelectorAll(".ts-drag-over").forEach((el)=>el.classList.remove("ts-drag-over"));
                    (_drag_item = drag_item) == null || _drag_item.classList.remove("ts-dragging");
                    drag_item = undefined;
                    var values = [];
                    self.control.querySelectorAll(`[data-value]`).forEach((el)=>{
                        if (el.dataset.value) {
                            let value = el.dataset.value;
                            if (value) values.push(value);
                        }
                    });
                    self.setValue(values);
                };
                addEvent(item, "mousedown", mousedown);
                addEvent(item, "dragstart", dragStart);
                addEvent(item, "dragenter", dragOver);
                addEvent(item, "dragover", dragOver);
                addEvent(item, "dragleave", dragLeave);
                addEvent(item, "dragend", dragend);
                return item;
            };
        });
        self.hook("instead", "lock", ()=>{
            sortable = false;
            return orig_lock.call(self);
        });
        self.hook("instead", "unlock", ()=>{
            sortable = true;
            return orig_unlock.call(self);
        });
    }
    /**
	 * Plugin: "dropdown_header" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function dropdown_header(userOptions) {
        const self = this;
        const options = Object.assign({
            title: "Untitled",
            headerClass: "dropdown-header",
            titleRowClass: "dropdown-header-title",
            labelClass: "dropdown-header-label",
            closeClass: "dropdown-header-close",
            html: (data)=>{
                return '<div class="' + data.headerClass + '">' + '<div class="' + data.titleRowClass + '">' + '<span class="' + data.labelClass + '">' + data.title + "</span>" + '<a class="' + data.closeClass + '">&times;</a>' + "</div>" + "</div>";
            }
        }, userOptions);
        self.on("initialize", ()=>{
            var header = getDom(options.html(options));
            var close_link = header.querySelector("." + options.closeClass);
            if (close_link) close_link.addEventListener("click", (evt)=>{
                preventDefault(evt, true);
                self.close();
            });
            self.dropdown.insertBefore(header, self.dropdown.firstChild);
        });
    }
    /**
	 * Plugin: "dropdown_input" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function caret_position() {
        var self = this;
        /**
	   * Moves the caret to the specified index.
	   *
	   * The input must be moved by leaving it in place and moving the
	   * siblings, due to the fact that focus cannot be restored once lost
	   * on mobile webkit devices
	   *
	   */ self.hook("instead", "setCaret", (new_pos)=>{
            if (self.settings.mode === "single" || !self.control.contains(self.control_input)) new_pos = self.items.length;
            else {
                new_pos = Math.max(0, Math.min(self.items.length, new_pos));
                if (new_pos != self.caretPos && !self.isPending) self.controlChildren().forEach((child, j)=>{
                    if (j < new_pos) self.control_input.insertAdjacentElement("beforebegin", child);
                    else self.control.appendChild(child);
                });
            }
            self.caretPos = new_pos;
        });
        self.hook("instead", "moveCaret", (direction)=>{
            if (!self.isFocused) return;
            // move caret before or after selected items
            const last_active = self.getLastActive(direction);
            if (last_active) {
                const idx = nodeIndex(last_active);
                self.setCaret(direction > 0 ? idx + 1 : idx);
                self.setActiveItem();
                removeClasses(last_active, "last-active");
            // move caret left or right of current position
            } else self.setCaret(self.caretPos + direction);
        });
    }
    /**
	 * Plugin: "dropdown_input" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function dropdown_input() {
        const self = this;
        self.settings.shouldOpen = true; // make sure the input is shown even if there are no options to display in the dropdown
        self.hook("before", "setup", ()=>{
            self.focus_node = self.control;
            addClasses(self.control_input, "dropdown-input");
            const div = getDom('<div class="dropdown-input-wrap">');
            div.append(self.control_input);
            self.dropdown.insertBefore(div, self.dropdown.firstChild);
            // set a placeholder in the select control
            const placeholder = getDom('<input class="items-placeholder" tabindex="-1" />');
            placeholder.placeholder = self.settings.placeholder || "";
            self.control.append(placeholder);
        });
        self.on("initialize", ()=>{
            // set tabIndex on control to -1, otherwise [shift+tab] will put focus right back on control_input
            self.control_input.addEventListener("keydown", (evt)=>{
                //addEvent(self.control_input,'keydown' as const,(evt:KeyboardEvent) =>{
                switch(evt.keyCode){
                    case KEY_ESC:
                        if (self.isOpen) {
                            preventDefault(evt, true);
                            self.close();
                        }
                        self.clearActiveItems();
                        return;
                    case KEY_TAB:
                        self.focus_node.tabIndex = -1;
                        break;
                }
                return self.onKeyDown.call(self, evt);
            });
            self.on("blur", ()=>{
                self.focus_node.tabIndex = self.isDisabled ? -1 : self.tabIndex;
            });
            // give the control_input focus when the dropdown is open
            self.on("dropdown_open", ()=>{
                self.control_input.focus();
            });
            // prevent onBlur from closing when focus is on the control_input
            const orig_onBlur = self.onBlur;
            self.hook("instead", "onBlur", (evt)=>{
                if (evt && evt.relatedTarget == self.control_input) return;
                return orig_onBlur.call(self);
            });
            addEvent(self.control_input, "blur", ()=>self.onBlur());
            // return focus to control to allow further keyboard input
            self.hook("before", "close", ()=>{
                if (!self.isOpen) return;
                self.focus_node.focus({
                    preventScroll: true
                });
            });
        });
    }
    /**
	 * Plugin: "input_autogrow" (Tom Select)
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function input_autogrow() {
        var self = this;
        self.on("initialize", ()=>{
            var test_input = document.createElement("span");
            var control = self.control_input;
            test_input.style.cssText = "position:absolute; top:-99999px; left:-99999px; width:auto; padding:0; white-space:pre; ";
            self.wrapper.appendChild(test_input);
            var transfer_styles = [
                "letterSpacing",
                "fontSize",
                "fontFamily",
                "fontWeight",
                "textTransform"
            ];
            for (const style_name of transfer_styles)// @ts-ignore TS7015 https://stackoverflow.com/a/50506154/697576
            test_input.style[style_name] = control.style[style_name];
            /**
	     * Set the control width
	     *
	     */ var resize = ()=>{
                test_input.textContent = control.value;
                control.style.width = test_input.clientWidth + "px";
            };
            resize();
            self.on("update item_add item_remove", resize);
            addEvent(control, "input", resize);
            addEvent(control, "keyup", resize);
            addEvent(control, "blur", resize);
            addEvent(control, "update", resize);
        });
    }
    /**
	 * Plugin: "input_autogrow" (Tom Select)
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function no_backspace_delete() {
        var self = this;
        var orig_deleteSelection = self.deleteSelection;
        this.hook("instead", "deleteSelection", (evt)=>{
            if (self.activeItems.length) return orig_deleteSelection.call(self, evt);
            return false;
        });
    }
    /**
	 * Plugin: "no_active_items" (Tom Select)
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function no_active_items() {
        this.hook("instead", "setActiveItem", ()=>{});
        this.hook("instead", "selectAll", ()=>{});
    }
    /**
	 * Plugin: "optgroup_columns" (Tom Select.js)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function optgroup_columns() {
        var self = this;
        var orig_keydown = self.onKeyDown;
        self.hook("instead", "onKeyDown", (evt)=>{
            var index, option, options, optgroup;
            if (!self.isOpen || !(evt.keyCode === KEY_LEFT || evt.keyCode === KEY_RIGHT)) return orig_keydown.call(self, evt);
            self.ignoreHover = true;
            optgroup = parentMatch(self.activeOption, "[data-group]");
            index = nodeIndex(self.activeOption, "[data-selectable]");
            if (!optgroup) return;
            if (evt.keyCode === KEY_LEFT) optgroup = optgroup.previousSibling;
            else optgroup = optgroup.nextSibling;
            if (!optgroup) return;
            options = optgroup.querySelectorAll("[data-selectable]");
            option = options[Math.min(options.length - 1, index)];
            if (option) self.setActiveOption(option);
        });
    }
    /**
	 * Plugin: "remove_button" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function remove_button(userOptions) {
        const options = Object.assign({
            label: "&times;",
            title: "Remove",
            className: "remove",
            append: true
        }, userOptions);
        //options.className = 'remove-single';
        var self = this;
        // override the render method to add remove button to each item
        if (!options.append) return;
        var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escape_html(options.title) + '">' + options.label + "</a>";
        self.hook("after", "setupTemplates", ()=>{
            var orig_render_item = self.settings.render.item;
            self.settings.render.item = (data, escape)=>{
                var item = getDom(orig_render_item.call(self, data, escape));
                var close_button = getDom(html);
                item.appendChild(close_button);
                addEvent(close_button, "mousedown", (evt)=>{
                    preventDefault(evt, true);
                });
                addEvent(close_button, "click", (evt)=>{
                    if (self.isLocked) return;
                    // propagating will trigger the dropdown to show for single mode
                    preventDefault(evt, true);
                    if (self.isLocked) return;
                    if (!self.shouldDelete([
                        item
                    ], evt)) return;
                    self.removeItem(item);
                    self.refreshOptions(false);
                    self.inputState();
                });
                return item;
            };
        });
    }
    /**
	 * Plugin: "restore_on_backspace" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function restore_on_backspace(userOptions) {
        const self = this;
        const options = Object.assign({
            text: (option)=>{
                return option[self.settings.labelField];
            }
        }, userOptions);
        self.on("item_remove", function(value) {
            if (!self.isFocused) return;
            if (self.control_input.value.trim() === "") {
                var option = self.options[value];
                if (option) self.setTextboxValue(options.text.call(self, option));
            }
        });
    }
    /**
	 * Plugin: "restore_on_backspace" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function virtual_scroll() {
        const self = this;
        const orig_canLoad = self.canLoad;
        const orig_clearActiveOption = self.clearActiveOption;
        const orig_loadCallback = self.loadCallback;
        var pagination = {};
        var dropdown_content;
        var loading_more = false;
        var load_more_opt;
        var default_values = [];
        if (!self.settings.shouldLoadMore) // return true if additional results should be loaded
        self.settings.shouldLoadMore = ()=>{
            const scroll_percent = dropdown_content.clientHeight / (dropdown_content.scrollHeight - dropdown_content.scrollTop);
            if (scroll_percent > 0.9) return true;
            if (self.activeOption) {
                var selectable = self.selectable();
                var index = Array.from(selectable).indexOf(self.activeOption);
                if (index >= selectable.length - 2) return true;
            }
            return false;
        };
        if (!self.settings.firstUrl) throw "virtual_scroll plugin requires a firstUrl() method";
        // in order for virtual scrolling to work,
        // options need to be ordered the same way they're returned from the remote data source
        self.settings.sortField = [
            {
                field: "$order"
            },
            {
                field: "$score"
            }
        ];
        // can we load more results for given query?
        const canLoadMore = (query)=>{
            if (typeof self.settings.maxOptions === "number" && dropdown_content.children.length >= self.settings.maxOptions) return false;
            if (query in pagination && pagination[query]) return true;
            return false;
        };
        const clearFilter = (option, value)=>{
            if (self.items.indexOf(value) >= 0 || default_values.indexOf(value) >= 0) return true;
            return false;
        };
        // set the next url that will be
        self.setNextUrl = (value, next_url)=>{
            pagination[value] = next_url;
        };
        // getUrl() to be used in settings.load()
        self.getUrl = (query)=>{
            if (query in pagination) {
                const next_url = pagination[query];
                pagination[query] = false;
                return next_url;
            }
            // if the user goes back to a previous query
            // we need to load the first page again
            self.clearPagination();
            return self.settings.firstUrl.call(self, query);
        };
        // clear pagination
        self.clearPagination = ()=>{
            pagination = {};
        };
        // don't clear the active option (and cause unwanted dropdown scroll)
        // while loading more results
        self.hook("instead", "clearActiveOption", ()=>{
            if (loading_more) return;
            return orig_clearActiveOption.call(self);
        });
        // override the canLoad method
        self.hook("instead", "canLoad", (query)=>{
            // first time the query has been seen
            if (!(query in pagination)) return orig_canLoad.call(self, query);
            return canLoadMore(query);
        });
        // wrap the load
        self.hook("instead", "loadCallback", (options, optgroups)=>{
            if (!loading_more) self.clearOptions(clearFilter);
            else if (load_more_opt) {
                const first_option = options[0];
                if (first_option !== undefined) load_more_opt.dataset.value = first_option[self.settings.valueField];
            }
            orig_loadCallback.call(self, options, optgroups);
            loading_more = false;
        });
        // add templates to dropdown
        //	loading_more if we have another url in the queue
        //	no_more_results if we don't have another url in the queue
        self.hook("after", "refreshOptions", ()=>{
            const query = self.lastValue;
            var option;
            if (canLoadMore(query)) {
                option = self.render("loading_more", {
                    query: query
                });
                if (option) {
                    option.setAttribute("data-selectable", ""); // so that navigating dropdown with [down] keypresses can navigate to this node
                    load_more_opt = option;
                }
            } else if (query in pagination && !dropdown_content.querySelector(".no-results")) option = self.render("no_more_results", {
                query: query
            });
            if (option) {
                addClasses(option, self.settings.optionClass);
                dropdown_content.append(option);
            }
        });
        // add scroll listener and default templates
        self.on("initialize", ()=>{
            default_values = Object.keys(self.options);
            dropdown_content = self.dropdown_content;
            // default templates
            self.settings.render = Object.assign({}, {
                loading_more: ()=>{
                    return `<div class="loading-more-results">Loading more results ... </div>`;
                },
                no_more_results: ()=>{
                    return `<div class="no-more-results">No more results</div>`;
                }
            }, self.settings.render);
            // watch dropdown content scroll position
            dropdown_content.addEventListener("scroll", ()=>{
                if (!self.settings.shouldLoadMore.call(self)) return;
                // !important: this will get checked again in load() but we still need to check here otherwise loading_more will be set to true
                if (!canLoadMore(self.lastValue)) return;
                // don't call load() too much
                if (loading_more) return;
                loading_more = true;
                self.load.call(self, self.lastValue);
            });
        });
    }
    TomSelect1.define("change_listener", change_listener);
    TomSelect1.define("checkbox_options", checkbox_options);
    TomSelect1.define("clear_button", clear_button);
    TomSelect1.define("drag_drop", drag_drop);
    TomSelect1.define("dropdown_header", dropdown_header);
    TomSelect1.define("caret_position", caret_position);
    TomSelect1.define("dropdown_input", dropdown_input);
    TomSelect1.define("input_autogrow", input_autogrow);
    TomSelect1.define("no_backspace_delete", no_backspace_delete);
    TomSelect1.define("no_active_items", no_active_items);
    TomSelect1.define("optgroup_columns", optgroup_columns);
    TomSelect1.define("remove_button", remove_button);
    TomSelect1.define("restore_on_backspace", restore_on_backspace);
    TomSelect1.define("virtual_scroll", virtual_scroll);
    return TomSelect1;
});
var $79d03e7a40edeffe$var$tomSelect = function(el, opts) {
    return new TomSelect(el, opts);
};

});


parcelRegister("kmRqw", function(module, exports) {

$parcel$export(module.exports, "CronRuleItems", () => $b371ddcef1f8a884$export$cdcb122dbd92c988);
$parcel$export(module.exports, "CronRule", () => $b371ddcef1f8a884$export$e3d0bec757577332);
$parcel$export(module.exports, "CronRuleItem", () => $b371ddcef1f8a884$export$19e8db371162d029);

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");
function $b371ddcef1f8a884$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b371ddcef1f8a884$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b371ddcef1f8a884$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b371ddcef1f8a884$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b371ddcef1f8a884$var$_arrayLikeToArray(o, minLen);
}
function $b371ddcef1f8a884$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $b371ddcef1f8a884$export$cdcb122dbd92c988 extends (0, $dMN2n.MuWidget) {
}
class $b371ddcef1f8a884$export$e3d0bec757577332 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
		<ul mu-id="items">
			<li mu-template="item" mu-widget="CronRuleItem">
				<div><span mu-id="title" class="a">Nenastaveno</span> <span title="Zobrazit/skr\xfdt datumy" mu-id="btToglePreview" class="icon-calendar a"></span></div>
				<ul mu-id="errors" class="error-list">
				</ul>
				<ul mu-id="preview" class="" style="display: none">
				</ul>
			</li>
		</ul>
		<span class="-btn-default -btn a" mu-id="btAddItem"><span class="icon-plus"></span> P\u{159}idat</span>
		<div mu-id="editor" class="panel panel-default">
			<div class="panel-heading">
				<select mu-id="type">` + (0, $kwZWC.Utils).htmlOptions({
            "": "Vyberte",
            year: "Ro\u010Dn\u011B",
            month: "M\u011Bs\xed\u010Dn\u011B",
            week: "T\xfddn\u011B",
            day: "Denn\u011B"
        }) + `
				</select>
				<span class="pull-right">
					<span class="a icon-yes" mu-id="btSave" title="Zapsat"></span>
					<span class="a icon-no" mu-id="btCloseEditor" title="Zav\u{159}\xedt"></span>
					<span class="a icon-trash" mu-id="btDelete" title="Smazat"></span>
				</span>
			</div>
			<div class="panel-body">
				<div mu-id="block_year">
					<label>
						Ka\u{17E}d\xfd 
						<input type="number" mu-id="year_yearPeriod" size="3" maxlength="3" />
						rok 
					</label>
					<label>
						Modulo
						<input type="number" mu-id="year_yearMod" size="3" maxlength="3" />
					</label><br />
					<label>
						M\u{11B}s\xedc: <select mu-id="year_dayOfYearMonth">` + (0, $kwZWC.Utils).htmlOptions({
            1: "leden",
            2: "\xfanor",
            3: "b\u0159ezen",
            4: "duben",
            5: "kv\u011Bten",
            6: "\u010Derven",
            7: "\u010Dervenec",
            8: "srpen",
            9: "z\xe1\u0159\xed",
            10: "\u0159\xedjen",
            11: "listopad",
            12: "prosinec"
        }) + `</select>
					</label>
					<label>
						Den:
						<input type="number" mu-id="year_dayOfYearDay" />
					</label>
				</div>
				<div mu-id="block_month">
					<label>
						Den:
						<input type="number" mu-id="month_dayOfMoon" />
					</label>
				</div>
				<div mu-id="block_week">
					<label>
						Den:
						<select mu-id="week_dayOfWeek">` + (0, $kwZWC.Utils).htmlOptions({
            1: "Pond\u011Bl\xed",
            2: "\xdater\xfd",
            3: "St\u0159eda",
            4: "\u010Ctvrtek",
            5: "P\xe1tek",
            6: "Sobota",
            0: "Ned\u011Ble"
        }) + `</select>
					</label>
				</div>
				<div mu-id="block_day">
					<label>
						Ka\u{17E}d\xfd 
						<input type="number" mu-id="day_dayPeriod" size="3" maxlength="3" />
						den 
					</label>
					<label>
						Modulo
						<input type="number" mu-id="day_dayMod" size="3" maxlength="3" />
					</label><br />
				</div>
			</div>
		</div>
		`);
    }
    afterIndex() {
        this.switchBlock();
        const values = JSON.parse(this.ui.input.value);
        if (values) for(var _iterator = $b371ddcef1f8a884$var$_createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;){
            const val = _step.value;
            this.addItem(val);
        }
        this.btCloseEditor_click();
    }
    type_change() {
        this.switchBlock();
    }
    switchBlock() {
        const curr = this.ui.type.value;
        for(var _i = 0, _arr = [
            "year",
            "month",
            "week",
            "day"
        ]; _i < _arr.length; _i++){
            const k = _arr[_i];
            this.muVisible(curr == k, "block_" + k);
        }
    }
    btAddItem_click() {
        this.addItem();
    }
    addItem(params = {}) {
        this.openEditor(this.muWidgetFromTemplate("item", "items", {
            value: params == undefined ? {} : params
        }));
    }
    openEditor(item) {
        this.muVisible(true, this.ui.editor);
        this.muVisible(false, this.ui.btAddItem);
        for(const k in this.ui){
            const p = k.indexOf("_");
            if (p > -1) {
                var k2 = k.substr(p + 1);
                /* if (item.value[k2]) */ this.ui[k].value = item.value[k2] ? item.value[k2] : "";
            }
        }
        this.activeItem = item;
        let t = "";
        if (item.value.dayOfMoon) t = "month";
        else if (item.value.dayOfWeek != undefined) t = "week";
        else if (item.value.dayPeriod != undefined) t = "day";
        else if (item.value.yearPeriod != undefined || item.value.yearMod != undefined || item.value.dayOfYearMonth != undefined || item.value.dayOfYearDay != undefined) t = "year";
        this.ui.type.value = t;
        this.switchBlock();
        this.selectItem(item);
    }
    selectItem(item) {
        (0, $dMN2n.MuWidget).getChildWidgets(this.ui.items).map((listItem)=>listItem.setSelected(listItem == item));
    }
    btCloseEditor_click() {
        this.muVisible(false, "editor");
        this.muVisible(true, "btAddItem");
        this.selectItem();
    }
    saveEditor() {
        var t = this.ui.type.value;
        var value = {};
        for(var k in this.ui){
            var p = k.indexOf("_");
            if (p > -1) {
                var k1 = k.substr(0, p);
                var k2 = k.substr(p + 1);
                if (t == k1) value[k2] = this.ui[k].value;
            }
        }
        this.activeItem.setValue(value);
        this.saveField();
    }
    btSave_click() {
        this.saveEditor();
        this.btCloseEditor_click();
    }
    saveField() {
        this.ui.input.value = JSON.stringify((0, $dMN2n.MuWidget).getChildWidgets(this.ui.items).map((item)=>item.value));
    }
    btDelete_click() {
        if (confirm("Opravdu chcete smazat toto pravidlo?")) {
            this.ui.items.removeChild(this.activeItem.container);
            this.saveField();
            this.btCloseEditor_click();
        }
    }
    getUrl(cmd, params) {
        var url = this.url[cmd];
        url = url.replace(/__([a-zA-Z0-9]+)__/g, (m, n)=>params[n] ? params[n] : "");
        return url;
    }
}
class $b371ddcef1f8a884$export$19e8db371162d029 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.setValue(this.value);
        this.visiblePreview = false;
    }
    async setValue(value) {
        this.value = value;
        this.ui.title.innerText = JSON.stringify(value);
        const data = await (await fetch(this.getUrl("preview", {
            src: JSON.stringify(this.value)
        }))).json();
        this.ui.title.innerText = data.name;
        this.ui.errors.innerHTML = (0, $kwZWC.Utils).htmlListText(data.errors);
        this.muVisible(data.errors.length > 0, this.ui.errors);
        this.ui.preview.innerHTML = (0, $kwZWC.Utils).htmlListText(data.preview);
        this.muVisible(data.preview.length > 0, "btToglePreview");
    }
    btToglePreview_click() {
        this.visiblePreview = !this.visiblePreview;
        this.muVisible(this.visiblePreview, this.ui.preview);
    }
    title_click() {
        this.muParent.openEditor(this);
    }
    setSelected(selected) {
        this.container.classList.toggle("selected", selected);
    }
    getUrl(cmd, params) {
        return this.muParent.getUrl(cmd, params);
    }
    constructor(...args){
        super(...args);
        this.visiblePreview = false;
    }
}

});

parcelRegister("iQTdn", function(module, exports) {

$parcel$export(module.exports, "CalendarPage", () => $2a43e326929dc355$export$246e90a17afccc11);
$parcel$export(module.exports, "UiCalendarItem", () => $2a43e326929dc355$export$1f8ebc7749c29824);
$parcel$export(module.exports, "UiCalendarRow", () => $2a43e326929dc355$export$14390cf0f973e778);
$parcel$export(module.exports, "CalendarPageRouter", () => $2a43e326929dc355$export$a775cdef229b25b2);

var $6Taw3 = parcelRequire("6Taw3");

var $l5WCV = parcelRequire("l5WCV");

var $aMsft = parcelRequire("aMsft");

var $kwZWC = parcelRequire("kwZWC");

var $d9JXN = parcelRequire("d9JXN");

var $iF9nm = parcelRequire("iF9nm");
class $2a43e326929dc355$export$246e90a17afccc11 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
        <h3 class="display-flex-row align-items-center">
            <span class="icon-before-left icon-before--autosize a-nc" mu="bPeriodPrev"></span>
            <input type="month" class="calendar-page__period h3" mu="period" />
            <span class="icon-before-right icon-before--autosize a-nc" mu="bPeriodNext"></span>
            <span class="flex-grow-1"></span>
            <!-- <span class="icon-before-search icon-before--autosize a-nc" mu="bSearch">Hled\xe1n\xed</span>        
            <span class="icon-before-calendar icon-before--autosize a-nc" mu="bCalendar">Kalend\xe1\u{159}</span> -->
            <div mu="tabs:UiTabs" class="font-size-normal"></div>        
        </h3>
        <div mu="calendar:CalendarOverview" tab-label="Kalend\xe1\u{159}">
			<div mu=":UiCalendarItem@item">
				<span mu="#note"></span>
			</div>
        </div>
        <div mu="cSearch" tab-label="Hled\xe1n\xed">
            <div mu-keybind="Enter:bDoSearch">
                <div class="row form-group">
                    <label class="col-2 control-label" mu-for="fulltext">Hledan\xfd text</label>
                    <div class="col-10">
                        <input type="search" mu="fulltext" class="form-control" />
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-2 control-label" mu-for="dtFrom">Datum od</label>
                    <div class="col-4">
                        <input type="date" mu="dtFrom" class="form-control" />
                    </div>
                    <label class="col-2 control-label" mu-for="dtTo">do</label>
                    <div class="col-4">
                        <input type="date" mu="dtTo" class="form-control" />
                    </div>
                </div>
                <div class="buttons">
                    <span class="btn btn-primary icon-before-search" mu="bDoSearch">Vyhledat</span>    
                </div>
            </div>

            <div class="alert alert-warning" mu="manyResultsAlert" style="display: none">
                Nalezeno p\u{159}\xedli\u{17E} mnoho v\xfdsledk\u{16F}, up\u{159}esn\u{11B}te hledan\xfd term\xedn.    
            </div>
            <table mu="searchResultsContainer" class="table">
                <tbody mu="searchResults#searchResults:@foreach">
                    <tr mu=":UiCalendarRow@searchResultItem" class="a-nc">
                    </tr>
                </tbody>
            </table>        
        </div>
        `);
        this.container.classList.add("calendar-page", "calendar-page--month");
    }
    async afterIndex() {
        this.ui.period.value = new Date().toISOString().substring(0, 7);
    }
    async doInit() {
        this.period_change();
    }
    async reloadCalendar(y = null, m = null) {
        if (y !== null) this.ui.period.value = (0, $kwZWC.YMPeriod).toInput(y, m);
        this.currentM = m ?? this.currentM;
        this.currentY = y ?? this.currentY;
        const data = await this.cl.withMessage("Na\u010D\xedt\xe1m kalend\xe1\u0159", this.ui.calendar).getCalOverview((0, $kwZWC.YMPeriod).toNum(this.currentY, this.currentM));
        this.muNamedWidget.calendar.bindData(this.currentY, this.currentM, data.items);
    }
    bDoSearch_click() {
        this.loadSearchResults();
    }
    async loadSearchResults() {
        const data = await this.cl.withMessage("Hled\xe1m v kalend\xe1\u0159i", this.ui.searchResultsContainer).searchInCalendar(this.ui.dtFrom.value, this.ui.dtTo.value, this.ui.fulltext.value);
        this.muVisible(data.manyResults, "manyResultsAlert");
        this.muBindData({
            searchResults: data.items
        });
    }
    bPeriodPrev_click() {
        this.shiftPeriod(-1);
    }
    bPeriodNext_click() {
        this.shiftPeriod(1);
    }
    period_change() {
        const p = (0, $kwZWC.YMPeriod).inputToYM(this.ui.period.value);
        if (p) this.reloadCalendar(...p);
    }
    openItem(item) {
        if (item.ticket?.projectCode === "TODO") this.openTodoEditor(null, item.ticket.id, "ticket");
        else if (item.calItemRepeating) this.openTodoEditor(null, item.calItemRepeating.id, "cir");
        else this.openInModal("UiCalendarItemDetail", "Detail polo\u017Eky kalend\xe1\u0159e").bindData(item);
    }
    calendar_add(ev, dt) {
        this.openTodoEditor(dt);
    }
    openTodoEditor(dt, id = null, itemType = null) {
        const ttf = this.openInModal("TodoTicketForm", " ", {
            muParent: this
        });
        if (dt) ttf.muBindData({
            dtTerm: dt,
            repeating: {
                dtFrom: dt,
                dayOfMonth: dt.getDate(),
                dayOfWeek: (dt.getDay() + 6) % 7
            }
        });
        if (itemType) ttf.doLoad(id, itemType);
        else ttf.doNew();
        ttf.addEventListener("saved", ()=>{
            ttf.muRemoveSelf();
            this.reloadCalendar();
        });
        return ttf;
    }
    shiftPeriod(change) {
        this.ui.period.value = (0, $kwZWC.YMPeriod).shift(this.ui.period.value, change);
        this.period_change();
    }
    setMonth(dt) {
        this.ui.period.value = dt.substring(0, 7);
        this.period_change();
        this.muNamedWidget.tabs.selectTab("calendar");
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $l5WCV.CalCL)();
        this.currentY = -1;
        this.currentM = 0;
    }
}
class $2a43e326929dc355$export$1f8ebc7749c29824 extends (0, $aMsft.CalendarOverviewItem) {
    afterIndex() {}
    muAfterBindData(data) {
        const ccl = [];
        if (data.ticket) ccl.push("calendar-item--state-" + data.ticket.stateCode);
        this.container.classList.add(...ccl);
    }
    container_click() {
        this.muParent.muParent.openItem(this.item);
    }
    constructor(...args){
        super(...args);
        this.item = null;
    }
}
class $2a43e326929dc355$export$14390cf0f973e778 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
            <td><span mu="stateIcon"></span></td>
            <td>
                <span class="icon-before-calendar" title="Otev\u{159}\xedt m\u{11B}s\xedc v kalend\xe1\u{159}i" mu-click='openMonth:"dtFrom"'></span>
                <span mu="dtFrom#dtFrom|date"></span>
            </td>
            <td>
                <span class="icon-before-calendar" title="Otev\u{159}\xedt m\u{11B}s\xedc v kalend\xe1\u{159}i" mu-click='openMonth:"dtFrom"' mu-bind="dtTo:@visible"></span>
                <span mu-bind="dtTo|date"></span>
            </td>
            <td><span mu="icon"></span></td>
            <td><span mu="note#note"></span> <em class="content-in-brackets" mu="noteAddon"></em></td>
        `);
    }
    openMonth(ev, field) {
        this.callMethodInFirstAncestors("setMonth", this.item[field]);
        ev.stopPropagation();
    }
    afterIndex() {}
    muAfterBindData(data) {
        const ccl = [];
        if (data.ticket) ccl.push("calendar-item--state-" + data.ticket.stateCode);
        this.ui.stateIcon.classList.add(...ccl);
        this.item = data;
        this.ui.icon.classList.add("icon-before-" + ({
            calItem: "calendar",
            calItemRepeating: "calendar-range",
            procDataValue: "pqm-item"
        })[data.type]);
        this.ui.icon.title = ({
            calItem: "Polo\u017Eka kalend\xe1\u0159e",
            calItemRepeating: "Opakovan\xe1 polo\u017Eka",
            procDataValue: "Datum z procesu"
        })[data.type];
        if (data.calItemRepeating) this.ui.noteAddon.innerText = (0, $iF9nm.DateRepeating).getTextInfo(data.calItemRepeating);
    }
    container_click() {
        this.muParent.openItem(this.item);
    }
    constructor(...args){
        super(...args);
        this.item = null;
    }
}
class $2a43e326929dc355$export$a775cdef229b25b2 extends (0, $d9JXN.BaseRouter) {
    paTicket(a, ticket) {
        super.paTicket(a, ticket);
    }
}

});
parcelRegister("l5WCV", function(module, exports) {

$parcel$export(module.exports, "CalCL", () => $bb422d44355445f7$export$6aa5f6f48a21c184);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $bb422d44355445f7$export$6aa5f6f48a21c184 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/cal"){
        super(url);
    }
    getPlannedDates(repeating, count, dateTime = null) {
        return this.callMethod("getPlannedDates", arguments, {
            "rawResult": false
        });
    }
    getCalOverview(period) {
        return this.callMethod("getCalOverview", arguments, {
            "rawResult": false
        });
    }
    searchInCalendar(dtFrom, dtTo, fulltext) {
        return this.callMethod("searchInCalendar", arguments, {
            "rawResult": false
        });
    }
}

});

parcelRegister("aMsft", function(module, exports) {

$parcel$export(module.exports, "CalendarOverview", () => $69129c388e70f436$export$660984028a59dc1a);
$parcel$export(module.exports, "CalendarOverviewDay", () => $69129c388e70f436$export$f0d36dd53f4d8da);
$parcel$export(module.exports, "CalendarOverviewItem", () => $69129c388e70f436$export$8631a3a35c6290a9);

var $6Taw3 = parcelRequire("6Taw3");
function $69129c388e70f436$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $69129c388e70f436$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $69129c388e70f436$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $69129c388e70f436$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $69129c388e70f436$var$_arrayLikeToArray(o, minLen);
}
function $69129c388e70f436$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $69129c388e70f436$export$660984028a59dc1a extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muRegisterEvent("add");
        this.container.classList.add("calendar-overview", "calendar-overview--grid");
        this.muAppendContent(`
			<div class="calendar-overview__content" mu="content">
				<div mu=":CalendarOverviewDay@day"></div>
				<div class="calendar-overview__weekday" mu=":.@weekDay"><span mu-bind="name"></span></div>
			</div>
		`);
    }
    afterIndex() {
    // this.makeDays(2024, 1);
    }
    makeDays(y, m) {
        this.currentMonth = m;
        this.currentYear = y;
        const lastDayNum = new Date(y, m + 1, 0).getDate();
        const firstDay = new Date(y, m);
        const fdc = (firstDay.getDay() - this.firstDayInWeek + 7) % 7;
        for(var _iterator = $69129c388e70f436$var$_createForOfIteratorHelperLoose(this.dayNames), _step; !(_step = _iterator()).done;){
            const name = _step.value;
            this.muWidgetFromTemplate("weekDay", "content").muBindData({
                name: name
            });
        }
        for(let i = 0; i < fdc; i++)this.muWidgetFromTemplate("day", "content", {
            otherMonthDay: true
        });
        this.dayWidgets = {};
        for(let d = 1; d <= lastDayNum; d++){
            const dt = new Date(firstDay);
            dt.setDate(d);
            this.dayWidgets[d] = this.muWidgetFromTemplate("day", "content", {
                otherMonthDay: false,
                dayNum: d,
                date: dt
            });
        }
    }
    bindData(y, m, data = []) {
        this.ui.content.innerHTML = "";
        this.makeDays(y, m);
        for(var _i = 0, _data = data; _i < _data.length; _i++){
            const item = _data[_i];
            let dt = new Date(item[this.opts.dateFromField]);
            const dtFrom = new Date(dt);
            const dtTo = new Date(item[this.opts.dateToField] ?? item[this.opts.dateFromField]);
            let f = true;
            const currPeriod = this.currentMonth + this.currentYear * 12;
            while(dt <= dtTo){
                const itemPeriod = dt.getMonth() + dt.getFullYear() * 12;
                const dom = dt.getDate();
                dt.setDate(dt.getDate() + 1);
                if (itemPeriod < currPeriod) {
                    f = false;
                    continue;
                }
                const data = {
                    ...item
                };
                let rangeType;
                const isEnd = dt > dtTo;
                if (isEnd && f) rangeType = "full";
                else if (f) rangeType = "begin";
                else if (isEnd) rangeType = "end";
                else rangeType = "mid";
                data[this.opts.rangeTypeField] = rangeType;
                f = false;
                if (itemPeriod > currPeriod) break;
                if (!this.dayWidgets[dom]) continue;
                const w = this.muWidgetFromTemplate("item", this.dayWidgets[dom].ui.items, this.itemParams);
                // @ts-ignore
                w.item = item;
                w.muBindData(data);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.firstDayInWeek = 1;
        this.dayNames = [
            "Po",
            "Ut",
            "St",
            "\u010Ct",
            "Pa",
            "So",
            "Ne"
        ];
        this.itemParams = {};
        this.currentYear = -1;
        this.currentMonth = -1;
        this.dayWidgets = {};
        this.opts = {
            dateFromField: "dtFrom",
            dateToField: "dtTo",
            rangeTypeField: "rangeType"
        };
    }
}
class $69129c388e70f436$export$f0d36dd53f4d8da extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.container.classList.add(`calendar-overview__day`);
        this.container.classList.toggle(`calendar-overview__day--empty-fill`, this.otherMonthDay);
        this.muAppendContent(`
			<span class="calendar-overview__day-date" mu="dayLabel">#</span>
			<div mu="items">
				<div mu=":CalendarOverviewItem@item">
				
				</div>
			</div>
			<span class="calendar-overview__day__add icon-before-add" mu="add">P\u{159}idat</span>			
		`);
    }
    afterIndex() {
        /* if (!this.otherMonthDay) {
    	for(let n = 0; n < Math.random() * 8; n++) {
    		this.muWidgetFromTemplate('item', 'items').muBindData({ name: "ggggg"});
    	}
    } */ // @ts-ignore
        this.ui.dayLabel.innerText = this.dayNum ?? "";
    }
    add_click() {
        this.muParent.muDispatchEvent("add", this.date);
    }
    constructor(...args){
        super(...args);
        this.otherMonthDay = false;
        this.dayNum = null;
    }
}
class $69129c388e70f436$export$8631a3a35c6290a9 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.container.classList.add(`calendar-overview__item`);
        this.muAppendContent(`<span mu="#name"></span>`);
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        this.container.classList.add("calendar-overview__item--" + srcData.rangeType);
        this.container.classList.toggle("calendar-overview__item--repeating", !!srcData.repeat);
    }
}

});

parcelRegister("d9JXN", function(module, exports) {

$parcel$export(module.exports, "BaseRouter", () => $ee193f8dc4e140e9$export$d924ab28242808ca);

var $9fwPo = parcelRequire("9fwPo");

var $kwZWC = parcelRequire("kwZWC");
class $ee193f8dc4e140e9$export$d924ab28242808ca extends (0, $9fwPo.MuRouter) {
    paTicket(a, ticket) {
        // this.prepareAnchor();
        (0, $kwZWC.Arrays).ooaToArray(a).forEach((el)=>el.href = "/ticket/detail/" + ticket.id);
    }
    paProcData(a, procDataId) {
        // this.prepareAnchor();
        (0, $kwZWC.Arrays).ooaToArray(a).forEach((el)=>el.href = "/ticket/proc-data-detail?procDataId=" + procDataId);
    }
}

});

parcelRegister("iF9nm", function(module, exports) {

$parcel$export(module.exports, "DateRepeating", () => $76d0fadefeea9abe$export$d5fab6055ac53460);

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");

var $l5WCV = parcelRequire("l5WCV");

var $75oRH = parcelRequire("75oRH");
class $76d0fadefeea9abe$export$d5fab6055ac53460 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muRegisterEvent("changeType");
        this.muAppendContent(`
			<div class="row form-group">
				<label class="col-sm-3 control-label" mu-for="type">Opakov\xe1n\xed</label>
				<div class="display-flex col-9">
					<div class="radiolist-horizontal flex-grow-1">
						<label mu="lNone"><input type="radio" mu-change="type_change" mu-name="type" value="none">Jednor\xe1zov\u{11B}</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="week" mu="type_week">T\xfddn\u{11B}</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="month">M\u{11B}s\xed\u{10D}n\u{11B}</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="month3">\u{10C}tvrtletn\u{11B}</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="month6">P\u{16F}lro\u{10D}n\u{11B}</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="year">Ro\u{10D}n\u{11B}</label>
					</div>
					<span class="btn btn-default" mu="bTest">Uka\u{17E} data</span>
				</div>
				<input type="hidden" mu-bind="type" />
				<div class="col-3"></div><div class="col-md-9" mu-for="error:type"></div>
			</div>
			<div mu="pDayOfWeek" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="dayOfWeek">Den v t\xfddnu</label>
				<div class="col-sm-9">
					<select mu="dayOfWeek#dayOfWeek;dayList:@options" class="form-control"></select>
				</div>
			</div>	
			<div mu="pDayOfMonth" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="dayOfMonth">Den v m\u{11B}s\xedci</label>
				<div class="col-sm-9">
					<div class="display-flex">
						<input type="number" mu="dayOfMonth#dayOfMonth" class="form-control flex-grow-1" min="-29" max="31" />
						<span class="">
							<span class="icon-help" title="Zadejte \u{10D}\xedslo dne v m\u{11B}s\xedc\xed nebo 0 pro posledn\xed den v m\u{11B}s\xedc\xed, nebo z\xe1porn\xe9 \u{10D}\xedslo den v m\u{11B}s\xedci od konce"></span>
						</span>
					</div>
					<div mu-for="error:dayOfMonth"></div>
				</div>
			</div>
			<div mu="pMonthMod" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="monthMod">M\u{11B}s\xedc</label>
				<div class="col-sm-9">
					<select type="number" mu="monthMod#monthMod;monthList:@options" class="form-control"></select>
				</div>
			</div>	
			<div mu="pFromTo" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="dtFrom">Platnost od</label>
				<div class="col-sm-3">
					<input type="date" mu="dtFrom#dtFrom|dateToInputD" class="form-control">
				</div>
				<label class="col-sm-3 control-label text-center" mu-for="dtTo">do</label>
				<div class="col-sm-3">
					<input type="date" mu="dtTo#dtTo|dateToInputD" class="form-control">
				</div>
			</div>
		`);
    }
    afterIndex() {
        let n = 0;
        this.muBindData({
            dayList: [
                {
                    text: "Vyberte den",
                    value: ""
                },
                ...$76d0fadefeea9abe$export$d5fab6055ac53460.dayNames.map((name)=>({
                        text: name,
                        value: n++
                    }))
            ]
        });
        this.update();
    }
    static{
        this.dayNames = [
            "Pond\u011Bl\xed",
            "\xdater\xfd",
            "St\u0159eda",
            "\u010Ctvrtek",
            "P\xe1tek",
            "Sobota",
            "Ned\u011Bla"
        ];
    }
    static{
        this.monthNames = [
            "Leden",
            // '1 - Leden',
            "\xdanor",
            // '2 - Únor',
            "B\u0159ezen",
            // '3 - Březen',
            "Duben",
            // '4 - Duben',
            "Kv\u011Bten",
            // '5 - Květen',
            "\u010Cerven",
            // '6 - Červen',
            "\u010Cervenec",
            // '7 - Červenec',
            "Srpen",
            // '8 - Srpen',
            "Z\xe1\u0159\xed",
            // '9 - Září',
            "\u0158\xedjen",
            // '10 - Říjen',
            "Listopad",
            // '11 - Listopad',
            "Prosinec" // '12 - Prosinec',
        ];
    }
    type_change() {
        this.update();
        this.muDispatchEvent("changeType", this.type);
    }
    get type() {
        // @ts-ignore
        return (0, $kwZWC.getSelectedValue)(this.ui.type_week);
    }
    set type(value) {
        // @ts-ignore
        (0, $kwZWC.setSelectedValue)(this.ui.type_week, value);
    }
    set hideNone(hidden) {
        this.muVisible(!hidden, "lNone");
    }
    update() {
        this.muVisible(this.type === "week", "pDayOfWeek");
        this.muVisible(![
            null,
            "none",
            "week"
        ].includes(this.type), "pDayOfMonth");
        this.muVisible(![
            null,
            "none",
            "week",
            "month"
        ].includes(this.type), "pMonthMod");
        this.muVisible(this.type !== null && this.type !== "none", "pFromTo");
        // @ts-ignore
        const period = this.typePeriod[this.type];
        if (period) {
            const opts = {};
            for(let mm = 0; mm < period; mm++){
                const months = $76d0fadefeea9abe$export$d5fab6055ac53460.getMonthsByPeriod(period, mm);
                opts[mm] = months;
            }
            this.muBindData({
                monthList: opts
            });
        }
        this.muVisible(![
            null,
            "none"
        ].includes(this.type), "bTest");
    }
    static getMonthsByPeriod(period, mm) {
        const months = [];
        for(let mi = mm; mi < 12; mi += period)months.push($76d0fadefeea9abe$export$d5fab6055ac53460.monthNames[mi]);
        return months.join(", ");
    }
    muFetchData() {
        const res = {
            dayOfMonth: null,
            dayOfWeek: null,
            monthMod: null,
            monthPeriod: null,
            dtFrom: (0, $kwZWC.emptyToNull)(this.ui.dtFrom.value),
            dtTo: (0, $kwZWC.emptyToNull)(this.ui.dtTo.value)
        };
        switch(this.type){
            case "month3":
            case "month6":
            case "year":
            case "month":
                res.monthPeriod = this.typePeriod[this.type];
                res.monthMod = parseInt(this.ui.monthMod.value);
                res.dayOfMonth = this.ui.dayOfMonth.valueAsNumber;
                break;
            case "week":
                res.dayOfWeek = parseInt(this.ui.dayOfWeek.value);
                break;
            default:
                return null;
        }
        return res;
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        if (srcData.dayOfWeek) {
            this.type = "week";
            this.update();
        } else if (srcData.monthPeriod) {
            this.type = (0, $kwZWC.Objects).swapKeysValues(this.typePeriod)[srcData.monthPeriod];
            this.update();
        }
    }
    async bTest_click() {
        const errs = this.checkForm();
        if (errs) (0, $kwZWC.flashError)("Nejprve opravte: " + errs.map((e)=>e.message).join(", "));
        else (0, $kwZWC.flashInfo)("Tato polo\u017Eka se bude opakovat: \n" + (await this.cl.getPlannedDates(this.muFetchData(), 20, this.ui.dtFrom.value)).map((d)=>(0, $kwZWC.formatDate)("d.m.Y", d)).join("\n") + "\n...");
    }
    checkForm() {
        const errors = new (0, $75oRH.ErrorMarkerErrors)();
        switch(this.type){
            case "month3":
            case "month6":
            case "year":
            case "month":
                if (isNaN(this.ui.dayOfMonth.valueAsNumber)) errors.add("dayOfMonth", "Vyberte v m\u011Bs\xedci");
                if (!this.ui.monthMod.value) errors.add("monthMod", "Vyberte m\u011Bs\xedc");
                break;
            case "week":
                if (!this.ui.dayOfWeek.value) errors.add("dayOfWeek", "Vyberte den v t\xfddnu");
                break;
            case "none":
                break;
            default:
                errors.add("type", "Vyberte opakov\xe1n\xed");
                break;
        }
        return errors.length ? errors : null;
    }
    static getTextInfo(data) {
        if (typeof data.dayOfWeek === "number") return "Ka\u017Ed\xfd t\xfdden v " + $76d0fadefeea9abe$export$d5fab6055ac53460.dayNames[data.dayOfWeek];
        let text = "";
        switch(data.monthPeriod){
            case 1:
                text += "Ka\u017Ed\xfd m\u011Bs\xedc";
                break;
            case 3:
                text += "\u010Ctvrtletn\u011B";
                break;
            case 6:
                text += "Pololetn\u011B";
                break;
            case 12:
                text += "Ro\u010Dn\u011B";
                break;
        }
        text += " ";
        if (data.dayOfMonth === 0) text += "posledn\xed den v m\u011Bs\xedc\xed";
        else if (data.dayOfMonth > 28) text += data.dayOfMonth + ". nebo posledn\xed den v m\u011Bs\xedci";
        else if (data.dayOfMonth > 1) text += data.dayOfMonth + ". den v m\u011Bs\xedci";
        else text += data.dayOfMonth + ". den p\u0159ed koncem m\u011Bs\xedce";
        if (data.monthPeriod > 1) text += " " + $76d0fadefeea9abe$export$d5fab6055ac53460.getMonthsByPeriod(data.monthPeriod, data.monthMod);
        return text;
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $l5WCV.CalCL)();
        this.typePeriod = {
            month: 1,
            month3: 3,
            month6: 6,
            year: 12
        };
    }
}

});


parcelRegister("gxt3I", function(module, exports) {

$parcel$export(module.exports, "UiCalendarItemDetail", () => $69e69a76952f1b8e$export$3d870b4972ac3030);
$parcel$export(module.exports, "UiCalendarItemDetailTicketLI", () => $69e69a76952f1b8e$export$65d819bef4565048);

var $6Taw3 = parcelRequire("6Taw3");

var $l5WCV = parcelRequire("l5WCV");

var $jRjEI = parcelRequire("jRjEI");

var $5k56K = parcelRequire("5k56K");

var $iF9nm = parcelRequire("iF9nm");
class $69e69a76952f1b8e$export$3d870b4972ac3030 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
            <h4><span mu-bind="note"></span> <span class="head-subtitle" mu-bind="typeLabel"></span></h4>
            <div>
                <span mu-bind='dtFrom|dateTime("auto-date-time")'></span> -
                <span mu-bind='dtTo|dateTime("auto-date-time")'></span>
            </div>
            <div mu="pProcData">
                <a mu="lProcData">Spu\u{161}t\u{11B}n\xfd proces <span mu-bind="procDataSummary"></span> <em mu-id="procDataEvidenceUid" mu-bind="procDataEvidenceUid"></em></a>
                <h5>Souvisej\xedc\xed po\u{17E}adavky</h5>
                <ul mu-bind="tickets:@foreach">
                    <li mu=":UiCalendarItemDetailTicketLI@item">
                        <a mu="link">
                            <strong mu-bind="evidenceUid"></strong> <span mu-bind="summary"></span>
                        </a>
                    </li>
                </ul>
            </div>
            <div mu="repeatingInfo"></div>
            <div>
                <a mu="ticketLink">
                    Pat\u{159}\xed k po\u{17E}adavku 
                    <strong mu-bind='ticket|getField("evidenceUid")'></strong>
                    <strong mu-bind='ticket|getField("summary")'></strong>
                </a>
            </div>
        `);
    }
    closeDetail(ev) {
        this.muRemoveSelf();
    }
    async bindData(item) {
        let typeLabel = "";
        if (item.repeat) typeLabel = "Opakovan\xe1 polo\u017Eka";
        else if (item.procDataId) typeLabel = "Datum procesu";
        else typeLabel = "Polo\u017Eka kalend\xe1\u0159e" + (item.calItemRepeating ? " z opakov\xe1n\xed" : "");
        this.muBindData({
            ...item,
            typeLabel: typeLabel
        });
        this.muVisible(false, [
            "pProcData"
        ]);
        if (item.procDataId) {
            this.muVisible(true, "pProcData");
            this.muBindData(await this.pqmCl.getMyTicketWithPqmPacket(item.procDataId, item.pqmPacketId));
            this.getRouter().paProcData(this.ui.lProcData, item.procDataId);
        }
        if (item.calItemRepeating) this.ui.repeatingInfo.innerText = (0, $iF9nm.DateRepeating).getTextInfo(item.calItemRepeating);
        if (item.ticket) this.getRouter().paTicket(this.ui.ticketLink, item.ticket);
        else this.muVisible(false, "ticketLink");
    }
    ticketLink_click(ev) {
        this.closeDetail(ev);
    }
    constructor(...args){
        super(...args);
        this.calCl = new (0, $l5WCV.CalCL)();
        this.ticketsCl = new (0, $jRjEI.TicketsCL)();
        this.pqmCl = new (0, $5k56K.PqmCL)();
    }
}
class $69e69a76952f1b8e$export$65d819bef4565048 extends (0, $6Taw3.BaseMuWidget) {
    muAfterBindData(data) {
        this.getRouter().paTicket(this.ui.link, data);
    }
    link_click(ev) {
        this.callMethodInFirstAncestors("closeDetail", ev);
    }
}

});
parcelRegister("jRjEI", function(module, exports) {

$parcel$export(module.exports, "TicketsCL", () => $3f51ad7cda4f1a4d$export$da40f16fc510fc2d);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $3f51ad7cda4f1a4d$export$da40f16fc510fc2d extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/tickets"){
        super(url);
    }
    getTicketRels(ticketId, profile) {
        return this.callMethod("getTicketRels", arguments, {
            "rawResult": false
        });
    }
    addTicketRels(ticketId, profile, ticketBIds, returnNewList = true) {
        return this.callMethod("addTicketRels", arguments, {
            "rawResult": false
        });
    }
    dropTicketRels(ticketRelId) {
        return this.callMethod("dropTicketRels", arguments, {
            "rawResult": false
        });
    }
    findTickets(query, filter = []) {
        return this.callMethod("findTickets", arguments, {
            "rawResult": false
        });
    }
    splitTicketByAttach(originalTicketId, groupAttach) {
        return this.callMethod("splitTicketByAttach", arguments, {
            "rawResult": false
        });
    }
    getTodoTicket(id) {
        return this.callMethod("getTodoTicket", arguments, {
            "rawResult": false
        });
    }
    getCalItemRepeating(id) {
        return this.callMethod("getCalItemRepeating", arguments, {
            "rawResult": false
        });
    }
    saveTodoTicket(data, id) {
        return this.callMethod("saveTodoTicket", arguments, {
            "rawResult": false
        });
    }
    saveCalItemRepeating(data, id) {
        return this.callMethod("saveCalItemRepeating", arguments, {
            "rawResult": false
        });
    }
    callTicketActionState(id, code) {
        return this.callMethod("callTicketActionState", arguments, {
            "rawResult": false
        });
    }
    getTickets(overviewProfileId, subprofile, userFilter, limitFrom, limitCount) {
        return this.callMethod("getTickets", arguments, {
            "rawResult": false
        });
    }
    getPqmTicketStats(overviewProfileId, subprofile, userFilter) {
        return this.callMethod("getPqmTicketStats", arguments, {
            "rawResult": false
        });
    }
    getTicketMetadata(id) {
        return this.callMethod("getTicketMetadata", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getAttachData(attachId, authByTicketId = null) {
        return this.callMethod("getAttachData", arguments, {
            "rawResult": false
        });
    }
    getAttachesFotTicketAndRelated(ticketId) {
        return this.callMethod("getAttachesFotTicketAndRelated", arguments, {
            "rawResult": false
        });
    }
    findAttachesFor(ids) {
        return this.callMethod("findAttachesFor", arguments, {
            "rawResult": false
        });
    }
    getBcmAttachesFor(ids) {
        return this.callMethod("getBcmAttachesFor", arguments, {
            "rawResult": false
        });
    }
    saveAttach(attachId, ids, data) {
        return this.callMethod("saveAttach", arguments, {
            "rawResult": false
        });
    }
    createFolder(ids, name, parentId) {
        return this.callMethod("createFolder", arguments, {
            "rawResult": false
        });
    }
    newTempFile() {
        return this.callMethod("newTempFile", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});

parcelRegister("5k56K", function(module, exports) {

$parcel$export(module.exports, "PqmCL", () => $da4b17d7da5d7c1d$export$d2e42ccaee939982);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $da4b17d7da5d7c1d$export$d2e42ccaee939982 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/pqm"){
        super(url);
    }
    getTicketAndProcDataWithDetailsFor(ticketId) {
        return this.callMethod("getTicketAndProcDataWithDetailsFor", arguments, {
            "rawResult": false
        });
    }
    saveTicketAndProcData(ticketData, srcProcData, ticketId) {
        return this.callMethod("saveTicketAndProcData", arguments, {
            "rawResult": false
        });
    }
    createTicketAndProcData(pqmItemId, ticketData, srcProcData) {
        return this.callMethod("createTicketAndProcData", arguments, {
            "rawResult": false
        });
    }
    getMyTicketWithPqmPacket(procDataId, pqmPacketId) {
        return this.callMethod("getMyTicketWithPqmPacket", arguments, {
            "rawResult": false
        });
    }
    procDataFinalize(id) {
        return this.callMethod("procDataFinalize", arguments, {
            "rawResult": false
        });
    }
    ticketFinalize(ticketId) {
        return this.callMethod("ticketFinalize", arguments, {
            "rawResult": false
        });
    }
    getStartData(pqmItemId) {
        return this.callMethod("getStartData", arguments, {
            "rawResult": false
        });
    }
    cancelProcData(procDataId, reason) {
        return this.callMethod("cancelProcData", arguments, {
            "rawResult": false
        });
    }
    requireCompletion(procDataId, pqmPacketIds, reason, ticketId = null) {
        return this.callMethod("requireCompletion", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("g7kTW", function(module, exports) {

$parcel$export(module.exports, "TopPage", () => $4fcdbd6b17d3291f$export$63a9b4af538ab47);

var $6Taw3 = parcelRequire("6Taw3");

var $d9JXN = parcelRequire("d9JXN");
class $4fcdbd6b17d3291f$export$63a9b4af538ab47 extends (0, $6Taw3.BaseMuWidget) {
    constructor(...args){
        super(...args);
        this.router = new (0, $d9JXN.BaseRouter)();
    }
}

});

parcelRegister("lbTwC", function(module, exports) {

$parcel$export(module.exports, "TodoTicketForm", () => $3d2eac4642bdcc81$export$cfdd48bb4f947ac5);

var $6Taw3 = parcelRequire("6Taw3");

var $jRjEI = parcelRequire("jRjEI");

var $l5WCV = parcelRequire("l5WCV");

var $75oRH = parcelRequire("75oRH");

var $kwZWC = parcelRequire("kwZWC");
class $3d2eac4642bdcc81$export$cfdd48bb4f947ac5 extends (0, $6Taw3.BaseMuWidget) {
    doNew() {
        this.item = null;
        this.itemType = "new";
        this.muNamedWidget.repeating.type = null;
        this.muNamedWidget.repeating.update();
    }
    async doLoad(id, itemType) {
        this.itemType = itemType;
        this.item = itemType === "ticket" ? await this.ticketsCl.withMessage("Na\u010D\xedt\xe1m polo\u017Eku", this.ui.editor).getTodoTicket(id) : await this.ticketsCl.withMessage("Na\u010D\xedt\xe1m \u0159adu", this.ui.editor).getCalItemRepeating(id);
        this.muBindData(this.item);
        if (itemType === "cir") this.muBindData({
            repeating: this.item
        });
        this.updateForm();
        if (itemType === "ticket") await this.muNamedWidget.attachList.bindData({
            ticketId: id
        });
        // @ts-ignore
        return this.item;
    }
    beforeIndex() {
        this.muRegisterEvent("saved");
        this.muAppendContent((this.addTitle ? '<h1 mu="modalTitle"></h1>' : "") + `<div mu="editor">
                <div class="row form-group">
                    <label class="col-3 control-label" mu-for="name">N\xe1zev</label>
                    <div class="col-9 form-label">
                        <input type="text" mu-bind="name" class="form-control" />
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-3 control-label" mu-for="summary">Pozn\xe1mka</label>
                    <div class="col-9 form-label">
                        <div mu="note:Htmlarea#note"></div>
                    </div>
                </div>
                <div mu="repeating:DateRepeating#repeating"></div>
                <div mu="repeatingInfo"></div>
                <div class="row form-group control-label" mu="pDtTerm">
                    <label class="col-3 form-label" mu-for="dtTerm">Term\xedn</label>
                    <div class="col-9">
                        <input type="date" mu-bind="dtTerm|dateToInputD" class="form-control" />
                    </div>
                </div>
                <div class="row form-group" mu="pAttaches">
                    <label class="col-3 form-label">P\u{159}\xedloha</label>
                    <div class="col-9">
                        <div mu="attachNew:MultiUpload"></div>
                        <div mu="attachList:AttachList"></div>
                    </div> 
                </div>
    
                <div class="buttons">
                    <span class="btn btn-default" mu="bSave">Ulo\u{17E}it zm\u{11B}ny</span>
                    <span class="btn btn-primary" mu="bCreateTicket">Vytvo\u{159}it polo\u{17E}ku</span>
                    <span class="btn btn-primary" mu="bCreateRepeating">Vytvo\u{159}it \u{159}adu</span>
                    <span class="btn btn-primary" mu="bDone">Dokon\u{10D}it</span>
                    <span class="btn btn-primary" mu="bReopen">Znovu otev\u{159}\xedt</span>
                </div>
            </div>
        `);
    }
    afterIndex() {
        this.updateForm();
        this.ui.pAttaches.append(this.muNamedWidget.attachList.ui.pPreview);
    }
    repeating_changeType() {
        this.updateForm();
    }
    updateForm() {
        const rt = this.muNamedWidget.repeating.type;
        this.muVisible(rt === "none" || this.itemType === "ticket", [
            "pAttaches",
            "pDtTerm"
        ]);
        this.muNamedWidget.repeating.hideNone = this.itemType !== "new";
        const repeatingEditable = this.itemType !== "ticket";
        this.muVisible(repeatingEditable, [
            "repeating",
            "!repeatingInfo"
        ]);
        // this.ui.repeatingInfo.innerText = DateRepeating.getTextInfo(this.item.repeating);
        this.muVisible(this.itemType !== "new", "bSave");
        this.muVisible(this.itemType === "new" && rt === "none", "bCreateTicket");
        this.muVisible(this.itemType === "new" && rt !== "none", "bCreateRepeating");
        // @ts-ignore
        this.muVisible(this.itemType === "ticket" && this.item.state === "new", "bDone");
        // @ts-ignore
        this.muVisible(this.itemType === "ticket" && this.item.state === "done", "bReopen");
        this.ui.modalTitle.innerText = this.itemType === "new" ? rt === "none" ? "Nov\xe9 todo" : "Nov\xe1 \u0159ada" : "Upravit " + (this.itemType === "ticket" ? "todo" : "\u0159adu");
    }
    async bSave_click() {
        await this.trySave();
    }
    async bCreateTicket_click() {
        await this.trySave();
    }
    async bCreateRepeating_click() {
        await this.trySave();
    }
    async bDone_click() {
        await this.trySave("close");
    }
    async bReopen_click() {
        await this.trySave("reopen");
    }
    async trySave(stateActionCode = null) {
        const data = this.muFetchData();
        const dataR = {
            ...data,
            ...data.repeating
        };
        data.stateActionCode = stateActionCode;
        if (this.validateForm()) {
            if (this.itemType === "new") {
                if (this.muNamedWidget.repeating.type === "none") {
                    this.item = await this.ticketsCl.saveTodoTicket(data, null);
                    this.itemType = "ticket";
                } else {
                    this.item = await this.ticketsCl.saveCalItemRepeating(dataR, null);
                    this.itemType = "cir";
                }
            } else if (this.itemType === "ticket") this.item = await this.ticketsCl.saveTodoTicket(data, this.item.id);
            else this.item = await this.ticketsCl.saveCalItemRepeating(dataR, this.item.id);
            (0, $kwZWC.flashInfo)("Ulo\u017Eeno" + (stateActionCode ? " a zm\u011Bn\u011Bn stav" : ""));
            if (this.itemType === "ticket" && this.muNamedWidget.attachNew.getAllFiles().length > 0) var res = await this.muNamedWidget.attachNew.sendToBackend((ctx, send)=>{
                ctx.url = this.uploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
                    ticketId: this.item.id,
                    fileName: ctx.file.name,
                    contentType: ctx.file.type,
                    size: ctx.file.size
                }));
                send();
            });
            this.muDispatchEvent("saved");
        } else (0, $kwZWC.flashError)("Nejprve opravte chyby");
    }
    validateForm() {
        const data = this.muFetchData();
        const errors = new (0, $75oRH.ErrorMarkerErrors)();
        if (this.itemType !== "ticket") errors.merge(this.muNamedWidget.repeating.checkForm() || [], "repeating");
        if (!data.name) errors.add("name", "Zadejte n\xe1zev");
        this.errorMarker.markErrors(errors);
        return errors.isValid();
    }
    constructor(...args){
        super(...args);
        this.ticketsCl = new (0, $jRjEI.TicketsCL)();
        this.calCl = new (0, $l5WCV.CalCL)();
        this.uploadUrl = "/ticket/upload-raw-attach";
        this.addTitle = false;
        this.itemType = "new";
        this.item = null;
        this.errorMarker = new (0, $75oRH.ErrorMarker)(this);
    }
}

});

parcelRegister("5epYV", function(module, exports) {

$parcel$export(module.exports, "AttachList", () => $07744eecf04a19e5$export$dad4ccdecbb8f187);
$parcel$export(module.exports, "AttachListActions", () => $07744eecf04a19e5$export$ddb795a1343db3a5);

var $6Taw3 = parcelRequire("6Taw3");

var $3Yb7l = parcelRequire("3Yb7l");

var $jRjEI = parcelRequire("jRjEI");

var $bjpdy = parcelRequire("bjpdy");
class $07744eecf04a19e5$export$dad4ccdecbb8f187 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`<table mu="list:UiTable" class="table table-striped table-hover table-sticky-header tbody-_td-_a">
            <tr>
                <td mu=":UiTableCell@actions">
                    <span class="icon-before-remove" mu="bRemove">odstranit</span>
                    <span class="icon-before-remove" mu="bDownload">st\xe1hnout</span>
                </td>
            </tr>
        </table>
        <div mu="pPreview">
            <div class="attaches__preview">
                <div mu-id="preview"></div>
            </div>
            <div class="buttons" mu-id="previewButtons">
                <a target="_blank" class="btn-icon btn-icon-size-3 icon-before-download" mu-id="bDownload">St\xe1hnout</a>
                <span class="btn-icon btn-icon-size-3 icon-before-close" mu-id="bClosePreview">Zav\u{159}\xedt n\xe1hled</span>
            </div>
        </div>`);
    }
    afterIndex() {
        this.bClosePreview_click();
    }
    async bindData(ids = null) {
        ids = ids || this.ids;
        this.ids = ids;
        const self = this;
        this.muNamedWidget.list.columns = [
            new (0, $3Yb7l.ColumnInfo)({
                field: "fileName",
                name: "N\xe1zev",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "fileSize",
                name: "Velikost",
                orderable: false,
                filterable: false
            }),
            // new ColumnInfo({ field: "description", name: "", orderable: false, isFiltered: false }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "typeTitle",
                name: "Type",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dtAdd",
                name: "P\u0159id\xe1no",
                orderable: false,
                filterable: false,
                transformContent: (value, columnInf, cell, ev)=>(0, $bjpdy.MuBinder).filters.dateTime(value)
            })
        ];
        this.muNamedWidget.list.rowParams = {};
        this.muNamedWidget.list.data = await this.cl.withMessage("Na\u010D\xedt\xe1m p\u0159\xedlohy", this.container).findAttachesFor(ids);
        this.muNamedWidget.list.render();
    }
    async list_rowClick(ev, row) {
        this.muVisible(true, "pPreview");
        this.ui.bDownload.href = row.data.downloadLink;
        const data = await this.cl.withMessage("Na\u010D\xedt\xe1m n\xe1hled", this.ui.preview).getAttachDetail(row.data.id, null);
        this.ui.preview.innerHTML = data;
    }
    bClosePreview_click() {
        this.muVisible(false, "pPreview");
    }
    hasAnyAttach() {
        return this.muNamedWidget.list.data.length > 0;
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $jRjEI.TicketsCL)();
        this.ids = {
            foo: 42
        };
    }
}
class $07744eecf04a19e5$export$ddb795a1343db3a5 extends (0, $3Yb7l.UiTableCell) {
}

});
parcelRegister("3Yb7l", function(module, exports) {

$parcel$export(module.exports, "UiTable", () => $d7205ce4d70c13b1$export$c0fcccb49c87941f);
$parcel$export(module.exports, "UiTableHeadCell", () => $d7205ce4d70c13b1$export$1f9db997510a5c30);
$parcel$export(module.exports, "ColumnInfo", () => $d7205ce4d70c13b1$export$fb288f79c90984d1);
$parcel$export(module.exports, "UiTableCell", () => $d7205ce4d70c13b1$export$4788a7a418384109);
$parcel$export(module.exports, "UiTableCellTemplate", () => $d7205ce4d70c13b1$export$1d2324502580922a);

var $dMN2n = parcelRequire("dMN2n");
function $d7205ce4d70c13b1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d7205ce4d70c13b1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d7205ce4d70c13b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d7205ce4d70c13b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d7205ce4d70c13b1$var$_arrayLikeToArray(o, minLen);
}
function $d7205ce4d70c13b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $d7205ce4d70c13b1$export$c0fcccb49c87941f extends (0, $dMN2n.MuWidget) {
    render(isInteractive = true) {
        this.ui.head.innerHTML = "";
        this.ui.body.innerHTML = "";
        for(var _iterator = $d7205ce4d70c13b1$var$_createForOfIteratorHelperLoose(this.columns), _step; !(_step = _iterator()).done;){
            const columnInfo = _step.value;
            if (!isInteractive && columnInfo.interactiveOnly) continue;
            const wth = this.muWidgetFromTemplate("tableHeadCell", "head", {
                columnInfo: columnInfo,
                isInteractive: isInteractive
            });
            if (columnInfo.cssClass) wth.container.classList.add(...columnInfo.cssClass.split(" "));
            if (columnInfo.headCssClass) wth.container.classList.add(...columnInfo.headCssClass.split(" "));
        }
        for(var _iterator2 = $d7205ce4d70c13b1$var$_createForOfIteratorHelperLoose(this.data), _step2; !(_step2 = _iterator2()).done;){
            const row = _step2.value;
            let rowParams = {
                data: row
            };
            if (typeof this.rowParams === "function") this.rowParams(row, rowParams);
            else rowParams = {
                ...rowParams,
                ...this.rowParams
            };
            const wRow = this.muWidgetFromTemplate("row", "body", rowParams);
            wRow.container.addEventListener("click", (ev)=>this.muDispatchEvent("rowClick", wRow));
            for(var _iterator3 = $d7205ce4d70c13b1$var$_createForOfIteratorHelperLoose(this.columns), _step3; !(_step3 = _iterator3()).done;){
                const columnInfo = _step3.value;
                const ev = {
                    isInteractive: isInteractive
                };
                if (!isInteractive && columnInfo.interactiveOnly) continue;
                const cell = wRow.muWidgetFromTemplate(columnInfo.template || "tableCell", wRow.container, {
                    columnInfo: columnInfo,
                    ...columnInfo.widgetParams
                });
                let val = columnInfo.transformContent ? columnInfo.transformContent(row[columnInfo.field], columnInfo, cell, ev) : row[columnInfo.field];
                /* if (val !== null && val !== undefined) */ if (columnInfo.cssClass) cell.container.classList.add(...columnInfo.cssClass.split(" "));
                if (columnInfo.cellCssClass) cell.container.classList.add(...columnInfo.cellCssClass.split(" "));
                cell.value = val;
                cell.row = row;
                cell.render(val, row, ev);
            }
            this.muDispatchEvent("rowRendered", wRow);
        }
    }
    afterIndex() {
        if (this.ui.templates) this.ui.templates.parentElement.removeChild(this.ui.templates);
    }
    beforeIndex() {
        this.container.innerHTML += `<thead><tr mu-id="head">
			<th mu-widget="UiTableHeadCell" mu-template="tableHeadCell"></th>
		</tr></thead>
		<tbody mu-id="body">
			<tr mu-widget="." mu-template="row">
				<td mu-template="tableCell" mu-widget="UiTableCell"></td>
			</tr>
		</tbody>`;
        this.muRegisterEvent("order", "filter", "rowClick", "rowRendered");
    }
    constructor(...args){
        super(...args);
        this.columns = [];
        this.data = [];
        this.rowParams = {};
    }
}
class $d7205ce4d70c13b1$export$1f9db997510a5c30 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.container.innerHTML += this.isInteractive ? `<div class="mtable-head-cell">
				<span class="mtable-head-cell__label">
				  <span class="mtable-head-cell__label-label" mu-id="label">Popisek sloupce</span>
				  <span class="mtable-head-cell__label-indicator" mu-id="indicatorOrderAsc">&and;</span>
				  <span class="mtable-head-cell__label-indicator" mu-id="indicatorOrderDesc">&or;</span>
				  <span class="mtable-head-cell__label-indicator" mu-id="indicatorFilter">&#128269;</span>
				</span>
				<span class="mtable-head-cell__buttons">
				  <span class="mtable-head-cell__button" mu-id="bOrderAsc">&and;</span>
				  <span class="mtable-head-cell__button" mu-id="bOrderDesc">&or;</span>
				  <span class="mtable-head-cell__button" mu-id="bFilter">&#128269;</span>
				</span>
			  </div>` : `<strong class="mtable-head-cell__label-label" mu-id="label">Popisek sloupce</strong>`;
    }
    afterIndex() {
        if (this.isInteractive) {
            this.muVisible(this.columnInfo.filterable, "bFilter");
            this.muVisible(this.columnInfo.orderable, [
                "bOrderAsc",
                "bOrderDesc"
            ]);
            this.muVisible(this.columnInfo.isFiltered, "indicatorFilter");
            this.muVisible(this.columnInfo.isOrdered === "asc", "indicatorOrderAsc");
            this.muVisible(this.columnInfo.isOrdered === "desc", "indicatorOrderDesc");
        }
        this.ui.label.innerText = this.columnInfo.name;
    }
    bOrderAsc_click() {
        this.muParent.muDispatchEvent("order", this.columnInfo.field, "asc");
    }
    bOrderDesc_click() {
        this.muParent.muDispatchEvent("order", this.columnInfo.field, "desc");
    }
    bFilter_click() {
        this.muParent.muDispatchEvent("filter", this.columnInfo.field);
    }
    constructor(...args){
        super(...args);
        this.isFilted = false;
        this.ordered = null;
        this.isInteractive = true;
    }
}
class $d7205ce4d70c13b1$export$fb288f79c90984d1 {
    /* renderHeadCell(table: UiTable) {
  	this.table = table;
  } */ constructor(initData = {}){
        this.name = "";
        this.field = "";
        this.position = 0;
        this.orderable = true;
        this.filterable = true;
        this.template = null;
        this.isFiltered = false;
        this.isOrdered = null;
        this.widgetParams = {};
        this.cssClass = null;
        this.cellCssClass = null;
        this.headCssClass = null;
        this.transformContent = null;
        this.interactiveOnly = false;
        Object.assign(this, initData);
    }
}
class $d7205ce4d70c13b1$export$4788a7a418384109 extends (0, $dMN2n.MuWidget) {
    render(value, row, ev) {
        this.container.innerText = value || "";
    }
}
class $d7205ce4d70c13b1$export$1d2324502580922a extends (0, $dMN2n.MuWidget) {
    render(value, row, ev) {
        this.muBindData({
            ...row,
            value: value
        });
    }
}

});


parcelRegister("ktJgr", function(module, exports) {

$parcel$export(module.exports, "UiTomSelect", () => $0a088e7fe4f2ee97$export$e20a1ccc43b93668);

var $aspqD = parcelRequire("aspqD");

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");
function $0a088e7fe4f2ee97$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0a088e7fe4f2ee97$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0a088e7fe4f2ee97$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0a088e7fe4f2ee97$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0a088e7fe4f2ee97$var$_arrayLikeToArray(o, minLen);
}
function $0a088e7fe4f2ee97$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $0a088e7fe4f2ee97$export$e20a1ccc43b93668 extends (0, $dMN2n.MuWidget) {
    get value() {
        return this.tom?.getValue();
    }
    set value(v) {
        this.tom.setValue(v);
    }
    get valueOption() {
        const v = this.value;
        // @ts-ignore
        return v ? this.tom.options[v] : null;
    }
    muFetchData() {
        this.autoinit();
        return this.value;
    }
    fireEvent() {
        const newValue = JSON.stringify(this.value);
        if (this.oldValue !== newValue) {
            this.oldValue = newValue;
            if (!this.disableEvents) this.muDispatchEvent("changeValue", {
                selector: this,
                option: this.valueOption,
                value: newValue
            });
        }
    }
    async muBindData(data) {
        this.autoinit();
        const oldValue = this.getValue();
        if (this.multiple) {
            if (data) {
                let value = [];
                for(var _iterator = $0a088e7fe4f2ee97$var$_createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;){
                    const v = _step.value;
                    if (!v || [
                        "string",
                        "number"
                    ].includes(typeof v)) value.push(v);
                    else {
                        this.tom.addOption(v);
                        value.push(v[this.valueField]);
                    }
                }
                if (value.length) {
                    const existsIds = Object.keys(this.tom.options);
                    value = value.map((v)=>v.toString());
                    const missing = (0, $kwZWC.arrayDiff)(value, existsIds);
                    if (missing.length) {
                        const loader = this.missingOptionLoader || this.optionLoader;
                        if (loader) loader(missing, (newOptions)=>{
                            this.replaceOptions(newOptions);
                            this.value = value;
                            this.fireEvent();
                        });
                        else this.fireEvent();
                    } else {
                        this.value = value;
                        this.fireEvent();
                    }
                } else {
                    this.value = [];
                    this.fireEvent();
                }
            } else {
                this.value = [];
                this.fireEvent();
            }
        } else if (!data || [
            "string",
            "number"
        ].includes(typeof data)) {
            const val = data;
            if (!val) ;
            else if (!this.tom.options[val]) {
                this.tom.addOption({
                    [this.valueField]: val,
                    [this.labelField]: "... " + val
                });
                const loader = this.missingOptionLoader || this.optionLoader;
                if (loader) loader([
                    val
                ], (newOptions)=>{
                    this.replaceOptions(newOptions);
                    this.fireEvent();
                    this.muDispatchEvent("changeText");
                });
                else this.fireEvent();
            } else this.fireEvent();
            this.value = val;
        } else {
            this.replaceOption(data);
            this.value = data[this.valueField];
        }
    }
    bindItems(items, removeExists = false) {
        this.autoinit();
        this.noEvents(()=>{
            const oldValue = this.value;
            if (removeExists) this.tom.clearOptions();
            if (Array.isArray(items)) for(var _iterator2 = $0a088e7fe4f2ee97$var$_createForOfIteratorHelperLoose(items), _step2; !(_step2 = _iterator2()).done;){
                const item = _step2.value;
                this.replaceOption(item);
            }
            else for(const k in items){
                let item = items[k];
                this.replaceOption(typeof item === "string" ? {
                    id: k,
                    title: item
                } : item);
            }
            this.value = oldValue;
        });
    }
    beforeIndex() {
        this.muRegisterEvent("changeValue", "changeText");
        this.container.innerHTML += '<select mu-id="input"' + (this._multiple ? " multiple" : "") + "></select>";
    }
    afterIndex() {
    // this.init();
    }
    set multiple(multiple) {
        this._multiple = multiple;
        if (this.ui.input) this.ui.input.multiple = multiple;
    }
    get multiple() {
        return this._multiple;
    }
    init(initOpts = {}) {
        for(const k in initOpts)// @ts-ignore
        this[k] = initOpts[k];
        const opts = {
            maxItems: this.multiple ? this.maxItems : 1,
            valueField: this.valueField,
            labelField: this.labelField,
            searchField: this.searchField.length ? this.searchField : [
                this.labelField
            ]
        };
        if (this.muTemplates.item) {
            const render = (item, escape)=>{
                const itemWidget = this.muWidgetFromTemplate("item", null, item);
                itemWidget.muBindData(item);
                return itemWidget.container;
            };
            // @ts-ignore
            opts.render = {
                option: render,
                item: render
            };
        }
        if (this.canCreate) {
            opts.create = true;
            //TODO: Obejít méně prasečím způsobem
            opts.onItemAdd = (v, d)=>{
                const newOpt = this.tom.options[v];
                if (newOpt[this.valueField] != newOpt[this.labelField]) return;
                delete this.tom.options[v];
                const newV = this.newValuePrefix + v;
                newOpt[this.valueField] = newV;
                this.tom.options[newV] = newOpt;
                this.tom.items = this.tom.items.map((iv)=>iv == v ? newV : iv);
            };
        }
        if (this.optionLoader) opts.load = (escapeQuery, callback)=>this.optionLoader(escapeQuery, callback);
        opts.onChange = (ev)=>this.fireEvent();
        if (this.tom) this.tom.destroy();
        // @ts-ignore
        this.tom = new (0, (/*@__PURE__*/$parcel$interopDefault($aspqD)))(this.ui.input, opts);
        return this;
    }
    replaceOption(option) {
        if (this.tom.options[option[this.valueField]]) this.tom.updateOption(option[this.valueField], option);
        else this.tom.addOption(option);
    // this.tom.
    }
    replaceOptions(options) {
        for(var _i = 0, _options = options; _i < _options.length; _i++){
            const option = _options[_i];
            this.replaceOption(option);
        }
    }
    autoinit() {
        if (!this.tom) this.init();
    }
    getValue() {
        return this.muFetchData();
    }
    setSelected(v) {
        return this.muBindData(v);
    }
    addSelected(v) {
        this.setSelected([
            ...this.getValue(),
            v
        ]);
    }
    removeSelected(v) {
        this.setSelected([
            ...this.getValue().filter((ve)=>v.toString() != ve.toString())
        ]);
    }
    setDisabled(disabled) {
        this.autoinit();
        if (disabled) this.tom.disable();
        else this.tom.enable();
    }
    noEvents(runThis) {
        this.disableEvents = true;
        try {
            runThis();
        } finally{
            this.disableEvents = false;
        }
    }
    getValueStr(field = "name", seprator = ", ") {
        const values = this.multiple ? this.tom.getValue() : [
            this.tom.getValue()
        ];
        // @ts-ignore
        return values.map((id)=>(this.tom.options[id] ? this.tom.options[id][field] : null) ?? "...").join(seprator);
    }
    focus() {
        this.tom.focus();
    }
    constructor(...args){
        super(...args);
        this.maxItems = null;
        this.valueField = "id";
        this.labelField = "name";
        this.searchField = [];
        this.optionLoader = null;
        this.missingOptionLoader = null;
        this.canCreate = false;
        this.newValuePrefix = "*";
        this.disableEvents = false;
        this.emptyLabel = "";
        this.oldValue = "";
        this._multiple = false;
    }
}

});

parcelRegister("75yia", function(module, exports) {

$parcel$export(module.exports, "UiBuSubjectSelector", () => $638bed575bdf213f$export$e734488f7700bc19);

var $ktJgr = parcelRequire("ktJgr");

var $ffuEw = parcelRequire("ffuEw");
class $638bed575bdf213f$export$e734488f7700bc19 extends (0, $ktJgr.UiTomSelect) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="ic"></em>
			</div>
			<div>
				<span class="btn-link btn" mu-id="createNew">Vytvo\u{159}it nov\xfd subjekt</span>
			</div>`);
    }
    afterIndex() {
        this.optionLoader = async (query, callback)=>{
            const res = await (0, $ffuEw.UiDms).instance.cl.findBuSubjects(query, null);
            callback(res, []);
        };
        this.init();
    }
    createNew_click() {
        const bse = (0, $ffuEw.UiDms).instance.openInModal("UiBuSubjectEditor", "P\u0159idat subjekt");
        bse.savedPromise.then((buSubject)=>{
            this.muBindData(buSubject);
            bse.muRemoveSelf();
        });
    }
}

});
parcelRegister("ffuEw", function(module, exports) {

$parcel$export(module.exports, "UiDms", () => $100f201f27c27fc4$export$32428a9cadf26e6d);
$parcel$export(module.exports, "getDocumentName", () => $100f201f27c27fc4$export$c29f08336649747);
$parcel$export(module.exports, "UiTdAmountCurrency", () => $100f201f27c27fc4$export$a9bcb3c85439acf1);
$parcel$export(module.exports, "getBuSubjectName", () => $100f201f27c27fc4$export$b24fa89e31acc0b3);
$parcel$export(module.exports, "getOrgProjectName", () => $100f201f27c27fc4$export$55839b1de9f3a7a7);

var $bxsP3 = parcelRequire("bxsP3");

var $3Yb7l = parcelRequire("3Yb7l");

var $kwZWC = parcelRequire("kwZWC");

var $dMN2n = parcelRequire("dMN2n");

var $fnX8e = parcelRequire("fnX8e");

var $9fwPo = parcelRequire("9fwPo");

var $fykIr = parcelRequire("fykIr");
function $100f201f27c27fc4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $100f201f27c27fc4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $100f201f27c27fc4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $100f201f27c27fc4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $100f201f27c27fc4$var$_arrayLikeToArray(o, minLen);
}
function $100f201f27c27fc4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $100f201f27c27fc4$export$32428a9cadf26e6d extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        $100f201f27c27fc4$export$32428a9cadf26e6d.instance = this;
        this.cl = new (0, $bxsP3.DmsCL)(this.clUrl);
        this.container.innerHTML = `
			<div class="display-flex gap-4px" mu-id="pIbsFilter" style="display: none">
				<label><input type="checkbox" mu-id="ibsFilterActive"> Zobrazit jen za firmu</label>
				<div class="flex-grow-1" mu-widget="UiTomSelect" mu-id="ibsFilter" mu-bind="buSubjectId" mu-params='{"multiple":true}'></div>
			</div>
			<div>
				<ul class="bcm-nav-tabs" mu-id="tabs">
					<li><a mu-tag="showSectionBt" data-tab="documents" class="a">Dokumenty</a></li>` + (this.isAdmin ? '<li><a mu-tag="showSectionBt" data-tab="subjects" class="a">Obchodn\xed subjekty</a></li>' : "") + `<li><a mu-tag="showSectionBt" data-tab="suppliers" class="a">Dodavatel\xe9</a></li>
					<li><a mu-tag="showSectionBt" data-tab="customers" class="a">Odb\u{11B}ratel\xe9</a></li>
					<li><a mu-tag="showSectionBt" data-tab="projects" class="a">Projekty</a></li>
				</ul>
			</div>			
			<div mu-id="tabContents">
				<div data-tab="documents" mu-id="documents" mu-widget="UiDmsDocuments"></div>` + (this.isAdmin ? '<div data-tab="subjects" mu-id="subjects" mu-widget="UiBuSubjects"></div>' : "") + `<div data-tab="suppliers" mu-id="suppliers" mu-widget="UiBuSubjects" mu-params='{"contractFilter":"supplier"}'></div>
				<div data-tab="customers" mu-id="customers" mu-widget="UiBuSubjects" mu-params='{"contractFilter":"customer"}'></div>
				<div data-tab="projects" mu-id="projects" mu-widget="UiDmsOrgProjects"></div>
			</div>
			
			<div mu-id="modals" class="modal-b"></div>
			
			<table style="display: none"><tr>
				<td mu-template="shared:tdLink" mu-widget="UiDocumentLinkCell"></td>
				<td mu-template="shared:tdAmountCurrency" class="number" mu-widget="UiTdAmountCurrency"></td>
			</tr></table>
		`;
        this.router.pathPrefix = this.baseUrl.replace(/\/+$/, "");
        const dra = (context)=>{
            const tab = context.parameters.tab?.toString() || "documents";
            this.showTab(tab, false);
            let module = this.muNamedWidget[tab];
            const listParams = context.parameters[tab + "_list"];
            if (listParams) module.setupList(JSON.parse(listParams));
            if (context.parameters.id && module) module.loadItem(parseInt(context.parameters.id));
        };
        this.router.persistentKeys = [
            "tab",
            "subjects_list",
            "documents_list"
        ];
        this.router.lastName = "root";
        this.router.addRoute("default", "/<tab>/<id>", dra);
        this.router.addRoute("open", "/<tab>", dra);
        this.router.addRoute("root", "/", dra);
    }
    async getDocumentTypeOpts(documentTypeId) {
        return (await this.cpDmsDocumentType.fetch()).find((t)=>t.id == documentTypeId)?.opts;
    }
    async getDmsDocumentType(documentTypeId) {
        return (await this.cpDmsDocumentType.fetch()).find((t)=>(typeof documentTypeId === "string" ? t.code : t.id) == documentTypeId);
    }
    openInModal(widget, title = null, params = {}, focusFirstInput = true) {
        const el = document.createElement("div");
        this.ui.modals.appendChild(el);
        this.updateModals();
        el.classList.add("modal-i");
        el.setAttribute("mu-widget", widget);
        if (title) el.innerHTML = `<div class="modal-title"><h2 mu-id="modalTitle"></h2><span class="close" mu-id="btCloseModal" mu-click="muRemoveSelf">\xd7</span> </div>`;
        const w = this.muActivateWidget(el, {
            widget: widget,
            params: params // JSON.stringify(params)
        }, params);
        if (title) // @ts-ignore
        w.ui.modalTitle.innerText = title;
        if (focusFirstInput) (0, $kwZWC.focusFirstVisibleControl)(el);
        // @ts-ignore
        setTimeout(()=>w.container.scrollIntoView(), 200);
        return w;
    }
    afterIndex() {
        super.afterIndex();
        this.ui.modals.addEventListener("DOMNodeRemoved", (ev)=>setTimeout(()=>this.updateModals(ev), 1));
        this.updateModals();
        (async ()=>{
            this.muNamedWidget.ibsFilter.init();
            const bss = (await $100f201f27c27fc4$export$32428a9cadf26e6d.instance.cpMyBuSubjects.fetch()).read;
            this.muNamedWidget.ibsFilter.bindItems(bss); // this.cl.getDocuments({});
            this.muVisible(bss.length > 1, "pIbsFilter");
        })();
        this.updateIbsFilterUi();
        /* const documentList = this.muNamedWidget.documentList;
    documentList.columns = [
    	new ColumnInfo({field: "id", name: "ID"}),
    	new ColumnInfo({field: "evidenceUid", name: "Číslo"}),
    	new ColumnInfo({field: "dmsDocumentTypeName", name: "Typ"}),
    	new ColumnInfo({field: "dateFrom", name: "Od", transformContent: (v,columnInf,w) => formatDate("d.m.Y", v)}),
    	new ColumnInfo({field: "dateTo", name: "Do", transformContent: (v,columnInf,w) => formatDate("d.m.Y", v)}),
    ];
    documentList.data = [
    	{
    		id: 123,
    		evidenceUid: "45874ICT2020",
    		dmsDocumentTypeName: "Smlouva bla",
    		dateFrom: new Date(),
    		dateTo: new Date(),
    	},
    	{
    		id: 123,
    		evidenceUid: "77874ICT2020",
    		dmsDocumentTypeName: "Smlouva ble",
    		dateFrom: new Date(),
    		dateTo: new Date(),
    	}
    ]
    documentList.render(); */ setTimeout(()=>this.router.route(), 1000);
    // this.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Upravit subjekt");
    }
    documentList_order(ev, field, dir) {
        console.log({
            ev: ev,
            field: field,
            dir: dir
        });
    }
    documentList_filter(ev, field) {
        console.log({
            ev: ev,
            field: field
        });
    }
    showSectionBt_click(ev) {
        // alert((ev.target as HTMLElement).getAttribute('data-tab'));
        // @ts-ignore
        this.showTab(ev.target.dataset.tab);
    }
    updateModals(ev = null) {
        this.muVisible(this.ui.modals.children.length > 0, "modals");
    // console.log(ev);
    }
    openBuSubjectEditor(id) {
        // @ts-ignore
        const ed = this.openInModal("UiBuSubjectEditor", id ? "Upravit subjekt" : "P\u0159idat subjekt");
        if (id) ed.loadItem(id);
        ed.savedPromise.then(()=>ed.muRemoveSelf());
        return ed;
    }
    openDmsDocumentEditor(id, initData = {}) {
        const editor = $100f201f27c27fc4$export$32428a9cadf26e6d.instance.openInModal(id ? "UiDmsDocumentEditor" : "UiNewDocumentAttach", id ? "Upravit dokument" : "Vytvo\u0159it dokument");
        if (id) editor.loadItem(id);
        if (initData) editor.muBindData(initData);
        editor.savedPromise.then(()=>{
            this.muNamedWidget.documents.loadList();
            editor.muRemoveSelf();
        });
        return editor;
    }
    openAttaches(dmsDocument) {
        const atts = this.openInModal("UiDmsAttaches", "P\u0159\xedlohy k dokumentu " + $100f201f27c27fc4$export$c29f08336649747(dmsDocument));
        atts.showForDmsDocument(dmsDocument);
        return atts;
    }
    showTab(tab, updateUrl = true) {
        // @ts-ignore
        for(var _iterator = $100f201f27c27fc4$var$_createForOfIteratorHelperLoose(this.ui.tabContents.children), _step; !(_step = _iterator()).done;){
            const el = _step.value;
            const etab = el.dataset.tab;
            el.style.display = etab == tab ? "" : "none";
        }
        // @ts-ignore
        for(var _iterator2 = $100f201f27c27fc4$var$_createForOfIteratorHelperLoose(this.ui.tabs.children), _step2; !(_step2 = _iterator2()).done;){
            const el = _step2.value;
            const etab = el.children[0].dataset.tab;
            el.classList.toggle("active", etab == tab);
        }
        if (updateUrl) this.router.push(null, {
            tab: tab
        });
    }
    openDocumentsPreview(entity, id, entityData) {
        const listPreview = $100f201f27c27fc4$export$32428a9cadf26e6d.instance.openInModal("UiDocumentListPreview", "...");
        listPreview.showFor(entity, id, entityData);
    }
    ibsFilterActive_change() {
        this.updateIbsFilter();
        this.updateIbsFilterUi();
    }
    ibsFilter_change() {
        this.updateIbsFilter();
    }
    updateIbsFilter() {
        this.ibsReloadDL.send();
    }
    updateIbsFilterUi() {
        this.muVisible(this.ui.ibsFilterActive.checked, "ibsFilter");
        if (this.ui.ibsFilterActive.checked) this.muNamedWidget.ibsFilter.tom.focus();
    }
    constructor(...args){
        super(...args);
        this.cpDmsDocumentClass = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m typy smluv").getDmsDocumentClasses());
        this.cpDmsDocumentType = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m typy dokument\u016F").getDmsDocumentTypes());
        this.cpMyBuSubjects = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m subjekty").getMyBuSubjects());
        this.cpCurrencies = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m m\u011Bny").getAllCurrencies());
        this.cpOrgDivision = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m organiza\u010Dn\xed jednotky").getOrgDivisions(null));
        this.cpDmsAttachType = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m typy p\u0159\xedloh").getAllDmsAttachTypes({}));
        this.cpStates = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m stavy").getAllStates({}));
        this.router = new (0, $9fwPo.MuRouter)();
        this.baseUrl = "";
        this.securityLevels = [];
        this.isAdmin = false;
        this.clUrl = "";
        this.ibsReloadDL = new (0, $fykIr.DelayedSingleLauncher)(3, ()=>{
            const f = this.ui.ibsFilterActive.checked ? this.muNamedWidget.ibsFilter.value || null : null;
            if (JSON.stringify(this.cl.context.ibsFilter) == JSON.stringify(f)) return;
            this.cl.context.ibsFilter = f;
            // this.muNamedWidget.projects
            // this.muNamedWidget.subjects
            this.muNamedWidget.customers.bReload_click();
            this.muNamedWidget.suppliers.bReload_click();
            this.muNamedWidget.documents.bReload_click();
            this.muNamedWidget.projects.bReload_click();
        });
    }
}
class $100f201f27c27fc4$export$a9bcb3c85439acf1 extends (0, $3Yb7l.UiTableCell) {
    render(value, row, ev) {
        this.container.innerHTML = (0, $kwZWC.formatNumber)(value, 2) + (row.currency?.code || "");
    }
}
function $100f201f27c27fc4$export$c29f08336649747(dmsDocument) {
    return dmsDocument.evidenceUid + " " + (dmsDocument.name || "");
}
function $100f201f27c27fc4$export$b24fa89e31acc0b3(buSubject) {
    return buSubject.name + " (" + buSubject.ic + ")";
}
function $100f201f27c27fc4$export$55839b1de9f3a7a7(orgProject) {
    return orgProject.name + " (" + orgProject.code + ")";
}

});
parcelRegister("bxsP3", function(module, exports) {

$parcel$export(module.exports, "DmsCL", () => $82c2cc379667e3ad$export$c197e35892a9397f);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $82c2cc379667e3ad$export$c197e35892a9397f extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/dms"){
        super(url);
    }
    findProjects(query) {
        return this.callMethod("findProjects", arguments, {
            "rawResult": false
        });
    }
    findBuSubjects(query) {
        return this.callMethod("findBuSubjects", arguments, {
            "rawResult": false
        });
    }
    loadFromAres(ic) {
        return this.callMethod("loadFromAres", arguments, {
            "rawResult": false
        });
    }
    saveBuSubject(id, data) {
        return this.callMethod("saveBuSubject", arguments, {
            "rawResult": false
        });
    }
    allBuSubjects(filter, orderBy, limitFrom = 0, limitCount = null) {
        return this.callMethod("allBuSubjects", arguments, {
            "rawResult": false
        });
    }
    getBuSubject(id) {
        return this.callMethod("getBuSubject", arguments, {
            "rawResult": false
        });
    }
    getOrgProject(id) {
        return this.callMethod("getOrgProject", arguments, {
            "rawResult": false
        });
    }
    getMyBuSubjects() {
        return this.callMethod("getMyBuSubjects", arguments, {
            "rawResult": false
        });
    }
    getDmsDocumentClasses() {
        return this.callMethod("getDmsDocumentClasses", arguments, {
            "rawResult": false
        });
    }
    getDmsDocumentTypes() {
        return this.callMethod("getDmsDocumentTypes", arguments, {
            "rawResult": false
        });
    }
    allDocuments(filter, orderBy, limitFrom = 0, limitCount = 100) {
        return this.callMethod("allDocuments", arguments, {
            "rawResult": false
        });
    }
    getDocument(id) {
        return this.callMethod("getDocument", arguments, {
            "rawResult": false
        });
    }
    saveDocument(id, data) {
        return this.callMethod("saveDocument", arguments, {
            "rawResult": false
        });
    }
    getAllCurrencies() {
        return this.callMethod("getAllCurrencies", arguments, {
            "rawResult": false
        });
    }
    getAllDmsAttaches(filter) {
        return this.callMethod("getAllDmsAttaches", arguments, {
            "rawResult": false
        });
    }
    getAllDmsAttachTypes(filter = []) {
        return this.callMethod("getAllDmsAttachTypes", arguments, {
            "rawResult": false
        });
    }
    invalidateDmsAttach(id) {
        return this.callMethod("invalidateDmsAttach", arguments, {
            "rawResult": false
        });
    }
    saveAllAttaches(attaches) {
        return this.callMethod("saveAllAttaches", arguments, {
            "rawResult": false
        });
    }
    getDmsAttachPreview(id) {
        return this.callMethod("getDmsAttachPreview", arguments, {
            "rawResult": false
        });
    }
    getDocumentHistory(id) {
        return this.callMethod("getDocumentHistory", arguments, {
            "rawResult": false
        });
    }
    allOrgProjects(filter, orderBy, limitFrom = 0, limitCount = null) {
        return this.callMethod("allOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getAllStates() {
        return this.callMethod("getAllStates", arguments, {
            "rawResult": false
        });
    }
    checkProjectsImport(src, buSubjectId) {
        return this.callMethod("checkProjectsImport", arguments, {
            "rawResult": false
        });
    }
    projectsImport(src, buSujectId) {
        return this.callMethod("projectsImport", arguments, {
            "rawResult": false
        });
    }
    getAllProducts(buSubjectId) {
        return this.callMethod("getAllProducts", arguments, {
            "rawResult": false
        });
    }
    checkProductsImport(src, buSubjectId) {
        return this.callMethod("checkProductsImport", arguments, {
            "rawResult": false
        });
    }
    productsImport(src, buSubjectId) {
        return this.callMethod("productsImport", arguments, {
            "rawResult": false
        });
    }
    updateProducts(buSubjectId, data) {
        return this.callMethod("updateProducts", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
    getAttachData(attachId, authByTicketId = null) {
        return this.callMethod("getAttachData", arguments, {
            "rawResult": false
        });
    }
    getAttachesFotTicketAndRelated(ticketId) {
        return this.callMethod("getAttachesFotTicketAndRelated", arguments, {
            "rawResult": false
        });
    }
    findAttachesFor(ids) {
        return this.callMethod("findAttachesFor", arguments, {
            "rawResult": false
        });
    }
    getBcmAttachesFor(ids) {
        return this.callMethod("getBcmAttachesFor", arguments, {
            "rawResult": false
        });
    }
    saveAttach(attachId, ids, data) {
        return this.callMethod("saveAttach", arguments, {
            "rawResult": false
        });
    }
    createFolder(ids, name, parentId) {
        return this.callMethod("createFolder", arguments, {
            "rawResult": false
        });
    }
    newTempFile() {
        return this.callMethod("newTempFile", arguments, {
            "rawResult": false
        });
    }
}

});



parcelRegister("8wyRe", function(module, exports) {

$parcel$export(module.exports, "UiOrgProjectSelector", () => $b2e878d00fbd27f6$export$c47555b1260ecfdb);

var $ktJgr = parcelRequire("ktJgr");

var $ffuEw = parcelRequire("ffuEw");
class $b2e878d00fbd27f6$export$c47555b1260ecfdb extends (0, $ktJgr.UiTomSelect) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="code"></em> |
				<span mu-bind="odName"></span>
				<em mu-bind="odCode"></em> |
				<span mu-bind="acName"></span>
			</div>`);
    }
    afterIndex() {
        this.optionLoader = async (query, callback)=>{
            const res = await (0, $ffuEw.UiDms).instance.cl.findProjects(query);
            callback(res, []);
        };
        this.searchField = [
            "code",
            "name",
            "odName",
            "odCode",
            "acName"
        ];
        this.init();
    }
}

});

parcelRegister("7wRzu", function(module, exports) {

$parcel$export(module.exports, "UiAccountSelector", () => $c9c44129f5dcb902$export$2697b9ec6e4aca59);
$parcel$export(module.exports, "UiAccountSelector_old", () => $c9c44129f5dcb902$export$9d775caffd1704c2);

var $dMN2n = parcelRequire("dMN2n");

var $ktJgr = parcelRequire("ktJgr");

var $ffuEw = parcelRequire("ffuEw");

var $bxsP3 = parcelRequire("bxsP3");
class $c9c44129f5dcb902$export$2697b9ec6e4aca59 extends (0, $ktJgr.UiTomSelect) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="orgDivisionCode"></em>
			</div>`);
    }
    afterIndex() {
        this.optionLoader = async (query, callback)=>{
            // @ts-ignore
            const res = await ((0, $ffuEw.UiDms).instance?.cl || new (0, $bxsP3.DmsCL)()).findAccounts(query, this.inSameCompany);
            callback(res, []);
        };
        this.init();
    }
    constructor(...args){
        super(...args);
        this.inSameCompany = false;
    }
}
class $c9c44129f5dcb902$export$9d775caffd1704c2 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`<div mu-widget="UiTomSelect" mu-id="input">
			<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="orgDivisionCode"></em>
			</div>
			</div>`);
    }
    afterIndex() {
        const tom = this.muNamedWidget.input;
        tom.optionLoader = async (query, callback)=>{
            // @ts-ignore
            const res = await (0, $ffuEw.UiDms).instance.cl.findAccounts(query);
            callback(res, []);
        };
        tom.init();
    }
    createNew_click() {
        // @ts-ignore
        const bse = (0, $ffuEw.UiDms).instance.openInModal("UiBuSubjectEditor", "P\u0159idat subjekt");
    }
}

});

parcelRegister("jW8G6", function(module, exports) {

$parcel$export(module.exports, "UiDateFilter", () => $d741f4ad1ece58dd$export$5391b23e3581fecd);

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");
function $d741f4ad1ece58dd$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d741f4ad1ece58dd$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d741f4ad1ece58dd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d741f4ad1ece58dd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d741f4ad1ece58dd$var$_arrayLikeToArray(o, minLen);
}
function $d741f4ad1ece58dd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $d741f4ad1ece58dd$export$5391b23e3581fecd extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`
		<div>
			<label class="radio-inline">
				<input type="radio" mu-name="type" mu-id="type_null" mu-change="type_change" value="null">neomezeno
			</label>
			<label class="radio-inline">
				<input type="radio" mu-name="type" mu-id="type_abs" mu-change="type_change" value="abs">datum od-do
			</label>
			<label class="radio-inline">
				<input type="radio" mu-name="type" mu-id="type_rel" mu-change="type_change" value="rel">dny od-do
			</label>
		</div>
		<div class="form-inline" mu-id="controls_abs">
  			<div class="form-group">
    			<label mu-for="absFrom">Datum od</label>
    			<input type="date" class="form-control" mu-id="absFrom">
  			</div>
  			<div class="form-group">
    			<label mu-for="absTo">do</label>
    			<input type="date" class="form-control" mu-id="absTo">
  			</div>
		</div>
		<div class="form-inline" mu-id="controls_rel">
  			<div class="form-group">
    			<label mu-for="relFrom">P\u{159}ed</label>
    			<input type="number" class="form-control" mu-id="relFrom">
    			<label mu-for="relFrom">dny</label>
  			</div>
  			<div class="form-group">
    			<label mu-for="relTo">za</label>
    			<input type="number" class="form-control" mu-id="relTo">
    			<label mu-for="relTo">dn\u{16F}</label>
  			</div>
		</div>
		`);
    }
    getType() {
        // @ts-ignore
        return (0, $kwZWC.getSelectedValue)(this.ui.type_null) || "null";
    /* for(const t of this.allTypes) {
    	if (this.ui["type_" + t].checked) {
    		return t;
    	}
    }
    return "null"; */ }
    setType(type, changeRadio = true) {
        for(var _iterator = $d741f4ad1ece58dd$var$_createForOfIteratorHelperLoose(this.allTypes), _step; !(_step = _iterator()).done;){
            const t = _step.value;
            if (this.ui["controls_" + t]) this.muVisible(t == type, "controls_" + t);
        }
        (0, $kwZWC.setSelectedValue)(this.ui.type_null, type);
    }
    type_change() {
        this.setType(this.getType(), false);
    }
    afterIndex() {
        this.type_change();
    }
    muFetchData() {
        const res = {
            type: this.getType()
        };
        switch(res.type){
            case "null":
                return null;
            case "abs":
                res.dtFrom = this.ui.absFrom.value;
                res.dtTo = this.ui.absTo.value;
                break;
            case "rel":
                res.dayFrom = this.ui.relFrom.value;
                res.dayTo = this.ui.relTo.value;
                break;
        }
        return res;
    }
    muBindData(srcData) {
        if (srcData) {
            this.setType(srcData.type);
            switch(srcData.type){
                case "abs":
                    this.ui.absFrom.value = srcData.dtFrom;
                    this.ui.absTo.value = srcData.dtTo;
                    break;
                case "rel":
                    this.ui.relFrom.value = srcData.dayFrom;
                    this.ui.relTo.value = srcData.dayTo;
                    break;
            }
        } else this.setType("null");
    }
    constructor(...args){
        super(...args);
        this.allTypes = [
            "rel",
            "abs",
            "null"
        ];
    }
}

});

parcelRegister("k638V", function(module, exports) {

$parcel$export(module.exports, "UiRadioList", () => $b7eb88dbb55896c2$export$60d188a35e72c070);
$parcel$export(module.exports, "UiRadioListItem", () => $b7eb88dbb55896c2$export$5485357ef3b19951);

var $dMN2n = parcelRequire("dMN2n");

var $d4ug8 = parcelRequire("d4ug8");
function $b7eb88dbb55896c2$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b7eb88dbb55896c2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b7eb88dbb55896c2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b7eb88dbb55896c2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b7eb88dbb55896c2$var$_arrayLikeToArray(o, minLen);
}
function $b7eb88dbb55896c2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $b7eb88dbb55896c2$export$60d188a35e72c070 extends (0, $dMN2n.MuWidget) {
    setDisabled(disabled) {
        for(const k in this.items)this.items[k].setDisabled(disabled);
    }
    beforeIndex() {
        this.muAppendContent(`<label mu-template="item" mu-widget="UiRadioListItem">
			<input type="radio" mu-id="input">
			<!-- <img mu-id="icon" /> -->
			<span mu-id="title"></span>
		</label>`);
        this.htmlName = (0, $d4ug8.MuUIDs).next("name");
        this.muRegisterEvent("change");
    }
    bindItems(items) {
        this.container.innerHTML = "";
        if (Array.isArray(items)) for(var _iterator = $b7eb88dbb55896c2$var$_createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;){
            const item = _step.value;
            this.replaceItem(item);
        }
        else for(const k in items){
            let item = items[k];
            this.replaceItem(typeof item === "string" ? {
                id: k,
                title: item
            } : item);
        }
    }
    replaceItem(item) {
        if (!this.items[item.id]) {
            // @ts-ignore
            this.items[item.id] = this.muWidgetFromTemplate("item", this.container, item);
            if (this._value == item.id) this.value = this._value;
        } else {
            Object.assign(this.items[item.id], item);
            this.items[item.id].afterIndex();
        }
    }
    onChanged() {
        let v = null;
        this.selectedItem = null;
        for(const k in this.items)if (this.items[k].getChecked()) {
            v = k;
            this.selectedItem = this.items[k];
        }
        this._value = v;
        this.muDispatchEvent("change", this.value);
    }
    get value() {
        return this._value;
    /* for(const k in this.items) {
    	if (this.items[k].getChecked()) return k;
    }
    return null; */ }
    set value(v) {
        this._value = v;
        for(const k in this.items)this.items[k].setChecked(k == v);
    }
    muBindData(srcData) {
        this.value = srcData;
    }
    muFetchData() {
        return this.value;
    }
    constructor(...args){
        super(...args);
        this.selectedItem = null;
        this.items = {};
        this._value = null;
    }
}
class $b7eb88dbb55896c2$export$5485357ef3b19951 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.ui.input.name = this.muParent.htmlName;
        this.ui.input.value = this.id;
        this.ui.input.disabled = this.disabled;
        // if (typeof this.title === "string")
        this.ui.title.innerText = this.title;
    }
    input_change() {
        this.muParent.onChanged();
    }
    setChecked(checked) {
        this.ui.input.checked = checked;
    }
    getChecked() {
        return this.ui.input.checked;
    }
    setDisabled(disabled) {
        this.ui.input.disabled = disabled;
    }
    constructor(...args){
        super(...args);
        this.disabled = false;
    }
}

});
parcelRegister("d4ug8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MuUIDs = void 0;
class $98431eed83470086$var$MuUIDs {
    static next(k) {
        $98431eed83470086$var$MuUIDs.counters[k]++;
        return $98431eed83470086$var$MuUIDs.prefix + $98431eed83470086$var$MuUIDs.counters[k].toString();
    }
}
module.exports.MuUIDs = $98431eed83470086$var$MuUIDs;
$98431eed83470086$var$MuUIDs.counters = {
    id: 0,
    name: 0
};
$98431eed83470086$var$MuUIDs.prefix = "_Mu_";

});


parcelRegister("izbI7", function(module, exports) {

$parcel$export(module.exports, "UiPager", () => $2eb2496c6676af75$export$cd411a62e56a7f80);
$parcel$export(module.exports, "UiPagerItem", () => $2eb2496c6676af75$export$818819c8f81e1428);

var $dMN2n = parcelRequire("dMN2n");
function $2eb2496c6676af75$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2eb2496c6676af75$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2eb2496c6676af75$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2eb2496c6676af75$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2eb2496c6676af75$var$_arrayLikeToArray(o, minLen);
}
function $2eb2496c6676af75$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $2eb2496c6676af75$export$cd411a62e56a7f80 extends (0, $dMN2n.MuWidget) {
    get itemPerPage() {
        const v = this.ui.itemPerPage.valueAsNumber;
        return v == NaN ? 100 : Math.max(v, 1);
    }
    set itemPerPage(v) {
        this.ui.itemPerPage.valueAsNumber = v;
    }
    get currentItemFrom() {
        return this.currentPageNum * this.itemPerPage;
    }
    bChangeItemPerPage_click() {
        this.setPageNum(this.currentItemFrom / this.itemPerPage, true);
    }
    beforeIndex() {
        this.muRegisterEvent("changePage");
        this.muAppendContent(`
			<ul mu-id="pages" class="pagination ui-pager--pages"><li mu-widget="UiPagerItem" mu-template="item"><a mu-id="label"></a></li></ul>
			<div class="ui-pager--item-per-page input-group">
				<input type="number" mu-id="itemPerPage" value="100" class="form-control" />
				<span class="input-group-btn"><span class="btn btn-default" mu-id="bChangeItemPerPage">Zobraz</span></span>
			</div>
		`);
        this.container.classList.add("ui-pager");
    }
    setPageNum(current, launchEvent = false) {
        for(var _iterator = $2eb2496c6676af75$var$_createForOfIteratorHelperLoose(this.pageItems), _step; !(_step = _iterator()).done;){
            const item = _step.value;
            item.setSelected(item.num == current);
        }
        this.currentPageNum = current;
        if (launchEvent) this.muDispatchEvent("changePage", current);
    }
    set itemCount(c) {
        this.setItemCount(c);
    }
    setPageCount(count) {
        this.ui.pages.innerHTML = "";
        for(let n = 0; n < count; n++)this.pageItems[n] = this.muWidgetFromTemplate("item", "pages", {
            num: n
        });
        this.setPageNum(this.currentPageNum, false);
    }
    setItemCount(count) {
        this.setPageCount(Math.ceil(count / this.itemPerPage));
    }
    constructor(...args){
        super(...args);
        this.currentPageNum = 0;
        this.pageItems = [];
    }
}
class $2eb2496c6676af75$export$818819c8f81e1428 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.ui.label.innerText = (this.num + 1).toString();
    }
    container_click() {
        this.muParent.setPageNum(this.num, true);
    }
    setSelected(val) {
        this.container.classList.toggle("active", val);
    }
}

});

parcelRegister("jtPnK", function(module, exports) {

$parcel$export(module.exports, "UiTree", () => $4670759408748cb8$export$f5ba74e34ebf4a92);

var $dMN2n = parcelRequire("dMN2n");
class $4670759408748cb8$export$f5ba74e34ebf4a92 extends (0, $dMN2n.MuWidget) {
    muBindData(srcData, params) {
        this.bindItems(srcData.items, this.ui.items || this.container, params);
    }
    bindItems(items, container, params = {}) {
        for(var _i = 0, _items = items; _i < _items.length; _i++){
            const item = _items[_i];
            const w = this.muWidgetFromTemplate("ancestor:item", container, params);
            w.muBindData({
                ...item.data,
                pathItemName: item.name
            });
            this.bindItems(item.items, w.ui.items, params);
        }
    }
}

});

parcelRegister("hM3wT", function(module, exports) {

$parcel$export(module.exports, "UiInlineTreeSelector", () => $d34627e2be450cd9$export$74855afb460598e7);

var $dMN2n = parcelRequire("dMN2n");
function $d34627e2be450cd9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d34627e2be450cd9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d34627e2be450cd9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d34627e2be450cd9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d34627e2be450cd9$var$_arrayLikeToArray(o, minLen);
}
function $d34627e2be450cd9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $d34627e2be450cd9$export$74855afb460598e7 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.container.classList.add("inline-tree-selector");
        this.muAppendContent(`
			<ul class="inline-tree-selector--path" mu-id="path"><li mu-widget="." mu-template="pathItem"><span mu-id="name"></span></li></ul>
			<ul class="inline-tree-selector--select" mu-id="select"><li mu-widget="." mu-template="selectItem"><span mu-id="name"></span></li></ul>
		`);
        this.muRegisterEvent("select");
    }
    bind(item) {
        this.ui.select.innerHTML = "";
        this.ui.path.innerHTML = "";
        for(var _iterator = $d34627e2be450cd9$var$_createForOfIteratorHelperLoose(item.items), _step; !(_step = _iterator()).done;){
            const subItem = _step.value;
            this.muWidgetFromTemplate("selectItem", "select", {
                name_click: ()=>{
                    this.bind(subItem);
                    this.muDispatchEvent("select", subItem);
                },
                afterIndex: function() {
                    this.ui.name.innerText = subItem.name;
                }
            });
        }
        let it = item;
        while(it){
            if (it.parent !== null) {
                const currIt = it;
                this.muWidgetFromTemplate("pathItem", "path", {
                    name_click: ()=>{
                        // @ts-ignore
                        this.bind(currIt.parent);
                        this.muDispatchEvent("select", currIt.parent);
                    },
                    afterIndex: function() {
                        this.ui.name.innerText = currIt.name;
                    }
                }, "first");
            }
            it = it.parent;
        }
    }
}

});

parcelRegister("fDXUL", function(module, exports) {

$parcel$export(module.exports, "UiDateTimeRange", () => $bac33a0b2e68d07a$export$ab7b5786b94396df);

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");
class $bac33a0b2e68d07a$export$ab7b5786b94396df extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<label>
				<input type="radio" mu-name="type" mu-id="typeNone" value="none" />
				Neomezeno
			</label>
			<label>
				<input type="radio" mu-name="type" mu-id="typePrev" value="prev" />
				P\u{159}edchoz\xedch <input type="number" class="form-control display-inline-block w5em" mu-bind="daysNext" mu-id="daysNext" /> dn\u{16F}.
			</label>
			<label>
				<input type="radio" mu-name="type" mu-id="typeNext" value="next" />
				N\xe1sleduj\xedc\xedch <input type="number" class="form-control display-inline-block w5em" mu-bind="daysNext" mu-id="daysNext" style="width: 5em" /> dn\u{16F}.
			</label>
			<label>
				<input type="radio" mu-name="type" mu-id="typeRange" value="range" />
				Od <input type="date" mu-id="rangeFrom" mu-bind="rangeFrom" class="form-control display-inline-block w8em">
				do <input type="date" mu-id="rangeTo" mu-bind="rangeTo" class="form-control display-inline-block w8em">
			</label>
		`);
    }
    muFetchData() {
        const data = super.muFetchData();
        data.type = (0, $kwZWC.getSelectedValue)(this.ui.typeNone);
        return data;
    }
    muBindData(src) {
        super.muBindData(src);
        (0, $kwZWC.setSelectedValue)(this.ui.typeNone, src.type);
    }
}

});

parcelRegister("akyCl", function(module, exports) {

$parcel$export(module.exports, "UiNumberRange", () => $7988d5de264121bc$export$e93263d48f48409d);

var $dMN2n = parcelRequire("dMN2n");
class $7988d5de264121bc$export$e93263d48f48409d extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.container.classList.add("display-flex", "flex-items-grow-1");
        this.muAppendContent(`
			<label mu-for="rangeFrom">Od</label>
			<input type="number" mu-bind="rangeFrom" class="form-control display-inline-block w8em">
			<label mu-for="rangeTo">Do</label>
			<input type="number" mu-bind="rangeTo" class="form-control display-inline-block w8em">
		`);
    }
}

});

parcelRegister("2GpDn", function(module, exports) {

$parcel$export(module.exports, "Pager", () => $fc4d0ec76fcacaf7$export$57625d62e5386b09);
$parcel$export(module.exports, "PagerItem", () => $fc4d0ec76fcacaf7$export$3397fbc33820c498);

var $4pyNk = parcelRequire("4pyNk");

var $dMN2n = parcelRequire("dMN2n");
function $fc4d0ec76fcacaf7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fc4d0ec76fcacaf7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fc4d0ec76fcacaf7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fc4d0ec76fcacaf7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fc4d0ec76fcacaf7$var$_arrayLikeToArray(o, minLen);
}
function $fc4d0ec76fcacaf7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $fc4d0ec76fcacaf7$export$57625d62e5386b09 extends (0, $4pyNk.BaseWidget) {
    beforeIndex() {
        this.muRegisterEvent("changePage");
        this.container.classList.add("pager");
        this.muAppendContent(`
			<div class="pager__nav">
				<span class="pager__btn" mu-id="bPrev">&lt;</span>
				<input class="pager__page-num" title="\u{10C}\xedslo str\xe1nky" type="number" min="2" value="1" mu-id="pageNumber" />
				<span class="pager__info"> / <span mu-id="pagesCount"></span> (</span>
				<input class="pager__page-size" title="Po\u{10D}et na str\xe1nku" type="number" min="1" value="100" mu-id="itemPerPage" />
				<span class="pager__info">)</span>
				<span class="pager__btn" mu-id="bChangeItemPerPage">Zobrazit</span>
				<span class="pager__btn" mu-id="bNext">&gt;</span>
			</div>
			<div class="pager__numbers" mu-id="pages">
				<span class="pager__btn" mu-widget="PagerItem" mu-template="item">
					<span mu-id="label"></span>
				</span>
			</div>
		`);
    }
    setItemCount(newItemCount, launchEvent = false) {
        this.itemCount = newItemCount;
        this.update(launchEvent);
    }
    update(fireEvent) {
        let newCurrentPageNum = this.currentPageNum; // Math.floor(this.oldValues.itemFrom / this.itemPerPage);
        this.currentPageCount = Math.ceil(this.itemCount / this.itemPerPage);
        newCurrentPageNum = Math.min(this.currentPageCount - 1, Math.max(0, newCurrentPageNum));
        // Změna počtu stránek
        if (this.oldValues.pageCount !== this.currentPageCount) {
            this.ui.pages.innerHTML = "";
            for(let n = 0; n < this.currentPageCount; n++)this.pageItems[n] = this.muWidgetFromTemplate("item", "pages", {
                num: n
            });
            this.ui.pagesCount.innerText = this.ui.pageNumber.max = this.currentPageCount.toString();
        }
        // změna pozice, nebo počtu stránek
        if (this.oldValues.currentPageNum !== newCurrentPageNum || this.oldValues.pageCount !== this.currentPageCount) {
            for(var _iterator = $fc4d0ec76fcacaf7$var$_createForOfIteratorHelperLoose(this.pageItems), _step; !(_step = _iterator()).done;){
                const item = _step.value;
                item.setSelected(item.num == newCurrentPageNum);
            }
            this.ui.pageNumber.valueAsNumber = newCurrentPageNum + 1;
            if (fireEvent) // console.log("New set " + newCurrentPageNum + " / " + this.currentPageCount);
            this.muDispatchEvent("changePage", newCurrentPageNum);
        }
        this.oldValues = {
            pageCount: this.currentPageCount,
            currentPageNum: newCurrentPageNum,
            itemFrom: this.currentItemFrom,
            itemCount: this.itemCount
        };
        // tooltip
        // @ts-ignore
        this.container.title = this.itemCount ? this.fullInfoTemplate.replace(/\{([^{}]+)\}/g, (fm, vn)=>{
            switch(vn){
                case "firstItem":
                    return Math.max(newCurrentPageNum * this.itemPerPage + 1, 0);
                case "lastItem":
                    return Math.min((newCurrentPageNum + 1) * this.itemPerPage, this.itemCount);
                case "itemCount":
                    return this.itemCount.toString();
                default:
                    return fm;
            }
        }) : this.emptyInfo;
    }
    get itemPerPage() {
        return this.ui.itemPerPage.valueAsNumber;
    }
    set itemPerPage(c) {
        this.ui.itemPerPage.valueAsNumber = Math.max(1, c);
        this.update(true);
    }
    get currentPageNum() {
        return this.ui.pageNumber.valueAsNumber - 1;
    }
    set currentPageNum(p) {
        p = Math.min(this.currentPageCount - 1, Math.max(0, p));
        this.ui.pageNumber.valueAsNumber = p + 1;
        this.update(true);
    }
    get currentItemFrom() {
        return Math.max(0, this.currentPageNum * this.itemPerPage);
    }
    pageNumber_change() {
        this.update(true);
    }
    /* public setItemCount(count: number, launchEvent: boolean = false) {
  	this.setPageCount(Math.ceil(count / this.itemPerPage));
  	this.update(launchEvent);
  }
  	/* public get itemPerPage(): number {
  	const v = this.ui.itemPerPage.valueAsNumber;
  	return isNaN(v) ? 100 : Math.max(v, 1);
  }
  public set itemPerPage(v) {
  	this.ui.itemPerPage.valueAsNumber = v;
  } */ /* public get currentItemFrom(): number {
  	return this.currentPageNum * this.itemPerPage;
  }
  public get currentPageNum(): number
  {
  	return this.ui.pageNumber.valueAsNumber - 1;
  }
  public set currentPageNum(v: number)
  {
  	this.ui.pageNumber.valueAsNumber = v + 1;
  } */ bChangeItemPerPage_click() {
        // this.setPageNum(this.currentItemFrom / this.itemPerPage, true);
        this.update(true);
    }
    /* public setPageNum(current: number, launchEvent: boolean = false) {
  	current = Math.min(Math.max(0, current), this.currentPageCount);
  	if (this.currentPageNum === current) return;
  	for(const item of this.pageItems) item.setSelected(item.num == current);
  	this.currentPageNum = current;
  	if (launchEvent) this.muDispatchEvent('changePage', current);
  }
  	public setPageCount(count: number) {
  	this.currentPageCount = count;
  	this.ui.pages.innerHTML = "";
  	for(let n = 0; n < count; n++) {
  		this.pageItems[n] = this.muWidgetFromTemplate('item', 'pages', {num: n}) as unknown as UiPagerItem;
  	}
  	this.setPageNum(this.currentPageNum, false);
  	this.ui.pageNumber.max = (count + 1).toString();
  } */ bPrev_click() {
        this.currentPageNum--;
    }
    bNext_click() {
        this.currentPageNum++;
    }
    constructor(...args){
        super(...args);
        this.currentPageCount = 0;
        this.itemCount = -1;
        this.oldValues = {
            itemCount: -1,
            itemFrom: -1,
            pageCount: -1,
            currentPageNum: -1
        };
        this.fullInfoTemplate = "Showing records {firstItem} to {lastItem} of {itemCount} total.";
        this.emptyInfo = "No records are displayed.";
        this.pageItems = [];
    }
}
class $fc4d0ec76fcacaf7$export$3397fbc33820c498 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.ui.label.innerText = (this.num + 1).toString();
    }
    container_click() {
        this.muParent.currentPageNum = this.num;
    }
    setSelected(val) {
        this.container.classList.toggle("pager__btn--active", val);
    }
    constructor(...args){
        super(...args);
        this.num = -1;
    }
}

});
parcelRegister("4pyNk", function(module, exports) {

$parcel$export(module.exports, "BaseWidget", () => $c0f7dea8304fd78b$export$9046a58f39a6aeef);

var $6Taw3 = parcelRequire("6Taw3");
class $c0f7dea8304fd78b$export$9046a58f39a6aeef extends (0, $6Taw3.BaseMuWidget) {
}

});


parcelRegister("fgCVL", function(module, exports) {

$parcel$export(module.exports, "AccountLink", () => $fd7866874346ff8e$export$1fc4e01ef72f2255);

var $6Taw3 = parcelRequire("6Taw3");
class $fd7866874346ff8e$export$1fc4e01ef72f2255 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.container.classList.add("icon-before-person");
    }
    update() {
        // @ts-ignore
        this.container.innerText = this.accountName;
    }
    afterIndex() {
        this.update();
    }
    muAfterBindData(data) {
        this.update();
    }
}

});

parcelRegister("9Htj6", function(module, exports) {

$parcel$export(module.exports, "TreeView", () => $1d011c41b5a5926b$export$6940b0d9c820eca7);

var $dMN2n = parcelRequire("dMN2n");

var $kwZWC = parcelRequire("kwZWC");
function $1d011c41b5a5926b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1d011c41b5a5926b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1d011c41b5a5926b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1d011c41b5a5926b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1d011c41b5a5926b$var$_arrayLikeToArray(o, minLen);
}
function $1d011c41b5a5926b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $1d011c41b5a5926b$export$6940b0d9c820eca7 extends (0, $dMN2n.MuWidget) {
    render(data, opts = {}) {
        this.itemWidgets = [];
        this.opts = {
            ...this.opts,
            ...opts
        };
        let srcStructFormat = this.opts.srcStructFormat;
        let itemsByParent = {};
        const makeKey = (val)=>JSON.stringify(val);
        const allIds = [];
        if (srcStructFormat === "parentField") {
            itemsByParent = {};
            for(var _iterator = $1d011c41b5a5926b$var$_createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;){
                const item = _step.value;
                allIds.push(makeKey(item[this.opts.idField]));
                const k = makeKey(item[this.opts.parentField]);
                (itemsByParent[k] ?? (itemsByParent[k] = [])).push(item);
            }
            srcStructFormat = "groupedByParent";
        } else if (srcStructFormat === "groupedByParent") {
            for(const k in data)for(var _iterator2 = $1d011c41b5a5926b$var$_createForOfIteratorHelperLoose(data[k]), _step2; !(_step2 = _iterator2()).done;){
                const item = _step2.value;
                allIds.push(makeKey(item[this.opts.idField]));
            }
            itemsByParent = data;
        }
        if (srcStructFormat === "groupedByParent") {
            const rootIds = (0, $kwZWC.Arrays).diff(Object.keys(itemsByParent), allIds);
            for(var _iterator3 = $1d011c41b5a5926b$var$_createForOfIteratorHelperLoose(rootIds), _step3; !(_step3 = _iterator3()).done;){
                const k = _step3.value;
                this.renderList(itemsByParent[k], (item)=>itemsByParent[makeKey(item[this.opts.idField])]);
            }
        } else this.renderList(data, (item)=>item[this.opts.childField]);
    }
    renderList(items, getChilds, container = null, plunge = 0) {
        if (!container) // @ts-ignore
        container = this.container;
        for(var _i = 0, _items = items; _i < _items.length; _i++){
            const item = _items[_i];
            const templateName = typeof this.opts.templateName === "string" ? this.opts.templateName : this.opts.templateName(item);
            // @ts-ignore
            const itemWidget = this.muWidgetFromTemplate(templateName, container, this.opts.itemWidgetParams);
            itemWidget.muBindData({
                ...item,
                [this.opts.plungeField]: plunge
            });
            this.itemWidgets.push(itemWidget);
            const childrens = getChilds(item);
            if (childrens) {
                const childContainer = this.opts.outStructType === "plunge" ? itemWidget.ui[this.opts.childContainer] : container;
                this.renderList(childrens, getChilds, childContainer, plunge + 1);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.opts = {
            srcStructFormat: "parentField",
            outStructType: "plunge",
            parentField: "parentId",
            childField: "children",
            idField: "id",
            childContainer: "children",
            indentField: "indent",
            templateName: "item",
            plungeField: "plunge",
            onCreateItem: null,
            itemWidgetParams: {}
        };
        this.itemWidgets = [];
    }
}

});

parcelRegister("4lD3q", function(module, exports) {

$parcel$export(module.exports, "UiChboxList", () => $57180c96013ce2e7$export$9ac971d141b6464f);
$parcel$export(module.exports, "UiChboxListItem", () => $57180c96013ce2e7$export$a533a9430efb2ee1);

var $dMN2n = parcelRequire("dMN2n");

var $d4ug8 = parcelRequire("d4ug8");
function $57180c96013ce2e7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $57180c96013ce2e7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $57180c96013ce2e7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $57180c96013ce2e7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $57180c96013ce2e7$var$_arrayLikeToArray(o, minLen);
}
function $57180c96013ce2e7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $57180c96013ce2e7$export$9ac971d141b6464f extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        /* this.muAppendContent(`<label mu-template="item" mu-widget="UiChboxListItem">
    	<input type="checkbox" mu-id="input">
    	<!-- <img mu-id="icon" /> -->
    	<span mu-id="title"></span>
    </label>`); */ this.htmlName = (0, $d4ug8.MuUIDs).next("name");
        this.muRegisterEvent("change");
    }
    afterIndex() {
        if (!("item" in this.muTemplates)) this.muTemplates.item = `<label mu-widget="UiChboxListItem">
			<input type="checkbox" mu-id="input">
			<span mu-id="title"></span>
		</label>`;
    }
    checkBy(checkedCallback) {
        for(var _i = 0, _Object$values = Object.values(this.items); _i < _Object$values.length; _i++){
            const item = _Object$values[_i];
            const res = checkedCallback(item);
            if (res !== undefined) item.ui.input.checked = res;
        }
    }
    bindItems(items) {
        this.container.innerHTML = "";
        this.items = {};
        if (Array.isArray(items)) for(var _iterator = $57180c96013ce2e7$var$_createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;){
            const item = _step.value;
            this.replaceItem(item);
        }
        else for(const k in items){
            let item = items[k];
            this.replaceItem(typeof item === "string" ? {
                id: k,
                title: item
            } : item);
        }
    }
    replaceItem(item) {
        if (!this.items[item.id]) {
            // @ts-ignore
            this.items[item.id] = this.muWidgetFromTemplate("item", this.container, item);
            if (this._value == item.id) this.value = this._value;
        } else {
            Object.assign(this.items[item.id], item);
            this.items[item.id].afterIndex();
        }
    }
    onChanged() {
        this.muDispatchEvent("change", this.value);
    }
    get value() {
        const res = [];
        for(const k in this.items)if (this.items[k].getChecked()) res.push(k);
        return res;
    }
    set value(v) {
        v = v || [];
        for(const k in this.items)this.items[k].setChecked(v.includes(k));
    }
    muBindData(srcData) {
        this.value = srcData;
    }
    muFetchData() {
        return this.value;
    }
    setDisabled(disabled) {
        for(const k in this.items)this.items[k].ui.input.disabled = disabled;
    }
    constructor(...args){
        super(...args);
        this.selectedItem = null;
        this.items = {};
    }
}
class $57180c96013ce2e7$export$a533a9430efb2ee1 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.ui.input.name = this.muParent.htmlName;
        this.ui.input.value = this.id;
        this.ui.input.disabled = this.disabled;
        // if (typeof this.title === "string")
        if (typeof this.title === "string") this.ui.title.innerText = this.title;
        else this.muBindData(this.title);
    }
    input_change() {
        this.muParent.onChanged();
    }
    setChecked(checked) {
        this.ui.input.checked = checked;
    }
    getChecked() {
        return this.ui.input.checked;
    }
    constructor(...args){
        super(...args);
        this.disabled = false;
    }
}

});

parcelRegister("jYXU5", function(module, exports) {

$parcel$export(module.exports, "BaseCompanyForm", () => $3a236dadb7a8225c$export$a90f431b3ecbb34b);

var $6Taw3 = parcelRequire("6Taw3");

var $bxsP3 = parcelRequire("bxsP3");

var $kwZWC = parcelRequire("kwZWC");
class $3a236dadb7a8225c$export$a90f431b3ecbb34b extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="form-group row">
				<label class="col-sm-3">
					I\u{10C} / DI\u{10C}
				</label>
				<div class="col-sm-5">
					<div class="input-group">
					<input type="text" mu="ic#ic" class="form-control">
						<span class="input-group-btn">
							<span class="btn btn-primary" mu-id="bAres">Na\u{10D}\xedst dle I\u{10C}</span>
						</span>
					</div>
				</div>
				<div class="col-sm-4">
					<input type="text" mu-bind="dic" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					N\xe1zev
				</label>
				<div class="col-sm-9">
					<input type="text" mu-bind="name" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					Ulice / \u{10D}p / \u{10D}o
				</label>
				<div class="col-sm-5">
					<input type="text" mu-bind="address_street" class="form-control">
				</div>
				<div class="col-sm-2">
					<input type="text" mu-bind="address_nd" class="form-control">
				</div>
				<div class="col-sm-2">
					<input type="text" mu-bind="address_no" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					M\u{11B}sto / PS\u{10C}
				</label>
				<div class="col-sm-5">
					<input type="text" mu-bind="address_city" class="form-control">
				</div>
				<div class="col-sm-4">
					<input type="text" mu-bind="address_zip" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					St\xe1t
				</label>
				<div class="col-sm-9">
					<input type="text" mu-bind="address_country" class="form-control">
				</div>
			</div>`);
    }
    async bAres_click() {
        const aresData = await new (0, $bxsP3.DmsCL)().loadFromAres(this.ui.ic.value);
        this.muBindData({
            ...aresData,
            address_street: aresData.address.street,
            address_nd: aresData.address.numD,
            address_no: aresData.address.numO,
            address_city: (0, $kwZWC.Arrays).unique([
                aresData.address.cityCityPart,
                aresData.address.cityPart,
                aresData.address.city
            ]).map((s)=>s.trim()).filter((s)=>s !== "").join(", "),
            address_zip: aresData.address.zip,
            address_country: aresData.address.country
        });
    }
    setDisabled(disabled) {
        this.muVisible(!disabled, "bAres");
        this.container.querySelectorAll("input").forEach((input)=>input.disabled = disabled);
    }
}

});

parcelRegister("chE5m", function(module, exports) {

$parcel$export(module.exports, "RelatedAccountSelector", () => $ab8ad75a5831a434$export$696570d525688e6b);
$parcel$export(module.exports, "RelatedAccountSelectorItem", () => $ab8ad75a5831a434$export$a5dc505712cd3ee3);

var $6Taw3 = parcelRequire("6Taw3");

var $5OSdp = parcelRequire("5OSdp");

var $dMN2n = parcelRequire("dMN2n");

var $jRjEI = parcelRequire("jRjEI");
class $ab8ad75a5831a434$export$696570d525688e6b extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="display-flex">
				<h4 class="flex-grow-1" mu="label">Vyberte komu delegovat \xfakol.</h4>
				<span mu-id="bCloseUnderlings" class="close">&times;</span>
			</div>
			<div mu-bind="underlings:@visible">
				<h5>Pod\u{159}\xedzen\xed</h5>
				<ul mu-id="underlings" mu-bind="underlings:@foreach">
					<li mu-template="itemU" mu-widget="RelatedAccountSelectorItem" mu-bind="id::.accountId">
						<div mu-id="name" mu-bind="name" class="btn btn-link"></div>
					</li>
				</ul>				
			</div>
			<h5>Nad\u{159}\xedzen\xed</h5>
			<ul mu-id="superiors" mu-bind="superiors:@foreach">
				<li mu-template="itemS" mu-widget="RelatedAccountSelectorItem" mu-bind="id::.accountId">
					<div mu-id="name" mu-bind="name" class="btn btn-link"></div>
				</li>
			</ul>
			<h5>Spolupracovn\xedci</h5>
			<ul mu-id="collaborators" mu-bind="collaborators:@foreach">
				<li mu-template="itemC" mu-widget="RelatedAccountSelectorItem" mu-bind="id::.accountId">
					<div mu-id="name" mu-bind="name" class="btn btn-link"></div>
				</li>
			</ul>
		`);
    }
    static open(label) {
        const widget = (0, $5OSdp.UiModalContainer).open("RelatedAccountSelector", label);
        return widget.newSelectPromise();
    }
    newSelectPromise() {
        return new Promise((resolve)=>this.onSelect = resolve);
    }
    muRemoveSelf() {
        this.onSelect(null);
        super.muRemoveSelf();
    }
    async afterIndex() {
        this.muBindData(await this.cl.getOrgRelatedAccounts(null));
    }
    selectAccount(accountId) {
        this.onSelect(accountId);
        this.muRemoveSelf();
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $jRjEI.TicketsCL)();
    }
}
class $ab8ad75a5831a434$export$a5dc505712cd3ee3 extends (0, $dMN2n.MuWidget) {
    name_click() {
        this.muParent.selectAccount(this.accountId);
    }
}

});

parcelRegister("6dyRm", function(module, exports) {

$parcel$export(module.exports, "UiCharCounter", () => $e9f6a1b9197da03c$export$78df5285fc879cc9);

var $dMN2n = parcelRequire("dMN2n");
class $e9f6a1b9197da03c$export$78df5285fc879cc9 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        const newContainer = document.createElement("div");
        this.container.setAttribute("mu-id", "input");
        this.container.classList.add("input-group");
        this.container.parentElement?.insertBefore(newContainer, this.container);
        newContainer.appendChild(this.container);
        const info = document.createElement("span");
        info.classList.add("input-group-addon");
        info.setAttribute("mu-id", "info");
        newContainer.appendChild(info);
        const errorLabel = document.createElement("span");
        errorLabel.setAttribute("mu-for");
        this.container = newContainer;
    }
    afterIndex() {
        this.update();
    }
    input_input() {
        this.update();
    }
    update() {
        this.ui.info.innerText = this.ui.input.value.length.toString() + " / " + this.ui.input.maxLength.toString();
    }
}

});

parcelRegister("kMzi9", function(module, exports) {

$parcel$export(module.exports, "UiBuSubjectEditor", () => $29dc39b2c160764b$export$19849b52adafef9a);

var $ffuEw = parcelRequire("ffuEw");

var $3cBch = parcelRequire("3cBch");

var $9QECq = parcelRequire("9QECq");
function $29dc39b2c160764b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $29dc39b2c160764b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $29dc39b2c160764b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $29dc39b2c160764b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $29dc39b2c160764b$var$_arrayLikeToArray(o, minLen);
}
function $29dc39b2c160764b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $29dc39b2c160764b$export$19849b52adafef9a extends (0, $9QECq.BaseEditor) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`<div>
			<fieldset><legend>Z\xe1kladn\xed \xfadaje</legend>
				<div class="form-group row">
					<label mu-for="name" class="col-sm-3 control-label">N\xe1zev</label>
					<div class="col-sm-9">
						<input type="text" mu-id="name" mu-bind="name" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="ic" class="col-sm-3 control-label">I\u{10C}</label>
					<div class="col-sm-9">
						<div class="input-group">
							<input type="text" mu-id="ic" mu-bind="ic" class="form-control" />
							<span class="input-group-btn">
								<button class="btn btn-default" type="button" mu-id="bLoadFromAres">Na\u{10D}\xedst</button>
							</span>
						</div>
						<div mu-for="error:ic"></div>
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="dic" class="col-sm-3 control-label">DI\u{10C}</label>
					<div class="col-sm-9">
						<input type="text" mu-id="dic" mu-bind="dic" class="form-control" />
					</div>
				</div>
				<div class="form-group row" mu-id="block_internalCode">
					<label mu-for="internalCode" class="col-sm-3 control-label">K\xf3d intern\xedho subjektu</label>
					<div class="col-sm-9">
						<input type="text" mu-id="internalCode" mu-bind="internalCode" class="form-control" />
					</div>
				</div>
				<div class="col-sm-9 col-sm-offset-3" mu-for="error:internalCode"></div>
				<div class="form-group row" mu-id="block_emails">
					<label mu-for="emails" class="col-sm-3 control-label">Emaily subjektu</label>
					<div class="col-sm-9">
						<input type="text" mu-id="emails" mu-bind="emails" class="form-control" />
					</div>
				</div>
			</fieldset>
			<fieldset><legend>Adresa</legend>
				<div mu-widget="." mu-bind="address" class="address-form">
					<div class="form-group row">
						<label mu-for="street" class="col-sm-3 control-label">Ulice</label>
						<div class="col-sm-9">
							<div class="address-form__street-block">
								<input type="text" mu-bind="street" class="address-form__street-block__street form-control" />
								<label mu-for="numD">\u{10C}P</label>
								<input type="text" size="5" mu-bind="numD" class="address-form__street-block__numd form-control" />
								<label mu-for="numO">\u{10C}O</label>
								<input type="text" size="3" mu-bind="numO" class="address-form__street-block__numo form-control" />
							</div>
							<div mu-for="error:street"></div>
							<div mu-for="error:numD"></div>
							<div mu-for="error:numO"></div>
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="city" class="col-sm-3 control-label">M\u{11B}sto</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="city" class="form-control" />
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="cityPart" class="col-sm-3 control-label">\u{10C}\xe1st obce</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="cityPart" class="form-control" />
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="cityCityPart" class="col-sm-3 control-label">M\u{11B}stsk\xe1 \u{10D}\xe1st</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="cityCityPart" class="form-control" />
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="zip" class="col-sm-3 control-label">PS\u{10C}</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="zip" class="form-control" />
						</div>
					</div>
				</div>
			</fieldset>
			<fieldset mu-widget="." mu-bind="headerInfo"><legend>Hlavi\u{10D}ka smlouvy</legend>
				<div class="form-group row">
					<label mu-for="representativeFirstName" class="col-sm-3 control-label">Zastupuje</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="representativeFirst" class="form-control" />
					</div>
				</div>
				<!-- <div class="form-group row">
					<label mu-for="representativeFirstName" class="col-sm-3 control-label">Zastupuje - jm\xe9no</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="representativeFirstName" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="representativeLastName" class="col-sm-3 control-label">Zastupuje - p\u{159}\xedjmen\xed</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="representativeLastName" class="form-control" />
					</div>
				</div> -->
				<div class="form-group row">
					<label mu-for="courtName" class="col-sm-3 control-label">Zaps\xe1no u soudu</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="courtName" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="courtTract" class="col-sm-3 control-label">Odd\xedl / vlo\u{17E}ka</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="courtTract" class="form-control" />
					</div>
				</div>
			</fieldset>
		</div>
		<div class="buttons">
			<span class="btn btn-primary" mu-id="bSave">Ulo\u{17E}it</span>
		</div>`);
    }
    afterIndex() {
        super.afterIndex();
        this.muVisible((0, $ffuEw.UiDms).instance?.isAdmin ?? false, "block_internalCode");
    }
    /* emails_keyup(ev: Event) {
  	ev.stopPropagation();
  } */ async bLoadFromAres_click() {
        const res = await (0, $ffuEw.UiDms).instance.cl.loadFromAres(this.ui.ic.value);
        if (res.status == "ok") this.muBindData(res);
        else (0, $3cBch.UiFlashMessage).instance.add({
            unknownIc: "Nezn\xe1m\xe9 I\u010C",
            failed: "Ares je nedostupn\xfd"
        }[res.status] || "");
    }
    async bSave_click() {
        const data = this.muFetchData();
        const res = await (0, $ffuEw.UiDms).instance.cl.saveBuSubject(this.id, data);
        if (res.status === "ok") {
            (0, $3cBch.UiFlashMessage).instance.add("Subjekt ulo\u017Een");
            this.onSaved(res.entity);
        } else (0, $3cBch.UiFlashMessage).instance.add("Opravte chyby ve formul\xe1\u0159i");
        this.errorMarker.markErrors(res.errorList || []);
    }
    async loadItem(id) {
        this.id = id;
        this.container.classList.add("loading-data");
        const data = await (0, $ffuEw.UiDms).instance.cl.getBuSubject(id);
        this.muBindData(data);
        this.container.classList.remove("loading-data");
    }
    showErrors(errors) {
        const allErrorLabels = Array.from(this.container.querySelectorAll('[mu-for^="error:"]'));
        for(var _i = 0, _allErrorLabels = allErrorLabels; _i < _allErrorLabels.length; _i++){
            const el = _allErrorLabels[_i];
            el.innerHTML = "";
        }
        for(const place in errors){
            // @ts-ignore
            const cont = this.ui[place]["errorLabel"];
            for(var _iterator = $29dc39b2c160764b$var$_createForOfIteratorHelperLoose(errors[place]), _step; !(_step = _iterator()).done;){
                const message = _step.value;
                const elMessage = document.createElement("div");
                elMessage.innerText = message;
                cont.appendChild(elMessage);
            }
        }
    }
    ic_keypress(ev) {
        if (ev.key === "Enter") {
            ev.preventDefault();
            ev.cancelBubble = true;
            this.ui.bLoadFromAres.click();
        }
    }
}

});

parcelRegister("3pvHV", function(module, exports) {

$parcel$export(module.exports, "UiDmsDocumentEditor", () => $bb0833f388c04d33$export$4fce3947ab38aafe);
$parcel$export(module.exports, "UiDmsDocumentEditorType", () => $bb0833f388c04d33$export$bf8db7e716f122f3);

var $ffuEw = parcelRequire("ffuEw");

var $9QECq = parcelRequire("9QECq");

var $dMN2n = parcelRequire("dMN2n");

var $3cBch = parcelRequire("3cBch");

var $8iO6j = parcelRequire("8iO6j");
class $bb0833f388c04d33$export$4fce3947ab38aafe extends (0, $9QECq.BaseEditor) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`
			<div mu-id="selectType">
				<fieldset><legend>Vyberte typ dokumentu</legend>
					<!-- <ul mu-id="documentTypes" mu-bind="documentTypes:@foreach">
						<li mu-template="documentTypeItem" mu-widget="UiDmsDocumentEditorType" mu-bind="id:.id">
							<span class="btn btn-link" mu-id="bSelectType" mu-bind="name"></span>
						</li>
					</ul> -->
					<ul mu-id='newTypesTree' mu-widget="UiTree">
						<li mu-template="item" mu-widget=".">
							<span mu-bind='pathItemName;id|tern("a icon-before-document-file","strong"):className;id:dmsDocumentTypeId' class="strong cursor-pointer icon-before-document-dir" mu-id="bSelectType"></span>
							<ul mu-id="items" style="display: none"></ul>
						</li>
					</ul>
				</fieldset>
			</div>
			<div mu-id="editor">
				<fieldset><legend>Z\xe1kladn\xed \xfadaje</legend>
					<div class="form-group row" mu-id="block_dmsDocumentTypeName">
						<label mu-for="" class="col-sm-3 control-label">Typ</label>
						<div class="col-sm-9">
							<span mu-bind="dmsDocumentTypeName"></span>							
							<span mu-id="parentDmsDocument" class="a"></span>
						</div>
					</div>

					<div class="form-group row" mu-id="block_stateId">
						<label mu-for="stateId" class="col-sm-3 control-label">Stav</label>
						<div class="col-sm-9">
							<div class="checkbox" mu-widget="UiRadioList" mu-id="stateId" mu-bind="stateId"></div>
						</div>
					</div>
				` + (0, $9QECq.formGroup)("cancelNote", "Pozn\xe1mka ke stornu", `<textarea mu-id="cancelNote" mu-bind="cancelNote" class="form-control" rows="5"></textarea>`) + `					
					<div class="form-group row" mu-id="securityLevel_stateId">
						<label mu-for="securityLevel" class="col-sm-3 control-label">Stupe\u{148} utajen\xed dokumentu</label>
						<div class="col-sm-9">
							<div class="checkbox" mu-widget="UiRadioList" mu-id="securityLevel" mu-bind="securityLevel"></div>
						</div>
					</div>` + (0, $9QECq.formGroup)("dmsDocumentClassId", "Druh", `<div mu-widget="UiTomSelect" mu-id="dmsDocumentClassId" mu-bind="dmsDocumentClassId"></div>`) + (0, $9QECq.formGroup)("name", "N\xe1zev", `<input type="text" class="form-control" mu-id="name" mu-bind="name" />`) + (0, $9QECq.formGroup)("orgProjectId", "Projekt", `<div mu-widget="UiOrgProjectSelector" mu-id="orgProjectId" mu-bind="orgProjectId"></div>
					<div mu-for="error:orgProjectId"></div>
					<span class="btn btn-link" mu-id="bSetProjectResponsible">Nastavit odpov\u{11B}dnou osobu.</span>
					<span class="btn btn-link" mu-id="bSetProjectOrgDivision">Nastavit st\u{159}edisko.</span>`) + (0, $9QECq.formGroup)("responsibleId", "Odpov\u011Bdn\xe1 osoba", `<div mu-widget="UiAccountSelector" mu-id="responsibleId" mu-bind="responsibleId"></div>`) + (0, $9QECq.formGroup)("orgDivisionId", "St\u0159edisko", `<div mu-widget="TreeSelector" mu-id="orgDivisionId" mu-params='{"inModal":true}' mu-bind="orgDivisionId"></div>`) + (0, $9QECq.formGroup)("amount", "\u010C\xe1stka / m\u011Bna", `<div class="input-group display-flex">
						<input type="number" mu-id="amount" mu-bind="amount" class="form-control flex-grow-1"  />
						<select mu-id="currencyId" mu-bind="currencyId;currencies:@options" class="form-control"></select>
					</div>
					<div class="col-md-6" mu-for="error:amount"></div>
					<div class="col-md-6" mu-for="error:currencyId"></div>`) + (0, $9QECq.formGroup)("note", "Pozn\xe1mka", `<input type="text" mu-id="note" mu-bind="note" class="form-control" />`) + `</fieldset>
	
				<fieldset><legend>Na\u{161}e strana</legend>
					<div class="form-group row" mu-id="block_evidenceUid">
						<label mu-for="" class="col-sm-3 control-label">Eviden\u{10D}n\xed \u{10D}\xedslo</label>
						<div class="col-sm-9" mu-bind="evidenceUid"></div>
					</div>` + (0, $9QECq.formGroup)("buSubjectId", "Subjekt", `<div mu-widget="UiTomSelect" mu-id="buSubjectId" mu-bind="buSubjectId"></div>`) + `</fieldset>
				
				<fieldset><legend>Druh\xe1 strana</legend>` + (0, $9QECq.formGroup)("partnerEvidenceUid", "Orig. \u010C", `<input type="text" mu-id="partnerEvidenceUid" mu-bind="partnerEvidenceUid" class="form-control" />`) + (0, $9QECq.formGroup)("partnerBuSubjectId", "Subjekt", `<div mu-widget="UiBuSubjectSelector" mu-id="partnerBuSubject" mu-bind="partnerBuSubjectId"></div>`) + `</fieldset>
				
				<fieldset><legend>Dal\u{161}\xed \xfadaje</legend>` + (0, $9QECq.formGroup)("date", "Datum", `<input type="date" mu-id="date" mu-bind="date" class="form-control" />`) + (0, $9QECq.formGroup)("dateFrom", "Datum platnosti od", `<input type="date" mu-id="dateFrom" mu-bind="dateFrom" class="form-control" />`) + (0, $9QECq.formGroup)("dateTo", "Datum platnosti do", `<input type="date" mu-id="dateTo" mu-bind="dateTo" class="form-control" />`) + `<div class="buttons" mu-id="pButtons"><span mu-id="bSave" class="btn btn-primary">Ulo\u{17E}it</span></div>
			</div>`);
        this.muRegisterEvent("dmsDocumentTypeChange");
    }
    async afterIndex() {
        super.afterIndex();
        this.muBindData({
            dmsDocumentTypeId: null,
            evidenceUid: "Bude p\u0159i\u0159azeno po vytvo\u0159en\xed dokumentu"
        });
        const ddcs = this.muNamedWidget.dmsDocumentClassId;
        ddcs.init();
        this.muNamedWidget.securityLevel.bindItems((0, $ffuEw.UiDms).instance.securityLevels);
        this.promiseInit = new Promise(async (resolve)=>{
            const bss = this.muNamedWidget.buSubjectId;
            bss.init();
            const myBuSubjects = (await (0, $ffuEw.UiDms).instance.cpMyBuSubjects.fetch()).write;
            bss.bindItems(myBuSubjects);
            if (myBuSubjects.length == 1) bss.value = myBuSubjects[0].id;
            this.muNamedWidget.orgDivisionId.bindTree(await (0, $ffuEw.UiDms).instance.cpOrgDivision.fetch());
            /* const cs = (this.muNamedWidget.currencyId as unknown as UiTomSelect);
      cs.init();
      cs.bindItems(await UiDms.instance.cpCurrencies.fetch()); */ const currencies = await (0, $ffuEw.UiDms).instance.cpCurrencies.fetch();
            const documentTypes = (await (0, $ffuEw.UiDms).instance.cpDmsDocumentType.fetch()).filter((dt)=>!dt.mustHaveParent);
            this.muBindData({
                documentTypes: documentTypes,
                // documentTypesTree: ,
                currencies: currencies.map((item)=>({
                        value: item.id,
                        text: item.code
                    }))
            });
            this.muNamedWidget.newTypesTree.muBindData((0, $8iO6j.SlashTree).parse(documentTypes, "name", " - "), {
                bSelectType_click: async (ev)=>{
                    // @ts-ignore
                    const id = ev.target.dmsDocumentTypeId;
                    if (id) this.selectType(await (0, $ffuEw.UiDms).instance.getDmsDocumentType(id));
                    else (0, $dMN2n.MuWidget).getWidget(ev.target)?.muVisible("toggle", "items");
                }
            });
            resolve();
        // console.log(FD);
        /* for(const key in fieldDefs)
      {
      	const fieldDef = fieldDefs[key];
      	if (!fieldDef.edit) continue;
      	const fieldType = fieldDef.edit === true ? fieldDef.type : fieldDef.edit;
      	const editFieldDef = editFieldDefs[fieldType];
      	if (!editFieldDef) throw "No editFieldDefs[" + fieldType + "]";
      	const templateName = "field" + editFieldDef.widget;
      	const widget = this.muWidgetFromTemplate(templateName, 'editorFields', {
      		...editFieldDef,
      		...fieldDef,
      	}) as BaseField;
      	widget.setupField();
      } */ });
    }
    async stateId_change() {
        const stateId = this.muNamedWidget.stateId.value;
        if (!stateId) return;
        const state = (await (0, $ffuEw.UiDms).instance.cpStates.fetch()).find((s)=>s.id == stateId);
        this.muVisible(state.code == "canceled", "block_cancelNote");
    }
    selectType(ddt) {
        this.muBindData(ddt ? {
            dmsDocumentTypeId: ddt.id,
            stateOpts: ddt.default.stateOpts
        } : {
            dmsDocumentTypeId: null
        });
    }
    async setupForm(documentType) {
        super.muBindData({
            dmsDocumentTypeName: documentType.name
        });
        const opts = documentType.opts;
        // Uprav formulář podle typu
        if (opts.fields) for(const k in opts.fields){
            const field = opts.fields[k];
            if (field.visible === false) this.muVisible(false, "block_" + k);
            if (field.label) this.ui["label_" + k].innerText = field.label;
        }
        // Název okna
        if (!this.id) (this.ui.modalTitle || this.muParent.ui.modalTitle).innerText = "Nov\xfd dokument: " + documentType.name;
        // Druhy
        const ddcs = this.muNamedWidget.dmsDocumentClassId;
        if (documentType.dmsDocumentClassGroupId) ddcs.replaceOptions((await (0, $ffuEw.UiDms).instance.cpDmsDocumentClass.fetch()).filter((drc)=>drc.dmsDocumentClassGroupId == documentType.dmsDocumentClassGroupId));
        // Stavy
        const sts = this.muNamedWidget.stateId;
        sts.bindItems((await (0, $ffuEw.UiDms).instance.cpStates.fetch()).filter((s)=>s.workflowId == documentType.workflowId).map((s)=>({
                id: s.id,
                title: s.name
            })));
        let firstEnabled = sts.value;
        const stateOpts = this.stateOpts || documentType.default.stateOpts;
        for(const sid in sts.items){
            const disabled = !(stateOpts.enabledStateCodes === null || stateOpts.enabledStateCodes.includes(parseInt(sid)));
            sts.replaceItem({
                id: sid,
                disabled: disabled
            });
            if (!firstEnabled && !disabled) firstEnabled = sid.toString();
        }
        if (firstEnabled) sts.value = firstEnabled;
        this.stateId_change();
    }
    async muBindData(srcData) {
        // Počkat na načtení číselníků
        if (this.promiseInit) await this.promiseInit;
        // datumy
        for(var _i = 0, _arr = [
            "date",
            "dateFrom",
            "dateTo" /*, "dateProlong", "dateProlongChangeTerm"*/ 
        ]; _i < _arr.length; _i++){
            const k = _arr[_i];
            if (srcData[k]) srcData[k] = srcData[k].substr(0, 10);
        }
        if (srcData.currencyId) srcData.currencyId = srcData.currencyId.id;
        super.muBindData(srcData);
        if (srcData.dmsDocumentTypeId !== undefined) {
            this.dmsDocumentTypeId = srcData.dmsDocumentTypeId;
            this.muVisible(!!srcData.dmsDocumentTypeId, [
                "!selectType",
                "editor"
            ]);
        }
        if (srcData.stateOpts) this.stateOpts = srcData.stateOpts;
        if (srcData.parentId) {
            this.ui.parentDmsDocument.innerText = (0, $ffuEw.getDocumentName)(srcData.parentId);
            this.parentDocument = srcData.parentId;
        }
        if (srcData.dmsDocumentTypeId) {
            //const documentTypes = await UiDms.instance.cpDmsDocumentType.fetch();
            // console.log(new SlashTree(documentTypes, 'name').rootNode);
            const documentType = await (0, $ffuEw.UiDms).instance.getDmsDocumentType(srcData.dmsDocumentTypeId); // documentTypes.find((dt: any) => dt.id == srcData.dmsDocumentTypeId);
            this.setupForm(documentType);
            this.muDispatchEvent("dmsDocumentTypeChange", documentType);
        }
        this.stateId_change();
    }
    muFetchData() {
        return {
            ...super.muFetchData(),
            dmsDocumentTypeId: this.dmsDocumentTypeId,
            parentId: this.parentDocument?.id
        };
    }
    parentDmsDocument_click() {
        (0, $ffuEw.UiDms).instance.openDmsDocumentEditor(this.parentDocument.id);
    }
    async loadItem(id) {
        this.id = id;
        this.container.classList.add("loading-data");
        const data = await (0, $ffuEw.UiDms).instance.cl.getDocument(id);
        if (!data) {
            (0, $3cBch.UiFlashMessage).instance.add("Nem\xe1te opr\xe1vn\u011Bn\xed \u010D\xedst tento dokument");
            this.muRemoveSelf();
            return;
        }
        this.muBindData(data);
        /* this.ui.modalTitle.innerText = data
    	? "Upravit " + getDocumentName(data)
    	: "Nový dokument"; */ this.container.classList.remove("loading-data");
    }
    async bSave_click() {
        const data = this.muFetchData();
        const res = await (0, $ffuEw.UiDms).instance.cl.saveDocument(this.id, data);
        if (res.status === "ok") {
            (0, $3cBch.UiFlashMessage).instance.add("Dokument ulo\u017Een");
            this.onSaved(res.entity);
        } else (0, $3cBch.UiFlashMessage).instance.add("Opravte chyby ve formul\xe1\u0159i");
        this.errorMarker.markErrors(res.errorList || []);
    }
    bSetProjectResponsible_click() {
        const op = this.muNamedWidget.orgProjectId.valueOption;
        if (op) this.muNamedWidget.responsibleId.muBindData({
            name: op.acName,
            id: op.accountId
        });
    }
    bSetProjectOrgDivision_click() {
        const op = this.muNamedWidget.orgProjectId.valueOption;
        if (op) this.muNamedWidget.orgDivisionId.muBindData(op.orgDivisionId);
    }
    constructor(...args){
        super(...args);
        this.promiseInit = null;
        this.dmsDocumentTypeId = null;
    }
}
class $bb0833f388c04d33$export$bf8db7e716f122f3 extends (0, $dMN2n.MuWidget) {
    bSelectType_click() {
        (0, $ffuEw.UiDms).instance.selectType(this.dmsDocumentType);
    }
    muBindData(srcData) {
        this.dmsDocumentType = srcData;
        super.muBindData(srcData);
    }
} /*<div class="form-group row" mu-id="block_">
			<label mu-for="" class="col-sm-3 control-label">Subjekt</label>
			<div class="col-sm-9">
				<input type="text" mu-id="" mu-bind="" class="form-control" />
			</div>
		</div>

	</fieldset>


		<div class="form-group row" mu-id="block_partnerEvidenceUid">
			<label mu-for="partnerEvidenceUid" class="col-sm-3 control-label">Evidenční číslo druhé strany</label>
			<div class="col-sm-9">

			</div>
		</div>

		<div class="form-group row" mu-id="block_">
			<label mu-for="" class="col-sm-3 control-label">Typ obsahu</label>
			<div class="col-sm-9">
				<input type="text" mu-id="" mu-bind="" class="form-control" />
			</div>
		</div>



		<div class="form-group row" mu-id="block_">
			<label mu-for="" class="col-sm-3 control-label"></label>
			<div class="col-sm-9">
				<input type="text" mu-id="" mu-bind="" class="form-control" />
			</div>
		</div>
	</fieldset>`)
/* this.container.innerHTML = `<h2>Úprava dokumentu</h2>
	<div mu-id="editorFields"></div>
	<div class="buttons"><button mu-id="btSave" class="btn btn-primary">Uložit</button></div>`;
for(const widget of new Set(Object.values(editFieldDefs).map(it => it.widget)))
	this.container.innerHTML += `<div mu-template="field${widget}" mu-widget="${widget}"></div>`; */ 

});
parcelRegister("8iO6j", function(module, exports) {

$parcel$export(module.exports, "SlashTree", () => $f070831ee968aeb0$export$233b89a92a224e9e);
function $f070831ee968aeb0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f070831ee968aeb0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f070831ee968aeb0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f070831ee968aeb0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f070831ee968aeb0$var$_arrayLikeToArray(o, minLen);
}
function $f070831ee968aeb0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $f070831ee968aeb0$export$233b89a92a224e9e {
    constructor(data = [], field = "", separator = "/"){
        this.trimPathItem = true;
        this.caseInsensitivePathItem = true;
        this.rootNode = this.newNode();
        this.separator = separator;
        for(var _i = 0, _data = data; _i < _data.length; _i++){
            const item = _data[_i];
            const path = typeof field === "string" ? item[field] : field(item);
            this.addItem(path, item);
        }
    }
    nodeByPath(path) {
        const pathItems = path.split(this.separator);
        let n = this.rootNode;
        for(var _iterator = $f070831ee968aeb0$var$_createForOfIteratorHelperLoose(pathItems), _step; !(_step = _iterator()).done;){
            let pathItem = _step.value;
            if (this.trimPathItem) pathItem = pathItem.trim();
            const pathItemCS = pathItem;
            if (this.caseInsensitivePathItem) pathItem = pathItem.toLowerCase();
            let nn = n.items.find((n)=>n.key == pathItem);
            if (!nn) {
                nn = this.newNode(n);
                nn.name = pathItemCS;
                nn.key = pathItem;
                n.items.push(nn);
            }
            n = nn;
        }
        return n;
    }
    newNode(parent = null) {
        return {
            name: "",
            key: "",
            items: [],
            data: {},
            parent: parent
        };
    }
    addItem(path, data) {
        this.nodeByPath(path).data = data;
    }
    static parse(data = [], field = "", separator = "/") {
        return new $f070831ee968aeb0$export$233b89a92a224e9e(data, field, separator).rootNode;
    }
    static getItemsRecursive(item) {
        const res = [];
        const addItems = (item)=>{
            res.push(item);
            item.items.map((subItem)=>addItems(subItem));
        };
        addItems(item);
        return res; // [ item, ...item.items.map(it => this.getItemsRecursive(it))] as SlashTreeNode[]; // item.items.reduce((acc, curr) => [...acc, ...curr.items], [] as SlashTreeNode[]);
    }
    exportAs(transformer, itemsField, srcNode = null) {
        const res = transformer(srcNode ?? this.rootNode);
        res[itemsField] = res[itemsField].map((item)=>this.exportAs(transformer, itemsField, item));
        return res;
    }
}

});


parcelRegister("cLxj2", function(module, exports) {

$parcel$export(module.exports, "UiBuSubjects", () => $553b3a11deb2a540$export$24ae514068fbcc71);
$parcel$export(module.exports, "UiBuSubjectsActionCell", () => $553b3a11deb2a540$export$902c812c64efe79f);
$parcel$export(module.exports, "UiBuSubjectsFilter", () => $553b3a11deb2a540$export$be769a98e498f80b);

var $3Yb7l = parcelRequire("3Yb7l");

var $ffuEw = parcelRequire("ffuEw");

var $6YeHu = parcelRequire("6YeHu");

var $9QECq = parcelRequire("9QECq");

var $fQex0 = parcelRequire("fQex0");

var $9qZbt = parcelRequire("9qZbt");
class $553b3a11deb2a540$export$24ae514068fbcc71 extends (0, $6YeHu.BaseModule) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`
			<h2 mu-id="label">Seznam subjekt\u{16F}</h2>
			<div class="toolbar">
				<span class="btn btn-link icon-before-add" mu-id="rCreateItem">P\u{159}idat subjekt</span>
				<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>
				<span class="btn btn-link icon-before-filter" mu-id="bFilter">Cel\xfd filtr <span mu-id="filterCount" class="badge"></span></span>
				<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zru\u{161}it filtr</span>
				<span class="btn btn-link icon-before-document-sheet" mu-id="bExport">Export</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>
			<table mu-id="list" mu-widget="UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu-template="actions" mu-widget="UiBuSubjectsActionCell">
						<span mu-id="bEdit" class="a icon-before-edit">Upravit</span>
						<span mu-id="bDocuments" class="a icon-before-document-dir">Dokumenty</span>
					</td>
				</tr>
			</table>
			
			<div mu-id="pager" mu-widget="Pager"></div>
		`);
    }
    afterIndex() {
        super.afterIndex();
        this.muNamedWidget.list.columns = [
            new (0, $3Yb7l.ColumnInfo)({
                field: "id",
                name: "ID",
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "name",
                name: "N\xe1zev"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "internalCode",
                name: "K\xf3d"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "ic",
                name: "I\u010C"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dic",
                name: "DI\u010C"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "id",
                name: "-",
                template: "ancestor:actions",
                orderable: false,
                filterable: false,
                interactiveOnly: true
            })
        ];
        if (this.contractFilter) this.muVisible(false, "rCreateItem");
        this.ui.label.innerText = (0, $9qZbt.ContractFilter)[this.contractFilter];
    }
    openEditor(id) {
        // @ts-ignore
        return (0, $ffuEw.UiDms).instance.openBuSubjectEditor(id);
    }
    /* protected async loadList() {
  	this.muParent?.router.pushUpdate(null, {
  		[this.muIndexOpts?.id + '_list']: JSON.stringify({
  			filter: this.filter,
  			orderBy: this.orderBy
  		})
  	});
  	const filterFields = UiBuSubjectsFilter.filtredFields(this.filter);
  	for(const ci of this.muNamedWidget.list.columns) {
  		ci.isFiltered = filterFields.includes(ci.field);
  		ci.isOrdered = this.orderBy.field === ci.field ? this.orderBy.dir : null;
  	}
  	this.muNamedWidget.list.data = await this.getListData();
  	this.muNamedWidget.list.render();
  } */ getListData(forExport) {
        return (0, $ffuEw.UiDms).instance.cl.allBuSubjects({
            ...this.filter,
            contractFilter: this.contractFilter,
            fulltext: this.ui.cFulltext.value
        }, this.orderBy, forExport ? 0 : this.muNamedWidget.pager.currentItemFrom, forExport ? null : this.muNamedWidget.pager.itemPerPage);
    }
    openFilter(field) {
        const filter = this.muParent.openInModal("UiBuSubjectsFilter", "Nastavit filtr", {
            muParent: this
        });
        // filter?.showByField(field);
        return filter;
    }
    constructor(...args){
        super(...args);
        this.contractFilter = "";
    }
}
class $553b3a11deb2a540$export$902c812c64efe79f extends (0, $3Yb7l.UiTableCell) {
    render(id, row) {
        this.id = id;
        this.row = row;
    }
    bEdit_click() {
        const module = this.muParent.muParent.muParent;
        module.loadItem(this.id);
    }
    bDocuments_click() {
        (0, $ffuEw.UiDms).instance.openDocumentsPreview("BuSubject", this.id, this.row);
    }
}
class $553b3a11deb2a540$export$be769a98e498f80b extends (0, $fQex0.BaseFilter // MuWidget<UiBuSubjects>
) {
    beforeIndex() {
        this.muAppendContent(`
			<div mu-id="searchFields">` + (0, $9QECq.formGroup)("name", "N\xe1zev", `<input type="search" class="form-control" mu-bind="name" />`, true) + (0, $9QECq.formGroup)("internalCode", "Intern\xed k\xf3d", `<input type="search" class="form-control" mu-bind="internalCode" />`, true) + (0, $9QECq.formGroup)("ic", "I\u010C", `<input type="search" class="form-control" mu-bind="ic" />`, true) + (0, $9QECq.formGroup)("dic", "DI\u010C", `<input type="search" class="form-control" mu-bind="dic" />`, true) + `			
			</div>
			<div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zru\u{161}it filtr</span>
			</div>
		`);
    }
    static filtredFields(filterData) {
        return Object.keys(filterData).filter((f)=>{
            const v = filterData[f];
            if (Array.isArray(v)) return v.length > 0;
            else if ("rangeFrom" in filterData) return filterData.rangeFrom || filterData.rangeTo;
            else return !!v;
        });
    }
}

});
parcelRegister("6YeHu", function(module, exports) {

$parcel$export(module.exports, "BaseModule", () => $3ea17cb3b2b9ec99$export$adea4f5921a64958);

var $dMN2n = parcelRequire("dMN2n");

var $ffuEw = parcelRequire("ffuEw");

var $cLxj2 = parcelRequire("cLxj2");

var $kwZWC = parcelRequire("kwZWC");

var $1GQhJ = parcelRequire("1GQhJ");
function $3ea17cb3b2b9ec99$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $3ea17cb3b2b9ec99$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3ea17cb3b2b9ec99$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3ea17cb3b2b9ec99$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3ea17cb3b2b9ec99$var$_arrayLikeToArray(o, minLen);
}
function $3ea17cb3b2b9ec99$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $3ea17cb3b2b9ec99$export$adea4f5921a64958 extends (0, $dMN2n.MuWidget) {
    setupList(listOpts) {
        if (listOpts.filter) this.filter = listOpts.filter;
        if (listOpts.orderBy) this.orderBy = listOpts.orderBy;
        this.loadList();
    }
    loadItem(id) {
        const bse = this.openEditor(id);
        bse.savedPromise.then(()=>{
            this.loadList();
            bse.muRemoveSelf();
            this.muParent.router.pushUpdate(null, {
                id: null
            });
        });
        (0, $ffuEw.UiDms).instance.router.pushUpdate(null, {
            id: id
        });
    }
    async rCreateItem_click() {
        const bse = this.openEditor(null);
        bse?.savedPromise.then(()=>this.loadList());
    }
    bReload_click() {
        this.loadList();
    }
    bFulltextSearch_click() {
        this.loadList();
    }
    bFulltextErase_click() {
        this.ui.cFulltext.value = "";
        this.loadList();
    }
    list_filter(ev, field) {
        const filter = this.openFilter(field);
        const blocks = filter.showByField(field);
        if (blocks.length) (0, $kwZWC.focusFirstVisibleControl)(blocks[0]);
    }
    list_order(ev, field, dir) {
        this.setOrder(field, dir);
    }
    bFilter_click(ev) {
        this.openFilter(null);
    }
    setFilter(filterData) {
        this.filter = filterData;
        const filterFields = (0, $cLxj2.UiBuSubjectsFilter).filtredFields(filterData);
        this.ui.filterCount.innerText = filterFields.length > 0 ? filterFields.length.toString() : "";
        this.loadList();
    }
    getFilter() {
        return this.filter;
    }
    setOrder(field, dir) {
        this.orderBy.field = field;
        this.orderBy.dir = dir;
        this.loadList();
    }
    async loadList(forExport = false) {
        /* this.muParent?.router.pushUpdate(null, {
    	[this.muMetaData?.id + '_list']: JSON.stringify({
    		filter: removeEmptyProperties(this.filter),
    		orderBy: this.orderBy
    	})
    }); */ const filterFields = (0, $cLxj2.UiBuSubjectsFilter).filtredFields(this.filter);
        for(var _iterator = $3ea17cb3b2b9ec99$var$_createForOfIteratorHelperLoose(this.muNamedWidget.list.columns), _step; !(_step = _iterator()).done;){
            const ci = _step.value;
            ci.isFiltered = filterFields.includes(ci.field);
            ci.isOrdered = this.orderBy.field === ci.field ? this.orderBy.dir : null;
        }
        const res = await this.getListData(forExport);
        this.muNamedWidget.list.data = res.list;
        this.muNamedWidget.pager?.setItemCount(res.fullCount);
        this.muNamedWidget.list.render(!forExport);
    }
    afterIndex() {
        setTimeout(()=>this.loadList(), 10);
    }
    pager_changePage() {
        this.loadList();
    }
    bExport_click() {
        this.exportList();
    }
    bFilterErase_click() {
        this.ui.cFulltext.value = "";
        this.setFilter({});
        this.loadList();
    }
    async exportList() {
        await this.loadList(true);
        const wb = $1GQhJ.utils.table_to_book(this.ui.list, {
            sheet: "sheet1"
        });
        // XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'base64' });
        $1GQhJ.writeFile(wb, (0, $kwZWC.webalizeString)(this.ui.label.innerText + " " + (0, $kwZWC.formatDate)("Y-m-d H:i", new Date())) + ".xlsx", {
            compression: true
        });
        await this.loadList(false);
    }
    constructor(...args){
        super(...args);
        this.filter = {};
        this.orderBy = {
            dir: "desc",
            field: "id"
        };
    }
}

});
parcelRegister("1GQhJ", function(module, exports) {

$parcel$export(module.exports, "writeFile", () => $1d9233f60ebd1a44$export$552bfb764b5cd2b4);
$parcel$export(module.exports, "utils", () => $1d9233f60ebd1a44$export$eab97d15b1788b8d);
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $foUwZ = parcelRequire("foUwZ");
var $1d9233f60ebd1a44$require$Buffer = $foUwZ.Buffer;

var $foUwZ = parcelRequire("foUwZ");
var $1d9233f60ebd1a44$var$XLSX = {};
$1d9233f60ebd1a44$var$XLSX.version = "0.19.2";
var $1d9233f60ebd1a44$var$current_codepage = 1200, $1d9233f60ebd1a44$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $1d9233f60ebd1a44$var$$cptable;
var $1d9233f60ebd1a44$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $1d9233f60ebd1a44$var$CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $1d9233f60ebd1a44$var$set_ansi = function(cp /*:number*/ ) {
    if ($1d9233f60ebd1a44$var$VALID_ANSI.indexOf(cp) == -1) return;
    $1d9233f60ebd1a44$var$current_ansi = $1d9233f60ebd1a44$var$CS2CP[0] = cp;
};
function $1d9233f60ebd1a44$var$reset_ansi() {
    $1d9233f60ebd1a44$var$set_ansi(1252);
}
var $1d9233f60ebd1a44$var$set_cp = function(cp /*:number*/ ) {
    $1d9233f60ebd1a44$var$current_codepage = cp;
    $1d9233f60ebd1a44$var$set_ansi(cp);
};
function $1d9233f60ebd1a44$var$reset_cp() {
    $1d9233f60ebd1a44$var$set_cp(1200);
    $1d9233f60ebd1a44$var$reset_ansi();
}
function $1d9233f60ebd1a44$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $1d9233f60ebd1a44$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $1d9233f60ebd1a44$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $1d9233f60ebd1a44$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $1d9233f60ebd1a44$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $1d9233f60ebd1a44$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $1d9233f60ebd1a44$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $1d9233f60ebd1a44$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $1d9233f60ebd1a44$export$58f247d16f363b86(cptable) {
    $1d9233f60ebd1a44$var$$cptable = cptable;
    $1d9233f60ebd1a44$var$set_cp = function(cp /*:number*/ ) {
        $1d9233f60ebd1a44$var$current_codepage = cp;
        $1d9233f60ebd1a44$var$set_ansi(cp);
    };
    $1d9233f60ebd1a44$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $1d9233f60ebd1a44$var$$cptable.utils.decode(1200, $1d9233f60ebd1a44$var$char_codes(data.slice(2)));
        return data;
    };
    $1d9233f60ebd1a44$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($1d9233f60ebd1a44$var$current_codepage === 1200) return String.fromCharCode(x);
        return $1d9233f60ebd1a44$var$$cptable.utils.decode($1d9233f60ebd1a44$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $1d9233f60ebd1a44$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $1d9233f60ebd1a44$var$$cptable.utils.decode($1d9233f60ebd1a44$var$current_ansi, [
            x
        ])[0];
    };
    $1d9233f60ebd1a44$var$cpdoit();
}
var $1d9233f60ebd1a44$var$DENSE = null;
var $1d9233f60ebd1a44$var$DIF_XL = true;
var $1d9233f60ebd1a44$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $1d9233f60ebd1a44$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $1d9233f60ebd1a44$var$Base64_map.charAt(e1) + $1d9233f60ebd1a44$var$Base64_map.charAt(e2) + $1d9233f60ebd1a44$var$Base64_map.charAt(e3) + $1d9233f60ebd1a44$var$Base64_map.charAt(e4);
    }
    return o;
}
function $1d9233f60ebd1a44$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $1d9233f60ebd1a44$var$Base64_map.charAt(e1) + $1d9233f60ebd1a44$var$Base64_map.charAt(e2) + $1d9233f60ebd1a44$var$Base64_map.charAt(e3) + $1d9233f60ebd1a44$var$Base64_map.charAt(e4);
    }
    return o;
}
function $1d9233f60ebd1a44$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/^data:([^\/]+\/[^\/]+)?;base64\,/, "").replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $1d9233f60ebd1a44$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $1d9233f60ebd1a44$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $1d9233f60ebd1a44$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $1d9233f60ebd1a44$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $1d9233f60ebd1a44$var$has_buf = /*#__PURE__*/ function() {
    return typeof $1d9233f60ebd1a44$require$Buffer !== "undefined" && typeof $foUwZ !== "undefined" && typeof $foUwZ.versions !== "undefined" && !!$foUwZ.versions.node;
}();
var $1d9233f60ebd1a44$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $1d9233f60ebd1a44$require$Buffer !== "undefined") {
        var nbfs = !$1d9233f60ebd1a44$require$Buffer.from;
        if (!nbfs) try {
            $1d9233f60ebd1a44$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $1d9233f60ebd1a44$require$Buffer(buf, enc) : new $1d9233f60ebd1a44$require$Buffer(buf);
        } : $1d9233f60ebd1a44$require$Buffer.from.bind($1d9233f60ebd1a44$require$Buffer);
    }
    return function() {};
}();
var $1d9233f60ebd1a44$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $1d9233f60ebd1a44$require$Buffer === "undefined") return false;
    var x = $1d9233f60ebd1a44$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $1d9233f60ebd1a44$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$require$Buffer.alloc ? $1d9233f60ebd1a44$require$Buffer.alloc(len) : new $1d9233f60ebd1a44$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $1d9233f60ebd1a44$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$require$Buffer.allocUnsafe ? $1d9233f60ebd1a44$require$Buffer.allocUnsafe(len) : new $1d9233f60ebd1a44$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $1d9233f60ebd1a44$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $1d9233f60ebd1a44$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === "undefined") return $1d9233f60ebd1a44$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $1d9233f60ebd1a44$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $1d9233f60ebd1a44$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === "undefined") throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $1d9233f60ebd1a44$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == "undefined") throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $1d9233f60ebd1a44$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $1d9233f60ebd1a44$var$bconcat = $1d9233f60ebd1a44$var$has_buf ? function(bufs) {
    return $1d9233f60ebd1a44$require$Buffer.concat(bufs.map(function(buf) {
        return $1d9233f60ebd1a44$require$Buffer.isBuffer(buf) ? buf : $1d9233f60ebd1a44$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($1d9233f60ebd1a44$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $1d9233f60ebd1a44$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $1d9233f60ebd1a44$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $1d9233f60ebd1a44$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $1d9233f60ebd1a44$var$bconcat(out);
}
var $1d9233f60ebd1a44$var$chr0 = /\u0000/g, $1d9233f60ebd1a44$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $1d9233f60ebd1a44$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $1d9233f60ebd1a44$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $1d9233f60ebd1a44$var$fill("0", d - t.length) + t;
}
function $1d9233f60ebd1a44$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $1d9233f60ebd1a44$var$fill(" ", d - t.length) + t;
}
function $1d9233f60ebd1a44$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $1d9233f60ebd1a44$var$fill(" ", d - t.length);
}
function $1d9233f60ebd1a44$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $1d9233f60ebd1a44$var$fill("0", d - t.length) + t;
}
function $1d9233f60ebd1a44$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $1d9233f60ebd1a44$var$fill("0", d - t.length) + t;
}
var $1d9233f60ebd1a44$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $1d9233f60ebd1a44$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $1d9233f60ebd1a44$var$p2_32 || v < -$1d9233f60ebd1a44$var$p2_32) return $1d9233f60ebd1a44$var$pad0r1(v, d);
    var i = Math.round(v);
    return $1d9233f60ebd1a44$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $1d9233f60ebd1a44$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $1d9233f60ebd1a44$var$days /*:Array<Array<string> >*/  = [
    [
        "Sun",
        "Sunday"
    ],
    [
        "Mon",
        "Monday"
    ],
    [
        "Tue",
        "Tuesday"
    ],
    [
        "Wed",
        "Wednesday"
    ],
    [
        "Thu",
        "Thursday"
    ],
    [
        "Fri",
        "Friday"
    ],
    [
        "Sat",
        "Saturday"
    ]
];
var $1d9233f60ebd1a44$var$months /*:Array<Array<string> >*/  = [
    [
        "J",
        "Jan",
        "January"
    ],
    [
        "F",
        "Feb",
        "February"
    ],
    [
        "M",
        "Mar",
        "March"
    ],
    [
        "A",
        "Apr",
        "April"
    ],
    [
        "M",
        "May",
        "May"
    ],
    [
        "J",
        "Jun",
        "June"
    ],
    [
        "J",
        "Jul",
        "July"
    ],
    [
        "A",
        "Aug",
        "August"
    ],
    [
        "S",
        "Sep",
        "September"
    ],
    [
        "O",
        "Oct",
        "October"
    ],
    [
        "N",
        "Nov",
        "November"
    ],
    [
        "D",
        "Dec",
        "December"
    ]
];
function $1d9233f60ebd1a44$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = "General";
    t[1] = "0";
    t[2] = "0.00";
    t[3] = "#,##0";
    t[4] = "#,##0.00";
    t[9] = "0%";
    t[10] = "0.00%";
    t[11] = "0.00E+00";
    t[12] = "# ?/?";
    t[13] = "# ??/??";
    t[14] = "m/d/yy";
    t[15] = "d-mmm-yy";
    t[16] = "d-mmm";
    t[17] = "mmm-yy";
    t[18] = "h:mm AM/PM";
    t[19] = "h:mm:ss AM/PM";
    t[20] = "h:mm";
    t[21] = "h:mm:ss";
    t[22] = "m/d/yy h:mm";
    t[37] = "#,##0 ;(#,##0)";
    t[38] = "#,##0 ;[Red](#,##0)";
    t[39] = "#,##0.00;(#,##0.00)";
    t[40] = "#,##0.00;[Red](#,##0.00)";
    t[45] = "mm:ss";
    t[46] = "[h]:mm:ss";
    t[47] = "mmss.0";
    t[48] = "##0.0E+0";
    t[49] = "@";
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $1d9233f60ebd1a44$var$table_fmt = {
    0: "General",
    1: "0",
    2: "0.00",
    3: "#,##0",
    4: "#,##0.00",
    9: "0%",
    10: "0.00%",
    11: "0.00E+00",
    12: "# ?/?",
    13: "# ??/??",
    14: "m/d/yy",
    15: "d-mmm-yy",
    16: "d-mmm",
    17: "mmm-yy",
    18: "h:mm AM/PM",
    19: "h:mm:ss AM/PM",
    20: "h:mm",
    21: "h:mm:ss",
    22: "m/d/yy h:mm",
    37: "#,##0 ;(#,##0)",
    38: "#,##0 ;[Red](#,##0)",
    39: "#,##0.00;(#,##0.00)",
    40: "#,##0.00;[Red](#,##0.00)",
    45: "mm:ss",
    46: "[h]:mm:ss",
    47: "mmss.0",
    48: "##0.0E+0",
    49: "@",
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $1d9233f60ebd1a44$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $1d9233f60ebd1a44$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $1d9233f60ebd1a44$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $1d9233f60ebd1a44$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $1d9233f60ebd1a44$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var $1d9233f60ebd1a44$var$SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var $1d9233f60ebd1a44$var$SSFdnthresh = /*#__PURE__*/ $1d9233f60ebd1a44$var$SSFbasedate.getTime();
var $1d9233f60ebd1a44$var$SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function $1d9233f60ebd1a44$var$datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= $1d9233f60ebd1a44$var$SSFbase1904) epoch += 86400000;
    return (epoch - ($1d9233f60ebd1a44$var$SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $1d9233f60ebd1a44$var$SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $1d9233f60ebd1a44$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $1d9233f60ebd1a44$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $1d9233f60ebd1a44$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $1d9233f60ebd1a44$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $1d9233f60ebd1a44$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $1d9233f60ebd1a44$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $1d9233f60ebd1a44$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $1d9233f60ebd1a44$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $1d9233f60ebd1a44$var$SSF_large_exp(v);
    return $1d9233f60ebd1a44$var$SSF_strip_decimal($1d9233f60ebd1a44$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $1d9233f60ebd1a44$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "TRUE" : "FALSE";
        case "number":
            return (v | 0) === v ? v.toString(10) : $1d9233f60ebd1a44$var$SSF_general_num(v);
        case "undefined":
            return "";
        case "object":
            if (v == null) return "";
            if (v instanceof Date) return $1d9233f60ebd1a44$var$SSF_format(14, $1d9233f60ebd1a44$var$datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $1d9233f60ebd1a44$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $1d9233f60ebd1a44$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $1d9233f60ebd1a44$var$months[val.m - 1][1];
                case 5:
                    return $1d9233f60ebd1a44$var$months[val.m - 1][0];
                default:
                    return $1d9233f60ebd1a44$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $1d9233f60ebd1a44$var$days[val.q][0];
                default:
                    return $1d9233f60ebd1a44$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad minute format: " + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != "s" && fmt != "ss" && fmt != ".0" && fmt != ".00" && fmt != ".000") throw "bad second format: " + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $1d9233f60ebd1a44$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
            o = $1d9233f60ebd1a44$var$pad0(ss, 2 + ss0);
            if (fmt === "ss") return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case "[h]":
                case "[hh]":
                    out = val.D * 24 + val.H;
                    break;
                case "[m]":
                case "[mm]":
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case "[s]":
                case "[ss]":
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw "bad abstime format: " + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $1d9233f60ebd1a44$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $1d9233f60ebd1a44$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $1d9233f60ebd1a44$var$pct1 = /%/g;
function $1d9233f60ebd1a44$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($1d9233f60ebd1a44$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $1d9233f60ebd1a44$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $1d9233f60ebd1a44$var$fill("%", mul);
}
function $1d9233f60ebd1a44$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $1d9233f60ebd1a44$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $1d9233f60ebd1a44$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $1d9233f60ebd1a44$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $1d9233f60ebd1a44$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $1d9233f60ebd1a44$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $1d9233f60ebd1a44$var$fill(" ", r[1].length + 1 + r[4].length) : $1d9233f60ebd1a44$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $1d9233f60ebd1a44$var$pad0(myd, r[4].length));
}
function $1d9233f60ebd1a44$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $1d9233f60ebd1a44$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $1d9233f60ebd1a44$var$dec1 = /^#*0*\.([0#]+)/;
var $1d9233f60ebd1a44$var$closeparen = /\).*[0#]/;
var $1d9233f60ebd1a44$var$phone = /\(###\) ###\\?-####/;
function $1d9233f60ebd1a44$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $1d9233f60ebd1a44$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $1d9233f60ebd1a44$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ("" + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $1d9233f60ebd1a44$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ("" + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $1d9233f60ebd1a44$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $1d9233f60ebd1a44$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($1d9233f60ebd1a44$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $1d9233f60ebd1a44$var$write_num_flt("n", ffmt, val);
        return "(" + $1d9233f60ebd1a44$var$write_num_flt("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $1d9233f60ebd1a44$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $1d9233f60ebd1a44$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $1d9233f60ebd1a44$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $1d9233f60ebd1a44$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $1d9233f60ebd1a44$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $1d9233f60ebd1a44$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $1d9233f60ebd1a44$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($1d9233f60ebd1a44$var$frac1)) return $1d9233f60ebd1a44$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $1d9233f60ebd1a44$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($1d9233f60ebd1a44$var$dec1)) {
        o = $1d9233f60ebd1a44$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $1d9233f60ebd1a44$var$hashq(r[1])).replace(/\.$/, "." + $1d9233f60ebd1a44$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $1d9233f60ebd1a44$var$fill("0", $1d9233f60ebd1a44$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $1d9233f60ebd1a44$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $1d9233f60ebd1a44$var$commaify($1d9233f60ebd1a44$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $1d9233f60ebd1a44$var$write_num_flt(type, fmt, -val) : $1d9233f60ebd1a44$var$commaify("" + (Math.floor(val) + $1d9233f60ebd1a44$var$carry(val, r[1].length))) + "." + $1d9233f60ebd1a44$var$pad0($1d9233f60ebd1a44$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $1d9233f60ebd1a44$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $1d9233f60ebd1a44$var$_strrev($1d9233f60ebd1a44$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $1d9233f60ebd1a44$var$_strrev($1d9233f60ebd1a44$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($1d9233f60ebd1a44$var$phone)) {
        o = $1d9233f60ebd1a44$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $1d9233f60ebd1a44$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $1d9233f60ebd1a44$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $1d9233f60ebd1a44$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $1d9233f60ebd1a44$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $1d9233f60ebd1a44$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $1d9233f60ebd1a44$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $1d9233f60ebd1a44$var$rpad_(ff[2], ri) : $1d9233f60ebd1a44$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $1d9233f60ebd1a44$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $1d9233f60ebd1a44$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $1d9233f60ebd1a44$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $1d9233f60ebd1a44$var$dec(val, r[1].length);
        return val < 0 ? "-" + $1d9233f60ebd1a44$var$write_num_flt(type, fmt, -val) : $1d9233f60ebd1a44$var$commaify($1d9233f60ebd1a44$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $1d9233f60ebd1a44$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $1d9233f60ebd1a44$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $1d9233f60ebd1a44$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $1d9233f60ebd1a44$var$commaify($1d9233f60ebd1a44$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $1d9233f60ebd1a44$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $1d9233f60ebd1a44$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $1d9233f60ebd1a44$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $1d9233f60ebd1a44$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $1d9233f60ebd1a44$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($1d9233f60ebd1a44$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $1d9233f60ebd1a44$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $1d9233f60ebd1a44$var$fill("%", mul);
}
function $1d9233f60ebd1a44$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $1d9233f60ebd1a44$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $1d9233f60ebd1a44$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($1d9233f60ebd1a44$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $1d9233f60ebd1a44$var$write_num_int("n", ffmt, val);
        return "(" + $1d9233f60ebd1a44$var$write_num_int("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $1d9233f60ebd1a44$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $1d9233f60ebd1a44$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $1d9233f60ebd1a44$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $1d9233f60ebd1a44$var$write_num_int(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $1d9233f60ebd1a44$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $1d9233f60ebd1a44$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($1d9233f60ebd1a44$var$frac1)) return $1d9233f60ebd1a44$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $1d9233f60ebd1a44$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($1d9233f60ebd1a44$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $1d9233f60ebd1a44$var$hashq(r[1])).replace(/\.$/, "." + $1d9233f60ebd1a44$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $1d9233f60ebd1a44$var$fill("0", $1d9233f60ebd1a44$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $1d9233f60ebd1a44$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $1d9233f60ebd1a44$var$write_num_int(type, fmt, -val) : $1d9233f60ebd1a44$var$commaify("" + val) + "." + $1d9233f60ebd1a44$var$fill("0", r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $1d9233f60ebd1a44$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $1d9233f60ebd1a44$var$_strrev($1d9233f60ebd1a44$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $1d9233f60ebd1a44$var$_strrev($1d9233f60ebd1a44$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($1d9233f60ebd1a44$var$phone)) {
        o = $1d9233f60ebd1a44$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $1d9233f60ebd1a44$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $1d9233f60ebd1a44$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $1d9233f60ebd1a44$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $1d9233f60ebd1a44$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $1d9233f60ebd1a44$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $1d9233f60ebd1a44$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $1d9233f60ebd1a44$var$rpad_(ff[2], ri) : $1d9233f60ebd1a44$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $1d9233f60ebd1a44$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $1d9233f60ebd1a44$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $1d9233f60ebd1a44$var$write_num_int(type, fmt, -val) : $1d9233f60ebd1a44$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $1d9233f60ebd1a44$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $1d9233f60ebd1a44$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $1d9233f60ebd1a44$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $1d9233f60ebd1a44$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $1d9233f60ebd1a44$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $1d9233f60ebd1a44$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $1d9233f60ebd1a44$var$write_num_int(type, fmt, val) : $1d9233f60ebd1a44$var$write_num_flt(type, fmt, val);
}
function $1d9233f60ebd1a44$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $1d9233f60ebd1a44$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $1d9233f60ebd1a44$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            if ($1d9233f60ebd1a44$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case "\\":
            i += 2;
            break;
        case "_":
            i += 2;
            break;
        case "@":
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            return true;
        case "A":
        case "a":
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.match($1d9233f60ebd1a44$var$SSF_abstime)) return true;
            break;
        case ".":
        /* falls through */ case "0":
        case "#":
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == "\\" && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case "?":
            while(fmt.charAt(++i) === c);
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break;
        case "(":
        case ")":
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case " ":
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $1d9233f60ebd1a44$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = "t", dt, j, cc;
    var hr = "H";
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            /* General */ if (!$1d9233f60ebd1a44$var$SSF_isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "G",
                v: "General"
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: "t",
                v: o
            };
            ++i;
            break;
        case "\\":
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : "t";
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case "_":
            out[out.length] = {
                t: "t",
                v: " "
            };
            i += 2;
            break;
        case "@":
            /* Text Placeholder */ out[out.length] = {
                t: "T",
                v: v
            };
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $1d9233f60ebd1a44$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "X",
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
            c = c.toLowerCase();
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            if (v < 0) return "";
            if (dt == null) {
                dt = $1d9233f60ebd1a44$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === "m" && lst.toLowerCase() === "h") c = "M";
            if (c === "h") c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "A":
        case "a":
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $1d9233f60ebd1a44$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = "T";
                hr = "h";
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = "T";
                i += 5;
                hr = "h";
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = "T";
                i += 5;
                hr = "h";
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === "T") return "";
            out[out.length] = q;
            lst = c;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";
            if (o.match($1d9233f60ebd1a44$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $1d9233f60ebd1a44$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "Z",
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$1d9233f60ebd1a44$var$fmt_is_date(fmt)) out[out.length] = {
                    t: "t",
                    v: o
                };
            }
            break;
        /* Numbers */ case ".":
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: "s",
                    v: o
                };
                break;
            }
        /* falls through */ case "0":
        case "#":
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: "n",
                v: o
            };
            break;
        case "?":
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break; // **
        case "(":
        case ")":
            out[out.length] = {
                t: flen === 1 ? "t" : c,
                v: c
            };
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: "D",
                v: o
            };
            break;
        case " ":
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case "$":
            out[out.length] = {
                t: "t",
                v: "$"
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "t",
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = "t"; i >= 0; --i)switch(out[i].t){
        case "h":
        case "H":
            out[i].t = hr;
            lst = "h";
            if (bt < 1) bt = 1;
            break;
        case "s":
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case "d":
        case "y":
        case "M":
        case "e":
            lst = out[i].t;
            break;
        case "m":
            if (lst === "s") {
                out[i].t = "M";
                if (bt < 2) bt = 2;
            }
            break;
        case "X":
            break;
        case "Z":
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case "t":
        case "T":
        case " ":
        case "D":
            break;
        case "X":
            out[i].v = "";
            out[i].t = ";";
            break;
        case "d":
        case "m":
        case "y":
        case "h":
        case "H":
        case "M":
        case "s":
        case "e":
        case "b":
        case "Z":
            /*::if(!dt) throw "unreachable"; */ out[i].v = $1d9233f60ebd1a44$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = "t";
            break;
        case "n":
        case "?":
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case "G":
            out[i].t = "t";
            out[i].v = $1d9233f60ebd1a44$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $1d9233f60ebd1a44$var$write_num("n", nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $1d9233f60ebd1a44$var$write_num("n", nstr, myv);
            if (myv < 0 && out[0] && out[0].t == "t") {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != "t" && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && "n?".indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $1d9233f60ebd1a44$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = "t";
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $1d9233f60ebd1a44$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $1d9233f60ebd1a44$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $1d9233f60ebd1a44$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $1d9233f60ebd1a44$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($1d9233f60ebd1a44$var$cfregex2);
        var m2 = fmt[1].match($1d9233f60ebd1a44$var$cfregex2);
        return $1d9233f60ebd1a44$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $1d9233f60ebd1a44$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $1d9233f60ebd1a44$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $1d9233f60ebd1a44$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$1d9233f60ebd1a44$var$SSF_default_map[fmt]] || $1d9233f60ebd1a44$var$table_fmt[$1d9233f60ebd1a44$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $1d9233f60ebd1a44$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($1d9233f60ebd1a44$var$SSF_isgeneral(sfmt, 0)) return $1d9233f60ebd1a44$var$SSF_general(v, o);
    if (v instanceof Date) v = $1d9233f60ebd1a44$var$datenum_local(v, o.date1904);
    var f = $1d9233f60ebd1a44$var$choose_fmt(sfmt, v);
    if ($1d9233f60ebd1a44$var$SSF_isgeneral(f[1])) return $1d9233f60ebd1a44$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $1d9233f60ebd1a44$var$eval_fmt(f[1], v, o, f[0]);
}
function $1d9233f60ebd1a44$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != "number") {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($1d9233f60ebd1a44$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($1d9233f60ebd1a44$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $1d9233f60ebd1a44$var$table_fmt[idx] = fmt;
    return idx;
}
function $1d9233f60ebd1a44$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $1d9233f60ebd1a44$var$SSF_load(tbl[i], i);
}
function $1d9233f60ebd1a44$var$make_ssf() {
    $1d9233f60ebd1a44$var$table_fmt = $1d9233f60ebd1a44$var$SSF_init_table();
}
var $1d9233f60ebd1a44$export$40d8edd678456c2b = {
    format: $1d9233f60ebd1a44$var$SSF_format,
    load: $1d9233f60ebd1a44$var$SSF_load,
    _table: $1d9233f60ebd1a44$var$table_fmt,
    load_table: $1d9233f60ebd1a44$var$SSF_load_table,
    parse_date_code: $1d9233f60ebd1a44$var$SSF_parse_date_code,
    is_date: $1d9233f60ebd1a44$var$fmt_is_date,
    get_table: function get_table() {
        return $1d9233f60ebd1a44$export$40d8edd678456c2b._table = $1d9233f60ebd1a44$var$table_fmt;
    }
};
var $1d9233f60ebd1a44$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": "General",
    "24": "General",
    "25": "General",
    "26": "General",
    "27": "m/d/yy",
    "28": "m/d/yy",
    "29": "m/d/yy",
    "30": "m/d/yy",
    "31": "m/d/yy",
    "32": "h:mm:ss",
    "33": "h:mm:ss",
    "34": "h:mm:ss",
    "35": "h:mm:ss",
    "36": "m/d/yy",
    "41": '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    "50": "m/d/yy",
    "51": "m/d/yy",
    "52": "m/d/yy",
    "53": "m/d/yy",
    "54": "m/d/yy",
    "55": "m/d/yy",
    "56": "m/d/yy",
    "57": "m/d/yy",
    "58": "m/d/yy",
    "59": "0",
    "60": "0.00",
    "61": "#,##0",
    "62": "#,##0.00",
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": "0%",
    "68": "0.00%",
    "69": "# ?/?",
    "70": "# ??/??",
    "71": "m/d/yy",
    "72": "m/d/yy",
    "73": "d-mmm-yy",
    "74": "d-mmm",
    "75": "mmm-yy",
    "76": "h:mm",
    "77": "h:mm:ss",
    "78": "m/d/yy h:mm",
    "79": "mm:ss",
    "80": "[h]:mm:ss",
    "81": "mmss.0"
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $1d9233f60ebd1a44$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $1d9233f60ebd1a44$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $1d9233f60ebd1a44$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($1d9233f60ebd1a44$var$dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function $1d9233f60ebd1a44$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($1d9233f60ebd1a44$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case "y":
                Y = v;
                break;
            case "d":
                d = v;
                break;
            case "h":
                H = v;
                break;
            case "s":
                S = v;
                break;
            case "m":
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $1d9233f60ebd1a44$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $1d9233f60ebd1a44$var$SSF__load(fmt, idx) {
    return $1d9233f60ebd1a44$var$SSF_load($1d9233f60ebd1a44$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $1d9233f60ebd1a44$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = "1.2.0";
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== "undefined" ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== "undefined" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $1d9233f60ebd1a44$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = "1.2.2";
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $1d9233f60ebd1a44$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $1d9233f60ebd1a44$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $1d9233f60ebd1a44$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $1d9233f60ebd1a44$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, "i");
        if (mver === 3 && dir_cnt !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, "i");
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk("00100000", "Mini Stream Cutoff Size: ");
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, "i");
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, "i");
        // First DIFAT sector location
        difat_start = blob.read_shift(4, "i");
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, "i");
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, "i");
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, "Header Signature: ");
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, "u");
        return [
            blob.read_shift(2, "u"),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error("Sector Shift: Expected 9 saw " + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error("Sector Shift: Expected 12 saw " + shift);
                break;
            default:
                throw new Error("Sector Shift: Expected 9 or 12 saw " + shift);
        }
        // Mini Sector Shift
        blob.chk("0600", "Mini Sector Shift: ");
        // Reserved
        blob.chk("000000000000", "Reserved: ");
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $1d9233f60ebd1a44$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $1d9233f60ebd1a44$var$new_buf(0);
        return $1d9233f60ebd1a44$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $1d9233f60ebd1a44$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($1d9233f60ebd1a44$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $1d9233f60ebd1a44$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $1d9233f60ebd1a44$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $1d9233f60ebd1a44$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $1d9233f60ebd1a44$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $1d9233f60ebd1a44$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $1d9233f60ebd1a44$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, "i"),
                R: blob.read_shift(4, "i"),
                C: blob.read_shift(4, "i"),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, "i"),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, "i");
            o.size = blob.read_shift(4, "i");
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = "fat";
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = "minifat";
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $1d9233f60ebd1a44$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($1d9233f60ebd1a44$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $1d9233f60ebd1a44$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($1d9233f60ebd1a44$var$s2a($1d9233f60ebd1a44$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($1d9233f60ebd1a44$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\x01Sh33tJ5";
        if ($1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $1d9233f60ebd1a44$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == "mad") return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case "zip":
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $1d9233f60ebd1a44$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 32) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 32));
                _nm = _nm.slice(0, 32);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($1d9233f60ebd1a44$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($1d9233f60ebd1a44$var$chr1);
        UCPath = UCPath.replace($1d9233f60ebd1a44$var$chr0, "");
        if (m) UCPath = UCPath.replace($1d9233f60ebd1a44$var$chr1, "!");
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($1d9233f60ebd1a44$var$chr1, "!") : UCFullPaths[w]).replace($1d9233f60ebd1a44$var$chr0, "") == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($1d9233f60ebd1a44$var$chr1, "!") : UCPaths[w]).replace($1d9233f60ebd1a44$var$chr0, "") == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = "d0cf11e0a1b11ae1";
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = "00000000000000000000000000000000";
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: "3e00",
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            "unknown",
            "storage",
            "stream",
            "lockbytes",
            "property",
            "root"
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $1d9233f60ebd1a44$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$require$Buffer.isBuffer(o) ? o : $1d9233f60ebd1a44$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $1d9233f60ebd1a44$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== "undefined";
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($1d9233f60ebd1a44$var$has_buf) {
            var o = $1d9233f60ebd1a44$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $1d9233f60ebd1a44$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $1d9233f60ebd1a44$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $1d9233f60ebd1a44$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== "undefined") console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $1d9233f60ebd1a44$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = ef[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $1d9233f60ebd1a44$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $1d9233f60ebd1a44$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $1d9233f60ebd1a44$var$CRC32.bstr(fi.content, 0) : $1d9233f60ebd1a44$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $1d9233f60ebd1a44$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $1d9233f60ebd1a44$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $1d9233f60ebd1a44$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $1d9233f60ebd1a44$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $1d9233f60ebd1a44$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $1d9233f60ebd1a44$var$bconcat([
            $1d9233f60ebd1a44$var$bconcat(out /*:any*/ ),
            $1d9233f60ebd1a44$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $1d9233f60ebd1a44$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $1d9233f60ebd1a44$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case "base64":
                fdata = $1d9233f60ebd1a44$var$s2a($1d9233f60ebd1a44$var$Base64_decode(data.slice(di).join("")));
                break;
            case "quoted-printable":
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = "------=" + boundary;
        var out = [
            "MIME-Version: 1.0",
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            "",
            "",
            ""
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push("Content-Location: " + (opts.root || "file:///C:/SheetJS/") + fp);
            out.push("Content-Transfer-Encoding: " + (qp ? "quoted-printable" : "base64"));
            out.push("Content-Type: " + get_content_type(fi, fp));
            out.push("");
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + "--\r\n");
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $1d9233f60ebd1a44$var$ReadShift,
        CheckField: $1d9233f60ebd1a44$var$CheckField,
        prep_blob: $1d9233f60ebd1a44$var$prep_blob,
        bconcat: $1d9233f60ebd1a44$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $1d9233f60ebd1a44$var$_fs;
function $1d9233f60ebd1a44$export$a48eb669e1768bcf(fs) {
    $1d9233f60ebd1a44$var$_fs = fs;
}
/* normalize data for blob ctor */ function $1d9233f60ebd1a44$var$blobify(data) {
    if (typeof data === "string") return $1d9233f60ebd1a44$var$s2ab(data);
    if (Array.isArray(data)) return $1d9233f60ebd1a44$var$a2u(data);
    return data;
}
/* write or download file */ function $1d9233f60ebd1a44$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $1d9233f60ebd1a44$var$_fs !== "undefined" && $1d9233f60ebd1a44$var$_fs.writeFileSync) return enc ? $1d9233f60ebd1a44$var$_fs.writeFileSync(fname, payload, enc) : $1d9233f60ebd1a44$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== "undefined") {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $1d9233f60ebd1a44$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $1d9233f60ebd1a44$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== "undefined") return IE_SaveFile(data, fname);
    if (typeof Blob !== "undefined") {
        var blob = new Blob([
            $1d9233f60ebd1a44$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== "undefined" && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== "undefined") return saveAs(blob, fname);
        if (typeof URL !== "undefined" && typeof document !== "undefined" && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === "object" && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $1d9233f60ebd1a44$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $1d9233f60ebd1a44$var$read_binary(path /*:string*/ ) {
    if (typeof $1d9233f60ebd1a44$var$_fs !== "undefined") return $1d9233f60ebd1a44$var$_fs.readFileSync(path);
    if (typeof Deno !== "undefined") return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $1d9233f60ebd1a44$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $1d9233f60ebd1a44$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $1d9233f60ebd1a44$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $1d9233f60ebd1a44$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $1d9233f60ebd1a44$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $1d9233f60ebd1a44$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $1d9233f60ebd1a44$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $1d9233f60ebd1a44$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $1d9233f60ebd1a44$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $1d9233f60ebd1a44$var$basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function $1d9233f60ebd1a44$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ $1d9233f60ebd1a44$var$basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $1d9233f60ebd1a44$var$basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var $1d9233f60ebd1a44$var$refdate = /*#__PURE__*/ new Date();
var $1d9233f60ebd1a44$var$dnthresh = /*#__PURE__*/ $1d9233f60ebd1a44$var$basedate.getTime() + /*#__PURE__*/ ($1d9233f60ebd1a44$var$refdate.getTimezoneOffset() - /*#__PURE__*/ $1d9233f60ebd1a44$var$basedate.getTimezoneOffset()) * 60000;
var $1d9233f60ebd1a44$var$refoffset = /*#__PURE__*/ $1d9233f60ebd1a44$var$refdate.getTimezoneOffset();
function $1d9233f60ebd1a44$var$numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + $1d9233f60ebd1a44$var$dnthresh);
    if (out.getTimezoneOffset() !== $1d9233f60ebd1a44$var$refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - $1d9233f60ebd1a44$var$refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function $1d9233f60ebd1a44$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case "Y":
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case "D":
                mt *= 24;
            /* falls through */ case "H":
                mt *= 60;
            /* falls through */ case "M":
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case "S":
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var $1d9233f60ebd1a44$var$good_pd_date_1 = /*#__PURE__*/ new Date("2017-02-19T19:06:09.000Z");
var $1d9233f60ebd1a44$var$good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ $1d9233f60ebd1a44$var$good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date("2/19/17") : $1d9233f60ebd1a44$var$good_pd_date_1;
var $1d9233f60ebd1a44$var$good_pd = /*#__PURE__*/ $1d9233f60ebd1a44$var$good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function $1d9233f60ebd1a44$var$parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if ($1d9233f60ebd1a44$var$good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if ($1d9233f60ebd1a44$var$good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function $1d9233f60ebd1a44$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(arr)) {
        if (debomit && $1d9233f60ebd1a44$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $1d9233f60ebd1a44$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $1d9233f60ebd1a44$var$utf8write($1d9233f60ebd1a44$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $1d9233f60ebd1a44$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $1d9233f60ebd1a44$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20AC": "\x80",
            "\u201A": "\x82",
            "\u0192": "\x83",
            "\u201E": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02C6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017D": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201C": "\x93",
            "\u201D": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02DC": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203A": "\x9b",
            "\u0153": "\x9c",
            "\u017E": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function $1d9233f60ebd1a44$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != "undefined" && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != "object" || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $1d9233f60ebd1a44$var$dup(o[k]);
    return out;
}
function $1d9233f60ebd1a44$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $1d9233f60ebd1a44$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $1d9233f60ebd1a44$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
function $1d9233f60ebd1a44$var$fuzzytime1(M) /*:Date*/ {
    /* TODO: 1904 adjustment, keep in sync with base date */ if (!M[2]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0);
    if (M[3]) {
        if (M[4]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000);
        else return new Date(1899, 11, 30, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000);
    } else if (M[5]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0);
    else return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0);
}
var $1d9233f60ebd1a44$var$lower_months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $1d9233f60ebd1a44$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($1d9233f60ebd1a44$var$FDRE1);
    if (M) return $1d9233f60ebd1a44$var$fuzzytime1(M);
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $1d9233f60ebd1a44$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var $1d9233f60ebd1a44$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $1d9233f60ebd1a44$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $1d9233f60ebd1a44$var$cc2str(data.content, true);
    if (data.data) return $1d9233f60ebd1a44$var$debom(data.data);
    if (data.asNodeBuffer && $1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$var$debom(data.asNodeBuffer().toString("binary"));
    if (data.asBinary) return $1d9233f60ebd1a44$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $1d9233f60ebd1a44$var$debom($1d9233f60ebd1a44$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $1d9233f60ebd1a44$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $1d9233f60ebd1a44$var$char_codes(data.data);
    if (data.asNodeBuffer && $1d9233f60ebd1a44$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $1d9233f60ebd1a44$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $1d9233f60ebd1a44$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $1d9233f60ebd1a44$var$getdatabin(data) : $1d9233f60ebd1a44$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $1d9233f60ebd1a44$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $1d9233f60ebd1a44$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, "\\"), g = f.replace(/\\/g, "/");
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $1d9233f60ebd1a44$var$getzipfile(zip, file /*:string*/ ) {
    var o = $1d9233f60ebd1a44$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $1d9233f60ebd1a44$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $1d9233f60ebd1a44$var$getdata($1d9233f60ebd1a44$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $1d9233f60ebd1a44$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $1d9233f60ebd1a44$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $1d9233f60ebd1a44$var$getdatastr($1d9233f60ebd1a44$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $1d9233f60ebd1a44$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $1d9233f60ebd1a44$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $1d9233f60ebd1a44$var$getdatabin($1d9233f60ebd1a44$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $1d9233f60ebd1a44$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $1d9233f60ebd1a44$var$zipentries(zip) {
    var k = zip.FullPaths || $1d9233f60ebd1a44$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != "/") o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $1d9233f60ebd1a44$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($1d9233f60ebd1a44$var$has_buf) res = $1d9233f60ebd1a44$var$Buffer_from(content);
            else res = $1d9233f60ebd1a44$var$utf8decode(content);
            return $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $1d9233f60ebd1a44$var$zip_new() {
    return $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_new();
}
function $1d9233f60ebd1a44$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $1d9233f60ebd1a44$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $1d9233f60ebd1a44$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $1d9233f60ebd1a44$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $1d9233f60ebd1a44$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split("/");
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split("/");
    while(target.length !== 0){
        var step = target.shift();
        if (step === "..") result.pop();
        else if (step !== ".") result.push(step);
    }
    return result.join("/");
}
var $1d9233f60ebd1a44$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $1d9233f60ebd1a44$var$attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $1d9233f60ebd1a44$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, $1d9233f60ebd1a44$var$tagregex2 = /<[^>]*>/g;
var $1d9233f60ebd1a44$var$tagregex = /*#__PURE__*/ $1d9233f60ebd1a44$var$XML_HEADER.match($1d9233f60ebd1a44$var$tagregex1) ? $1d9233f60ebd1a44$var$tagregex1 : $1d9233f60ebd1a44$var$tagregex2;
var $1d9233f60ebd1a44$var$nsregex = /<\w*:/, $1d9233f60ebd1a44$var$nsregex2 = /<(\/?)\w+:/;
function $1d9233f60ebd1a44$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($1d9233f60ebd1a44$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $1d9233f60ebd1a44$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($1d9233f60ebd1a44$var$nsregex2, "<$1");
}
var $1d9233f60ebd1a44$var$encodings = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&"
};
var $1d9233f60ebd1a44$var$rencoding = /*#__PURE__*/ $1d9233f60ebd1a44$var$evert($1d9233f60ebd1a44$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $1d9233f60ebd1a44$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + "", i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $1d9233f60ebd1a44$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $1d9233f60ebd1a44$var$decregex = /[&<>'"]/g, $1d9233f60ebd1a44$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $1d9233f60ebd1a44$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($1d9233f60ebd1a44$var$decregex, function(y) {
        return $1d9233f60ebd1a44$var$rencoding[y];
    }).replace($1d9233f60ebd1a44$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $1d9233f60ebd1a44$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $1d9233f60ebd1a44$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $1d9233f60ebd1a44$var$htmlcharegex = /[\u0000-\u001f]/g;
function $1d9233f60ebd1a44$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($1d9233f60ebd1a44$var$decregex, function(y) {
        return $1d9233f60ebd1a44$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($1d9233f60ebd1a44$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $1d9233f60ebd1a44$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($1d9233f60ebd1a44$var$decregex, function(y) {
        return $1d9233f60ebd1a44$var$rencoding[y];
    }).replace($1d9233f60ebd1a44$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $1d9233f60ebd1a44$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $1d9233f60ebd1a44$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $1d9233f60ebd1a44$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case "1":
        case "true":
            return true;
        case 0:
        case false:
        case "0":
        case "false":
            return false;
    }
    return false;
}
function $1d9233f60ebd1a44$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $1d9233f60ebd1a44$var$utf8readb(data) {
    var out = $1d9233f60ebd1a44$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString("ucs2");
}
function $1d9233f60ebd1a44$var$utf8readc(data) {
    return $1d9233f60ebd1a44$var$Buffer_from(data, "binary").toString("utf8");
}
var $1d9233f60ebd1a44$var$utf8corpus = "foo bar baz\xe2\x98\x83\xf0\x9f\x8d\xa3";
var $1d9233f60ebd1a44$var$utf8read = $1d9233f60ebd1a44$var$has_buf && /*#__PURE__*/ ($1d9233f60ebd1a44$var$utf8readc($1d9233f60ebd1a44$var$utf8corpus) == /*#__PURE__*/ $1d9233f60ebd1a44$var$utf8reada($1d9233f60ebd1a44$var$utf8corpus) && $1d9233f60ebd1a44$var$utf8readc || /*#__PURE__*/ $1d9233f60ebd1a44$var$utf8readb($1d9233f60ebd1a44$var$utf8corpus) == /*#__PURE__*/ $1d9233f60ebd1a44$var$utf8reada($1d9233f60ebd1a44$var$utf8corpus) && $1d9233f60ebd1a44$var$utf8readb) || $1d9233f60ebd1a44$var$utf8reada;
var $1d9233f60ebd1a44$var$utf8write /*:StringConv*/  = $1d9233f60ebd1a44$var$has_buf ? function(data) {
    return $1d9233f60ebd1a44$var$Buffer_from(data, "utf8").toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var $1d9233f60ebd1a44$var$matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp("<(?:\\w+:)?" + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + ">", g || "");
    };
}();
var $1d9233f60ebd1a44$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            "nbsp",
            " "
        ],
        [
            "middot",
            "\xb7"
        ],
        [
            "quot",
            '"'
        ],
        [
            "apos",
            "'"
        ],
        [
            "gt",
            ">"
        ],
        [
            "lt",
            "<"
        ],
        [
            "amp",
            "&"
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp("&" + x[0] + ";", "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $1d9233f60ebd1a44$var$vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", "g");
    };
}();
var $1d9233f60ebd1a44$var$vtvregex = /<\/?(?:vt:)?variant>/g, $1d9233f60ebd1a44$var$vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function $1d9233f60ebd1a44$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $1d9233f60ebd1a44$var$parsexmltag(data);
    var matches /*:Array<string>*/  = data.match($1d9233f60ebd1a44$var$vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($1d9233f60ebd1a44$var$vtvregex, "").match($1d9233f60ebd1a44$var$vtmregex);
        if (v) res.push({
            v: $1d9233f60ebd1a44$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $1d9233f60ebd1a44$var$wtregex = /(^\s|\s$|\n)/;
function $1d9233f60ebd1a44$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return "<" + f + (g.match($1d9233f60ebd1a44$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f + ">";
}
function $1d9233f60ebd1a44$var$wxt_helper(h) /*:string*/ {
    return $1d9233f60ebd1a44$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $1d9233f60ebd1a44$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return "<" + f + (h != null ? $1d9233f60ebd1a44$var$wxt_helper(h) : "") + (g != null ? (g.match($1d9233f60ebd1a44$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f : "/") + ">";
}
function $1d9233f60ebd1a44$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $1d9233f60ebd1a44$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case "string":
            var o = $1d9233f60ebd1a44$var$writextag("vt:lpwstr", $1d9233f60ebd1a44$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case "number":
            return $1d9233f60ebd1a44$var$writextag((s | 0) == s ? "vt:i4" : "vt:r8", $1d9233f60ebd1a44$var$escapexml(String(s)));
        case "boolean":
            return $1d9233f60ebd1a44$var$writextag("vt:bool", s ? "true" : "false");
    }
    if (s instanceof Date) return $1d9233f60ebd1a44$var$writextag("vt:filetime", $1d9233f60ebd1a44$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $1d9233f60ebd1a44$var$xlml_normalize(d) /*:string*/ {
    if ($1d9233f60ebd1a44$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $1d9233f60ebd1a44$require$Buffer.isBuffer(d)) return d.toString("utf8");
    if (typeof d === "string") return d;
    /* duktape */ if (typeof Uint8Array !== "undefined" && d instanceof Uint8Array) return $1d9233f60ebd1a44$var$utf8read($1d9233f60ebd1a44$var$a2s($1d9233f60ebd1a44$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var $1d9233f60ebd1a44$var$xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/](?:[^>=]|="[^"]*?")*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var $1d9233f60ebd1a44$var$XMLNS = {
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: "http://schemas.openxmlformats.org/package/2006/content-types",
    RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
    TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
    "dc": "http://purl.org/dc/elements/1.1/",
    "dcterms": "http://purl.org/dc/terms/",
    "dcmitype": "http://purl.org/dc/dcmitype/",
    "mx": "http://schemas.microsoft.com/office/mac/excel/2008/main",
    "r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    "sjs": "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    "vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "xsd": "http://www.w3.org/2001/XMLSchema"
} /*:any*/ ;
var $1d9233f60ebd1a44$var$XMLNS_main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2"
];
var $1d9233f60ebd1a44$var$XLMLNS = {
    "o": "urn:schemas-microsoft-com:office:office",
    "x": "urn:schemas-microsoft-com:office:excel",
    "ss": "urn:schemas-microsoft-com:office:spreadsheet",
    "dt": "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    "mv": "http://macVmlSchemaUri",
    "v": "urn:schemas-microsoft-com:vml",
    "html": "http://www.w3.org/TR/REC-html40"
} /*:any*/ ;
function $1d9233f60ebd1a44$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $1d9233f60ebd1a44$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $1d9233f60ebd1a44$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $1d9233f60ebd1a44$var$__toBuffer = $1d9233f60ebd1a44$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $1d9233f60ebd1a44$require$Buffer.isBuffer(bufs[0][0]) ? $1d9233f60ebd1a44$require$Buffer.concat(bufs[0].map(function(x) {
        return $1d9233f60ebd1a44$require$Buffer.isBuffer(x) ? x : $1d9233f60ebd1a44$var$Buffer_from(x);
    })) : $1d9233f60ebd1a44$var$___toBuffer(bufs);
} : $1d9233f60ebd1a44$var$___toBuffer;
var $1d9233f60ebd1a44$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($1d9233f60ebd1a44$var$__readUInt16LE(b, i)));
    return ss.join("").replace($1d9233f60ebd1a44$var$chr0, "");
};
var $1d9233f60ebd1a44$var$__utf16le = $1d9233f60ebd1a44$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$1d9233f60ebd1a44$require$Buffer.isBuffer(b) || !$1d9233f60ebd1a44$var$buf_utf16le) return $1d9233f60ebd1a44$var$___utf16le(b, s, e);
    return b.toString("utf16le", s, e).replace($1d9233f60ebd1a44$var$chr0, "") /*.replace(chr1,'!')*/ ;
} : $1d9233f60ebd1a44$var$___utf16le;
var $1d9233f60ebd1a44$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $1d9233f60ebd1a44$var$__hexlify = $1d9233f60ebd1a44$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $1d9233f60ebd1a44$require$Buffer.isBuffer(b) ? b.toString("hex", s, s + l) : $1d9233f60ebd1a44$var$___hexlify(b, s, l);
} : $1d9233f60ebd1a44$var$___hexlify;
var $1d9233f60ebd1a44$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($1d9233f60ebd1a44$var$__readUInt8(b, i)));
    return ss.join("");
};
var $1d9233f60ebd1a44$var$__utf8 = $1d9233f60ebd1a44$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $1d9233f60ebd1a44$require$Buffer.isBuffer(b) ? b.toString("utf8", s, e) : $1d9233f60ebd1a44$var$___utf8(b, s, e);
} : $1d9233f60ebd1a44$var$___utf8;
var $1d9233f60ebd1a44$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
    return len > 0 ? $1d9233f60ebd1a44$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $1d9233f60ebd1a44$var$__lpstr = $1d9233f60ebd1a44$var$___lpstr;
var $1d9233f60ebd1a44$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
    return len > 0 ? $1d9233f60ebd1a44$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $1d9233f60ebd1a44$var$__cpstr = $1d9233f60ebd1a44$var$___cpstr;
var $1d9233f60ebd1a44$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
    return len > 0 ? $1d9233f60ebd1a44$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $1d9233f60ebd1a44$var$__lpwstr = $1d9233f60ebd1a44$var$___lpwstr;
var $1d9233f60ebd1a44$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
    return len > 0 ? $1d9233f60ebd1a44$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $1d9233f60ebd1a44$var$__lpp4 = $1d9233f60ebd1a44$var$___lpp4;
var $1d9233f60ebd1a44$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
    return len > 0 ? $1d9233f60ebd1a44$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $1d9233f60ebd1a44$var$__8lpp4 = $1d9233f60ebd1a44$var$___8lpp4;
var $1d9233f60ebd1a44$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $1d9233f60ebd1a44$var$read_double_le(b, idx);
};
var $1d9233f60ebd1a44$var$__double = $1d9233f60ebd1a44$var$___double;
var $1d9233f60ebd1a44$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($1d9233f60ebd1a44$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $1d9233f60ebd1a44$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$1d9233f60ebd1a44$require$Buffer.isBuffer(b)) return $1d9233f60ebd1a44$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $1d9233f60ebd1a44$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$1d9233f60ebd1a44$require$Buffer.isBuffer(b)) return $1d9233f60ebd1a44$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $1d9233f60ebd1a44$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$1d9233f60ebd1a44$require$Buffer.isBuffer(b) || !$1d9233f60ebd1a44$var$buf_utf16le) return $1d9233f60ebd1a44$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len - 1);
    };
    $1d9233f60ebd1a44$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$1d9233f60ebd1a44$require$Buffer.isBuffer(b) || !$1d9233f60ebd1a44$var$buf_utf16le) return $1d9233f60ebd1a44$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len);
    };
    $1d9233f60ebd1a44$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$1d9233f60ebd1a44$require$Buffer.isBuffer(b)) return $1d9233f60ebd1a44$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf8", i + 4, i + 4 + len);
    };
    $1d9233f60ebd1a44$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($1d9233f60ebd1a44$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $1d9233f60ebd1a44$var$___double(b, i);
    };
    $1d9233f60ebd1a44$var$is_buf = function is_buf_b(a) {
        return $1d9233f60ebd1a44$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $1d9233f60ebd1a44$var$cpdoit() {
    $1d9233f60ebd1a44$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $1d9233f60ebd1a44$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($1d9233f60ebd1a44$var$chr0, "");
    };
    $1d9233f60ebd1a44$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $1d9233f60ebd1a44$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $1d9233f60ebd1a44$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
        return len > 0 ? $1d9233f60ebd1a44$var$$cptable.utils.decode($1d9233f60ebd1a44$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $1d9233f60ebd1a44$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
        return len > 0 ? $1d9233f60ebd1a44$var$$cptable.utils.decode($1d9233f60ebd1a44$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $1d9233f60ebd1a44$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
        return len > 0 ? $1d9233f60ebd1a44$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $1d9233f60ebd1a44$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
        return len > 0 ? $1d9233f60ebd1a44$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $1d9233f60ebd1a44$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $1d9233f60ebd1a44$var$__readUInt32LE(b, i);
        return len > 0 ? $1d9233f60ebd1a44$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined") $1d9233f60ebd1a44$var$cpdoit();
var $1d9233f60ebd1a44$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $1d9233f60ebd1a44$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $1d9233f60ebd1a44$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $1d9233f60ebd1a44$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $1d9233f60ebd1a44$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $1d9233f60ebd1a44$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $1d9233f60ebd1a44$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case "dbcs":
            loc = this.l;
            if ($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(this) && $1d9233f60ebd1a44$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($1d9233f60ebd1a44$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case "utf8":
            o = $1d9233f60ebd1a44$var$__utf8(this, this.l, this.l + size);
            break;
        case "utf16le":
            size *= 2;
            o = $1d9233f60ebd1a44$var$__utf16le(this, this.l, this.l + size);
            break;
        case "wstr":
            if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined") o = $1d9233f60ebd1a44$var$$cptable.utils.decode($1d9233f60ebd1a44$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $1d9233f60ebd1a44$var$ReadShift.call(this, size, "dbcs");
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case "lpstr-ansi":
            o = $1d9233f60ebd1a44$var$__lpstr(this, this.l);
            size = 4 + $1d9233f60ebd1a44$var$__readUInt32LE(this, this.l);
            break;
        case "lpstr-cp":
            o = $1d9233f60ebd1a44$var$__cpstr(this, this.l);
            size = 4 + $1d9233f60ebd1a44$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case "lpwstr":
            o = $1d9233f60ebd1a44$var$__lpwstr(this, this.l);
            size = 4 + 2 * $1d9233f60ebd1a44$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case "lpp4":
            size = 4 + $1d9233f60ebd1a44$var$__readUInt32LE(this, this.l);
            o = $1d9233f60ebd1a44$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case "8lpp4":
            size = 4 + $1d9233f60ebd1a44$var$__readUInt32LE(this, this.l);
            o = $1d9233f60ebd1a44$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case "cstr":
            size = 0;
            o = "";
            while((w = $1d9233f60ebd1a44$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($1d9233f60ebd1a44$var$_getchar(w));
            o = oo.join("");
            break;
        case "_wstr":
            size = 0;
            o = "";
            while((w = $1d9233f60ebd1a44$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($1d9233f60ebd1a44$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case "dbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $1d9233f60ebd1a44$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $1d9233f60ebd1a44$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($1d9233f60ebd1a44$var$_getchar($1d9233f60ebd1a44$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case "cpstr":
            if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined") {
                o = $1d9233f60ebd1a44$var$$cptable.utils.decode($1d9233f60ebd1a44$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case "sbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $1d9233f60ebd1a44$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $1d9233f60ebd1a44$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($1d9233f60ebd1a44$var$_getchar($1d9233f60ebd1a44$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $1d9233f60ebd1a44$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === "i" ? $1d9233f60ebd1a44$var$__readInt16LE : $1d9233f60ebd1a44$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === "i" || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $1d9233f60ebd1a44$var$__readInt32LE : $1d9233f60ebd1a44$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $1d9233f60ebd1a44$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === "f") {
                        if (size == 8) oR = $1d9233f60ebd1a44$var$__double(this, this.l);
                        else oR = $1d9233f60ebd1a44$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $1d9233f60ebd1a44$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $1d9233f60ebd1a44$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $1d9233f60ebd1a44$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $1d9233f60ebd1a44$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $1d9233f60ebd1a44$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === "dbcs") {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$1d9233f60ebd1a44$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === "sbcs" || f == "cpstr") {
        if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" && $1d9233f60ebd1a44$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
                var cpp = $1d9233f60ebd1a44$var$$cptable.utils.encode($1d9233f60ebd1a44$var$current_ansi, val.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val.length;
        } else if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" && f == "cpstr") {
            cpp = $1d9233f60ebd1a44$var$$cptable.utils.encode($1d9233f60ebd1a44$var$current_codepage, val);
            /* replace null bytes with _ when relevant */ if (cpp.length == val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[i] == 0 && val.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
            size = val.length;
        }
    } else if (f === "hex") {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === "utf16le") {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $1d9233f60ebd1a44$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === "f") {
                $1d9233f60ebd1a44$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $1d9233f60ebd1a44$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $1d9233f60ebd1a44$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $1d9233f60ebd1a44$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + "Expected " + hexstr + " saw " + m);
    this.l += hexstr.length >> 1;
}
function $1d9233f60ebd1a44$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $1d9233f60ebd1a44$var$ReadShift /*:: :any)*/ ;
    blob.chk = $1d9233f60ebd1a44$var$CheckField;
    blob.write_shift = $1d9233f60ebd1a44$var$WriteShift;
}
function $1d9233f60ebd1a44$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $1d9233f60ebd1a44$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $1d9233f60ebd1a44$var$new_raw_buf(sz);
    $1d9233f60ebd1a44$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $1d9233f60ebd1a44$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $1d9233f60ebd1a44$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $1d9233f60ebd1a44$var$XLSBRecordEnum[RT] || $1d9233f60ebd1a44$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $1d9233f60ebd1a44$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $1d9233f60ebd1a44$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $1d9233f60ebd1a44$var$new_buf(sz);
        $1d9233f60ebd1a44$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $1d9233f60ebd1a44$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $1d9233f60ebd1a44$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $1d9233f60ebd1a44$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $1d9233f60ebd1a44$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $1d9233f60ebd1a44$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $1d9233f60ebd1a44$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $1d9233f60ebd1a44$var$shift_range_xls(cell, range, opts) {
    var out = $1d9233f60ebd1a44$var$dup(cell);
    out.s = $1d9233f60ebd1a44$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $1d9233f60ebd1a44$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $1d9233f60ebd1a44$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $1d9233f60ebd1a44$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $1d9233f60ebd1a44$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $1d9233f60ebd1a44$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $1d9233f60ebd1a44$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $1d9233f60ebd1a44$var$fix_row(s);
    return s;
}
function $1d9233f60ebd1a44$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $1d9233f60ebd1a44$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $1d9233f60ebd1a44$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $1d9233f60ebd1a44$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $1d9233f60ebd1a44$var$encode_row(r.e.r);
    }
    return $1d9233f60ebd1a44$var$encode_cell_xls(r.s, opts.biff) + ":" + $1d9233f60ebd1a44$var$encode_cell_xls(r.e, opts.biff);
}
function $1d9233f60ebd1a44$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($1d9233f60ebd1a44$var$unfix_row(rowstr), 10) - 1;
}
function $1d9233f60ebd1a44$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $1d9233f60ebd1a44$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $1d9233f60ebd1a44$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $1d9233f60ebd1a44$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $1d9233f60ebd1a44$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $1d9233f60ebd1a44$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $1d9233f60ebd1a44$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $1d9233f60ebd1a44$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $1d9233f60ebd1a44$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $1d9233f60ebd1a44$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $1d9233f60ebd1a44$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $1d9233f60ebd1a44$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $1d9233f60ebd1a44$var$decode_cell(range),
        e: $1d9233f60ebd1a44$var$decode_cell(range)
    };
    return {
        s: $1d9233f60ebd1a44$var$decode_cell(range.slice(0, idx)),
        e: $1d9233f60ebd1a44$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $1d9233f60ebd1a44$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === "undefined" || typeof ce === "number") /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $1d9233f60ebd1a44$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== "string") cs = $1d9233f60ebd1a44$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== "string") ce = $1d9233f60ebd1a44$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $1d9233f60ebd1a44$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $1d9233f60ebd1a44$var$decode_range(a1);
    return "$" + $1d9233f60ebd1a44$var$encode_col(s.s.c) + "$" + $1d9233f60ebd1a44$var$encode_row(s.s.r) + ":$" + $1d9233f60ebd1a44$var$encode_col(s.e.c) + "$" + $1d9233f60ebd1a44$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $1d9233f60ebd1a44$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $1d9233f60ebd1a44$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $1d9233f60ebd1a44$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == "d" && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $1d9233f60ebd1a44$var$SSF_format(cell.z, q ? $1d9233f60ebd1a44$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $1d9233f60ebd1a44$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $1d9233f60ebd1a44$var$datenum(v) : v);
    } catch (e) {
        return "" + v;
    }
}
function $1d9233f60ebd1a44$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == "z") return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == "d" && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $1d9233f60ebd1a44$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $1d9233f60ebd1a44$var$safe_format_cell(cell, cell.v);
    return $1d9233f60ebd1a44$var$safe_format_cell(cell, v);
}
function $1d9233f60ebd1a44$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $1d9233f60ebd1a44$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($1d9233f60ebd1a44$var$DENSE != null && dense == null) dense = $1d9233f60ebd1a44$var$DENSE;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $1d9233f60ebd1a44$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    var row = [];
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R, __Rstr = "" + (__R + 1);
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === "undefined") continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === "object" && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = "n";
                    else if (o.nullError) {
                        cell.t = "e";
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = "z";
                } else if (typeof cell.v === "number") cell.t = "n";
                else if (typeof cell.v === "boolean") cell.t = "b";
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $1d9233f60ebd1a44$var$table_fmt[14];
                    if (o.cellDates) {
                        cell.t = "d";
                        cell.w = $1d9233f60ebd1a44$var$SSF_format(cell.z, $1d9233f60ebd1a44$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = "n";
                        cell.v = $1d9233f60ebd1a44$var$datenum(cell.v, o.date1904);
                        cell.w = $1d9233f60ebd1a44$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = "s";
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $1d9233f60ebd1a44$var$encode_col(__C) + __Rstr /*:any*/ ;
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
    return ws;
}
function $1d9233f60ebd1a44$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $1d9233f60ebd1a44$var$sheet_add_aoa(null, data, opts);
}
function $1d9233f60ebd1a44$var$parse_Int32LE(data) {
    return data.read_shift(4, "i");
}
function $1d9233f60ebd1a44$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $1d9233f60ebd1a44$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $1d9233f60ebd1a44$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $1d9233f60ebd1a44$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $1d9233f60ebd1a44$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $1d9233f60ebd1a44$var$write_StrRun(run, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $1d9233f60ebd1a44$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($1d9233f60ebd1a44$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $1d9233f60ebd1a44$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $1d9233f60ebd1a44$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $1d9233f60ebd1a44$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $1d9233f60ebd1a44$var$parse_BrtCommentText = $1d9233f60ebd1a44$var$parse_RichStr;
function $1d9233f60ebd1a44$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $1d9233f60ebd1a44$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $1d9233f60ebd1a44$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $1d9233f60ebd1a44$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $1d9233f60ebd1a44$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $1d9233f60ebd1a44$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $1d9233f60ebd1a44$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $1d9233f60ebd1a44$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $1d9233f60ebd1a44$var$parse_XLSBCodeName = $1d9233f60ebd1a44$var$parse_XLWideString;
var $1d9233f60ebd1a44$var$write_XLSBCodeName = $1d9233f60ebd1a44$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $1d9233f60ebd1a44$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $1d9233f60ebd1a44$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $1d9233f60ebd1a44$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $1d9233f60ebd1a44$var$parse_XLNameWideString = $1d9233f60ebd1a44$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $1d9233f60ebd1a44$var$parse_RelID = $1d9233f60ebd1a44$var$parse_XLNullableWideString;
var $1d9233f60ebd1a44$var$write_RelID = $1d9233f60ebd1a44$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $1d9233f60ebd1a44$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $1d9233f60ebd1a44$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $1d9233f60ebd1a44$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $1d9233f60ebd1a44$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $1d9233f60ebd1a44$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $1d9233f60ebd1a44$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $1d9233f60ebd1a44$var$parse_UncheckedRfX = $1d9233f60ebd1a44$var$parse_RfX;
var $1d9233f60ebd1a44$var$write_UncheckedRfX = $1d9233f60ebd1a44$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $1d9233f60ebd1a44$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, "f");
}
function $1d9233f60ebd1a44$var$write_Xnum(data, o) {
    return (o || $1d9233f60ebd1a44$var$new_buf(8)).write_shift(8, data, "f");
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $1d9233f60ebd1a44$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, "i");
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $1d9233f60ebd1a44$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $1d9233f60ebd1a44$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $1d9233f60ebd1a44$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $1d9233f60ebd1a44$var$write_BrtColor(color, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || "FFFFFF";
        if (typeof rgb == "number") rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $1d9233f60ebd1a44$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $1d9233f60ebd1a44$var$write_FontFlags(font, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $1d9233f60ebd1a44$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $1d9233f60ebd1a44$var$parse_ClipboardFormatOrAnsiString(o) {
    return $1d9233f60ebd1a44$var$parse_ClipboardFormatOrString(o, 1);
}
function $1d9233f60ebd1a44$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $1d9233f60ebd1a44$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $1d9233f60ebd1a44$var$VT_I2 = 0x0002;
var $1d9233f60ebd1a44$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $1d9233f60ebd1a44$var$VT_BOOL = 0x000B;
var $1d9233f60ebd1a44$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $1d9233f60ebd1a44$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $1d9233f60ebd1a44$var$VT_FILETIME = 0x0040;
var $1d9233f60ebd1a44$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $1d9233f60ebd1a44$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $1d9233f60ebd1a44$var$VT_VECTOR_VARIANT = 0x100C;
var $1d9233f60ebd1a44$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $1d9233f60ebd1a44$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $1d9233f60ebd1a44$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $1d9233f60ebd1a44$var$VT_CUSTOM = [
    $1d9233f60ebd1a44$var$VT_STRING,
    $1d9233f60ebd1a44$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $1d9233f60ebd1a44$var$DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $1d9233f60ebd1a44$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Category",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "PresentationFormat",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "ByteCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x05: {
        n: "LineCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x06: {
        n: "ParagraphCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x07: {
        n: "SlideCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x08: {
        n: "NoteCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x09: {
        n: "HiddenCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x0a: {
        n: "MultimediaClipCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x0b: {
        n: "ScaleCrop",
        t: $1d9233f60ebd1a44$var$VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: "HeadingPairs",
        t: $1d9233f60ebd1a44$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: "TitlesOfParts",
        t: $1d9233f60ebd1a44$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: "Manager",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x0f: {
        n: "Company",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x10: {
        n: "LinksUpToDate",
        t: $1d9233f60ebd1a44$var$VT_BOOL
    },
    /*::[*/ 0x11: {
        n: "CharacterCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x13: {
        n: "SharedDoc",
        t: $1d9233f60ebd1a44$var$VT_BOOL
    },
    /*::[*/ 0x16: {
        n: "HyperlinksChanged",
        t: $1d9233f60ebd1a44$var$VT_BOOL
    },
    /*::[*/ 0x17: {
        n: "AppVersion",
        t: $1d9233f60ebd1a44$var$VT_I4,
        p: "version"
    },
    /*::[*/ 0x18: {
        n: "DigSig",
        t: $1d9233f60ebd1a44$var$VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: "ContentType",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x1B: {
        n: "ContentStatus",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x1C: {
        n: "Language",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x1D: {
        n: "Version",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $1d9233f60ebd1a44$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $1d9233f60ebd1a44$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $1d9233f60ebd1a44$var$SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $1d9233f60ebd1a44$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Title",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "Subject",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "Author",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x05: {
        n: "Keywords",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x06: {
        n: "Comments",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x07: {
        n: "Template",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x08: {
        n: "LastAuthor",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x09: {
        n: "RevNumber",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x0A: {
        n: "EditTime",
        t: $1d9233f60ebd1a44$var$VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: "LastPrinted",
        t: $1d9233f60ebd1a44$var$VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: "CreatedDate",
        t: $1d9233f60ebd1a44$var$VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: "ModifiedDate",
        t: $1d9233f60ebd1a44$var$VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: "PageCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x0F: {
        n: "WordCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x10: {
        n: "CharCount",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0x11: {
        n: "Thumbnail",
        t: $1d9233f60ebd1a44$var$VT_CF
    },
    /*::[*/ 0x12: {
        n: "Application",
        t: $1d9233f60ebd1a44$var$VT_STRING
    },
    /*::[*/ 0x13: {
        n: "DocSecurity",
        t: $1d9233f60ebd1a44$var$VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $1d9233f60ebd1a44$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $1d9233f60ebd1a44$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $1d9233f60ebd1a44$var$CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $1d9233f60ebd1a44$var$XLSFillPattern = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
function $1d9233f60ebd1a44$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $1d9233f60ebd1a44$var$_XLSIcv = /*#__PURE__*/ $1d9233f60ebd1a44$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $1d9233f60ebd1a44$var$XLSIcv = /*#__PURE__*/ $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $1d9233f60ebd1a44$var$BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $1d9233f60ebd1a44$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $1d9233f60ebd1a44$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $1d9233f60ebd1a44$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $1d9233f60ebd1a44$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $1d9233f60ebd1a44$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $1d9233f60ebd1a44$var$parse_ct(data /*:?string*/ ) {
    var ct = $1d9233f60ebd1a44$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch(y[0].replace($1d9233f60ebd1a44$var$nsregex, "<")){
            case "<?xml":
                break;
            case "<Types":
                ct.xmlns = y["xmlns" + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case "<Default":
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case "<Override":
                if (ct[$1d9233f60ebd1a44$var$ct2type[y.ContentType]] !== undefined) ct[$1d9233f60ebd1a44$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $1d9233f60ebd1a44$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $1d9233f60ebd1a44$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $1d9233f60ebd1a44$var$evert_arr($1d9233f60ebd1a44$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $1d9233f60ebd1a44$var$XML_HEADER;
        o[o.length] = $1d9233f60ebd1a44$var$writextag("Types", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS.CT,
            "xmlns:xsd": $1d9233f60ebd1a44$var$XMLNS.xsd,
            "xmlns:xsi": $1d9233f60ebd1a44$var$XMLNS.xsi
        });
        o = o.concat([
            [
                "xml",
                "application/xml"
            ],
            [
                "bin",
                "application/vnd.ms-excel.sheet.binary.macroEnabled.main"
            ],
            [
                "vml",
                "application/vnd.openxmlformats-officedocument.vmlDrawing"
            ],
            [
                "data",
                "application/vnd.openxmlformats-officedocument.model+data"
            ],
            /* from test files */ [
                "bmp",
                "image/bmp"
            ],
            [
                "png",
                "image/png"
            ],
            [
                "gif",
                "image/gif"
            ],
            [
                "emf",
                "image/x-emf"
            ],
            [
                "wmf",
                "image/x-wmf"
            ],
            [
                "jpg",
                "image/jpeg"
            ],
            [
                "jpeg",
                "image/jpeg"
            ],
            [
                "tif",
                "image/tiff"
            ],
            [
                "tiff",
                "image/tiff"
            ],
            [
                "pdf",
                "application/pdf"
            ],
            [
                "rels",
                "application/vnd.openxmlformats-package.relationships+xml"
            ]
        ].map(function(x) {
            return $1d9233f60ebd1a44$var$writextag("Default", null, {
                "Extension": x[0],
                "ContentType": x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $1d9233f60ebd1a44$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $1d9233f60ebd1a44$var$CT_LIST[w][opts.bookType] || $1d9233f60ebd1a44$var$CT_LIST[w]["xlsx"]
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $1d9233f60ebd1a44$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $1d9233f60ebd1a44$var$CT_LIST[w][opts.bookType] || $1d9233f60ebd1a44$var$CT_LIST[w]["xlsx"]
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $1d9233f60ebd1a44$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": type2ct[t][0]
            });
        });
    };
    f1("workbooks");
    f2("sheets");
    f2("charts");
    f3("themes");
    [
        "strs",
        "styles"
    ].forEach(f1);
    [
        "coreprops",
        "extprops",
        "custprops"
    ].forEach(f3);
    f3("vba");
    f3("comments");
    f3("threadedcomments");
    f3("drawings");
    f2("metadata");
    f3("people");
    if (!raw && o.length > 2) {
        o[o.length] = "</Types>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $1d9233f60ebd1a44$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $1d9233f60ebd1a44$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + "_rels/" + file.slice(n + 1) + ".rels";
}
function $1d9233f60ebd1a44$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== "/") currentFilePath = "/" + currentFilePath;
    var hash = {};
    (data.match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === "<Relationship") {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $1d9233f60ebd1a44$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === "External" ? y.Target : $1d9233f60ebd1a44$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $1d9233f60ebd1a44$var$write_rels(rels) /*:string*/ {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("Relationships", null, {
            //'xmlns:ns0': XMLNS.RELS,
            "xmlns": $1d9233f60ebd1a44$var$XMLNS.RELS
        })
    ];
    $1d9233f60ebd1a44$var$keys(rels["!id"]).forEach(function(rid) {
        o[o.length] = $1d9233f60ebd1a44$var$writextag("Relationship", null, rels["!id"][rid]);
    });
    if (o.length > 2) {
        o[o.length] = "</Relationships>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $1d9233f60ebd1a44$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels["!id"]) rels["!id"] = {};
    if (!rels["!idx"]) rels["!idx"] = 1;
    if (rId < 0) for(rId = rels["!idx"]; rels["!id"]["rId" + rId]; ++rId);
    rels["!idx"] = rId + 1;
    relobj.Id = "rId" + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $1d9233f60ebd1a44$var$RELS.HLINK,
        $1d9233f60ebd1a44$var$RELS.XPATH,
        $1d9233f60ebd1a44$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels["!id"][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels["!id"][relobj.Id] = relobj;
    rels[("/" + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var $1d9233f60ebd1a44$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $1d9233f60ebd1a44$var$parse_manifest(d, opts) {
    var str = $1d9233f60ebd1a44$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $1d9233f60ebd1a44$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break; // 4.2 <manifest:manifest>
        case "file-entry":
            FEtag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $1d9233f60ebd1a44$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $1d9233f60ebd1a44$var$write_manifest(manifest /*:Array<Array<string> >*/ ) /*:string*/ {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
/* Part 3 Section 6 Metadata Manifest File */ function $1d9233f60ebd1a44$var$write_rdf_type(file /*:string*/ , res /*:string*/ , tag /*:?string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $1d9233f60ebd1a44$var$write_rdf_has(base /*:string*/ , file /*:string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $1d9233f60ebd1a44$var$write_rdf(rdf) {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($1d9233f60ebd1a44$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($1d9233f60ebd1a44$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($1d9233f60ebd1a44$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
/* TODO: pull properties */ function $1d9233f60ebd1a44$var$write_meta_ods() /*:string*/ {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $1d9233f60ebd1a44$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $1d9233f60ebd1a44$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        "date"
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        "date"
    ]
];
var $1d9233f60ebd1a44$var$CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array($1d9233f60ebd1a44$var$CORE_PROPS.length);
    for(var i = 0; i < $1d9233f60ebd1a44$var$CORE_PROPS.length; ++i){
        var f = $1d9233f60ebd1a44$var$CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)</" + g + ">");
    }
    return r;
}();
function $1d9233f60ebd1a44$var$parse_core_props(data) {
    var p = {};
    data = $1d9233f60ebd1a44$var$utf8read(data);
    for(var i = 0; i < $1d9233f60ebd1a44$var$CORE_PROPS.length; ++i){
        var f = $1d9233f60ebd1a44$var$CORE_PROPS[i], cur = data.match($1d9233f60ebd1a44$var$CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = $1d9233f60ebd1a44$var$unescapexml(cur[1]);
        if (f[2] === "date" && p[f[1]]) p[f[1]] = $1d9233f60ebd1a44$var$parseDate(p[f[1]]);
    }
    return p;
}
function $1d9233f60ebd1a44$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $1d9233f60ebd1a44$var$escapexml(g);
    o[o.length] = h ? $1d9233f60ebd1a44$var$writextag(f, g, h) : $1d9233f60ebd1a44$var$writetag(f, g);
}
function $1d9233f60ebd1a44$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("cp:coreProperties", null, {
            //'xmlns': XMLNS.CORE_PROPS,
            "xmlns:cp": $1d9233f60ebd1a44$var$XMLNS.CORE_PROPS,
            "xmlns:dc": $1d9233f60ebd1a44$var$XMLNS.dc,
            "xmlns:dcterms": $1d9233f60ebd1a44$var$XMLNS.dcterms,
            "xmlns:dcmitype": $1d9233f60ebd1a44$var$XMLNS.dcmitype,
            "xmlns:xsi": $1d9233f60ebd1a44$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $1d9233f60ebd1a44$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $1d9233f60ebd1a44$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $1d9233f60ebd1a44$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $1d9233f60ebd1a44$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $1d9233f60ebd1a44$var$CORE_PROPS.length; ++i){
        var f = $1d9233f60ebd1a44$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $1d9233f60ebd1a44$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = "</cp:coreProperties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $1d9233f60ebd1a44$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $1d9233f60ebd1a44$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $1d9233f60ebd1a44$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $1d9233f60ebd1a44$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $1d9233f60ebd1a44$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $1d9233f60ebd1a44$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $1d9233f60ebd1a44$var$utf8read(data);
    $1d9233f60ebd1a44$var$EXT_PROPS.forEach(function(f) {
        var xml = (data.match($1d9233f60ebd1a44$var$matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $1d9233f60ebd1a44$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)</" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $1d9233f60ebd1a44$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $1d9233f60ebd1a44$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $1d9233f60ebd1a44$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $1d9233f60ebd1a44$var$XML_HEADER;
    o[o.length] = $1d9233f60ebd1a44$var$writextag("Properties", null, {
        "xmlns": $1d9233f60ebd1a44$var$XMLNS.EXT_PROPS,
        "xmlns:vt": $1d9233f60ebd1a44$var$XMLNS.vt
    });
    $1d9233f60ebd1a44$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case "string":
                v = $1d9233f60ebd1a44$var$escapexml(String(cp[f[1]]));
                break;
            case "bool":
                v = cp[f[1]] ? "true" : "false";
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W("HeadingPairs", W("vt:vector", W("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + W("vt:variant", W("vt:i4", String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W("TitlesOfParts", W("vt:vector", cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $1d9233f60ebd1a44$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $1d9233f60ebd1a44$var$custregex = /<[^>]+>[^<]*/g;
function $1d9233f60ebd1a44$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($1d9233f60ebd1a44$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<Properties":
                break;
            case "<property":
                name = $1d9233f60ebd1a44$var$unescapexml(y.name);
                break;
            case "</property>":
                name = null;
                break;
            default:
                if (x.indexOf("<vt:") === 0) {
                    var toks = x.split(">");
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case "lpstr":
                        case "bstr":
                        case "lpwstr":
                            p[name] = $1d9233f60ebd1a44$var$unescapexml(text);
                            break;
                        case "bool":
                            p[name] = $1d9233f60ebd1a44$var$parsexmlbool(text);
                            break;
                        case "i1":
                        case "i2":
                        case "i4":
                        case "i8":
                        case "int":
                        case "uint":
                            p[name] = parseInt(text, 10);
                            break;
                        case "r4":
                        case "r8":
                        case "decimal":
                            p[name] = parseFloat(text);
                            break;
                        case "filetime":
                        case "date":
                            p[name] = $1d9233f60ebd1a44$var$parseDate(text);
                            break;
                        case "cy":
                        case "error":
                            p[name] = $1d9233f60ebd1a44$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == "/") break;
                            if (opts.WTF && typeof console !== "undefined") console.warn("Unexpected", x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $1d9233f60ebd1a44$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("Properties", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS.CUST_PROPS,
            "xmlns:vt": $1d9233f60ebd1a44$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $1d9233f60ebd1a44$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $1d9233f60ebd1a44$var$writextag("property", $1d9233f60ebd1a44$var$write_vt(cp[k], true), {
            "fmtid": "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            "pid": pid,
            "name": $1d9233f60ebd1a44$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $1d9233f60ebd1a44$var$XLMLDocPropsMap = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    /* TotalTime: 'TotalTime', */ LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    /* Pages */ /* Words */ /* Characters */ Category: "Category",
    /* PresentationFormat */ Manager: "Manager",
    Company: "Company",
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: "Version",
    ContentStatus: "ContentStatus",
    /* NOTE: missing from schema */ Identifier: "Identifier",
    /* NOTE: missing from schema */ Language: "Language" /* NOTE: missing from schema */ 
};
var $1d9233f60ebd1a44$var$evert_XLMLDPM;
function $1d9233f60ebd1a44$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$1d9233f60ebd1a44$var$evert_XLMLDPM) $1d9233f60ebd1a44$var$evert_XLMLDPM = $1d9233f60ebd1a44$var$evert($1d9233f60ebd1a44$var$XLMLDocPropsMap);
    tag = $1d9233f60ebd1a44$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $1d9233f60ebd1a44$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $1d9233f60ebd1a44$var$keys($1d9233f60ebd1a44$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $1d9233f60ebd1a44$var$CORE_PROPS.length; ++i)if ($1d9233f60ebd1a44$var$CORE_PROPS[i][1] == m) return $1d9233f60ebd1a44$var$CORE_PROPS[i];
        for(i = 0; i < $1d9233f60ebd1a44$var$EXT_PROPS.length; ++i)if ($1d9233f60ebd1a44$var$EXT_PROPS[i][1] == m) return $1d9233f60ebd1a44$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case "date":
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == "number") m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($1d9233f60ebd1a44$var$writetag($1d9233f60ebd1a44$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $1d9233f60ebd1a44$var$writextag("DocumentProperties", o.join(""), {
        xmlns: $1d9233f60ebd1a44$var$XLMLNS.o
    });
}
function $1d9233f60ebd1a44$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = "CustomDocumentProperties";
    var o /*:Array<string>*/  = [];
    if (Props) $1d9233f60ebd1a44$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $1d9233f60ebd1a44$var$CORE_PROPS.length; ++i)if (k == $1d9233f60ebd1a44$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $1d9233f60ebd1a44$var$EXT_PROPS.length; ++i)if (k == $1d9233f60ebd1a44$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($1d9233f60ebd1a44$var$writextag($1d9233f60ebd1a44$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $1d9233f60ebd1a44$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($1d9233f60ebd1a44$var$writextag($1d9233f60ebd1a44$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return "<" + T + ' xmlns="' + $1d9233f60ebd1a44$var$XLMLNS.o + '">' + o.join("") + "</" + T + ">";
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $1d9233f60ebd1a44$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $1d9233f60ebd1a44$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $1d9233f60ebd1a44$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $1d9233f60ebd1a44$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, "lpstr-cp");
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $1d9233f60ebd1a44$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpwstr");
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $1d9233f60ebd1a44$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $1d9233f60ebd1a44$var$parse_lpwstr(blob);
    return $1d9233f60ebd1a44$var$parse_lpstr(blob, stringType, pad);
}
function $1d9233f60ebd1a44$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $1d9233f60ebd1a44$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $1d9233f60ebd1a44$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $1d9233f60ebd1a44$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $1d9233f60ebd1a44$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, "lpwstr").replace($1d9233f60ebd1a44$var$chr0, "");
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $1d9233f60ebd1a44$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, "lpstr-cp").replace($1d9233f60ebd1a44$var$chr0, "");
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $1d9233f60ebd1a44$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $1d9233f60ebd1a44$var$parse_TypedPropertyValue(blob, $1d9233f60ebd1a44$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $1d9233f60ebd1a44$var$parse_TypedPropertyValue(blob, $1d9233f60ebd1a44$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $1d9233f60ebd1a44$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($1d9233f60ebd1a44$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $1d9233f60ebd1a44$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? "utf16le" : "utf8").replace($1d9233f60ebd1a44$var$chr0, "").replace($1d9233f60ebd1a44$var$chr1, "!");
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $1d9233f60ebd1a44$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $1d9233f60ebd1a44$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $1d9233f60ebd1a44$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $1d9233f60ebd1a44$var$VT_VARIANT) {
        if (t !== type && $1d9233f60ebd1a44$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error("Expected type " + type + " saw " + t);
    }
    switch(type === $1d9233f60ebd1a44$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, "i");
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, "i");
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $1d9233f60ebd1a44$var$parse_lpstr(blob, t, 4).replace($1d9233f60ebd1a44$var$chr0, "");
        case 0x1F /*VT_LPWSTR*/ :
            return $1d9233f60ebd1a44$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $1d9233f60ebd1a44$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $1d9233f60ebd1a44$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $1d9233f60ebd1a44$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $1d9233f60ebd1a44$var$parse_VtString(blob, t, !opts.raw).replace($1d9233f60ebd1a44$var$chr0, "");
        case 0x51 /*VT_USTR*/ :
            return $1d9233f60ebd1a44$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($1d9233f60ebd1a44$var$chr0, "");
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $1d9233f60ebd1a44$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $1d9233f60ebd1a44$var$parse_VtVecLpwstrValue(blob) : $1d9233f60ebd1a44$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $1d9233f60ebd1a44$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $1d9233f60ebd1a44$var$new_buf(4), p = $1d9233f60ebd1a44$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $1d9233f60ebd1a44$var$new_buf(8);
            p.write_shift(8, value, "f");
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $1d9233f60ebd1a44$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $1d9233f60ebd1a44$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $1d9233f60ebd1a44$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $1d9233f60ebd1a44$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + " at " + blob.l + " :" + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $1d9233f60ebd1a44$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === "version") PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $1d9233f60ebd1a44$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $1d9233f60ebd1a44$var$parse_TypedPropertyValue(blob, $1d9233f60ebd1a44$var$VT_I2);
                $1d9233f60ebd1a44$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $1d9233f60ebd1a44$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $1d9233f60ebd1a44$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $1d9233f60ebd1a44$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $1d9233f60ebd1a44$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $1d9233f60ebd1a44$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, "i");
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, "f");
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $1d9233f60ebd1a44$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $1d9233f60ebd1a44$var$parseDate($1d9233f60ebd1a44$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $1d9233f60ebd1a44$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $1d9233f60ebd1a44$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $1d9233f60ebd1a44$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $1d9233f60ebd1a44$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $1d9233f60ebd1a44$var$new_buf(8), pio = $1d9233f60ebd1a44$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $1d9233f60ebd1a44$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $1d9233f60ebd1a44$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $1d9233f60ebd1a44$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $1d9233f60ebd1a44$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($1d9233f60ebd1a44$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $1d9233f60ebd1a44$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $1d9233f60ebd1a44$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $1d9233f60ebd1a44$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $1d9233f60ebd1a44$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $1d9233f60ebd1a44$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $1d9233f60ebd1a44$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $1d9233f60ebd1a44$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $1d9233f60ebd1a44$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk("feff", "Byte Order: ");
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $1d9233f60ebd1a44$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $1d9233f60ebd1a44$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $1d9233f60ebd1a44$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $1d9233f60ebd1a44$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $1d9233f60ebd1a44$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $1d9233f60ebd1a44$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $1d9233f60ebd1a44$var$bconcat(bufs);
}
function $1d9233f60ebd1a44$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $1d9233f60ebd1a44$var$writezeroes(n, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $1d9233f60ebd1a44$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $1d9233f60ebd1a44$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $1d9233f60ebd1a44$var$writebool(v /*:any*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $1d9233f60ebd1a44$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, "u");
}
function $1d9233f60ebd1a44$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $1d9233f60ebd1a44$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $1d9233f60ebd1a44$var$parslurp(blob, length, $1d9233f60ebd1a44$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $1d9233f60ebd1a44$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $1d9233f60ebd1a44$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(2);
    o.write_shift(1, t == "e" ? +v : +!!v);
    o.write_shift(1, t == "e" ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $1d9233f60ebd1a44$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = "sbcs-cont";
    var cp = $1d9233f60ebd1a44$var$current_codepage;
    if (opts && opts.biff >= 8) $1d9233f60ebd1a44$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = "dbcs-cont";
    } else if (opts.biff == 12) encoding = "wstr";
    if (opts.biff >= 2 && opts.biff <= 5) encoding = "cpstr";
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $1d9233f60ebd1a44$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $1d9233f60ebd1a44$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $1d9233f60ebd1a44$var$current_codepage;
    $1d9233f60ebd1a44$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? "dbcs-cont" : "sbcs-cont";
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $1d9233f60ebd1a44$var$current_codepage = cp;
    return z;
}
function $1d9233f60ebd1a44$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $1d9233f60ebd1a44$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $1d9233f60ebd1a44$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, "utf16le");
    var out = [
        hdr,
        otext
    ];
    return $1d9233f60ebd1a44$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, "cpstr");
        if (opts.biff >= 12) return blob.read_shift(cch, "dbcs-cont");
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, "sbcs-cont");
    else retval = blob.read_shift(cch, "dbcs-cont");
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $1d9233f60ebd1a44$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $1d9233f60ebd1a44$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? "cpstr" : "sbcs-cont");
}
/* TODO: BIFF5 and lower, codepage awareness */ function $1d9233f60ebd1a44$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, "utf16le");
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $1d9233f60ebd1a44$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $1d9233f60ebd1a44$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, "utf16le").replace($1d9233f60ebd1a44$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $1d9233f60ebd1a44$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, "lpstr-ansi");
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, "utf16le").replace($1d9233f60ebd1a44$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $1d9233f60ebd1a44$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $1d9233f60ebd1a44$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $1d9233f60ebd1a44$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $1d9233f60ebd1a44$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, "utf16le").replace($1d9233f60ebd1a44$var$chr0, "") : "";
    return o;
}
function $1d9233f60ebd1a44$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $1d9233f60ebd1a44$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $1d9233f60ebd1a44$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $1d9233f60ebd1a44$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $1d9233f60ebd1a44$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $1d9233f60ebd1a44$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $1d9233f60ebd1a44$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $1d9233f60ebd1a44$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $1d9233f60ebd1a44$var$write_Hyperlink(hl) {
    var out = $1d9233f60ebd1a44$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $1d9233f60ebd1a44$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $1d9233f60ebd1a44$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $1d9233f60ebd1a44$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $1d9233f60ebd1a44$var$parse_LongRGB(blob, length) {
    var x = $1d9233f60ebd1a44$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $1d9233f60ebd1a44$var$parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function $1d9233f60ebd1a44$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $1d9233f60ebd1a44$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $1d9233f60ebd1a44$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $1d9233f60ebd1a44$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, "i"), itabLast = blob.read_shift(w, "i");
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $1d9233f60ebd1a44$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $1d9233f60ebd1a44$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $1d9233f60ebd1a44$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $1d9233f60ebd1a44$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $1d9233f60ebd1a44$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $1d9233f60ebd1a44$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $1d9233f60ebd1a44$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $1d9233f60ebd1a44$var$parse_Ref = $1d9233f60ebd1a44$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $1d9233f60ebd1a44$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $1d9233f60ebd1a44$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $1d9233f60ebd1a44$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $1d9233f60ebd1a44$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $1d9233f60ebd1a44$var$FtTab = {
    /*::[*/ 0x00: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: $1d9233f60ebd1a44$var$parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: $1d9233f60ebd1a44$var$parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: $1d9233f60ebd1a44$var$parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: $1d9233f60ebd1a44$var$parse_FtCmo
};
function $1d9233f60ebd1a44$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts.push($1d9233f60ebd1a44$var$FtTab[ft](blob, tgt - blob.l));
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $1d9233f60ebd1a44$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $1d9233f60ebd1a44$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case "biff8":
            break;
        case "biff5":
            h = 0x0500;
            w = 8;
            break;
        case "biff4":
            h = 0x0004;
            w = 6;
            break;
        case "biff3":
            h = 0x0003;
            w = 6;
            break;
        case "biff2":
            h = 0x0002;
            w = 4;
            break;
        case "xla":
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $1d9233f60ebd1a44$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $1d9233f60ebd1a44$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $1d9233f60ebd1a44$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $1d9233f60ebd1a44$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $1d9233f60ebd1a44$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $1d9233f60ebd1a44$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $1d9233f60ebd1a44$var$parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = "Worksheet";
            break;
        case 1:
            dt = "Macrosheet";
            break;
        case 2:
            dt = "Chartsheet";
            break;
        case 6:
            dt = "VBAModule";
            break;
    }
    var name = $1d9233f60ebd1a44$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $1d9233f60ebd1a44$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $1d9233f60ebd1a44$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? "sbcs" : "utf16le");
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $1d9233f60ebd1a44$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($1d9233f60ebd1a44$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $1d9233f60ebd1a44$var$write_SST(sst, opts) {
    var header = $1d9233f60ebd1a44$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $1d9233f60ebd1a44$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $1d9233f60ebd1a44$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $1d9233f60ebd1a44$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $1d9233f60ebd1a44$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $1d9233f60ebd1a44$var$parse_ForceFullCalculation(blob) {
    var header = $1d9233f60ebd1a44$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $1d9233f60ebd1a44$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $1d9233f60ebd1a44$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $1d9233f60ebd1a44$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $1d9233f60ebd1a44$var$write_Window1() {
    var o = $1d9233f60ebd1a44$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $1d9233f60ebd1a44$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $1d9233f60ebd1a44$var$write_Window2(view) {
    var o = $1d9233f60ebd1a44$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $1d9233f60ebd1a44$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $1d9233f60ebd1a44$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $1d9233f60ebd1a44$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $1d9233f60ebd1a44$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $1d9233f60ebd1a44$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $1d9233f60ebd1a44$var$parse_LabelSst(blob) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $1d9233f60ebd1a44$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $1d9233f60ebd1a44$var$new_buf(10);
    $1d9233f60ebd1a44$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $1d9233f60ebd1a44$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = $1d9233f60ebd1a44$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $1d9233f60ebd1a44$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $1d9233f60ebd1a44$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $1d9233f60ebd1a44$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? "utf16le" : "sbcs");
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $1d9233f60ebd1a44$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $1d9233f60ebd1a44$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? "sbcs" : "utf16le");
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $1d9233f60ebd1a44$var$parse_BIFF2Format = $1d9233f60ebd1a44$var$parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function $1d9233f60ebd1a44$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $1d9233f60ebd1a44$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $1d9233f60ebd1a44$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $1d9233f60ebd1a44$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $1d9233f60ebd1a44$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $1d9233f60ebd1a44$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($1d9233f60ebd1a44$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $1d9233f60ebd1a44$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $1d9233f60ebd1a44$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $1d9233f60ebd1a44$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $1d9233f60ebd1a44$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $1d9233f60ebd1a44$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $1d9233f60ebd1a44$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function $1d9233f60ebd1a44$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $1d9233f60ebd1a44$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $1d9233f60ebd1a44$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $1d9233f60ebd1a44$var$parse_BoolErr(blob, length, opts) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = $1d9233f60ebd1a44$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? "b" : "e";
    return cell;
}
function $1d9233f60ebd1a44$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $1d9233f60ebd1a44$var$new_buf(8);
    $1d9233f60ebd1a44$var$write_XLSCell(R, C, os, o);
    $1d9233f60ebd1a44$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $1d9233f60ebd1a44$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    var xnum = $1d9233f60ebd1a44$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $1d9233f60ebd1a44$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $1d9233f60ebd1a44$var$new_buf(14);
    $1d9233f60ebd1a44$var$write_XLSCell(R, C, os, o);
    $1d9233f60ebd1a44$var$write_Xnum(v, o);
    return o;
}
var $1d9233f60ebd1a44$var$parse_XLHeaderFooter = $1d9233f60ebd1a44$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $1d9233f60ebd1a44$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($1d9233f60ebd1a44$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $1d9233f60ebd1a44$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $1d9233f60ebd1a44$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $1d9233f60ebd1a44$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $1d9233f60ebd1a44$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $1d9233f60ebd1a44$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function $1d9233f60ebd1a44$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $1d9233f60ebd1a44$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($1d9233f60ebd1a44$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $1d9233f60ebd1a44$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $1d9233f60ebd1a44$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $1d9233f60ebd1a44$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $1d9233f60ebd1a44$var$parse_ShrFmla(blob, length, opts) {
    var ref = $1d9233f60ebd1a44$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $1d9233f60ebd1a44$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $1d9233f60ebd1a44$var$parse_Array(blob, length, opts) {
    var ref = $1d9233f60ebd1a44$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $1d9233f60ebd1a44$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $1d9233f60ebd1a44$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function $1d9233f60ebd1a44$var$parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $1d9233f60ebd1a44$var$parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return $1d9233f60ebd1a44$var$parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function $1d9233f60ebd1a44$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($1d9233f60ebd1a44$var$parse_Ref8U(blob, length));
    return merges;
}
function $1d9233f60ebd1a44$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $1d9233f60ebd1a44$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$1d9233f60ebd1a44$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $1d9233f60ebd1a44$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $1d9233f60ebd1a44$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $1d9233f60ebd1a44$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $1d9233f60ebd1a44$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $1d9233f60ebd1a44$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $1d9233f60ebd1a44$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($1d9233f60ebd1a44$var$parse_BIFF5OT[ot] || $1d9233f60ebd1a44$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $1d9233f60ebd1a44$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $1d9233f60ebd1a44$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $1d9233f60ebd1a44$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $1d9233f60ebd1a44$var$parse_HLink(blob, length) {
    var ref = $1d9233f60ebd1a44$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $1d9233f60ebd1a44$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $1d9233f60ebd1a44$var$write_HLink(hl) {
    var O = $1d9233f60ebd1a44$var$new_buf(24);
    var ref = $1d9233f60ebd1a44$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $1d9233f60ebd1a44$var$bconcat([
        O,
        $1d9233f60ebd1a44$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $1d9233f60ebd1a44$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $1d9233f60ebd1a44$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, "dbcs-cont");
    wzTooltip = wzTooltip.replace($1d9233f60ebd1a44$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $1d9233f60ebd1a44$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $1d9233f60ebd1a44$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $1d9233f60ebd1a44$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $1d9233f60ebd1a44$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $1d9233f60ebd1a44$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $1d9233f60ebd1a44$var$CountryEnum[d] || d;
    return o;
}
function $1d9233f60ebd1a44$var$write_Country(o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $1d9233f60ebd1a44$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($1d9233f60ebd1a44$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $1d9233f60ebd1a44$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($1d9233f60ebd1a44$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $1d9233f60ebd1a44$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $1d9233f60ebd1a44$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $1d9233f60ebd1a44$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $1d9233f60ebd1a44$var$write_ColInfo(col, idx) {
    var o = $1d9233f60ebd1a44$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $1d9233f60ebd1a44$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $1d9233f60ebd1a44$var$parse_Xnum(blob, 8);
    o.footer = $1d9233f60ebd1a44$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $1d9233f60ebd1a44$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $1d9233f60ebd1a44$var$write_RRTabId(n /*:number*/ ) {
    var out = $1d9233f60ebd1a44$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $1d9233f60ebd1a44$var$parse_Blank = $1d9233f60ebd1a44$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $1d9233f60ebd1a44$var$parse_Scl = $1d9233f60ebd1a44$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $1d9233f60ebd1a44$var$parse_String = $1d9233f60ebd1a44$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $1d9233f60ebd1a44$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $1d9233f60ebd1a44$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var str = $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = "str";
    cell.val = str;
    return cell;
}
function $1d9233f60ebd1a44$var$parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = $1d9233f60ebd1a44$var$parse_Xnum(blob, 8);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $1d9233f60ebd1a44$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $1d9233f60ebd1a44$var$new_buf(15);
    $1d9233f60ebd1a44$var$write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, "f");
    return out;
}
function $1d9233f60ebd1a44$var$parse_BIFF2INT(blob) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $1d9233f60ebd1a44$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $1d9233f60ebd1a44$var$new_buf(9);
    $1d9233f60ebd1a44$var$write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function $1d9233f60ebd1a44$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
}
/* TODO: convert to BIFF8 font struct */ function $1d9233f60ebd1a44$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $1d9233f60ebd1a44$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = $1d9233f60ebd1a44$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = "str";
    cell.val = str;
    return cell;
}
var $1d9233f60ebd1a44$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $1d9233f60ebd1a44$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = $1d9233f60ebd1a44$var$evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $1d9233f60ebd1a44$var$new_raw_buf(1);
        switch(opts.type){
            case "base64":
                d = $1d9233f60ebd1a44$var$s2a($1d9233f60ebd1a44$var$Base64_decode(buf));
                break;
            case "binary":
                d = $1d9233f60ebd1a44$var$s2a(buf);
                break;
            case "buffer":
            case "array":
                d = buf;
                break;
        }
        $1d9233f60ebd1a44$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" ? $1d9233f60ebd1a44$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $1d9233f60ebd1a44$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case "B":
                    if ((!vfp || field.len != 8) && opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "G":
                case "P":
                    if (opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "+":
                case "0":
                case "@":
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "O":
                case "T":
                case "Y":
                    break;
                default:
                    throw new Error("Unknown Field Type: " + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $1d9233f60ebd1a44$var$prep_blob(dd, 0);
                var s = typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" ? $1d9233f60ebd1a44$var$$cptable.utils.decode(current_cp, dd) : $1d9233f60ebd1a44$var$a2s(dd);
                switch(fields[C].type){
                    case "C":
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case "D":
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case "F":
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case "+":
                    case "I":
                        out[R][C] = l7 ? dd.read_shift(-4, "i") ^ 0x80000000 : dd.read_shift(4, "i");
                        break;
                    case "L":
                        switch(s.trim().toUpperCase()){
                            case "Y":
                            case "T":
                                out[R][C] = true;
                                break;
                            case "N":
                            case "F":
                                out[R][C] = false;
                                break;
                            case "":
                            case "?":
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case "M":
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case "N":
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case "@":
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, "f") - 0x388317533400);
                        break;
                    case "T":
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case "Y":
                        out[R][C] = dd.read_shift(4, "i") / 1e4 + dd.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                        break;
                    case "O":
                        out[R][C] = -dd.read_shift(-8, "f");
                        break;
                    case "B":
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, "f");
                            break;
                        }
                    /* falls through */ case "G":
                    case "P":
                        dd.l += fields[C].len;
                        break;
                    case "0":
                        if (fields[C].name === "_NullFlags") break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $1d9233f60ebd1a44$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $1d9233f60ebd1a44$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        "B": 8,
        "C": 250,
        "L": 1,
        "D": 8,
        "?": 0,
        "": 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        var old_cp = $1d9233f60ebd1a44$var$current_codepage;
        if (+o.codepage >= 0) $1d9233f60ebd1a44$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $1d9233f60ebd1a44$var$buf_array();
        var aoa /*:AOA*/  = $1d9233f60ebd1a44$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === "number") headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== "string") throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = "", _guess = "", maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = "?";
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case "number":
                        _guess = "B";
                        break;
                    case "string":
                        _guess = "C";
                        break;
                    case "boolean":
                        _guess = "L";
                        break;
                    case "object":
                        _guess = col[j] instanceof Date ? "D" : "C";
                        break;
                    default:
                        _guess = "C";
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" && typeof col[j] == "string" ? $1d9233f60ebd1a44$var$$cptable.utils.encode($1d9233f60ebd1a44$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? "C" : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == "C") {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == "B" && _guess == "N") {
                guess = "N";
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == "C" || _guess == "N" ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $1d9233f60ebd1a44$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $1d9233f60ebd1a44$var$current_codepage + ", using 1252");
            $1d9233f60ebd1a44$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == "?" ? "C" : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case "L":
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case "B":
                        rout.write_shift(8, data[i][j] || 0, "f");
                        break;
                    case "N":
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case "D":
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case "C":
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $1d9233f60ebd1a44$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $1d9233f60ebd1a44$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\x1bN(" + $1d9233f60ebd1a44$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $1d9233f60ebd1a44$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $1d9233f60ebd1a44$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case "base64":
                return sylk_to_aoa_str($1d9233f60ebd1a44$var$Base64_decode(d), opts);
            case "binary":
                return sylk_to_aoa_str(d, opts);
            case "buffer":
                return sylk_to_aoa_str($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(d) ? d.toString("binary") : $1d9233f60ebd1a44$var$a2s(d), opts);
            case "array":
                return sylk_to_aoa_str($1d9233f60ebd1a44$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $1d9233f60ebd1a44$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\x00").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case "ID":
                    break; /* header */ 
                case "E":
                    break; /* EOF */ 
                case "B":
                    break; /* dimensions */ 
                case "O":
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "V":
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case "W":
                    break; /* window */ 
                case "P":
                    switch(record[1].charAt(0)){
                        case "P":
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case "NN":
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "N":
                            nn.Name = record[rj].slice(1);
                            break;
                        case "E":
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $1d9233f60ebd1a44$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case "C":
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "A":
                            break; // TODO: comment
                        case "X":
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "K":
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') {
                                val = val.slice(1, val.length - 1);
                                cell_t = "s";
                            } else if (val === "TRUE" || val === "FALSE") {
                                val = val === "TRUE";
                                cell_t = "b";
                            } else if (!isNaN($1d9233f60ebd1a44$var$fuzzynum(val))) {
                                val = $1d9233f60ebd1a44$var$fuzzynum(val);
                                cell_t = "n";
                                if (next_cell_format !== null && $1d9233f60ebd1a44$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val = $1d9233f60ebd1a44$var$numdate(wb.Workbook.WBProps.date1904 ? val + 1462 : val);
                                    cell_t = "d";
                                }
                            } else if (!isNaN($1d9233f60ebd1a44$var$fuzzydate(val).getDate())) {
                                val = $1d9233f60ebd1a44$var$parseDate(val);
                                cell_t = "d";
                                if (!opts.cellDates) {
                                    cell_t = "n";
                                    val = $1d9233f60ebd1a44$var$datenum(val, wb.Workbook.WBProps.date1904);
                                }
                            }
                            if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $1d9233f60ebd1a44$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case "E":
                            C_seen_E = true;
                            formula = $1d9233f60ebd1a44$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case "S":
                            C_seen_S = true;
                            break;
                        case "G":
                            break; // unknown
                        case "R":
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case "C":
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $1d9233f60ebd1a44$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $1d9233f60ebd1a44$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: "n",
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    break;
                case "F":
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "X":
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "M":
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case "F":
                            break; /* ??? */ 
                        case "G":
                            break; /* hide grid */ 
                        case "P":
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case "S":
                            break; /* cell style */ 
                        case "D":
                            break; /* column */ 
                        case "N":
                            break; /* font */ 
                        case "W":
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case "C":
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case "R":
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $1d9233f60ebd1a44$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht["!rows"] = rowinfo;
        if (colinfo.length > 0) sht["!cols"] = colinfo;
        colinfo.forEach(function(col) {
            $1d9233f60ebd1a44$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $1d9233f60ebd1a44$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $1d9233f60ebd1a44$var$aoa_to_sheet(aoa, _opts);
        $1d9233f60ebd1a44$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $1d9233f60ebd1a44$var$sheet_to_workbook(o, opts);
        $1d9233f60ebd1a44$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case "n":
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $1d9233f60ebd1a44$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case "b":
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case "e":
                o += cell.w || cell.v;
                break;
            case "d":
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case "s":
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == "number" && !col.wpx) col.wpx = $1d9233f60ebd1a44$var$width2px(col.width);
                if (typeof col.wpx == "number" && !col.wch) col.wch = $1d9233f60ebd1a44$var$px2char(col.wpx);
                if (typeof col.wch == "number") rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $1d9233f60ebd1a44$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws["!cols"]) write_ws_cols_sylk(preamble, ws["!cols"]);
        if (ws["!rows"]) write_ws_rows_sylk(preamble, ws["!rows"]);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        for(var R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            var p = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts)); // TODO: pass date1904 info
            }
            o.push(p.join(RS));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $1d9233f60ebd1a44$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case "base64":
                return dif_to_aoa_str($1d9233f60ebd1a44$var$Base64_decode(d), opts);
            case "binary":
                return dif_to_aoa_str(d, opts);
            case "buffer":
                return dif_to_aoa_str($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(d) ? d.toString("binary") : $1d9233f60ebd1a44$var$a2s(d), opts);
            case "array":
                return dif_to_aoa_str($1d9233f60ebd1a44$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === "BOT") {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === "BOT") {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== "EOD") throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === "TRUE") arr[R][C] = true;
                    else if (data === "FALSE") arr[R][C] = false;
                    else if (!isNaN($1d9233f60ebd1a44$var$fuzzynum(value))) arr[R][C] = $1d9233f60ebd1a44$var$fuzzynum(value);
                    else if (!isNaN($1d9233f60ebd1a44$var$fuzzydate(value).getDate())) arr[R][C] = $1d9233f60ebd1a44$var$parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($1d9233f60ebd1a44$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== "" ? data : null;
                    break;
            }
            if (data === "EOD") break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $1d9233f60ebd1a44$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $1d9233f60ebd1a44$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return '1,0\r\n"' + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $1d9233f60ebd1a44$var$DIF_XL;
        var r = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            'TABLE\r\n0,1\r\n"sheetjs"\r\n',
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + '\r\n""\r\n',
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + '\r\n""\r\n',
            'DATA\r\n0,0\r\n""\r\n'
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$1d9233f60ebd1a44$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += '1,0\r\n""\r\n';
                    continue;
                }
                switch(cell.t){
                    case "n":
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += '1,0\r\n""';
                        } else if (cell.v == null) p += '1,0\r\n""';
                        else p += make_value(cell.v, "V");
                        break;
                    case "b":
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case "s":
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case "d":
                        if (!cell.w) cell.w = $1d9233f60ebd1a44$var$SSF_format(cell.z || $1d9233f60ebd1a44$var$table_fmt[14], $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += '1,0\r\n""';
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $1d9233f60ebd1a44$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== "cell") continue;
            var addr = $1d9233f60ebd1a44$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case "t":
                    arr[R][C] = decode(record[3]);
                    break;
                case "v":
                    arr[R][C] = +record[3];
                    break;
                case "vtf":
                    var _f = record[record.length - 1];
                /* falls through */ case "vtc":
                    switch(record[3]){
                        case "nl":
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == "vtf") arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $1d9233f60ebd1a44$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $1d9233f60ebd1a44$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws["!ref"]) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $1d9233f60ebd1a44$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === "z") continue;
            oo = [
                "cell",
                coord,
                "t"
            ];
            switch(cell.t){
                case "s":
                case "str":
                    oo.push(encode(cell.v));
                    break;
                case "n":
                    if (!cell.f) {
                        oo[2] = "v";
                        oo[3] = cell.v;
                    } else {
                        oo[2] = "vtf";
                        oo[3] = "n";
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case "b":
                    oo[2] = "vt" + (cell.f ? "f" : "c");
                    oo[3] = "nl";
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? "TRUE" : "FALSE"));
                    break;
                case "d":
                    var t = $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(cell.v));
                    oo[2] = "vtc";
                    oo[3] = "nd";
                    oo[4] = "" + t;
                    oo[5] = cell.w || $1d9233f60ebd1a44$var$SSF_format(cell.z || $1d9233f60ebd1a44$var$table_fmt[14], t);
                    break;
                case "e":
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $1d9233f60ebd1a44$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === "TRUE") arr[R][C] = true;
        else if (data === "FALSE") arr[R][C] = false;
        else if (!isNaN($1d9233f60ebd1a44$var$fuzzynum(data))) arr[R][C] = $1d9233f60ebd1a44$var$fuzzynum(data);
        else if (!isNaN($1d9233f60ebd1a44$var$fuzzydate(data).getDate())) arr[R][C] = $1d9233f60ebd1a44$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ",",
        /*::[*/ 0x09: "	",
        /*::[*/ 0x3B: ";",
        /*::[*/ 0x7C: "|"
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($1d9233f60ebd1a44$var$DENSE != null && o.dense == null) o.dense = $1d9233f60ebd1a44$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $1d9233f60ebd1a44$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = "z";
            else if (o.raw) {
                cell.t = "s";
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = "s";
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = "s";
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($1d9233f60ebd1a44$var$fuzzyfmla(s)) {
                    cell.t = "n";
                    cell.f = s.slice(1);
                } else {
                    cell.t = "s";
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = "b";
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = "b";
                cell.v = false;
            } else if (!isNaN(v = $1d9233f60ebd1a44$var$fuzzynum(s))) {
                cell.t = "n";
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN((v = $1d9233f60ebd1a44$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $1d9233f60ebd1a44$var$table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = $1d9233f60ebd1a44$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                    v = $1d9233f60ebd1a44$var$parseDate(s, k);
                }
                if (o.cellDates) {
                    cell.t = "d";
                    cell.v = v;
                } else {
                    cell.t = "n";
                    cell.v = $1d9233f60ebd1a44$var$datenum(v);
                }
                if (o.cellText !== false) cell.w = $1d9233f60ebd1a44$var$SSF_format(cell.z, cell.v instanceof Date ? $1d9233f60ebd1a44$var$datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = "s";
                cell.v = s;
            }
            if (cell.t == "z") ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$1d9233f60ebd1a44$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("	") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $1d9233f60ebd1a44$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == "string" ? [
            0,
            0,
            0,
            0
        ] : $1d9233f60ebd1a44$var$firstbyte(d, opts);
        switch(opts.type){
            case "base64":
                str = $1d9233f60ebd1a44$var$Base64_decode(d);
                break;
            case "binary":
                str = d;
                break;
            case "buffer":
                if (opts.codepage == 65001) str = d.toString("utf8"); // TODO: test if buf
                else if (opts.codepage && typeof $1d9233f60ebd1a44$var$$cptable !== "undefined") str = $1d9233f60ebd1a44$var$$cptable.utils.decode(opts.codepage, d);
                else str = $1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(d) ? d.toString("binary") : $1d9233f60ebd1a44$var$a2s(d);
                break;
            case "array":
                str = $1d9233f60ebd1a44$var$cc2str(d);
                break;
            case "string":
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $1d9233f60ebd1a44$var$utf8read(str.slice(3));
        else if (opts.type != "string" && opts.type != "buffer" && opts.codepage == 65001) str = $1d9233f60ebd1a44$var$utf8read(str);
        else if (opts.type == "binary" && typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" && opts.codepage) str = $1d9233f60ebd1a44$var$$cptable.utils.decode(opts.codepage, $1d9233f60ebd1a44$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $1d9233f60ebd1a44$var$ETH.to_sheet(opts.type == "string" ? str : $1d9233f60ebd1a44$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $1d9233f60ebd1a44$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $1d9233f60ebd1a44$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($1d9233f60ebd1a44$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $1d9233f60ebd1a44$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $1d9233f60ebd1a44$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return $1d9233f60ebd1a44$var$PRN.to_workbook(d, opts);
    }
}
var $1d9233f60ebd1a44$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $1d9233f60ebd1a44$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case "base64":
                return lotus_to_workbook_buf($1d9233f60ebd1a44$var$s2a($1d9233f60ebd1a44$var$Base64_decode(d)), opts);
            case "binary":
                return lotus_to_workbook_buf($1d9233f60ebd1a44$var$s2a(d), opts);
            case "buffer":
            case "array":
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($1d9233f60ebd1a44$var$DENSE != null && o.dense == null) o.dense = $1d9233f60ebd1a44$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        if (o.works || o.works2) val[1].v = val[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || $1d9233f60ebd1a44$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = "d";
                                val[1].v = $1d9233f60ebd1a44$var$numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val[0].r] || [])[val[0].c] : s[$1d9233f60ebd1a44$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$1d9233f60ebd1a44$var$encode_cell(val[0])] = val[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val[1].v = val[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$1d9233f60ebd1a44$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $1d9233f60ebd1a44$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $1d9233f60ebd1a44$var$buf_array();
        var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $1d9233f60ebd1a44$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = $1d9233f60ebd1a44$var$format_cell(cell);
                    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $1d9233f60ebd1a44$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $1d9233f60ebd1a44$var$buf_array();
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $1d9233f60ebd1a44$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $1d9233f60ebd1a44$var$format_cell(cell);
                        /* TODO: max len? */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $1d9233f60ebd1a44$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $1d9233f60ebd1a44$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $1d9233f60ebd1a44$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $1d9233f60ebd1a44$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, "i");
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = $1d9233f60ebd1a44$var$new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, "i");
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, "f");
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = $1d9233f60ebd1a44$var$new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, "f");
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, "f");
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $1d9233f60ebd1a44$var$encode_col(V) : $1d9233f60ebd1a44$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        // 0x36 DATE
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        // 0x40 TIME
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $1d9233f60ebd1a44$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, "f"));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = "s";
        o[1].v = blob.read_shift(length - 4, "cstr");
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $1d9233f60ebd1a44$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $1d9233f60ebd1a44$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, "f");
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, "cstr") : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, "cstr");
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $1d9233f60ebd1a44$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: $1d9233f60ebd1a44$var$parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0x00FF: {
            n: "BOF",
            f: $1d9233f60ebd1a44$var$parseuint16
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $1d9233f60ebd1a44$var$prep_blob(d, 0);
        var o = opts || {};
        if ($1d9233f60ebd1a44$var$DENSE != null && o.dense == null) o.dense = $1d9233f60ebd1a44$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $1d9233f60ebd1a44$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, "cstr"));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, "cstr");
                    }
                    if (!sname) sname = $1d9233f60ebd1a44$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
                    $1d9233f60ebd1a44$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $1d9233f60ebd1a44$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1);
                        if (flags & 0x80) p.l += 2;
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, "i")
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, "f")
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, "f")
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, "i");
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = cell;
                            } else s[CC + $1d9233f60ebd1a44$var$encode_row(R)] = cell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $1d9233f60ebd1a44$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $1d9233f60ebd1a44$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($1d9233f60ebd1a44$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $1d9233f60ebd1a44$var$parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case "<condense":
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case "<extend":
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case "<shadow":
                if (!y.val) break;
            /* falls through */ case "<shadow>":
            case "<shadow/>":
                font.shadow = 1;
                break;
            case "</shadow>":
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case "<charset":
                if (y.val == "1") break;
                font.cp = $1d9233f60ebd1a44$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case "<outline":
                if (!y.val) break;
            /* falls through */ case "<outline>":
            case "<outline/>":
                font.outline = 1;
                break;
            case "</outline>":
                break;
            /* 18.4.5 rFont CT_FontName */ case "<rFont":
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                if (!y.val) break;
            /* falls through */ case "<strike>":
            case "<strike/>":
                font.strike = 1;
                break;
            case "</strike>":
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                if (!y.val) break;
                switch(y.val){
                    case "double":
                        font.uval = "double";
                        break;
                    case "singleAccounting":
                        font.uval = "single-accounting";
                        break;
                    case "doubleAccounting":
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case "<u>":
            case "<u/>":
                font.u = 1;
                break;
            case "</u>":
                break;
            /* 18.8.2 b */ case "<b":
                if (y.val == "0") break;
            /* falls through */ case "<b>":
            case "<b/>":
                font.b = 1;
                break;
            case "</b>":
                break;
            /* 18.8.26 i */ case "<i":
                if (y.val == "0") break;
            /* falls through */ case "<i>":
            case "<i/>":
                font.i = 1;
                break;
            case "</i>":
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case "<color":
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case "<color>":
            case "<color/>":
            case "</color>":
                break;
            /* 18.8.18 family ST_FontFamily */ case "<family":
                font.family = y.val;
                break;
            case "<family>":
            case "<family/>":
            case "</family>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case "<vertAlign":
                font.valign = y.val;
                break;
            case "<vertAlign>":
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case "<scheme":
                break;
            case "<scheme>":
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error("Unrecognized rich format " + y[0]);
        }
    }
    return font;
}
var $1d9233f60ebd1a44$var$parse_rs = /*#__PURE__*/ function() {
    var tregex = $1d9233f60ebd1a44$var$matchtag("t"), rpregex = $1d9233f60ebd1a44$var$matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: "s",
            v: $1d9233f60ebd1a44$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = $1d9233f60ebd1a44$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $1d9233f60ebd1a44$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, "<br/>") + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $1d9233f60ebd1a44$var$sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, $1d9233f60ebd1a44$var$sirregex = /<(?:\w+:)?r\b[^>]*>/;
var $1d9233f60ebd1a44$var$sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function $1d9233f60ebd1a44$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $1d9233f60ebd1a44$var$utf8read(x);
        if (html) z.h = $1d9233f60ebd1a44$var$escapehtml(z.t);
    } else if (/*y = */ x.match($1d9233f60ebd1a44$var$sirregex)) {
        z.r = $1d9233f60ebd1a44$var$utf8read(x);
        z.t = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read((x.replace($1d9233f60ebd1a44$var$sirphregex, "").match($1d9233f60ebd1a44$var$sitregex) || []).join("").replace($1d9233f60ebd1a44$var$tagregex, "")), true);
        if (html) z.h = $1d9233f60ebd1a44$var$rs_to_html($1d9233f60ebd1a44$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $1d9233f60ebd1a44$var$sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var $1d9233f60ebd1a44$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $1d9233f60ebd1a44$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $1d9233f60ebd1a44$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match($1d9233f60ebd1a44$var$sstr0);
    if (sst) {
        ss = sst[2].replace($1d9233f60ebd1a44$var$sstr1, "").split($1d9233f60ebd1a44$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $1d9233f60ebd1a44$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $1d9233f60ebd1a44$var$parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $1d9233f60ebd1a44$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $1d9233f60ebd1a44$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER
    ];
    o[o.length] = $1d9233f60ebd1a44$var$writextag("sst", null, {
        xmlns: $1d9233f60ebd1a44$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($1d9233f60ebd1a44$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $1d9233f60ebd1a44$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = "</sst>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $1d9233f60ebd1a44$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $1d9233f60ebd1a44$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $1d9233f60ebd1a44$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $1d9233f60ebd1a44$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $1d9233f60ebd1a44$var$write_BrtSSTItem = $1d9233f60ebd1a44$var$write_RichStr;
function $1d9233f60ebd1a44$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    $1d9233f60ebd1a44$var$write_record(ba, 0x009F /* BrtBeginSst */ , $1d9233f60ebd1a44$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$1d9233f60ebd1a44$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $1d9233f60ebd1a44$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $1d9233f60ebd1a44$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $1d9233f60ebd1a44$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined") return $1d9233f60ebd1a44$var$$cptable.utils.encode($1d9233f60ebd1a44$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $1d9233f60ebd1a44$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, "lpp4");
    o.R = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    o.U = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    o.W = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $1d9233f60ebd1a44$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, "lpp4")
    });
    o.name = blob.read_shift(0, "lpp4");
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $1d9233f60ebd1a44$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($1d9233f60ebd1a44$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $1d9233f60ebd1a44$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, "lpp4"));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $1d9233f60ebd1a44$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, "lpp4");
    o.name = blob.read_shift(0, "lpp4");
    o.R = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    o.U = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    o.W = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $1d9233f60ebd1a44$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $1d9233f60ebd1a44$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, "8lpp4");
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $1d9233f60ebd1a44$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw "Unrecognized encryption algorithm: " + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, "utf16le");
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $1d9233f60ebd1a44$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $1d9233f60ebd1a44$var$parse_EncryptionInfo(blob) {
    var vers = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $1d9233f60ebd1a44$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $1d9233f60ebd1a44$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $1d9233f60ebd1a44$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $1d9233f60ebd1a44$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $1d9233f60ebd1a44$var$parse_EncryptionHeader(blob, sz);
    var verifier = $1d9233f60ebd1a44$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $1d9233f60ebd1a44$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $1d9233f60ebd1a44$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, "utf8");
    var o = {};
    xml.replace($1d9233f60ebd1a44$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<encryption":
            case "</encryption>":
                break;
            case "<keyData":
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case "<dataIntegrity":
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case "<keyEncryptors>":
            case "<keyEncryptors":
                o.encs = [];
                break;
            case "</keyEncryptors>":
                break;
            case "<keyEncryptor":
                o.uri = y.uri;
                break;
            case "</keyEncryptor>":
                break;
            case "<encryptedKey":
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $1d9233f60ebd1a44$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error("unrecognized minor version code: " + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error("unrecognized major version code: " + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $1d9233f60ebd1a44$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $1d9233f60ebd1a44$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $1d9233f60ebd1a44$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $1d9233f60ebd1a44$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw "unrecognized version code " + vers.Major + " : " + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $1d9233f60ebd1a44$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $1d9233f60ebd1a44$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $1d9233f60ebd1a44$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $1d9233f60ebd1a44$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $1d9233f60ebd1a44$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $1d9233f60ebd1a44$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $1d9233f60ebd1a44$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $1d9233f60ebd1a44$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $1d9233f60ebd1a44$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $1d9233f60ebd1a44$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $1d9233f60ebd1a44$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $1d9233f60ebd1a44$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $1d9233f60ebd1a44$var$parseuint16(blob),
        verificationBytes: $1d9233f60ebd1a44$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $1d9233f60ebd1a44$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $1d9233f60ebd1a44$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $1d9233f60ebd1a44$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $1d9233f60ebd1a44$var$parse_RC4Header(blob, length);
    else o.Data = $1d9233f60ebd1a44$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $1d9233f60ebd1a44$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $1d9233f60ebd1a44$var$parse_FilePassHeader(blob, length - 2, o);
    else $1d9233f60ebd1a44$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $1d9233f60ebd1a44$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $1d9233f60ebd1a44$var$rtf_to_sheet_str($1d9233f60ebd1a44$var$Base64_decode(d), opts);
        case "binary":
            return $1d9233f60ebd1a44$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $1d9233f60ebd1a44$var$rtf_to_sheet_str($1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(d) ? d.toString("binary") : $1d9233f60ebd1a44$var$a2s(d), opts);
        case "array":
            return $1d9233f60ebd1a44$var$rtf_to_sheet_str($1d9233f60ebd1a44$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $1d9233f60ebd1a44$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = str.match(/\\trowd[\s\S]*?\\row\b/g);
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($1d9233f60ebd1a44$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $1d9233f60ebd1a44$var$fuzzynum(cell.v);
                        }
                        if (dense) row[C] = cell;
                        else ws[$1d9233f60ebd1a44$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
    return ws;
}
function $1d9233f60ebd1a44$var$rtf_to_workbook(d, opts) {
    var wb = $1d9233f60ebd1a44$var$sheet_to_workbook($1d9233f60ebd1a44$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $1d9233f60ebd1a44$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $1d9233f60ebd1a44$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($1d9233f60ebd1a44$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $1d9233f60ebd1a44$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $1d9233f60ebd1a44$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $1d9233f60ebd1a44$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $1d9233f60ebd1a44$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $1d9233f60ebd1a44$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $1d9233f60ebd1a44$var$rgb2HSL($1d9233f60ebd1a44$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $1d9233f60ebd1a44$var$rgb2Hex($1d9233f60ebd1a44$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $1d9233f60ebd1a44$var$DEF_MDW = 6, $1d9233f60ebd1a44$var$MAX_MDW = 15, $1d9233f60ebd1a44$var$MIN_MDW = 1, $1d9233f60ebd1a44$var$MDW = $1d9233f60ebd1a44$var$DEF_MDW;
function $1d9233f60ebd1a44$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $1d9233f60ebd1a44$var$MDW) / 256) * $1d9233f60ebd1a44$var$MDW);
}
function $1d9233f60ebd1a44$var$px2char(px) {
    return Math.floor((px - 5) / $1d9233f60ebd1a44$var$MDW * 100 + 0.5) / 100;
}
function $1d9233f60ebd1a44$var$char2width(chr) {
    return Math.round((chr * $1d9233f60ebd1a44$var$MDW + 5) / $1d9233f60ebd1a44$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $1d9233f60ebd1a44$var$cycle_width(collw) {
    return $1d9233f60ebd1a44$var$char2width($1d9233f60ebd1a44$var$px2char($1d9233f60ebd1a44$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $1d9233f60ebd1a44$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $1d9233f60ebd1a44$var$cycle_width(collw)), _MDW = $1d9233f60ebd1a44$var$MDW;
    if (delta > 0.005) {
        for($1d9233f60ebd1a44$var$MDW = $1d9233f60ebd1a44$var$MIN_MDW; $1d9233f60ebd1a44$var$MDW < $1d9233f60ebd1a44$var$MAX_MDW; ++$1d9233f60ebd1a44$var$MDW)if (Math.abs(collw - $1d9233f60ebd1a44$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $1d9233f60ebd1a44$var$cycle_width(collw));
            _MDW = $1d9233f60ebd1a44$var$MDW;
        }
    }
    $1d9233f60ebd1a44$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $1d9233f60ebd1a44$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $1d9233f60ebd1a44$var$width2px(coll.width);
        coll.wch = $1d9233f60ebd1a44$var$px2char(coll.wpx);
        coll.MDW = $1d9233f60ebd1a44$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $1d9233f60ebd1a44$var$px2char(coll.wpx);
        coll.width = $1d9233f60ebd1a44$var$char2width(coll.wch);
        coll.MDW = $1d9233f60ebd1a44$var$MDW;
    } else if (typeof coll.wch == "number") {
        coll.width = $1d9233f60ebd1a44$var$char2width(coll.wch);
        coll.wpx = $1d9233f60ebd1a44$var$width2px(coll.width);
        coll.MDW = $1d9233f60ebd1a44$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $1d9233f60ebd1a44$var$DEF_PPI = 96, $1d9233f60ebd1a44$var$PPI = $1d9233f60ebd1a44$var$DEF_PPI;
function $1d9233f60ebd1a44$var$px2pt(px) {
    return px * 96 / $1d9233f60ebd1a44$var$PPI;
}
function $1d9233f60ebd1a44$var$pt2px(pt) {
    return pt * $1d9233f60ebd1a44$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $1d9233f60ebd1a44$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $1d9233f60ebd1a44$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<borders":
            case "<borders>":
            case "</borders>":
                break;
            /* 18.8.4 border CT_Border */ case "<border":
            case "<border>":
            case "<border/>":
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $1d9233f60ebd1a44$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $1d9233f60ebd1a44$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case "</border>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<left/>":
                break;
            case "<left":
            case "<left>":
                break;
            case "</left>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<right/>":
                break;
            case "<right":
            case "<right>":
                break;
            case "</right>":
                break;
            /* 18.8.43 top CT_BorderPr */ case "<top/>":
                break;
            case "<top":
            case "<top>":
                break;
            case "</top>":
                break;
            /* 18.8.6 bottom CT_BorderPr */ case "<bottom/>":
                break;
            case "<bottom":
            case "<bottom>":
                break;
            case "</bottom>":
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case "<diagonal":
            case "<diagonal>":
            case "<diagonal/>":
                break;
            case "</diagonal>":
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case "<horizontal":
            case "<horizontal>":
            case "<horizontal/>":
                break;
            case "</horizontal>":
                break;
            /* 18.8.44 vertical CT_BorderPr */ case "<vertical":
            case "<vertical>":
            case "<vertical/>":
                break;
            case "</vertical>":
                break;
            /* 18.8.37 start CT_BorderPr */ case "<start":
            case "<start>":
            case "<start/>":
                break;
            case "</start>":
                break;
            /* 18.8.16 end CT_BorderPr */ case "<end":
            case "<end>":
            case "<end/>":
                break;
            case "</end>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color>":
                break;
            case "<color/>":
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in borders");
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $1d9233f60ebd1a44$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<fills":
            case "<fills>":
            case "</fills>":
                break;
            /* 18.8.20 fill CT_Fill */ case "<fill>":
            case "<fill":
            case "<fill/>":
                fill = {};
                styles.Fills.push(fill);
                break;
            case "</fill>":
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case "<gradientFill>":
                break;
            case "<gradientFill":
            case "</gradientFill>":
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case "<patternFill":
            case "<patternFill>":
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case "<patternFill/>":
            case "</patternFill>":
                break;
            /* 18.8.3 bgColor CT_Color */ case "<bgColor":
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case "<bgColor/>":
            case "</bgColor>":
                break;
            /* 18.8.19 fgColor CT_Color */ case "<fgColor":
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case "<fgColor/>":
            case "</fgColor>":
                break;
            /* 18.8.38 stop CT_GradientStop */ case "<stop":
            case "<stop/>":
                break;
            case "</stop>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color/>":
                break;
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fills");
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $1d9233f60ebd1a44$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<fonts":
            case "<fonts>":
            case "</fonts>":
                break;
            /* 18.8.22 font CT_Font */ case "<font":
            case "<font>":
                break;
            case "</font>":
            case "<font/>":
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case "<name":
                if (y.val) font.name = $1d9233f60ebd1a44$var$utf8read(y.val);
                break;
            case "<name/>":
            case "</name>":
                break;
            /* 18.8.2  b CT_BooleanProperty */ case "<b":
                font.bold = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<b/>":
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case "<i":
                font.italic = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<i/>":
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case "<u/>":
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                font.strike = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<strike/>":
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case "<outline":
                font.outline = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<outline/>":
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case "<shadow":
                font.shadow = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<shadow/>":
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case "<condense":
                font.condense = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<condense/>":
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case "<extend":
                font.extend = y.val ? $1d9233f60ebd1a44$var$parsexmlbool(y.val) : 1;
                break;
            case "<extend/>":
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                if (y.val) font.sz = +y.val;
                break;
            case "<sz/>":
            case "</sz>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case "<vertAlign":
                if (y.val) font.vertAlign = y.val;
                break;
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.18 family CT_FontFamily */ case "<family":
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case "<family/>":
            case "</family>":
                break;
            /* 18.8.35 scheme CT_FontScheme */ case "<scheme":
                if (y.val) font.scheme = y.val;
                break;
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.4.1 charset CT_IntProperty */ case "<charset":
                if (y.val == "1") break;
                y.codepage = $1d9233f60ebd1a44$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case "<color":
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $1d9233f60ebd1a44$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $1d9233f60ebd1a44$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $1d9233f60ebd1a44$var$XLSIcv[1];
                    if (!icv) icv = $1d9233f60ebd1a44$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $1d9233f60ebd1a44$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case "<color/>":
            case "</color>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fonts");
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $1d9233f60ebd1a44$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $1d9233f60ebd1a44$var$keys($1d9233f60ebd1a44$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $1d9233f60ebd1a44$var$table_fmt[k[i]];
    var m = t[0].match($1d9233f60ebd1a44$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $1d9233f60ebd1a44$var$parsexmltag(m[i]);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<numFmts":
            case "</numFmts>":
            case "<numFmts/>":
            case "<numFmts>":
                break;
            case "<numFmt":
                var f = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $1d9233f60ebd1a44$var$SSF__load(f, j);
                }
                break;
            case "</numFmt>":
                break;
            default:
                if (opts.WTF) throw new Error("unrecognized " + y[0] + " in numFmts");
        }
    }
}
function $1d9233f60ebd1a44$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $1d9233f60ebd1a44$var$writextag("numFmt", null, {
            numFmtId: i,
            formatCode: $1d9233f60ebd1a44$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $1d9233f60ebd1a44$var$writextag("numFmts", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $1d9233f60ebd1a44$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $1d9233f60ebd1a44$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $1d9233f60ebd1a44$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x), i = 0;
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<cellXfs":
            case "<cellXfs>":
            case "<cellXfs/>":
            case "</cellXfs>":
                break;
            /* 18.8.45 xf CT_Xf */ case "<xf":
            case "<xf/>":
                xf = y;
                delete xf[0];
                for(i = 0; i < $1d9233f60ebd1a44$var$cellXF_uint.length; ++i)if (xf[$1d9233f60ebd1a44$var$cellXF_uint[i]]) xf[$1d9233f60ebd1a44$var$cellXF_uint[i]] = parseInt(xf[$1d9233f60ebd1a44$var$cellXF_uint[i]], 10);
                for(i = 0; i < $1d9233f60ebd1a44$var$cellXF_bool.length; ++i)if (xf[$1d9233f60ebd1a44$var$cellXF_bool[i]]) xf[$1d9233f60ebd1a44$var$cellXF_bool[i]] = $1d9233f60ebd1a44$var$parsexmlbool(xf[$1d9233f60ebd1a44$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case "</xf>":
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case "<alignment":
            case "<alignment/>":
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $1d9233f60ebd1a44$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case "</alignment>":
                break;
            /* 18.8.33 protection CT_CellProtection */ case "<protection":
                break;
            case "</protection>":
            case "<protection/>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in cellXfs");
                }
        }
    });
}
function $1d9233f60ebd1a44$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $1d9233f60ebd1a44$var$writextag("cellXfs", null);
    cellXfs.forEach(function(c) {
        o[o.length] = $1d9233f60ebd1a44$var$writextag("xf", null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $1d9233f60ebd1a44$var$writextag("cellXfs", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $1d9233f60ebd1a44$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) $1d9233f60ebd1a44$var$parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) $1d9233f60ebd1a44$var$parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) $1d9233f60ebd1a44$var$parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) $1d9233f60ebd1a44$var$parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) $1d9233f60ebd1a44$var$parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $1d9233f60ebd1a44$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("styleSheet", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS_main[0],
            "xmlns:vt": $1d9233f60ebd1a44$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $1d9233f60ebd1a44$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $1d9233f60ebd1a44$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = "</styleSheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $1d9233f60ebd1a44$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $1d9233f60ebd1a44$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $1d9233f60ebd1a44$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $1d9233f60ebd1a44$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $1d9233f60ebd1a44$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $1d9233f60ebd1a44$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $1d9233f60ebd1a44$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $1d9233f60ebd1a44$var$parse_XLWideString(data, length - 21);
    return out;
}
function $1d9233f60ebd1a44$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $1d9233f60ebd1a44$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $1d9233f60ebd1a44$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $1d9233f60ebd1a44$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $1d9233f60ebd1a44$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $1d9233f60ebd1a44$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $1d9233f60ebd1a44$var$parse_BrtFill = $1d9233f60ebd1a44$var$parsenoop;
function $1d9233f60ebd1a44$var$write_BrtFill(fill, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(84);
    if (!$1d9233f60ebd1a44$var$rev_XLSBFillPTNames) $1d9233f60ebd1a44$var$rev_XLSBFillPTNames = $1d9233f60ebd1a44$var$evert($1d9233f60ebd1a44$var$XLSBFillPTNames);
    var fls /*:number*/  = $1d9233f60ebd1a44$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $1d9233f60ebd1a44$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $1d9233f60ebd1a44$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $1d9233f60ebd1a44$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $1d9233f60ebd1a44$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $1d9233f60ebd1a44$var$write_Blxf(data, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $1d9233f60ebd1a44$var$parse_BrtBorder = $1d9233f60ebd1a44$var$parsenoop;
function $1d9233f60ebd1a44$var$write_BrtBorder(border, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $1d9233f60ebd1a44$var$write_Blxf(null, o); /* top */ 
    $1d9233f60ebd1a44$var$write_Blxf(null, o); /* bottom */ 
    $1d9233f60ebd1a44$var$write_Blxf(null, o); /* left */ 
    $1d9233f60ebd1a44$var$write_Blxf(null, o); /* right */ 
    $1d9233f60ebd1a44$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $1d9233f60ebd1a44$var$write_BrtStyle(style, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $1d9233f60ebd1a44$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $1d9233f60ebd1a44$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $1d9233f60ebd1a44$var$new_buf(2052);
    o.write_shift(4, cnt);
    $1d9233f60ebd1a44$var$write_XLNullableWideString(defTableStyle, o);
    $1d9233f60ebd1a44$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $1d9233f60ebd1a44$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $1d9233f60ebd1a44$var$table_fmt)styles.NumberFmt[y] = $1d9233f60ebd1a44$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $1d9233f60ebd1a44$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $1d9233f60ebd1a44$var$SSF__load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $1d9233f60ebd1a44$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $1d9233f60ebd1a44$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $1d9233f60ebd1a44$var$write_record(ba, 0x002C /* BrtFmt */ , $1d9233f60ebd1a44$var$write_BrtFmt(i, NF[i]));
    });
    $1d9233f60ebd1a44$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $1d9233f60ebd1a44$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    $1d9233f60ebd1a44$var$write_record(ba, 0x002B /* BrtFont */ , $1d9233f60ebd1a44$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $1d9233f60ebd1a44$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $1d9233f60ebd1a44$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x025B /* BrtBeginFills */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    $1d9233f60ebd1a44$var$write_record(ba, 0x002D /* BrtFill */ , $1d9233f60ebd1a44$var$write_BrtFill({
        patternType: "none"
    }));
    $1d9233f60ebd1a44$var$write_record(ba, 0x002D /* BrtFill */ , $1d9233f60ebd1a44$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $1d9233f60ebd1a44$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $1d9233f60ebd1a44$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    $1d9233f60ebd1a44$var$write_record(ba, 0x002E /* BrtBorder */ , $1d9233f60ebd1a44$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $1d9233f60ebd1a44$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $1d9233f60ebd1a44$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    $1d9233f60ebd1a44$var$write_record(ba, 0x002F /* BrtXF */ , $1d9233f60ebd1a44$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $1d9233f60ebd1a44$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $1d9233f60ebd1a44$var$write_CELLXFS_bin(ba, data) {
    $1d9233f60ebd1a44$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $1d9233f60ebd1a44$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $1d9233f60ebd1a44$var$write_record(ba, 0x002F /* BrtXF */ , $1d9233f60ebd1a44$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $1d9233f60ebd1a44$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $1d9233f60ebd1a44$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $1d9233f60ebd1a44$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    $1d9233f60ebd1a44$var$write_record(ba, 0x0030 /* BrtStyle */ , $1d9233f60ebd1a44$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $1d9233f60ebd1a44$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $1d9233f60ebd1a44$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $1d9233f60ebd1a44$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $1d9233f60ebd1a44$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $1d9233f60ebd1a44$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $1d9233f60ebd1a44$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $1d9233f60ebd1a44$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $1d9233f60ebd1a44$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $1d9233f60ebd1a44$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $1d9233f60ebd1a44$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $1d9233f60ebd1a44$var$write_sty_bin(wb, opts) {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    $1d9233f60ebd1a44$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $1d9233f60ebd1a44$var$write_FMTS_bin(ba, wb.SSF);
    $1d9233f60ebd1a44$var$write_FONTS_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_FILLS_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_BORDERS_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_CELLSTYLEXFS_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $1d9233f60ebd1a44$var$write_STYLES_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_DXFS_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_TABLESTYLES_bin(ba, wb);
    $1d9233f60ebd1a44$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $1d9233f60ebd1a44$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $1d9233f60ebd1a44$var$XLSXThemeClrScheme = [
    "</a:lt1>",
    "</a:dk1>",
    "</a:lt2>",
    "</a:dk2>",
    "</a:accent1>",
    "</a:accent2>",
    "</a:accent3>",
    "</a:accent4>",
    "</a:accent5>",
    "</a:accent6>",
    "</a:hlink>",
    "</a:folHlink>"
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $1d9233f60ebd1a44$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case "<a:clrScheme":
            case "</a:clrScheme>":
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case "<a:srgbClr":
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case "<a:sysClr":
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case "<a:dk1>":
            case "</a:dk1>":
            case "<a:lt1>":
            case "</a:lt1>":
            case "<a:dk2>":
            case "</a:dk2>":
            case "<a:lt2>":
            case "</a:lt2>":
            case "<a:accent1>":
            case "</a:accent1>":
            case "<a:accent2>":
            case "</a:accent2>":
            case "<a:accent3>":
            case "</a:accent3>":
            case "<a:accent4>":
            case "</a:accent4>":
            case "<a:accent5>":
            case "</a:accent5>":
            case "<a:accent6>":
            case "</a:accent6>":
            case "<a:hlink>":
            case "</a:hlink>":
            case "<a:folHlink>":
            case "</a:folHlink>":
                if (y[0].charAt(1) === "/") {
                    themes.themeElements.clrScheme[$1d9233f60ebd1a44$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error("Unrecognized " + y[0] + " in clrScheme");
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $1d9233f60ebd1a44$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $1d9233f60ebd1a44$var$parse_fmtScheme() {}
var $1d9233f60ebd1a44$var$clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var $1d9233f60ebd1a44$var$fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var $1d9233f60ebd1a44$var$fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function $1d9233f60ebd1a44$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            "clrScheme",
            $1d9233f60ebd1a44$var$clrsregex,
            $1d9233f60ebd1a44$var$parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            "fontScheme",
            $1d9233f60ebd1a44$var$fntsregex,
            $1d9233f60ebd1a44$var$parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            "fmtScheme",
            $1d9233f60ebd1a44$var$fmtsregex,
            $1d9233f60ebd1a44$var$parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + " not found in themeElements");
        m[2](t, themes, opts);
    });
}
var $1d9233f60ebd1a44$var$themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function $1d9233f60ebd1a44$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $1d9233f60ebd1a44$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match($1d9233f60ebd1a44$var$themeltregex))) throw new Error("themeElements not found in theme");
    $1d9233f60ebd1a44$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $1d9233f60ebd1a44$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = "<a:themeElements>";
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = "</a:clrScheme>";
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = "<a:majorFont>";
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:majorFont>";
    o[o.length] = "<a:minorFont>";
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:minorFont>";
    o[o.length] = "</a:fontScheme>";
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = "<a:fillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:fillStyleLst>";
    o[o.length] = "<a:lnStyleLst>";
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = "</a:lnStyleLst>";
    o[o.length] = "<a:effectStyleLst>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "</a:effectStyleLst>";
    o[o.length] = "<a:bgFillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:bgFillStyleLst>";
    o[o.length] = "</a:fmtScheme>";
    o[o.length] = "</a:themeElements>";
    o[o.length] = "<a:objectDefaults>";
    o[o.length] = "<a:spDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = "</a:spDef>";
    o[o.length] = "<a:lnDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = "</a:lnDef>";
    o[o.length] = "</a:objectDefaults>";
    o[o.length] = "<a:extraClrSchemeLst/>";
    o[o.length] = "</a:theme>";
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $1d9233f60ebd1a44$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $1d9233f60ebd1a44$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $1d9233f60ebd1a44$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $1d9233f60ebd1a44$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $1d9233f60ebd1a44$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $1d9233f60ebd1a44$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $1d9233f60ebd1a44$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $1d9233f60ebd1a44$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $1d9233f60ebd1a44$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $1d9233f60ebd1a44$var$parse_IcvXF(blob, length) {
    return $1d9233f60ebd1a44$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $1d9233f60ebd1a44$var$parse_XFExtGradient(blob, length) {
    return $1d9233f60ebd1a44$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $1d9233f60ebd1a44$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $1d9233f60ebd1a44$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $1d9233f60ebd1a44$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $1d9233f60ebd1a44$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($1d9233f60ebd1a44$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $1d9233f60ebd1a44$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $1d9233f60ebd1a44$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $1d9233f60ebd1a44$var$parse_XLWideString(data, length - 8)
    };
}
function $1d9233f60ebd1a44$var$write_BrtMdtinfo(data) {
    var o = $1d9233f60ebd1a44$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $1d9233f60ebd1a44$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $1d9233f60ebd1a44$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $1d9233f60ebd1a44$var$write_BrtMdb(mdb) {
    var o = $1d9233f60ebd1a44$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $1d9233f60ebd1a44$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $1d9233f60ebd1a44$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $1d9233f60ebd1a44$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $1d9233f60ebd1a44$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $1d9233f60ebd1a44$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $1d9233f60ebd1a44$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $1d9233f60ebd1a44$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $1d9233f60ebd1a44$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $1d9233f60ebd1a44$var$write_xlmeta_bin() {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    $1d9233f60ebd1a44$var$write_record(ba, 332);
    $1d9233f60ebd1a44$var$write_record(ba, 334, $1d9233f60ebd1a44$var$write_UInt32LE(1));
    $1d9233f60ebd1a44$var$write_record(ba, 335, $1d9233f60ebd1a44$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $1d9233f60ebd1a44$var$write_record(ba, 336);
    $1d9233f60ebd1a44$var$write_record(ba, 339, $1d9233f60ebd1a44$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $1d9233f60ebd1a44$var$write_record(ba, 52);
    $1d9233f60ebd1a44$var$write_record(ba, 35, $1d9233f60ebd1a44$var$write_UInt32LE(514));
    $1d9233f60ebd1a44$var$write_record(ba, 4096, $1d9233f60ebd1a44$var$write_UInt32LE(0));
    $1d9233f60ebd1a44$var$write_record(ba, 4097, $1d9233f60ebd1a44$var$writeuint16(1));
    $1d9233f60ebd1a44$var$write_record(ba, 36);
    $1d9233f60ebd1a44$var$write_record(ba, 53);
    $1d9233f60ebd1a44$var$write_record(ba, 340);
    $1d9233f60ebd1a44$var$write_record(ba, 337, $1d9233f60ebd1a44$var$write_BrtBeginEsmdb(1, true));
    $1d9233f60ebd1a44$var$write_record(ba, 51, $1d9233f60ebd1a44$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $1d9233f60ebd1a44$var$write_record(ba, 338);
    $1d9233f60ebd1a44$var$write_record(ba, 333);
    return ba.end();
}
function $1d9233f60ebd1a44$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($1d9233f60ebd1a44$var$tagregex, function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $1d9233f60ebd1a44$var$write_xlmeta_xml() {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $1d9233f60ebd1a44$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($1d9233f60ebd1a44$var$tagregex) || []).forEach(function(x) {
        var y = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case "<calcChain":
            case "<calcChain>":
            case "</calcChain>":
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case "<c":
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $1d9233f60ebd1a44$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $1d9233f60ebd1a44$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = "1";
    if (flags & 0x8) out.a = "1";
    return out;
}
/* 18.6 Calculation Chain */ function $1d9233f60ebd1a44$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $1d9233f60ebd1a44$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $1d9233f60ebd1a44$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $1d9233f60ebd1a44$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $1d9233f60ebd1a44$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $1d9233f60ebd1a44$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels["!id"][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $1d9233f60ebd1a44$var$write_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $1d9233f60ebd1a44$var$writextag("xml", null, {
            "xmlns:v": $1d9233f60ebd1a44$var$XLMLNS.v,
            "xmlns:o": $1d9233f60ebd1a44$var$XLMLNS.o,
            "xmlns:x": $1d9233f60ebd1a44$var$XLMLNS.x,
            "xmlns:mv": $1d9233f60ebd1a44$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $1d9233f60ebd1a44$var$writextag("o:shapelayout", $1d9233f60ebd1a44$var$writextag("o:idmap", null, {
            "v:ext": "edit",
            "data": rId
        }), {
            "v:ext": "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($1d9233f60ebd1a44$var$writextag("v:shapetype", [
        $1d9233f60ebd1a44$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $1d9233f60ebd1a44$var$writextag("v:path", null, {
            gradientshapeok: "t",
            "o:connecttype": "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        "o:spt": 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($1d9233f60ebd1a44$var$write_vml_comment(x, _shapeid));
    });
    o.push("</xml>");
    return o.join("");
}
function $1d9233f60ebd1a44$var$write_vml_comment(x, _shapeid) /*:string*/ {
    var c = $1d9233f60ebd1a44$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        "color2": "#BEFF82",
        "type": "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $1d9233f60ebd1a44$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        "v:ext": "view"
    }) : null;
    var fillxml = $1d9233f60ebd1a44$var$writextag("v:fill", fillparm, fillopts);
    var shadata = {
        on: "t",
        "obscured": "t"
    } /*:any*/ ;
    return [
        "<v:shape" + $1d9233f60ebd1a44$var$wxt_helper({
            id: "_x0000_s" + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + ">",
        fillxml,
        $1d9233f60ebd1a44$var$writextag("v:shadow", null, shadata),
        $1d9233f60ebd1a44$var$writextag("v:path", null, {
            "o:connecttype": "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        "<x:MoveWithCells/>",
        "<x:SizeWithCells/>",
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $1d9233f60ebd1a44$var$writetag("x:Anchor", [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $1d9233f60ebd1a44$var$writetag("x:AutoFill", "False"),
        $1d9233f60ebd1a44$var$writetag("x:Row", String(c.r)),
        $1d9233f60ebd1a44$var$writetag("x:Column", String(c.c)),
        x[1].hidden ? "" : "<x:Visible/>",
        "</x:ClientData>",
        "</v:shape>"
    ].join("");
}
function $1d9233f60ebd1a44$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $1d9233f60ebd1a44$var$decode_cell(comment.ref);
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $1d9233f60ebd1a44$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $1d9233f60ebd1a44$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $1d9233f60ebd1a44$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = $1d9233f60ebd1a44$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $1d9233f60ebd1a44$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && $1d9233f60ebd1a44$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $1d9233f60ebd1a44$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("comments", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $1d9233f60ebd1a44$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($1d9233f60ebd1a44$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $1d9233f60ebd1a44$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($1d9233f60ebd1a44$var$escapexml(c.a)) + '"><text>');
            o.push($1d9233f60ebd1a44$var$writetag("t", c.t == null ? "" : $1d9233f60ebd1a44$var$escapexml(c.t)));
            o.push("</text></comment>");
        });
        else {
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($1d9233f60ebd1a44$var$writetag("t", $1d9233f60ebd1a44$var$escapexml(t)));
            o.push("</text></comment>");
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = "</comments>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $1d9233f60ebd1a44$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($1d9233f60ebd1a44$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case "<ThreadedComments":
                break;
            case "</ThreadedComments>":
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case "<threadedComment":
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case "</threadedComment>":
                if (comment.t != null) out.push(comment);
                break;
            case "<text>":
            case "<text":
                tidx = idx + x.length;
                break;
            case "</text>":
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case "<mentions":
            case "<mentions>":
                pass = true;
                break;
            case "</mentions>":
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $1d9233f60ebd1a44$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("ThreadedComments", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($1d9233f60ebd1a44$var$writextag("threadedComment", $1d9233f60ebd1a44$var$writetag("text", c.t || ""), tcopts));
        });
    });
    o.push("</ThreadedComments>");
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $1d9233f60ebd1a44$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($1d9233f60ebd1a44$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.4.85 personList CT_PersonList */ case "<personList":
                break;
            case "</personList>":
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case "<person":
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case "</person>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $1d9233f60ebd1a44$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("personList", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS.TCMNT,
            "xmlns:x": $1d9233f60ebd1a44$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($1d9233f60ebd1a44$var$writextag("person", null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $1d9233f60ebd1a44$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $1d9233f60ebd1a44$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $1d9233f60ebd1a44$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $1d9233f60ebd1a44$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $1d9233f60ebd1a44$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $1d9233f60ebd1a44$var$parse_BrtCommentAuthor = $1d9233f60ebd1a44$var$parse_XLWideString;
function $1d9233f60ebd1a44$var$write_BrtCommentAuthor(data) {
    return $1d9233f60ebd1a44$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $1d9233f60ebd1a44$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $1d9233f60ebd1a44$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $1d9233f60ebd1a44$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $1d9233f60ebd1a44$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $1d9233f60ebd1a44$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $1d9233f60ebd1a44$var$write_BrtCommentAuthor(c.a));
        });
    });
    $1d9233f60ebd1a44$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: $1d9233f60ebd1a44$var$decode_cell(comment[0]),
                e: $1d9233f60ebd1a44$var$decode_cell(comment[0])
            };
            $1d9233f60ebd1a44$var$write_record(ba, 0x027B /* BrtBeginComment */ , $1d9233f60ebd1a44$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $1d9233f60ebd1a44$var$write_record(ba, 0x027D /* BrtCommentText */ , $1d9233f60ebd1a44$var$write_BrtCommentText(c));
            $1d9233f60ebd1a44$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $1d9233f60ebd1a44$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $1d9233f60ebd1a44$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $1d9233f60ebd1a44$var$make_vba_xls(cfb) {
    var newcfb = $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $1d9233f60ebd1a44$export$9f0e51cd97c572a.write(newcfb);
}
function $1d9233f60ebd1a44$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $1d9233f60ebd1a44$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $1d9233f60ebd1a44$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $1d9233f60ebd1a44$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $1d9233f60ebd1a44$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
function $1d9233f60ebd1a44$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
/* TODO: it will be useful to parse the function str */ var $1d9233f60ebd1a44$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $1d9233f60ebd1a44$var$encode_col(C) + (rRel ? "" : "$") + $1d9233f60ebd1a44$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $1d9233f60ebd1a44$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var $1d9233f60ebd1a44$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($1d9233f60ebd1a44$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $1d9233f60ebd1a44$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $1d9233f60ebd1a44$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $1d9233f60ebd1a44$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($1d9233f60ebd1a44$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $1d9233f60ebd1a44$var$encode_col($1d9233f60ebd1a44$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $1d9233f60ebd1a44$var$encode_row($1d9233f60ebd1a44$var$decode_row($5) + delta.r));
    });
}
function $1d9233f60ebd1a44$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $1d9233f60ebd1a44$var$decode_range(range), s = r.s, c = $1d9233f60ebd1a44$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $1d9233f60ebd1a44$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $1d9233f60ebd1a44$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $1d9233f60ebd1a44$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $1d9233f60ebd1a44$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $1d9233f60ebd1a44$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $1d9233f60ebd1a44$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $1d9233f60ebd1a44$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    var C = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $1d9233f60ebd1a44$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2), R = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $1d9233f60ebd1a44$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $1d9233f60ebd1a44$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    var C = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $1d9233f60ebd1a44$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $1d9233f60ebd1a44$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $1d9233f60ebd1a44$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $1d9233f60ebd1a44$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $1d9233f60ebd1a44$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $1d9233f60ebd1a44$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $1d9233f60ebd1a44$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $1d9233f60ebd1a44$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $1d9233f60ebd1a44$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $1d9233f60ebd1a44$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $1d9233f60ebd1a44$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, "i");
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $1d9233f60ebd1a44$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $1d9233f60ebd1a44$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $1d9233f60ebd1a44$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $1d9233f60ebd1a44$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $1d9233f60ebd1a44$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $1d9233f60ebd1a44$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $1d9233f60ebd1a44$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $1d9233f60ebd1a44$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $1d9233f60ebd1a44$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $1d9233f60ebd1a44$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $1d9233f60ebd1a44$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $1d9233f60ebd1a44$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $1d9233f60ebd1a44$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $1d9233f60ebd1a44$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $1d9233f60ebd1a44$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $1d9233f60ebd1a44$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $1d9233f60ebd1a44$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $1d9233f60ebd1a44$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $1d9233f60ebd1a44$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $1d9233f60ebd1a44$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $1d9233f60ebd1a44$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $1d9233f60ebd1a44$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $1d9233f60ebd1a44$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $1d9233f60ebd1a44$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $1d9233f60ebd1a44$var$FtabArgc[iftab],
        $1d9233f60ebd1a44$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $1d9233f60ebd1a44$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $1d9233f60ebd1a44$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $1d9233f60ebd1a44$var$Ftab : $1d9233f60ebd1a44$var$Cetab)[tab[1]]
    ];
}
function $1d9233f60ebd1a44$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $1d9233f60ebd1a44$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $1d9233f60ebd1a44$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, "i"),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $1d9233f60ebd1a44$var$parse_PtgErr(blob) {
    blob.l++;
    return $1d9233f60ebd1a44$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $1d9233f60ebd1a44$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $1d9233f60ebd1a44$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $1d9233f60ebd1a44$var$parse_PtgNum(blob) {
    blob.l++;
    return $1d9233f60ebd1a44$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $1d9233f60ebd1a44$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $1d9233f60ebd1a44$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $1d9233f60ebd1a44$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $1d9233f60ebd1a44$var$parsebool(blob, 1) ? "TRUE" : "FALSE";
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $1d9233f60ebd1a44$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $1d9233f60ebd1a44$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $1d9233f60ebd1a44$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $1d9233f60ebd1a44$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $1d9233f60ebd1a44$var$parse_UncheckedRfX : $1d9233f60ebd1a44$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $1d9233f60ebd1a44$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $1d9233f60ebd1a44$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $1d9233f60ebd1a44$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $1d9233f60ebd1a44$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $1d9233f60ebd1a44$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $1d9233f60ebd1a44$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, "i"); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $1d9233f60ebd1a44$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $1d9233f60ebd1a44$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $1d9233f60ebd1a44$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $1d9233f60ebd1a44$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $1d9233f60ebd1a44$var$parse_PtgMemErr = $1d9233f60ebd1a44$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $1d9233f60ebd1a44$var$parse_PtgMemNoMem = $1d9233f60ebd1a44$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $1d9233f60ebd1a44$var$parse_PtgTbl = $1d9233f60ebd1a44$var$parsenoop;
function $1d9233f60ebd1a44$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $1d9233f60ebd1a44$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $1d9233f60ebd1a44$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $1d9233f60ebd1a44$var$parse_PtgElfCol = $1d9233f60ebd1a44$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $1d9233f60ebd1a44$var$parse_PtgElfColS = $1d9233f60ebd1a44$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $1d9233f60ebd1a44$var$parse_PtgElfColSV = $1d9233f60ebd1a44$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $1d9233f60ebd1a44$var$parse_PtgElfColV = $1d9233f60ebd1a44$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $1d9233f60ebd1a44$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $1d9233f60ebd1a44$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $1d9233f60ebd1a44$var$parse_PtgElfRadical = $1d9233f60ebd1a44$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $1d9233f60ebd1a44$var$parse_PtgElfRadicalLel = $1d9233f60ebd1a44$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $1d9233f60ebd1a44$var$parse_PtgElfRadicalS = $1d9233f60ebd1a44$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $1d9233f60ebd1a44$var$parse_PtgElfRw = $1d9233f60ebd1a44$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $1d9233f60ebd1a44$var$parse_PtgElfRwV = $1d9233f60ebd1a44$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $1d9233f60ebd1a44$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $1d9233f60ebd1a44$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $1d9233f60ebd1a44$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $1d9233f60ebd1a44$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $1d9233f60ebd1a44$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $1d9233f60ebd1a44$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $1d9233f60ebd1a44$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $1d9233f60ebd1a44$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $1d9233f60ebd1a44$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $1d9233f60ebd1a44$var$PtgTypes = {
    /*::[*/ 0x01: {
        n: "PtgExp",
        f: $1d9233f60ebd1a44$var$parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: "PtgTbl",
        f: $1d9233f60ebd1a44$var$parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: "PtgAdd",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x04: {
        n: "PtgSub",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x05: {
        n: "PtgMul",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x06: {
        n: "PtgDiv",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x07: {
        n: "PtgPower",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x08: {
        n: "PtgConcat",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x09: {
        n: "PtgLt",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x0A: {
        n: "PtgLe",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x0B: {
        n: "PtgEq",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x0C: {
        n: "PtgGe",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x0D: {
        n: "PtgGt",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x0E: {
        n: "PtgNe",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x0F: {
        n: "PtgIsect",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x10: {
        n: "PtgUnion",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x11: {
        n: "PtgRange",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x12: {
        n: "PtgUplus",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x13: {
        n: "PtgUminus",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x14: {
        n: "PtgPercent",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x15: {
        n: "PtgParen",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x16: {
        n: "PtgMissArg",
        f: $1d9233f60ebd1a44$var$parseread1
    },
    /*::[*/ 0x17: {
        n: "PtgStr",
        f: $1d9233f60ebd1a44$var$parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: "PtgSheet",
        f: $1d9233f60ebd1a44$var$parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: "PtgEndSheet",
        f: $1d9233f60ebd1a44$var$parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: "PtgErr",
        f: $1d9233f60ebd1a44$var$parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: "PtgBool",
        f: $1d9233f60ebd1a44$var$parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: "PtgInt",
        f: $1d9233f60ebd1a44$var$parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: "PtgNum",
        f: $1d9233f60ebd1a44$var$parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: "PtgArray",
        f: $1d9233f60ebd1a44$var$parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: "PtgFunc",
        f: $1d9233f60ebd1a44$var$parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: "PtgFuncVar",
        f: $1d9233f60ebd1a44$var$parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: "PtgName",
        f: $1d9233f60ebd1a44$var$parse_PtgName
    },
    /*::[*/ 0x24: {
        n: "PtgRef",
        f: $1d9233f60ebd1a44$var$parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: "PtgArea",
        f: $1d9233f60ebd1a44$var$parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: "PtgMemArea",
        f: $1d9233f60ebd1a44$var$parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: "PtgMemErr",
        f: $1d9233f60ebd1a44$var$parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: "PtgMemNoMem",
        f: $1d9233f60ebd1a44$var$parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: "PtgMemFunc",
        f: $1d9233f60ebd1a44$var$parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: "PtgRefErr",
        f: $1d9233f60ebd1a44$var$parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: "PtgAreaErr",
        f: $1d9233f60ebd1a44$var$parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: "PtgRefN",
        f: $1d9233f60ebd1a44$var$parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: "PtgAreaN",
        f: $1d9233f60ebd1a44$var$parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: "PtgMemAreaN",
        f: $1d9233f60ebd1a44$var$parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: "PtgMemNoMemN",
        f: $1d9233f60ebd1a44$var$parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: "PtgNameX",
        f: $1d9233f60ebd1a44$var$parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: "PtgRef3d",
        f: $1d9233f60ebd1a44$var$parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: "PtgArea3d",
        f: $1d9233f60ebd1a44$var$parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: "PtgRefErr3d",
        f: $1d9233f60ebd1a44$var$parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: "PtgAreaErr3d",
        f: $1d9233f60ebd1a44$var$parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $1d9233f60ebd1a44$var$PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var $1d9233f60ebd1a44$var$Ptg18 = {
    /*::[*/ 0x01: {
        n: "PtgElfLel",
        f: $1d9233f60ebd1a44$var$parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: "PtgElfRw",
        f: $1d9233f60ebd1a44$var$parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: "PtgElfCol",
        f: $1d9233f60ebd1a44$var$parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: "PtgElfRwV",
        f: $1d9233f60ebd1a44$var$parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: "PtgElfColV",
        f: $1d9233f60ebd1a44$var$parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: "PtgElfRadical",
        f: $1d9233f60ebd1a44$var$parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: "PtgElfRadicalS",
        f: $1d9233f60ebd1a44$var$parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: "PtgElfColS",
        f: $1d9233f60ebd1a44$var$parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: "PtgElfColSV",
        f: $1d9233f60ebd1a44$var$parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: "PtgElfRadicalLel",
        f: $1d9233f60ebd1a44$var$parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: "PtgList",
        f: $1d9233f60ebd1a44$var$parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: "PtgSxName",
        f: $1d9233f60ebd1a44$var$parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var $1d9233f60ebd1a44$var$Ptg19 = {
    /*::[*/ 0x00: {
        n: "PtgAttrNoop",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: "PtgAttrSemi",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: "PtgAttrIf",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: "PtgAttrChoose",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: "PtgAttrGoto",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: "PtgAttrSum",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: "PtgAttrBaxcel",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: "PtgAttrBaxcel",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: "PtgAttrSpace",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: "PtgAttrSpaceSemi",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: "PtgAttrIfError",
        f: $1d9233f60ebd1a44$var$parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $1d9233f60ebd1a44$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $1d9233f60ebd1a44$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case "PtgArray":
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $1d9233f60ebd1a44$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case "PtgMemArea":
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $1d9233f60ebd1a44$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case "PtgExp":
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case "PtgList":
        /* TODO: PtgList -> PtgExtraList */ case "PtgElfRadicalS":
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case "PtgElfColS":
        /* TODO: PtgElfColS -> PtgExtraElf */ case "PtgElfColSV":
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($1d9233f60ebd1a44$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $1d9233f60ebd1a44$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $1d9233f60ebd1a44$var$PtgTypes[id] || $1d9233f60ebd1a44$var$PtgTypes[$1d9233f60ebd1a44$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $1d9233f60ebd1a44$var$Ptg18 : $1d9233f60ebd1a44$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $1d9233f60ebd1a44$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $1d9233f60ebd1a44$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $1d9233f60ebd1a44$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $1d9233f60ebd1a44$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $1d9233f60ebd1a44$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $1d9233f60ebd1a44$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $1d9233f60ebd1a44$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $1d9233f60ebd1a44$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $1d9233f60ebd1a44$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case "PtgUminus":
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case "PtgUplus":
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case "PtgPercent":
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case "PtgAdd":
            /* [MS-XLS] 2.5.198.26 */ case "PtgConcat":
            /* [MS-XLS] 2.5.198.43 */ case "PtgDiv":
            /* [MS-XLS] 2.5.198.45 */ case "PtgEq":
            /* [MS-XLS] 2.5.198.56 */ case "PtgGe":
            /* [MS-XLS] 2.5.198.64 */ case "PtgGt":
            /* [MS-XLS] 2.5.198.65 */ case "PtgLe":
            /* [MS-XLS] 2.5.198.68 */ case "PtgLt":
            /* [MS-XLS] 2.5.198.69 */ case "PtgMul":
            /* [MS-XLS] 2.5.198.75 */ case "PtgNe":
            /* [MS-XLS] 2.5.198.78 */ case "PtgPower":
            /* [MS-XLS] 2.5.198.82 */ case "PtgSub":
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $1d9233f60ebd1a44$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $1d9233f60ebd1a44$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $1d9233f60ebd1a44$var$PtgBinOp[f[0]] + e1);
                break;
            case "PtgIsect":
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case "PtgUnion":
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case "PtgRange":
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($1d9233f60ebd1a44$var$make_3d_range(e2, e1));
                break;
            case "PtgAttrChoose":
                break;
            case "PtgAttrGoto":
                break;
            case "PtgAttrIf":
                break;
            case "PtgAttrIfError":
                break;
            case "PtgRef":
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $1d9233f60ebd1a44$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($1d9233f60ebd1a44$var$encode_cell_xls(c, biff));
                break;
            case "PtgRefN":
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $1d9233f60ebd1a44$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($1d9233f60ebd1a44$var$encode_cell_xls(c, biff));
                break;
            case "PtgRef3d":
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $1d9233f60ebd1a44$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $1d9233f60ebd1a44$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $1d9233f60ebd1a44$var$encode_cell_xls(c, biff));
                break;
            case "PtgFunc":
            /* [MS-XLS] 2.5.198.62 */ case "PtgFuncVar":
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === "User") func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case "PtgBool":
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case "PtgInt":
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgNum":
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case "PtgStr":
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case "PtgErr":
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgAreaN":
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $1d9233f60ebd1a44$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($1d9233f60ebd1a44$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea":
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $1d9233f60ebd1a44$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($1d9233f60ebd1a44$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea3d":
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $1d9233f60ebd1a44$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $1d9233f60ebd1a44$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgAttrSum":
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case "PtgAttrBaxcel":
            /* [MS-XLS] 2.5.198.33 */ case "PtgAttrSemi":
                break;
            case "PtgName":
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case "PtgNameX":
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($1d9233f60ebd1a44$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case "PtgParen":
                /* [MS-XLS] 2.5.198.80 */ var lp = "(", rp = ")";
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $1d9233f60ebd1a44$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $1d9233f60ebd1a44$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $1d9233f60ebd1a44$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $1d9233f60ebd1a44$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case "PtgRefErr":
                /* [MS-XLS] 2.5.198.86 */ stack.push("#REF!");
                break;
            case "PtgRefErr3d":
                /* [MS-XLS] 2.5.198.87 */ stack.push("#REF!");
                break;
            case "PtgExp":
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$1d9233f60ebd1a44$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$1d9233f60ebd1a44$var$encode_cell(c)];
                    stack.push($1d9233f60ebd1a44$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($1d9233f60ebd1a44$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case "PtgArray":
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $1d9233f60ebd1a44$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case "PtgMemArea":
                break;
            case "PtgAttrSpace":
            /* [MS-XLS] 2.5.198.38 */ case "PtgAttrSpaceSemi":
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case "PtgTbl":
                break;
            case "PtgMemErr":
                break;
            case "PtgMissArg":
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case "PtgAreaErr":
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case "PtgAreaErr3d":
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case "PtgList":
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case "PtgMemAreaN":
            case "PtgMemNoMemN":
            case "PtgAttrNoop":
            case "PtgSheet":
            case "PtgEndSheet":
                break;
            case "PtgMemFunc":
                break;
            case "PtgMemNoMem":
                break;
            case "PtgElfCol":
            /* [MS-XLS] 2.5.198.46 */ case "PtgElfColS":
            /* [MS-XLS] 2.5.198.47 */ case "PtgElfColSV":
            /* [MS-XLS] 2.5.198.48 */ case "PtgElfColV":
            /* [MS-XLS] 2.5.198.49 */ case "PtgElfLel":
            /* [MS-XLS] 2.5.198.50 */ case "PtgElfRadical":
            /* [MS-XLS] 2.5.198.51 */ case "PtgElfRadicalLel":
            /* [MS-XLS] 2.5.198.52 */ case "PtgElfRadicalS":
            /* [MS-XLS] 2.5.198.53 */ case "PtgElfRw":
            /* [MS-XLS] 2.5.198.54 */ case "PtgElfRwV":
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case "PtgSxName":
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error("Unrecognized Formula Token: " + String(f));
            default:
                throw new Error("Unrecognized Formula Token: " + String(f));
        }
        var PtgNonDisp = [
            "PtgAttrSpace",
            "PtgAttrSpaceSemi",
            "PtgAttrGoto"
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $1d9233f60ebd1a44$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $1d9233f60ebd1a44$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $1d9233f60ebd1a44$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $1d9233f60ebd1a44$var$parsenoop(blob, length - 2)
    ];
    var rgce = $1d9233f60ebd1a44$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $1d9233f60ebd1a44$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $1d9233f60ebd1a44$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $1d9233f60ebd1a44$var$parsenoop(blob, length - 2)
    ];
    var rgce = $1d9233f60ebd1a44$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $1d9233f60ebd1a44$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $1d9233f60ebd1a44$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $1d9233f60ebd1a44$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $1d9233f60ebd1a44$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $1d9233f60ebd1a44$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $1d9233f60ebd1a44$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $1d9233f60ebd1a44$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $1d9233f60ebd1a44$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $1d9233f60ebd1a44$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($1d9233f60ebd1a44$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $1d9233f60ebd1a44$var$parse_Xnum(blob),
        "n"
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                "s"
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                "b"
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                "e"
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                "s"
            ];
    }
    return [];
}
function $1d9233f60ebd1a44$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $1d9233f60ebd1a44$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $1d9233f60ebd1a44$var$write_Xnum(value);
    return $1d9233f60ebd1a44$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $1d9233f60ebd1a44$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = $1d9233f60ebd1a44$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $1d9233f60ebd1a44$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $1d9233f60ebd1a44$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $1d9233f60ebd1a44$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $1d9233f60ebd1a44$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $1d9233f60ebd1a44$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $1d9233f60ebd1a44$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $1d9233f60ebd1a44$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $1d9233f60ebd1a44$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $1d9233f60ebd1a44$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $1d9233f60ebd1a44$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $1d9233f60ebd1a44$var$parse_XLSBArrayParsedFormula = $1d9233f60ebd1a44$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $1d9233f60ebd1a44$var$parse_XLSBCellParsedFormula = $1d9233f60ebd1a44$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $1d9233f60ebd1a44$var$parse_XLSBNameParsedFormula = $1d9233f60ebd1a44$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $1d9233f60ebd1a44$var$parse_XLSBSharedParsedFormula = $1d9233f60ebd1a44$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $1d9233f60ebd1a44$var$write_XLSBFormulaNum(val /*:number*/ ) {
    if ((val | 0) == val && val < Math.pow(2, 16) && val >= 0) {
        var oint = $1d9233f60ebd1a44$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $1d9233f60ebd1a44$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $1d9233f60ebd1a44$var$write_XLSBFormulaErr(val /*:number*/ ) {
    var oint = $1d9233f60ebd1a44$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $1d9233f60ebd1a44$var$write_XLSBFormulaBool(val /*:boolean*/ ) {
    var oint = $1d9233f60ebd1a44$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $1d9233f60ebd1a44$var$write_XLSBFormulaStr(val /*:string*/ ) {
    var preamble = $1d9233f60ebd1a44$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val.length);
    var body = $1d9233f60ebd1a44$var$new_buf(2 * val.length);
    body.write_shift(2 * val.length, val, "utf16le");
    var postamble = $1d9233f60ebd1a44$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $1d9233f60ebd1a44$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $1d9233f60ebd1a44$var$write_XLSBFormulaRef(str) {
    var cell = $1d9233f60ebd1a44$var$decode_cell(str);
    var out = $1d9233f60ebd1a44$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $1d9233f60ebd1a44$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $1d9233f60ebd1a44$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $1d9233f60ebd1a44$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $1d9233f60ebd1a44$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $1d9233f60ebd1a44$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $1d9233f60ebd1a44$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $1d9233f60ebd1a44$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $1d9233f60ebd1a44$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $1d9233f60ebd1a44$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $1d9233f60ebd1a44$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    str = parts[0];
    var out = $1d9233f60ebd1a44$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $1d9233f60ebd1a44$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $1d9233f60ebd1a44$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $1d9233f60ebd1a44$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $1d9233f60ebd1a44$var$decode_range(_str);
    var out = $1d9233f60ebd1a44$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $1d9233f60ebd1a44$var$write_XLSBFormula(val /*:string|number*/ , wb) {
    if (typeof val == "number") return $1d9233f60ebd1a44$var$write_XLSBFormulaNum(val);
    if (typeof val == "boolean") return $1d9233f60ebd1a44$var$write_XLSBFormulaBool(val);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val)) return $1d9233f60ebd1a44$var$write_XLSBFormulaErr(+$1d9233f60ebd1a44$var$RBErr[val]);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $1d9233f60ebd1a44$var$write_XLSBFormulaRef(val);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $1d9233f60ebd1a44$var$write_XLSBFormulaRange(val);
    if (val.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $1d9233f60ebd1a44$var$write_XLSBFormulaArea3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $1d9233f60ebd1a44$var$write_XLSBFormulaRef3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $1d9233f60ebd1a44$var$write_XLSBFormulaRangeWS(val, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val)) return $1d9233f60ebd1a44$var$write_XLSBFormulaRefErr3D(val, wb);
    if (/^".*"$/.test(val)) return $1d9233f60ebd1a44$var$write_XLSBFormulaStr(val);
    if (/^[+-]\d+$/.test(val)) return $1d9233f60ebd1a44$var$write_XLSBFormulaNum(parseInt(val, 10));
    throw "Formula |" + val + "| not supported for XLSB";
}
var $1d9233f60ebd1a44$var$write_XLSBNameParsedFormula = $1d9233f60ebd1a44$var$write_XLSBFormula;
var $1d9233f60ebd1a44$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $1d9233f60ebd1a44$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $1d9233f60ebd1a44$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $1d9233f60ebd1a44$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $1d9233f60ebd1a44$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($1d9233f60ebd1a44$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $1d9233f60ebd1a44$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $1d9233f60ebd1a44$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".");
}
var $1d9233f60ebd1a44$var$strs = {}; // shared strings
var $1d9233f60ebd1a44$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $1d9233f60ebd1a44$var$browser_has_Map = typeof Map !== "undefined";
function $1d9233f60ebd1a44$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($1d9233f60ebd1a44$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $1d9233f60ebd1a44$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($1d9233f60ebd1a44$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $1d9233f60ebd1a44$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $1d9233f60ebd1a44$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $1d9233f60ebd1a44$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $1d9233f60ebd1a44$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $1d9233f60ebd1a44$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == "xlml") defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $1d9233f60ebd1a44$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $1d9233f60ebd1a44$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $1d9233f60ebd1a44$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = $1d9233f60ebd1a44$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === "z" && !opts.cellStyles) return;
    if (p.t === "d" && typeof p.v === "string") p.v = $1d9233f60ebd1a44$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== "z") try {
        if ($1d9233f60ebd1a44$var$table_fmt[fmtid] == null) $1d9233f60ebd1a44$var$SSF__load($1d9233f60ebd1a44$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === "e") p.w = p.w || $1d9233f60ebd1a44$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $1d9233f60ebd1a44$var$SSF_general_num(p.v);
            } else if (p.t === "d") {
                var dd = $1d9233f60ebd1a44$var$datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $1d9233f60ebd1a44$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $1d9233f60ebd1a44$var$SSF_general(p.v, $1d9233f60ebd1a44$var$_ssfopts);
        } else if (p.t === "d") p.w = $1d9233f60ebd1a44$var$SSF_format(fmtid, $1d9233f60ebd1a44$var$datenum(p.v), $1d9233f60ebd1a44$var$_ssfopts);
        else p.w = $1d9233f60ebd1a44$var$SSF_format(fmtid, p.v, $1d9233f60ebd1a44$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $1d9233f60ebd1a44$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $1d9233f60ebd1a44$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $1d9233f60ebd1a44$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws["!ref"]) {
        var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws["!ref"]);
    }
}
function $1d9233f60ebd1a44$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $1d9233f60ebd1a44$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(d);
}
var $1d9233f60ebd1a44$var$mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var $1d9233f60ebd1a44$var$sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var $1d9233f60ebd1a44$var$hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var $1d9233f60ebd1a44$var$dimregex = /"(\w*:\w*)"/;
var $1d9233f60ebd1a44$var$colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var $1d9233f60ebd1a44$var$afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var $1d9233f60ebd1a44$var$marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var $1d9233f60ebd1a44$var$sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var $1d9233f60ebd1a44$var$sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var $1d9233f60ebd1a44$var$svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function $1d9233f60ebd1a44$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    if ($1d9233f60ebd1a44$var$DENSE != null && opts.dense == null) opts.dense = $1d9233f60ebd1a44$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match($1d9233f60ebd1a44$var$sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($1d9233f60ebd1a44$var$sheetprregex);
    if (sheetPr) $1d9233f60ebd1a44$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match($1d9233f60ebd1a44$var$sheetprregex2)) $1d9233f60ebd1a44$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($1d9233f60ebd1a44$var$dimregex);
        if (ref && !(opts && opts.nodim)) $1d9233f60ebd1a44$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match($1d9233f60ebd1a44$var$svsregex);
    if (svs && svs[1]) $1d9233f60ebd1a44$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($1d9233f60ebd1a44$var$colregex);
        if (cols) $1d9233f60ebd1a44$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $1d9233f60ebd1a44$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($1d9233f60ebd1a44$var$afregex);
    if (afilter) s["!autofilter"] = $1d9233f60ebd1a44$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($1d9233f60ebd1a44$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $1d9233f60ebd1a44$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf('"') + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($1d9233f60ebd1a44$var$hlinkregex);
    if (hlink) $1d9233f60ebd1a44$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($1d9233f60ebd1a44$var$marginregex);
    if (margins) s["!margins"] = $1d9233f60ebd1a44$var$parse_ws_xml_margins($1d9233f60ebd1a44$var$parsexmltag(margins[0]));
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $1d9233f60ebd1a44$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $1d9233f60ebd1a44$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function $1d9233f60ebd1a44$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $1d9233f60ebd1a44$var$encode_range(merges[i]) + '"/>';
    return o + "</mergeCells>";
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $1d9233f60ebd1a44$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $1d9233f60ebd1a44$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(data.codeName));
}
function $1d9233f60ebd1a44$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $1d9233f60ebd1a44$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $1d9233f60ebd1a44$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== "xlsx" && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $1d9233f60ebd1a44$var$utf8write($1d9233f60ebd1a44$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $1d9233f60ebd1a44$var$writextag("outlinePr", null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $1d9233f60ebd1a44$var$writextag("sheetPr", payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $1d9233f60ebd1a44$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $1d9233f60ebd1a44$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $1d9233f60ebd1a44$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $1d9233f60ebd1a44$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $1d9233f60ebd1a44$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $1d9233f60ebd1a44$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $1d9233f60ebd1a44$var$writextag("sheetProtection", null, o);
}
function $1d9233f60ebd1a44$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val = $1d9233f60ebd1a44$var$parsexmltag($1d9233f60ebd1a44$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})["!id"] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $1d9233f60ebd1a44$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $1d9233f60ebd1a44$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: "Internal"
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $1d9233f60ebd1a44$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $1d9233f60ebd1a44$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $1d9233f60ebd1a44$var$write_ws_xml_margins(margin) /*:string*/ {
    $1d9233f60ebd1a44$var$default_margins(margin);
    return $1d9233f60ebd1a44$var$writextag("pageMargins", null, margin);
}
function $1d9233f60ebd1a44$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $1d9233f60ebd1a44$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $1d9233f60ebd1a44$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $1d9233f60ebd1a44$var$find_mdw_colw(coll.width);
        }
        $1d9233f60ebd1a44$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $1d9233f60ebd1a44$var$dup(coll);
    }
}
function $1d9233f60ebd1a44$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $1d9233f60ebd1a44$var$writextag("col", null, $1d9233f60ebd1a44$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $1d9233f60ebd1a44$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $1d9233f60ebd1a44$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $1d9233f60ebd1a44$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $1d9233f60ebd1a44$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]).e.r;
        ref = $1d9233f60ebd1a44$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = $1d9233f60ebd1a44$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $1d9233f60ebd1a44$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $1d9233f60ebd1a44$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $1d9233f60ebd1a44$var$sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/g;
function $1d9233f60ebd1a44$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($1d9233f60ebd1a44$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $1d9233f60ebd1a44$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $1d9233f60ebd1a44$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $1d9233f60ebd1a44$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $1d9233f60ebd1a44$var$writextag("sheetViews", $1d9233f60ebd1a44$var$writextag("sheetView", null, sview), {});
}
function $1d9233f60ebd1a44$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws["!comments"].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "n":
            vv = "" + cell.v;
            break;
        case "e":
            vv = $1d9233f60ebd1a44$var$BErr[cell.v];
            break;
        case "d":
            if (opts && opts.cellDates) vv = $1d9233f60ebd1a44$var$parseDate(cell.v, -1).toISOString();
            else {
                cell = $1d9233f60ebd1a44$var$dup(cell);
                cell.t = "n";
                vv = "" + (cell.v = $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(cell.v)));
            }
            if (typeof cell.z === "undefined") cell.z = $1d9233f60ebd1a44$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $1d9233f60ebd1a44$var$writetag("v", $1d9233f60ebd1a44$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case "n":
            break;
        case "d":
            o.t = "d";
            break;
        case "b":
            o.t = "b";
            break;
        case "e":
            o.t = "e";
            break;
        case "z":
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $1d9233f60ebd1a44$var$writetag("v", "" + $1d9233f60ebd1a44$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $1d9233f60ebd1a44$var$writextag("f", $1d9233f60ebd1a44$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $1d9233f60ebd1a44$var$escapexml(vv);
        ws["!links"].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $1d9233f60ebd1a44$var$writextag("c", v, o);
}
var $1d9233f60ebd1a44$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = $1d9233f60ebd1a44$var$matchtag("v"), match_f = $1d9233f60ebd1a44$var$matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $1d9233f60ebd1a44$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $1d9233f60ebd1a44$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $1d9233f60ebd1a44$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $1d9233f60ebd1a44$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $1d9233f60ebd1a44$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $1d9233f60ebd1a44$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $1d9233f60ebd1a44$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $1d9233f60ebd1a44$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== "") p.v = $1d9233f60ebd1a44$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== "") {
                        /* TODO: match against XLSXFutureFunctions */ p.f = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(cref[1]), true);
                        if (!opts.xlfn) p.f = $1d9233f60ebd1a44$var$_xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                $1d9233f60ebd1a44$var$safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = $1d9233f60ebd1a44$var$parsexmltag(cref[0]);
                            var ___f = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(cref[1]));
                            if (!opts.xlfn) ___f = $1d9233f60ebd1a44$var$_xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = $1d9233f60ebd1a44$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $1d9233f60ebd1a44$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $1d9233f60ebd1a44$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case "n":
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else p.v = parseFloat(p.v);
                        break;
                    case "s":
                        if (typeof p.v == "undefined") {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else {
                            sstr = $1d9233f60ebd1a44$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case "str":
                        p.t = "s";
                        p.v = p.v != null ? $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(p.v), true) : "";
                        if (opts.cellHTML) p.h = $1d9233f60ebd1a44$var$escapehtml(p.v);
                        break;
                    case "inlineStr":
                        cref = d.match(isregex);
                        p.t = "s";
                        if (cref != null && (sstr = $1d9233f60ebd1a44$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case "b":
                        p.v = $1d9233f60ebd1a44$var$parsexmlbool(p.v);
                        break;
                    case "d":
                        if (opts.cellDates) p.v = $1d9233f60ebd1a44$var$parseDate(p.v, 1);
                        else {
                            p.v = $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(p.v, 1));
                            p.t = "n";
                        }
                        break;
                    /* error string in .w, number in .v */ case "e":
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $1d9233f60ebd1a44$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $1d9233f60ebd1a44$var$safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == "n" && $1d9233f60ebd1a44$var$fmt_is_date($1d9233f60ebd1a44$var$table_fmt[fmtid])) {
                    p.t = "d";
                    p.v = $1d9233f60ebd1a44$var$numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == "XLDAPR") p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $1d9233f60ebd1a44$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $1d9233f60ebd1a44$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s["!rows"] = rows;
    };
}();
function $1d9233f60ebd1a44$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws["!rows"];
    var dense = ws["!data"] != null;
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $1d9233f60ebd1a44$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $1d9233f60ebd1a44$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $1d9233f60ebd1a44$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $1d9233f60ebd1a44$var$writextag("row", r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $1d9233f60ebd1a44$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $1d9233f60ebd1a44$var$writextag("row", "", params);
        }
    }
    return o.join("");
}
function $1d9233f60ebd1a44$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER,
        $1d9233f60ebd1a44$var$writextag("worksheet", null, {
            "xmlns": $1d9233f60ebd1a44$var$XMLNS_main[0],
            "xmlns:r": $1d9233f60ebd1a44$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws["!ref"] || "A1";
    var range = $1d9233f60ebd1a44$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $1d9233f60ebd1a44$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws["!comments"] = [];
    var _drawing = [];
    $1d9233f60ebd1a44$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $1d9233f60ebd1a44$var$writextag("dimension", null, {
        "ref": ref
    });
    o[o.length] = $1d9233f60ebd1a44$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $1d9233f60ebd1a44$var$writextag("sheetFormatPr", null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || "16",
        baseColWidth: opts.sheetFormat.baseColWidth || "10",
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || "7"
    });
    if (ws["!cols"] != null && ws["!cols"].length > 0) o[o.length] = $1d9233f60ebd1a44$var$write_ws_xml_cols(ws, ws["!cols"]);
    o[sidx = o.length] = "<sheetData/>";
    ws["!links"] = [];
    if (ws["!ref"] != null) {
        rdata = $1d9233f60ebd1a44$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = "</sheetData>";
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws["!protect"]) o[o.length] = $1d9233f60ebd1a44$var$write_ws_xml_protection(ws["!protect"]);
    /* protectedRanges */ /* scenarios */ if (ws["!autofilter"] != null) o[o.length] = $1d9233f60ebd1a44$var$write_ws_xml_autofilter(ws["!autofilter"], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws["!merges"] != null && ws["!merges"].length > 0) o[o.length] = $1d9233f60ebd1a44$var$write_ws_xml_merges(ws["!merges"]);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws["!links"]/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws["!links"]/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $1d9233f60ebd1a44$var$add_rels(rels, -1, $1d9233f60ebd1a44$var$escapexml(l[1].Target).replace(/#.*$/, ""), $1d9233f60ebd1a44$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $1d9233f60ebd1a44$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $1d9233f60ebd1a44$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $1d9233f60ebd1a44$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws["!links"];
    /* printOptions */ if (ws["!margins"] != null) o[o.length] = $1d9233f60ebd1a44$var$write_ws_xml_margins(ws["!margins"]);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $1d9233f60ebd1a44$var$writetag("ignoredErrors", $1d9233f60ebd1a44$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $1d9233f60ebd1a44$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $1d9233f60ebd1a44$var$RELS.DRAW);
        o[o.length] = $1d9233f60ebd1a44$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws["!drawing"] = _drawing;
    }
    if (ws["!comments"].length > 0) {
        rId = $1d9233f60ebd1a44$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $1d9233f60ebd1a44$var$RELS.VML);
        o[o.length] = $1d9233f60ebd1a44$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws["!legacy"] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = "</worksheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $1d9233f60ebd1a44$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $1d9233f60ebd1a44$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $1d9233f60ebd1a44$var$new_buf(145);
    var row = (ws["!rows"] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $1d9233f60ebd1a44$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$1d9233f60ebd1a44$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $1d9233f60ebd1a44$var$write_row_header(ba, ws, range, R) {
    var o = $1d9233f60ebd1a44$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws["!rows"] || [])[R]) $1d9233f60ebd1a44$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $1d9233f60ebd1a44$var$parse_BrtWsDim = $1d9233f60ebd1a44$var$parse_UncheckedRfX;
var $1d9233f60ebd1a44$var$write_BrtWsDim = $1d9233f60ebd1a44$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $1d9233f60ebd1a44$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $1d9233f60ebd1a44$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $1d9233f60ebd1a44$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $1d9233f60ebd1a44$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $1d9233f60ebd1a44$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $1d9233f60ebd1a44$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $1d9233f60ebd1a44$var$parse_BrtCellBlank(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(8);
    return $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
}
function $1d9233f60ebd1a44$var$parse_BrtShortBlank(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(4);
    return $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $1d9233f60ebd1a44$var$parse_BrtCellBool(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(9);
    $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $1d9233f60ebd1a44$var$parse_BrtShortBool(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(5);
    $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $1d9233f60ebd1a44$var$parse_BrtCellError(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(9);
    $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $1d9233f60ebd1a44$var$parse_BrtShortError(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(8);
    $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $1d9233f60ebd1a44$var$parse_BrtCellIsst(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(12);
    $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $1d9233f60ebd1a44$var$parse_BrtShortIsst(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(8);
    $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $1d9233f60ebd1a44$var$parse_BrtCellReal(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var value = $1d9233f60ebd1a44$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(16);
    $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
    $1d9233f60ebd1a44$var$write_Xnum(cell.v, o);
    return o;
}
function $1d9233f60ebd1a44$var$parse_BrtShortReal(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    var value = $1d9233f60ebd1a44$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(12);
    $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
    $1d9233f60ebd1a44$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $1d9233f60ebd1a44$var$parse_BrtCellRk(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var value = $1d9233f60ebd1a44$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(12);
    $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
    $1d9233f60ebd1a44$var$write_RkNumber(cell.v, o);
    return o;
}
function $1d9233f60ebd1a44$var$parse_BrtShortRk(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    var value = $1d9233f60ebd1a44$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(8);
    $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
    $1d9233f60ebd1a44$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $1d9233f60ebd1a44$var$parse_BrtCellRString(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var value = $1d9233f60ebd1a44$var$parse_RichStr(data);
    return [
        cell,
        value,
        "is"
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $1d9233f60ebd1a44$var$parse_BrtCellSt(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    var value = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(12 + 4 * cell.v.length);
    $1d9233f60ebd1a44$var$write_XLSBCell(ncell, o);
    $1d9233f60ebd1a44$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $1d9233f60ebd1a44$var$parse_BrtShortSt(data) {
    var cell = $1d9233f60ebd1a44$var$parse_XLSBShortCell(data);
    var value = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $1d9233f60ebd1a44$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(8 + 4 * data.length);
    $1d9233f60ebd1a44$var$write_XLSBShortCell(ncell, o);
    $1d9233f60ebd1a44$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $1d9233f60ebd1a44$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "b"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $1d9233f60ebd1a44$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $1d9233f60ebd1a44$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $1d9233f60ebd1a44$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "e"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $1d9233f60ebd1a44$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $1d9233f60ebd1a44$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $1d9233f60ebd1a44$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $1d9233f60ebd1a44$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        "n"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $1d9233f60ebd1a44$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $1d9233f60ebd1a44$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $1d9233f60ebd1a44$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $1d9233f60ebd1a44$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        "str"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $1d9233f60ebd1a44$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $1d9233f60ebd1a44$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $1d9233f60ebd1a44$var$parse_BrtMergeCell = $1d9233f60ebd1a44$var$parse_UncheckedRfX;
var $1d9233f60ebd1a44$var$write_BrtMergeCell = $1d9233f60ebd1a44$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $1d9233f60ebd1a44$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $1d9233f60ebd1a44$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $1d9233f60ebd1a44$var$parse_UncheckedRfX(data, 16);
    var relId = $1d9233f60ebd1a44$var$parse_XLNullableWideString(data);
    var loc = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    var tooltip = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    var display = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $1d9233f60ebd1a44$var$write_BrtHLink(l, rId) {
    var o = $1d9233f60ebd1a44$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $1d9233f60ebd1a44$var$write_UncheckedRfX({
        s: $1d9233f60ebd1a44$var$decode_cell(l[0]),
        e: $1d9233f60ebd1a44$var$decode_cell(l[0])
    }, o);
    $1d9233f60ebd1a44$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $1d9233f60ebd1a44$var$write_XLWideString(loc || "", o);
    $1d9233f60ebd1a44$var$write_XLWideString(l[1].Tooltip || "", o);
    $1d9233f60ebd1a44$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $1d9233f60ebd1a44$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $1d9233f60ebd1a44$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $1d9233f60ebd1a44$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $1d9233f60ebd1a44$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $1d9233f60ebd1a44$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $1d9233f60ebd1a44$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $1d9233f60ebd1a44$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $1d9233f60ebd1a44$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(18);
    var p = $1d9233f60ebd1a44$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == "number") flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $1d9233f60ebd1a44$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $1d9233f60ebd1a44$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $1d9233f60ebd1a44$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $1d9233f60ebd1a44$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $1d9233f60ebd1a44$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(48);
    $1d9233f60ebd1a44$var$default_margins(margins);
    $1d9233f60ebd1a44$var$BrtMarginKeys.forEach(function(k) {
        $1d9233f60ebd1a44$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $1d9233f60ebd1a44$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $1d9233f60ebd1a44$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $1d9233f60ebd1a44$var$write_BrtCellIgnoreEC(ref) {
    var o = $1d9233f60ebd1a44$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $1d9233f60ebd1a44$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $1d9233f60ebd1a44$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $1d9233f60ebd1a44$var$new_buf(66);
    o.write_shift(2, sp.password ? $1d9233f60ebd1a44$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $1d9233f60ebd1a44$var$parse_BrtDVal() {}
function $1d9233f60ebd1a44$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $1d9233f60ebd1a44$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        "!id": {}
    };
    if ($1d9233f60ebd1a44$var$DENSE != null && opts.dense == null) opts.dense = $1d9233f60ebd1a44$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts["!row"] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $1d9233f60ebd1a44$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $1d9233f60ebd1a44$var$parse_BrtShortReal
    };
    var cm, vm;
    $1d9233f60ebd1a44$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $1d9233f60ebd1a44$var$encode_row(R = row.r);
                opts["!row"] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $1d9233f60ebd1a44$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case "n":
                        p.v = val[1];
                        break;
                    case "s":
                        sstr = $1d9233f60ebd1a44$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case "b":
                        p.v = val[1] ? true : false;
                        break;
                    case "e":
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $1d9233f60ebd1a44$var$BErr[p.v];
                        break;
                    case "str":
                        p.t = "s";
                        p.v = val[1];
                        break;
                    case "is":
                        p.t = "s";
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $1d9233f60ebd1a44$var$safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$1d9233f60ebd1a44$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $1d9233f60ebd1a44$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == "n" && $1d9233f60ebd1a44$var$fmt_is_date($1d9233f60ebd1a44$var$table_fmt[cf.numFmtId])) {
                    var _d = $1d9233f60ebd1a44$var$SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = "d";
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: "z",
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$1d9233f60ebd1a44$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels["!id"][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == "") val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: "z",
                        v: undefined
                    };
                    s["!data"][R][C].l = val;
                } else {
                    addr = $1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: "z",
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s["!data"][R][C] : s[$1d9233f60ebd1a44$var$encode_col(C) + rr];
                cell.f = $1d9233f60ebd1a44$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $1d9233f60ebd1a44$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$1d9233f60ebd1a44$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s["!data"][R][C] : s[$1d9233f60ebd1a44$var$encode_col(C) + rr];
                cell.f = $1d9233f60ebd1a44$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $1d9233f60ebd1a44$var$find_mdw_colw(val.w / 256);
                    }
                    $1d9233f60ebd1a44$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s["!autofilter"] = {
                    ref: $1d9233f60ebd1a44$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s["!margins"] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s["!outline"] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts["!row"];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $1d9233f60ebd1a44$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $1d9233f60ebd1a44$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $1d9233f60ebd1a44$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function $1d9233f60ebd1a44$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws["!comments"].push([
        $1d9233f60ebd1a44$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "d":
            cell = $1d9233f60ebd1a44$var$dup(cell);
            cell.z = cell.z || $1d9233f60ebd1a44$var$table_fmt[14];
            cell.v = $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(cell.v));
            cell.t = "n";
            break;
        /* falls through */ case "n":
        case "e":
            vv = "" + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws["!links"].push([
        $1d9233f60ebd1a44$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case "s":
        case "str":
            if (opts.bookSST) {
                vv = $1d9233f60ebd1a44$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $1d9233f60ebd1a44$var$write_BrtShortIsst(cell, o));
                else $1d9233f60ebd1a44$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $1d9233f60ebd1a44$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x0011 /* BrtShortSt */ , $1d9233f60ebd1a44$var$write_BrtShortSt(cell, o));
                else $1d9233f60ebd1a44$var$write_record(ba, 0x0006 /* BrtCellSt */ , $1d9233f60ebd1a44$var$write_BrtCellSt(cell, o));
            }
            return true;
        case "n":
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x000D /* BrtShortRk */ , $1d9233f60ebd1a44$var$write_BrtShortRk(cell, o));
                else $1d9233f60ebd1a44$var$write_record(ba, 0x0002 /* BrtCellRk */ , $1d9233f60ebd1a44$var$write_BrtCellRk(cell, o));
            } else if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x0010 /* BrtShortReal */ , $1d9233f60ebd1a44$var$write_BrtShortReal(cell, o));
            else $1d9233f60ebd1a44$var$write_record(ba, 0x0005 /* BrtCellReal */ , $1d9233f60ebd1a44$var$write_BrtCellReal(cell, o));
            return true;
        case "b":
            o.t = "b";
            if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x000F /* BrtShortBool */ , $1d9233f60ebd1a44$var$write_BrtShortBool(cell, o));
            else $1d9233f60ebd1a44$var$write_record(ba, 0x0004 /* BrtCellBool */ , $1d9233f60ebd1a44$var$write_BrtCellBool(cell, o));
            return true;
        case "e":
            o.t = "e";
            if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x000E /* BrtShortError */ , $1d9233f60ebd1a44$var$write_BrtShortError(cell, o));
            else $1d9233f60ebd1a44$var$write_record(ba, 0x0003 /* BrtCellError */ , $1d9233f60ebd1a44$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $1d9233f60ebd1a44$var$write_record(ba, 0x000C /* BrtShortBlank */ , $1d9233f60ebd1a44$var$write_BrtShortBlank(cell, o));
    else $1d9233f60ebd1a44$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $1d9233f60ebd1a44$var$write_BrtCellBlank(cell, o));
    return true;
}
function $1d9233f60ebd1a44$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    $1d9233f60ebd1a44$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null;
    var cap = range.e.r;
    if (ws["!rows"]) cap = Math.max(range.e.r, ws["!rows"].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $1d9233f60ebd1a44$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $1d9233f60ebd1a44$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $1d9233f60ebd1a44$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    $1d9233f60ebd1a44$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $1d9233f60ebd1a44$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!merges"]) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $1d9233f60ebd1a44$var$write_BrtBeginMergeCells(ws["!merges"].length));
    ws["!merges"].forEach(function(m) {
        $1d9233f60ebd1a44$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $1d9233f60ebd1a44$var$write_BrtMergeCell(m));
    });
    $1d9233f60ebd1a44$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $1d9233f60ebd1a44$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws["!cols"]) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws["!cols"].forEach(function(m, i) {
        if (m) $1d9233f60ebd1a44$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $1d9233f60ebd1a44$var$write_BrtColInfo(i, m));
    });
    $1d9233f60ebd1a44$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $1d9233f60ebd1a44$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!ref"]) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $1d9233f60ebd1a44$var$write_BrtCellIgnoreEC($1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"])));
    $1d9233f60ebd1a44$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $1d9233f60ebd1a44$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws["!links"].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $1d9233f60ebd1a44$var$add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), $1d9233f60ebd1a44$var$RELS.HLINK);
        $1d9233f60ebd1a44$var$write_record(ba, 0x01EE /* BrtHLink */ , $1d9233f60ebd1a44$var$write_BrtHLink(l, rId));
    });
    delete ws["!links"];
}
function $1d9233f60ebd1a44$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws["!comments"].length > 0) {
        var rId = $1d9233f60ebd1a44$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $1d9233f60ebd1a44$var$RELS.VML);
        $1d9233f60ebd1a44$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $1d9233f60ebd1a44$var$write_RelID("rId" + rId));
        ws["!legacy"] = rId;
    }
}
function $1d9233f60ebd1a44$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws["!autofilter"]) return;
    var data = ws["!autofilter"];
    var ref = typeof data.ref === "string" ? data.ref : $1d9233f60ebd1a44$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $1d9233f60ebd1a44$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]).e.r;
        ref = $1d9233f60ebd1a44$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = $1d9233f60ebd1a44$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $1d9233f60ebd1a44$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: $1d9233f60ebd1a44$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $1d9233f60ebd1a44$var$fix_range(ref)
    });
    $1d9233f60ebd1a44$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $1d9233f60ebd1a44$var$write_UncheckedRfX($1d9233f60ebd1a44$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $1d9233f60ebd1a44$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $1d9233f60ebd1a44$var$write_WSVIEWS2(ba, ws, Workbook) {
    $1d9233f60ebd1a44$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $1d9233f60ebd1a44$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $1d9233f60ebd1a44$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $1d9233f60ebd1a44$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $1d9233f60ebd1a44$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $1d9233f60ebd1a44$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $1d9233f60ebd1a44$var$write_SHEETPROTECT(ba, ws) {
    if (!ws["!protect"]) return;
    /* [BrtSheetProtectionIso] */ $1d9233f60ebd1a44$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $1d9233f60ebd1a44$var$write_BrtSheetProtection(ws["!protect"]));
}
function $1d9233f60ebd1a44$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws["!links"] = [];
    /* passed back to write_zip and removed there */ ws["!comments"] = [];
    $1d9233f60ebd1a44$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws["!outline"]) $1d9233f60ebd1a44$var$write_record(ba, 0x0093 /* BrtWsProp */ , $1d9233f60ebd1a44$var$write_BrtWsProp(c, ws["!outline"]));
    $1d9233f60ebd1a44$var$write_record(ba, 0x0094 /* BrtWsDim */ , $1d9233f60ebd1a44$var$write_BrtWsDim(r));
    $1d9233f60ebd1a44$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $1d9233f60ebd1a44$var$write_WSFMTINFO(ba, ws);
    $1d9233f60ebd1a44$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $1d9233f60ebd1a44$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $1d9233f60ebd1a44$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $1d9233f60ebd1a44$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $1d9233f60ebd1a44$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $1d9233f60ebd1a44$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws["!margins"]) $1d9233f60ebd1a44$var$write_record(ba, 0x01DC /* BrtMargins */ , $1d9233f60ebd1a44$var$write_BrtMargins(ws["!margins"]));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $1d9233f60ebd1a44$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $1d9233f60ebd1a44$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $1d9233f60ebd1a44$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $1d9233f60ebd1a44$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $1d9233f60ebd1a44$var$unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $1d9233f60ebd1a44$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = $1d9233f60ebd1a44$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $1d9233f60ebd1a44$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: "n",
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $1d9233f60ebd1a44$var$encode_row(i)] = {
                t: "n",
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $1d9233f60ebd1a44$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($1d9233f60ebd1a44$var$sheetprregex);
    if (sheetPr) $1d9233f60ebd1a44$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s["!rel"] = m[1];
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $1d9233f60ebd1a44$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $1d9233f60ebd1a44$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $1d9233f60ebd1a44$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $1d9233f60ebd1a44$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s["!rel"] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $1d9233f60ebd1a44$var$WBPropsDef = [
    [
        "allowRefreshQuery",
        false,
        "bool"
    ],
    [
        "autoCompressPictures",
        true,
        "bool"
    ],
    [
        "backupFile",
        false,
        "bool"
    ],
    [
        "checkCompatibility",
        false,
        "bool"
    ],
    [
        "CodeName",
        ""
    ],
    [
        "date1904",
        false,
        "bool"
    ],
    [
        "defaultThemeVersion",
        0,
        "int"
    ],
    [
        "filterPrivacy",
        false,
        "bool"
    ],
    [
        "hidePivotFieldList",
        false,
        "bool"
    ],
    [
        "promptedSolutions",
        false,
        "bool"
    ],
    [
        "publishItems",
        false,
        "bool"
    ],
    [
        "refreshAllConnections",
        false,
        "bool"
    ],
    [
        "saveExternalLinkValues",
        true,
        "bool"
    ],
    [
        "showBorderUnselectedTables",
        true,
        "bool"
    ],
    [
        "showInkAnnotation",
        true,
        "bool"
    ],
    [
        "showObjects",
        "all"
    ],
    [
        "showPivotChartFilter",
        false,
        "bool"
    ],
    [
        "updateLinks",
        "userSet"
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $1d9233f60ebd1a44$var$WBViewDef = [
    [
        "activeTab",
        0,
        "int"
    ],
    [
        "autoFilterDateGrouping",
        true,
        "bool"
    ],
    [
        "firstSheet",
        0,
        "int"
    ],
    [
        "minimized",
        false,
        "bool"
    ],
    [
        "showHorizontalScroll",
        true,
        "bool"
    ],
    [
        "showSheetTabs",
        true,
        "bool"
    ],
    [
        "showVerticalScroll",
        true,
        "bool"
    ],
    [
        "tabRatio",
        600,
        "int"
    ],
    [
        "visibility",
        "visible"
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $1d9233f60ebd1a44$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $1d9233f60ebd1a44$var$CalcPrDef = [
    [
        "calcCompleted",
        "true"
    ],
    [
        "calcMode",
        "auto"
    ],
    [
        "calcOnSave",
        "true"
    ],
    [
        "concurrentCalc",
        "true"
    ],
    [
        "fullCalcOnLoad",
        "false"
    ],
    [
        "fullPrecision",
        "true"
    ],
    [
        "iterate",
        "false"
    ],
    [
        "iterateCount",
        "100"
    ],
    [
        "iterateDelta",
        "0.001"
    ],
    [
        "refMode",
        "A1"
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $1d9233f60ebd1a44$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $1d9233f60ebd1a44$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $1d9233f60ebd1a44$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $1d9233f60ebd1a44$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $1d9233f60ebd1a44$var$parse_wb_defaults(wb) {
    $1d9233f60ebd1a44$var$push_defaults(wb.WBProps, $1d9233f60ebd1a44$var$WBPropsDef);
    $1d9233f60ebd1a44$var$push_defaults(wb.CalcPr, $1d9233f60ebd1a44$var$CalcPrDef);
    $1d9233f60ebd1a44$var$push_defaults_array(wb.WBView, $1d9233f60ebd1a44$var$WBViewDef);
    $1d9233f60ebd1a44$var$push_defaults_array(wb.Sheets, $1d9233f60ebd1a44$var$SheetDef);
    $1d9233f60ebd1a44$var$_ssfopts.date1904 = $1d9233f60ebd1a44$var$parsexmlbool(wb.WBProps.date1904);
}
function $1d9233f60ebd1a44$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $1d9233f60ebd1a44$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $1d9233f60ebd1a44$var$badchars = /*#__PURE__*/ ":][*?/\\".split("");
function $1d9233f60ebd1a44$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    if (n.length > 31) {
        if (safe) return false;
        throw new Error("Sheet names cannot exceed 31 chars");
    }
    var _good = true;
    $1d9233f60ebd1a44$var$badchars.forEach(function(c) {
        if (n.indexOf(c) == -1) return;
        if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        _good = false;
    });
    return _good;
}
function $1d9233f60ebd1a44$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $1d9233f60ebd1a44$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $1d9233f60ebd1a44$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $1d9233f60ebd1a44$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$1d9233f60ebd1a44$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $1d9233f60ebd1a44$var$formula_quote_sheet_name(n) + "!" + $1d9233f60ebd1a44$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $1d9233f60ebd1a44$var$wbnsregex = /<\w+:workbook/;
function $1d9233f60ebd1a44$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($1d9233f60ebd1a44$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $1d9233f60ebd1a44$var$parsexmltag(x);
        switch($1d9233f60ebd1a44$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case "<workbook":
                if (x.match($1d9233f60ebd1a44$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case "</workbook>":
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case "<fileVersion":
                delete y[0];
                wb.AppVersion = y;
                break;
            case "<fileVersion/>":
            case "</fileVersion>":
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case "<fileSharing":
                break;
            case "<fileSharing/>":
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case "<workbookPr":
            case "<workbookPr/>":
                $1d9233f60ebd1a44$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $1d9233f60ebd1a44$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $1d9233f60ebd1a44$var$utf8read(y.codeName);
                break;
            case "</workbookPr>":
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case "<workbookProtection":
                break;
            case "<workbookProtection/>":
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case "<bookViews":
            case "<bookViews>":
            case "</bookViews>":
                break;
            /* 18.2.30   workbookView CT_BookView + */ case "<workbookView":
            case "<workbookView/>":
                delete y[0];
                wb.WBView.push(y);
                break;
            case "</workbookView>":
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case "<sheets":
            case "<sheets>":
            case "</sheets>":
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case "<sheet":
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case "</sheet>":
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case "<functionGroups":
            case "<functionGroups/>":
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case "<functionGroup":
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case "<externalReferences":
            case "</externalReferences>":
            case "<externalReferences>":
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case "<externalReference":
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case "<definedNames/>":
                break;
            case "<definedNames>":
            case "<definedNames":
                pass = true;
                break;
            case "</definedNames>":
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case "<definedName":
                dname = {};
                dname.Name = $1d9233f60ebd1a44$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($1d9233f60ebd1a44$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case "</definedName>":
                dname.Ref = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case "<definedName/>":
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case "<calcPr":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "<calcPr/>":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "</calcPr>":
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case "<oleSize":
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case "<customWorkbookViews>":
            case "</customWorkbookViews>":
            case "<customWorkbookViews":
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case "<customWorkbookView":
            case "</customWorkbookView>":
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case "<pivotCaches>":
            case "</pivotCaches>":
            case "<pivotCaches":
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case "<pivotCache":
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case "<smartTagPr":
            case "<smartTagPr/>":
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case "<smartTagTypes":
            case "<smartTagTypes>":
            case "</smartTagTypes>":
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case "<smartTagType":
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case "<webPublishing":
            case "<webPublishing/>":
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case "<fileRecoveryPr":
            case "<fileRecoveryPr/>":
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case "<webPublishObjects>":
            case "<webPublishObjects":
            case "</webPublishObjects>":
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case "<webPublishObject":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break; //TODO: check with versions of excel
            case "</ext>":
                pass = false;
                break;
            /* Others */ case "<ArchID":
                break;
            case "<AlternateContent":
            case "<AlternateContent>":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* TODO */ case "<revisionPtr":
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in workbook");
        }
        return x;
    });
    if ($1d9233f60ebd1a44$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $1d9233f60ebd1a44$var$parse_wb_defaults(wb);
    return wb;
}
function $1d9233f60ebd1a44$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $1d9233f60ebd1a44$var$XML_HEADER
    ];
    o[o.length] = $1d9233f60ebd1a44$var$writextag("workbook", null, {
        "xmlns": $1d9233f60ebd1a44$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        "xmlns:r": $1d9233f60ebd1a44$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $1d9233f60ebd1a44$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $1d9233f60ebd1a44$var$writextag("workbookPr", null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $1d9233f60ebd1a44$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $1d9233f60ebd1a44$var$writextag("sheet", null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $1d9233f60ebd1a44$var$writextag("definedName", $1d9233f60ebd1a44$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = "</workbook>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $1d9233f60ebd1a44$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $1d9233f60ebd1a44$var$parse_RelID(data, length - 8);
    z.name = $1d9233f60ebd1a44$var$parse_XLWideString(data);
    return z;
}
function $1d9233f60ebd1a44$var$write_BrtBundleSh(data, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $1d9233f60ebd1a44$var$write_RelID(data.strRelID, o);
    $1d9233f60ebd1a44$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $1d9233f60ebd1a44$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $1d9233f60ebd1a44$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $1d9233f60ebd1a44$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $1d9233f60ebd1a44$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $1d9233f60ebd1a44$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $1d9233f60ebd1a44$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $1d9233f60ebd1a44$var$parse_XLNameWideString(data);
    var formula = $1d9233f60ebd1a44$var$parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = $1d9233f60ebd1a44$var$parse_XLNullableWideString(data);
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $1d9233f60ebd1a44$var$write_BrtName(name, wb) {
    var o = $1d9233f60ebd1a44$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($1d9233f60ebd1a44$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $1d9233f60ebd1a44$var$write_XLWideString(dname),
        $1d9233f60ebd1a44$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($1d9233f60ebd1a44$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $1d9233f60ebd1a44$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $1d9233f60ebd1a44$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $1d9233f60ebd1a44$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $1d9233f60ebd1a44$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $1d9233f60ebd1a44$var$parse_BrtFRTArchID$
    };
    $1d9233f60ebd1a44$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = $1d9233f60ebd1a44$var$stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $1d9233f60ebd1a44$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $1d9233f60ebd1a44$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $1d9233f60ebd1a44$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: "rId" + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $1d9233f60ebd1a44$var$write_record(ba, 0x009C /* BrtBundleSh */ , $1d9233f60ebd1a44$var$write_BrtBundleSh(d));
    }
    $1d9233f60ebd1a44$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $1d9233f60ebd1a44$var$write_BrtFileVersion(data, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $1d9233f60ebd1a44$var$write_XLWideString("SheetJS", o);
    $1d9233f60ebd1a44$var$write_XLWideString($1d9233f60ebd1a44$var$XLSX.version, o);
    $1d9233f60ebd1a44$var$write_XLWideString($1d9233f60ebd1a44$var$XLSX.version, o);
    $1d9233f60ebd1a44$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $1d9233f60ebd1a44$var$write_BrtBookView(idx, o) {
    if (!o) o = $1d9233f60ebd1a44$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $1d9233f60ebd1a44$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $1d9233f60ebd1a44$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x009E /* BrtBookView */ , $1d9233f60ebd1a44$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $1d9233f60ebd1a44$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $1d9233f60ebd1a44$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $1d9233f60ebd1a44$var$write_record(ba, 0x0027 /* BrtName */ , $1d9233f60ebd1a44$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $1d9233f60ebd1a44$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $1d9233f60ebd1a44$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $1d9233f60ebd1a44$var$write_EXTERNALS_xlsb(ba, wb) {
    $1d9233f60ebd1a44$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x016A /* BrtExternSheet */ , $1d9233f60ebd1a44$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $1d9233f60ebd1a44$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $1d9233f60ebd1a44$var$write_wb_bin(wb, opts) {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    $1d9233f60ebd1a44$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $1d9233f60ebd1a44$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $1d9233f60ebd1a44$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $1d9233f60ebd1a44$var$write_record(ba, 0x0099 /* BrtWbProp */ , $1d9233f60ebd1a44$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $1d9233f60ebd1a44$var$write_BOOKVIEWS(ba, wb, opts);
    $1d9233f60ebd1a44$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $1d9233f60ebd1a44$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $1d9233f60ebd1a44$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $1d9233f60ebd1a44$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $1d9233f60ebd1a44$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_wb_bin(data /*:any*/ , opts);
    return $1d9233f60ebd1a44$var$parse_wb_xml(data /*:any*/ , opts);
}
function $1d9233f60ebd1a44$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $1d9233f60ebd1a44$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $1d9233f60ebd1a44$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $1d9233f60ebd1a44$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $1d9233f60ebd1a44$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $1d9233f60ebd1a44$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $1d9233f60ebd1a44$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $1d9233f60ebd1a44$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $1d9233f60ebd1a44$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $1d9233f60ebd1a44$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $1d9233f60ebd1a44$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_sst_bin(data /*:any*/ , opts);
    return $1d9233f60ebd1a44$var$parse_sst_xml(data /*:any*/ , opts);
}
function $1d9233f60ebd1a44$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_comments_bin(data /*:any*/ , opts);
    return $1d9233f60ebd1a44$var$parse_comments_xml(data /*:any*/ , opts);
}
function $1d9233f60ebd1a44$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $1d9233f60ebd1a44$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $1d9233f60ebd1a44$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $1d9233f60ebd1a44$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $1d9233f60ebd1a44$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $1d9233f60ebd1a44$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $1d9233f60ebd1a44$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $1d9233f60ebd1a44$var$attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $1d9233f60ebd1a44$var$attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $1d9233f60ebd1a44$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($1d9233f60ebd1a44$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($1d9233f60ebd1a44$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $1d9233f60ebd1a44$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($1d9233f60ebd1a44$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($1d9233f60ebd1a44$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $1d9233f60ebd1a44$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $1d9233f60ebd1a44$var$xlml_format(format, value) /*:string*/ {
    var fmt = $1d9233f60ebd1a44$var$XLMLFormatMap[format] || $1d9233f60ebd1a44$var$unescapexml(format);
    if (fmt === "General") return $1d9233f60ebd1a44$var$SSF_general(value);
    return $1d9233f60ebd1a44$var$SSF_format(fmt, value);
}
function $1d9233f60ebd1a44$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $1d9233f60ebd1a44$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $1d9233f60ebd1a44$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$1d9233f60ebd1a44$var$unescapexml(key)] = oval;
}
function $1d9233f60ebd1a44$var$safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === "z") return;
    if (!o || o.cellText !== false) try {
        if (cell.t === "e") cell.w = cell.w || $1d9233f60ebd1a44$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === "n") {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $1d9233f60ebd1a44$var$SSF_general_num(cell.v);
            } else cell.w = $1d9233f60ebd1a44$var$SSF_general(cell.v);
        } else cell.w = $1d9233f60ebd1a44$var$xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $1d9233f60ebd1a44$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == "n" && $1d9233f60ebd1a44$var$fmt_is_date(z)) {
            var _d = $1d9233f60ebd1a44$var$SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = "d";
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $1d9233f60ebd1a44$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $1d9233f60ebd1a44$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $1d9233f60ebd1a44$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case "Boolean":
            cell.t = "b";
            cell.v = $1d9233f60ebd1a44$var$parsexmlbool(xml);
            break;
        case "String":
            cell.t = "s";
            cell.r = $1d9233f60ebd1a44$var$xlml_fixstr($1d9233f60ebd1a44$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $1d9233f60ebd1a44$var$unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case "DateTime":
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = ($1d9233f60ebd1a44$var$parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = $1d9233f60ebd1a44$var$unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case "Number":
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = "n";
            break;
        case "Error":
            cell.t = "e";
            cell.v = $1d9233f60ebd1a44$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = "z";
            else {
                cell.t = "s";
                cell.v = $1d9233f60ebd1a44$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $1d9233f60ebd1a44$var$safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $1d9233f60ebd1a44$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $1d9233f60ebd1a44$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $1d9233f60ebd1a44$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $1d9233f60ebd1a44$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $1d9233f60ebd1a44$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $1d9233f60ebd1a44$var$xlml_prefix_dname(dname) {
    return $1d9233f60ebd1a44$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $1d9233f60ebd1a44$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $1d9233f60ebd1a44$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $1d9233f60ebd1a44$var$make_ssf();
    var str = $1d9233f60ebd1a44$var$debom($1d9233f60ebd1a44$var$xlml_normalize(d));
    if (opts.type == "binary" || opts.type == "array" || opts.type == "base64") {
        if (typeof $1d9233f60ebd1a44$var$$cptable !== "undefined") str = $1d9233f60ebd1a44$var$$cptable.utils.decode(65001, $1d9233f60ebd1a44$var$char_codes(str));
        else str = $1d9233f60ebd1a44$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $1d9233f60ebd1a44$var$dup(opts);
        _o.type = "string";
        return $1d9233f60ebd1a44$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $1d9233f60ebd1a44$var$html_to_workbook(str, opts);
    $1d9233f60ebd1a44$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $1d9233f60ebd1a44$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $1d9233f60ebd1a44$var$table_fmt[15],
        "Short Date": $1d9233f60ebd1a44$var$table_fmt[14],
        "Long Time": $1d9233f60ebd1a44$var$table_fmt[19],
        "Medium Time": $1d9233f60ebd1a44$var$table_fmt[18],
        "Short Time": $1d9233f60ebd1a44$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $1d9233f60ebd1a44$var$table_fmt[2],
        "Standard": $1d9233f60ebd1a44$var$table_fmt[4],
        "Percent": $1d9233f60ebd1a44$var$table_fmt[10],
        "Scientific": $1d9233f60ebd1a44$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($1d9233f60ebd1a44$var$DENSE != null && opts.dense == null) opts.dense = $1d9233f60ebd1a44$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $1d9233f60ebd1a44$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $1d9233f60ebd1a44$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = $1d9233f60ebd1a44$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case "data" /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === "/") {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === "/") $1d9233f60ebd1a44$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case "cell" /*case 'Cell'*/ :
            if (Rn[1] === "/") {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$1d9233f60ebd1a44$var$encode_col(c) + $1d9233f60ebd1a44$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $1d9233f60ebd1a44$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: "z"
                                };
                            } else cursheet[$1d9233f60ebd1a44$var$encode_col(cma) + $1d9233f60ebd1a44$var$encode_row(cmd)] = {
                                t: "z"
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $1d9233f60ebd1a44$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case "row" /*case 'Row'*/ :
            if (Rn[1] === "/" || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $1d9233f60ebd1a44$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case "worksheet" /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $1d9233f60ebd1a44$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
                sheetname = $1d9233f60ebd1a44$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case "table" /*case 'Table'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case "style" /*case 'Style'*/ :
            if (Rn[1] === "/") $1d9233f60ebd1a44$var$process_style_xlml(styles, stag, opts);
            else stag = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
            break;
        case "numberformat" /*case 'NumberFormat'*/ :
            stag.nf = $1d9233f60ebd1a44$var$unescapexml($1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($1d9233f60ebd1a44$var$XLMLFormatMap[stag.nf]) stag.nf = $1d9233f60ebd1a44$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($1d9233f60ebd1a44$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($1d9233f60ebd1a44$var$table_fmt[ssfidx] == null) {
                    $1d9233f60ebd1a44$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case "column" /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ "table") break;
            if (Rn[1] === "/") break;
            csty = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $1d9233f60ebd1a44$var$MDW = $1d9233f60ebd1a44$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $1d9233f60ebd1a44$var$process_col(cstys[_col]);
            }
            if (seencol) $1d9233f60ebd1a44$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $1d9233f60ebd1a44$var$dup(csty);
            break;
        case "namedrange" /*case 'NamedRange'*/ :
            if (Rn[1] === "/") break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $1d9233f60ebd1a44$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $1d9233f60ebd1a44$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $1d9233f60ebd1a44$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case "namedcell" /*case 'NamedCell'*/ :
            break;
        case "b" /*case 'B'*/ :
            break;
        case "i" /*case 'I'*/ :
            break;
        case "u" /*case 'U'*/ :
            break;
        case "s" /*case 'S'*/ :
            break;
        case "em" /*case 'EM'*/ :
            break;
        case "h2" /*case 'H2'*/ :
            break;
        case "h3" /*case 'H3'*/ :
            break;
        case "sub" /*case 'Sub'*/ :
            break;
        case "sup" /*case 'Sup'*/ :
            break;
        case "span" /*case 'Span'*/ :
            break;
        case "alignment" /*case 'Alignment'*/ :
            break;
        case "borders" /*case 'Borders'*/ :
            break;
        case "border" /*case 'Border'*/ :
            break;
        case "font" /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case "interior" /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
            break;
        case "protection" /*case 'Protection'*/ :
            break;
        case "author" /*case 'Author'*/ :
        case "title" /*case 'Title'*/ :
        case "description" /*case 'Description'*/ :
        case "created" /*case 'Created'*/ :
        case "keywords" /*case 'Keywords'*/ :
        case "subject" /*case 'Subject'*/ :
        case "category" /*case 'Category'*/ :
        case "company" /*case 'Company'*/ :
        case "lastauthor" /*case 'LastAuthor'*/ :
        case "lastsaved" /*case 'LastSaved'*/ :
        case "lastprinted" /*case 'LastPrinted'*/ :
        case "version" /*case 'Version'*/ :
        case "revision" /*case 'Revision'*/ :
        case "totaltime" /*case 'TotalTime'*/ :
        case "hyperlinkbase" /*case 'HyperlinkBase'*/ :
        case "manager" /*case 'Manager'*/ :
        case "contentstatus" /*case 'ContentStatus'*/ :
        case "identifier" /*case 'Identifier'*/ :
        case "language" /*case 'Language'*/ :
        case "appname" /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $1d9233f60ebd1a44$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case "paragraphs" /*case 'Paragraphs'*/ :
            break;
        case "styles" /*case 'Styles'*/ :
        case "workbook" /*case 'Workbook'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case "comment" /*case 'Comment'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $1d9233f60ebd1a44$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case "autofilter" /*case 'AutoFilter'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                var AutoFilter = $1d9233f60ebd1a44$var$xlml_parsexmltag(Rn[0]);
                cursheet["!autofilter"] = {
                    ref: $1d9233f60ebd1a44$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "name" /*case 'Name'*/ :
            break;
        case "datavalidation" /*case 'DataValidation'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "pixelsperinch" /*case 'PixelsPerInch'*/ :
            break;
        case "componentoptions" /*case 'ComponentOptions'*/ :
        case "documentproperties" /*case 'DocumentProperties'*/ :
        case "customdocumentproperties" /*case 'CustomDocumentProperties'*/ :
        case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
        case "pivottable" /*case 'PivotTable'*/ :
        case "pivotcache" /*case 'PivotCache'*/ :
        case "names" /*case 'Names'*/ :
        case "mapinfo" /*case 'MapInfo'*/ :
        case "pagebreaks" /*case 'PageBreaks'*/ :
        case "querytable" /*case 'QueryTable'*/ :
        case "sorting" /*case 'Sorting'*/ :
        case "schema" /*case 'Schema'*/ :
        case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
        case "smarttagtype" /*case 'SmartTagType'*/ :
        case "smarttags" /*case 'SmartTags'*/ :
        case "excelworkbook" /*case 'ExcelWorkbook'*/ :
        case "workbookoptions" /*case 'WorkbookOptions'*/ :
        case "worksheetoptions" /*case 'WorksheetOptions'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "null" /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $1d9233f60ebd1a44$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $1d9233f60ebd1a44$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case "allowpng" /*case 'AllowPNG'*/ :
                            break;
                        case "removepersonalinformation" /*case 'RemovePersonalInformation'*/ :
                            break;
                        case "downloadcomponents" /*case 'DownloadComponents'*/ :
                            break;
                        case "locationofcomponents" /*case 'LocationOfComponents'*/ :
                            break;
                        case "colors" /*case 'Colors'*/ :
                            break;
                        case "color" /*case 'Color'*/ :
                            break;
                        case "index" /*case 'Index'*/ :
                            break;
                        case "rgb" /*case 'RGB'*/ :
                            break;
                        case "targetscreensize" /*case 'TargetScreenSize'*/ :
                            break;
                        case "readonlyrecommended" /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case "componentoptions" /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case "toolbar" /*case 'Toolbar'*/ :
                            break;
                        case "hideofficelogo" /*case 'HideOfficeLogo'*/ :
                            break;
                        case "spreadsheetautofit" /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case "label" /*case 'Label'*/ :
                            break;
                        case "caption" /*case 'Caption'*/ :
                            break;
                        case "maxheight" /*case 'MaxHeight'*/ :
                            break;
                        case "maxwidth" /*case 'MaxWidth'*/ :
                            break;
                        case "nextsheetnumber" /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case "excelworkbook" /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case "date1904" /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case "windowheight" /*case 'WindowHeight'*/ :
                            break;
                        case "windowwidth" /*case 'WindowWidth'*/ :
                            break;
                        case "windowtopx" /*case 'WindowTopX'*/ :
                            break;
                        case "windowtopy" /*case 'WindowTopY'*/ :
                            break;
                        case "tabratio" /*case 'TabRatio'*/ :
                            break;
                        case "protectstructure" /*case 'ProtectStructure'*/ :
                            break;
                        case "protectwindow" /*case 'ProtectWindow'*/ :
                            break;
                        case "protectwindows" /*case 'ProtectWindows'*/ :
                            break;
                        case "activesheet" /*case 'ActiveSheet'*/ :
                            break;
                        case "displayinknotes" /*case 'DisplayInkNotes'*/ :
                            break;
                        case "firstvisiblesheet" /*case 'FirstVisibleSheet'*/ :
                            break;
                        case "supbook" /*case 'SupBook'*/ :
                            break;
                        case "sheetname" /*case 'SheetName'*/ :
                            break;
                        case "sheetindex" /*case 'SheetIndex'*/ :
                            break;
                        case "sheetindexfirst" /*case 'SheetIndexFirst'*/ :
                            break;
                        case "sheetindexlast" /*case 'SheetIndexLast'*/ :
                            break;
                        case "dll" /*case 'Dll'*/ :
                            break;
                        case "acceptlabelsinformulas" /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case "donotsavelinkvalues" /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case "iteration" /*case 'Iteration'*/ :
                            break;
                        case "maxiterations" /*case 'MaxIterations'*/ :
                            break;
                        case "maxchange" /*case 'MaxChange'*/ :
                            break;
                        case "path" /*case 'Path'*/ :
                            break;
                        case "xct" /*case 'Xct'*/ :
                            break;
                        case "count" /*case 'Count'*/ :
                            break;
                        case "selectedsheets" /*case 'SelectedSheets'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        case "uncalced" /*case 'Uncalced'*/ :
                            break;
                        case "startupprompt" /*case 'StartupPrompt'*/ :
                            break;
                        case "crn" /*case 'Crn'*/ :
                            break;
                        case "externname" /*case 'ExternName'*/ :
                            break;
                        case "formula" /*case 'Formula'*/ :
                            break;
                        case "colfirst" /*case 'ColFirst'*/ :
                            break;
                        case "collast" /*case 'ColLast'*/ :
                            break;
                        case "wantadvise" /*case 'WantAdvise'*/ :
                            break;
                        case "boolean" /*case 'Boolean'*/ :
                            break;
                        case "error" /*case 'Error'*/ :
                            break;
                        case "text" /*case 'Text'*/ :
                            break;
                        case "ole" /*case 'OLE'*/ :
                            break;
                        case "noautorecover" /*case 'NoAutoRecover'*/ :
                            break;
                        case "publishobjects" /*case 'PublishObjects'*/ :
                            break;
                        case "donotcalculatebeforesave" /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "refmoder1c1" /*case 'RefModeR1C1'*/ :
                            break;
                        case "embedsavesmarttags" /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case "workbookoptions" /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case "owcversion" /*case 'OWCVersion'*/ :
                            break;
                        case "height" /*case 'Height'*/ :
                            break;
                        case "width" /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case "worksheetoptions" /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case "visible" /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case "header" /*case 'Header'*/ :
                            if (!cursheet["!margins"]) $1d9233f60ebd1a44$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$1d9233f60ebd1a44$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].header = +$1d9233f60ebd1a44$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "footer" /*case 'Footer'*/ :
                            if (!cursheet["!margins"]) $1d9233f60ebd1a44$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$1d9233f60ebd1a44$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].footer = +$1d9233f60ebd1a44$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "pagemargins" /*case 'PageMargins'*/ :
                            var pagemargins = $1d9233f60ebd1a44$var$parsexmltag(Rn[0]);
                            if (!cursheet["!margins"]) $1d9233f60ebd1a44$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+pagemargins.Top)) cursheet["!margins"].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet["!margins"].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet["!margins"].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet["!margins"].bottom = +pagemargins.Bottom;
                            break;
                        case "displayrighttoleft" /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case "freezepanes" /*case 'FreezePanes'*/ :
                            break;
                        case "frozennosplit" /*case 'FrozenNoSplit'*/ :
                            break;
                        case "splithorizontal" /*case 'SplitHorizontal'*/ :
                        case "splitvertical" /*case 'SplitVertical'*/ :
                            break;
                        case "donotdisplaygridlines" /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case "activerow" /*case 'ActiveRow'*/ :
                            break;
                        case "activecol" /*case 'ActiveCol'*/ :
                            break;
                        case "toprowbottompane" /*case 'TopRowBottomPane'*/ :
                            break;
                        case "leftcolumnrightpane" /*case 'LeftColumnRightPane'*/ :
                            break;
                        case "unsynced" /*case 'Unsynced'*/ :
                            break;
                        case "print" /*case 'Print'*/ :
                            break;
                        case "printerrors" /*case 'PrintErrors'*/ :
                            break;
                        case "panes" /*case 'Panes'*/ :
                            break;
                        case "scale" /*case 'Scale'*/ :
                            break;
                        case "pane" /*case 'Pane'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "layout" /*case 'Layout'*/ :
                            break;
                        case "pagesetup" /*case 'PageSetup'*/ :
                            break;
                        case "selected" /*case 'Selected'*/ :
                            break;
                        case "protectobjects" /*case 'ProtectObjects'*/ :
                            break;
                        case "enableselection" /*case 'EnableSelection'*/ :
                            break;
                        case "protectscenarios" /*case 'ProtectScenarios'*/ :
                            break;
                        case "validprinterinfo" /*case 'ValidPrinterInfo'*/ :
                            break;
                        case "horizontalresolution" /*case 'HorizontalResolution'*/ :
                            break;
                        case "verticalresolution" /*case 'VerticalResolution'*/ :
                            break;
                        case "numberofcopies" /*case 'NumberofCopies'*/ :
                            break;
                        case "activepane" /*case 'ActivePane'*/ :
                            break;
                        case "toprowvisible" /*case 'TopRowVisible'*/ :
                            break;
                        case "leftcolumnvisible" /*case 'LeftColumnVisible'*/ :
                            break;
                        case "fittopage" /*case 'FitToPage'*/ :
                            break;
                        case "rangeselection" /*case 'RangeSelection'*/ :
                            break;
                        case "papersizeindex" /*case 'PaperSizeIndex'*/ :
                            break;
                        case "pagelayoutzoom" /*case 'PageLayoutZoom'*/ :
                            break;
                        case "pagebreakzoom" /*case 'PageBreakZoom'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "fitwidth" /*case 'FitWidth'*/ :
                            break;
                        case "fitheight" /*case 'FitHeight'*/ :
                            break;
                        case "commentslayout" /*case 'CommentsLayout'*/ :
                            break;
                        case "zoom" /*case 'Zoom'*/ :
                            break;
                        case "lefttoright" /*case 'LeftToRight'*/ :
                            break;
                        case "gridlines" /*case 'Gridlines'*/ :
                            break;
                        case "allowsort" /*case 'AllowSort'*/ :
                            break;
                        case "allowfilter" /*case 'AllowFilter'*/ :
                            break;
                        case "allowinsertrows" /*case 'AllowInsertRows'*/ :
                            break;
                        case "allowdeleterows" /*case 'AllowDeleteRows'*/ :
                            break;
                        case "allowinsertcols" /*case 'AllowInsertCols'*/ :
                            break;
                        case "allowdeletecols" /*case 'AllowDeleteCols'*/ :
                            break;
                        case "allowinserthyperlinks" /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case "allowformatcells" /*case 'AllowFormatCells'*/ :
                            break;
                        case "allowsizecols" /*case 'AllowSizeCols'*/ :
                            break;
                        case "allowsizerows" /*case 'AllowSizeRows'*/ :
                            break;
                        case "nosummaryrowsbelowdetail" /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case "tabcolorindex" /*case 'TabColorIndex'*/ :
                            break;
                        case "donotdisplayheadings" /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case "showpagelayoutzoom" /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case "nosummarycolumnsrightdetail" /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case "blackandwhite" /*case 'BlackAndWhite'*/ :
                            break;
                        case "donotdisplayzeros" /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case "displaypagebreak" /*case 'DisplayPageBreak'*/ :
                            break;
                        case "rowcolheadings" /*case 'RowColHeadings'*/ :
                            break;
                        case "donotdisplayoutline" /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case "noorientation" /*case 'NoOrientation'*/ :
                            break;
                        case "allowusepivottables" /*case 'AllowUsePivotTables'*/ :
                            break;
                        case "zeroheight" /*case 'ZeroHeight'*/ :
                            break;
                        case "viewablerange" /*case 'ViewableRange'*/ :
                            break;
                        case "selection" /*case 'Selection'*/ :
                            break;
                        case "protectcontents" /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case "pivottable" /*case 'PivotTable'*/ :
                case "pivotcache" /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case "immediateitemsondrop" /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case "showpagemultipleitemlabel" /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case "compactrowindent" /*case 'CompactRowIndent'*/ :
                            break;
                        case "location" /*case 'Location'*/ :
                            break;
                        case "pivotfield" /*case 'PivotField'*/ :
                            break;
                        case "orientation" /*case 'Orientation'*/ :
                            break;
                        case "layoutform" /*case 'LayoutForm'*/ :
                            break;
                        case "layoutsubtotallocation" /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case "layoutcompactrow" /*case 'LayoutCompactRow'*/ :
                            break;
                        case "position" /*case 'Position'*/ :
                            break;
                        case "pivotitem" /*case 'PivotItem'*/ :
                            break;
                        case "datatype" /*case 'DataType'*/ :
                            break;
                        case "datafield" /*case 'DataField'*/ :
                            break;
                        case "sourcename" /*case 'SourceName'*/ :
                            break;
                        case "parentfield" /*case 'ParentField'*/ :
                            break;
                        case "ptlineitems" /*case 'PTLineItems'*/ :
                            break;
                        case "ptlineitem" /*case 'PTLineItem'*/ :
                            break;
                        case "countofsameitems" /*case 'CountOfSameItems'*/ :
                            break;
                        case "item" /*case 'Item'*/ :
                            break;
                        case "itemtype" /*case 'ItemType'*/ :
                            break;
                        case "ptsource" /*case 'PTSource'*/ :
                            break;
                        case "cacheindex" /*case 'CacheIndex'*/ :
                            break;
                        case "consolidationreference" /*case 'ConsolidationReference'*/ :
                            break;
                        case "filename" /*case 'FileName'*/ :
                            break;
                        case "reference" /*case 'Reference'*/ :
                            break;
                        case "nocolumngrand" /*case 'NoColumnGrand'*/ :
                            break;
                        case "norowgrand" /*case 'NoRowGrand'*/ :
                            break;
                        case "blanklineafteritems" /*case 'BlankLineAfterItems'*/ :
                            break;
                        case "hidden" /*case 'Hidden'*/ :
                            break;
                        case "subtotal" /*case 'Subtotal'*/ :
                            break;
                        case "basefield" /*case 'BaseField'*/ :
                            break;
                        case "mapchilditems" /*case 'MapChildItems'*/ :
                            break;
                        case "function" /*case 'Function'*/ :
                            break;
                        case "refreshonfileopen" /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case "printsettitles" /*case 'PrintSetTitles'*/ :
                            break;
                        case "mergelabels" /*case 'MergeLabels'*/ :
                            break;
                        case "defaultversion" /*case 'DefaultVersion'*/ :
                            break;
                        case "refreshname" /*case 'RefreshName'*/ :
                            break;
                        case "refreshdate" /*case 'RefreshDate'*/ :
                            break;
                        case "refreshdatecopy" /*case 'RefreshDateCopy'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        case "versionlastupdate" /*case 'VersionLastUpdate'*/ :
                            break;
                        case "versionupdateablemin" /*case 'VersionUpdateableMin'*/ :
                            break;
                        case "versionrefreshablemin" /*case 'VersionRefreshableMin'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case "pagebreaks" /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case "colbreaks" /*case 'ColBreaks'*/ :
                            break;
                        case "colbreak" /*case 'ColBreak'*/ :
                            break;
                        case "rowbreaks" /*case 'RowBreaks'*/ :
                            break;
                        case "rowbreak" /*case 'RowBreak'*/ :
                            break;
                        case "colstart" /*case 'ColStart'*/ :
                            break;
                        case "colend" /*case 'ColEnd'*/ :
                            break;
                        case "rowend" /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case "autofilter" /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case "autofiltercolumn" /*case 'AutoFilterColumn'*/ :
                            break;
                        case "autofiltercondition" /*case 'AutoFilterCondition'*/ :
                            break;
                        case "autofilterand" /*case 'AutoFilterAnd'*/ :
                            break;
                        case "autofilteror" /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case "querytable" /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case "id" /*case 'Id'*/ :
                            break;
                        case "autoformatfont" /*case 'AutoFormatFont'*/ :
                            break;
                        case "autoformatpattern" /*case 'AutoFormatPattern'*/ :
                            break;
                        case "querysource" /*case 'QuerySource'*/ :
                            break;
                        case "querytype" /*case 'QueryType'*/ :
                            break;
                        case "enableredirections" /*case 'EnableRedirections'*/ :
                            break;
                        case "refreshedinxl9" /*case 'RefreshedInXl9'*/ :
                            break;
                        case "urlstring" /*case 'URLString'*/ :
                            break;
                        case "htmltables" /*case 'HTMLTables'*/ :
                            break;
                        case "connection" /*case 'Connection'*/ :
                            break;
                        case "commandtext" /*case 'CommandText'*/ :
                            break;
                        case "refreshinfo" /*case 'RefreshInfo'*/ :
                            break;
                        case "notitles" /*case 'NoTitles'*/ :
                            break;
                        case "nextid" /*case 'NextId'*/ :
                            break;
                        case "columninfo" /*case 'ColumnInfo'*/ :
                            break;
                        case "overwritecells" /*case 'OverwriteCells'*/ :
                            break;
                        case "donotpromptforfile" /*case 'DoNotPromptForFile'*/ :
                            break;
                        case "textwizardsettings" /*case 'TextWizardSettings'*/ :
                            break;
                        case "source" /*case 'Source'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "decimal" /*case 'Decimal'*/ :
                            break;
                        case "thousandseparator" /*case 'ThousandSeparator'*/ :
                            break;
                        case "trailingminusnumbers" /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case "formatsettings" /*case 'FormatSettings'*/ :
                            break;
                        case "fieldtype" /*case 'FieldType'*/ :
                            break;
                        case "delimiters" /*case 'Delimiters'*/ :
                            break;
                        case "tab" /*case 'Tab'*/ :
                            break;
                        case "comma" /*case 'Comma'*/ :
                            break;
                        case "autoformatname" /*case 'AutoFormatName'*/ :
                            break;
                        case "versionlastedit" /*case 'VersionLastEdit'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "datavalidation" /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "sorting" /*case 'Sorting'*/ :
                case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case "mapinfo" /*case 'MapInfo'*/ :
                case "schema" /*case 'Schema'*/ :
                case "data" /*case 'data'*/ :
                    switch(Rn[3]){
                        case "map" /*case 'Map'*/ :
                            break;
                        case "entry" /*case 'Entry'*/ :
                            break;
                        case "range" /*case 'Range'*/ :
                            break;
                        case "xpath" /*case 'XPath'*/ :
                            break;
                        case "field" /*case 'Field'*/ :
                            break;
                        case "xsdtype" /*case 'XSDType'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "aggregate" /*case 'Aggregate'*/ :
                            break;
                        case "elementtype" /*case 'ElementType'*/ :
                            break;
                        case "attributetype" /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case "schema" /*case 'schema'*/ :
                        case "element" /*case 'element'*/ :
                        case "complextype" /*case 'complexType'*/ :
                        case "datatype" /*case 'datatype'*/ :
                        case "all" /*case 'all'*/ :
                        case "attribute" /*case 'attribute'*/ :
                        case "extends" /*case 'extends'*/ :
                            break;
                        case "row" /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case "smarttags" /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ "customdocumentproperties") {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $1d9233f60ebd1a44$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $1d9233f60ebd1a44$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $1d9233f60ebd1a44$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $1d9233f60ebd1a44$var$parse_xlml_xml($1d9233f60ebd1a44$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $1d9233f60ebd1a44$var$parse_xlml_xml(data, opts);
        case "array":
            return $1d9233f60ebd1a44$var$parse_xlml_xml($1d9233f60ebd1a44$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $1d9233f60ebd1a44$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($1d9233f60ebd1a44$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($1d9233f60ebd1a44$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $1d9233f60ebd1a44$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $1d9233f60ebd1a44$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($1d9233f60ebd1a44$var$writextag("NumberFormat", null, {
            "ss:Format": $1d9233f60ebd1a44$var$escapexml($1d9233f60ebd1a44$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($1d9233f60ebd1a44$var$writextag("Style", payload.join(""), o));
    });
    return $1d9233f60ebd1a44$var$writextag("Styles", styles.join(""));
}
function $1d9233f60ebd1a44$var$write_name_xlml(n) {
    return $1d9233f60ebd1a44$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $1d9233f60ebd1a44$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $1d9233f60ebd1a44$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($1d9233f60ebd1a44$var$write_name_xlml(n));
    }
    return $1d9233f60ebd1a44$var$writextag("Names", out.join(""));
}
function $1d9233f60ebd1a44$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($1d9233f60ebd1a44$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $1d9233f60ebd1a44$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws["!margins"]) {
        o.push("<PageSetup>");
        if (ws["!margins"].header) o.push($1d9233f60ebd1a44$var$writextag("Header", null, {
            "x:Margin": ws["!margins"].header
        }));
        if (ws["!margins"].footer) o.push($1d9233f60ebd1a44$var$writextag("Footer", null, {
            "x:Margin": ws["!margins"].footer
        }));
        o.push($1d9233f60ebd1a44$var$writextag("PageMargins", null, {
            "x:Bottom": ws["!margins"].bottom || "0.75",
            "x:Left": ws["!margins"].left || "0.7",
            "x:Right": ws["!margins"].right || "0.7",
            "x:Top": ws["!margins"].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($1d9233f60ebd1a44$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws["!protect"]) {
        o.push($1d9233f60ebd1a44$var$writetag("ProtectContents", "True"));
        if (ws["!protect"].objects) o.push($1d9233f60ebd1a44$var$writetag("ProtectObjects", "True"));
        if (ws["!protect"].scenarios) o.push($1d9233f60ebd1a44$var$writetag("ProtectScenarios", "True"));
        if (ws["!protect"].selectLockedCells != null && !ws["!protect"].selectLockedCells) o.push($1d9233f60ebd1a44$var$writetag("EnableSelection", "NoSelection"));
        else if (ws["!protect"].selectUnlockedCells != null && !ws["!protect"].selectUnlockedCells) o.push($1d9233f60ebd1a44$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws["!protect"][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $1d9233f60ebd1a44$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $1d9233f60ebd1a44$var$XLMLNS.x
    });
}
function $1d9233f60ebd1a44$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = $1d9233f60ebd1a44$var$xlml_unfixstr(c.t || "");
        var d = $1d9233f60ebd1a44$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return $1d9233f60ebd1a44$var$writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function $1d9233f60ebd1a44$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $1d9233f60ebd1a44$var$escapexml($1d9233f60ebd1a44$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $1d9233f60ebd1a44$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $1d9233f60ebd1a44$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $1d9233f60ebd1a44$var$escapexml(cell.l.Tooltip);
    }
    if (ws["!merges"]) {
        var marr = ws["!merges"];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr["ss:MergeAcross"] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr["ss:MergeDown"] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case "z":
            if (!opts.sheetStubs) return "";
            break;
        case "n":
            t = "Number";
            p = String(cell.v);
            break;
        case "b":
            t = "Boolean";
            p = cell.v ? "1" : "0";
            break;
        case "e":
            t = "Error";
            p = $1d9233f60ebd1a44$var$BErr[cell.v];
            break;
        case "d":
            t = "DateTime";
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $1d9233f60ebd1a44$var$table_fmt[14];
            break;
        case "s":
            t = "String";
            p = $1d9233f60ebd1a44$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == "z" ? "" : '<Data ss:Type="' + t + '">' + _v + "</Data>";
    if ((cell.c || []).length > 0) m += $1d9233f60ebd1a44$var$write_ws_xlml_comment(cell.c);
    return $1d9233f60ebd1a44$var$writextag("Cell", m, attr);
}
function $1d9233f60ebd1a44$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $1d9233f60ebd1a44$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + ">";
}
/* TODO */ function $1d9233f60ebd1a44$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws["!ref"]) return "";
    var range /*:Range*/  = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
    var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws["!cols"]) ws["!cols"].forEach(function(n, i) {
        $1d9233f60ebd1a44$var$process_col(n);
        var w = !!n.width;
        var p = $1d9233f60ebd1a44$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k["ss:Width"] = $1d9233f60ebd1a44$var$width2px(p.width);
        if (n.hidden) k["ss:Hidden"] = "1";
        o.push($1d9233f60ebd1a44$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $1d9233f60ebd1a44$var$write_ws_xlml_row(R, (ws["!rows"] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($1d9233f60ebd1a44$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $1d9233f60ebd1a44$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $1d9233f60ebd1a44$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $1d9233f60ebd1a44$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($1d9233f60ebd1a44$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $1d9233f60ebd1a44$var$a1_to_rc($1d9233f60ebd1a44$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $1d9233f60ebd1a44$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt);
    if (wb.SSF) {
        $1d9233f60ebd1a44$var$make_ssf();
        $1d9233f60ebd1a44$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $1d9233f60ebd1a44$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($1d9233f60ebd1a44$var$write_props_xlml(wb, opts));
    d.push($1d9233f60ebd1a44$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($1d9233f60ebd1a44$var$writextag("Worksheet", $1d9233f60ebd1a44$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $1d9233f60ebd1a44$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $1d9233f60ebd1a44$var$write_sty_xlml(wb, opts);
    d[3] = $1d9233f60ebd1a44$var$write_names_xlml(wb, opts);
    return $1d9233f60ebd1a44$var$XML_HEADER + $1d9233f60ebd1a44$var$writextag("Workbook", d.join(""), {
        "xmlns": $1d9233f60ebd1a44$var$XLMLNS.ss,
        "xmlns:o": $1d9233f60ebd1a44$var$XLMLNS.o,
        "xmlns:x": $1d9233f60ebd1a44$var$XLMLNS.x,
        "xmlns:ss": $1d9233f60ebd1a44$var$XLMLNS.ss,
        "xmlns:dt": $1d9233f60ebd1a44$var$XLMLNS.dt,
        "xmlns:html": $1d9233f60ebd1a44$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $1d9233f60ebd1a44$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $1d9233f60ebd1a44$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $1d9233f60ebd1a44$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $1d9233f60ebd1a44$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $1d9233f60ebd1a44$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $1d9233f60ebd1a44$var$__readUInt16LE(blob, blob.l), next = $1d9233f60ebd1a44$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $1d9233f60ebd1a44$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $1d9233f60ebd1a44$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $1d9233f60ebd1a44$var$XLSRecordEnum[nextrt = $1d9233f60ebd1a44$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $1d9233f60ebd1a44$var$bconcat(bufs);
    $1d9233f60ebd1a44$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $1d9233f60ebd1a44$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === "z") return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = $1d9233f60ebd1a44$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === "e") p.w = p.w || $1d9233f60ebd1a44$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $1d9233f60ebd1a44$var$SSF_general_num(p.v);
            } else p.w = $1d9233f60ebd1a44$var$SSF_general(p.v);
        } else p.w = $1d9233f60ebd1a44$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == "n" && $1d9233f60ebd1a44$var$fmt_is_date($1d9233f60ebd1a44$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $1d9233f60ebd1a44$var$SSF_parse_date_code(p.v);
        if (_d) {
            p.t = "d";
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function $1d9233f60ebd1a44$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $1d9233f60ebd1a44$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($1d9233f60ebd1a44$var$DENSE != null && options.dense == null) options.dense = $1d9233f60ebd1a44$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $1d9233f60ebd1a44$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $1d9233f60ebd1a44$var$XLSIcv[icv];
        return $1d9233f60ebd1a44$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $1d9233f60ebd1a44$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $1d9233f60ebd1a44$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $1d9233f60ebd1a44$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $1d9233f60ebd1a44$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $1d9233f60ebd1a44$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $1d9233f60ebd1a44$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $1d9233f60ebd1a44$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $1d9233f60ebd1a44$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $1d9233f60ebd1a44$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $1d9233f60ebd1a44$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == "PtgArea3d") FilterDatabases[val.itab - 1] = {
                            ref: $1d9233f60ebd1a44$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $1d9233f60ebd1a44$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $1d9233f60ebd1a44$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val.r] || [])[val.c] : out[$1d9233f60ebd1a44$var$encode_col(val.c) + $1d9233f60ebd1a44$var$encode_row(val.r)]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: "n"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == "String") {
                        last_formula = val;
                        break;
                    }
                    temp_val = $1d9233f60ebd1a44$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == "PtgExp") {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $1d9233f60ebd1a44$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $1d9233f60ebd1a44$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $1d9233f60ebd1a44$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $1d9233f60ebd1a44$var$make_cell(val, last_formula.cell.ixfe, "s");
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $1d9233f60ebd1a44$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $1d9233f60ebd1a44$var$encode_cell(val[0].s);
                    cc = options.dense ? (out["!data"][val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $1d9233f60ebd1a44$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $1d9233f60ebd1a44$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$1d9233f60ebd1a44$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$1d9233f60ebd1a44$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $1d9233f60ebd1a44$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $1d9233f60ebd1a44$var$make_cell(sst[val.isst].t, val.ixfe, "s");
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $1d9233f60ebd1a44$var$make_cell(val.val, val.ixfe, "s");
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $1d9233f60ebd1a44$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($1d9233f60ebd1a44$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $1d9233f60ebd1a44$var$SSF__load(val[1], BIFF2Fmt + 163);
                    } else $1d9233f60ebd1a44$var$SSF__load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($1d9233f60ebd1a44$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $1d9233f60ebd1a44$var$SSF__load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$1d9233f60ebd1a44$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$1d9233f60ebd1a44$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out["!data"][val[0].r] || [])[val[0].c] : out[$1d9233f60ebd1a44$var$encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val[0].r]) out["!data"][val[0].r] = [];
                            cc = out["!data"][val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$1d9233f60ebd1a44$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $1d9233f60ebd1a44$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $1d9233f60ebd1a44$var$find_mdw_colw(val.w / 256);
                        }
                        $1d9233f60ebd1a44$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $1d9233f60ebd1a44$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out["!margins"]) $1d9233f60ebd1a44$var$default_margins(out["!margins"] = {});
                    out["!margins"][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out["!margins"]) $1d9233f60ebd1a44$var$default_margins(out["!margins"] = {});
                    out["!margins"].header = val.header;
                    out["!margins"].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $1d9233f60ebd1a44$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]["!autofilter"] = r;
    });
    wb.Strings = sst;
    wb.SSF = $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $1d9233f60ebd1a44$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $1d9233f60ebd1a44$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/!DocumentSummaryInformation");
    if (DSI && DSI.size > 0) try {
        var DocSummary = $1d9233f60ebd1a44$var$parse_PropertySetStream(DSI, $1d9233f60ebd1a44$var$DocSummaryPIDDSI, $1d9233f60ebd1a44$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/!SummaryInformation");
    if (SI && SI.size > 0) try {
        var Summary = $1d9233f60ebd1a44$var$parse_PropertySetStream(SI, $1d9233f60ebd1a44$var$SummaryPIDSI, $1d9233f60ebd1a44$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $1d9233f60ebd1a44$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $1d9233f60ebd1a44$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $1d9233f60ebd1a44$var$evert_key($1d9233f60ebd1a44$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $1d9233f60ebd1a44$var$evert_key($1d9233f60ebd1a44$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $1d9233f60ebd1a44$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $1d9233f60ebd1a44$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($1d9233f60ebd1a44$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $1d9233f60ebd1a44$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05SummaryInformation", $1d9233f60ebd1a44$var$write_PropertySetStream(SEntries, $1d9233f60ebd1a44$var$PSCLSID.SI, SummaryRE, $1d9233f60ebd1a44$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05DocumentSummaryInformation", $1d9233f60ebd1a44$var$write_PropertySetStream(DSEntries, $1d9233f60ebd1a44$var$PSCLSID.DSI, DocSummaryRE, $1d9233f60ebd1a44$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $1d9233f60ebd1a44$var$PSCLSID.UDI));
}
function $1d9233f60ebd1a44$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $1d9233f60ebd1a44$var$fix_read_opts(options);
    $1d9233f60ebd1a44$var$reset_cp();
    if (options.codepage) $1d9233f60ebd1a44$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/encryption")) throw new Error("File is password-protected");
        CompObj = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "!CompObj");
        WB = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/Workbook") || $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/Book");
    } else {
        switch(options.type){
            case "base64":
                cfb = $1d9233f60ebd1a44$var$s2a($1d9233f60ebd1a44$var$Base64_decode(cfb));
                break;
            case "binary":
                cfb = $1d9233f60ebd1a44$var$s2a(cfb);
                break;
            case "buffer":
                break;
            case "array":
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $1d9233f60ebd1a44$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $1d9233f60ebd1a44$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $1d9233f60ebd1a44$var$has_buf ? "buffer" : "array";
        if (WB && WB.content) WorkbookP = $1d9233f60ebd1a44$var$parse_workbook(WB.content, options);
        else if ((_data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "PerfectOffice_MAIN")) && _data.content) WorkbookP = $1d9233f60ebd1a44$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "NativeContent_MAIN")) && _data.content) WorkbookP = $1d9233f60ebd1a44$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "MN0")) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "/_VBA_PROJECT_CUR/VBA/dir")) WorkbookP.vbaraw = $1d9233f60ebd1a44$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $1d9233f60ebd1a44$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $1d9233f60ebd1a44$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $1d9233f60ebd1a44$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $1d9233f60ebd1a44$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $1d9233f60ebd1a44$var$fill_vba_xls(cfb, $1d9233f60ebd1a44$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $1d9233f60ebd1a44$var$XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: $1d9233f60ebd1a44$var$parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: $1d9233f60ebd1a44$var$parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: $1d9233f60ebd1a44$var$parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: $1d9233f60ebd1a44$var$parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: $1d9233f60ebd1a44$var$parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: $1d9233f60ebd1a44$var$parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: $1d9233f60ebd1a44$var$parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: $1d9233f60ebd1a44$var$parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: $1d9233f60ebd1a44$var$parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: $1d9233f60ebd1a44$var$parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: $1d9233f60ebd1a44$var$parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: $1d9233f60ebd1a44$var$parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: $1d9233f60ebd1a44$var$parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: $1d9233f60ebd1a44$var$parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: $1d9233f60ebd1a44$var$parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: $1d9233f60ebd1a44$var$parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: $1d9233f60ebd1a44$var$parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: $1d9233f60ebd1a44$var$parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: $1d9233f60ebd1a44$var$parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: $1d9233f60ebd1a44$var$parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: $1d9233f60ebd1a44$var$parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: $1d9233f60ebd1a44$var$parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: $1d9233f60ebd1a44$var$parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: $1d9233f60ebd1a44$var$parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: $1d9233f60ebd1a44$var$parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: $1d9233f60ebd1a44$var$parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: $1d9233f60ebd1a44$var$parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: $1d9233f60ebd1a44$var$parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: $1d9233f60ebd1a44$var$parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: $1d9233f60ebd1a44$var$parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: $1d9233f60ebd1a44$var$parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: $1d9233f60ebd1a44$var$parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: $1d9233f60ebd1a44$var$parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: $1d9233f60ebd1a44$var$parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: $1d9233f60ebd1a44$var$parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: $1d9233f60ebd1a44$var$parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: $1d9233f60ebd1a44$var$parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: $1d9233f60ebd1a44$var$parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: $1d9233f60ebd1a44$var$parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: $1d9233f60ebd1a44$var$parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: $1d9233f60ebd1a44$var$parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: $1d9233f60ebd1a44$var$parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: $1d9233f60ebd1a44$var$parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: $1d9233f60ebd1a44$var$parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $1d9233f60ebd1a44$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: $1d9233f60ebd1a44$var$parse_Formula
    },
    /*::[*/ 0x000a: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x000c: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x000d: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x000e: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x000f: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0010: {
        f: $1d9233f60ebd1a44$var$parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0012: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0013: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x0014: {
        f: $1d9233f60ebd1a44$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: $1d9233f60ebd1a44$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: $1d9233f60ebd1a44$var$parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: $1d9233f60ebd1a44$var$parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: $1d9233f60ebd1a44$var$parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0023: {
        f: $1d9233f60ebd1a44$var$parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: $1d9233f60ebd1a44$var$parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: $1d9233f60ebd1a44$var$parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: $1d9233f60ebd1a44$var$parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: $1d9233f60ebd1a44$var$parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x002b: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x002f: {
        f: $1d9233f60ebd1a44$var$parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: $1d9233f60ebd1a44$var$parse_Font
    },
    /*::[*/ 0x0033: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: $1d9233f60ebd1a44$var$parse_Window1
    },
    /*::[*/ 0x0040: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0041: {
        f: $1d9233f60ebd1a44$var$parse_Pane
    },
    /*::[*/ 0x0042: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: $1d9233f60ebd1a44$var$parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: $1d9233f60ebd1a44$var$parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x007d: {
        f: $1d9233f60ebd1a44$var$parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: $1d9233f60ebd1a44$var$parse_Guts
    },
    /*::[*/ 0x0081: {
        f: $1d9233f60ebd1a44$var$parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x0083: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0084: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0085: {
        f: $1d9233f60ebd1a44$var$parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: $1d9233f60ebd1a44$var$parse_Country
    },
    /*::[*/ 0x008d: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: $1d9233f60ebd1a44$var$parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: $1d9233f60ebd1a44$var$parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: $1d9233f60ebd1a44$var$parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: $1d9233f60ebd1a44$var$parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: $1d9233f60ebd1a44$var$parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: $1d9233f60ebd1a44$var$parse_XF
    },
    /*::[*/ 0x00e1: {
        f: $1d9233f60ebd1a44$var$parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: $1d9233f60ebd1a44$var$parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: $1d9233f60ebd1a44$var$parse_SST
    },
    /*::[*/ 0x00fd: {
        f: $1d9233f60ebd1a44$var$parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: $1d9233f60ebd1a44$var$parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: $1d9233f60ebd1a44$var$parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x0161: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: $1d9233f60ebd1a44$var$parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: $1d9233f60ebd1a44$var$parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: $1d9233f60ebd1a44$var$parsebool
    },
    /*::[*/ 0x01b8: {
        f: $1d9233f60ebd1a44$var$parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: $1d9233f60ebd1a44$var$parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: $1d9233f60ebd1a44$var$parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x0200: {
        f: $1d9233f60ebd1a44$var$parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: $1d9233f60ebd1a44$var$parse_Blank
    },
    /*::[*/ 0x0203: {
        f: $1d9233f60ebd1a44$var$parse_Number
    },
    /*::[*/ 0x0204: {
        f: $1d9233f60ebd1a44$var$parse_Label
    },
    /*::[*/ 0x0205: {
        f: $1d9233f60ebd1a44$var$parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: $1d9233f60ebd1a44$var$parse_String
    },
    /*::[*/ 0x0208: {
        f: $1d9233f60ebd1a44$var$parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: $1d9233f60ebd1a44$var$parse_Array
    },
    /*::[*/ 0x0225: {
        f: $1d9233f60ebd1a44$var$parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: $1d9233f60ebd1a44$var$parse_Window2
    },
    /*::[*/ 0x027e: {
        f: $1d9233f60ebd1a44$var$parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: $1d9233f60ebd1a44$var$parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: $1d9233f60ebd1a44$var$parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: $1d9233f60ebd1a44$var$parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: $1d9233f60ebd1a44$var$parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: $1d9233f60ebd1a44$var$parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: $1d9233f60ebd1a44$var$parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: $1d9233f60ebd1a44$var$parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: $1d9233f60ebd1a44$var$parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: $1d9233f60ebd1a44$var$parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: $1d9233f60ebd1a44$var$parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: $1d9233f60ebd1a44$var$parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: $1d9233f60ebd1a44$var$parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: $1d9233f60ebd1a44$var$parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: $1d9233f60ebd1a44$var$parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: $1d9233f60ebd1a44$var$parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: $1d9233f60ebd1a44$var$parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: $1d9233f60ebd1a44$var$parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: $1d9233f60ebd1a44$var$parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: $1d9233f60ebd1a44$var$parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: $1d9233f60ebd1a44$var$parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: $1d9233f60ebd1a44$var$parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x001e: {
        f: $1d9233f60ebd1a44$var$parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: $1d9233f60ebd1a44$var$parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: $1d9233f60ebd1a44$var$parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: $1d9233f60ebd1a44$var$parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: $1d9233f60ebd1a44$var$parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: $1d9233f60ebd1a44$var$parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: $1d9233f60ebd1a44$var$parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: $1d9233f60ebd1a44$var$parse_Formula
    },
    /*::[*/ 0x0209: {
        f: $1d9233f60ebd1a44$var$parse_BOF
    },
    /*::[*/ 0x0218: {
        f: $1d9233f60ebd1a44$var$parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: $1d9233f60ebd1a44$var$parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: $1d9233f60ebd1a44$var$parse_Formula
    },
    /*::[*/ 0x0409: {
        f: $1d9233f60ebd1a44$var$parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ /*::[*/ 0x0065: {},
    /*::[*/ 0x0066: {},
    /*::[*/ 0x0069: {},
    /*::[*/ 0x006a: {},
    /*::[*/ 0x006b: {},
    /*::[*/ 0x006d: {},
    /*::[*/ 0x0070: {},
    /*::[*/ 0x0072: {},
    /*::[*/ 0x7262: {}
};
function $1d9233f60ebd1a44$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $1d9233f60ebd1a44$var$is_buf(payload)) ba.push(payload);
}
function $1d9233f60ebd1a44$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $1d9233f60ebd1a44$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $1d9233f60ebd1a44$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = $1d9233f60ebd1a44$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function $1d9233f60ebd1a44$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $1d9233f60ebd1a44$var$new_buf(9);
    $1d9233f60ebd1a44$var$write_BIFF2Cell(out, r, c);
    $1d9233f60ebd1a44$var$write_Bes(val, t || "b", out);
    return out;
}
/* TODO: codepage, large strings */ function $1d9233f60ebd1a44$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $1d9233f60ebd1a44$var$new_buf(8 + 2 * val.length);
    $1d9233f60ebd1a44$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, "sbcs");
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $1d9233f60ebd1a44$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0002, $1d9233f60ebd1a44$var$write_BIFF2INT(R, C, v));
            else $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0003, $1d9233f60ebd1a44$var$write_BIFF2NUM(R, C, v));
            return;
        case "b":
        case "e":
            $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0005, $1d9233f60ebd1a44$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case "s":
        case "str":
            $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0004, $1d9233f60ebd1a44$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0001, $1d9233f60ebd1a44$var$write_BIFF2Cell(null, R, C));
}
function $1d9233f60ebd1a44$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
    }
    var row = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $1d9233f60ebd1a44$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $1d9233f60ebd1a44$var$write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function $1d9233f60ebd1a44$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $1d9233f60ebd1a44$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $1d9233f60ebd1a44$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $1d9233f60ebd1a44$var$write_BOF(wb, 0x10, o));
    /* ... */ $1d9233f60ebd1a44$var$write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
function $1d9233f60ebd1a44$var$write_FONTS_biff8(ba, data, opts) {
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0031 /* Font */ , $1d9233f60ebd1a44$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $1d9233f60ebd1a44$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x041E /* Format */ , $1d9233f60ebd1a44$var$write_Format(i, NF[i], opts));
    });
}
function $1d9233f60ebd1a44$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $1d9233f60ebd1a44$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $1d9233f60ebd1a44$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $1d9233f60ebd1a44$var$write_Ref8U($1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"] || "A1"), o);
    o.write_shift(4, 4);
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $1d9233f60ebd1a44$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$1d9233f60ebd1a44$var$write_biff_rec(ba, 0x00e0 /* XF */ , $1d9233f60ebd1a44$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x00e0 /* XF */ , $1d9233f60ebd1a44$var$write_XF(c, 0, opts));
    });
}
function $1d9233f60ebd1a44$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws["!links"].length; ++R){
        var HL = ws["!links"][R];
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $1d9233f60ebd1a44$var$write_HLink(HL));
        if (HL[1].Tooltip) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $1d9233f60ebd1a44$var$write_HLinkTooltip(HL));
    }
    delete ws["!links"];
}
function $1d9233f60ebd1a44$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $1d9233f60ebd1a44$var$write_ColInfo($1d9233f60ebd1a44$var$col_obj_w(idx, col), idx));
    });
}
function $1d9233f60ebd1a44$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0201 /* Blank */ , $1d9233f60ebd1a44$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0006 /* Formula */ , $1d9233f60ebd1a44$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $1d9233f60ebd1a44$var$datenum($1d9233f60ebd1a44$var$parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0203 /* Number */ , $1d9233f60ebd1a44$var$write_Number(R, C, v, os, opts));
            break;
        case "b":
        case "e":
            $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $1d9233f60ebd1a44$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case "s":
        case "str":
            if (opts.bookSST) {
                var isst = $1d9233f60ebd1a44$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $1d9233f60ebd1a44$var$write_LabelSst(R, C, isst, os, opts));
            } else $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0204 /* Label */ , $1d9233f60ebd1a44$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0201 /* Blank */ , $1d9233f60ebd1a44$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $1d9233f60ebd1a44$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $1d9233f60ebd1a44$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0809, $1d9233f60ebd1a44$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $1d9233f60ebd1a44$var$writeuint16(1));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $1d9233f60ebd1a44$var$writeuint16(100));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $1d9233f60ebd1a44$var$writebool(true));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $1d9233f60ebd1a44$var$write_Xnum(0.001));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $1d9233f60ebd1a44$var$writebool(true));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $1d9233f60ebd1a44$var$writeuint16(1));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0080 /* Guts */ , $1d9233f60ebd1a44$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $1d9233f60ebd1a44$var$writebool(false));
    /* ... */ if (b8) $1d9233f60ebd1a44$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $1d9233f60ebd1a44$var$write_Dimensions(range, opts));
    /* ... */ if (b8) ws["!links"] = [];
    var comments = [];
    var row = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $1d9233f60ebd1a44$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var cell = dense ? row[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $1d9233f60ebd1a44$var$write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws["!links"].push([
                ref,
                cell.l
            ]);
            if (b8 && cell.c) comments.push([
                ref,
                cell.c
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ // if(b8) comments.forEach(function(comment) { write_biff_rec(ba, 0x001c /* Note */, write_NoteSh(comment)); });
    /* ... */ if (b8) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x023e /* Window2 */ , $1d9233f60ebd1a44$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws["!merges"] || []).length) $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $1d9233f60ebd1a44$var$write_MergeCells(ws["!merges"]));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $1d9233f60ebd1a44$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $1d9233f60ebd1a44$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $1d9233f60ebd1a44$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $1d9233f60ebd1a44$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $1d9233f60ebd1a44$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $1d9233f60ebd1a44$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0809, $1d9233f60ebd1a44$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $1d9233f60ebd1a44$var$writeuint16(0x04b0) : null);
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00c1 /* Mms */ , $1d9233f60ebd1a44$var$writezeroes(2));
    if (b5) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $1d9233f60ebd1a44$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0042 /* CodePage */ , $1d9233f60ebd1a44$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0161 /* DSF */ , $1d9233f60ebd1a44$var$writeuint16(0));
    if (b8) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x013d /* RRTabId */ , $1d9233f60ebd1a44$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $1d9233f60ebd1a44$var$write_biff_rec(A, 0x01ba /* CodeName */ , $1d9233f60ebd1a44$var$write_XLUnicodeString(cname, opts));
    }
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $1d9233f60ebd1a44$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0012 /* Protect */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0013 /* Password */ , $1d9233f60ebd1a44$var$writeuint16(0));
    if (b8) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $1d9233f60ebd1a44$var$writebool(false));
    if (b8) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $1d9233f60ebd1a44$var$writeuint16(0));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x003d /* Window1 */ , $1d9233f60ebd1a44$var$write_Window1(opts));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0040 /* Backup */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x008d /* HideObj */ , $1d9233f60ebd1a44$var$writeuint16(0));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $1d9233f60ebd1a44$var$writebool($1d9233f60ebd1a44$var$safe1904(wb) == "true"));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $1d9233f60ebd1a44$var$writebool(true));
    if (b8) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $1d9233f60ebd1a44$var$writebool(false));
    $1d9233f60ebd1a44$var$write_biff_rec(A, 0x00DA /* BookBool */ , $1d9233f60ebd1a44$var$writeuint16(0));
    /* ... */ $1d9233f60ebd1a44$var$write_FONTS_biff8(A, wb, opts);
    $1d9233f60ebd1a44$var$write_FMTS_biff8(A, wb.SSF, opts);
    $1d9233f60ebd1a44$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $1d9233f60ebd1a44$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $1d9233f60ebd1a44$var$writebool(false));
    var a = A.end();
    var C = $1d9233f60ebd1a44$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $1d9233f60ebd1a44$var$write_biff_rec(C, 0x008C /* Country */ , $1d9233f60ebd1a44$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $1d9233f60ebd1a44$var$write_biff_continue(C, 0x00FC /* SST */ , $1d9233f60ebd1a44$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $1d9233f60ebd1a44$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $1d9233f60ebd1a44$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $1d9233f60ebd1a44$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $1d9233f60ebd1a44$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $1d9233f60ebd1a44$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $1d9233f60ebd1a44$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt);
    if (wb && wb.SSF) {
        $1d9233f60ebd1a44$var$make_ssf();
        $1d9233f60ebd1a44$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $1d9233f60ebd1a44$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $1d9233f60ebd1a44$var$fix_write_opts(o);
    o.cellXfs = [];
    $1d9233f60ebd1a44$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $1d9233f60ebd1a44$var$write_ws_biff8(i, o, wb);
    bufs.unshift($1d9233f60ebd1a44$var$write_biff8_global(wb, bufs, o));
    return $1d9233f60ebd1a44$var$bconcat(bufs);
}
function $1d9233f60ebd1a44$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $1d9233f60ebd1a44$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $1d9233f60ebd1a44$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $1d9233f60ebd1a44$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $1d9233f60ebd1a44$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $1d9233f60ebd1a44$var$split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $1d9233f60ebd1a44$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $1d9233f60ebd1a44$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: "s",
                v: m
            };
            if (opts.raw || !m.trim().length || _t == "s") ;
            else if (m === "TRUE") o = {
                t: "b",
                v: true
            };
            else if (m === "FALSE") o = {
                t: "b",
                v: false
            };
            else if (!isNaN($1d9233f60ebd1a44$var$fuzzynum(m))) o = {
                t: "n",
                v: $1d9233f60ebd1a44$var$fuzzynum(m)
            };
            else if (!isNaN($1d9233f60ebd1a44$var$fuzzydate(m).getDate())) {
                o = {
                    t: "d",
                    v: $1d9233f60ebd1a44$var$parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: "n",
                    v: $1d9233f60ebd1a44$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $1d9233f60ebd1a44$var$table_fmt[14];
            }
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$1d9233f60ebd1a44$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $1d9233f60ebd1a44$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws["!merges"] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $1d9233f60ebd1a44$var$escapehtml(cell.w || ($1d9233f60ebd1a44$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + "</span>";
        else if (cell) {
            sp["data-t"] = cell && cell.t || "z";
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target + '">' + w + "</a>";
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($1d9233f60ebd1a44$var$writextag("td", w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $1d9233f60ebd1a44$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $1d9233f60ebd1a44$var$HTML_END = "</body></html>";
function $1d9233f60ebd1a44$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $1d9233f60ebd1a44$var$sheet_to_workbook($1d9233f60ebd1a44$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $1d9233f60ebd1a44$var$book_new();
    mtch.forEach(function(s, idx) {
        $1d9233f60ebd1a44$var$book_append_sheet(wb, $1d9233f60ebd1a44$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $1d9233f60ebd1a44$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + "<table" + (o && o.id ? ' id="' + o.id + '"' : "") + ">";
}
function $1d9233f60ebd1a44$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $1d9233f60ebd1a44$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $1d9233f60ebd1a44$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
    out.push($1d9233f60ebd1a44$var$make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push($1d9233f60ebd1a44$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $1d9233f60ebd1a44$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == "number") or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $1d9233f60ebd1a44$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws["!cols"] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($1d9233f60ebd1a44$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $1d9233f60ebd1a44$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute("data-v") ? elt.getAttribute("data-v") : elt.hasAttribute("v") ? elt.getAttribute("v") : $1d9233f60ebd1a44$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute("data-z") || elt.getAttribute("z");
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: "s",
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || "z";
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === "TRUE") o = {
                    t: "b",
                    v: true
                };
                else if (v === "FALSE") o = {
                    t: "b",
                    v: false
                };
                else if (!isNaN($1d9233f60ebd1a44$var$fuzzynum(v))) o = {
                    t: "n",
                    v: $1d9233f60ebd1a44$var$fuzzynum(v)
                };
                else if (!isNaN($1d9233f60ebd1a44$var$fuzzydate(v).getDate())) {
                    o = {
                        t: "d",
                        v: $1d9233f60ebd1a44$var$parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: "n",
                        v: $1d9233f60ebd1a44$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $1d9233f60ebd1a44$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != "javascript:") o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$1d9233f60ebd1a44$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws["!merges"] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
    if (R >= sheetRows) ws["!fullref"] = $1d9233f60ebd1a44$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $1d9233f60ebd1a44$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $1d9233f60ebd1a44$var$sheet_add_dom(ws, table, _opts);
}
function $1d9233f60ebd1a44$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $1d9233f60ebd1a44$var$sheet_to_workbook($1d9233f60ebd1a44$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $1d9233f60ebd1a44$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = "";
    var get_computed_style /*:?function*/  = $1d9233f60ebd1a44$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue("display");
    if (!display) display = element.style && element.style.display;
    return display === "none";
}
/* global getComputedStyle */ function $1d9233f60ebd1a44$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === "function") return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === "function") return getComputedStyle;
    return null;
}
/* OpenDocument */ function $1d9233f60ebd1a44$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, "\n");
    var v = $1d9233f60ebd1a44$var$unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $1d9233f60ebd1a44$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $1d9233f60ebd1a44$var$xlml_normalize(d);
    $1d9233f60ebd1a44$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $1d9233f60ebd1a44$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        /* Number Format Definitions */ case "number-style":
        case "currency-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
        case "text-style":
            if (Rn[1] === "/") {
                infmt = false;
                if (NFtag["truncate-on-overflow"] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                infmt = true;
                NF = "";
                NFtag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case "boolean-style":
            if (Rn[1] === "/") {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                infmt = true;
                NF = "";
                NFtag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case "boolean":
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case "text":
            if (Rn[1] === "/") {
                payload = str.slice(tidx, $1d9233f60ebd1a44$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == "<number:percentage-style") NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") tidx = $1d9233f60ebd1a44$var$xlmlregex.lastIndex;
            break;
        case "day":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case "day-of-week":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case "era":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case "hours":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case "minutes":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case "month":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case "seconds":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $1d9233f60ebd1a44$var$fill("0", +y["decimal-places"]);
            break;
        case "year":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case "am-pm":
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case "week-of-year":
        case "quarter":
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case "fill-character":
            if (Rn[1] === "/") {
                payload = str.slice(tidx, $1d9233f60ebd1a44$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") tidx = $1d9233f60ebd1a44$var$xlmlregex.lastIndex;
            break;
        case "scientific-number":
            // TODO: find a mapping for all parameters
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            NF += "0." + $1d9233f60ebd1a44$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $1d9233f60ebd1a44$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($1d9233f60ebd1a44$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $1d9233f60ebd1a44$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case "fraction":
            // TODO: find a mapping for all parameters
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $1d9233f60ebd1a44$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $1d9233f60ebd1a44$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $1d9233f60ebd1a44$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case "currency-symbol":
            // TODO: localization with [$-...]
            if (Rn[1] === "/") NF += '"' + str.slice(tidx, $1d9233f60ebd1a44$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== "/") tidx = $1d9233f60ebd1a44$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case "text-properties":
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case "text-content":
            NF += "@";
            break;
        case "map":
            // TODO: handle more complex maps
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            if ($1d9233f60ebd1a44$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case "number":
            // TODO: handle all the attributes
            if (Rn[1] === "/") break;
            y = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $1d9233f60ebd1a44$var$fill("0", +y["min-integer-digits"] || 1);
            if ($1d9233f60ebd1a44$var$parsexmlbool(y["grouping"])) tNF = $1d9233f60ebd1a44$var$commaify($1d9233f60ebd1a44$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $1d9233f60ebd1a44$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $1d9233f60ebd1a44$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case "embedded-text":
            // TODO: verify interplay with grouping et al
            if (Rn[1] === "/") {
                if (etpos == 0) NF += '"' + str.slice(tidx, $1d9233f60ebd1a44$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $1d9233f60ebd1a44$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                tidx = $1d9233f60ebd1a44$var$xlmlregex.lastIndex;
                etpos = -+$1d9233f60ebd1a44$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $1d9233f60ebd1a44$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($1d9233f60ebd1a44$var$DENSE != null && opts.dense == null) opts.dense = $1d9233f60ebd1a44$var$DENSE;
    var str = $1d9233f60ebd1a44$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    var baddate = 0;
    $1d9233f60ebd1a44$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = $1d9233f60ebd1a44$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case "table":
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === "/") {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
                else ws["!ref"] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws["!fullref"] = ws["!ref"];
                    range.e.r = opts.sheetRows - 1;
                    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
                }
                if (merges.length) ws["!merges"] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== "undefined") JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                sheetag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case "table-row-group":
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case "table-row":
        case "\u884C":
            if (Rn[1] === "/") {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag["number-rows-repeated"] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case "covered-table-cell":
            if (Rn[1] !== "/") ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws["!data"][R]) ws["!data"][R] = [];
                    ws["!data"][R][C] = {
                        t: "z"
                    };
                } else ws[$1d9233f60ebd1a44$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: "z"
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case "table-cell":
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === "/") {
                ++C;
                ctag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                q = {
                    t: "z",
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $1d9233f60ebd1a44$var$ods_to_csf_formula($1d9233f60ebd1a44$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"]) == "string") {
                    q.t = "s";
                    q.v = $1d9233f60ebd1a44$var$unescapexml(ctag["string-value"] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== "/") {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $1d9233f60ebd1a44$var$unescapexml(ctag.formula);
                    if (ctag["number-matrix-columns-spanned"] && ctag["number-matrix-rows-spanned"]) {
                        mR = parseInt(ctag["number-matrix-rows-spanned"], 10) || 0;
                        mC = parseInt(ctag["number-matrix-columns-spanned"], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $1d9233f60ebd1a44$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $1d9233f60ebd1a44$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag["number-columns-spanned"] || ctag["number-rows-spanned"]) {
                    mR = parseInt(ctag["number-rows-spanned"], 10) || 0;
                    mC = parseInt(ctag["number-columns-spanned"], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag["number-columns-repeated"]) colpeat = parseInt(ctag["number-columns-repeated"], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case "boolean":
                        q.t = "b";
                        q.v = $1d9233f60ebd1a44$var$parsexmlbool(ctag["boolean-value"]) || +ctag["boolean-value"] >= 1;
                        break;
                    case "float":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "percentage":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "currency":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "date":
                        q.t = "d";
                        q.v = $1d9233f60ebd1a44$var$parseDate(ctag["date-value"]);
                        if (!opts.cellDates) {
                            q.t = "n";
                            q.v = $1d9233f60ebd1a44$var$datenum(q.v, WB.WBProps.date1904) - baddate;
                        }
                        if (!q.z) q.z = "m/d/yy";
                        break;
                    case "time":
                        q.t = "n";
                        q.v = $1d9233f60ebd1a44$var$parse_isodur(ctag["time-value"]) / 86400;
                        if (opts.cellDates) {
                            q.t = "d";
                            q.v = $1d9233f60ebd1a44$var$numdate(q.v);
                        }
                        if (!q.z) q.z = "HH:MM:SS";
                        break;
                    case "number":
                        q.t = "n";
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === "string" || q.t === "text" || !q.t) {
                            q.t = "s";
                            if (ctag["string-value"] != null) {
                                textp = $1d9233f60ebd1a44$var$unescapexml(ctag["string-value"]);
                                textR = [];
                            }
                        } else throw new Error("Unsupported value type " + q.t);
                }
            } else {
                isstub = false;
                if (q.t === "s") {
                    q.v = textp || "";
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $1d9233f60ebd1a44$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $1d9233f60ebd1a44$var$dup(q);
                        } else {
                            ws[$1d9233f60ebd1a44$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$1d9233f60ebd1a44$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $1d9233f60ebd1a44$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case "document":
        case "document-content":
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case "spreadsheet":
        case "\u4E3B\u4F53":
        case "scripts":
        case "styles":
        case "font-face-decls":
        case "master-styles":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "annotation":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "creator":
            if (Rn[1] === "/") creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case "meta":
        case "\u5143\u6570\u636E":
        case "settings":
        case "config-item-set":
        case "config-item-map-indexed":
        case "config-item-map-entry":
        case "config-item-map-named":
        case "shapes":
        case "frame":
        case "text-box":
        case "image":
        case "data-pilot-tables":
        case "list-style":
        case "form":
        case "dde-links":
        case "event-listeners":
        case "chart":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "scientific-number":
        case "currency-symbol":
        case "fill-character":
            break;
        case "text-style":
        case "boolean-style":
        case "number-style":
        case "currency-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
            if (Rn[1] === "/") {
                var xlmlidx = $1d9233f60ebd1a44$var$xlmlregex.lastIndex;
                $1d9233f60ebd1a44$var$parse_ods_styles(str.slice(nfidx, $1d9233f60ebd1a44$var$xlmlregex.lastIndex), _opts, number_format_map);
                $1d9233f60ebd1a44$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") nfidx = $1d9233f60ebd1a44$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case "script":
            break; // 3.13 <office:script>
        case "libraries":
            break; // TODO: <ooo:libraries>
        case "automatic-styles":
            break; // 3.15.3 <office:automatic-styles>
        case "default-style":
        case "page-layout":
            break; // TODO: <style:page-layout>
        case "style":
            var styletag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case "map":
            break; // 16.3 <style:map>
        case "font-face":
            break; // 16.21 <style:font-face>
        case "paragraph-properties":
            break; // 17.6 <style:paragraph-properties>
        case "table-properties":
            break; // 17.15 <style:table-properties>
        case "table-column-properties":
            break; // 17.16 <style:table-column-properties>
        case "table-row-properties":
            break; // 17.17 <style:table-row-properties>
        case "table-cell-properties":
            break; // 17.18 <style:table-cell-properties>
        case "number":
            break;
        case "fraction":
            break; // TODO 16.27.6 <number:fraction>
        case "day":
        case "month":
        case "year":
        case "era":
        case "day-of-week":
        case "week-of-year":
        case "quarter":
        case "hours":
        case "minutes":
        case "seconds":
        case "am-pm":
            break;
        case "boolean":
            break; // 16.27.24 <number:boolean>
        case "text":
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case "number-style":
                case "date-style":
                case "time-style":
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case "named-range":
            tag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            _Ref = $1d9233f60ebd1a44$var$ods_to_csf_3D(tag["cell-range-address"]);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + "!" + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case "text-content":
            break; // 16.27.27 <number:text-content>
        case "text-properties":
            break; // 16.27.27 <style:text-properties>
        case "embedded-text":
            break; // 16.27.4 <number:embedded-text>
        case "body":
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case "forms":
            break; // 12.25.2 13.2
        case "table-column":
            break; // 9.1.6 <table:table-column>
        case "table-header-rows":
            break; // 9.1.7 <table:table-header-rows>
        case "table-rows":
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case "table-column-group":
            break; // 9.1.10 <table:table-column-group>
        case "table-header-columns":
            break; // 9.1.11 <table:table-header-columns>
        case "table-columns":
            break; // 9.1.12 <table:table-columns>
        case "null-date":
            tag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                /* falls through */ case "1900-01-01":
                    baddate = 0;
            }
            break;
        case "graphic-properties":
            break; // 17.21 <style:graphic-properties>
        case "calculation-settings":
            break; // 9.4.1 <table:calculation-settings>
        case "named-expressions":
            break; // 9.4.11 <table:named-expressions>
        case "label-range":
            break; // 9.4.9 <table:label-range>
        case "label-ranges":
            break; // 9.4.10 <table:label-ranges>
        case "named-expression":
            break; // 9.4.13 <table:named-expression>
        case "sort":
            break; // 9.4.19 <table:sort>
        case "sort-by":
            break; // 9.4.20 <table:sort-by>
        case "sort-groups":
            break; // 9.4.22 <table:sort-groups>
        case "tab":
            break; // 6.1.4 <text:tab>
        case "line-break":
            break; // 6.1.5 <text:line-break>
        case "span":
            break; // 6.1.7 <text:span>
        case "p":
        case "\u6587\u672C\u4E32":
            if ([
                "master-styles"
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === "/" && (!ctag || !ctag["string-value"])) {
                var ptp = $1d9233f60ebd1a44$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case "s":
            break; // <text:s>
        case "database-range":
            if (Rn[1] === "/") break;
            try {
                _Ref = $1d9233f60ebd1a44$var$ods_to_csf_3D($1d9233f60ebd1a44$var$parsexmltag(Rn[0])["target-range-address"]);
                Sheets[_Ref[0]]["!autofilter"] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case "date":
            break; // <*:date>
        case "object":
            break; // 10.4.6.2 <draw:object>
        case "title":
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case "desc":
            break; // <*:desc>
        case "binary-data":
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case "table-source":
            break; // 9.2.6
        case "scenario":
            break; // 9.2.6
        case "iteration":
            break; // 9.4.3 <table:iteration>
        case "content-validations":
            break; // 9.4.4 <table:
        case "content-validation":
            break; // 9.4.5 <table:
        case "help-message":
            break; // 9.4.6 <table:
        case "error-message":
            break; // 9.4.7 <table:
        case "database-ranges":
            break; // 9.4.14 <table:database-ranges>
        case "filter":
            break; // 9.5.2 <table:filter>
        case "filter-and":
            break; // 9.5.3 <table:filter-and>
        case "filter-or":
            break; // 9.5.4 <table:filter-or>
        case "filter-condition":
            break; // 9.5.5 <table:filter-condition>
        case "list-level-style-bullet":
            break; // 16.31 <text:
        case "list-level-style-number":
            break; // 16.32 <text:
        case "list-level-properties":
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case "sender-firstname":
        case "sender-lastname":
        case "sender-initials":
        case "sender-title":
        case "sender-position":
        case "sender-email":
        case "sender-phone-private":
        case "sender-fax":
        case "sender-company":
        case "sender-phone-work":
        case "sender-street":
        case "sender-city":
        case "sender-postal-code":
        case "sender-country":
        case "sender-state-or-province":
        case "author-name":
        case "author-initials":
        case "chapter":
        case "file-name":
        case "template-name":
        case "sheet-name":
            break;
        case "event-listener":
            break;
        /* TODO: FODS Properties */ case "initial-creator":
        case "creation-date":
        case "print-date":
        case "generator":
        case "document-statistic":
        case "user-defined":
        case "editing-duration":
        case "editing-cycles":
            break;
        /* TODO: FODS Config */ case "config-item":
            break;
        /* TODO: style tokens */ case "page-number":
            break; // TODO <text:page-number>
        case "page-count":
            break; // TODO <text:page-count>
        case "time":
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case "cell-range-source":
            break; // 9.3.1 <table:
        case "detective":
            break; // 9.3.2 <table:
        case "operation":
            break; // 9.3.3 <table:
        case "highlighted-range":
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case "data-pilot-table":
        case "source-cell-range":
        case "source-service":
        case "data-pilot-field":
        case "data-pilot-level":
        case "data-pilot-subtotals":
        case "data-pilot-subtotal":
        case "data-pilot-members":
        case "data-pilot-member":
        case "data-pilot-display-info":
        case "data-pilot-sort-info":
        case "data-pilot-layout-info":
        case "data-pilot-field-reference":
        case "data-pilot-groups":
        case "data-pilot-group":
        case "data-pilot-group-member":
            break;
        /* 10.3 Drawing Shapes */ case "rect":
            break;
        /* 14.6 DDE Connections */ case "dde-connection-decls":
        case "dde-connection-decl":
        case "dde-link":
        case "dde-source":
            break;
        case "properties":
            break; // 13.7 <form:properties>
        case "property":
            break; // 13.8 <form:property>
        case "a":
            if (Rn[1] !== "/") {
                atag = $1d9233f60ebd1a44$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $1d9233f60ebd1a44$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $1d9233f60ebd1a44$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case "table-protection":
            break;
        case "data-pilot-grand-total":
            break; // <table:
        case "office-document-common-attrs":
            break; // bare
        default:
            switch(Rn[2]){
                case "dc:":
                case "calcext:":
                case "loext:":
                case "ooo:":
                case "chartooo:":
                case "draw:":
                case "style:":
                case "chart:":
                case "form:":
                case "uof:":
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $1d9233f60ebd1a44$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "META-INF/manifest.xml")) $1d9233f60ebd1a44$var$parse_manifest($1d9233f60ebd1a44$var$getzipdata(zip, "META-INF/manifest.xml"), opts);
    var styles = $1d9233f60ebd1a44$var$getzipstr(zip, "styles.xml");
    var Styles = styles && $1d9233f60ebd1a44$var$parse_ods_styles($1d9233f60ebd1a44$var$utf8read(styles), opts);
    var content = $1d9233f60ebd1a44$var$getzipstr(zip, "content.xml");
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $1d9233f60ebd1a44$var$parse_content_xml($1d9233f60ebd1a44$var$utf8read(content), opts, Styles);
    if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "meta.xml")) wb.Props = $1d9233f60ebd1a44$var$parse_core_props($1d9233f60ebd1a44$var$getzipdata(zip, "meta.xml"));
    wb.bookType = "ods";
    return wb;
}
function $1d9233f60ebd1a44$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $1d9233f60ebd1a44$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $1d9233f60ebd1a44$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        "<office:master-styles>",
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        "<style:header/>",
        '<style:header-left style:display="false"/>',
        "<style:footer/>",
        '<style:footer-left style:display="false"/>',
        "</style:master-page>",
        "</office:master-styles>"
    ].join("");
    var payload = "<office:document-styles " + $1d9233f60ebd1a44$var$wxt_helper({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "office:version": "1.2"
    }) + ">" + master_styles + "</office:document-styles>";
    return function wso() {
        return $1d9233f60ebd1a44$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $1d9233f60ebd1a44$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += "<number:fill-character>" + $1d9233f60ebd1a44$var$escapexml(c.replace(/""/g, '"')) + "</number:fill-character>";
            } else payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c.replace(/""/g, '"')) + "</number:text>";
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $1d9233f60ebd1a44$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $1d9233f60ebd1a44$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $1d9233f60ebd1a44$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c.slice(1).replace(/""/g, '"')) + "</number:text>";
                    break;
                case "/":
                    payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c) + "</number:text>";
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts["number:truncate-on-overflow"] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + "/>";
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c.slice(1).replace(/""/g, '"')) + "</number:text>";
                    break;
                case "/":
                    payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c) + "</number:text>";
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += "<number:am-pm/>";
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += "<number:am-pm/>";
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += "<number:fill-character>" + $1d9233f60ebd1a44$var$escapexml(c.replace(/""/g, '"')) + "</number:fill-character>";
            } else payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c.replace(/""/g, '"')) + "</number:text>";
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += "<number:" + (np[3] ? "scientific-" : "") + "number" + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + ">" + /* TODO: interstitial text placeholders */ "</number:" + (np[3] ? "scientific-" : "") + "number>";
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += "<number:text>" + $1d9233f60ebd1a44$var$escapexml(c.replace(/""/g, '"')) + "</number:text>";
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $1d9233f60ebd1a44$var$writextag("number:" + type + "-style", payload, nopts);
}
function $1d9233f60ebd1a44$var$write_names_ods(Names, SheetNames, idx) {
    var scoped = Names.filter(function(name) {
        return name.Sheet == (idx == -1 ? null : idx);
    });
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = $1d9233f60ebd1a44$var$csf_to_ods_3D(name.Ref);
        return "        " + $1d9233f60ebd1a44$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.]?[^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $1d9233f60ebd1a44$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return $1d9233f60ebd1a44$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = "          <table:table-cell />\n";
    var covered_cell_xml = "          <table:covered-table-cell/>\n";
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $1d9233f60ebd1a44$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $1d9233f60ebd1a44$var$decode_range(ws["!ref"] || "A1");
        var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push("        <table:table-column" + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : "") + "></table:table-column>\n");
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + "></table:table-row>\n");
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + ">\n");
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct["table:number-columns-spanned"] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct["table:number-rows-spanned"] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = $1d9233f60ebd1a44$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct["table:formula"] = $1d9233f60ebd1a44$var$escapexml($1d9233f60ebd1a44$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $1d9233f60ebd1a44$var$decode_range(cell.F);
                            ct["table:number-matrix-columns-spanned"] = _Fref.e.c - _Fref.s.c + 1;
                            ct["table:number-matrix-rows-spanned"] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case "b":
                        textp = cell.v ? "TRUE" : "FALSE";
                        ct["office:value-type"] = "boolean";
                        ct["office:boolean-value"] = cell.v ? "true" : "false";
                        break;
                    case "n":
                        textp = cell.w || String(cell.v || 0);
                        ct["office:value-type"] = "float";
                        ct["office:value"] = cell.v || 0;
                        break;
                    case "s":
                    case "str":
                        textp = cell.v == null ? "" : cell.v;
                        ct["office:value-type"] = "string";
                        break;
                    case "d":
                        textp = cell.w || $1d9233f60ebd1a44$var$parseDate(cell.v).toISOString();
                        ct["office:value-type"] = "date";
                        ct["office:date-value"] = $1d9233f60ebd1a44$var$parseDate(cell.v).toISOString();
                        ct["table:style-name"] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $1d9233f60ebd1a44$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = "../" + _tgt;
                    text_p = $1d9233f60ebd1a44$var$writextag("text:a", text_p, {
                        "xlink:href": _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                o.push("          " + $1d9233f60ebd1a44$var$writextag("table:table-cell", $1d9233f60ebd1a44$var$writextag("text:p", text_p, {}), ct) + "\n");
            }
            o.push("        </table:table-row>\n");
        }
        if ((wb.Workbook || {}).Names) o.push($1d9233f60ebd1a44$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push("      </table:table>\n");
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(" <office:automatic-styles>\n");
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $1d9233f60ebd1a44$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push("  </style:style>\n");
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push("  </style:style>\n");
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push("  </style:style>\n");
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push('   <number:day number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push("   <number:year/>\n");
        o.push("  </number:date-style>\n");
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            var range = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$1d9233f60ebd1a44$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $1d9233f60ebd1a44$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $1d9233f60ebd1a44$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(" </office:automatic-styles>\n");
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $1d9233f60ebd1a44$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $1d9233f60ebd1a44$var$wxt_helper({
            "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:dc": "http://purl.org/dc/elements/1.1/",
            "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            "xmlns:math": "http://www.w3.org/1998/Math/MathML",
            "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            "xmlns:ooo": "http://openoffice.org/2004/office",
            "xmlns:ooow": "http://openoffice.org/2004/writer",
            "xmlns:oooc": "http://openoffice.org/2004/calc",
            "xmlns:dom": "http://www.w3.org/2001/xml-events",
            "xmlns:xforms": "http://www.w3.org/2002/xforms",
            "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            "xmlns:rpt": "http://openoffice.org/2005/report",
            "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
            "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
            "xmlns:tableooo": "http://openoffice.org/2009/table",
            "xmlns:drawooo": "http://openoffice.org/2010/draw",
            "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
            "office:version": "1.2"
        });
        var fods = $1d9233f60ebd1a44$var$wxt_helper({
            "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push("<office:document" + attr + fods + ">\n");
            o.push($1d9233f60ebd1a44$var$write_meta_ods().replace(/<office:document-meta.*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push("<office:document-content" + attr + ">\n");
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push("  <office:body>\n");
        o.push("    <office:spreadsheet>\n");
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs));
        if ((wb.Workbook || {}).Names) o.push($1d9233f60ebd1a44$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push("    </office:spreadsheet>\n");
        o.push("  </office:body>\n");
        if (opts.bookType == "fods") o.push("</office:document>");
        else o.push("</office:document-content>");
        return o.join("");
    };
}();
function $1d9233f60ebd1a44$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $1d9233f60ebd1a44$var$write_content_ods(wb, opts);
    var zip = $1d9233f60ebd1a44$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$XML_HEADER + $1d9233f60ebd1a44$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $1d9233f60ebd1a44$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $1d9233f60ebd1a44$require$Buffer !== "undefined") {
            if (typeof $1d9233f60ebd1a44$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $1d9233f60ebd1a44$require$Buffer.from == "function" ? $1d9233f60ebd1a44$require$Buffer.from([
                72,
                62
            ]) : new $1d9233f60ebd1a44$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $1d9233f60ebd1a44$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $1d9233f60ebd1a44$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $1d9233f60ebd1a44$var$utf8read($1d9233f60ebd1a44$var$a2s(u8));
}
function $1d9233f60ebd1a44$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $1d9233f60ebd1a44$var$s2a($1d9233f60ebd1a44$var$utf8write(str));
}
function $1d9233f60ebd1a44$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $1d9233f60ebd1a44$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $1d9233f60ebd1a44$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $1d9233f60ebd1a44$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $1d9233f60ebd1a44$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $1d9233f60ebd1a44$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$1d9233f60ebd1a44$var$subarray](0, L);
}
function $1d9233f60ebd1a44$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($1d9233f60ebd1a44$var$parse_varint49(buf, ptr));
    return out;
}
function $1d9233f60ebd1a44$var$write_packed_varints(nums) {
    return $1d9233f60ebd1a44$var$u8concat(nums.map(function(x) {
        return $1d9233f60ebd1a44$var$write_varint49(x);
    }));
}
function $1d9233f60ebd1a44$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function $1d9233f60ebd1a44$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $1d9233f60ebd1a44$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $1d9233f60ebd1a44$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$1d9233f60ebd1a44$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$1d9233f60ebd1a44$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $1d9233f60ebd1a44$var$parse_varint49(buf, ptr);
                data = buf[$1d9233f60ebd1a44$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$1d9233f60ebd1a44$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $1d9233f60ebd1a44$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($1d9233f60ebd1a44$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($1d9233f60ebd1a44$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $1d9233f60ebd1a44$var$u8concat(out);
}
function $1d9233f60ebd1a44$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $1d9233f60ebd1a44$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $1d9233f60ebd1a44$var$parse_varint49(buf, ptr);
        var ai = $1d9233f60ebd1a44$var$parse_shallow(buf[$1d9233f60ebd1a44$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $1d9233f60ebd1a44$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $1d9233f60ebd1a44$var$parse_shallow(b.data);
            var fl = $1d9233f60ebd1a44$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$1d9233f60ebd1a44$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $1d9233f60ebd1a44$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $1d9233f60ebd1a44$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $1d9233f60ebd1a44$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $1d9233f60ebd1a44$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $1d9233f60ebd1a44$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $1d9233f60ebd1a44$var$write_shallow(ai);
        bufs.push($1d9233f60ebd1a44$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $1d9233f60ebd1a44$var$u8concat(bufs);
}
function $1d9233f60ebd1a44$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $1d9233f60ebd1a44$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$1d9233f60ebd1a44$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$1d9233f60ebd1a44$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$1d9233f60ebd1a44$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$1d9233f60ebd1a44$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $1d9233f60ebd1a44$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $1d9233f60ebd1a44$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $1d9233f60ebd1a44$var$parse_snappy_chunk(t, buf[$1d9233f60ebd1a44$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $1d9233f60ebd1a44$var$u8concat(out);
}
function $1d9233f60ebd1a44$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $1d9233f60ebd1a44$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$1d9233f60ebd1a44$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $1d9233f60ebd1a44$var$u8concat(out);
}
var $1d9233f60ebd1a44$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: []
    };
};
function $1d9233f60ebd1a44$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $1d9233f60ebd1a44$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $1d9233f60ebd1a44$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $1d9233f60ebd1a44$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $1d9233f60ebd1a44$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $1d9233f60ebd1a44$var$parse_old_storage(buf, lut, v) {
    var dv = $1d9233f60ebd1a44$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $1d9233f60ebd1a44$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $1d9233f60ebd1a44$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: lut.rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[$1d9233f60ebd1a44$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$1d9233f60ebd1a44$var$subarray](0, 4)));
    }
    if (zidx > -1) $1d9233f60ebd1a44$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $1d9233f60ebd1a44$var$parse_new_storage(buf, lut) {
    var dv = $1d9233f60ebd1a44$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (fields & 1) {
        d128 = $1d9233f60ebd1a44$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            ret = {
                t: "s",
                v: lut.rsst[ridx]
            };
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$1d9233f60ebd1a44$var$subarray](0, 4)));
    }
    doff += $1d9233f60ebd1a44$var$popcnt(fields & 8160) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (zidx > -1) $1d9233f60ebd1a44$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $1d9233f60ebd1a44$var$write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $1d9233f60ebd1a44$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            $1d9233f60ebd1a44$var$writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            var isst = sst.indexOf(s);
            if (isst == -1) sst[isst = sst.length] = s;
            out[1] = 3;
            dv.setUint32(l, isst, true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out[$1d9233f60ebd1a44$var$subarray](0, l);
}
function $1d9233f60ebd1a44$var$write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $1d9233f60ebd1a44$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 4;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            var isst = sst.indexOf(s);
            if (isst == -1) sst[isst = sst.length] = s;
            out[2] = 3;
            dv.setUint32(l, isst, true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out[$1d9233f60ebd1a44$var$subarray](0, l);
}
function $1d9233f60ebd1a44$var$parse_cell_storage(buf, lut) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $1d9233f60ebd1a44$var$parse_old_storage(buf, lut, buf[0]);
        case 5:
            return $1d9233f60ebd1a44$var$parse_new_storage(buf, lut);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $1d9233f60ebd1a44$var$parse_TSP_Reference(buf) {
    var pb = $1d9233f60ebd1a44$var$parse_shallow(buf);
    return $1d9233f60ebd1a44$var$varint_to_i32(pb[1][0].data);
}
function $1d9233f60ebd1a44$var$write_TSP_Reference(idx) {
    return $1d9233f60ebd1a44$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $1d9233f60ebd1a44$var$write_varint49(idx)
            }
        ]
    ]);
}
function $1d9233f60ebd1a44$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $1d9233f60ebd1a44$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $1d9233f60ebd1a44$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $1d9233f60ebd1a44$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $1d9233f60ebd1a44$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $1d9233f60ebd1a44$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $1d9233f60ebd1a44$var$parse_TST_TableDataList(M, root) {
    var pb = $1d9233f60ebd1a44$var$parse_shallow(root.data);
    var type = $1d9233f60ebd1a44$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = $1d9233f60ebd1a44$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $1d9233f60ebd1a44$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $1d9233f60ebd1a44$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$1d9233f60ebd1a44$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $1d9233f60ebd1a44$var$parse_shallow(rt.data);
                var rtpref = M[$1d9233f60ebd1a44$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $1d9233f60ebd1a44$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $1d9233f60ebd1a44$var$parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return $1d9233f60ebd1a44$var$u8str(x.data);
                }).join("");
                break;
            case 2:
                data[key] = $1d9233f60ebd1a44$var$parse_shallow(le[6][0].data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $1d9233f60ebd1a44$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $1d9233f60ebd1a44$var$parse_shallow(u8);
    var R = $1d9233f60ebd1a44$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $1d9233f60ebd1a44$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $1d9233f60ebd1a44$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $1d9233f60ebd1a44$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$1d9233f60ebd1a44$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$1d9233f60ebd1a44$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $1d9233f60ebd1a44$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $1d9233f60ebd1a44$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($1d9233f60ebd1a44$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $1d9233f60ebd1a44$var$mappa(pb[5], function(u8) {
        return $1d9233f60ebd1a44$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $1d9233f60ebd1a44$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $1d9233f60ebd1a44$var$parse_TST_TableModelArchive(M, root, ws) {
    var _a, _b, _c, _d, _e, _f;
    var pb = $1d9233f60ebd1a44$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($1d9233f60ebd1a44$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($1d9233f60ebd1a44$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $1d9233f60ebd1a44$var$parse_shallow(pb[4][0].data);
    var lut = $1d9233f60ebd1a44$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $1d9233f60ebd1a44$var$parse_TST_TableDataList(M, M[$1d9233f60ebd1a44$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[11]) == null ? void 0 : _b[0]) lut.ofmt = $1d9233f60ebd1a44$var$parse_TST_TableDataList(M, M[$1d9233f60ebd1a44$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_c = store[17]) == null ? void 0 : _c[0]) lut.rsst = $1d9233f60ebd1a44$var$parse_TST_TableDataList(M, M[$1d9233f60ebd1a44$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_d = store[22]) == null ? void 0 : _d[0]) lut.nfmt = $1d9233f60ebd1a44$var$parse_TST_TableDataList(M, M[$1d9233f60ebd1a44$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $1d9233f60ebd1a44$var$parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = $1d9233f60ebd1a44$var$parse_shallow(t.data);
        var ref2 = M[$1d9233f60ebd1a44$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $1d9233f60ebd1a44$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $1d9233f60ebd1a44$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $1d9233f60ebd1a44$var$parse_cell_storage(buf, lut);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$1d9233f60ebd1a44$var$encode_col(C) + $1d9233f60ebd1a44$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_e = store[13]) == null ? void 0 : _e[0]) {
        var ref = M[$1d9233f60ebd1a44$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $1d9233f60ebd1a44$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_f = $1d9233f60ebd1a44$var$parse_shallow(ref.data)) == null ? void 0 : _f[1].map(function(pi) {
            var merge = $1d9233f60ebd1a44$var$parse_shallow(pi.data);
            var origin = $1d9233f60ebd1a44$var$u8_to_dataview($1d9233f60ebd1a44$var$parse_shallow(merge[1][0].data)[1][0].data), size = $1d9233f60ebd1a44$var$u8_to_dataview($1d9233f60ebd1a44$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
}
function $1d9233f60ebd1a44$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $1d9233f60ebd1a44$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$1d9233f60ebd1a44$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $1d9233f60ebd1a44$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $1d9233f60ebd1a44$var$parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function $1d9233f60ebd1a44$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $1d9233f60ebd1a44$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $1d9233f60ebd1a44$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $1d9233f60ebd1a44$var$mappa(pb[2], $1d9233f60ebd1a44$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $1d9233f60ebd1a44$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($1d9233f60ebd1a44$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $1d9233f60ebd1a44$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $1d9233f60ebd1a44$var$book_new();
    var pb = $1d9233f60ebd1a44$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $1d9233f60ebd1a44$var$mappa(pb[1], $1d9233f60ebd1a44$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $1d9233f60ebd1a44$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $1d9233f60ebd1a44$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $1d9233f60ebd1a44$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $1d9233f60ebd1a44$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $1d9233f60ebd1a44$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $1d9233f60ebd1a44$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $1d9233f60ebd1a44$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $1d9233f60ebd1a44$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $1d9233f60ebd1a44$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $1d9233f60ebd1a44$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $1d9233f60ebd1a44$var$write_TST_TileRowInfo(data, SST, wide) {
    var _a, _b;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $1d9233f60ebd1a44$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $1d9233f60ebd1a44$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $1d9233f60ebd1a44$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $1d9233f60ebd1a44$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $1d9233f60ebd1a44$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $1d9233f60ebd1a44$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = $1d9233f60ebd1a44$var$write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = $1d9233f60ebd1a44$var$write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = $1d9233f60ebd1a44$var$write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = $1d9233f60ebd1a44$var$write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = $1d9233f60ebd1a44$var$write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = $1d9233f60ebd1a44$var$write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                if (data[C] instanceof Date) {
                    celload = $1d9233f60ebd1a44$var$write_new_storage({
                        t: "s",
                        v: data[C].toISOString()
                    }, SST);
                    _celload = $1d9233f60ebd1a44$var$write_old_storage({
                        t: "s",
                        v: data[C].toISOString()
                    }, SST);
                    break;
                }
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $1d9233f60ebd1a44$var$write_varint49(cnt);
    tri[5][0].data = $1d9233f60ebd1a44$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $1d9233f60ebd1a44$var$u8concat(cell_storage);
    tri[3][0].data = $1d9233f60ebd1a44$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $1d9233f60ebd1a44$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $1d9233f60ebd1a44$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $1d9233f60ebd1a44$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $1d9233f60ebd1a44$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $1d9233f60ebd1a44$var$parse_iwa_file($1d9233f60ebd1a44$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $1d9233f60ebd1a44$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $1d9233f60ebd1a44$var$parse_iwa_file($1d9233f60ebd1a44$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($1d9233f60ebd1a44$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $1d9233f60ebd1a44$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $1d9233f60ebd1a44$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $1d9233f60ebd1a44$var$build_numbers_deps(cfb);
    var docroot = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $1d9233f60ebd1a44$var$mappa($1d9233f60ebd1a44$var$parse_shallow(docroot.messages[0].data)[1], $1d9233f60ebd1a44$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $1d9233f60ebd1a44$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $1d9233f60ebd1a44$var$mappa($1d9233f60ebd1a44$var$parse_shallow(docroot.messages[0].data)[1], $1d9233f60ebd1a44$var$parse_TSP_Reference);
        }
        $1d9233f60ebd1a44$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $1d9233f60ebd1a44$var$parse_iwa_file($1d9233f60ebd1a44$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $1d9233f60ebd1a44$var$compress_iwa_file($1d9233f60ebd1a44$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $1d9233f60ebd1a44$var$parse_iwa_file($1d9233f60ebd1a44$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $1d9233f60ebd1a44$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $1d9233f60ebd1a44$var$parse_shallow(docroot.messages[0].data);
        sheetref = $1d9233f60ebd1a44$var$parse_TSP_Reference($1d9233f60ebd1a44$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $1d9233f60ebd1a44$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $1d9233f60ebd1a44$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $1d9233f60ebd1a44$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(doc);
    });
    var tiaref = -1;
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $1d9233f60ebd1a44$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $1d9233f60ebd1a44$var$mappa(sa[2], $1d9233f60ebd1a44$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $1d9233f60ebd1a44$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $1d9233f60ebd1a44$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $1d9233f60ebd1a44$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $1d9233f60ebd1a44$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            var loc2 = deps[newsheetref].location;
            loc2 = loc2.replace(/^Root Entry\//, "");
            loc2 = loc2.replace(/^Index\//, "").replace(/\.iwa$/, "");
            $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
                var parentidx = mlist[3].findIndex(function(m) {
                    var _a, _b;
                    var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
                    if ((_a = mm[3]) == null ? void 0 : _a[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc2;
                    if (((_b = mm[2]) == null ? void 0 : _b[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc2) return true;
                    return false;
                });
                var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
                if (!parent[6]) parent[6] = [];
                parent[6].push({
                    type: 2,
                    data: $1d9233f60ebd1a44$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $1d9233f60ebd1a44$var$write_varint49(tiaref)
                            }
                        ]
                    ])
                });
                mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
                ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
            });
            $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(sa);
    });
    var tmaref = -1;
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $1d9233f60ebd1a44$var$parse_shallow(tiaroot.messages[0].data);
        var da = $1d9233f60ebd1a44$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $1d9233f60ebd1a44$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $1d9233f60ebd1a44$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $1d9233f60ebd1a44$var$write_shallow(da);
        var oldtmaref = $1d9233f60ebd1a44$var$parse_TSP_Reference(tia[2][0].data);
        $1d9233f60ebd1a44$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $1d9233f60ebd1a44$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $1d9233f60ebd1a44$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $1d9233f60ebd1a44$var$write_TSP_Reference(tmaref);
        var tma = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(tia);
    });
    var loc = deps[tmaref].location;
    loc = loc.replace(/^Root Entry\//, "");
    loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $1d9233f60ebd1a44$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $1d9233f60ebd1a44$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(wsidx.toString(16).padStart(4, "0")));
        tma[1][0].data = $1d9233f60ebd1a44$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $1d9233f60ebd1a44$var$parse_shallow(tma[45][0].data);
            var ref = $1d9233f60ebd1a44$var$parse_TSP_Reference(srrta[1][0].data);
            $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $1d9233f60ebd1a44$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $1d9233f60ebd1a44$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $1d9233f60ebd1a44$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $1d9233f60ebd1a44$var$parse_TSP_Reference(hsea[8][0].data);
                    $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $1d9233f60ebd1a44$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $1d9233f60ebd1a44$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $1d9233f60ebd1a44$var$parse_TSP_Reference(store[n][0].data);
            var newref = $1d9233f60ebd1a44$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, oldref);
            $1d9233f60ebd1a44$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $1d9233f60ebd1a44$var$compress_iwa_file($1d9233f60ebd1a44$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location;
                newloc = newloc.replace(/^Root Entry\//, "");
                newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
                $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(newref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $1d9233f60ebd1a44$var$stru8(newloc.replace(/-.*$/, ""))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $1d9233f60ebd1a44$var$stru8(newloc)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(Math.max(newref + 1, $1d9233f60ebd1a44$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a3, _b2;
                        var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
                        if ((_a3 = mm[3]) == null ? void 0 : _a3[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(newref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
                    ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $1d9233f60ebd1a44$var$write_TSP_Reference(newref);
        });
        var row_headers = $1d9233f60ebd1a44$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $1d9233f60ebd1a44$var$parse_TSP_Reference(tspref.data);
            var newref = $1d9233f60ebd1a44$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, oldref);
            $1d9233f60ebd1a44$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $1d9233f60ebd1a44$var$compress_iwa_file($1d9233f60ebd1a44$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location;
                newloc = newloc.replace(/^Root Entry\//, "");
                newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
                $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(newref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $1d9233f60ebd1a44$var$stru8(newloc.replace(/-.*$/, ""))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $1d9233f60ebd1a44$var$stru8(newloc)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(Math.max(newref + 1, $1d9233f60ebd1a44$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a2, _b2;
                        var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
                        if ((_a2 = mm[3]) == null ? void 0 : _a2[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(newref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
                    ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
                });
            }
            tspref.data = $1d9233f60ebd1a44$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $1d9233f60ebd1a44$var$write_shallow(row_headers);
        var tiles = $1d9233f60ebd1a44$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $1d9233f60ebd1a44$var$parse_shallow(t.data);
            var oldtileref = $1d9233f60ebd1a44$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $1d9233f60ebd1a44$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, oldtileref);
                $1d9233f60ebd1a44$var$numbers_add_oref(tmaroot, newtileref);
                $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $1d9233f60ebd1a44$var$compress_iwa_file($1d9233f60ebd1a44$var$write_iwa_file([
                    oldtile
                ])));
                $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $1d9233f60ebd1a44$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $1d9233f60ebd1a44$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(Math.max(newtileref + 1, $1d9233f60ebd1a44$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a2, _b2;
                        var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
                        if ((_a2 = mm[3]) == null ? void 0 : _a2[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $1d9233f60ebd1a44$var$write_varint49(newtileref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
                    ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $1d9233f60ebd1a44$var$write_TSP_Reference(newtileref);
            t.data = $1d9233f60ebd1a44$var$write_shallow(tst);
        });
        store[3][0].data = $1d9233f60ebd1a44$var$write_shallow(tiles);
        tma[4][0].data = $1d9233f60ebd1a44$var$write_shallow(store);
        tmaroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(tma);
    });
}
function $1d9233f60ebd1a44$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $1d9233f60ebd1a44$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $1d9233f60ebd1a44$var$stru8(wsname)
            }
        ];
        drawables = $1d9233f60ebd1a44$var$mappa(sheetref[2], $1d9233f60ebd1a44$var$parse_TSP_Reference);
        docroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(sheetref);
    });
    var tia = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $1d9233f60ebd1a44$var$parse_TSP_Reference($1d9233f60ebd1a44$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $1d9233f60ebd1a44$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $1d9233f60ebd1a44$var$USE_WIDE_ROWS = true;
function $1d9233f60ebd1a44$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    var range = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($1d9233f60ebd1a44$var$encode_range(range)));
    var data = $1d9233f60ebd1a44$var$sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    var loc = deps[tmaref].location;
    loc = loc.replace(/^Root Entry\//, "");
    loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
    var pb = $1d9233f60ebd1a44$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $1d9233f60ebd1a44$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $1d9233f60ebd1a44$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $1d9233f60ebd1a44$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $1d9233f60ebd1a44$var$parse_TSP_Reference($1d9233f60ebd1a44$var$parse_shallow(store[1][0].data)[2][0].data);
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $1d9233f60ebd1a44$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $1d9233f60ebd1a44$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $1d9233f60ebd1a44$var$write_varint49(R2);
            _bucket[4][0].data = $1d9233f60ebd1a44$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $1d9233f60ebd1a44$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(base_bucket);
    });
    var col_header_ref = $1d9233f60ebd1a44$var$parse_TSP_Reference(store[2][0].data);
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $1d9233f60ebd1a44$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $1d9233f60ebd1a44$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $1d9233f60ebd1a44$var$write_varint49(C);
            _bucket[4][0].data = $1d9233f60ebd1a44$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $1d9233f60ebd1a44$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(base_bucket);
    });
    var rbtree = $1d9233f60ebd1a44$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $1d9233f60ebd1a44$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $1d9233f60ebd1a44$var$write_varint49(tstride)
        }
    ];
    var tileref = $1d9233f60ebd1a44$var$parse_TSP_Reference($1d9233f60ebd1a44$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $1d9233f60ebd1a44$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $1d9233f60ebd1a44$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $1d9233f60ebd1a44$var$varint_to_i32($1d9233f60ebd1a44$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $1d9233f60ebd1a44$var$varint_to_i32($1d9233f60ebd1a44$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $1d9233f60ebd1a44$var$varint_to_i32($1d9233f60ebd1a44$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        var parentidx = mlist[3].findIndex(function(m) {
            var _a, _b;
            var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
            if ((_a = mm[3]) == null ? void 0 : _a[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc;
            if (((_b = mm[2]) == null ? void 0 : _b[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc) return true;
            return false;
        });
        var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
        if (!parent[6]) parent[6] = [];
        parent[6] = parent[6].filter(function(m) {
            return $1d9233f60ebd1a44$var$varint_to_i32($1d9233f60ebd1a44$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
        ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
    });
    $1d9233f60ebd1a44$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $1d9233f60ebd1a44$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49($1d9233f60ebd1a44$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $1d9233f60ebd1a44$var$write_TST_TileRowInfo(data[R], SST, $1d9233f60ebd1a44$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $1d9233f60ebd1a44$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $1d9233f60ebd1a44$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $1d9233f60ebd1a44$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $1d9233f60ebd1a44$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $1d9233f60ebd1a44$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $1d9233f60ebd1a44$var$write_iwam(6002, $1d9233f60ebd1a44$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $1d9233f60ebd1a44$var$compress_iwa_file($1d9233f60ebd1a44$var$write_iwa_file([
            newtile
        ]));
        $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $1d9233f60ebd1a44$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $1d9233f60ebd1a44$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $1d9233f60ebd1a44$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $1d9233f60ebd1a44$var$write_varint49(Math.max(newtileid + 1, $1d9233f60ebd1a44$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            var parentidx = mlist[3].findIndex(function(m) {
                var _a, _b;
                var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
                if ((_a = mm[3]) == null ? void 0 : _a[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc;
                if (((_b = mm[2]) == null ? void 0 : _b[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc) return true;
                return false;
            });
            var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
            if (!parent[6]) parent[6] = [];
            parent[6].push({
                type: 2,
                data: $1d9233f60ebd1a44$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(newtileid)
                        }
                    ]
                ])
            });
            mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
            ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
        });
        $1d9233f60ebd1a44$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $1d9233f60ebd1a44$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $1d9233f60ebd1a44$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $1d9233f60ebd1a44$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $1d9233f60ebd1a44$var$write_shallow(tilestore);
    store[9][0].data = $1d9233f60ebd1a44$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $1d9233f60ebd1a44$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $1d9233f60ebd1a44$var$write_iwam(6144, $1d9233f60ebd1a44$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $1d9233f60ebd1a44$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $1d9233f60ebd1a44$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $1d9233f60ebd1a44$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $1d9233f60ebd1a44$var$write_TSP_Reference(mergeid)
            }
        ];
        $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $1d9233f60ebd1a44$var$parse_shallow(ai.messages[0].data);
            var parentidx = mlist[3].findIndex(function(m) {
                var _a, _b;
                var mm = $1d9233f60ebd1a44$var$parse_shallow(m.data);
                if ((_a = mm[3]) == null ? void 0 : _a[0]) return $1d9233f60ebd1a44$var$u8str(mm[3][0].data) == loc;
                if (((_b = mm[2]) == null ? void 0 : _b[0]) && $1d9233f60ebd1a44$var$u8str(mm[2][0].data) == loc) return true;
                return false;
            });
            var parent = $1d9233f60ebd1a44$var$parse_shallow(mlist[3][parentidx].data);
            if (!parent[6]) parent[6] = [];
            parent[6].push({
                type: 2,
                data: $1d9233f60ebd1a44$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(mergeid)
                        }
                    ]
                ])
            });
            mlist[3][parentidx].data = $1d9233f60ebd1a44$var$write_shallow(parent);
            ai.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(mlist);
        });
        $1d9233f60ebd1a44$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $1d9233f60ebd1a44$var$parse_TSP_Reference(store[4][0].data);
    $1d9233f60ebd1a44$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $1d9233f60ebd1a44$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        SST.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $1d9233f60ebd1a44$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $1d9233f60ebd1a44$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $1d9233f60ebd1a44$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(sstdata);
    });
    pb[4][0].data = $1d9233f60ebd1a44$var$write_shallow(store);
    tmaroot.messages[0].data = $1d9233f60ebd1a44$var$write_shallow(pb);
}
function $1d9233f60ebd1a44$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $1d9233f60ebd1a44$var$fix_read_opts(opts) {
    $1d9233f60ebd1a44$var$fix_opts_func([
        [
            "cellNF",
            false
        ],
        /* emit cell number format string as .z */ [
            "cellHTML",
            true
        ],
        /* emit html string as .h */ [
            "cellFormula",
            true
        ],
        /* emit formulae as .f */ [
            "cellStyles",
            false
        ],
        /* emits style/theme as .s */ [
            "cellText",
            true
        ],
        /* emit formatted text as .w */ [
            "cellDates",
            false
        ],
        /* emit date cells with type `d` */ [
            "sheetStubs",
            false
        ],
        /* emit empty cells */ [
            "sheetRows",
            0,
            "n"
        ],
        /* read n rows (0 = read all rows) */ [
            "bookDeps",
            false
        ],
        /* parse calculation chains */ [
            "bookSheets",
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            "bookProps",
            false
        ],
        /* only try to get properties (no Sheets) */ [
            "bookFiles",
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            "bookVBA",
            false
        ],
        /* include vba raw data (vbaraw) */ [
            "password",
            ""
        ],
        /* password */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $1d9233f60ebd1a44$var$fix_write_opts(opts) {
    $1d9233f60ebd1a44$var$fix_opts_func([
        [
            "cellDates",
            false
        ],
        /* write date cells with type `d` */ [
            "bookSST",
            false
        ],
        /* Generate Shared String Table */ [
            "bookType",
            "xlsx"
        ],
        /* Type of workbook (xlsx/m/b) */ [
            "compression",
            false
        ],
        /* Use file compression */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $1d9233f60ebd1a44$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($1d9233f60ebd1a44$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($1d9233f60ebd1a44$var$RELS.CS && n == $1d9233f60ebd1a44$var$RELS.CS) return "chart";
    if ($1d9233f60ebd1a44$var$RELS.DS && n == $1d9233f60ebd1a44$var$RELS.DS) return "dialog";
    if ($1d9233f60ebd1a44$var$RELS.MS && n == $1d9233f60ebd1a44$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $1d9233f60ebd1a44$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels["!id"][w.id].Target,
                $1d9233f60ebd1a44$var$get_sheet_type(wbrels["!id"][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $1d9233f60ebd1a44$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $1d9233f60ebd1a44$var$parse_rels($1d9233f60ebd1a44$var$getzipstr(zip, relsPath, true), path);
        var data = $1d9233f60ebd1a44$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case "sheet":
                _ws = $1d9233f60ebd1a44$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "chart":
                _ws = $1d9233f60ebd1a44$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws["!drawel"]) break;
                var dfile = $1d9233f60ebd1a44$var$resolve_path(_ws["!drawel"].Target, path);
                var drelsp = $1d9233f60ebd1a44$var$get_rels_path(dfile);
                var draw = $1d9233f60ebd1a44$var$parse_drawing($1d9233f60ebd1a44$var$getzipstr(zip, dfile, true), $1d9233f60ebd1a44$var$parse_rels($1d9233f60ebd1a44$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $1d9233f60ebd1a44$var$resolve_path(draw, dfile);
                var crelsp = $1d9233f60ebd1a44$var$get_rels_path(chartp);
                _ws = $1d9233f60ebd1a44$var$parse_chart($1d9233f60ebd1a44$var$getzipstr(zip, chartp, true), chartp, opts, $1d9233f60ebd1a44$var$parse_rels($1d9233f60ebd1a44$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case "macro":
                _ws = $1d9233f60ebd1a44$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "dialog":
                _ws = $1d9233f60ebd1a44$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $1d9233f60ebd1a44$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $1d9233f60ebd1a44$var$RELS.CMNT) {
                dfile = $1d9233f60ebd1a44$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $1d9233f60ebd1a44$var$parse_cmnt($1d9233f60ebd1a44$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $1d9233f60ebd1a44$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $1d9233f60ebd1a44$var$RELS.TCMNT) {
                dfile = $1d9233f60ebd1a44$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($1d9233f60ebd1a44$var$parse_tcmnt_xml($1d9233f60ebd1a44$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $1d9233f60ebd1a44$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $1d9233f60ebd1a44$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == "/" ? x.slice(1) : x;
}
function $1d9233f60ebd1a44$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $1d9233f60ebd1a44$var$make_ssf();
    opts = opts || {};
    $1d9233f60ebd1a44$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "META-INF/manifest.xml")) return $1d9233f60ebd1a44$var$parse_ods(zip, opts);
    /* UOC */ if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "objectdata.xml")) return $1d9233f60ebd1a44$var$parse_ods(zip, opts);
    /* Numbers */ if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "Index/Document.iwa")) {
        if (typeof Uint8Array == "undefined") throw new Error("NUMBERS file parsing requires Uint8Array support");
        if (typeof $1d9233f60ebd1a44$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $1d9233f60ebd1a44$var$parse_numbers_iwa(zip, opts);
            var _zip = $1d9233f60ebd1a44$export$9f0e51cd97c572a.utils.cfb_new();
            $1d9233f60ebd1a44$var$zipentries(zip).forEach(function(e) {
                $1d9233f60ebd1a44$var$zip_add_file(_zip, e, $1d9233f60ebd1a44$var$getzipbin(zip, e));
            });
            return $1d9233f60ebd1a44$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error("Unsupported NUMBERS file");
    }
    if (!$1d9233f60ebd1a44$var$safegetzipfile(zip, "[Content_Types].xml")) {
        if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "index.xml.gz")) throw new Error("Unsupported NUMBERS 08 file");
        if ($1d9233f60ebd1a44$var$safegetzipfile(zip, "index.xml")) throw new Error("Unsupported NUMBERS 09 file");
        var index_zip = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(zip, "Index.zip");
        if (index_zip) {
            opts = $1d9233f60ebd1a44$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $1d9233f60ebd1a44$require$Buffer.isBuffer(index_zip.content)) return $1d9233f60ebd1a44$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $1d9233f60ebd1a44$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error("Unsupported ZIP file");
    }
    var entries = $1d9233f60ebd1a44$var$zipentries(zip);
    var dir = $1d9233f60ebd1a44$var$parse_ct($1d9233f60ebd1a44$var$getzipstr(zip, "[Content_Types].xml"));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($1d9233f60ebd1a44$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$1d9233f60ebd1a44$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $1d9233f60ebd1a44$var$strs = [];
        if (dir.sst) try {
            $1d9233f60ebd1a44$var$strs = $1d9233f60ebd1a44$var$parse_sst($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $1d9233f60ebd1a44$var$parse_theme_xml($1d9233f60ebd1a44$var$getzipstr(zip, dir.themes[0].replace(/^\//, ""), true) || "", opts);
        if (dir.style) styles = $1d9233f60ebd1a44$var$parse_sty($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $1d9233f60ebd1a44$var$parse_rels($1d9233f60ebd1a44$var$getzipstr(zip, $1d9233f60ebd1a44$var$get_rels_path($1d9233f60ebd1a44$var$strip_front_slash(link))), link);
            return $1d9233f60ebd1a44$var$parse_xlink($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $1d9233f60ebd1a44$var$parse_wb($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $1d9233f60ebd1a44$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $1d9233f60ebd1a44$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $1d9233f60ebd1a44$var$getzipstr(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $1d9233f60ebd1a44$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== "undefined") out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $1d9233f60ebd1a44$var$parse_cc($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$1d9233f60ebd1a44$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = "xl/_rels/workbook." + wbext + ".rels";
    var wbrels = $1d9233f60ebd1a44$var$parse_rels($1d9233f60ebd1a44$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $1d9233f60ebd1a44$var$parse_xlmeta($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $1d9233f60ebd1a44$var$parse_people_xml($1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $1d9233f60ebd1a44$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $1d9233f60ebd1a44$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = "xl/" + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$1d9233f60ebd1a44$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$1d9233f60ebd1a44$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = "xl/worksheets/sheet" + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $1d9233f60ebd1a44$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $1d9233f60ebd1a44$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $1d9233f60ebd1a44$var$getzipdata(zip, $1d9233f60ebd1a44$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $1d9233f60ebd1a44$var$CT_VBA) out.vbaraw = $1d9233f60ebd1a44$var$getzipdata(zip, "xl/vbaProject.bin", true);
    }
    // TODO: pass back content types metdata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $1d9233f60ebd1a44$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = "Workbook", data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = "/!DataSpaces/Version";
        data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $1d9233f60ebd1a44$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = "/!DataSpaces/DataSpaceMap";
        data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $1d9233f60ebd1a44$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";
        data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $1d9233f60ebd1a44$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";
        data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $1d9233f60ebd1a44$var$parse_Primary(data.content);
    } catch (e) {}
    f = "/EncryptionInfo";
    data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $1d9233f60ebd1a44$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = "/EncryptedPackage";
    data = $1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== "undefined") return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== "undefined") return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $1d9233f60ebd1a44$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt);
    if (wb && wb.SSF) {
        $1d9233f60ebd1a44$var$make_ssf();
        $1d9233f60ebd1a44$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $1d9233f60ebd1a44$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($1d9233f60ebd1a44$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $1d9233f60ebd1a44$var$new_ct();
    $1d9233f60ebd1a44$var$fix_write_opts(opts = opts || {});
    var zip = $1d9233f60ebd1a44$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.rels, 2, f, $1d9233f60ebd1a44$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.rels, 3, f, $1d9233f60ebd1a44$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $1d9233f60ebd1a44$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.rels, 4, f, $1d9233f60ebd1a44$var$RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $1d9233f60ebd1a44$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                $1d9233f60ebd1a44$var$zip_add_file(zip, cf, $1d9233f60ebd1a44$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $1d9233f60ebd1a44$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $1d9233f60ebd1a44$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $1d9233f60ebd1a44$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $1d9233f60ebd1a44$var$write_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $1d9233f60ebd1a44$var$zip_add_file(zip, $1d9233f60ebd1a44$var$get_rels_path(f), $1d9233f60ebd1a44$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $1d9233f60ebd1a44$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.rels, 1, f, $1d9233f60ebd1a44$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $1d9233f60ebd1a44$var$write_theme(wb.Themes, opts);
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $1d9233f60ebd1a44$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "styles." + wbext, $1d9233f60ebd1a44$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $1d9233f60ebd1a44$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $1d9233f60ebd1a44$var$RELS.XLMETA);
    $1d9233f60ebd1a44$var$zip_add_file(zip, "[Content_Types].xml", $1d9233f60ebd1a44$var$write_ct(ct, opts));
    $1d9233f60ebd1a44$var$zip_add_file(zip, "_rels/.rels", $1d9233f60ebd1a44$var$write_rels(opts.rels));
    $1d9233f60ebd1a44$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $1d9233f60ebd1a44$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $1d9233f60ebd1a44$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $1d9233f60ebd1a44$var$dup($1d9233f60ebd1a44$var$table_fmt);
    if (wb && wb.SSF) {
        $1d9233f60ebd1a44$var$make_ssf();
        $1d9233f60ebd1a44$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $1d9233f60ebd1a44$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($1d9233f60ebd1a44$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $1d9233f60ebd1a44$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $1d9233f60ebd1a44$var$new_ct();
    $1d9233f60ebd1a44$var$fix_write_opts(opts = opts || {});
    var zip = $1d9233f60ebd1a44$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $1d9233f60ebd1a44$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.rels, 2, f, $1d9233f60ebd1a44$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.rels, 3, f, $1d9233f60ebd1a44$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $1d9233f60ebd1a44$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.rels, 4, f, $1d9233f60ebd1a44$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $1d9233f60ebd1a44$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $1d9233f60ebd1a44$var$zip_add_file(zip, cf, $1d9233f60ebd1a44$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $1d9233f60ebd1a44$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $1d9233f60ebd1a44$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $1d9233f60ebd1a44$var$zip_add_file(zip, cf, $1d9233f60ebd1a44$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $1d9233f60ebd1a44$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $1d9233f60ebd1a44$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $1d9233f60ebd1a44$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $1d9233f60ebd1a44$var$write_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $1d9233f60ebd1a44$var$zip_add_file(zip, $1d9233f60ebd1a44$var$get_rels_path(f), $1d9233f60ebd1a44$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $1d9233f60ebd1a44$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.rels, 1, f, $1d9233f60ebd1a44$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $1d9233f60ebd1a44$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "styles." + wbext, $1d9233f60ebd1a44$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $1d9233f60ebd1a44$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $1d9233f60ebd1a44$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $1d9233f60ebd1a44$var$zip_add_file(zip, f, $1d9233f60ebd1a44$var$write_people_xml(people, opts));
        ct.people.push(f);
        $1d9233f60ebd1a44$var$add_rels(opts.wbrels, -1, "persons/person.xml", $1d9233f60ebd1a44$var$RELS.PEOPLE);
    }
    $1d9233f60ebd1a44$var$zip_add_file(zip, "[Content_Types].xml", $1d9233f60ebd1a44$var$write_ct(ct, opts));
    $1d9233f60ebd1a44$var$zip_add_file(zip, "_rels/.rels", $1d9233f60ebd1a44$var$write_rels(opts.rels));
    $1d9233f60ebd1a44$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $1d9233f60ebd1a44$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $1d9233f60ebd1a44$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case "buffer":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case "base64":
            x = $1d9233f60ebd1a44$var$Base64_decode(f.slice(0, 12));
            break;
        case "binary":
            x = f;
            break;
        case "array":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $1d9233f60ebd1a44$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($1d9233f60ebd1a44$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $1d9233f60ebd1a44$var$parse_xlsxcfb(cfb, opts);
    return $1d9233f60ebd1a44$export$b41972a043aba84c(cfb, opts);
}
function $1d9233f60ebd1a44$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $1d9233f60ebd1a44$var$zip_read(d, o);
    return $1d9233f60ebd1a44$export$b165387946f79a1(zip, o);
}
function $1d9233f60ebd1a44$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $1d9233f60ebd1a44$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $1d9233f60ebd1a44$var$PRN.to_workbook(data, o);
}
function $1d9233f60ebd1a44$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $1d9233f60ebd1a44$var$firstbyte(data, o);
    switch(o.type){
        case "base64":
            str = $1d9233f60ebd1a44$var$Base64_decode(data);
            break;
        case "binary":
            str = data;
            break;
        case "buffer":
            str = data.toString("binary");
            break;
        case "array":
            str = $1d9233f60ebd1a44$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $1d9233f60ebd1a44$var$utf8read(str);
    o.type = "binary";
    return $1d9233f60ebd1a44$var$read_plaintext(str, o);
}
function $1d9233f60ebd1a44$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == "base64") d = $1d9233f60ebd1a44$var$Base64_decode(d);
    d = typeof $1d9233f60ebd1a44$var$$cptable !== "undefined" ? $1d9233f60ebd1a44$var$$cptable.utils.decode(1200, d.slice(2), "str") : $1d9233f60ebd1a44$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $1d9233f60ebd1a44$var$read_plaintext(d, o);
}
function $1d9233f60ebd1a44$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $1d9233f60ebd1a44$var$utf8write(data);
}
function $1d9233f60ebd1a44$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $1d9233f60ebd1a44$var$PRN.to_workbook(data, o);
    }
    return $1d9233f60ebd1a44$var$PRN.to_workbook(d, o);
}
function $1d9233f60ebd1a44$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $1d9233f60ebd1a44$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $1d9233f60ebd1a44$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) return $1d9233f60ebd1a44$export$aafa59e2e03f2942(new Uint8Array(data), (o = $1d9233f60ebd1a44$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== "undefined" && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $1d9233f60ebd1a44$var$_ssfopts = {};
    if (o.dateNF) $1d9233f60ebd1a44$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $1d9233f60ebd1a44$var$has_buf && $1d9233f60ebd1a44$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $1d9233f60ebd1a44$var$has_buf ? "buffer" : "binary";
        d = $1d9233f60ebd1a44$var$read_binary(data);
        if (typeof Uint8Array !== "undefined" && !$1d9233f60ebd1a44$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $1d9233f60ebd1a44$var$bstrify(data);
    }
    if (o.type == "array" && typeof Uint8Array !== "undefined" && data instanceof Uint8Array && typeof ArrayBuffer !== "undefined") {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $1d9233f60ebd1a44$var$dup(o);
            o.type = "array";
            return $1d9233f60ebd1a44$export$aafa59e2e03f2942($1d9233f60ebd1a44$var$ab2a(d), o);
        }
    }
    switch((n = $1d9233f60ebd1a44$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $1d9233f60ebd1a44$var$read_cfb($1d9233f60ebd1a44$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $1d9233f60ebd1a44$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $1d9233f60ebd1a44$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $1d9233f60ebd1a44$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $1d9233f60ebd1a44$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $1d9233f60ebd1a44$var$read_zip(d, o) : $1d9233f60ebd1a44$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $1d9233f60ebd1a44$var$parse_xlml(d, o) : $1d9233f60ebd1a44$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $1d9233f60ebd1a44$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $1d9233f60ebd1a44$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $1d9233f60ebd1a44$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $1d9233f60ebd1a44$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $1d9233f60ebd1a44$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $1d9233f60ebd1a44$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $1d9233f60ebd1a44$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($1d9233f60ebd1a44$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $1d9233f60ebd1a44$var$DBF.to_workbook(d, o);
    return $1d9233f60ebd1a44$var$read_prn(data, d, o, str);
}
function $1d9233f60ebd1a44$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = "file";
    return $1d9233f60ebd1a44$export$aafa59e2e03f2942(filename, o);
}
function $1d9233f60ebd1a44$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $1d9233f60ebd1a44$var$write_dl(o.file, $1d9233f60ebd1a44$export$9f0e51cd97c572a.write(cfb, {
                type: $1d9233f60ebd1a44$var$has_buf ? "buffer" : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $1d9233f60ebd1a44$export$9f0e51cd97c572a.write(cfb, o);
}
function $1d9233f60ebd1a44$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $1d9233f60ebd1a44$var$write_ods(wb, opts);
        case "numbers":
            return $1d9233f60ebd1a44$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $1d9233f60ebd1a44$var$write_zip_xlsb(wb, opts);
        default:
            return $1d9233f60ebd1a44$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $1d9233f60ebd1a44$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $1d9233f60ebd1a44$var$dup(opts || {});
    var z = $1d9233f60ebd1a44$var$write_zip(wb, o);
    return $1d9233f60ebd1a44$var$write_zip_denouement(z, o);
}
function $1d9233f60ebd1a44$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $1d9233f60ebd1a44$var$dup(opts || {});
    var z = $1d9233f60ebd1a44$var$write_zip_xlsx(wb, o);
    return $1d9233f60ebd1a44$var$write_zip_denouement(z, o);
}
function $1d9233f60ebd1a44$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $1d9233f60ebd1a44$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = "DEFLATE";
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $1d9233f60ebd1a44$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($1d9233f60ebd1a44$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== "undefined") return $1d9233f60ebd1a44$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $1d9233f60ebd1a44$var$write_dl(o.file, out);
    return o.type == "string" ? $1d9233f60ebd1a44$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $1d9233f60ebd1a44$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $1d9233f60ebd1a44$var$write_xlscfb(wb, o);
    return $1d9233f60ebd1a44$var$write_cfb_ctr(cfb, o);
}
function $1d9233f60ebd1a44$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $1d9233f60ebd1a44$var$Base64_encode($1d9233f60ebd1a44$var$utf8write(o));
        case "binary":
            return $1d9233f60ebd1a44$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $1d9233f60ebd1a44$var$write_dl(opts.file, o, "utf8");
        case "buffer":
            if ($1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$var$Buffer_from(o, "utf8");
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $1d9233f60ebd1a44$var$write_string_type(o, {
                type: "binary"
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $1d9233f60ebd1a44$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $1d9233f60ebd1a44$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $1d9233f60ebd1a44$var$write_dl(opts.file, out, "binary");
        case "buffer":
            if ($1d9233f60ebd1a44$var$has_buf) return $1d9233f60ebd1a44$var$Buffer_from(out, "binary");
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $1d9233f60ebd1a44$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == "base64" ? $1d9233f60ebd1a44$var$Base64_encode(bstr) : opts.type == "string" ? $1d9233f60ebd1a44$var$utf8read(bstr) : bstr;
        case "file":
            return $1d9233f60ebd1a44$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $1d9233f60ebd1a44$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $1d9233f60ebd1a44$var$reset_cp();
    $1d9233f60ebd1a44$var$check_wb(wb);
    var o = $1d9233f60ebd1a44$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $1d9233f60ebd1a44$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $1d9233f60ebd1a44$var$s2ab(out);
    }
    return $1d9233f60ebd1a44$var$write_zip_typeXLSX(wb, o);
}
function $1d9233f60ebd1a44$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $1d9233f60ebd1a44$var$reset_cp();
    $1d9233f60ebd1a44$var$check_wb(wb);
    var o = $1d9233f60ebd1a44$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $1d9233f60ebd1a44$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $1d9233f60ebd1a44$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || "xlsb"){
        case "xml":
        case "xlml":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$write_xlml(wb, o), o);
        case "slk":
        case "sylk":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case "htm":
        case "html":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "txt":
            return $1d9233f60ebd1a44$var$write_stxt_type($1d9233f60ebd1a44$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "csv":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\uFEFF");
        case "dif":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "dbf":
            return $1d9233f60ebd1a44$var$write_binary_type($1d9233f60ebd1a44$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "prn":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "rtf":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "eth":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "fods":
            return $1d9233f60ebd1a44$var$write_string_type($1d9233f60ebd1a44$var$write_ods(wb, o), o);
        case "wk1":
            return $1d9233f60ebd1a44$var$write_binary_type($1d9233f60ebd1a44$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "wk3":
            return $1d9233f60ebd1a44$var$write_binary_type($1d9233f60ebd1a44$var$WK_.book_to_wk3(wb, o), o);
        case "biff2":
            if (!o.biff) o.biff = 2; /* falls through */ 
        case "biff3":
            if (!o.biff) o.biff = 3; /* falls through */ 
        case "biff4":
            if (!o.biff) o.biff = 4;
            return $1d9233f60ebd1a44$var$write_binary_type($1d9233f60ebd1a44$var$write_biff_buf(wb, o), o);
        case "biff5":
            if (!o.biff) o.biff = 5; /* falls through */ 
        case "biff8":
        case "xla":
        case "xls":
            if (!o.biff) o.biff = 8;
            return $1d9233f60ebd1a44$var$write_cfb_type(wb, o);
        case "xlsx":
        case "xlsm":
        case "xlam":
        case "xlsb":
        case "numbers":
        case "ods":
            return $1d9233f60ebd1a44$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $1d9233f60ebd1a44$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $1d9233f60ebd1a44$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $1d9233f60ebd1a44$var$resolve_book_type(o);
    return $1d9233f60ebd1a44$export$68d8715fc104d294(wb, o);
}
function $1d9233f60ebd1a44$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $1d9233f60ebd1a44$var$resolve_book_type(o);
    return $1d9233f60ebd1a44$export$f6ca43591cb061b1(wb, o);
}
function $1d9233f60ebd1a44$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $1d9233f60ebd1a44$var$resolve_book_type(o);
    o.type = "buffer";
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $1d9233f60ebd1a44$var$_fs.writeFile(filename, $1d9233f60ebd1a44$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $1d9233f60ebd1a44$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $1d9233f60ebd1a44$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, "__rowNum__", {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case "z":
                if (v == null) break;
                continue;
            case "e":
                v = v == 0 ? null : void 0;
                break;
            case "s":
            case "d":
            case "b":
            case "n":
                break;
            default:
                throw new Error("unrecognized type " + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : $1d9233f60ebd1a44$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $1d9233f60ebd1a44$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case "string":
            r = $1d9233f60ebd1a44$var$safe_decode_range(range);
            break;
        case "number":
            r = $1d9233f60ebd1a44$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $1d9233f60ebd1a44$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $1d9233f60ebd1a44$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $1d9233f60ebd1a44$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $1d9233f60ebd1a44$var$qreg = /"/g;
function $1d9233f60ebd1a44$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $1d9233f60ebd1a44$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = "" + (o.rawNumbers && val.t == "n" ? val.v : $1d9233f60ebd1a44$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = '"' + txt.replace($1d9233f60ebd1a44$var$qreg, '""') + '"';
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = "=" + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($1d9233f60ebd1a44$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $1d9233f60ebd1a44$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $1d9233f60ebd1a44$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $1d9233f60ebd1a44$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $1d9233f60ebd1a44$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "	";
    opts.RS = "\n";
    var s = $1d9233f60ebd1a44$var$sheet_to_csv(sheet, opts);
    if (typeof $1d9233f60ebd1a44$var$$cptable == "undefined" || opts.type == "string") return s;
    var o = $1d9233f60ebd1a44$var$$cptable.utils.encode(1200, s, "str");
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $1d9233f60ebd1a44$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $1d9233f60ebd1a44$var$safe_decode_range(sheet["!ref"]), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $1d9233f60ebd1a44$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == "z") continue;
            else if (x.t == "n" && x.v != null) val = "" + x.v;
            else if (x.t == "b") val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == "s") val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $1d9233f60ebd1a44$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($1d9233f60ebd1a44$var$DENSE != null && dense == null) dense = $1d9233f60ebd1a44$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $1d9233f60ebd1a44$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $1d9233f60ebd1a44$var$safe_decode_range(ws["!ref"]);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $1d9233f60ebd1a44$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = "z";
            var z = "";
            var ref = dense ? "" : $1d9233f60ebd1a44$var$encode_col(_C + C) + $1d9233f60ebd1a44$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === "object" && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == "number") t = "n";
                else if (typeof v == "boolean") t = "b";
                else if (typeof v == "string") t = "s";
                else if (v instanceof Date) {
                    t = "d";
                    if (!o.cellDates) {
                        t = "n";
                        v = $1d9233f60ebd1a44$var$datenum(v);
                    }
                    z = cell != null && cell.z && $1d9233f60ebd1a44$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $1d9233f60ebd1a44$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = "e";
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $1d9233f60ebd1a44$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: "s",
        v: hdr[C]
    };
    else ws[$1d9233f60ebd1a44$var$encode_col(C + _C) + __R] = {
        t: "s",
        v: hdr[C]
    };
    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(range);
    return ws;
}
function $1d9233f60ebd1a44$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $1d9233f60ebd1a44$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $1d9233f60ebd1a44$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $1d9233f60ebd1a44$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: "z"
            });
        }
        return ws[R] || (ws[R] = {
            t: "z"
        });
    }
    /* cell address object */ if (typeof R != "number") return $1d9233f60ebd1a44$var$ws_get_cell_stub(ws, $1d9233f60ebd1a44$var$encode_cell(R));
    /* R and C are 0-based indices */ return $1d9233f60ebd1a44$var$ws_get_cell_stub(ws, $1d9233f60ebd1a44$var$encode_col(C || 0) + $1d9233f60ebd1a44$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $1d9233f60ebd1a44$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function $1d9233f60ebd1a44$var$book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function $1d9233f60ebd1a44$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $1d9233f60ebd1a44$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $1d9233f60ebd1a44$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $1d9233f60ebd1a44$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $1d9233f60ebd1a44$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $1d9233f60ebd1a44$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $1d9233f60ebd1a44$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $1d9233f60ebd1a44$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $1d9233f60ebd1a44$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $1d9233f60ebd1a44$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $1d9233f60ebd1a44$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $1d9233f60ebd1a44$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $1d9233f60ebd1a44$var$ws_get_cell_stub(ws, R, C);
        cell.t = "n";
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $1d9233f60ebd1a44$var$encode_range(wsr);
    return ws;
}
var $1d9233f60ebd1a44$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $1d9233f60ebd1a44$var$encode_col,
    encode_row: $1d9233f60ebd1a44$var$encode_row,
    encode_cell: $1d9233f60ebd1a44$var$encode_cell,
    encode_range: $1d9233f60ebd1a44$var$encode_range,
    decode_col: $1d9233f60ebd1a44$var$decode_col,
    decode_row: $1d9233f60ebd1a44$var$decode_row,
    split_cell: $1d9233f60ebd1a44$var$split_cell,
    decode_cell: $1d9233f60ebd1a44$var$decode_cell,
    decode_range: $1d9233f60ebd1a44$var$decode_range,
    format_cell: $1d9233f60ebd1a44$var$format_cell,
    sheet_add_aoa: $1d9233f60ebd1a44$var$sheet_add_aoa,
    sheet_add_json: $1d9233f60ebd1a44$var$sheet_add_json,
    sheet_add_dom: $1d9233f60ebd1a44$var$sheet_add_dom,
    aoa_to_sheet: $1d9233f60ebd1a44$var$aoa_to_sheet,
    json_to_sheet: $1d9233f60ebd1a44$var$json_to_sheet,
    table_to_sheet: $1d9233f60ebd1a44$var$parse_dom_table,
    table_to_book: $1d9233f60ebd1a44$var$table_to_book,
    sheet_to_csv: $1d9233f60ebd1a44$var$sheet_to_csv,
    sheet_to_txt: $1d9233f60ebd1a44$var$sheet_to_txt,
    sheet_to_json: $1d9233f60ebd1a44$var$sheet_to_json,
    sheet_to_html: $1d9233f60ebd1a44$var$sheet_to_html,
    sheet_to_formulae: $1d9233f60ebd1a44$var$sheet_to_formulae,
    sheet_to_row_object_array: $1d9233f60ebd1a44$var$sheet_to_json,
    sheet_get_cell: $1d9233f60ebd1a44$var$ws_get_cell_stub,
    book_new: $1d9233f60ebd1a44$var$book_new,
    book_append_sheet: $1d9233f60ebd1a44$var$book_append_sheet,
    book_set_sheet_visibility: $1d9233f60ebd1a44$var$book_set_sheet_visibility,
    cell_set_number_format: $1d9233f60ebd1a44$var$cell_set_number_format,
    cell_set_hyperlink: $1d9233f60ebd1a44$var$cell_set_hyperlink,
    cell_set_internal_link: $1d9233f60ebd1a44$var$cell_set_internal_link,
    cell_add_comment: $1d9233f60ebd1a44$var$cell_add_comment,
    sheet_set_array_formula: $1d9233f60ebd1a44$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $1d9233f60ebd1a44$var$_Readable;
function $1d9233f60ebd1a44$var$set_readable(R) {
    $1d9233f60ebd1a44$var$_Readable = R;
}
function $1d9233f60ebd1a44$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $1d9233f60ebd1a44$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $1d9233f60ebd1a44$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $1d9233f60ebd1a44$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $1d9233f60ebd1a44$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $1d9233f60ebd1a44$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $1d9233f60ebd1a44$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $1d9233f60ebd1a44$var$HTML_END;
    stream.push(header);
    var r = $1d9233f60ebd1a44$var$decode_range(ws["!ref"]);
    stream.push($1d9233f60ebd1a44$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($1d9233f60ebd1a44$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $1d9233f60ebd1a44$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $1d9233f60ebd1a44$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case "string":
            r = $1d9233f60ebd1a44$var$safe_decode_range(range);
            break;
        case "number":
            r = $1d9233f60ebd1a44$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $1d9233f60ebd1a44$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $1d9233f60ebd1a44$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $1d9233f60ebd1a44$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $1d9233f60ebd1a44$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $1d9233f60ebd1a44$export$4938110305e6185f = {
    to_json: $1d9233f60ebd1a44$var$write_json_stream,
    to_html: $1d9233f60ebd1a44$var$write_html_stream,
    to_csv: $1d9233f60ebd1a44$var$write_csv_stream,
    set_readable: $1d9233f60ebd1a44$var$set_readable
};
const $1d9233f60ebd1a44$export$83d89fbfd8236492 = $1d9233f60ebd1a44$var$XLSX.version;
var $1d9233f60ebd1a44$export$2e2bcd8739ae039 = {
    parse_xlscfb: $1d9233f60ebd1a44$export$b41972a043aba84c,
    parse_zip: $1d9233f60ebd1a44$export$b165387946f79a1,
    read: $1d9233f60ebd1a44$export$aafa59e2e03f2942,
    readFile: $1d9233f60ebd1a44$export$72c04af63de9061a,
    readFileSync: $1d9233f60ebd1a44$export$72c04af63de9061a,
    write: $1d9233f60ebd1a44$export$68d8715fc104d294,
    writeFile: $1d9233f60ebd1a44$export$552bfb764b5cd2b4,
    writeFileSync: $1d9233f60ebd1a44$export$552bfb764b5cd2b4,
    writeFileAsync: $1d9233f60ebd1a44$export$25469296c4b8ebda,
    writeXLSX: $1d9233f60ebd1a44$export$f6ca43591cb061b1,
    writeFileXLSX: $1d9233f60ebd1a44$export$40a06aea54ee074e,
    utils: $1d9233f60ebd1a44$export$eab97d15b1788b8d,
    set_fs: $1d9233f60ebd1a44$export$a48eb669e1768bcf,
    set_cptable: $1d9233f60ebd1a44$export$58f247d16f363b86,
    stream: $1d9233f60ebd1a44$export$4938110305e6185f,
    SSF: $1d9233f60ebd1a44$export$40d8edd678456c2b,
    CFB: $1d9233f60ebd1a44$export$9f0e51cd97c572a
};

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});



parcelRegister("fQex0", function(module, exports) {

$parcel$export(module.exports, "BaseFilter", () => $ed4a87f0f6bed515$export$f900a054902114a6);

var $dMN2n = parcelRequire("dMN2n");
function $ed4a87f0f6bed515$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ed4a87f0f6bed515$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ed4a87f0f6bed515$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ed4a87f0f6bed515$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ed4a87f0f6bed515$var$_arrayLikeToArray(o, minLen);
}
function $ed4a87f0f6bed515$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $ed4a87f0f6bed515$export$f900a054902114a6 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.muBindData(this.muParent.getFilter());
    }
    showByField(field) {
        const res = [];
        // @ts-ignore
        for(var _iterator = $ed4a87f0f6bed515$var$_createForOfIteratorHelperLoose(this.ui.searchFields.children), _step; !(_step = _iterator()).done;){
            const el = _step.value;
            const vis = !field || field == el.dataset.field;
            el.style.display = vis ? "" : "none";
            if (vis) res.push(el);
        }
        this.muVisible(!field, "bClearFilter");
        return res;
    }
    bFilter_click() {
        this.muParent.setFilter(this.muFetchData());
        this.muRemoveSelf();
    }
    bClearFilter_click() {
        this.muParent.setFilter({});
        this.muRemoveSelf();
    }
    eraseFilterField(ev, field) {
        this.muBindData({
            [field]: null
        });
    }
}

});

parcelRegister("9qZbt", function(module, exports) {

$parcel$export(module.exports, "documentListPreviewOpts", () => $000e35d1d428130f$export$398542439cf661b9);
$parcel$export(module.exports, "ContractFilter", () => $000e35d1d428130f$export$dfdaba33902c6925);
const $000e35d1d428130f$export$398542439cf661b9 = {
    BuSubject: {
        filterField: "partnerBuSubjectId",
        label: "Dokumenty subjektu "
    },
    OrgProject: {
        filterField: "orgProjectId",
        label: "Dokumenty projektu "
    },
    Responsible: {
        filterField: "responsibleId",
        label: "Dokumenty u\u017Eivatele "
    },
    Parent: {
        filterField: "parentId",
        label: "Dodatky "
    }
};
const $000e35d1d428130f$export$dfdaba33902c6925 = {
    "": "Seznam subjekt\u016F",
    customer: "Z\xe1kazn\xedci",
    supplier: "Dodavatel\xe9"
};

});


parcelRegister("3h4tc", function(module, exports) {

$parcel$export(module.exports, "UiDmsDocuments", () => $6fd74f0991cc7049$export$e4e1966dd9871bf1);
$parcel$export(module.exports, "UiDocumentFilter", () => $6fd74f0991cc7049$export$587f007173341200);
$parcel$export(module.exports, "UiDocumentActionCell", () => $6fd74f0991cc7049$export$9c188c7ed3a9ef4);
$parcel$export(module.exports, "UiDocumentLinkCell", () => $6fd74f0991cc7049$export$d17f89592d6c2a65);
$parcel$export(module.exports, "UiNoteShorter", () => $6fd74f0991cc7049$export$475ea6abae5d0902);

var $6YeHu = parcelRequire("6YeHu");

var $9QECq = parcelRequire("9QECq");

var $ffuEw = parcelRequire("ffuEw");

var $fQex0 = parcelRequire("fQex0");

var $3Yb7l = parcelRequire("3Yb7l");

var $kwZWC = parcelRequire("kwZWC");

var $8iO6j = parcelRequire("8iO6j");
function $6fd74f0991cc7049$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6fd74f0991cc7049$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6fd74f0991cc7049$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6fd74f0991cc7049$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6fd74f0991cc7049$var$_arrayLikeToArray(o, minLen);
}
function $6fd74f0991cc7049$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $6fd74f0991cc7049$export$e4e1966dd9871bf1 extends (0, $6YeHu.BaseModule) {
    beforeIndex() {
        super.beforeIndex();
        this.filter.field = "id";
        this.muAppendContent(`
			<h2 mu-id="label">Seznam dokument\u{16F}</h2>
			<div mu-id="typeFilter" mu-widget="UiInlineTreeSelector"></div>
			<div class="toolbar">
				<span class="btn btn-link icon-before-add" mu-id="rCreateItem">P\u{159}idat dokument</span>
				<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>
				<span class="btn btn-link icon-before-filter" mu-id="bFilter">Cel\xfd filtr <span mu-id="filterCount" class="badge"></span></span>
				<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zru\u{161}it filtr</span>
				<span class="btn btn-link icon-before-document-sheet" mu-id="bExport">Export</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<!-- <span class="btn icon-erase" mu-id="bFulltextErase"></span> -->
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>
			<table mu-id="list" mu-widget="UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu-template="actions" mu-widget="UiDocumentActionCell">
					</td>
					<td mu-template="shared:documentLinkCell" mu-widget="UiDocumentLinkCell">
					</td>
					<td mu-template="noteShorter" mu-widget="UiNoteShorter"></td>
				</tr>
			</table>
			
			<div mu-id="pager" mu-widget="Pager"></div>
		`);
    }
    afterIndex() {
        super.afterIndex();
        const formatCellDate = (value, columnInf, cell)=>value ? (0, $kwZWC.formatDate)("d.m.Y", value) : "";
        this.muNamedWidget.list.columns = [
            // new ColumnInfo({field: "id", name: "ID", filterable: false}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "evidenceUid",
                name: "Na\u0161e Ev\u010D",
                cellCssClass: "whitespace-nowrap"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "partnerEvidenceUid",
                name: "Orig. \u010C",
                cellCssClass: "whitespace-nowrap"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dmsDocumentTypeId",
                name: "Typ",
                template: "shared:tdLink",
                widgetParams: {
                    showCode: false
                }
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dmsDocumentClassId",
                name: "Druh",
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "name",
                name: "N\xe1zev"
            }),
            // new ColumnInfo({field: "securityLevel", name: "Stupeň utajení dokumentu", transformContent: v => this.muParent.securityLevels.find(i => i.id == v).title }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "buSubjectId",
                name: "N\xe1\u0161 subjekt",
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "partnerBuSubjectId",
                name: "Druh\xfd subjekt",
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "date",
                name: "Datum",
                transformContent: formatCellDate
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dateFrom",
                name: "Datum platnosti od",
                transformContent: formatCellDate
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dateTo",
                name: "Datum platnosti do",
                transformContent: formatCellDate
            }),
            // new ColumnInfo({field: "dateProlong", name: "Datum prodloužení", transformContent: formatCellDate}),
            // new ColumnInfo({field: "dateProlongChangeTerm", name: "Termín změny", transformContent: formatCellDate}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "orgProjectId",
                name: "Projekt",
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "orgDivisionId",
                name: "St\u0159edisko",
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "responsibleId",
                name: "Odpov\u011Bdn\xe1 osoba",
                template: "shared:documentLinkCell"
            }),
            // new ColumnInfo({field: "parentId", name: "Nadřazený dokument", template: "shared:documentLinkCell"}),
            // new ColumnInfo({field: "amount", name: "Částka", template: "shared:tdAmountCurrency", filterable: false}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "amount",
                name: "\u010C\xe1stka",
                transformContent: (value, columnInf, cell, ev)=>ev.isInteractive ? (0, $kwZWC.formatNumber)(value, 2) : value,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "currencyId",
                name: "M\u011Bna",
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "stateId",
                name: "Stav",
                template: "shared:documentLinkCell",
                widgetParams: {
                    showCode: false
                }
            }),
            // new ColumnInfo({field: "cancelNote", name: "Poznámka ke stornu", template: "ancestor:noteShorter" }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "id",
                name: "-",
                template: "ancestor:actions",
                orderable: true,
                filterable: false,
                interactiveOnly: true
            })
        ];
        setTimeout(async ()=>{
            (0, $ffuEw.UiDms).instance.cpDmsDocumentClass.fetch();
            const types = (await (0, $ffuEw.UiDms).instance.cpDmsDocumentType.fetch()).filter((t)=>!t.mustHaveParent);
            this.muNamedWidget.typeFilter.bind((0, $8iO6j.SlashTree).parse(types, "name", " - "));
        }, 10);
    }
    typeFilter_select(ev, item) {
        const newDTFilter = (0, $8iO6j.SlashTree).getItemsRecursive(item).filter((it)=>it.data.id).map((it)=>it.data?.id);
        const newDTFilterS = newDTFilter.join(",");
        if (!this.filter.dmsDocumentTypeId || this.filter.dmsDocumentTypeId.join(",") != newDTFilterS) {
            this.filter.dmsDocumentTypeId = newDTFilter;
            this.loadList();
        }
    }
    openEditor(id) {
        /* const editor = UiDms.instance.openInModal("UiDmsDocumentEditor", id
    	? "Upravit dokument"
    	: "Vytvořit dokument"
    ) as unknown as BaseEditor;
    if (id) editor.loadItem(id);
    return editor; */ return this.muParent.openDmsDocumentEditor(id);
    }
    openFilter(field) {
        const filter = (0, $ffuEw.UiDms).instance.openInModal("UiDocumentFilter", "Nastavit filtr", {
            muParent: this
        });
        // filter?.showByField(field);
        return filter;
    }
    async rCreateItem_click() {
        const bse = this.openEditor(null);
        if (this.filter.dmsDocumentTypeId?.length == 1) {
            const dmsDocumentTypeId = parseInt(this.filter.dmsDocumentTypeId[0]);
            const dmsDocumentType = await this.muParent.getDmsDocumentType(dmsDocumentTypeId);
            if (!dmsDocumentType.mustHaveParent) bse.muBindData({
                dmsDocumentTypeId: dmsDocumentTypeId
            });
        }
        bse.muBindData({
            date: (0, $kwZWC.formatDate)("Y-m-d", new Date())
        });
        bse?.savedPromise.then(()=>this.loadList());
    }
    getListData(forExport) {
        return (0, $ffuEw.UiDms).instance.cl.allDocuments({
            ...this.filter,
            fulltext: this.ui.cFulltext.value
        }, this.orderBy, forExport ? 0 : this.muNamedWidget.pager.currentItemFrom, forExport ? null : this.muNamedWidget.pager.itemPerPage);
    }
    showAttaches(dmsDocument) {
        // const atts = UiDms.instance.openInModal<UiDmsAttaches>("UiDmsAttaches", "Přílohy k dokumentu " + getDocumentName(dmsDocument));
        // atts.showForDmsDocument(dmsDocument);
        (0, $ffuEw.UiDms).instance.openAttaches(dmsDocument);
    }
    showHistory(dmsDocument) {
        const atts = (0, $ffuEw.UiDms).instance.openInModal("UiDmsHistory", "...");
        atts.loadForDocument(dmsDocument);
    }
}
class $6fd74f0991cc7049$export$587f007173341200 extends (0, $fQex0.BaseFilter) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent('<div mu-id="searchFields">' + (0, $9QECq.formGroup)("dmsDocumentTypeId", "Typ", `<div mu-widget="UiTomSelect" mu-id="dmsDocumentType" mu-bind="dmsDocumentTypeId"></div>`, true) + (0, $9QECq.formGroup)("stateId", "Stav", `<div mu-widget="UiTomSelect" mu-id="state" mu-bind="stateId"></div>`, true) + (0, $9QECq.formGroup)("responsibleId", "Odpov\u011Bdn\xe1 osoba", `<div mu-widget="UiAccountSelector" mu-id="responsibleId" mu-bind="responsibleId"></div>`, true) + (0, $9QECq.formGroup)("orgDivisionId", "St\u0159edisko", `<div mu-widget="TreeSelector" mu-id="orgDivisionId" mu-bind="orgDivisionId" mu-params='{"inModal":true,"multiple":true,"useModalClass":false}'></div>`, true) + (0, $9QECq.formGroup)("dmsDocumentClassId", "Druh", `<div mu-widget="UiTomSelect" mu-id="dmsDocumentClass" mu-bind="dmsDocumentClassId"></div>`, true) + (0, $9QECq.formGroup)("orgProjectId", "Projekt", `<div mu-widget="UiOrgProjectSelector" mu-id="orgProjectId" mu-bind="orgProjectId" mu-params='{"multiple":true}'></div>`, true) + (0, $9QECq.formGroup)("evidenceUid", "Na\u0161e Ev\u010D", `<input type="search" class="form-control" mu-bind="evidenceUid" />`, true) + (0, $9QECq.formGroup)("name", "N\xe1zev", `<input type="search" class="form-control" mu-bind="name" />`, true) + (0, $9QECq.formGroup)("buSubjectId", "N\xe1\u0161 Subjekt", `<div mu-widget="UiTomSelect" mu-id="buSubjectId" mu-bind="buSubjectId" mu-params='{"multiple":true}'></div>`, true) + (0, $9QECq.formGroup)("partnerEvidenceUid", "Orig. \u010C", `<input type="search" class="form-control" mu-bind="partnerEvidenceUid" />`, true) + (0, $9QECq.formGroup)("partnerBuSubjectId", "Druh\xfd subjekt", `<div mu-widget="UiBuSubjectSelector" mu-id="partnerBuSubject" mu-bind="partnerBuSubjectId" mu-params='{"multiple":true}'></div>`, true) + (0, $9QECq.formGroup)("date", "Datum", `<div mu-widget="UiDateFilter" mu-id="date" mu-bind="date"></div>`, true) + (0, $9QECq.formGroup)("dateFrom", "Datum platnosti od", `<div mu-widget="UiDateFilter" mu-id="dateFrom" mu-bind="dateFrom"></div>`, true) + (0, $9QECq.formGroup)("dateTo", "Datum platnosti do", `<div mu-widget="UiDateFilter" mu-id="dateTo" mu-bind="dateTo"></div>`, true) + `</div><div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zru\u{161}it filtr</span>
			</div>`);
    }
    async afterIndex() {
        let c = this.muNamedWidget.dmsDocumentClass;
        c.multiple = true;
        c.init();
        c.bindItems(await (0, $ffuEw.UiDms).instance.cpDmsDocumentClass.fetch());
        c = this.muNamedWidget.dmsDocumentType;
        c.multiple = true;
        c.init();
        c.bindItems(await (0, $ffuEw.UiDms).instance.cpDmsDocumentType.fetch());
        c = this.muNamedWidget.buSubjectId;
        c.multiple = true;
        c.init();
        c.bindItems((await (0, $ffuEw.UiDms).instance.cpMyBuSubjects.fetch()).read);
        c = this.muNamedWidget.state;
        c.multiple = true;
        c.init();
        c.bindItems(await (0, $ffuEw.UiDms).instance.cpStates.fetch());
        this.muNamedWidget.orgDivisionId.bindTree(await (0, $ffuEw.UiDms).instance.cpOrgDivision.fetch());
        /* const bss = (this.muNamedWidget.buSubjectId as unknown as UiTomSelect);
    bss.multiple = true;
    bss.init();
    bss.bindItems(await UiDms.instance.cpMyBuSubjects.fetch()); */ super.afterIndex();
    }
}
class $6fd74f0991cc7049$export$9c188c7ed3a9ef4 extends (0, $3Yb7l.UiTableCell) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`<span mu-id="bEdit" class="whitespace-nowrap a icon-before-edit">Upravit</span>
			<span mu-id="bAttaches" class="whitespace-nowrap a icon-before-document-dir">P\u{159}\xedlohy</span>
			<span mu-id="bHistory" class="whitespace-nowrap a icon-before-detail">Historie</span>
			<span mu-id="bSubdocument" mu-template="subdocumentItem" mu-widget="." class="whitespace-nowrap">
				<span mu-id="bAddSubdocument" title="P\u{159}idat" class="a icon-before-add"></span>
				<span mu-id="count" title="Zobrazit" class="badge cursor-pointer"></span>
			</span>
		`);
    }
    async render(value, row) {
        this.id = value;
        this.dmsDocument = row;
        for(var _iterator = $6fd74f0991cc7049$var$_createForOfIteratorHelperLoose(row.dmsDocumentTypeId.opts.subDocumentTypes || []), _step; !(_step = _iterator()).done;){
            const subTypeCode = _step.value;
            const dmsDocumentType = await (0, $ffuEw.UiDms).instance.getDmsDocumentType(subTypeCode);
            this.muWidgetFromTemplate("subdocumentItem", this.container, {
                bAddSubdocument_click: ()=>(0, $ffuEw.UiDms).instance.openDmsDocumentEditor(null, {
                        dmsDocumentTypeId: dmsDocumentType.id,
                        stateOpts: dmsDocumentType.default.stateOpts,
                        parentId: row,
                        orgProjectId: row.orgProjectId,
                        responsibleId: row.responsibleId,
                        orgDivisionId: row.orgDivisionId.id,
                        currencyId: row.currencyId,
                        buSubjectId: row.buSubjectId,
                        partnerBuSubjectId: row.partnerBuSubjectId
                    }),
                count_click: ()=>(0, $ffuEw.UiDms).instance.openDocumentsPreview("Parent", row.id, row),
                afterIndex () {
                    this.ui.bAddSubdocument.innerText = dmsDocumentType.name;
                    this.ui.count.innerText = row.subDocumentCounts[dmsDocumentType.id] || "";
                }
            });
        }
    }
    bEdit_click() {
        const module = this.muParent.muParent.muParent;
        module.loadItem(this.id);
    }
    bAttaches_click() {
        const module = this.muParent.muParent.muParent;
        module.showAttaches(this.dmsDocument);
    }
    bHistory_click() {
        const module = this.muParent.muParent.muParent;
        module.showHistory(this.dmsDocument);
    }
    bAddSubdocument_click() {}
}
class $6fd74f0991cc7049$export$d17f89592d6c2a65 extends (0, $3Yb7l.UiTableCell) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`<div mu-id="link"><strong mu-id="code"></strong><span mu-id="space"></span><span mu-id="name"></span></div>`);
    }
    link_click() {
    // alert(this.value.id);
    }
    render(value) {
        this.ui.name.innerText = value ? value[this.labelField] ?? "" : "";
        if (value && value.code && this.showCode) this.ui.code.innerText = value ? value.code + " " : "";
        if (value && value.code && this.showCode && value[this.labelField]) this.ui.space.innerHTML = " &nbsp;";
        this.value = value;
    }
    constructor(...args){
        super(...args);
        this.labelField = "name";
        this.showCode = true;
    }
}
class $6fd74f0991cc7049$export$475ea6abae5d0902 extends (0, $3Yb7l.UiTableCell) {
    beforeIndex() {
        this.container.classList.add("note-shorter");
        this.muAppendContent(`<span mu-id="short" class="note-shorter--short"></span><div mu-id="full" class="note-shorter--full"></div>`);
    }
    render(value, row) {
        this.ui.short.innerText = value?.substr(0, this.shortLen) ?? "";
        this.ui.full.innerText = value ?? "";
    }
    constructor(...args){
        super(...args);
        this.shortLen = 50;
    }
}

});

parcelRegister("9DsTT", function(module, exports) {

$parcel$export(module.exports, "UiDocumentListPreview", () => $aae53a622ff7cb78$export$a8ecfaa3bd0c8d00);
$parcel$export(module.exports, "UiDocumentListPreviewTypeGroup", () => $aae53a622ff7cb78$export$18d2205e9e50fe67);
$parcel$export(module.exports, "UiDocumentListPreviewOpenLink", () => $aae53a622ff7cb78$export$573ef0241ea0644e);

var $dMN2n = parcelRequire("dMN2n");

var $ffuEw = parcelRequire("ffuEw");

var $9qZbt = parcelRequire("9qZbt");

var $3Yb7l = parcelRequire("3Yb7l");
function $aae53a622ff7cb78$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $aae53a622ff7cb78$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aae53a622ff7cb78$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aae53a622ff7cb78$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aae53a622ff7cb78$var$_arrayLikeToArray(o, minLen);
}
function $aae53a622ff7cb78$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $aae53a622ff7cb78$export$a8ecfaa3bd0c8d00 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`
			<div mu-keybind="Escape:btCloseModal">
				<div mu-bind="types:@foreach" style="display: none" mu-id="types">
					<div mu-template="item" mu-widget="UiDocumentListPreviewTypeGroup">
						<div class="display-flex" mu-id="typeInfo">
							<h3 mu-bind="name" class="flex-grow-1"></h3>
							<span class="btn btn-link icon-before-add" mu-id="bAddDocument">P\u{159}idat <span mu-bind="name"></span></span>						
						</div> 
						<table mu-id="documents" mu-widget="UiTable" class="table table-hover table-striped">
							<tr><td mu-template="actions" mu-widget="UiDocumentListPreviewOpenLink"></td></tr>
						</table>
					</div>
				</div>
				<table class="table table-hover table-striped" mu-id="fullTable">
					<thead mu-template="rowWrapper" mu-widget="."><tr><td colspan="10" mu-id="content"></td></tr></thead>
				</table>
				<span class="btn btn-link icon-before-add" mu-id="bAddDocument">P\u{159}idat jin\xfd dokument</span>		
			</div>
		`);
    }
    async showFor(entityType, entityId, entityData) {
        this.entityType = entityType;
        this.entityId = entityId;
        this.opts = (0, $9qZbt.documentListPreviewOpts)[entityType];
        // titulek okna
        let entityLabel = "";
        switch(entityType){
            case "BuSubject":
                entityLabel = (0, $ffuEw.getBuSubjectName)(entityData);
                break;
            case "Parent":
                entityLabel = (0, $ffuEw.getDocumentName)(entityData);
                break;
            case "OrgProject":
                entityLabel = (0, $ffuEw.getOrgProjectName)(entityData);
                break;
        }
        this.ui.modalTitle.innerText = this.opts.label + " " + entityLabel;
        const data = await this.muParent.cl.allDocuments({
            [this.opts.filterField]: entityId
        }, {
            field: "evidenceUid",
            dir: "asc"
        }, 0, null);
        const byType = {};
        for(var _iterator = $aae53a622ff7cb78$var$_createForOfIteratorHelperLoose(data.list), _step; !(_step = _iterator()).done;){
            const doc = _step.value;
            const k = doc.parentId?.dmsDocumentTypeId || doc.dmsDocumentTypeId.id;
            if (!byType[k]) byType[k] = {
                name: doc.dmsDocumentTypeId.name,
                canCreate: !doc.dmsDocumentTypeId.mustHaveParent,
                dmsDocumentTypeId: doc.dmsDocumentTypeId.id,
                documents: []
            };
            byType[k].documents.push(doc);
        }
        this.muBindData({
            types: Object.values(byType)
        });
        // Do jedné tabulky
        for(var _iterator2 = $aae53a622ff7cb78$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("types")), _step2; !(_step2 = _iterator2()).done;){
            const wType = _step2.value;
            const infoCW = this.muWidgetFromTemplate("rowWrapper", "fullTable");
            infoCW.ui.content.appendChild(wType.ui.typeInfo);
            for(var _i = 0, _Array$from = Array.from(wType.ui.documents.children); _i < _Array$from.length; _i++){
                const ch = _Array$from[_i];
                // @ts-ignore
                if (!ch.innerText.trim()) continue;
                this.ui.fullTable.appendChild(ch);
                console.log(ch);
            }
        }
    }
    bAddDocument_click() {
        this.openNew();
    }
    openNew(data = {}) {
        this.muParent.openDmsDocumentEditor(null, {
            [this.opts.filterField]: this.entityId,
            ...data
        });
    }
}
class $aae53a622ff7cb78$export$18d2205e9e50fe67 extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        super.afterIndex();
        const cols = [];
        for(var _iterator3 = $aae53a622ff7cb78$var$_createForOfIteratorHelperLoose(this.allColumnInfos), _step3; !(_step3 = _iterator3()).done;){
            const col = _step3.value;
            // if (col.field != this.muParent.entityType && col.field != this.muParent.entityType + "Id") cols.push(col);
            if (col.field != this.muParent.opts.filterField) cols.push(col);
        }
        this.muNamedWidget.documents.columns = cols;
    }
    muAfterBindData(data) {
        this.muNamedWidget.documents.data = data.documents;
        this.muNamedWidget.documents.render();
        this.dmsDocumentTypeId = data.dmsDocumentTypeId;
        this.muVisible(data.canCreate, "bAddDocument");
    }
    bAddDocument_click() {
        this.muParent.openNew({
            dmsDocumentTypeId: this.dmsDocumentTypeId
        });
    }
    constructor(...args){
        super(...args);
        this.allColumnInfos = [
            // new ColumnInfo({field: "id", name: "ID", filterable: false}),
            // new ColumnInfo({field: "dmsDocumentTypeId", name: "Typ", template: "shared:tdLink", widgetParams: { showCode: false }}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "evidenceUid",
                name: "Na\u0161e Ev\u010D",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "dmsDocumentClassId",
                name: "Druh",
                template: "shared:tdLink",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "name",
                name: "N\xe1zev",
                orderable: false,
                filterable: false
            }),
            // new ColumnInfo({field: "buSubjectId", name: "Náš subjekt", template: "shared:tdLink", orderable: false, filterable: false}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "partnerBuSubjectId",
                name: "Druh\xfd subjekt",
                template: "shared:tdLink",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "orgDivisionId",
                name: "St\u0159edisko",
                template: "shared:tdLink",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "orgProjectId",
                name: "Projekt",
                template: "shared:tdLink",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "stateId",
                name: "Stav",
                template: "shared:tdLink",
                orderable: false,
                filterable: false,
                widgetParams: {
                    showCode: false
                }
            }),
            // new ColumnInfo({field: "date", name: "Datum", transformContent: formatCellDate}),
            // new ColumnInfo({field: "dateFrom", name: "Datum platnosti od"}),
            // new ColumnInfo({field: "dateTo", name: "Datum platnosti do"}),
            // new ColumnInfo({field: "dateProlong", name: "Datum prodloužení"}),
            // new ColumnInfo({field: "dateProlongChangeTerm", name: "Termín změny"}),
            // new ColumnInfo({field: "responsible", name: "Odpovědná osoba", template: "shared:tdAmountCurrency"}),
            // new ColumnInfo({field: "parent", name: "Nařazený dokument"}),
            // new ColumnInfo({field: "amount", name: "Částka", template: "shared:tdAmountCurrency", headCssClass: 'number', orderable: false, filterable: false}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "id",
                name: "-",
                template: "ancestor:actions",
                orderable: false,
                filterable: false
            })
        ];
    }
}
class $aae53a622ff7cb78$export$573ef0241ea0644e extends (0, $3Yb7l.UiTableCell) {
    beforeIndex() {
        this.muAppendContent(`
			<span class="a whitespace-nowrap icon-before-edit" mu-id="edit">Upravit</span>
			<span class="a whitespace-nowrap icon-before-document-dir" mu-id="attaches">P\u{159}\xedlohy</span>
		`);
    }
    render(value, row) {
        this.id = value;
        this.dmsDocument = row;
    }
    edit_click() {
        (0, $ffuEw.UiDms).instance.openDmsDocumentEditor(this.id);
    }
    attaches_click() {
        (0, $ffuEw.UiDms).instance.openAttaches(this.dmsDocument);
    }
}

});

parcelRegister("gIRkU", function(module, exports) {

$parcel$export(module.exports, "UiDmsAttaches", () => $c4d40ea4442a32c8$export$b18bdb492b3a4b7e);
$parcel$export(module.exports, "UiDmsAttachesType", () => $c4d40ea4442a32c8$export$a58f495b8ec25c0e);
$parcel$export(module.exports, "UiDmsAttachesAttach", () => $c4d40ea4442a32c8$export$7bb1ea1862e5182c);

var $dMN2n = parcelRequire("dMN2n");

var $ffuEw = parcelRequire("ffuEw");

var $3Yb7l = parcelRequire("3Yb7l");

var $kwZWC = parcelRequire("kwZWC");
function $c4d40ea4442a32c8$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c4d40ea4442a32c8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c4d40ea4442a32c8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c4d40ea4442a32c8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c4d40ea4442a32c8$var$_arrayLikeToArray(o, minLen);
}
function $c4d40ea4442a32c8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $c4d40ea4442a32c8$export$b18bdb492b3a4b7e extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="dms-attaches__list-preview" mu-id="listPreview" mu-keybind="Escape:btCloseModal">
				<div>
					<label mu-id="pShowInvalidated"><input type="checkbox" mu-id="chShowInvalidated" />Zobrazit zneplatn\u{11B}n\xe9</label>
					<div mu-id="types" mu-bind="types::@foreach" class="dms-attaches__list">
						<fieldset mu-widget="UiDmsAttachesType" mu-template="item" mu-bind="attachTypeId:.attachTypeId">
							<legend mu-bind="name"></legend>
							<!-- <div mu-bind="attaches:@foreach">
								<div mu-widget="UiDmsAttachesAttach" mu-template="item" class="dms-attaches__list-item">
									<span mu-bind='dtCreated|dateTime("d.m.Y");dtCreated|dateTime("d.m.Y H:i"):title'></span>
									<span class="icon-document-html"></span>
									<strong mu-bind='fileName; dtInvalidation|tern("dms-attaches__list-item--invalidated", "")|append(" a"):className' mu-id="fileName" class="a"></strong>
								</div>
							</div> -->
							<table class="table" mu-id="attaches" mu-widget="UiTable"></table>
							<div mu-id="mupNewAttach" mu-widget="MultiUpload"></div>
						</fieldset>
					</div>
				</div>
				<div class="dms-attaches__preview">
					<h3 class="display-flex-row dms-attaches__preview__title">
						<span class="flex-grow-1">N\xe1hled <span mu-id="previewFileName"></span></span>
						<span class="icon-trash icon-24 cursor-pointer" mu-id="bInvalidate" title="Zneplatnit"></span>
						<span class="icon-download icon-24 cursor-pointer" mu-id="bDownload" title="St\xe1hnout"></span>
						<span class="icon-close icon-24 cursor-pointer" mu-id="bClosePreview"></span>
					</h3>
					<div class="loading-data dms-attaches__preview__content" mu-id="pPreviewContent"></div>
					<div class="alert alert-danger" mu-template="previewFailed">Nepoda\u{159}ilo se vygenerovat n\xe1hled. st\xe1hn\u{11B}te dokument do sv\xe9ho za\u{159}\xedzen\xed</div>
					<div class="dms-attaches__preview__notice alert alert-warning" mu-id="previewNotice"></div>
				</div>
			</div>
			<div class="buttons" mu-id="pSaveButton">
				<span class="btn btn-primary" mu-id="bAddDocuments">P\u{159}idat dokumenty</span>
			</div>
		`);
    }
    async reload() {
        await this.showForDmsDocument(this.dmsDocument);
    }
    afterIndex() {
        this.muVisible(!this.inCreateForm, [
            "pSaveButton",
            "pShowInvalidated"
        ]);
    }
    async showForDmsDocument(dmsDocument) {
        this.container.classList.add("loading-data");
        this.dmsDocumentId = dmsDocument.id;
        this.dmsDocument = dmsDocument;
        const allAttachTypes = await (0, $ffuEw.UiDms).instance.cpDmsAttachType.fetch();
        const byTypes = {};
        const documentTypeOpts = dmsDocument.dmsDocumentTypeId.opts;
        const newTypeGroup = (attachType)=>{
            if (typeof attachType === "number") attachType = allAttachTypes.find((at)=>at.id == attachType);
            return {
                name: attachType.name,
                attachTypeId: attachType.id,
                attaches: []
            };
        };
        for(var _iterator = $c4d40ea4442a32c8$var$_createForOfIteratorHelperLoose(allAttachTypes), _step; !(_step = _iterator()).done;){
            const attachType = _step.value;
            if (documentTypeOpts.attachTypes && !documentTypeOpts.attachTypes.includes(attachType.code)) continue;
            byTypes[attachType.id] = newTypeGroup(attachType);
        }
        if (dmsDocument.id) {
            const filter = {
                showInvalidated: this.ui.chShowInvalidated.checked,
                dmsDocumentId: dmsDocument.id
            };
            for(var _iterator2 = $c4d40ea4442a32c8$var$_createForOfIteratorHelperLoose(await (0, $ffuEw.UiDms).instance.cl.getAllDmsAttaches(filter)), _step2; !(_step2 = _iterator2()).done;){
                const dAttach = _step2.value;
                if (!byTypes[dAttach.dmsAttachTypeId]) byTypes[dAttach.dmsAttachTypeId] = newTypeGroup(dAttach.dmsAttachTypeId);
                byTypes[dAttach.dmsAttachTypeId].attaches.push(dAttach);
            }
        }
        this.muBindData({
            types: Object.values(byTypes)
        });
        this.container.classList.remove("loading-data");
    }
    async bAddDocuments_click() {
        return await this.doSaveAttaches();
    }
    async doSaveAttaches() {
        let attaches = [];
        for(var _iterator3 = $c4d40ea4442a32c8$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("types")), _step3; !(_step3 = _iterator3()).done;){
            const type = _step3.value;
            const typeRes = await type.muNamedWidget.mupNewAttach.sendToBackend(async (context, send)=>{
                context.url = await (0, $ffuEw.UiDms).instance.cl.newTempFile();
                context.dmsAttachTypeId = type.attachTypeId;
                send();
            });
            attaches = [
                ...attaches,
                ...typeRes.map((uc)=>({
                        dmsAttachTypeId: uc.dmsAttachTypeId,
                        fileName: uc.file.name,
                        fileContentType: uc.file.type,
                        dmsDocumentId: this.dmsDocumentId,
                        tmpName: uc.url
                    }))
            ];
        }
        // console.log(attaches);
        await (0, $ffuEw.UiDms).instance.cl.saveAllAttaches(attaches);
        await Promise.all([
            this.reload(),
            (0, $ffuEw.UiDms).instance.muNamedWidget.documents.loadList()
        ]);
        if (this.onSaved) this.onSaved(null);
    }
    bClosePreview_click() {
        this.openPreview(null);
    }
    bDownload_click() {
        window.open(this.downloadLink, "_blank");
    }
    async bInvalidate_click() {
        if (confirm("Opravdu chcete zneplatnit p\u0159\xedlohu?")) {
            // @ts-ignore
            await (0, $ffuEw.UiDms).instance.cl.invalidateDmsAttach(this.currentDmsAttach.id);
            await Promise.all([
                this.reload(),
                (0, $ffuEw.UiDms).instance.muNamedWidget.documents.loadList()
            ]);
        }
    }
    async openPreview(attach) {
        this.currentDmsAttach = attach;
        this.ui.listPreview.classList.toggle("dms-attaches__list-preview--with-preview", !!attach);
        this.container.classList.toggle("dms-attaches__modal", !!attach);
        if (attach) {
            this.ui.pPreviewContent.classList.toggle("loading-data", true);
            this.ui.previewFileName.innerText = attach.fileName;
            this.downloadLink = attach.downloadLink;
            try {
                const previewData = await (0, $ffuEw.UiDms).instance.cl.getDmsAttachPreview(attach.id);
                this.ui.pPreviewContent.innerHTML = previewData.content;
                this.muVisible(!!previewData.notice, "previewNotice");
                this.ui.previewNotice.innerText = previewData.notice || "";
            // this.downloadLink = previewData.downloadLink;
            } catch (exc) {
                this.ui.pPreviewContent.innerHTML = this.muTemplates.previewFailed;
            } finally{
                this.ui.pPreviewContent.classList.toggle("loading-data", false);
            }
        }
    }
    chShowInvalidated_change() {
        this.reload();
    }
    newSavedPromise() {
        this.savedPromise = new Promise((resolve)=>{
            this.onSaved = resolve;
        });
        return this.savedPromise;
    }
    constructor(...args){
        super(...args);
        this.currentDmsAttach = null;
        this.onSaved = null;
        this.savedPromise = null;
        this.inCreateForm = false;
    }
}
class $c4d40ea4442a32c8$export$a58f495b8ec25c0e extends (0, $dMN2n.MuWidget) {
    muBindData(srcData) {
        super.muBindData(srcData);
        const table = this.muNamedWidget.attaches;
        table.columns = [
            new (0, $3Yb7l.ColumnInfo)({
                field: "dtCreated",
                name: "P\u0159id\xe1no",
                orderable: false,
                filterable: false,
                transformContent: (0, $kwZWC.TCFormatDate)
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "fileName",
                name: "N\xe1zev",
                orderable: false,
                filterable: false
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "accountCreated",
                name: "P\u0159idal",
                orderable: false,
                filterable: false
            })
        ];
        table.data = srcData.attaches;
        table.render();
    }
    attaches_rowClick(ev, wRow) {
        this.muParent.openPreview(wRow.data);
    }
    attaches_rowRendered(ev, wRow) {
        wRow.container.classList.toggle("dms-attaches__list-item--invalidated", !!wRow.data.dtInvalidation);
    }
}
class $c4d40ea4442a32c8$export$7bb1ea1862e5182c extends (0, $dMN2n.MuWidget) {
    fileName_click() {
        this.muParent.muParent.openPreview(this.dmsAttach);
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        this.dmsAttach = srcData;
    }
}

});

parcelRegister("kedEG", function(module, exports) {

$parcel$export(module.exports, "UiDmsHistory", () => $929fa6fbfc4cc719$export$bfe8c96847695758);

var $dMN2n = parcelRequire("dMN2n");

var $ffuEw = parcelRequire("ffuEw");
class $929fa6fbfc4cc719$export$bfe8c96847695758 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.container.classList.add("dms-history");
        this.muAppendContent(`
			<div mu-id="items" mu-bind="items:@foreach">
				<div mu-template="item" mu-widget="." class="dms-history__item">
					<div class="dms-history__item-head">
						<span mu-bind="account"></span> v <span mu-bind="dtOperation"></span>
					</div>
					<table class="table table-hover table-striped table-sticky-header">
						<thead><tr><th>Parametr</th><th>Star\xe1 hodnota</th><th>Nov\xe1 hodnota</th></tr></thead>
						<tbody mu-bind="changes:@foreach">
							<tr mu-template="item" mu-widget=".">
								<td mu-bind="fieldName"></td>
								<td mu-bind="oldValue"></td>
								<td mu-bind="newValue"></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		`);
    }
    async loadForDocument(document) {
        this.ui.modalTitle.innerText = "Historie dokumentu " + (0, $ffuEw.getDocumentName)(document.evidenceUid);
        const data = await (0, $ffuEw.UiDms).instance.cl.getDocumentHistory(document.id);
        console.log(data);
        this.muBindData({
            items: data
        });
    }
}

});

parcelRegister("1YGhk", function(module, exports) {

$parcel$export(module.exports, "UiDmsOrgProjects", () => $29eb4026bc03b70d$export$ed89e3341a565d5e);
$parcel$export(module.exports, "UiOrgProjectsActionCell", () => $29eb4026bc03b70d$export$77d0eb6ed540c74f);
$parcel$export(module.exports, "UiDmsOrgProjectsFilter", () => $29eb4026bc03b70d$export$c9fe1f417ccd0f0e);

var $dMN2n = parcelRequire("dMN2n");

var $3Yb7l = parcelRequire("3Yb7l");

var $ffuEw = parcelRequire("ffuEw");

var $6YeHu = parcelRequire("6YeHu");

var $9QECq = parcelRequire("9QECq");

var $fQex0 = parcelRequire("fQex0");
class $29eb4026bc03b70d$export$ed89e3341a565d5e extends (0, $6YeHu.BaseModule) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`
			<h2 mu-id="label">Seznam projekt\u{16F}</h2>
			<div class="toolbar">
				<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>
				<span class="btn btn-link icon-before-filter" mu-id="bFilter">Cel\xfd filtr <span mu-id="filterCount" class="badge"></span></span>
				<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zru\u{161}it filtr</span>
				<span class="btn btn-link icon-before-document-sheet" mu-id="bExport">Export</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>
			<table mu-id="list" mu-widget="UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu-template="actions" mu-widget="UiOrgProjectsActionCell">
						<span mu-id="bDocuments" class="a icon-before-document-dir">Dokumenty</span>
					</td>
				</tr>
			</table>
			
			<div mu-id="pager" mu-widget="Pager"></div>
			` + ((0, $ffuEw.UiDms).instance.isAdmin ? '<a href="/dms/projects-import">Import projekt\u016F</a>' : ""));
    }
    afterIndex() {
        super.afterIndex();
        this.muNamedWidget.list.columns = [
            // new ColumnInfo({field: "id", name: "ID", filterable: false}),
            new (0, $3Yb7l.ColumnInfo)({
                field: "name",
                name: "N\xe1zev"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "code",
                name: "K\xf3d"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "orgDivision",
                name: "St\u0159edisko",
                orderable: true,
                filterable: true,
                template: "shared:documentLinkCell"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "buSubjectName",
                name: "Firma"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "id",
                name: "-",
                template: "ancestor:actions",
                orderable: false,
                filterable: false,
                interactiveOnly: true
            })
        ];
    }
    // @ts-ignore
    openEditor(id) {}
    getListData(forExport) {
        return (0, $ffuEw.UiDms).instance.cl.allOrgProjects({
            ...this.filter,
            fulltext: this.ui.cFulltext.value
        }, this.orderBy, forExport ? 0 : this.muNamedWidget.pager.currentItemFrom, forExport ? null : this.muNamedWidget.pager.itemPerPage);
    }
    openFilter(field) {
        const filter = this.muParent.openInModal("UiDmsOrgProjectsFilter", "Nastavit filtr", {
            muParent: this
        });
        return filter;
    }
    constructor(...args){
        super(...args);
        this.contractFilter = "";
    }
}
class $29eb4026bc03b70d$export$77d0eb6ed540c74f extends (0, $dMN2n.MuWidget) {
    render(id, row) {
        this.id = id;
        this.row = row;
    }
    bDocuments_click() {
        const listPreview = (0, $ffuEw.UiDms).instance.openInModal("UiDocumentListPreview", "...");
        listPreview.showFor("OrgProject", this.id, this.row);
    }
}
class $29eb4026bc03b70d$export$c9fe1f417ccd0f0e extends (0, $fQex0.BaseFilter // MuWidget<UiBuSubjects>
) {
    beforeIndex() {
        this.muAppendContent(`
			<div mu-id="searchFields">` + (0, $9QECq.formGroup)("name", "N\xe1zev", `<input type="text" mu-bind="name" class="form-control" />`, true) + (0, $9QECq.formGroup)("code", "K\xf3d", `<input type="text" mu-bind="K\xf3d" class="form-control" />`, true) + (0, $9QECq.formGroup)("orgDivision", "St\u0159edisko", `<div mu-widget="TreeSelector" mu-id="orgDivision" mu-bind="orgDivision" mu-params='{"inModal":true,"multiple":true,"useModalClass":false}'></div>`, true) + `</div>
			<div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zru\u{161}it filtr</span>
			</div>
		`);
    }
    async afterIndex() {
        super.afterIndex();
        this.muNamedWidget.orgDivision.bindTree(await (0, $ffuEw.UiDms).instance.cpOrgDivision.fetch());
    }
    static filtredFields(filterData) {
        return Object.keys(filterData).filter((f)=>{
            const v = filterData[f];
            if (Array.isArray(v)) return v.length > 0;
            else return !!v;
        });
    }
}

});

parcelRegister("1OGiK", function(module, exports) {

$parcel$export(module.exports, "UiNewDocumentAttach", () => $afeb821a5d2bde18$export$7859be345380a4dd);

var $dMN2n = parcelRequire("dMN2n");
class $afeb821a5d2bde18$export$7859be345380a4dd extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        super.beforeIndex();
        this.muAppendContent(`
			<div mu-id="documentEditor" mu-widget="UiDmsDocumentEditor"></div>
			<div mu-id="attaches" mu-widget="UiDmsAttaches" mu-params='{"inCreateForm":true}'></div>
			<!-- div class="buttons">
				<span class="btn btn-primary">Vytvo\u{159}it dokument</span>
			</div -->
		`);
    }
    afterIndex() {
        this.savedPromise = Promise.all([
            this.muNamedWidget.documentEditor.savedPromise,
            this.muNamedWidget.attaches.newSavedPromise()
        ]);
        this.muNamedWidget.documentEditor.savedPromise.then((entity)=>{
            this.muNamedWidget.attaches.dmsDocumentId = entity.id; //todo id vytvořeného dokumentu
            this.muNamedWidget.attaches.doSaveAttaches();
        });
    }
    async muBindData(srcData) {
        await this.muNamedWidget.documentEditor.muBindData(srcData);
    }
    async loadItem(id) {
        return this.muNamedWidget.documentEditor.loadItem(id);
    }
    documentEditor_dmsDocumentTypeChange(ev, dmsDocumentType) {
        this.muNamedWidget.attaches.showForDmsDocument({
            dmsDocumentTypeId: dmsDocumentType,
            id: 0
        });
        this.container.appendChild(this.muNamedWidget.documentEditor.ui.pButtons);
    }
}

});

parcelRegister("f69Td", function(module, exports) {

$parcel$export(module.exports, "ProcDataField", () => $5e76b53ec1f99d94$export$1ab0bb891926bbd5);

var $dMN2n = parcelRequire("dMN2n");
class $5e76b53ec1f99d94$export$1ab0bb891926bbd5 extends (0, $dMN2n.MuWidget) {
    afterIndex() {}
    checkAllPackets(ev, part) {
        this.ui["packets-" + part].querySelectorAll("[data-packet-is-complete]").forEach(function(el) {
            el.checked = true;
        });
    }
    switchDetails(ev, part) {
        this.ui[part].classList.toggle("details-visible");
    }
}

});

parcelRegister("6cIq5", function(module, exports) {

$parcel$export(module.exports, "UiProjectImport", () => $d141b10e9cafb708$export$4e9c0e00c477914f);

var $4pyNk = parcelRequire("4pyNk");

var $kwZWC = parcelRequire("kwZWC");

var $bxsP3 = parcelRequire("bxsP3");

var $3cBch = parcelRequire("3cBch");
class $d141b10e9cafb708$export$4e9c0e00c477914f extends (0, $4pyNk.BaseWidget) {
    beforeIndex() {
        this.cl = new (0, $bxsP3.DmsCL)(this.clUrl);
        this.container.classList.add("project-import");
        this.muAppendContent(`
			<div class="project-import__src-data" mu-id="pSrcData">
				<div class="row form-group">
					<label class="col-md-3">Firma:</label>
					<div class="col-md-9">
						<div mu-widget="UiRadioList" mu-id="buSubject" class="checkbox"></div>
					</div>
				</div>
				<div class="form-group">
					<label mu-for="srcData">Zdrojov\xe1 data:</label>
					<textarea mu-id="srcData" placeholder="Sem zkop\xedrujte zdrojov\xe1 data" class="form-control"></textarea>
				</div>
				<div class="buttons"><span class="btn btn-primary" mu-id="bCheck">Zkontrolovat</span></div>
			</div>
			<div mu-id="pPreview">
				<h2 class="_icon-before-warning _icon-before--autosize">V\xfdsledek kontroly: <span mu-id="checkResult"></span></h2>
				<div class="buttons">
					<span class="btn btn-primary" mu-id="bImport">Importovat</span>
					<span class="btn btn-default" mu-id="bBack">Zp\u{11B}t</span>
				</div>
				<ul mu-bind="messages:@foreach">
					<li mu-template="item" mu-widget=".">
						<code mu-bind="cellCode"></code>
						<span mu-bind="message;type:className"></span>
					</li>
				</ul>
			</div>
			<div>
				<h2>\u{160}ablona importn\xedho souboru</h2>
				<span class="a icon-before-copy" mu-id="bCopy">Zkop\xedrovat</span>
				<table class="table" mu-id="exampleTable">
					<tr>
						<th>K\xf3d</th>
						<th>N\xe1zev</th>
						<th>K\xf3d st\u{159}ediska</th>
						<th>St\u{159}edisko</th>
						<th>Obchodn\xed mana\u{17E}er NWT</th>
						<th>Projektov\xfd mana\u{17E}er NWT</th>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
				</table>
			</div>
		`);
    }
    async afterIndex() {
        this.setMode("srcData");
        this.muNamedWidget.buSubject.bindItems((await this.cl.getMyBuSubjects()).write.map((bsu)=>({
                id: bsu.id,
                title: bsu.name
            })));
    }
    async bCheck_click() {
        const buSubjectId = this.muNamedWidget.buSubject.value;
        if (buSubjectId == null) {
            (0, $3cBch.UiFlashMessage).instance.add("Vyberte firmu");
            return;
        }
        if (!this.ui.srcData.value) {
            (0, $3cBch.UiFlashMessage).instance.add("Zadejte zdrojov\xe1 data");
            return;
        }
        const data = await this.cl.checkProjectsImport(this.ui.srcData.value, parseInt(buSubjectId));
        this.muBindData(data);
        this.setMode("preview");
        this.muVisible(data.status !== "error", "bImport");
        this.lastStatus = data.status;
        const resMsg = {
            ok: "v po\u0159\xe1dku",
            warning: "drobn\xe9 chyby",
            error: "v\xe1\u017En\xe9 chyby"
        };
        this.ui.checkResult.innerText = resMsg[this.lastStatus];
    }
    async bImport_click() {
        if (this.lastStatus === "ok" || confirm("V importu jsou drobn\xe9 chyby, chcete p\u0159esto naiportovat?")) {
            const buSubjectId = this.muNamedWidget.buSubject.value;
            // @ts-ignore
            await this.cl.projectsImport(this.ui.srcData.value, parseInt(buSubjectId));
            (0, $3cBch.UiFlashMessage).instance.add("Naimportov\xe1no");
        }
    }
    bBack_click() {
        this.setMode("srcData");
    }
    bCopy_click() {
        (0, $kwZWC.copyToClipoard)(this.ui.exampleTable.outerHTML, "html");
    }
    setMode(mode) {
        this.muVisible(mode == "preview", [
            "pPreview",
            "!pSrcData"
        ]);
    }
    constructor(...args){
        super(...args);
        this.lastStatus = "ok";
    }
}

});

parcelRegister("ekS8C", function(module, exports) {

$parcel$export(module.exports, "UiTodoButton", () => $2540789e3fd6f7b6$export$172d0cd9598ca38a);
$parcel$export(module.exports, "UiTodoDialog", () => $2540789e3fd6f7b6$export$7ea9db6de7caebd6);
$parcel$export(module.exports, "UiTodoEditor", () => $2540789e3fd6f7b6$export$c899ef21a53c5d27);
$parcel$export(module.exports, "UiTodoList", () => $2540789e3fd6f7b6$export$600f0fd44e3ed998);
$parcel$export(module.exports, "UiTodoListItem", () => $2540789e3fd6f7b6$export$1d90768dc5705866);
$parcel$export(module.exports, "UiTodoPage", () => $2540789e3fd6f7b6$export$4c327ddfa538197e);
$parcel$export(module.exports, "UiTodoFilter", () => $2540789e3fd6f7b6$export$b1ea832310772466);
$parcel$export(module.exports, "UiTodoFilterPreset", () => $2540789e3fd6f7b6$export$863cef89235f8d25);

var $dMN2n = parcelRequire("dMN2n");

var $1qZOm = parcelRequire("1qZOm");

var $bjpdy = parcelRequire("bjpdy");
function $2540789e3fd6f7b6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2540789e3fd6f7b6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2540789e3fd6f7b6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2540789e3fd6f7b6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2540789e3fd6f7b6$var$_arrayLikeToArray(o, minLen);
}
function $2540789e3fd6f7b6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $2540789e3fd6f7b6$export$172d0cd9598ca38a extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.cl = new (0, $1qZOm.TodoCL)();
    }
    beforeIndex() {
        this.muAppendContent(`
			<span class="icon-todo cursor-pointer" mu-id="bOpenTodoFor"></span>
			<div mu-widget="UiTodoDialog" mu-template="todoDialog"></div>
		`);
    }
    bOpenTodoFor_click() {
        this.muWidgetFromTemplate("todoDialog", (0, $dMN2n.MuWidget).root.ui.modals, {
            oid: this.oid,
            cl: this.cl
        });
    }
}
class $2540789e3fd6f7b6$export$7ea9db6de7caebd6 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`<div class="modal-i">
			<div class="modal-title">
				<h2>Seznam pozn\xe1mek</h2>
				<span class="close" mu-id="btCloseModal" mu-click="muRemoveSelf">\xd7</span>
			</div>
			<div mu-id="editor" mu-widget="UiTodoEditor"></div>
			<h3>Existuj\xedc\xed pozn\xe1mky</h3>
			<div mu-id="list" mu-widget="UiTodoList"></div>
		</div>`);
    }
    afterIndex() {
        this.muNamedWidget.editor.oid = this.oid;
        this.muNamedWidget.editor.cl = this.cl;
        this.muNamedWidget.list.oid = this.oid;
        this.muNamedWidget.list.cl = this.cl;
    }
    async list_archive(ev, id) {
        await this.cl.archiveTodoItem(id);
        this.muNamedWidget.list.reload();
    }
    async list_edit(ev, id) {
        this.muNamedWidget.editor.bindItem((await this.cl.getTodoItemById(id)).entity);
    }
    async editor_saved() {
        this.muNamedWidget.list.reload();
        this.muNamedWidget.editor.bindItem(null);
    }
}
class $2540789e3fd6f7b6$export$c899ef21a53c5d27 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<h3 mu-id="title"></h3>
			<div class="form-group row">
				<label class="col-md-3" mu-for="summary">Souhrn</label>
				<div class="col-md-9">
					<input type="text" class="form-control" mu-bind="summary" />
				</div>
			</div>
			<div class="form-group row">
				<label class="col-md-3" mu-for="note">Pozn\xe1mka</label>
				<div class="col-md-9">
					<textarea class="form-control" mu-bind="note"></textarea>
				</div>
			</div>
			<div class="form-group row">
				<label class="col-md-3" mu-for="calItemDt">Datum a \u{10D}as</label>
				<div class="col-md-4">
					<input class="form-control" mu-bind="calItemDt|dateToInput::value" mu-id="calItemDt" type="datetime-local" />
				</div>
				<div class="col-md-5 text-center">` + this.presetDtAdd.map((pr)=>'<span class="a" mu-click="addDtDuration: ' + pr.duration + '">' + pr.label + "</span>").join(" ") + `</div>
			</div>
			<div class="form-group row">
				<label class="col-md-3" mu-for="calItemDt">\u{160}t\xedtky</label>
				<div class="col-md-9">
					<div mu-widget="UiTomSelect" mu-bind="tags" mu-id="tags"></div>
				</div>
			</div>
			<div>
				<span class="btn btn-primary" mu-id="bSave">Ulo\u{17E}it</span>
				<span class="btn btn-primary" mu-id="bCancel">Zav\u{159}\xedt bez ulo\u{17E}en\xed</span>
				<span class="btn btn-primary" mu-id="bArchive">Archivovat</span>
			</div>
		`);
        this.muRegisterEvent("saved");
    }
    afterIndex() {
        this.muParent.muOnAfterIndex.push(async ()=>{
            const tagsClt = this.muNamedWidget.tags;
            tagsClt.labelField = "name";
            tagsClt.valueField = "id";
            tagsClt.canCreate = true;
            tagsClt.multiple = true;
            tagsClt.init();
            tagsClt.bindItems((await this.cl.getMyTags()).entityList);
            this.bindItem(null);
        });
    }
    addDtDuration(ev, duration) {
        let dt = this.ui.calItemDt.value ? new Date(this.ui.calItemDt.value) : new Date();
        if (duration) dt.setHours(dt.getHours() + duration);
        else dt = null;
        this.ui.calItemDt.value = dt ? (0, $bjpdy.MuBinder).filters.dateToInput(dt) : "";
    }
    bindItem(data) {
        this.ui.title.innerText = data ? "Upravit pozn\xe1mku" : "P\u0159idat pozn\xe1mku";
        this.muVisible(!!data || !!this.oid, this.container);
        data = data || {
            note: "",
            calItemDt: "",
            tags: [],
            id: null,
            summary: ""
        };
        this.id = data.id;
        this.muBindData(data);
        this.muVisible(!!data.id, [
            "bCancel",
            "bArchive"
        ]);
    }
    async bSave_click() {
        const data = this.muFetchData();
        const res = this.id ? await this.cl.updateTodoItem(data, this.id) : await this.cl.createTodoItem(data, this.oid);
        this.muDispatchEvent("saved", res);
    }
    bCancel_click() {
        this.bindItem(null);
    }
    async bArchive_click() {
        if (this.id) await await this.cl.archiveTodoItem(this.id);
        this.muDispatchEvent("saved", null);
    }
    constructor(...args){
        super(...args);
        this.presetDtAdd = [
            {
                duration: 24,
                label: "+1 den"
            },
            {
                duration: 48,
                label: "+2 dny"
            },
            {
                duration: 168,
                label: "+ t\xfdden"
            },
            {
                duration: 720,
                label: "+ m\u011Bs\xedc"
            },
            {
                duration: null,
                label: "Bez term\xednu"
            }
        ];
    }
}
class $2540789e3fd6f7b6$export$600f0fd44e3ed998 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
		<div class="todo-list" mu-id="list" mu-bind="list:@foreach">
			<div class="todo-list__item" mu-widget="UiTodoListItem" mu-template="item"></div>
		</div>
		`);
        this.muRegisterEvent("edit", "archive");
    }
    afterIndex() {
        this.muParent.muOnAfterIndex.push(async ()=>this.reload());
    }
    async reload(filter) {
        const data = await this.cl.findTodoItemsBy(filter || {
            oid: this.oid
        }, false);
        this.muBindData({
            list: data.entityList
        });
    }
    archiveItem(id) {
        this.muDispatchEvent("archive", id);
    }
    editItem(id) {
        this.muDispatchEvent("edit", id);
    }
}
class $2540789e3fd6f7b6$export$1d90768dc5705866 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="display-flex">
				<h4 mu-bind="summary" class="flex-grow-1"></h4>
				<a mu-bind="targetLink:href;targetName" class="flex-grow-1"></a>
				<div mu-bind='dtCreated|dateTime("d.m.Y H:i")'></div>
			</div>
			<div mu-bind="note"></div>
			<div mu-bind="dt"></div>
			<div class="display-flex">
				<div mu-bind="tagNames:@foreach" class="flex-grow-1">
					<span class="label label-default" mu-template="item" mu-widget="."><span mu-bind="name"></span></span>
				</div>
				<span mu-bind="calItemDt|dateTime;calItemDt:@visible" class="icon-before-calendar"></span>
				<div>
					<span class="btn btn-primary"><span mu-id="bEdit" class="icon-before-edit">Upravit</span></span>
					<span class="btn btn-warning"><span mu-id="bArchive" class="icon-before-archive">Archivovat</span></span>
				</div>
			</div>
		`);
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        this.id = srcData.id;
    }
    bEdit_click() {
        this.muParent.editItem(this.id);
    }
    bArchive_click() {
        this.muParent.archiveItem(this.id);
    }
}
class $2540789e3fd6f7b6$export$4c327ddfa538197e extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`<h3>Pozn\xe1mky</h3>
			<div mu-id="editor" mu-widget="UiTodoEditor"></div>
			<div mu-id="filter" mu-widget="UiTodoFilter"></div>
			<div class="row">
				<div class="col-md-3" >
					<div mu-id="filterPresets" mu-bind="filterPresets:@foreach" class="list-group">
						<span mu-template="item" mu-widget="UiTodoFilterPreset" class="list-group-item a "></span>
					</div>
				</div>
				<div mu-id="list" mu-widget="UiTodoList" class="col-md-9"></div>
			</div>
		`);
    }
    afterIndex() {
        this.cl = new (0, $1qZOm.TodoCL)();
        this.muNamedWidget.editor.cl = this.cl;
        this.muNamedWidget.list.cl = this.cl;
        this.bindFilterPresets();
    }
    async list_archive(ev, id) {
        await this.cl.archiveTodoItem(id);
        this.muNamedWidget.list.reload();
    }
    async list_edit(ev, id) {
        this.muNamedWidget.editor.bindItem((await this.cl.getTodoItemById(id)).entity);
    }
    async editor_saved() {
        this.muNamedWidget.list.reload();
        this.muNamedWidget.editor.bindItem(null);
    }
    async bindFilterPresets() {
        const nowTime = (h, m, s)=>{
            const dt = new Date();
            dt.setHours(h, m, s);
            return dt;
        };
        const presets = [];
        for(var _i2 = 0, _arr = [
            [
                "Dnes",
                nowTime(0, 0, 0),
                nowTime(23, 59, 59)
            ],
            [
                "Zitra",
                nowTime(24, 0, 0),
                nowTime(47, 59, 59)
            ],
            [
                "Dal\u0161\xedch 7 dn\u016F",
                nowTime(0, 0, 0),
                nowTime(144, 59, 59)
            ]
        ]; _i2 < _arr.length; _i2++){
            const _i = _arr[_i2];
            let name, calItemDtFrom, calItemDtTo;
            [name, calItemDtFrom, calItemDtTo] = _i;
            presets.push({
                name: name,
                filter: {
                    calItemDtFrom: calItemDtFrom,
                    calItemDtTo: calItemDtTo,
                    tags: []
                }
            });
        }
        for(var _iterator = $2540789e3fd6f7b6$var$_createForOfIteratorHelperLoose((await this.cl.getMyTags()).entityList), _step; !(_step = _iterator()).done;){
            const tag = _step.value;
            presets.push({
                name: tag.name,
                filter: {
                    tags: [
                        tag.id
                    ],
                    calItemDtFrom: null,
                    calItemDtTo: null
                }
            });
        }
        this.muBindData({
            filterPresets: presets
        });
    }
    async setFilter(filter) {
        this.muNamedWidget.filter.muBindData(filter);
        this.muNamedWidget.filter.bSearch_click();
    }
}
class $2540789e3fd6f7b6$export$b1ea832310772466 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="display-flex flex-items-grow-1">
				<span class="flex-grow-0">\u{160}t\xedtek</span>
				<div mu-widget="UiTomSelect" mu-id="tags" mu-bind="tags"></div>
				<span class="flex-grow-0">Datum od</span>
				<input type="datetime-local" class="form-control flex-grow-0" mu-bind="calItemDtFrom|dateToInput" style="width: 20ex" />
				<span class="flex-grow-0">do</span>
				<input type="datetime-local" class="form-control flex-grow-0" mu-bind="calItemDtTo|dateToInput" style="width: 20ex" />
			</div>
			<div class="display-flex">
				<input type="search" class="form-control flex-grow-1" mu-bind="fulltext" />
				<span class="btn btn-link icon-before-search" mu-id="bSearch">Vyhledat</span>
			</div>
		`);
    }
    afterIndex() {
        $2540789e3fd6f7b6$var$setupTagSelector(this.muNamedWidget.tags);
    }
    bSearch_click() {
        this.muParent.muNamedWidget.list.reload(this.muFetchData());
    }
}
class $2540789e3fd6f7b6$export$863cef89235f8d25 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`<span mu-bind="name"></span>`);
    // this.muRegisterEvent('selected');
    }
    container_click() {
        // this.muDispatchEvent("selected", this.filterSetting)
        this.muParent.setFilter(this.filterSetting);
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        this.filterSetting = srcData.filter;
    }
}
async function $2540789e3fd6f7b6$var$setupTagSelector(tomSelect) {
    tomSelect.labelField = "name";
    tomSelect.valueField = "id";
    tomSelect.canCreate = true;
    tomSelect.multiple = true;
    tomSelect.init();
    tomSelect.bindItems((await new (0, $1qZOm.TodoCL)().getMyTags()).entityList);
}

});
parcelRegister("1qZOm", function(module, exports) {

$parcel$export(module.exports, "TodoCL", () => $2799efbc84ae44cc$export$572e6116cab4c47f);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $2799efbc84ae44cc$export$572e6116cab4c47f extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/todo"){
        super(url);
    }
    createTodoItem(data, oid) {
        return this.callMethod("createTodoItem", arguments, {
            "rawResult": false
        });
    }
    updateTodoItem(data, id) {
        return this.callMethod("updateTodoItem", arguments, {
            "rawResult": false
        });
    }
    archiveTodoItem(id) {
        return this.callMethod("archiveTodoItem", arguments, {
            "rawResult": false
        });
    }
    getTodoItemById(id) {
        return this.callMethod("getTodoItemById", arguments, {
            "rawResult": false
        });
    }
    findTodoItemsBy(filter, archived = false) {
        return this.callMethod("findTodoItemsBy", arguments, {
            "rawResult": false
        });
    }
    getMyTags() {
        return this.callMethod("getMyTags", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("7tZdD", function(module, exports) {

$parcel$export(module.exports, "UiComment", () => $b36e3b269a35cfa8$export$15e5be7a18bb203f);
$parcel$export(module.exports, "UiCommentsNewItem", () => $b36e3b269a35cfa8$export$5d04ea2a906af6c2);

var $dMN2n = parcelRequire("dMN2n");

var $lfGOk = parcelRequire("lfGOk");

var $kwZWC = parcelRequire("kwZWC");
function $b36e3b269a35cfa8$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b36e3b269a35cfa8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b36e3b269a35cfa8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b36e3b269a35cfa8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b36e3b269a35cfa8$var$_arrayLikeToArray(o, minLen);
}
function $b36e3b269a35cfa8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $b36e3b269a35cfa8$export$15e5be7a18bb203f extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.container.classList.add("comment-items");
        // this.muVisible(!this.isRoot, '.');
        this.muAppendContent(`
			<div class="comment-items__title grid-column-s2" mu-id="title">
				<span>
					<strong mu-bind="accountName" mu-id="accountName"></strong> 
					<em mu-bind="commentTypeName"></em>
				</span>
				<span>
					<strong mu-bind="dtAdd|dateTime"></strong>
					<a href="" mu-bind='id|prepend("#comment-"):href' title="Odkaz na tento koment\xe1\u{159}">#</a>
				</span>			
			</div>
			<div class="comment-items__content grid-column-s2" mu-bind="content:innerHTML" mu-id="content"></div>
			<div class="comment-items__editor grid-column-s2" mu-bind="" mu-widget="Htmlarea" mu-id="contentEditor"></div>
			<div>
				<div mu-widget="UiRadioList" mu-id="commentType"></div>
			</div>
			<div class="comment-items__buttons" mu-id="pButtons">
				<span mu-id="bAdd" class="btn-icon btn-icon-size-3 icon-before-add">P\u{159}idat</span>
				<span mu-id="bEdit" class="btn-icon btn-icon-size-3 icon-before-edit">Upravit</span>
				<span mu-id="bCreate" class="btn-icon btn-icon-size-3 icon-before-add">Vytvo\u{159}it</span>
				<span mu-id="bSave" class="btn-icon btn-icon-size-3 icon-before-ok">Ulo\u{17E}it</span>
				<span mu-id="bCancel" class="btn-icon btn-icon-size-3 icon-before-cancel">Storno</span>
			</div>
			<!-- <div class="create-buttons" mu-id="createButtons">
				<span class="icon-before-edit a" mu-id="bEdit" mu-bind="editable:@visible">Upravit</span>
				<strong mu-bind="newTypes:@visible">P\u{159}idat: </strong>
				<span mu-bind="newTypes:@foreach">
					<span mu-template="newItemBtn" mu-widget="UiCommentsNewItem" class="a icon-before-comment"></span>
				</span> 
			</div> -->
			<div class="comment-items__items grid-column-s2" mu-id="comments" mu-bind="comments:@foreach">
				<div mu-template="commentItem" mu-widget="UiComment"></div>
			</div>`);
    }
    afterIndex() {
        if (this.loadId) this.reloadComments();
        // this.setEditing(false);
        /* if (!(this.muParent instanceof UiComment))
    	this.muVisible(false, '.'); */ this.setMode("view");
    }
    muAfterBindData(data) {
        this.id = data.id;
        this.editable = data.editable;
        this.setMode("view");
    }
    setEditing() {}
    reloadComments() {
        // @ts-ignore
        return this.loadComments(this.loadId);
    }
    async loadComments(id) {
        // const editing : Record<number, string>
        this.loadId = id;
        // @ts-ignore
        const res = await this.cl.withMessage("Na\u010D\xedt\xe1m koment\xe1\u0159e", this.container).getCommentFor("ticket", id);
        const commentsByParent = {};
        const mapContentTypeCreate = (ids)=>ids.filter((ctid)=>res.allowCreate.includes(ctid) || res.allowCreate.includes(null)).map((ctid)=>res.commentTypes[ctid]);
        for(var _iterator = $b36e3b269a35cfa8$var$_createForOfIteratorHelperLoose(res.comments), _step; !(_step = _iterator()).done;){
            const comment = _step.value;
            const pid = comment.parentId || 0;
            const node = commentsByParent[pid] || (commentsByParent[pid] = []);
            node.push(comment);
        }
        for(var _iterator2 = $b36e3b269a35cfa8$var$_createForOfIteratorHelperLoose(res.comments), _step2; !(_step2 = _iterator2()).done;){
            const comment = _step2.value;
            comment.commentTypeName = comment.commentType.name;
            comment.newTypes = mapContentTypeCreate(res.commentTypeByParent[comment.commentTypeId] || []);
            comment.accountName = comment.account.name;
            comment.comments = commentsByParent[comment.id] || [];
        }
        this.muBindData({
            comments: commentsByParent[0] || [],
            newTypes: mapContentTypeCreate(res.commentTypeByParent[0] || [])
        });
        this.bAdd_click(null);
    /* this.muVisible(true, '.');
    	// drobné úpravy vzhledu
    /* this.muVisible(false, 'bEdit');
    const pel = this.ui.createButtons.parentElement;
    pel.removeChild(this.ui.createButtons);
    pel.appendChild(this.ui.createButtons);
    this.muVisible(false, 'info');
    this.isRoot = true; */ }
    getRootComment() {
        return this.isRoot ? this : this.muParent.getRootComment();
    }
    /* newSubItem(contentTypeId: any) {
  	const wComment = this.muWidgetFromTemplate("commentItem", "comments") as unknown as UiComment;
  	wComment.muBindData({
  		id: null,
  		accountName: "Přidat",
  	});
  	wComment.commentTypeId = contentTypeId;
  	// wComment.setEditing();
  } */ bAdd_click(ev) {
        const wComment = this.muWidgetFromTemplate("commentItem", "comments");
        wComment.muBindData({
            id: null
        });
        wComment.commentTypeId = 1;
        wComment.setMode("new");
        if (ev) (async ()=>{
            await (0, $kwZWC.sleepPromise)(10);
            this.muNamedWidget.contentEditor.focus();
        })();
    }
    /* public setEditing(editing: boolean = true) {
  	this.muVisible(editing, [
  		'!content',
  		'contentEditor',
  		'cBSave',
  		'!createButtons',
  	]);
  	if (editing) (this.muNamedWidget.contentEditor as unknown as Htmlarea).focus();
  } */ setMode(newMode) {
        this.muVisible(newMode === "new", [
            "bCreate"
        ]);
        this.muVisible([
            "new",
            "edit"
        ].includes(newMode), [
            "bCancel",
            "contentEditor"
        ]);
        this.muVisible(newMode === "view", [
            "bAdd",
            "content"
        ]);
        this.muVisible(newMode === "view" && (this.editable || false) && !this.isRoot, "bEdit");
        this.muVisible(newMode === "new", "bCreate");
        this.muVisible(newMode === "edit", "bSave");
        this.muVisible(!this.isRoot, "title");
        if (newMode === "new") this.ui.accountName.innerText = "Nov\xfd koment\xe1\u0159";
        this.ui.bAdd.innerText = this.isRoot ? "P\u0159idat koment\xe1\u0159" : "Odpov\u011Bd\u011Bt";
    }
    bCancel_click() {
        this.setMode("view");
        if (!this.id) this.muRemoveSelf();
    }
    async bEdit_click() {
        const comment = await this.cl.getComment(this.id);
        if (comment) {
            this.muNamedWidget.contentEditor.muBindData(comment.content);
            this.setMode("edit");
        }
    }
    async bSave_click() {
        const content = this.muNamedWidget.contentEditor.muFetchData();
        const rootComment = this.getRootComment();
        const data = this.id ? {
            content: content
        } : {
            content: content,
            ticketId: rootComment.loadId,
            commentTypeId: this.commentTypeId,
            parentId: this.muParent.id
        };
        // @ts-ignore
        await this.cl.withMessage("Ukl\xe1d\xe1m koment\xe1\u0159").saveComment(this.id, data);
        this.setMode("view");
        rootComment.reloadComments();
    }
    async bCreate_click() {
        const content = this.muNamedWidget.contentEditor.muFetchData();
        const rootComment = this.getRootComment();
        const data = this.id ? {
            content: content
        } : {
            content: content,
            ticketId: rootComment.loadId,
            commentTypeId: this.commentTypeId,
            parentId: this.muParent.id
        };
        // @ts-ignore
        await this.cl.withMessage("Ukl\xe1d\xe1m koment\xe1\u0159").saveComment(null, data);
        this.setEditing(false);
        rootComment.reloadComments();
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $lfGOk.CommentsCL)();
        this.loadId = null;
        this.commentTypeId = 1;
        this.id = 0;
        this.isRoot = false;
        this.editable = false;
        this.mode = "root";
    }
}
class $b36e3b269a35cfa8$export$5d04ea2a906af6c2 extends (0, $dMN2n.MuWidget) {
    muBindData(src) {
        this.container.innerText = src.name;
        this.id = src.id;
    }
    container_click() {
        this.muParent.newSubItem(this.id);
    }
}

});
parcelRegister("lfGOk", function(module, exports) {

$parcel$export(module.exports, "CommentsCL", () => $e22ad108e0b91cb5$export$fd99d74a37719513);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $e22ad108e0b91cb5$export$fd99d74a37719513 extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/comments"){
        super(url);
    }
    getCommentFor(entity, entityId) {
        return this.callMethod("getCommentFor", arguments, {
            "rawResult": false
        });
    }
    getComment(id) {
        return this.callMethod("getComment", arguments, {
            "rawResult": false
        });
    }
    saveComment(id, data) {
        return this.callMethod("saveComment", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("3uYki", function(module, exports) {

$parcel$export(module.exports, "BaseTO", () => $635f89b0e833d98a$export$58d619dade06514f);
$parcel$export(module.exports, "TOInvoiceApprovingSubProfileItem", () => $635f89b0e833d98a$export$58f7a9d914c4795f);

var $6Taw3 = parcelRequire("6Taw3");

var $iSpsO = parcelRequire("iSpsO");

var $dMN2n = parcelRequire("dMN2n");

var $fnX8e = parcelRequire("fnX8e");

var $d9JXN = parcelRequire("d9JXN");

var $cLxj2 = parcelRequire("cLxj2");

var $kwZWC = parcelRequire("kwZWC");
class $635f89b0e833d98a$export$58d619dade06514f extends (0, $6Taw3.BaseMuWidget) {
    afterIndex() {
        this.setPageTitle(this.profile.name);
    }
    htmlNavSubprofiles(btnAdd = false) {
        return `<div class="display-flex">` + (btnAdd ? '<span class="icon-before-add icon-above a p1" mu="bAdd">P\u0159idat</span>' : "") + `<ul class="bcm-nav-tabs" mu-id="subProfiles">
				<li mu-widget="TOInvoiceApprovingSubProfileItem" mu-template="subProfilesItem"><a mu-id="btn">
					<span mu-id="name"></span>
					<span class="badge" mu-id="count"></span>
				</a></li>
			</ul>
		</div>`;
    }
    htmlToolbar(btnFilter = true, btnSwitchLayout = false, dateRange = false) {
        return `<div class="toolbar" mu="toolbar">` + (btnSwitchLayout ? '<span class="btn btn-icon icon-before-switch-columns" mu-id="bSwitchLayout"></span>' : "") + `<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>` + (dateRange ? ' od <input type="date" mu="cDateFrom"> do <input type="date" mu="cDateTo">' : "") + (btnFilter ? '<span class="btn btn-link icon-before-filter" mu-id="bFilter">Filtrovat <span mu-id="filterCount" class="badge"></span></span>' : "") + `<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zru\u{161}it filtr</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>`;
    }
    setupRouter() {
        this.router = new (0, $d9JXN.BaseRouter)();
        this.router.pathPrefix = "/ticket/overview/" + this.profile.code;
        this.router.persistentKeys = [
            "subprofile"
        ];
        const findSubProfile = async (id)=>(await this.subprofiles.fetch()).find((sp)=>sp.id === id);
        this.router.addRoute("ticket", "/<subprofile>/<ticketId>", async (rc)=>{
            this.activateSubProfile(await findSubProfile(rc.parameters.subprofile), false);
            this.loadTicket(parseInt(rc.parameters.ticketId));
        });
        this.router.addRoute("overview", "/<subprofile>", async (rc)=>this.activateSubProfile(await findSubProfile(rc.parameters.subprofile), true));
        this.router.addRoute("root", "", async (rc)=>this.activateSubProfile((await this.subprofiles.fetch())[0], true));
    }
    setupSubProfiles(subProfiles) {
        for(var _i = 0, _subProfiles = subProfiles; _i < _subProfiles.length; _i++){
            const subProfile = _subProfiles[_i];
            this.muWidgetFromTemplate("subProfilesItem", "subProfiles", {
                ...subProfile,
                subProfile: subProfile
            });
        }
    }
    activateSubProfile(subProfile, loadFirst) {
        this.currentSubProfile = subProfile;
        this.muGetChildWidgets("subProfiles").forEach((iw)=>iw.setActiveIf(subProfile.id));
        //@ts-ignore
        this.ui.overviewItems.className = `layout-${this.overviewLayoutPrefix}default layout-${this.overviewLayoutPrefix}${subProfile.id}`;
        // this.router!.pushUpdate('overview', { subprofile: subProfile.id });
        this.router.updatePersistent({
            subprofile: subProfile.id
        }, true);
        this.loadList(loadFirst);
        if (this.ui.sidePanel) {
            const ticketListSize = subProfile.ticketListSize ?? this.ticketListSize;
            (0, $kwZWC.changeClassStartsWith)(this.ui.sidePanel.classList, "col-sm-", ticketListSize.toString());
            (0, $kwZWC.changeClassStartsWith)(this.ui.ticketDetail.classList, "col-sm-", (12 - ticketListSize).toString());
        }
    }
    markSelectedTicket() {
        const id = this.currentTicket ? this.currentTicket.id : null;
        this.muGetChildWidgets("overviewItems").forEach((iw)=>iw.setActiveIf(id));
    }
    bFilterErase_click() {
        this.ui.cFulltext.value = "";
        this.setFilter({});
    }
    setFilter(filter) {
        this.filter = filter;
        const activeFieldsCount = (0, $cLxj2.UiBuSubjectsFilter).filtredFields(filter).length;
        this.ui.filterCount.innerText = activeFieldsCount > 0 ? activeFieldsCount.toString() : "";
        this.loadList();
    }
    patchFilter(filter) {
        this.setFilter({
            ...this.filter,
            ...filter
        });
    }
    bFulltextSearch_click() {
        this.loadList();
    }
    bReload_click() {
        this.loadList();
    }
    constructor(...args){
        super(...args);
        this.ticketListSize = 4;
        this.cl = new (0, $iSpsO.TicketOverviewCL)();
        this.filter = {};
        this.subprofiles = new (0, $fnX8e.CachedPromise)(()=>this.cl.getSubProfiles(this.profile.id));
        this.currentTicket = null;
        this.overviewLayoutPrefix = "";
    }
}
class $635f89b0e833d98a$export$58f7a9d914c4795f extends (0, $dMN2n.MuWidget) {
    afterIndex() {
        this.ui.name.innerText = this.name;
        // @ts-ignore
        this.muParent.router.prepareAnchor(this.ui.btn, "overview", {
            subprofile: this.subProfile.id
        });
    }
    /* btn_click() {
  	this.muParent.activateSubProfile(this.subProfile);
  } */ setActiveIf(id) {
        this.container.classList.toggle("active", id === this.id);
    }
    setCount(count) {
        this.ui.count.innerText = count || "";
    }
    constructor(...args){
        super(...args);
        this.name = "";
        this.id = "";
    }
}

});
parcelRegister("iSpsO", function(module, exports) {

$parcel$export(module.exports, "TicketOverviewCL", () => $402d1621338e7099$export$51c705a5aecaebab);
// GENERATED FILE, DO NOT EDIT

var $eieyy = parcelRequire("eieyy");
class $402d1621338e7099$export$51c705a5aecaebab extends (0, $eieyy.MyBaseCL) {
    constructor(url = "/cl/ticketoverview"){
        super(url);
    }
    getSubProfiles(overviewProfileId) {
        return this.callMethod("getSubProfiles", arguments, {
            "rawResult": false
        });
    }
    getSubProfileCounts(overviewProfileId) {
        return this.callMethod("getSubProfileCounts", arguments, {
            "rawResult": false
        });
    }
    getAllInvVendors() {
        return this.callMethod("getAllInvVendors", arguments, {
            "rawResult": false
        });
    }
    getTickets(overviewProfileId, subprofile, userFilter, limitFrom, limitCount) {
        return this.callMethod("getTickets", arguments, {
            "rawResult": false
        });
    }
    getMyBuSubject() {
        return this.callMethod("getMyBuSubject", arguments, {
            "rawResult": false
        });
    }
    getAccountingDocumentTypePairs() {
        return this.callMethod("getAccountingDocumentTypePairs", arguments, {
            "rawResult": false
        });
    }
    getTicketTypePairs(projectCode) {
        return this.callMethod("getTicketTypePairs", arguments, {
            "rawResult": false
        });
    }
    callStateAction(ticketId, code) {
        return this.callMethod("callStateAction", arguments, {
            "rawResult": false
        });
    }
    getTicketMetadata(id) {
        return this.callMethod("getTicketMetadata", arguments, {
            "rawResult": false
        });
    }
    getStartablePqmItems() {
        return this.callMethod("getStartablePqmItems", arguments, {
            "rawResult": false
        });
    }
    getProcData(procDataId) {
        return this.callMethod("getProcData", arguments, {
            "rawResult": false
        });
    }
    findAccounts(term, inSameCompany = false) {
        return this.callMethod("findAccounts", arguments, {
            "rawResult": false
        });
    }
    findOrgRoles(term) {
        return this.callMethod("findOrgRoles", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisionTree() {
        return this.callMethod("getOrgDivisionTree", arguments, {
            "rawResult": false
        });
    }
    getOrgProjects(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgProjects", arguments, {
            "rawResult": false
        });
    }
    getUnderlings(accountId) {
        return this.callMethod("getUnderlings", arguments, {
            "rawResult": false
        });
    }
    searchAccount(fulltext, limit = 100) {
        return this.callMethod("searchAccount", arguments, {
            "rawResult": false
        });
    }
    getAttachDetail(attachId, authByTicketId = null) {
        return this.callMethod("getAttachDetail", arguments, {
            "rawResult": false
        });
    }
    getOrgDivisions(buSubjectId = null, isEnabled = true) {
        return this.callMethod("getOrgDivisions", arguments, {
            "rawResult": false
        });
    }
    getOrgRelatedAccounts(accountId) {
        return this.callMethod("getOrgRelatedAccounts", arguments, {
            "rawResult": false
        });
    }
}

});


parcelRegister("jXacm", function(module, exports) {

$parcel$export(module.exports, "TOInvoiceApproving", () => $a02d6a829b6bc088$export$e5841d2d4a4b7999);

var $3uYki = parcelRequire("3uYki");

var $fnX8e = parcelRequire("fnX8e");

var $cJjA3 = parcelRequire("cJjA3");

var $kwZWC = parcelRequire("kwZWC");

var $3cBch = parcelRequire("3cBch");
function $a02d6a829b6bc088$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a02d6a829b6bc088$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a02d6a829b6bc088$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a02d6a829b6bc088$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a02d6a829b6bc088$var$_arrayLikeToArray(o, minLen);
}
function $a02d6a829b6bc088$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $a02d6a829b6bc088$export$e5841d2d4a4b7999 extends (0, $3uYki.BaseTO) {
    beforeIndex() {
        this.container.classList.add("ticket-overview");
        this.muAppendContent(this.htmlNavSubprofiles() + this.htmlToolbar() + `<div class="row">
				<div class="col-sm-${this.ticketListSize}">
					<table class="ticket-overview__stats" mu-id="stats">
						<tr mu-template="statsTotal" mu-widget="." class="ticket-overview__stats__total">
							<td mu-bind="totalCountLabel"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="buSubject" mu-widget="." class="ticket-overview__stats__bu-subject">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="documentType" mu-widget="." class="ticket-overview__stats__document-type">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="ticketType" mu-widget="." class="ticket-overview__stats__ticket-type">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="accountingType" mu-widget="." class="ticket-overview__stats__accounting-type">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<!-- <dt>\u{10C}\xe1stka bez DPH:</dt><dt class="number" mu-bind="amountNT"></dt>
						<dt>\u{10C}\xe1stka s DPH:</dt><dt class="number" mu-bind="amountWT"></dt>
						<dt>Po\u{10D}et:</dt><dt class="number" mu-bind="count"></dt> -->
					</table>
					<div mu-id="overviewItems" mu-bind="items:@foreach">
						<div mu-template="overviewItem" mu-widget="TOIInvoiceApproving"></div>
					</div>
					<div mu-widget="Pager" mu-id="pager"></div>
				</div>
				<div class="col-sm-${12 - this.ticketListSize}">
					<div mu-id="pTicket">
						<h2 mu-id="ticketLabel" class="ticket-overview__form-label">
							<span class="ticket-overview__form-label__evidence-uid" mu-bind="evidenceUid"></span>
							<span class="ticket-overview__form-label__bu-subject" mu-bind="buSubjectName"></span>
							<span class="ticket-overview__form-label__accounting-document-type" mu-bind="accountingDocumentType"></span>
						</h2>
						<ul class="bcm-nav-tabs">
							<li mu-id="btn_form" mu-click='showTicketPanel: "form"'><a>Detail</a></li>
							<li mu-id="btn_history" mu-click='showTicketPanel: "history"'><a>Historie</a></li>
						</ul>
	
						<div mu-id="form" mu-widget="."></div>
						<div mu-id="history" mu-widget="."></div>
						<div mu-widget="UiComment" mu-id="comments" mu-params='{"isRoot":true}'></div>
					</div>
					<div class="alert-success alert" mu-id="pNoTicket">Tomuto zobrazen\xed neodpov\xedd\xe1 ani jedna polo\u{17E}ka.</div>
				</div>
			</div>
		`);
        this.setupRouter();
    }
    getFormOptions() {
        return this.currentSubProfile.formOptions;
    }
    async updateSubprofileCounts() {
        const counts = await this.cl.getSubProfileCounts(this.profile.id);
        this.muGetChildWidgets("subProfiles").forEach((spw)=>{
            spw.setCount(counts[spw.subProfile.id]);
        });
    }
    async afterIndex() {
        super.afterIndex();
        this.setupSubProfiles(await this.subprofiles.fetch());
        // this.loadList();
        // @ts-ignore
        this.showTicketPanel(null, "form");
        this.router.route();
    }
    invoiceChanges(changes) {
        const res = {};
        changes = (0, $kwZWC.Arrays).unique(changes);
        for(var _i = 0, _changes = changes; _i < _changes.length; _i++){
            const ev = _changes[_i];
            const eva = (this.currentSubProfile.events || {})[ev];
            if (eva) {
                res.action = eva;
                switch(eva){
                    case "reloadNext":
                        this.ticketFormIsChanged = false;
                        this.loadList(true);
                        break;
                    case "reloadSame":
                        this.loadList(false);
                        break;
                }
            }
        }
        return res;
    }
    bFilter_click() {
        this.openInModal("InvoiceApprovingFilter", "Filtr", {
            getFilter: ()=>this.filter,
            setFilter: (filter)=>this.setFilter(filter),
            orgDivisionPromise: this.orgDivisionPromise,
            orgProjectPromise: this.orgProjectPromise,
            orgProductPromise: this.orgProductPromise,
            vendorPromise: this.vendorPromise,
            myBuSubjectPromise: this.myBuSubjectPromise,
            accountingDocumentTypePromise: this.accountingDocumentTypePromise,
            ticketTypePromise: this.ticketTypePromise
        });
    }
    showTicketPanel(ev, panel) {
        for(var _iterator = $a02d6a829b6bc088$var$_createForOfIteratorHelperLoose(this.allTicketPanels), _step; !(_step = _iterator()).done;){
            const k = _step.value;
            this.muVisible(panel === k, k);
            this.ui["btn_" + k].classList.toggle("active", panel === k);
        }
    }
    async loadList(loadNext = true) {
        const data = await this.cl.withMessage("Na\u010D\xedt\xe1m polo\u017Eky").getTickets(this.profile.id, this.currentSubProfile.id, {
            fulltext: this.ui.cFulltext.value,
            ...this.filter
        }, this.muNamedWidget.pager.currentItemFrom ?? 0, this.muNamedWidget.pager.itemPerPage);
        this.muBindData(data);
        await this.showStats(data.stats);
        if (loadNext && !this.isFormChanged()) {
            if (data.items.length) this.loadTicket(data.items[0]);
            else this.noTicket(true);
        }
        this.markSelectedTicket();
        setTimeout(()=>this.updateSubprofileCounts(), 1000);
    }
    async reloadTicketAndList() {
        return Promise.all([
            this.loadList(false),
            this.loadTicket(this.currentTicket.id)
        ]);
    }
    async showStats(stats) {
        // Statistika
        let fullCount = 0;
        let countByBuSubject = {};
        let statsByAdt = {};
        let statsByTT = {};
        const accountingDocumentTypeNames = await this.accountingDocumentTypePairsPromise.fetch();
        const ticketTypeNames = await this.ticketTypePairsPromise.fetch();
        for(var _i2 = 0, _stats = stats; _i2 < _stats.length; _i2++){
            const stat = _stats[_i2];
            fullCount += stat.count;
            countByBuSubject[stat.buSubjectId] = countByBuSubject[stat.buSubjectId] || 0;
            countByBuSubject[stat.buSubjectId] += stat.count;
            if (this.currentSubProfile.groupByAccountingDocumentType) {
                statsByAdt[stat.buSubjectId] = statsByAdt[stat.buSubjectId] || {};
                statsByAdt[stat.buSubjectId][stat.accountDocumentTypeId] = stat.count;
            }
            if (this.currentSubProfile.groupByTicketType) {
                statsByTT[stat.buSubjectId] = statsByTT[stat.buSubjectId] || {};
                statsByTT[stat.buSubjectId][stat.ticketTypeId] = stat.count;
            }
        }
        this.muNamedWidget.pager.setItemCount(fullCount);
        const buSubjectNames = {};
        for(var _iterator2 = $a02d6a829b6bc088$var$_createForOfIteratorHelperLoose(await this.myBuSubjectPromise.fetch()), _step2; !(_step2 = _iterator2()).done;){
            const buSubject = _step2.value;
            buSubjectNames[buSubject.id] = buSubject.name;
        }
        this.ui.stats.innerHTML = "";
        this.muWidgetFromTemplate("statsTotal", "stats").muBindData({
            totalCountLabel: this.currentSubProfile.totalCountLabel,
            count: fullCount
        });
        for(const buSubjectId in countByBuSubject){
            const isActive = this.filter.buSubjectId?.includes(buSubjectId) ?? false;
            const wb = this.muWidgetFromTemplate("buSubject", "stats", {
                container_click: ()=>{
                    this.patchFilter({
                        buSubjectId: isActive ? null : [
                            buSubjectId
                        ]
                    });
                }
            });
            wb.muBindData({
                // u klíče se převede na string
                name: buSubjectId != "null" ? buSubjectNames[buSubjectId] : "nezad\xe1no",
                count: countByBuSubject[buSubjectId]
            });
            wb.container.classList.toggle("active", isActive);
            if (this.currentSubProfile.groupByAccountingDocumentType) for(const accountingDocumentTypeId in statsByAdt[buSubjectId]){
                const isActive = (this.filter.accountingDocumentTypeId?.includes(accountingDocumentTypeId) && this.filter.buSubjectId?.includes(buSubjectId)) ?? false;
                const w = this.muWidgetFromTemplate("accountingType", "stats", {
                    container_click: ()=>{
                        this.patchFilter({
                            accountingDocumentTypeId: isActive ? null : [
                                accountingDocumentTypeId
                            ],
                            buSubjectId: isActive ? null : [
                                buSubjectId
                            ] // this.filter.buSubjectId = isActive ? null : [ buSubjectId ];
                        }); // this.filter.accountingDocumentTypeId = isActive ? null : [ accountingDocumentTypeId ];
                    }
                });
                w.muBindData({
                    // u klíče se převede na string
                    name: accountingDocumentTypeId != "null" ? accountingDocumentTypeNames[accountingDocumentTypeId] : "nezad\xe1no",
                    count: statsByAdt[buSubjectId][accountingDocumentTypeId]
                });
                w.container.classList.toggle("active", isActive);
            }
            if (this.currentSubProfile.groupByTicketType) for(const ticketTypeId in statsByTT[buSubjectId]){
                const isActive = (this.filter.ticketTypeId?.includes(ticketTypeId) && this.filter.buSubjectId?.includes(buSubjectId)) ?? false;
                const w = this.muWidgetFromTemplate("ticketType", "stats", {
                    container_click: ()=>{
                        this.patchFilter({
                            ticketTypeId: isActive ? null : [
                                ticketTypeId
                            ],
                            buSubjectId: isActive ? null : [
                                buSubjectId
                            ]
                        });
                    }
                });
                w.muBindData({
                    // u klíče se převede na string
                    name: ticketTypeId != "null" ? ticketTypeNames[ticketTypeId] : "nezad\xe1no",
                    count: statsByTT[buSubjectId][ticketTypeId]
                });
                w.container.classList.toggle("active", isActive);
            }
        }
    }
    pager_changePage() {
        this.loadList();
    }
    async loadHistory(id) {
        this.ui.history.innerHTML = await this.cl.withMessage("Na\u010D\xedt\xe1m historii", this.ui.form).loadRawData("/ticket/history/" + id + "?part=form") ?? "Chyba na\u010Dten\xed";
    }
    async loadForm(id, data = null) {
        // this.ui.form.classList.add('loading-data');
        const html = await this.cl.withMessage(data ? "Odes\xedl\xe1m po\u017Eadavek" : "Na\u010D\xedt\xe1m po\u017Eadavek", this.ui.form).loadRawData("/ticket/detail/" + id + "?part=form", data) ?? "Chyba na\u010Dten\xed";
        //todo:
        if (html.startsWith("{")) {
            const data = JSON.parse(html);
            this.ticketFormIsChanged = false;
            (0, $3cBch.UiFlashMessage).instance.add("Ulo\u017Eeno");
            this.ui.form.innerHTML = "Ulo\u017Eeno";
            switch(this.currentSubProfile.afterSaveTicket){
                case "sameTicket":
                    await this.loadList(false);
                    await this.loadTicket(data);
                    break;
                case "nextTicket":
                    await this.loadList(true);
                    break;
            }
        } else {
            this.ui.form.innerHTML = html;
            (0, $kwZWC.jsNextCycle)();
            (0, $kwZWC.reviveLoadedElement)(this.ui.form);
            this.muActivateWidget(this.ui.form, null, undefined);
            const form = this.ui.form.querySelector("form");
            if (form) {
                form.addEventListener("submit", async (ev)=>{
                    ev.preventDefault();
                    const fd = new FormData(form);
                    // @ts-ignore
                    fd.append(ev.submitter.name, ev.submitter.value);
                    (0, $kwZWC.sleepPromise)(200).then(()=>this.loadHistory(id));
                    await this.loadForm(id, fd);
                });
                form.addEventListener("change", (ev)=>{
                    this.ticketFormChanged();
                // console.log(ev);
                });
                // this.ui.form.classList.remove('loading-data');
                await (0, $kwZWC.sleepPromise)(200);
                if (this.currentSubProfile.hideTicketButtons) this.muNamedWidget.form.muVisible(false, "ticketButtons");
                if (this.currentSubProfile.hideTicketSaveButtons && this.muNamedWidget.form.ui.btSubmitPlace) this.muNamedWidget.form.muVisible(false, "btSubmitPlace");
            }
        }
    }
    noTicket(noTicket) {
        this.muVisible(noTicket, [
            "!pTicket",
            "pNoTicket"
        ]);
    }
    async loadTicket(srcOrId) {
        this.noTicket(false);
        const src = typeof srcOrId !== "object" ? await this.cl.getTicketMetadata(srcOrId) : srcOrId;
        this.router.pushUpdate("ticket", {
            ticketId: src.id?.toString()
        });
        // if (this.isFormChanged() && !confirm("Údaje ve formuláři byly změněny. Načtením jiné faktury o změny přijdete, chcete opravdu načíst tuto fakturu?"))
        // 	return;
        let subject = src.buSubjectName || "";
        switch(this.currentSubProfile.subjectInTitle){
            case true:
                subject += " " + src.summary;
                break;
            case null:
                subject = subject || src.summary;
                break;
        }
        this.muBindData({
            evidenceUid: src.evidenceUid,
            buSubjectName: subject,
            accountingDocumentType: this.currentSubProfile.accountingDocumentTypePrefix + ((await this.accountingDocumentTypePairsPromise.fetch())[src.accountDocumentTypeId ?? ""] ?? "") + (this.currentSubProfile.ticketStateInTitle ? " " + (src.stateName?.toLowerCase() ?? "") : "")
        });
        this.currentTicket = src;
        this.ticketFormIsChanged = false;
        this.markSelectedTicket();
        const pForm = this.loadForm(src.id);
        const pHistory = this.loadHistory(src.id);
        let pComments = null;
        const useComments = typeof this.currentSubProfile.useComments === "boolean" ? this.currentSubProfile.useComments : src.useComments;
        if (useComments) pComments = this.muNamedWidget.comments.loadComments(src.id);
        this.muVisible(useComments, "comments");
        return Promise.all([
            pForm,
            pHistory,
            pComments
        ]);
    }
    ticketFormChanged() {
        this.ticketFormIsChanged = true;
    }
    async onInvoiceCreated(ticketId) {
        (0, $kwZWC.flashInfo)("Faktura byla vytvo\u0159ena");
        this.ticketFormIsChanged = false;
        // this.cl.callStateAction(ticketId, "invoiceCreated");
        this.loadList(this.currentSubProfile.afterSaveInvoice === "nextTicket");
    }
    onApprovingStateChange() {
        this.ticketFormIsChanged = false;
        this.loadList();
    }
    isFormChanged() {
        return this.formChangedCallback ? this.formChangedCallback() : this.ticketFormIsChanged;
    }
    setFormChangedCallback(callback) {
        this.formChangedCallback = callback;
    }
    prepareTicketAnchor(a, id) {
        this.router.prepareAnchor(a, "ticket", {
            ticketId: id.toString()
        });
    }
    constructor(...args){
        super(...args);
        // public ticketListSize: number = 4;
        // public cl: TicketOverviewCL = new TicketOverviewCL();
        this.clAppr = new (0, $cJjA3.InvoiceApprovalCL)();
        // private filter: any = {};
        this.orgDivisionPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m organiza\u010Dn\xed jednotky").getOrgDivisions(null, true));
        this.orgProjectPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m projekty").getOrgProjects(null, true));
        this.orgProductPromise = new (0, $fnX8e.CachedPromise)(()=>this.clAppr.withMessage("Na\u010D\xedt\xe1m produkty").getOrgProducts(null, true));
        this.vendorPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m subjekty").getAllInvVendors());
        this.myBuSubjectPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m firmy").getMyBuSubject());
        this.accountingDocumentTypePairsPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m typy doklad\u016F").getAccountingDocumentTypePairs());
        this.ticketTypePairsPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m typy dokument\u016F").getTicketTypePairs("SNF"));
        this.ticketTypePromise = new (0, $fnX8e.CachedPromise)(async ()=>{
            const res = [];
            const pairs = await this.ticketTypePairsPromise.fetch();
            for(const k in pairs)res.push({
                name: pairs[k],
                id: k
            });
            return res;
        });
        this.accountingDocumentTypePromise = new (0, $fnX8e.CachedPromise)(async ()=>(0, $kwZWC.pairsToList)(await this.accountingDocumentTypePairsPromise.fetch()));
        this.ticketFormIsChanged = false;
        this.allTicketPanels = [
            "form",
            "history"
        ];
        this.currentTicket = null;
        this.formChangedCallback = null;
    }
}

});

parcelRegister("fddaE", function(module, exports) {

$parcel$export(module.exports, "TOIInvoiceApproving", () => $c3c3640998539778$export$a0cc0f227fc09b6);

var $7USbm = parcelRequire("7USbm");
class $c3c3640998539778$export$a0cc0f227fc09b6 extends (0, $7USbm.BaseTOI) {
    beforeIndex() {
        this.container.classList.add("ticket-overview__item", "ticket-overview--invoice-approving__item");
        this.muAppendContent(`
			<div mu-bind="dtCreate:@visible" class="icon-before-email field-created">P\u{159}ijato: <span mu-bind='dtCreate|dateTime("d.m.Y")'></span></div>
			<a mu-id="link1" mu-bind='evidenceUid;id|prepend("id "):title' class="field-evidenceUid"></a>
			
			<div -mu-bind="buSubjectName:@visible" class="field-buSubject"><span mu-bind='buSubjectName' class="icon-before-building"></span></div>
			<div mu-bind="accountDocumentTypeName:@visible" class="field-accountDocumentTypeName icon-before-color-documents">
				<span class="field-accountDocumentTypeName-before"></span>
				<span mu-bind='accountDocumentTypeName'></span>
				<span mu-bind="stateName"></span>
			</div>
			
			<div mu-bind='summary;summary:@visible' class="icon-before-detail grid-column-s2 field-summary"></div>
			
			<div mu-bind='vendorName;vendorName:@visible' class="icon-before-supplier grid-column-s2 field-vendorName"></div>
			<div mu-bind="amountWT:@visible" class="field-amountWT">S DPH: <span mu-bind='amountWT|price'></span></div>
			<div mu-bind="amountNT:@visible" class="field-amountNT">Bez: <span mu-bind='amountNT|price'></span></div>
			<div mu-bind="dtTax:@visible" class="icon-before-calendar field-dtTax"><DUZP: <span mu-bind='dtTax|dateTime("d.m.Y")'></span></div>
			<div mu-bind="dtDue:@visible" class="icon-before-calendar field-dtDue">Spl.: <span mu-bind='dtDue|dateTime("d.m.Y")'></span></div>
			<div mu-bind="mailFrom:@visible"  class="field-mailFrom">Od: <span mu-bind='mailFrom'></span></div>
			<div class="field-variableSymbol">Vs: <span mu-bind='variableSymbol'></span></div>
		`);
    }
    muBindData(srcData) {
        this.srcData = {
            ...srcData,
            vendorName: srcData.vendorInfo?.name || "",
            accountDocumentTypeName: srcData.accountDocumentTypeName || "",
            summary: /* srcData.vendorInfo ? "" : */ srcData.summary,
            dtCreate: /*srcData.dtDue ? null :*/ srcData.dtCreate,
            mailFrom: false
        };
        super.muBindData(this.srcData);
        this.muParent.router.prepareAnchor(this.ui.link1, "ticket", {
            ticketId: srcData.id
        });
    }
}

});
parcelRegister("7USbm", function(module, exports) {

$parcel$export(module.exports, "BaseTOI", () => $e4e46e9f56f4cd7d$export$28caec455050132b);

var $6Taw3 = parcelRequire("6Taw3");
class $e4e46e9f56f4cd7d$export$28caec455050132b extends (0, $6Taw3.BaseMuWidget) {
    container_click() {
        this.muParent.loadTicket(this.srcData.id, this.srcData);
    }
    setActiveIf(id) {
        this.container.classList.toggle("ticket-overview__item--active", id == this.srcData.id);
    }
}

});


parcelRegister("fudPg", function(module, exports) {

$parcel$export(module.exports, "TOPqm", () => $f54caba2f79ac27b$export$45f4bbae9e4ebab9);
$parcel$export(module.exports, "UiStates", () => $f54caba2f79ac27b$export$f4dbdfcf6b4e5e65);
$parcel$export(module.exports, "PqmSteps", () => $f54caba2f79ac27b$export$3f92f90346cd4090);

var $3uYki = parcelRequire("3uYki");

var $jRjEI = parcelRequire("jRjEI");

var $kwZWC = parcelRequire("kwZWC");

var $d9JXN = parcelRequire("d9JXN");

var $fykIr = parcelRequire("fykIr");

var $4lD3q = parcelRequire("4lD3q");

var $bjpdy = parcelRequire("bjpdy");

var $6Taw3 = parcelRequire("6Taw3");
function $f54caba2f79ac27b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f54caba2f79ac27b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f54caba2f79ac27b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f54caba2f79ac27b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f54caba2f79ac27b$var$_arrayLikeToArray(o, minLen);
}
function $f54caba2f79ac27b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $f54caba2f79ac27b$export$45f4bbae9e4ebab9 extends (0, $3uYki.BaseTO) {
    async loadTicket(id, metadata) {
        this.muClear("ticketDetail");
        if (!metadata || !metadata.projectCode) metadata = await this.ticketsCL.getTicketMetadata(id);
        this.router.pushUpdate("ticket", {
            ticketId: this.createTicketRid(metadata)
        });
        let widget;
        switch(metadata.projectCode){
            case "PQM":
                widget = this.openInDetail("PqmTicketDetail");
                // @ts-ignore
                this.currentTicket = (await widget.doLoad(id)).ticket;
                break;
            case "TODO":
                widget = this.openInDetail("TodoTicketForm", {
                    addTitle: true
                });
                // @ts-ignore
                this.currentTicket = await widget.doLoad(id, "ticket");
                break;
        }
        this.markSelectedTicket();
        widget.addEventListener("saved", (item)=>this.loadList(false));
        return null;
    }
    openInDetail(name, params = {}) {
        this.muClear("ticketDetail");
        return this.createWidgetIn(name, "ticketDetail", params);
    }
    getLastPqmItemId() {
        return this.filter.masterPqmItemId;
    }
    pqmFilter_change(ev, pqmItemId, items) {
        this.filter.masterPqmItemId = pqmItemId;
        if (this.isGgroupedByPI) this.muBindData({
            pqmItems: items
        });
        else this.loadList();
    }
    get isGgroupedByPI() {
        return (this.currentSubProfile.layout || "list") === "list" && this.currentSubProfile.groupByPqm && this.ui.cGroupedByItem.checked;
    }
    async getTicketsByFilter(ui, limitFrom, limitCount, filter = {}) {
        return await this.ticketsCL.withMessage("Na\u010D\xedt\xe1m polo\u017Eky", ui).getTickets(this.profile.id, this.currentSubProfile.id, {
            fulltext: this.ui.cFulltext.value,
            stateId: this.muNamedWidget.filterStateIds.muFetchData(),
            ...this.filter,
            ...filter
        }, limitFrom, limitCount);
    }
    async loadList(loadNext = true) {
        this.router?.update(null, {
            filter: JSON.stringify(this.filter)
        });
        this.setupPaneSizes(0);
        const layout = this.currentSubProfile.layout || "list";
        for(var _i = 0, _arr = [
            "calendar",
            "list"
        ]; _i < _arr.length; _i++){
            const l = _arr[_i];
            this.muVisible(l === layout, l);
        }
        if (layout === "calendar") await this.muNamedWidget.calendar.init();
        else {
            this.muVisible(!!this.currentSubProfile.groupByPqm, "lGroupedByItem");
            if (this.isGgroupedByPI) {
                const data = await this.ticketsCL.withMessage("Na\u010D\xedt\xe1m polo\u017Eky", this.ui.sidePanel).getPqmTicketStats(this.profile.id, this.currentSubProfile.id, {
                    fulltext: this.ui.cFulltext.value,
                    stateId: this.muNamedWidget.filterStateIds.muFetchData(),
                    ...this.filter
                });
                this.muClear("overviewItems");
                this.ui.overviewPqmItems.innerText = "Vyberte proces vpravo";
                this.muNamedWidget.pqmFilter.bindData(data);
                this.muVisible(false, "pager");
            } else {
                const data = await this.getTicketsByFilter(this.ui.sidePanel, this.muNamedWidget.pager.currentItemFrom ?? 0, this.muNamedWidget.pager.itemPerPage);
                this.muClear("overviewPqmItems");
                this.muBindData(data);
                this.muNamedWidget.pager.setItemCount(data.fullCount);
                this.muNamedWidget.pager.setItemCount(data.fullCount);
                if (data.stats && data.stats[0].name) this.muNamedWidget.pqmFilter.bindData(data.stats);
                this.muVisible(true, "pager");
            }
        }
        return Promise.resolve();
    }
    pager_changePage() {
        this.loadList(false);
    }
    beforeIndex() {
        this.muAppendContent(this.htmlNavSubprofiles(true) + this.htmlToolbar(false, true, false) + `
			<div mu="calendar:CalendarPage" style="display: none"></div>
			<div class="row" mu="list" style="display: none">
				<div mu="sidePanel" class="col-sm-${this.ticketListSize} display-flex-column gap-3">
					<div mu="stateGroups">
						<span mu=":.@stateGroup" class="btn"></span>
					</div>
					<div mu="filterStateIds:UiStates"></div>
					<div class="row">
						<div mu="pqmFilter:UiPqmFilter" class="ticket-overview__pqm-filter-process"></div>
						<div mu="overviewContainer" class="ticket-overview__pqm-filter-step">
							<label mu="lGroupedByItem"><input type="checkbox" mu="cGroupedByItem" checked="checked"> Seskupit dle \u{10D}innosti</label>
							<div mu-id="overviewItems" mu-bind="items:@foreach" class="layout-pqm-default">
								<div mu=":TOIPqm@overviewItem"></div>
							</div>
							<div mu-id="overviewPqmItems" mu-bind="pqmItems:@foreach" class="layout-pqm-default">
								<div mu=":PqmSteps@pqmStep"></div>
							</div>
						</div>
					</div>
					<div mu-widget="Pager" mu-id="pager"></div>
				</div>
				<div mu="ticketDetail" class="col-sm-${12 - this.ticketListSize}">
				</div>
			</div>
		`);
        this.container.classList.add("ticket-overview");
        this.setupRouter();
        this.overviewLayoutPrefix = "pqm-";
    }
    setupRouter() {
        this.router = new (0, $d9JXN.BaseRouter)();
        this.router.pathPrefix = "/ticket/overview/" + this.profile.code;
        this.router.persistentKeys = [
            "subprofile"
        ];
        this.router.paTicket = (oa, ticket)=>{
            (0, $kwZWC.Arrays).ooaToArray(oa).forEach((a)=>this.router.prepareAnchor(a, "ticket", {
                    ticketId: this.createTicketRid(ticket)
                }, true));
        };
        const findSubProfile = async (id)=>(await this.subprofiles.fetch()).find((sp)=>sp.id === id);
        const reactivateProfile = async (rc)=>{
            if (rc.parameters.subprofile !== this.currentSubProfile?.id) this.activateSubProfile(await findSubProfile(rc.parameters.subprofile), false);
        };
        this.router.addRoute("createPqmTicket", "/<subprofile>/createPqmTicket/<pqmItemId>", async (rc)=>{
            const md = {};
            // @ts-ignore
            this.doNewPqmTicket(parseInt(rc.parameters.pqmItemId));
            await reactivateProfile(rc);
        });
        this.router.addRoute("ticket", "/<subprofile>/<ticketId>", async (rc)=>{
            const md = {};
            [md.id, md.projectCode, md.ticketTypeCode] = rc.parameters.ticketId.split("-");
            this.loadTicket(parseInt(md.id), md);
            if (rc.parameters.subprofile === "calendar") rc.parameters.subprofile = "all";
            await reactivateProfile(rc);
        });
        this.router.addRoute("overview", "/<subprofile>", async (rc)=>this.activateSubProfile(await findSubProfile(rc.parameters.subprofile), true));
        this.router.addRoute("root", "", async (rc)=>this.activateSubProfile((await this.subprofiles.fetch())[0], true));
    }
    async afterIndex() {
        super.afterIndex();
        this.setupSubProfiles(await this.subprofiles.fetch());
        this.router.route();
    }
    cGroupedByItem_change() {
        this.loadList();
    }
    createTicketRid(ticket) {
        return ticket.id.toString() + "-" + ticket.projectCode + "-" + ticket.ticketTypeCode;
    }
    async bAdd_click() {
        if (this.currentSubProfile.id === "calendar") this.muNamedWidget.calendar.calendar_add(null, null);
        else if (this.currentSubProfile.id === "todo") {
            const widget = this.openInDetail("TodoTicketForm", {
                addTitle: true
            });
            widget.doNew();
            if (await widget.eventPromise("saved", null)) await this.loadList();
        } else {
            let ws = this.openInDetail("UiPqmLauncher" /*, "Vyberte proces ke spuštění" */ );
            const val = await ws.eventPromise("start", null);
            ws.muRemoveSelf();
            if (val) {
                this.router?.pushUpdate("createPqmTicket", {
                    pqmItemId: val,
                    ticketId: null
                });
                this.doNewPqmTicket(val);
            }
        }
    }
    async doNewPqmTicket(pqmItemId) {
        const we = this.openInDetail("PqmTicketDetail");
        await we.doNew(pqmItemId);
        if (await we.eventPromise("saved", false) !== null) this.loadList(false);
    }
    filterStateIds_change() {
        this.dslLoadList.send();
    }
    activateSubProfile(subProfile, loadFirst) {
        // @ts-ignore
        const items = subProfile.states.map((s)=>({
                id: s.id.toString(),
                title: s
            }));
        this.muNamedWidget.filterStateIds.bindItems(items);
        this.muNamedWidget.filterStateIds.checkBy((item)=>!subProfile.defaultStates || subProfile.defaultStates.includes(item.title.code));
        super.activateSubProfile(subProfile, loadFirst);
        this.muVisible(subProfile.layout !== "calendar", "toolbar");
        const stateCode2Id = Object.fromEntries(subProfile.states.map((state)=>[
                state.code,
                state.id.toString()
            ]));
        // Skupiny stavů
        this.muClear("stateGroups");
        if (subProfile.stateGroups) {
            for(var _iterator = $f54caba2f79ac27b$var$_createForOfIteratorHelperLoose(subProfile.stateGroups || []), _step; !(_step = _iterator()).done;){
                const stateGroup = _step.value;
                const stateIds = stateGroup.states.map((c)=>stateCode2Id[c]);
                this.muWidgetFromTemplate("stateGroup", "stateGroups", {
                    afterIndex: function() {
                        const c = this.container;
                        const color = stateGroup.color || "#ffffff";
                        c.innerText = stateGroup.name;
                        c.style.color = (0, $bjpdy.MuBinder).filters.bwContrasted(color);
                        c.style.backgroundColor = color;
                    },
                    container_click: ()=>{
                        this.muNamedWidget.filterStateIds.muBindData(stateIds);
                        this.loadList();
                    }
                });
            }
            this.muWidgetFromTemplate("stateGroup", "stateGroups", {
                afterIndex: function() {
                    const c = this.container;
                    c.innerText = "...";
                    c.title = "Podrobn\u011Bj\u0161\xed v\xfdb\u011Br stav\u016F";
                },
                container_click: ()=>this.muVisible("toggle", "filterStateIds")
            });
        }
        this.muVisible(!subProfile.stateGroups, "filterStateIds");
        const groupByPqm = subProfile.groupByPqm === "master";
        // this.ui.pqmFilter.classList.toggle('col-sm-6', groupByPqm);
        // this.ui.overviewContainer.classList.toggle('col-sm-6', groupByPqm);
        // this.muVisible(groupByPqm, "pqmFilter");
        this.filter.masterPqmItemId = null;
        this.setupPaneSizes(0);
    }
    setupPaneSizes(index) {
        const groupByPqm = this.currentSubProfile.groupByPqm === "master";
        if (index === "next") this.panelSizesIndex++;
        else this.panelSizesIndex = index;
        // @ts-ignore
        if (this.panelSizesIndex >= this.scProfiles[groupByPqm].length) this.panelSizesIndex = 0;
        const sizes = {};
        // @ts-ignore
        [sizes.sidePanel, sizes.ticketDetail, sizes.pqmFilter, sizes.overviewContainer] = this.scProfiles[groupByPqm][this.panelSizesIndex];
        for(const id in sizes)if (sizes[id] !== undefined) {
            const s = sizes[id];
            this.muVisible(s !== 0, id);
            (0, $kwZWC.changeClassStartsWith)(this.ui[id].classList, "col-sm-", s.toString());
        }
    }
    bSwitchLayout_click() {
        this.setupPaneSizes("next");
    }
    constructor(...args){
        super(...args);
        // public cl: TicketsCL = new TicketsCL();
        this.ticketsCL = new (0, $jRjEI.TicketsCL)();
        this.scProfiles = {
            true: [
                [
                    5,
                    7,
                    6,
                    6
                ],
                [
                    3,
                    9,
                    0,
                    12
                ],
                [
                    0,
                    12,
                    0,
                    0
                ]
            ],
            false: [
                [
                    3,
                    9,
                    0,
                    12
                ],
                [
                    0,
                    12,
                    0,
                    0
                ]
            ]
        };
        this.panelSizesIndex = 0;
        this.dslLoadList = new (0, $fykIr.DelayedSingleLauncher)(2, ()=>this.loadList(false));
    }
}
class $f54caba2f79ac27b$export$f4dbdfcf6b4e5e65 extends (0, $4lD3q.UiChboxList) {
    beforeIndex() {
        this.muAppendContent(`<label mu-bind="color:style.backgroundColor;color|bwContrasted:style.color" 
				mu-template="item" mu-widget="UiChboxListItem" class="badge">
			<input type="checkbox" mu-id="input">
			<span mu="title#name"></span>
		</label>`);
        super.beforeIndex();
    }
}
class $f54caba2f79ac27b$export$3f92f90346cd4090 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<label class="cursor-pointer checkbox-collapse d-block" mu="header">
				<input type="checkbox" mu="collapsed" />
				<span></span>
				<strong mu="#name" class="flex-grow-1"></strong>
				<span class="badge bg-secondary float-right" mu="#count"></span>			
			</label>
			<div mu="content">
				<div mu="list">
					<div mu=":.@overviewItem" class="cursor-pointer"><a mu="link">
						<em mu="#evidenceUid"></em><span mu="#summary"></span>
					</a></div>
				</div>
				<div class="buttons" mu="buttons">
					<span class="btn btn-link" mu="bLoadNexts">Na\u{10D}\xedst dal\u{161}\xed</span>
				</div>
			</div>
		`);
    }
    collapsed_change() {
        this.muVisible(this.ui.collapsed.checked, "content");
        if (this.loadedTicketCount === 0 && this.ui.collapsed.checked) // Automaticky načti první várku při otevření
        this.loadNextTickets();
    }
    afterIndex() {
        this.collapsed_change();
    // this.ui.name.innerText = this.name;
    // this.ui.count.innerText = this.count.toString();
    }
    muAfterBindData(data) {
        this.pqmItemId = data.pqmItemId;
        this.name = data.name;
    }
    async loadNextTickets() {
        this.muVisible(false, "bLoadNexts");
        const data = await this.callMethodInFirstAncestors("getTicketsByFilter", this.ui.buttons, this.loadedTicketCount, this.pageSize, {
            pqmItemId: this.pqmItemId
        });
        this.loadedTicketCount += data.items.length;
        this.fullCount = data.fullCount;
        this.muVisible(this.loadedTicketCount < this.fullCount, "bLoadNexts");
        this.muBindList(data.items, "overviewItem", "list", {}, (widget, item)=>{
            this.getRouter().paTicket([
                widget.container,
                widget.ui.link
            ], item);
            widget.muBindData({
                ...item,
                summary: item.summary.replace(this.name, " ") || item.summary
            });
        });
        console.log(data);
    }
    bLoadNexts_click() {
        this.loadNextTickets();
    }
    constructor(...args){
        super(...args);
        this.loadedTicketCount = 0;
        this.pageSize = 50;
        this.fullCount = -1;
    }
}

});

parcelRegister("2rQ63", function(module, exports) {

$parcel$export(module.exports, "UiPqmLauncher", () => $fa260726f85b6643$export$abb515097afbcdff);

var $4pyNk = parcelRequire("4pyNk");

var $iSpsO = parcelRequire("iSpsO");
class $fa260726f85b6643$export$abb515097afbcdff extends (0, $4pyNk.BaseWidget) {
    beforeIndex() {
        this.muRegisterEvent("start");
        this.container.classList.add("pqm-launcher");
        this.muAppendContent(`
			<div mu="pqmItems:TreeSelector" mu-params='{"inModal":false}'></div>
		`);
    }
    async afterIndex() {
        const tree = this.muNamedWidget.pqmItems;
        tree.afterItemRender = (item)=>{
            if (!item.data) item.ui.title.classList.add("strong");
            else {
                item.ui.title.classList.add("icon-before-play");
                item.muVisible(false, "bCollapse");
            }
        };
        tree.bindTree(await this.cl.getStartablePqmItems());
    }
    pqmItems_change(ev, id, item) {
        if (item.data) this.muDispatchEvent("start", item.data.id);
        else item.ui.bCollapse.click();
        this.muNamedWidget.pqmItems.setSelected("--", false);
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $iSpsO.TicketOverviewCL)();
    }
}

});

parcelRegister("5cJAH", function(module, exports) {

$parcel$export(module.exports, "PqmTicketList", () => $ddad7a265557d7e4$export$d7ff9725103e4dee);
$parcel$export(module.exports, "PqmTicketLink", () => $ddad7a265557d7e4$export$729fbe14b0365e6b);

var $6Taw3 = parcelRequire("6Taw3");

var $3Yb7l = parcelRequire("3Yb7l");
class $ddad7a265557d7e4$export$d7ff9725103e4dee extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<table mu="list:UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu=":UiTableCellTemplate@ticket"><a mu='link#value;level|append("em"):style.marginLeft' class="display-block"></a></td>
					<td mu=":UiTableCellTemplate@evidenceUid"><a mu='link#value' class="display-block"></a></td>
					<td mu=":UiTableCellTemplate@stateName">
						<div class="prod-data-ticket-tree-state" mu='#stateName;stateColor:style.backgroundColor'></div>
					</td>
					<td mu=":UiTableCellTemplate@pqmItem"><a mu="#value;pqmItem;pqmItemLink:href"></a></td>
				</tr>
			</table>
		`);
    }
    afterIndex() {
        const self = this;
        const setupTicketLink = function(row) {
            const router = self.getRouter();
            // @ts-ignore
            router.paTicket(this.ui.link, row);
        };
        this.muNamedWidget.list.columns = [
            new (0, $3Yb7l.ColumnInfo)({
                field: "summary",
                name: "Po\u017Eadavek",
                template: "ancestor:ticket",
                widgetParams: {
                    muAfterBindData: setupTicketLink
                }
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "evidenceUid",
                name: "Eviden\u010Dn\xed \u010D\xedslo",
                template: "ancestor:evidenceUid",
                widgetParams: {
                    muAfterBindData: setupTicketLink
                }
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "stateName",
                name: "Stav",
                template: "ancestor:stateName"
            }),
            new (0, $3Yb7l.ColumnInfo)({
                field: "pqmItemName",
                name: "Proces",
                template: "ancestor:pqmItem"
            })
        ];
    // this.muNamedWidget.list.rowParams()
    }
    loadItems(data) {
        this.muNamedWidget.list.data = data.tickets;
        this.muNamedWidget.list.render();
    }
}
class $ddad7a265557d7e4$export$729fbe14b0365e6b extends (0, $6Taw3.BaseMuWidget) {
    afterIndex() {
        this.update();
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        if ("ticketId" in srcData) this.ticketId = srcData.ticketId;
        this.update();
    }
    update() {
        const router = this.getRouter();
        if (this.ticket) // @ts-ignore
        router.paTicket(this.container, this.ticket);
        else if (this.ticketId) router.prepareAnchor(this.container, "ticket", {
            ticketId: this.ticketId.toString()
        });
    }
    constructor(...args){
        super(...args);
        this.ticketId = null;
        this.ticket = null;
    }
}

});

parcelRegister("9DFQu", function(module, exports) {

$parcel$export(module.exports, "PqmTicketDetail", () => $8c3520ee29e22214$export$a21a9d3f40efa3f);
$parcel$export(module.exports, "CancelProcDataDialog", () => $8c3520ee29e22214$export$27b4161a96e6c18b);

var $6Taw3 = parcelRequire("6Taw3");

var $5k56K = parcelRequire("5k56K");

var $fnX8e = parcelRequire("fnX8e");

var $iSpsO = parcelRequire("iSpsO");

var $kwZWC = parcelRequire("kwZWC");
function $8c3520ee29e22214$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8c3520ee29e22214$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8c3520ee29e22214$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8c3520ee29e22214$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8c3520ee29e22214$var$_arrayLikeToArray(o, minLen);
}
function $8c3520ee29e22214$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $8c3520ee29e22214$export$a21a9d3f40efa3f extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muRegisterEvent("saved");
        this.container.classList.add("pqm-ticket-detail", "pqm-ticket-detail--hide-details");
        this.muAppendContent(`
			<div mu="tabs:UiTabs"></div>
			<div tab-label="Detail" mu="tDetail">
				<div class="display-flex-row">
					<h1 class="flex-grow-1" mu-bind="summary"></h1>
					<div class="text-center">
						<div mu=":.#state"><div class="badge" mu-bind="name;color:style.backgroundColor;color|bwContrasted:style.color"></div></div>
						<label class="whitespace-nowrap"><input type="checkbox" mu="cDetails" />&nbsp;Detaily</label>
						<a mu="pqmDetail" target="_blank" class="icon-before-pqm-item">Proces</a>
					</div>
				</div>
				<div class="pqm-ticket-detail__header" mu="roles">
					<span>
						<strong>Datum:</strong> <span mu="#dtCreate|date"></span>
					</span>
					<span>
						<strong>Zadavatel:</strong> <span mu="#customers"></span>
					</span>
					<span mu="solver:TicketAccountSelector#solverIds" mu-params='{"label":"\u{158}e\u{161}itel","useDelegate":true}' class="flex-grow-1"></span>
					<span mu="reader:TicketAccountSelector#readerIds" mu-params='{"label":"Na v\u{11B}dom\xed","useAdd":true}' class="flex-grow-1"></span>
				</div>
				<fieldset mu="startInfo">
					<legend>Z\xe1kladn\xed \xfadaje</legend>
					<div class="row form-group">
						<label class="col-3 control-label">Pro st\u{159}edisko</label>
						<div class="col-9">
							<div mu="orgDivisionId:PqmFieldOrgDivision"></div>
							<label><input type="checkbox" mu="ticketPerSolver" /> Pro ka\u{17E}d\xe9ho \u{159}e\u{161}itele vytvo\u{159}it zvl\xe1\u{161}\u{165} po\u{17E}adavek </label>
						</div>
					</div>
					<!-- <div class="row form-group">
						<label class="col-3 control-label">Priorita</label>
						<div class="col-9">
							<div mu="priorityId:UiRadioList"></div>
						</div>
					</div> -->
				</fieldset>			
				<div mu="inputs:PqmPackets" mu-params='{"disabled": true}'></div>
				<div mu="outputs:PqmPackets"></div>
				<div class="buttons">
					<span class="btn btn-primary" mu="bSave">Ulo\u{17E}it</span>
				</div>
				<div mu="comments:UiComment" mu-params='{"isRoot":true}'></div>
			</div>
			<div tab-label="Cel\xe9 spu\u{161}t\u{11B}n\xed" mu="tProcData">
				<div mu="procData:PqmTicketList"></div>
				<div class="buttons">
					<span class="btn btn-danger" mu="bCancel">Stornovat cel\xe9 spu\u{161}t\u{11B}n\xed</span>
				</div>` + (this.useAttaches ? `<h2>P\u{159}\xedlohy</h2>
				<div mu="attachList:AttachList"></div>
				<div mu="attachNew:MultiUpload"></div>
				<div class="buttons">
					<span class="btn btn-primary" mu="bAddAttach">P\u{159}idat p\u{159}\xedlohu</span>				
				</div>` : "") + `<div 
			</div>
		`);
    }
    cDetails_change() {
        this.container.classList.toggle("pqm-ticket-detail--hide-details", !this.ui.cDetails.checked);
    }
    async afterIndex() {}
    async bCancel_click() {
        const widget = this.openInModal("CancelProcDataDialog", "Opravdu stornovat cel\xe9 spu\u0161t\u011Bn\xed?");
        const reason = await widget.eventPromise("cancelProcData", null);
        if (reason !== null) {
            await this.cl.cancelProcData(this.pqmProcData.procDataId, reason);
            await this.doLoad(this.ticketId);
            (0, $kwZWC.flashInfo)("Spu\u0161t\u011Bn\xed bylo stornov\xe1no.");
        }
    }
    bindForm(data) {
        const layout = data.layout || "edit";
        data = this.pqmProcData = {
            cooperating: {},
            data: [],
            ticket: {},
            layout: layout,
            ...data
        };
        this.muNamedWidget.inputs.disabled = layout === "edit";
        this.muNamedWidget.inputs.muBindData(data.inputs);
        this.muNamedWidget.inputs.setData(data.data);
        if (layout === "edit") {
            this.muNamedWidget.outputs.muBindData(data.outputs);
            this.muNamedWidget.outputs.setData(data.data);
            this.muNamedWidget.comments.loadComments(data.ticketId);
        }
        this.muVisible(layout === "edit", [
            "roles",
            "outputs",
            "comments",
            "!startInfo"
        ]);
        this.muBindData(data.ticket);
        if (data.ticket.pqmItem) {
            this.ui.pqmDetail.href = "/pqm/pqm-detail/" + data.ticket.pqmItem.id;
            this.ui.pqmDetail.title = data.ticket.pqmItem.name;
        }
        this.muVisible(!!data.ticket.pqmItem, "pqmDetail");
    }
    async bSave_click() {
        let res = null;
        if (this.pqmProcData.layout === "edit") {
            res = await this.cl.saveTicketAndProcData(this.muFetchData(), this.muNamedWidget.outputs.getData(), this.ticketId);
            await this.muNamedWidget.outputs.afterSave(res);
            res = await this.cl.ticketFinalize(res.ticketId);
            this.bindForm(res);
            this.doLoad(res.ticketId);
        } else {
            const orgDivisionId = this.muNamedWidget.orgDivisionId.getValue();
            if (!orgDivisionId) {
                (0, $kwZWC.flashError)("Je pot\u0159eba vybrat st\u0159edisko");
                this.muNamedWidget.orgDivisionId.muNamedWidget.value.openModal();
                return;
            }
            res = await this.cl.createTicketAndProcData(this.pqmItemId, {
                orgDivisionId: orgDivisionId,
                ticketPerSolver: this.ui.ticketPerSolver.checked
            }, this.muNamedWidget.inputs.getData());
            if (res.multiple) for(var _iterator = $8c3520ee29e22214$var$_createForOfIteratorHelperLoose(res.res), _step; !(_step = _iterator()).done;){
                const item = _step.value;
                await this.muNamedWidget.inputs.afterSave(item);
                res = await this.cl.ticketFinalize(item.ticketId);
            }
            else {
                await this.muNamedWidget.inputs.afterSave(res.res);
                res = await this.cl.ticketFinalize(res.res.ticketId);
            }
            // this.bindForm(res);
            this.doLoad(res.ticketId);
            this.muNamedWidget.tabs.selectTab("tProcData");
        }
        this.muDispatchEvent("saved", res.ticket);
    }
    async doLoad(id) {
        this.ticketId = id;
        const ticket = await this.cl.withMessage("Na\u010D\xedt\xe1m po\u017Eadavek", this.container).getTicketAndProcDataWithDetailsFor(this.ticketId);
        this.ticket = ticket;
        this.bindForm(ticket);
        await this.reloadTicketTree();
        if (this.useAttaches) this.muNamedWidget.attachList.bindData({
            procDataId: ticket.procDataId
        });
        return ticket;
    }
    async reloadTicketTree() {
        // proc data
        this.muNamedWidget.procData.loadItems(await new (0, $iSpsO.TicketOverviewCL)().withMessage("Na\u010D\xedt\xe1m detaily spu\u0161t\u011Bn\xed", this.ui.procData).getProcData(this.ticket.procDataId));
    }
    async bAddAttach_click() {
        await this.muNamedWidget.attachNew.sendToBackend((ctx, send)=>{
            ctx.url = this.rawUploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
                procDataId: this.ticket.procDataId,
                fileName: ctx.file.name,
                contentType: ctx.file.type,
                size: ctx.file.size
            }));
            send();
        });
        this.muNamedWidget.attachNew.clear();
        (0, $kwZWC.flashInfo)("P\u0159\xedloha byla ulo\u017Eena");
        await this.muNamedWidget.attachList.bindData();
    }
    async doNew(pqmItemId) {
        this.pqmItemId = pqmItemId;
        const data = await this.cl.withMessage("Na\u010D\xedt\xe1m proces", this.container).getStartData(pqmItemId);
        this.muNamedWidget.orgDivisionId.setValue(data.defaultOrgDivisionId.toString());
        this.pqmProcData = data;
        this.pqmProcData.layout = "create";
        this.bindForm(this.pqmProcData);
        this.muVisible(false, [
            "tProcData",
            "tabs"
        ]);
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $5k56K.PqmCL)();
        this.cpOrgDivision = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m organiza\u010Dn\xed jednotky").getOrgDivisions("*", true));
        this.ticketId = null;
        this.pqmItemId = null;
        this.useAttaches = false;
    }
}
class $8c3520ee29e22214$export$27b4161a96e6c18b extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muRegisterEvent("cancelProcData");
        this.muAppendContent(`
			<label>D\u{16F}vod ke stornov\xe1n\xed</label>
			<div mu="reason:Htmlarea"></div>
			<div class="buttons">
				<span class="btn btn-danger" mu="bDoCancel">Stornovat cel\xe9 spu\u{161}t\u{11B}n\xed</span>
				<span class="btn btn-default" mu-click="muRemoveSelf">Zav\u{159}\xedt beze zm\u{11B}n</span>
			</div>
		`);
    }
    bDoCancel_click() {
        this.muDispatchEvent("cancelProcData", this.muNamedWidget.reason.muFetchData());
        this.muRemoveSelf();
    }
}

});

parcelRegister("fhHvw", function(module, exports) {

$parcel$export(module.exports, "PqmField", () => $4c8158d83ce8ede0$export$5d41a9587d5920e);

var $6Taw3 = parcelRequire("6Taw3");

var $cnflh = parcelRequire("cnflh");

var $kwZWC = parcelRequire("kwZWC");
class $4c8158d83ce8ede0$export$5d41a9587d5920e extends (0, $6Taw3.BaseMuWidget) {
    setDisabled(disabled) {
        this.ui.isComplete.disabled = disabled;
        this.fieldWidget?.setDisabled(disabled);
    }
    setRejectVisible(visible) {
    // this.muVisible(visible, 'lReject');
    }
    beforeIndex() {
        this.container.classList.add("row");
        this.muAppendContent(`
			<label class="col-sm-3 control-label" mu="label">
				<label class="checkbox-icon" mu="lIsComplete"><input type="checkbox" mu="isComplete#isComplete" /><span></span></label>
				<span mu="isCompleteIndicator#isCompleteIndicator" class="pqm-packet-complete-indicator"></span>
				<label class="checkbox-invalid-input" mu="lReject" style="display: none">
					<input type="checkbox" mu="reject#requireCompletion;requireCompletion:disabled" /><span></span>
				</label>
				<span mu="name#name"></span>
			</label>
			<div mu="shiftDetails" class="col-sm-3"></div>
			<div class="col-sm-9">
				<div mu="pInput"></div>
				<div mu="details">
					<div mu="conditionsContainer" class="toggleable-details">
						<strong>Podm\xednky</strong>
						<ul mu="conditions:TreeView">
							<li mu=":.@item">
								<span mu-bind="name"></span> <em mu-bind="description"></em>
								<ul mu="children"></ul>
							</li>
						</ul>
					</div>
					<div mu="cooperatingContainer" class="toggleable-details">
						<strong mu="cooperatingLabel"></strong>
						<ul mu="#cooperating:@foreach">
							<li mu=":.@cooperatingItem">
								<a mu=":PqmTicketLink#ticketId:.ticketId;evidenceUid:innerText;ticket"></a>
								<a mu=":PqmTicketLink#ticketId:.ticketId;summary:innerText;ticket"></a>
								<span mu-bind="stateName;stateColor:style.backgroundColor;stateColor|bwContrasted:style.color" class="badge"></span>
								<span mu-bind="solvers:@foreach">
									<span mu=":AccountLink@solverItem#accountName:.accountName;accountId:.accountId;accountId"></span>
								</span>
							</li>
						</ul>					
					</div>
				</div>
			</div>
		`);
    }
    get packets() {
        return this.muParent.muParent;
    }
    reject_change() {
        this.packets.updateRejected();
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        this.pqmPacketData = srcData;
        this.ui.label.style.paddingLeft = ((srcData.plunge + 1) * 1.5).toString() + "rem";
        const conditions = this.getPropertyInAncestors("packetsData").conditions[srcData.pqmPacketId];
        if (conditions) this.muNamedWidget.conditions.render(conditions, {
            srcStructFormat: "parentField",
            outStructType: "plunge"
        });
        const cooperating = this.getPropertyInAncestors("pqmProcData").cooperating[srcData.pqmPacketId];
        if (cooperating) super.muBindData({
            cooperating: cooperating.map((a)=>({
                    ...a,
                    ticket: a
                }))
        });
        this.muVisible(!!conditions, "conditionsContainer");
        const fieldClass = (0, $cnflh.PqmFieldRegister).getClassFor(srcData.paramType, srcData.control);
        this.fieldWidget = fieldClass ? this.muWidgetFromTemplate({
            html: "<div></div>",
            classType: fieldClass
        }, "pInput", srcData) : null;
        if (this.fieldWidget) this.fieldWidget.onChange = ()=>this.update();
        (0, $kwZWC.sleepPromise)(100).then(()=>this.update());
        this.setDisabled(this.disabled);
        this.setRejectVisible(this.packets.packetsData.isInput);
    }
    markCompletion() {
        this.requireCompletion = true;
        this.update();
    }
    update() {
        this.muVisible(!!this.pqmPacketData.hasCheckbox, [
            "lIsComplete",
            "!isCompleteIndicator"
        ]);
        this.muVisible(!this.pqmPacketData.paramType, "shiftDetails");
        (0, $kwZWC.changeClassStartsWith)(this.ui.label.classList, "col-sm-", !this.pqmPacketData.paramType ? "12" : "3");
        (0, $kwZWC.changeIconBefore)(this.ui.isCompleteIndicator, this.pqmPacketData.optional ? "checked-blue" : this.fieldWidget?.isFilled() ? "checked-on" : "checked-off");
        const isInput = this.packets.packetsData.isInput;
        this.ui.reject.disabled = isInput ? this.requireCompletion : !this.requireCompletion;
        this.ui.lReject.title = isInput ? this.ui.reject.disabled ? "Tato hodnota vy\u017Eaduje dopln\u011Bn\xed" : "Klinut\xedm m\u016F\u017Eete ozna\u010D\xedt tuto hodnotu jako chybnout a vy\u017E\xe1d\xe1t jej\xed dopln\u011Bn\xed" : this.ui.reject.disabled ? "" : "Tato hodnota vy\u017Eaduje dopln\u011Bn\xed, a\u017E dopln\xedte \xfadaje, kliknut\xedm ozna\u010D\xedte jako dopln\u011Bnou. Nezapome\u0148te ulo\u017Eit zm\u011Bny.";
        this.getPropertyInAncestors("ticketId");
        this.muVisible(!!this.getPropertyInAncestors("ticketId"), "lReject");
    }
    checkIsComplete(checked = true) {
        if (this.pqmPacketData.hasCheckbox) this.ui.isComplete.checked = checked;
    }
    isComplete() {
        return this.pqmPacketData.hasCheckbox ? this.ui.isComplete.checked : this.fieldWidget?.isFilled() ?? true;
    }
    getFieldData() {
        return {
            isComplete: this.ui.isComplete.style.display ? null : this.ui.isComplete.checked,
            requireCompletion: this.ui.reject.checked,
            value: this.fieldWidget?.getValue()
        };
    }
    setFieldData(item) {
        if (typeof item.isComplete === "boolean") this.ui.isComplete.checked = item.isComplete;
        if (this.fieldWidget) this.fieldWidget.setValue(item.value);
        this.requireCompletion = item.requireCompletion || false;
        this.ui.reject.checked = item.requireCompletion ?? false;
        this.update();
    }
    async afterSave(res) {
        return this.fieldWidget ? this.fieldWidget.afterSave(res) : null;
    }
    constructor(...args){
        super(...args);
        // @ts-ignore
        this.fieldWidget = null;
        this.disabled = false;
        this.requireCompletion = false;
    }
}

});

parcelRegister("MZo6F", function(module, exports) {

$parcel$export(module.exports, "PqmPackets", () => $1764b031fe354f71$export$2a1a965a51a7035c);

var $6Taw3 = parcelRequire("6Taw3");

var $kwZWC = parcelRequire("kwZWC");

var $5k56K = parcelRequire("5k56K");
function $1764b031fe354f71$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1764b031fe354f71$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1764b031fe354f71$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1764b031fe354f71$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1764b031fe354f71$var$_arrayLikeToArray(o, minLen);
}
function $1764b031fe354f71$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $1764b031fe354f71$export$2a1a965a51a7035c extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="proc-data-field--packets" mu-id="main">
				<div class="proc-data-field--packets--header">
					<h2 mu-id="label">Vstupy</h2>
					<div class="checkbox">
						<span class="btn btn-secondary icon-before-checked-on" mu-id="bCheckAll">ozna\u{10D}it v\u{161}e</span>
						<label class="checkbox"><input type="checkbox" mu-id="cSwitchDetails">Podrobnosti <span mu="detailsLabel"></span></label>
					</div>
				</div>
				<div mu="fields:TreeView">
					<div mu=":PqmField@item"></div>
				</div>
				<div mu="pRejectForm" style="display: none">
					<h3>Vy\u{17E}\xe1dat dopln\u{11B}n\xed pro vybran\xe9 vstupy</h3>
					<div mu="rejectReason:Htmlarea"></div>
					<div class="buttons">
						<span class="btn btn-primary" mu="bReject">Vy\u{17E}\xe1dat dopln\u{11B}n\xed</span>
					</div>
				</div>
			</div>
		`);
    }
    muBindData(srcData) {
        this.packetsData = srcData;
        super.muBindData(srcData);
        this.ui.label.innerText = srcData.isInput ? "Vstupy" : "V\xfdstupy";
        this.ui.detailsLabel.innerText = srcData.isInput ? "vstup\u016F" : "v\xfdstup\u016F";
        this.muVisible(!srcData.isInput, "bCheckAll");
        this.ui.fields.innerHTML = "";
        this.muNamedWidget.fields.render(srcData.packets, {
            srcStructFormat: "parentField",
            itemWidgetParams: {
                disabled: this.disabled
            }
        });
        this.ui.main.classList.toggle("proc-data-field--packets--disabled", this.disabled);
    }
    cSwitchDetails_change() {
        this.container.classList.toggle("details-visible", this.ui.cSwitchDetails.checked);
    }
    bCheckAll_click() {
        for(var _iterator = $1764b031fe354f71$var$_createForOfIteratorHelperLoose(this.muNamedWidget.fields.muSubWidgets), _step; !(_step = _iterator()).done;){
            const field = _step.value;
            /*@type PqmField */ field.checkIsComplete();
        }
    }
    async bReject_click() {
        const res = await this.cl.requireCompletion(this.muParent.pqmProcData.procDataId, this.getRejected(), this.muNamedWidget.rejectReason.muFetchData(), this.muParent.ticketId);
        (0, $kwZWC.flashInfo)(res ? "Bylo po\u017E\xe1d\xe1no o dopln\u011Bn\xed" : "Nem\xe1te opr\xe1vn\u011Bn\xed po\u017E\xe1dat o dopn\u011Bn\xed, byl pouze p\u0159id\xe1n koment\xe1\u0159.");
        this.getRejectedItems().forEach((widget)=>widget.markCompletion());
        this.updateRejected();
        this.callMethodInFirstAncestors("reloadTicketTree");
    }
    getData() {
        const res = {};
        for(var _i = 0, _arr = this.muNamedWidget.fields.muSubWidgets; _i < _arr.length; _i++){
            const fieldWidget = _arr[_i];
            res[fieldWidget.pqmPacketData.pqmPacketId] = fieldWidget.getFieldData();
        }
        return res;
    }
    setData(data) {
        for(var _i2 = 0, _arr2 = this.muNamedWidget.fields.muSubWidgets; _i2 < _arr2.length; _i2++){
            const fieldWidget = _arr2[_i2];
            if (data[fieldWidget.pqmPacketData.pqmPacketId]) fieldWidget.setFieldData(data[fieldWidget.pqmPacketData.pqmPacketId]);
        }
    }
    async afterSave(res) {
        const proms = [];
        for(var _i3 = 0, _arr3 = this.muNamedWidget.fields.muSubWidgets; _i3 < _arr3.length; _i3++){
            const fieldWidget = _arr3[_i3];
            proms.push(fieldWidget.afterSave(res));
        }
        return Promise.all(proms);
    }
    updateRejected() {
        this.muVisible(this.getRejected().length > 0 && this.packetsData.isInput, "pRejectForm");
    }
    getRejectedItems() {
        return this.muNamedWidget.fields.itemWidgets.filter((item)=>{
            const ch = item.ui.reject;
            return ch.checked && !ch.disabled;
        });
    }
    getRejected() {
        return this.getRejectedItems().map((item)=>item.pqmPacketData.pqmPacketId);
    }
    constructor(...args){
        super(...args);
        this.disabled = false;
        this.cl = new (0, $5k56K.PqmCL)();
    }
}

});

parcelRegister("ktZi8", function(module, exports) {

$parcel$export(module.exports, "PqmFieldText", () => $be36e02c5b533e5b$export$f2029d3bd31cbb78);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");

var $kwZWC = parcelRequire("kwZWC");
class $be36e02c5b533e5b$export$f2029d3bd31cbb78 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "string:multiLine",
            "string:singleLine",
            "string:html"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent({
            "multiLine": '<textarea mu="value#value" class="form-control"></textarea>',
            "singleLine": '<input type="text" mu="value#value" class="form-control" />',
            "html": '<div mu="value:Htmlarea#value"></div>'
        }[this.control]);
    }
    isFilled() {
        if (this.control === "string:html") return this.muNamedWidget.value.isInitialized() && !(0, $kwZWC.isHTMLStringEmpty)(this.getValue());
        else return super.isFilled();
    }
    async afterIndex() {
        if (this.muNamedWidget.value) {
            super.afterIndex();
            await this.muNamedWidget.value.waitForInit();
            this.onChange();
        }
    }
    setDisabled(disabled) {
        if (this.muNamedWidget.value) this.muNamedWidget.value.setDisabled(disabled);
        else this.ui.value.disabled = disabled;
    }
}
(0, $cnflh.PqmFieldRegister).register($be36e02c5b533e5b$export$f2029d3bd31cbb78);

});

parcelRegister("xnjgP", function(module, exports) {

$parcel$export(module.exports, "PqmFieldDate", () => $152fe80e3373abab$export$d5332bb304fc949);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");
class $152fe80e3373abab$export$d5332bb304fc949 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "date:date",
            "datetime:datetime"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent('<input type="' + ({
            "date": "date",
            "datetime": "datetime-local"
        })[this.control] + `" mu='value#value|dateToInput(` + (this.control === "date" ? "true" : "false") + `)' class="form-control" />`);
    }
}
(0, $cnflh.PqmFieldRegister).register($152fe80e3373abab$export$d5332bb304fc949);

});

parcelRegister("8C0Ku", function(module, exports) {

$parcel$export(module.exports, "PqmFieldDate", () => $8f7bb4a21c89c0e9$export$d5332bb304fc949);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");

var $kwZWC = parcelRequire("kwZWC");
class $8f7bb4a21c89c0e9$export$d5332bb304fc949 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "bool:*"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent({
            "chbox": '<input type="checkbox" mu="value#value" />',
            "yesNo": `<span class="rbl-horizontal-item">
				<label><input type="radio" mu-name="value" mu-change="value_change" mu-id="value_true" value="true">Ano</label>
				<label><input type="radio" mu-name="value" mu-change="value_change" mu-id="value_false" value="false">Ne</label>
				</span>`
        }[this.control]);
    }
    getValue() {
        return this.control === "chbox" ? this.ui.value.checked : JSON.parse((0, $kwZWC.getSelectedValue)(this.ui.value_true) || "null");
    }
    setValue(value) {
        if (this.control === "chbox") this.ui.value.checked = value;
        else (0, $kwZWC.setSelectedValue)(this.ui.value_true, JSON.stringify(value));
    }
    isFilled() {
        return this.control === "chbox" ? super.isFilled() : this.getValue() !== null;
    }
    setDisabled(disabled) {
        for(var _i = 0, _arr = [
            "value_true",
            "value_false",
            "value"
        ]; _i < _arr.length; _i++){
            const k = _arr[_i];
            if (this.ui[k]) this.ui[k].disabled = disabled;
        }
    }
}
(0, $cnflh.PqmFieldRegister).register($8f7bb4a21c89c0e9$export$d5332bb304fc949);

});

parcelRegister("64s6w", function(module, exports) {

$parcel$export(module.exports, "PqmFieldEnum", () => $358bf08a6f92bed5$export$5ebbf90e2793c8f2);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");
class $358bf08a6f92bed5$export$5ebbf90e2793c8f2 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "enum:*"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent({
            radioList: `<div mu="value:UiRadioList#value" class="radiolist-vertical"></div>`,
            radioListHorizontal: `<div mu="value:UiRadioList#value" class="radiolist-horizontal"></div>`,
            radioTree: `<div mu="value:TreeSelector#value" mu-params='{"inModal":true}'></div>`,
            select: `<select mu="value#value;numberingValues:@options" class="form-control"></select>`
        }[this.control]);
    }
    afterIndex() {
        if (this.numberingId) {
            const numberingValues = this.getPropertyInAncestors("pqmProcData").numberingValues[this.numberingId];
            switch(this.control){
                case "radioList":
                case "radioListHorizontal":
                    this.muNamedWidget.value.bindItems(numberingValues.map((nv)=>({
                            id: nv.id.toString(),
                            title: nv.name
                        })));
                    break;
                case "select":
                    this.muBindData({
                        numberingValues: [
                            {
                                value: "",
                                text: "-"
                            },
                            ...numberingValues.map((nv)=>({
                                    value: nv.id,
                                    text: nv.name
                                }))
                        ]
                    });
                    break;
                case "radioTree":
                    this.muNamedWidget.value.bindTree(numberingValues.map((nv)=>({
                            id: nv.id.toString(),
                            title: nv.name,
                            parentId: nv.parentId?.toString() || null
                        })));
                    break;
            }
        }
    }
    setDisabled(disabled) {
        if (this.muNamedWidget.value) this.muNamedWidget.value.setDisabled(disabled);
        else this.ui.value.disabled = disabled;
    }
}
(0, $cnflh.PqmFieldRegister).register($358bf08a6f92bed5$export$5ebbf90e2793c8f2);

});

parcelRegister("kAYTi", function(module, exports) {

$parcel$export(module.exports, "PqmFieldSet", () => $551328bd2995959c$export$7ee648d12b2b8e97);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");
class $551328bd2995959c$export$7ee648d12b2b8e97 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "set:*"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent({
            chboxList: `<div mu="value:UiChboxList#value" class="radiolist-vertical"></div>`,
            tags: `<div mu="value:UiTomSelect#value" class="radiolist-horizontal" mu-params='{"multiple":true}'></div>`
        }[this.control]);
    }
    afterIndex() {
        if (this.numberingId) {
            const numberingValues = this.getPropertyInAncestors("pqmProcData").numberingValues[this.numberingId];
            switch(this.control){
                case "chboxList":
                case "chboxListHorizontal":
                    this.muNamedWidget.value.bindItems(numberingValues.map((nv)=>({
                            id: nv.id.toString(),
                            title: nv.name
                        })));
                    break;
                case "tags":
                    this.muNamedWidget.value.bindItems(numberingValues);
                    break;
            }
        }
    }
    isFilled() {
        const v = this.getValue();
        return v && v.length > 0;
    }
    setDisabled(disabled) {
        this.muNamedWidget.value.setDisabled(disabled);
    }
}
// @ts-ignore
(0, $cnflh.PqmFieldRegister).register($551328bd2995959c$export$7ee648d12b2b8e97);

});

parcelRegister("xw3FD", function(module, exports) {

$parcel$export(module.exports, "PqmFieldAccount", () => $d0f0fc43d3d3e499$export$3b8a896c49a23e53);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");

var $kwZWC = parcelRequire("kwZWC");
class $d0f0fc43d3d3e499$export$3b8a896c49a23e53 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "account:*"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent(`<div mu="value:UiAccountSelector#value" mu-params="` + (0, $kwZWC.escapeHtml)(JSON.stringify({
            multiple: this.control === "account_accounts",
            inSameCompany: true
        })) + `"></div>`);
    }
    setDisabled(disabled) {
        this.muNamedWidget.value.setDisabled(disabled);
    }
}
(0, $cnflh.PqmFieldRegister).register($d0f0fc43d3d3e499$export$3b8a896c49a23e53);

});

parcelRegister("5HXez", function(module, exports) {

$parcel$export(module.exports, "PqmFieldOrgDivision", () => $c27c8185a8b600eb$export$48a8cb8de8cfa3e5);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");

var $kwZWC = parcelRequire("kwZWC");
class $c27c8185a8b600eb$export$48a8cb8de8cfa3e5 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "orgDivision:*"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.container.append((0, $kwZWC.createHtmlElement)("div", {
            mu: "value:TreeSelector#value",
            "mu-params": JSON.stringify({
                inModal: true
            })
        }));
    }
    async afterIndex() {
        this.muNamedWidget.value.bindTree(await this.getPropertyInAncestors("cpOrgDivision").fetch());
    }
    setDisabled(disabled) {
        this.muNamedWidget.value.setDisabled(disabled);
    }
}
// @ts-ignore
(0, $cnflh.PqmFieldRegister).register($c27c8185a8b600eb$export$48a8cb8de8cfa3e5);

});

parcelRegister("bpp3O", function(module, exports) {

$parcel$export(module.exports, "PqmFieldAttach", () => $ace90880b4cb32ac$export$b64d456b8d8c00f8);

var $3XMts = parcelRequire("3XMts");

var $cnflh = parcelRequire("cnflh");

var $jRjEI = parcelRequire("jRjEI");
class $ace90880b4cb32ac$export$b64d456b8d8c00f8 extends (0, $3XMts.BasePqmFieldValue) {
    static getValueTypes() {
        return [
            "attach:*"
        ];
    }
    beforeIndex() {
        // @ts-ignore
        this.muAppendContent(`
			<div mu="attachNew:MultiUpload"></div>
			<div mu="attachList:AttachList"></div>
		`);
    }
    isFilled() {
        return this.muNamedWidget.attachList.hasAnyAttach() || this.muNamedWidget.attachNew.getAllFiles().length > 0;
    }
    async afterIndex() {
        const data = this.getPropertyInAncestors("pqmProcData");
        if (data.procDataId) {
            await this.muNamedWidget.attachList.bindData({
                procDataId: data.procDataId,
                pqmPacketId: this.pqmPacketId
            });
            this.onChange();
        }
    }
    attachNew_change() {
        this.onChange();
    }
    async afterSave(res) {
        return await this.muNamedWidget.attachNew.sendToBackend((ctx, send)=>{
            ctx.url = this.rawUploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
                procDataId: res.procDataId,
                pqmPacketId: this.pqmPacketId,
                fileName: ctx.file.name,
                contentType: ctx.file.type,
                size: ctx.file.size
            }));
            send();
        });
    }
    setDisabled(disabled) {
        this.muVisible(!disabled, "attachNew");
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $jRjEI.TicketsCL)();
    }
}
// @ts-ignore
(0, $cnflh.PqmFieldRegister).register($ace90880b4cb32ac$export$b64d456b8d8c00f8);

});

parcelRegister("iUwjk", function(module, exports) {

$parcel$export(module.exports, "TOIPqm", () => $08fd2fb76edab21c$export$130a900b8176fc78);
$parcel$export(module.exports, "UiAccountList", () => $08fd2fb76edab21c$export$90c980d12ccd30cf);

var $7USbm = parcelRequire("7USbm");

var $6Taw3 = parcelRequire("6Taw3");
class $08fd2fb76edab21c$export$130a900b8176fc78 extends (0, $7USbm.BaseTOI) {
    beforeIndex() {
        this.container.classList.add("ticket-overview__item", "ticket-overview--pqm__item");
        this.muAppendContent(`
 			<div class="icon-before-play field-created"><span mu-bind='dtCreate|dateTime("d.m.Y")'></span></div>
			<a mu-id="link1" mu-bind='evidenceUid;id|prepend("id "):title' class="field-evidenceUid icon-before-document-numbers"></a>
			<a mu-id="link2" mu-bind='summary;id|prepend("id "):title' class="field-summary icon-before-detail"></a>
            <div class="field-state">
                <div class="badge" mu-bind="stateName;stateColor:style.backgroundColor;stateColor|bwContrasted:style.color"></div></div>
            </div>
			<div title="Zadavatel" mu=':UiAccountList#roles|filterRole("customer")' class="field-customer icon-before-customer"></div>
			<div title="\u{158}e\u{161}itel" mu=':UiAccountList#roles|filterRole("solver")' class="field-solver icon-before-solver"></div>
			<div title="Kalend\xe1\u{159}" mu-bind="calItems:@foreach">
			    <div mu=":.@item" class="icon-before-calendar">
			        <span mu='#dtFrom|dateTime("d.m.Y");typeName:title'></span>
                </div>
            </div>
       `);
    }
    filterRole(data, ev, roleCode) {
        return data.filter((a)=>a.roleCode === roleCode);
    }
    muBindData(srcData) {
        super.muBindData(srcData);
        this.srcData = srcData;
        this.getRouter().paTicket([
            this.container,
            this.ui.link1,
            this.ui.link2
        ], srcData);
    }
    container_click() {}
}
class $08fd2fb76edab21c$export$90c980d12ccd30cf extends (0, $6Taw3.BaseMuWidget) {
    muBindData(srcData) {
        this.container.innerText = srcData.map((a)=>a.name).join(", ");
    }
}

});

parcelRegister("6T4bi", function(module, exports) {

$parcel$export(module.exports, "TicketAccountSelector", () => $47cc0427c63a8684$export$be9fad67ed86c40b);

var $6Taw3 = parcelRequire("6Taw3");

var $chE5m = parcelRequire("chE5m");

var $kwZWC = parcelRequire("kwZWC");
class $47cc0427c63a8684$export$be9fad67ed86c40b extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="ticket-account-selector gap-1 align-items-center">
				<strong mu="label" class="a-nc"></strong>
				<span style="position: relative">
					<span mu="valuesStr" class="ticket-account-selector__value-str">Karolina Kvasnicov\xe1</span>
					<div mu="values:UiAccountSelector#values" class="ticket-account-selector__value flex-grow-1" style="display: none" mu-params='{"multiple": true}'></div>
				</span>
				<span class="a-nc float-right icon-before-person-swap" mu="bDelegate" title="Vybrat nad\u{159}\xedzen\xe9ho, pod\u{159}\xedzen\xe9ho nebo spolupracovn\xedka a odebrat m\u{11B}">Delegovat</span>
				<span class="a-nc float-right icon-before-add" mu="bAdd" title="Vybrat nad\u{159}\xedzen\xe9ho, pod\u{159}\xedzen\xe9ho nebo spolupracovn\xedka">P\u{159}idat</span>
			</div>
		`);
    }
    label_click(ev) {
        this.valuesStr_click(ev);
    }
    async valuesStr_click(ev) {
        ev.stopPropagation();
        this.muVisible(true, "values");
        this.muNamedWidget.values.focus();
        await (0, $kwZWC.oneShotHandler)(document, "click");
        this.muVisible(false, "values");
    }
    values_click(ev) {
        ev.stopPropagation();
    }
    async bDelegate_click() {
        if (await this.selectAndAdd("Delegovat")) this.removeMe();
        this.update();
    }
    async bAdd_click() {
        await this.selectAndAdd("P\u0159idat");
        this.update();
    }
    removeMe() {
        this.muNamedWidget.values.removeSelected(this.loggedAccountId);
    }
    async selectAndAdd(label) {
        const newAccountId = await (0, $chE5m.RelatedAccountSelector).open(label);
        if (newAccountId !== null) this.muNamedWidget.values.addSelected(newAccountId);
        return !!newAccountId;
    }
    values_change() {
        this.update();
    }
    values_changeText() {
        this.updateText();
    }
    update() {
        const vals = this.muNamedWidget.values.value;
        this.muVisible(vals?.includes(this.loggedAccountId.toString()) && this.useDelegate, "bDelegate");
        this.updateText();
    }
    updateText() {
        this.ui.valuesStr.innerHTML = this.muNamedWidget.values.getValueStr();
    }
    afterIndex() {
        this.update();
        this.ui.label.innerText = this.label;
        this.muVisible(this.useAdd, "bAdd");
    }
    muBindData(srcData) {
        this.muNamedWidget.values.muBindData(srcData);
    }
    muFetchData() {
        return this.muNamedWidget.values.muFetchData();
    }
    constructor(...args){
        super(...args);
        // @ts-ignore
        this.loggedAccountId = window.conf.accountId;
        this.label = "";
        this.useAdd = false;
        this.useDelegate = true;
    }
} /* export class TicketAccountSelectorOld extends BaseMuWidget
{
	public loggedAccountId: number = 1;
	public label: string = "";
	public useAdd: boolean = false;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		values:UiAccountSelector
	}>;

	public useDelegate = true;

	beforeIndex() {
		this.muAppendContent(`
			<div class="display-flex gap-1 align-items-center">
				<strong mu="label"></strong>
				<div mu="values:UiAccountSelector#values" mu-params='{"multiple": true}' class="flex-grow-1"></div>
				<span class="btn btn-primary icon-before-person-swap" mu="bDelegate" title="Vybrat nadřízeného, podřízeného nebo spolupracovníka a odebrat mě">Delegovat</span>
				<span class="btn btn-primary icon-before-add" mu="bAdd" title="Vybrat nadřízeného, podřízeného nebo spolupracovníka">Přidat</span>
			</div>
		`);
	}

	async bDelegate_click() {
		if (await this.selectAndAdd("Delegovat"))
			this.removeMe();
		this.update();
	}

	async bAdd_click() {
		await this.selectAndAdd("Přidat");
		this.update();
	}


	private removeMe() {
		this.muNamedWidget.values.removeSelected(this.loggedAccountId);
	}

	private async selectAndAdd(label: string): Promise<boolean> {
		const newAccountId = await RelatedAccountSelector.open(label);
		if (newAccountId !== null) {
			this.muNamedWidget.values.addSelected(newAccountId);
		}

		return !!newAccountId;
	}

	values_change() {
		this.update();
	}

	private update() {
		const vals = this.muNamedWidget.values.value;
		this.muVisible(vals?.includes(this.loggedAccountId.toString()) && this.useDelegate, 'bDelegate');
	}

	afterIndex() {
		this.update();
		this.ui.label.innerText = this.label;
		this.muVisible(this.useAdd, "bAdd");
	}

	muBindData(srcData: any) {
		this.muNamedWidget.values.muBindData(srcData);
	}

	muFetchData(): any {
		return this.muNamedWidget.values.muFetchData();
	}
} */ 

});

parcelRegister("f43qp", function(module, exports) {

$parcel$export(module.exports, "TicketTypeFormField", () => $7c6f7358908c2d75$export$3b3854e3d6fba168);

var $5d8um = parcelRequire("5d8um");

var $5exrP = parcelRequire("5exrP");

var $kwZWC = parcelRequire("kwZWC");
function $7c6f7358908c2d75$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7c6f7358908c2d75$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7c6f7358908c2d75$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7c6f7358908c2d75$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7c6f7358908c2d75$var$_arrayLikeToArray(o, minLen);
}
function $7c6f7358908c2d75$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $7c6f7358908c2d75$export$3b3854e3d6fba168 extends (0, $5d8um.TicketFormField) {
    afterIndex() {
        super.afterIndex();
        const inp = this.container.querySelector("input");
        let initValue = "";
        if (inp) {
            const onChange = (v)=>{
                this.updateFields(v);
            };
            if (inp.tagName === "SELECT") {
                inp.addEventListener("change", (ev)=>onChange(inp.value));
                initValue = inp.value;
            } else {
                const radioList = new (0, $5exrP.RadioList)(inp);
                radioList.onChange = (v)=>onChange(v);
                initValue = radioList.value;
            }
            this.muParent.muOnAfterIndex.push(()=>onChange(initValue));
        }
    }
    updateFields(v) {
        v = typeof v === "string" ? parseInt(v) : v;
        let all = [];
        let visible = [];
        for(var _iterator = $7c6f7358908c2d75$var$_createForOfIteratorHelperLoose(this.visibilityFieldsRules), _step; !(_step = _iterator()).done;){
            const rule = _step.value;
            all = [
                ...all,
                ...rule.fields
            ];
            if (rule.values.includes(v || -1)) visible = [
                ...visible,
                ...rule.fields
            ];
        }
        all = Array.from(new Set(all));
        visible = Array.from(new Set(visible));
        const hide = (0, $kwZWC.Arrays).diff(all, visible);
        this.muParent.muVisible(false, hide);
        this.muParent.muVisible(true, visible);
    }
    constructor(...args){
        super(...args);
        this.visibilityFieldsRules = [];
    }
}

});
parcelRegister("5exrP", function(module, exports) {

$parcel$export(module.exports, "RadioList", () => $f4deaeea0032244e$export$3dff5655255b5729);
function $f4deaeea0032244e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f4deaeea0032244e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f4deaeea0032244e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f4deaeea0032244e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f4deaeea0032244e$var$_arrayLikeToArray(o, minLen);
}
function $f4deaeea0032244e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $f4deaeea0032244e$export$3dff5655255b5729 {
    constructor(anyInput){
        this.onChange = null;
        // @ts-ignore
        this.allInputs = anyInput.form?.querySelectorAll("[name='" + anyInput.name + "']") || [];
        for(var _iterator = $f4deaeea0032244e$var$_createForOfIteratorHelperLoose(this.allInputs), _step; !(_step = _iterator()).done;){
            const inp = _step.value;
            inp.addEventListener("change", (ev)=>this.onChange && this.onChange(this.value, ev));
        }
    }
    get value() {
        for(var _iterator2 = $f4deaeea0032244e$var$_createForOfIteratorHelperLoose(this.allInputs), _step2; !(_step2 = _iterator2()).done;){
            const inp = _step2.value;
            if (inp.checked) return inp.value;
        }
        return null;
    }
    set value(v) {
        for(var _iterator3 = $f4deaeea0032244e$var$_createForOfIteratorHelperLoose(this.allInputs), _step3; !(_step3 = _iterator3()).done;){
            const inp = _step3.value;
            inp.checked = inp.value === v;
        }
    }
}

});


parcelRegister("1Ap5b", function(module, exports) {

$parcel$export(module.exports, "TicketRelField", () => $b8602f5600e13254$export$bfdd9beb3da17089);

var $dMN2n = parcelRequire("dMN2n");
class $b8602f5600e13254$export$bfdd9beb3da17089 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        let w = this;
        while(w){
            if ("loadTicket" in w) break;
            w = w.muParent;
        }
        if (w) this.container.querySelectorAll("a").forEach((a)=>a.addEventListener("click", (ev)=>{
                w.loadTicket(parseInt(a.dataset["ticketid"] ?? "0"));
                ev.preventDefault();
            }));
    }
}

});

parcelRegister("gd8XR", function(module, exports) {

$parcel$export(module.exports, "UiTicketFieldAttaches", () => $ebcb9f97da1b56bc$export$9982951424a10410);
$parcel$export(module.exports, "UiTicketFieldAttach", () => $ebcb9f97da1b56bc$export$e24a04d9133b1203);
$parcel$export(module.exports, "UiTicketAttachPreview", () => $ebcb9f97da1b56bc$export$fe24a9dd9947cc25);

var $4pyNk = parcelRequire("4pyNk");

var $5OSdp = parcelRequire("5OSdp");

var $cJjA3 = parcelRequire("cJjA3");
class $ebcb9f97da1b56bc$export$9982951424a10410 extends (0, $4pyNk.BaseWidget) {
}
class $ebcb9f97da1b56bc$export$e24a04d9133b1203 extends (0, $4pyNk.BaseWidget) {
    attachLink_click(ev) {
        ev.preventDefault();
        const opts = {
            ticketId: this.ticketId,
            attachId: this.attachId,
            link: this.ui.attachLink.href
        };
        const label = "N\xe1hled p\u0159\xedlohy " + this.ui.attachLink.innerText;
        if (this.openPreviewInModal) (0, $5OSdp.UiModalContainer).open("UiTicketAttachPreview", label, opts);
        else {
            this.muClear("preview");
            this.muWidgetFromTemplate("preview", "preview", opts);
        }
    }
    beforeIndex() {
        this.muAppendContent(`<div mu-id="preview">
			<div mu-template="preview" mu-widget="UiTicketAttachPreview"></div>
		</div>`);
    }
    constructor(...args){
        super(...args);
        this.attachId = -1;
        this.ticketId = -1;
        this.openPreviewInModal = false;
    }
}
class $ebcb9f97da1b56bc$export$fe24a9dd9947cc25 extends (0, $4pyNk.BaseWidget) {
    beforeIndex() {
        this.muAppendContent(`<div mu-id="preview"><div class="jumbotron text-center"><h3>Na\u{10D}\xedt\xe1m n\xe1hled</h3><progress></progress></div></div>
			<a mu-id="lAttaches" target="_blank" class="btn-icon-size-4 btn-icon icon-before-document-dir">P\u{159}ej\xedt na p\u{159}\xedlohy</a>
			<a mu-id="lDownload" target="_blank" class="btn-icon-size-4 btn-icon icon-before-download">St\xe1hnout p\u{159}\xedlohu</a>
			<span mu-click="muRemoveSelf" class="btn-icon-size-4 btn-icon icon-before-close">Zav\u{159}\xedt n\xe1hled</span>
		`);
    }
    async afterIndex() {
        this.ui.preview.innerHTML = await this.cl.getAttachDetail(this.attachId, this.ticketId);
        this.ui.lAttaches.href = this.link;
    }
    constructor(...args){
        super(...args);
        this.attachId = -1;
        this.ticketId = -1;
        this.cl = new (0, $cJjA3.InvoiceApprovalCL)();
        this.link = "";
    }
}

});

parcelRegister("lfPg5", function(module, exports) {

$parcel$export(module.exports, "InvoiceCreator", () => $21b19d44130e2dc9$export$850404613a6ae04c);
$parcel$export(module.exports, "InvoiceCreatorItem", () => $21b19d44130e2dc9$export$c93a43cd36b0e41a);

var $6Taw3 = parcelRequire("6Taw3");

var $cJjA3 = parcelRequire("cJjA3");

var $ffuEw = parcelRequire("ffuEw");

var $92Ocn = parcelRequire("92Ocn");

var $fnX8e = parcelRequire("fnX8e");

var $75oRH = parcelRequire("75oRH");

var $kwZWC = parcelRequire("kwZWC");

var $4pyNk = parcelRequire("4pyNk");

var $bxsP3 = parcelRequire("bxsP3");
function $21b19d44130e2dc9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $21b19d44130e2dc9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $21b19d44130e2dc9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $21b19d44130e2dc9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $21b19d44130e2dc9$var$_arrayLikeToArray(o, minLen);
}
function $21b19d44130e2dc9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $21b19d44130e2dc9$export$850404613a6ae04c extends (0, $4pyNk.BaseWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="alert alert-success" mu-id="pIsCreated">Doklad byl vytvo\u{159}en. Pro vytvo\u{159}en\xed dal\u{161}\xedho dokladu zalo\u{17E}te nov\xfd po\u{17E}adavek.</div>
			<div mu-id="pInvoice">
				<div mu-id="pInvoiceHeader" class="row">
					<div class="col-md-6">
						<h3>Informace o faktu\u{159}e</h3>
						<table class="table">
							<tbody>
								<tr>
									<td>\u{10C}\xedslo objedn\xe1vky</td>
									<td class="text-right"><input class="form-control" type="text" mu-bind="orderNumber" /></td>
								</tr>
								<tr>
									<td>Datum vystaven\xed</td>
									<td class="text-right"><input class="form-control" type="date" mu-bind="issueDate" /></td>
								</tr>
								<tr>
									<td>Splatnost</td>
									<td class="text-right"><input class="form-control" type="date" mu-bind="maturityDate" /></td>
								</tr>
								<tr>
									<td>DUZP</td>
									<td class="text-right"><input class="form-control" type="date" mu-bind="vatDate" /></td>
								</tr>
								<tr>
									<td>Variabiln\xed symbol</td>
									<td class="text-right"><input class="form-control" type="text" mu-bind="variableSymbol" /></td>
								</tr>
								<!-- <tr>
								<td>Kontantn\xed symbol</td>
								<td class="text-right"><input class="form-control" type="text" mu-bind="constantSymbol" /></td>
							</tr>
							<tr>
								<td>\u{10C}\xe1stka bez DPH</td>
								<td class="text-right" mu-bind="price|priceV"></td>
							</tr> -->
								<tr>
									<td>Intern\xed \u{10D}\xedslo faktury</td>
									<td class="text-right"><input class="form-control" type="text" mu-bind="invoiceNumber"></td>
								</tr>
								<tr>
									<td>M\u{11B}na</td>
									<td class="text-right"><select class="form-control" mu-bind="currencyId;currencies:@options"></select></td>
								</tr>
							</tbody>
						</table>
					</div>
			
					<div class="col-md-6">
						<h3>
							Dodavatel
						</h3>
						<div mu-widget="UiTomSelect" mu-id="vendorSelector" mu-bind="vendorId">
							<div mu-template="item" mu-widget=".">
								<strong mu-bind="name"></strong>
								<em mu-bind="identificationNumber"></em>
								<small mu-bind="city"></small>
							</div>
						</div>
						<table class="table" mu-widget="." mu-bind="vendor">
							<tbody>
								<tr>
									<td>N\xe1zev</td>
									<td class="text-right" mu-bind="name"></td>
								</tr>
								<tr>
									<td>I\u{10C}</td>
									<td class="text-right" mu-bind="identificationNumber"></td>
								</tr>
								<tr>
									<td>Ulice</td>
									<td class="text-right" mu-bind="street"></td>
								</tr>
								<tr>
									<td>M\u{11B}sto</td>
									<td class="text-right"><span mu-bind="zip_code"></span> <span mu-bind="city"></span></td>
								</tr>
							</tbody>
						</table>
						<div class="buttons">
							<span class="icon-before-add btn-icon btn-icon-size-4" mu-id="dAddVendor">P\u{159}idat dodavatele</span>
						</div>
					</div>
				</div>
			
				<div class="clearfix"></div>
				<div mu-id="attaches" mu-widget="UiAttaches"></div>
				<!-- <div mu-id="pAttaches" class="invoice-approval--attaches row">
					<div class="col-md-3" mu-id="pAttachesList">
						<h3>P\u{159}\xedlohy</h3>
						<ul mu-id="attachList" mu-bind="attachList:@foreach">
							<li mu-widget="InvoiceCreatorAttachesListItem" mu-template="attachListItem"
								mu-bind="id:.id;contentType:.contentType" class="invoice-approval--attach">
								<span class="invoice-approval--attache-item a" mu-id="name" mu-bind="fileName"></span>
							</li>
						</ul>
						<div class="text-center">
							<label class="checkbox" title="Zobrazit p\u{159}\xedlohy kter\xe9 pravd\u{11B}podobn\u{11B} nebosahuj\xed fakturu"><input mu-id="showAttachJunk" type="checkbox" />zobrazit v\u{161}e</label>
						</div>
					</div>
					<div class="col-md-9" mu-id="pPreview">
						<div mu-id="preview"></div>
						<div class="buttons"><span class="a" mu-id="bClosePreview">Zav\u{159}\xedt n\xe1hled</span></div>
					</div>
				</div> -->
			
				<h3>Polo\u{17E}ky</h3>
				<table class="invoice-creator-items table" mu-id="pItems">
					<thead>
						<tr>
							<th class="text-center"><input type="checkbox" mu-id="checkAll">
							</th>
							<th class="text-center">Bez projektu</th>
							<th class="text-center">Projekt</th>
							<th class="text-center">St\u{159}edisko - povinn\xe9</th>
							<th class="text-center">N\xe1zev</th>
							<th class="text-center">Po\u{10D}et</th>
							<th class="text-center">Cena za jednotku bez DPH</th>
						</tr>
					</thead>
					<tbody mu-id="items" mu-bind="items::@foreach">
						<tr mu-widget="InvoiceCreatorItem" mu-template="item">
							<td><input type="checkbox" mu-id="forSet" /></td>
							<td class="text-center"><input type="checkbox" mu-bind="withoutProject" mu-id="withoutProject" /></td>
							<td>
								<div mu-widget="UiTomSelect" mu-bind="projectId" mu-id="projectId"></div>
							</td>
							<!-- <td><div mu-widget="TreeSelector" mu-id="organizationUnitId" mu-bind="organizationUnitId" mu-params='{"inModal":true}'></div></div></td> -->
							<td>
								<div mu-widget="UiTomSelect" mu-id="organizationUnitId" mu-bind="organizationUnitId"></div>
							</td>
							<td><input type="text" class="form-control" mu-bind="name" /></td>
							<td><input type="number" step="0.01" class="form-control" mu-bind="quantity" /></td>
							<td><input type="number" step="0.01" class="form-control" mu-bind="unitPrice"></td>
							<td>
								<a class="btn-icon icon-before-remove" mu-id="bRemove"></a>
								<a class="btn-icon icon-before-sortable-handle handle"></a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			
			<div class="buttons" mu-id="pButtons">
				<span class="btn-icon-size-4 icon-before-plus btn-icon" mu-id="bAdd">P\u{159}idat polo\u{17E}ku</span>
				<span class="btn-icon-size-4 icon-before-question-blue btn-icon" mu-id="bCreate">Spustit schvalov\xe1n\xed</span>
				<span class="btn-icon-size-4 icon-before-checked-on btn-icon" mu-id="bCreateNoApproving">Bez schvalov\xe1n\xed</span>
				<span style="display: none" class="btn-icon-size-4 icon-before-checked-off btn-icon" mu-id="bCreateTest">Test</span>
			</div>
			
			<hr />
			<!-- <h3>Souvisej\xedc\xed</h3>
			<div mu-widget="UiTicketRels" mu-id="ticketRels"></div> -->
			
			
		`); // <input type="text" mu-id="importPath" /><span mu-id="bImport">importovat soubor</span>
        const relsEl = this.container.querySelector('[mu-id="ticketRels"]');
        if (relsEl) relsEl.setAttribute("mu-params", JSON.stringify({
            buSubjectId: this.buSubjectId,
            ticketId: this.ticketId,
            projectId: this.projectId
        }));
    }
    async bImport_click() {
        try {
            const eInv = await this.cl.withMessage("Hled\xe1m elektronickou verzi faktury").importDigitalInvoice(-1, this.ui.importPath.value);
            if (eInv) {
                this.muBindData(eInv);
                (0, $kwZWC.flashInfo)("Naimportoval jsem eletronickou verzi faktury.");
            }
        } catch (ex) {
            (0, $kwZWC.flashInfo)("Nepovedlo se naimportoval eletronickou verzi faktury.");
        }
    }
    async afterIndex() {
        this.updateForm();
        if (this.invoiceId) return;
        this.muNamedWidget.attaches.ticketId = this.ticketId;
        this.muNamedWidget.attaches.loadAttaches();
        const currDate = (0, $kwZWC.formatDate)("Y-m-d", new Date());
        this.muBindData({
            issueDate: currDate,
            maturityDate: currDate,
            vatDate: currDate,
            currencies: [
                // { value: "", text: "Vyberte měnu" },
                ...(await this.cl.getAllCurrency()).map((currency)=>({
                        value: currency.id,
                        text: currency.code + " (" + currency.currency + " - " + currency.country + ")"
                    }))
            ]
        });
        const vs = this.muNamedWidget.vendorSelector;
        vs.optionLoader = async (query, callback)=>{
            // @ts-ignore
            const findRes = await this.cl.findVendor(query);
            const res = findRes.items;
            if (findRes.isIco) this.lastIco = findRes.query;
            callback(res, []);
        };
        vs.init();
        try {
            const eInv = await this.cl.withMessage("Hled\xe1m elektronickou verzi faktury").importDigitalInvoice(this.ticketId, null);
            if (eInv) {
                this.muBindData(eInv);
                (0, $kwZWC.flashInfo)("Naimportoval jsem eletronickou verzi faktury.");
            } else {
                (0, $kwZWC.flashInfo)("Neexistuje eletronick\xe1 verze faktury.");
                this.bAdd_click();
            }
        } catch (ex) {
            (0, $kwZWC.flashInfo)("Nepovedlo se naimportoval eletronickou verzi faktury.");
        }
        new (0, $92Ocn.Sortable)(this.ui.items, {
            handle: ".handle"
        });
    }
    vendorSelector_changeValue() {
        this.muBindData({
            vendor: this.muNamedWidget.vendorSelector.valueOption
        });
    }
    bAdd_click() {
        this.muWidgetFromTemplate("item", "items");
    }
    checkAll_change() {
        this.muGetChildWidgets("items").forEach((w)=>w.ui.forSet.checked = this.ui.checkAll.checked);
    }
    setForAllItems(data) {
        this.muGetChildWidgets("items").forEach((w)=>{
            if (w.isChecked) {
                w.disableSetAll = true;
                w.muBindData(data);
                if ("projectId" in data) w.projectId_change();
                if ("withoutProject" in data) w.withoutProject_change();
                if ("organizationUnitId" in data) w.organizationUnitId_change();
                w.disableSetAll = false;
            }
        });
    }
    async doCreate(approvingMode) {
        const data = this.muFetchData();
        if (this.validate(data)) {
            const res = await this.cl.createInvoice(data, this.ticketId, approvingMode);
            for(var _iterator = $21b19d44130e2dc9$var$_createForOfIteratorHelperLoose(res.messages), _step; !(_step = _iterator()).done;){
                const message = _step.value;
                (0, $kwZWC.flashInfo)(message[0]);
            }
            this.invoiceId = res.invoiceId;
            this.updateForm();
            if (res.invoiceId) this.callMethodInFirstAncestors("onInvoiceCreated", this.ticketId);
            return res;
        } else (0, $kwZWC.flashError)("Opravte chyby ve formul\xe1\u0159i");
    }
    bCreate_click() {
        this.doCreate("approving");
    }
    bCreateNoApproving_click() {
        this.doCreate("approved");
    }
    async bCreateTest_click() {
        console.log(await this.doCreate("test"));
    }
    /* muFetchData(): any {
  	const data = super.muFetchData();
  	data.items = this.muGetChildWidgets('items').map(w => w.muFetchData());
  		return data;
  }
  	muBindData(srcData: any) {
  	super.muBindData(srcData);
  	this.muClear('items');
  	for(const item of srcData.items) {
  		this.muWidgetFromTemplate('item', 'items').muBindData(item);
  	}
  } */ validate(data) {
        let isValid = true;
        let errs = [];
        let vsrc = {
            data: data,
            prefix: ""
        };
        const addError = (field, message)=>{
            errs.push({
                field: vsrc.prefix + field,
                message: message
            });
        };
        const checkFill = (field, message)=>{
            if (!vsrc.data[vsrc.prefix + field]) addError(field, message);
        };
        checkFill("vendorId", "Vyberte dodavatele");
        checkFill("issueDate", "Zadejte datum vystaven\xed");
        checkFill("maturityDate", "Zadejte splatnost");
        checkFill("vatDate", "Zadejte DUZP");
        checkFill("variableSymbol", "Zadejte variabiln\xed symbol");
        checkFill("invoiceNumber", "Zadejte intern\xed \u010D\xedslo faktury");
        checkFill("currencyId", "Vyberte m\u011Bnu");
        if (!vsrc.data.items?.length) addError("items", "Mus\xed b\xfdt zad\xe1na aspo\u0148 jedna polo\u017Eka");
        // @ts-ignore
        let em = new (0, $75oRH.ErrorMarker)(this);
        em.clearErrors();
        em.markErrors(errs);
        isValid = isValid && errs.length == 0;
        errs = [];
        const witems = this.muGetChildWidgets("items");
        for(let i = 0; i < data.items.length; i++){
            const item = data.items[i];
            // vsrc.prefix = 'items/' + i.toString() + '/';
            vsrc.data = item;
            if (!item.withoutProject && !item.projectId) addError("projectId", 'Vyberte projekt nebo zaklikn\u011Bte "bez projektu"');
            checkFill("organizationUnitId", "Zadejte St\u0159edisko");
            checkFill("name", "Zadejte N\xe1zev");
            checkFill("quantity", "Zadejte Po\u010Det");
            checkFill("unitPrice", "Zadejte Cena za jednotku bez DPH");
            em = new (0, $75oRH.ErrorMarker)(witems[i]);
            em.markErrors(errs);
            isValid = isValid && errs.length == 0;
            errs = [];
        }
        return isValid;
    }
    updateForm() {
        this.muVisible(!!this.invoiceId, [
            "pIsCreated",
            "!pInvoice",
            "!pButtons"
        ]);
    }
    dAddVendor_click() {
        (0, $ffuEw.UiDms).instance = new (0, $ffuEw.UiDms)(null);
        (0, $ffuEw.UiDms).instance.cl = new (0, $bxsP3.DmsCL)();
        const editor = this.openInModal("UiBuSubjectEditor", "P\u0159idat nov\xe9ho dodavatele", {}, false);
        editor.ui.ic.focus();
        if (this.lastIco) {
            editor.ui.ic.value = this.lastIco;
            editor.bLoadFromAres_click();
        }
        editor.savedPromise.then((buSubject)=>{
            this.muBindData({
                vendorId: "bs:" + buSubject.id
            });
            editor.muRemoveSelf();
        });
    }
    constructor(...args){
        super(...args);
        this.buSubjectId = 5;
        this.projectId = null;
        this.cl = new (0, $cJjA3.InvoiceApprovalCL)();
        this.orgDivisionPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m organiza\u010Dn\xed jednotky").getOrgDivisions(this.buSubjectId, true));
        this.orgProjectPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m projekty").getOrgProjects(this.buSubjectId, true));
        this.orgProductPromise = new (0, $fnX8e.CachedPromise)(()=>this.cl.withMessage("Na\u010D\xedt\xe1m produkty").getOrgProducts(this.buSubjectId, true));
        this.lastIco = "";
    }
}
class $21b19d44130e2dc9$export$c93a43cd36b0e41a extends (0, $6Taw3.BaseMuWidget) {
    bRemove_click() {
        if (confirm("Odebrat tuto polo\u017Eku?")) this.muRemoveSelf();
    }
    afterIndex() {
        this.muNamedWidget.projectId.init({
            labelField: "title",
            searchField: [
                "title"
            ]
        });
        this.muNamedWidget.projectId.missingOptionLoader = async (ids, resolve)=>{
            const idsInt = ids.map((id)=>parseInt(id));
            const allp = await this.allProjects;
            resolve(allp.filter((item)=>idsInt.includes(item.id)), []);
        };
        (async ()=>{
            this.allProjects = this.muParent.orgProjectPromise.fetch();
            // this.muNamedWidget.organizationUnitId.bindTree(await this.muParent.orgDivisionPromise.fetch());
            this.muNamedWidget.organizationUnitId.init({
                labelField: "title",
                searchField: [
                    "title"
                ]
            });
            this.muNamedWidget.organizationUnitId.bindItems(await this.muParent.orgDivisionPromise.fetch());
            this.bindOrgProjects();
        })();
    }
    organizationUnitId_change() {
        this.bindOrgProjects();
        // this.setForAllItems({organizationUnitId: this.muNamedWidget.organizationUnitId.getValue()});
        this.setForAllItems({
            organizationUnitId: this.muNamedWidget.organizationUnitId.value
        });
    }
    async bindOrgProjects() {
        // const orgDivisionId = this.muNamedWidget.organizationUnitId.getValue();
        const orgDivisionId = this.muNamedWidget.organizationUnitId.value;
        this.muNamedWidget.projectId.tom.clearOptions();
        this.muNamedWidget.projectId.bindItems(orgDivisionId ? (await this.allProjects).filter((op)=>op.orgDivisionId == orgDivisionId) : await this.allProjects);
    }
    projectId_change() {
        const orgProjectOpt = this.muNamedWidget.projectId.valueOption;
        if (orgProjectOpt && !this.muNamedWidget.organizationUnitId.value) {
            // this.muNamedWidget.organizationUnitId.setSelected(orgProjectOpt.orgDivisionId, false);
            this.muNamedWidget.organizationUnitId.value = orgProjectOpt.orgDivisionId;
            this.setForAllItems({
                projectId: orgProjectOpt.id
            });
        }
    }
    withoutProject_change() {
        this.muVisible(!this.ui.withoutProject.checked, "projectId");
        this.setForAllItems({
            withoutProject: this.ui.withoutProject.checked
        });
    }
    get isChecked() {
        return this.ui.forSet.checked;
    }
    setForAllItems(data) {
        if (!this.disableSetAll) this.muParent.setForAllItems(data);
    }
    constructor(...args){
        super(...args);
        this.disableSetAll = false;
    }
}

});

parcelRegister("l8pp6", function(module, exports) {

$parcel$export(module.exports, "UiTicketRels", () => $ec5a5ab03aee8d8a$export$2d110773413a47da);
$parcel$export(module.exports, "UiTicketRelsItem", () => $ec5a5ab03aee8d8a$export$cfc56555901412b0);

var $6Taw3 = parcelRequire("6Taw3");

var $jRjEI = parcelRequire("jRjEI");
class $ec5a5ab03aee8d8a$export$2d110773413a47da extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muAppendContent(`
			<div class="display-flex">
				<div mu-widget="UiTomSelect" mu-id="ticketSelector" class="flex-grow-1">
					<div mu-widget="." mu-template="item">
						<strong mu-bind="evidenceUid"></strong> <span mu-bind="summary"></span>
					</div>
				</div>
				<span class="icon-before-add btn-icon btn-icon-size-3" mu-id="bAdd">P\u{159}ipojit souvisej\xedc\xed</span>			
			</div>
			<table class="table">
				<thead><tr><th>Ev. \u{10D}\xedslo</th><th>N\xe1zev</th><th>Stav</th></tr></thead>
				<tbody mu-id="items" mu-bind="items:@foreach">
					<tr mu-template="item" mu-widget="UiTicketRelsItem" mu-bind="id:.id;ticketRelId:.ticketRelId">
						<td><span mu-id="evidenceUid" class="a" mu-bind="evidenceUid"></span></td>
						<td><span mu-id="summary" class="a" mu-bind="summary"></span></td>
						<td><span mu-bind="stateName"></span></td>

						<td>
							<span class="icon-before-remove" mu-id="bRemove"></span>
						</td>
					</tr>
				</tbody>
			</table>
			<p mu-id="noItems">\u{17D}\xe1dn\xe9 souvisej\xedc\xed po\u{17E}adavky</p>
		`);
    }
    async afterIndex() {
        this.muNamedWidget.ticketSelector.init({
            optionLoader: async (q, resolv)=>resolv(await this.cl.findTickets(q, {
                    projectId: this.projectId,
                    buSubjectId: this.buSubjectId ? Array.isArray(this.buSubjectId) ? this.buSubjectId : [
                        this.buSubjectId
                    ] : null
                }), []),
            valueField: "id",
            searchField: [
                "summary",
                "evidenceUid"
            ],
            multiple: true
        });
        this.reloadList();
    }
    async bAdd_click() {
        this.reloadList(await this.cl.addTicketRels(this.ticketId, this.profile, this.muNamedWidget.ticketSelector.muFetchData(), true));
        this.muNamedWidget.ticketSelector.muBindData([]);
    }
    async reloadList(items = null) {
        if (items === null) items = await this.cl.getTicketRels(this.ticketId, this.profile);
        this.muBindData({
            items: items
        });
        this.muVisible(!!items, [
            "items",
            "!noItems"
        ]);
    }
    constructor(...args){
        super(...args);
        this.profile = {
            type: 3,
            direction: null
        };
        this.cl = new (0, $jRjEI.TicketsCL)();
        this.projectId = null;
        this.buSubjectId = null;
    }
}
class $ec5a5ab03aee8d8a$export$cfc56555901412b0 extends (0, $6Taw3.BaseMuWidget) {
    afterIndex() {}
    async bRemove_click() {
        if (confirm("Odebrat souvisej\xedc\xed po\u017Eadavek?")) {
            await this.muParent.cl.withMessage("Odeb\xedr\xe1m souvisej\xedc\xed po\u017Eadavek").dropTicketRels(this.ticketRelId);
            this.muParent.reloadList();
        }
    }
    evidenceUid_click() {
        this.doLoadTicket(this.id);
    }
    summary_click() {
        this.doLoadTicket(this.id);
    }
    doLoadTicket(id) {
        this.callMethodInFirstAncestors("loadTicket", id);
    }
}

});

parcelRegister("jDZcV", function(module, exports) {

$parcel$export(module.exports, "UiSplitByAttach", () => $1830380cc9107e64$export$26a270da6562f41);
$parcel$export(module.exports, "UiSplitByAttachList", () => $1830380cc9107e64$export$4383bef3d6ccd048);

var $6Taw3 = parcelRequire("6Taw3");

var $d4ug8 = parcelRequire("d4ug8");

var $92Ocn = parcelRequire("92Ocn");

var $jRjEI = parcelRequire("jRjEI");

var $kwZWC = parcelRequire("kwZWC");
function $1830380cc9107e64$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1830380cc9107e64$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1830380cc9107e64$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1830380cc9107e64$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1830380cc9107e64$var$_arrayLikeToArray(o, minLen);
}
function $1830380cc9107e64$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
class $1830380cc9107e64$export$26a270da6562f41 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.container.classList.add("row", "split-by-attach");
        this.muAppendContent(`
			<div class="row">
				<div class="col-md-12">
					<strong>Rozd\u{11B}len\xed po\u{17E}adavku</strong> <em mu-id="message"></em>
				</div>
				<div class="col-md-6" mu-id="pCurrent">
					<div mu-id="lsCurrent" mu-widget="UiSplitByAttachList" mu-params='{"name":"Aktu\xe1ln\xed po\u{17E}adavek","currentTicket":true}'></div>
				</div>
				<div class="col-md-6" mu-id="pNew">
					<div mu-id="newTickets" mu-bind="newItems::@foreach">
						<div mu-widget="UiSplitByAttachList" mu-template="item"></div>			
					</div>
					<div class="buttons">
						<span class="icon-before-add btn-icon btn-icon-size-4" mu-id="bAdd">Vytvo\u{159}it nov\xe9</span>
					</div>
					<ul mu-id="response" class="split-by-attach__new-tickets">
						<li mu-widget="." mu-template="newTicket">
							<a mu-bind="evidenceUid" mu-id="link"></a>
						</li>
					</ul>
				</div>
			</div>
		`);
    }
    afterIndex() {
        this.updateWidget();
        this.muNamedWidget.lsCurrent.initSortable(this);
        this.loadAttaches();
    }
    updateWidget() {
        let lastIsEmpty = false;
        let i = 1;
        let lastWidget = null;
        for(var _iterator = $1830380cc9107e64$var$_createForOfIteratorHelperLoose(this.muGetChildWidgets("newTickets")), _step; !(_step = _iterator()).done;){
            const wLs = _step.value;
            const isLast = !wLs.container.nextSibling;
            if (isLast) {
                lastIsEmpty = wLs.isEmpty();
                lastWidget = wLs;
            } else if (wLs.isEmpty()) wLs.muRemoveSelf();
            wLs.setName("Nov\xfd po\u017Eadavek " + (i++).toString());
        }
        if (!lastIsEmpty) this.muWidgetFromTemplate("item", "newTickets").setName("Nov\xfd po\u017Eadavek").initSortable(this);
        else lastWidget?.setName("Nov\xfd po\u017Eadavek");
    }
    muFetchData() {
        const src = super.muFetchData();
        const res = src.newItems.map((td)=>({
                ...td,
                items: td.items.map((ad)=>parseInt(ad.id))
            })).filter((ids)=>ids.items.length > 0);
        return res;
    }
    async bAdd_click() {
        this.showSplitResult(await this.cl.withMessage("Vytv\xe1\u0159\xedm nov\xe9 po\u017Eadavky").splitTicketByAttach(this.ticketId, this.muFetchData()));
    // todo:: zobrazení výsledků
    }
    async loadAttaches() {
        const attaches = await this.cl.withMessage("Na\u010D\xedt\xe1m p\u0159\xedlohy").getAttachesFotTicketAndRelated(this.ticketId);
        this.muVisible(!!attaches.length, [
            "pCurrent",
            "pNew"
        ]);
        this.ui.message.innerText = !attaches.length ? "Neexistuj\xed p\u0159\xedlohy, nen\xed mo\u017En\xe9 rozd\u011Blit" : "";
        this.muNamedWidget.lsCurrent.muClear("attaches");
        for(var _iterator2 = $1830380cc9107e64$var$_createForOfIteratorHelperLoose(attaches), _step2; !(_step2 = _iterator2()).done;){
            const att = _step2.value;
            this.muNamedWidget.lsCurrent.muWidgetFromTemplate("item", "attaches").muBindData(att);
        }
    }
    showSplitResult(tickets) {
        const router = this.getPropertyInAncestors("router");
        for(var _i = 0, _tickets = tickets; _i < _tickets.length; _i++){
            const ticket = _tickets[_i];
            const w = this.muWidgetFromTemplate("newTicket", "newTickets", {});
            w.muBindData(ticket);
            router.prepareAnchor(w.ui.link, "ticket", {
                ticketId: ticket.id.toString()
            });
        }
        if (tickets.length === 0) (0, $kwZWC.flashError)("Nebyly vybr\xe1ny p\u0159\xedlohy pro p\u0159esun do nov\xe9ho po\u017Eadavku");
        this.ui.newTickets.innerHTML = "";
        this.updateWidget();
        this.loadAttaches();
        this.callMethodInFirstAncestors("loadList", false);
    }
    constructor(...args){
        super(...args);
        this.ticketId = 106753;
        this.cl = new (0, $jRjEI.TicketsCL)();
        this.uid = (0, $d4ug8.MuUIDs).next("id");
    }
}
class $1830380cc9107e64$export$4383bef3d6ccd048 extends (0, $6Taw3.BaseMuWidget) {
    setName(name) {
        this.ui.lName.innerText = name;
        return this;
    }
    beforeIndex() {
        this.container.classList.add("split-by-attach__attach-list");
        if (this.currentTicket) this.container.classList.add("split-by-attach__attach-list--current");
        this.muAppendContent(`
			<h4 mu-id="lName"></h4>
			<ul mu-id="attaches" class="split-by-attach__attach-list-attaches" mu-bind="items::@foreach"><li 
					class="icon-before-document-file" mu-template="item" mu-widget="." 
					mu-bind='id::@attr.data-id;inTextImage|tern("split-by-attach__attach-list__item--in-text","")|prepend("icon-before-document-file "):className'>
					<span mu-bind="fileName"></span>
				</li></ul>
			` + (this.currentTicket ? `<div class="checkbox">
					<label>
						<input type="checkbox" mu-id="cShowAll">
						Zobrazit v\u{161}e
					</label>
				</div>` : "") + `
		`);
    }
    cShowAll_change() {
        this.container.classList.toggle("split-by-attach__attach-list--hide-inline", !this.ui.cShowAll.checked);
    }
    afterIndex() {
        this.setName(this.name);
        if (this.currentTicket) this.cShowAll_change();
    }
    isEmpty() {
        return this.ui.attaches.childElementCount === 0;
    }
    initSortable(parentWidget) {
        new (0, $92Ocn.default)(this.ui.attaches, {
            group: parentWidget.uid,
            onChange: ()=>parentWidget.updateWidget()
        });
    }
    constructor(...args){
        super(...args);
        this.name = "";
        this.currentTicket = false;
    }
}

});

parcelRegister("71Nh7", function(module, exports) {

$parcel$export(module.exports, "UiAttaches", () => $21b93091ad5d1038$export$943a60a71cf5e9f8);
$parcel$export(module.exports, "InvoiceCreatorAttachesListItem", () => $21b93091ad5d1038$export$7dcf4c2231b2f247);

var $6Taw3 = parcelRequire("6Taw3");

var $jRjEI = parcelRequire("jRjEI");

var $kwZWC = parcelRequire("kwZWC");
class $21b93091ad5d1038$export$943a60a71cf5e9f8 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.container.classList.add("attaches");
        this.muAppendContent(`
			<!-- div mu-id="pAttaches" class="" -->
				<strong mu-id="label">P\u{159}\xedlohy</strong>
				<strong><span mu-id="pPreviewLabel">N\xe1hled</span></strong>
				<div class="grid-row-s2 attaches__list" mu-id="pAttachesList">
					<ul mu-id="attachList" mu-bind="attachList:@foreach">
						<li mu-widget="InvoiceCreatorAttachesListItem" mu-template="attachListItem"
							mu-bind="id:.id;contentType:.contentType" class="invoice-approval--attach">
							<span class="invoice-approval--attache-item a icon-before-document-file" mu-id="name" mu-bind="fileName;fileName:@attr.title"></span>
						</li>
					</ul>
					<div class="text-center checkbox" mu-id="pShowJunk">
						<label class="" title="Zobrazit p\u{159}\xedlohy kter\xe9 pravd\u{11B}podobn\u{11B} neobsahuj\xed fakturu"><input mu-id="showAttachJunk" type="checkbox" />
							zobrazit v\u{161}e (<span mu-id="fullCount"></span>)
						</label>
					</div>
				</div>
				<div class="attaches__preview">
					<div mu-id="preview"></div>
				</div>
				<div class="buttons" mu-id="previewButtons">
					<a target="_blank" class="btn-icon btn-icon-size-5 icon-before-download" mu-id="bDownload">St\xe1hnout</a>
					<span class="btn-icon btn-icon-size-5 icon-before-close" mu-id="bClosePreview">Zav\u{159}\xedt n\xe1hled</span>
				</div>
			<!-- /div -->` + (this.upladEnabled ? `<div class="grid-column-s2 display-flex-row">
						<div mu-id="mupNewAttach" mu-widget="MultiUpload" class="flex-grow-1"></div>
						<div class="buttons flex-grow-0" mu-id="pUploadButton"><span class="btn-icon btn-icon-size-5 icon-before-up" mu-id="bUploadButton">Ulo\u{17E}it vybran\xe9 p\u{159}\xedlohy</span></div>
					</div>` : "") + ``);
    }
    afterIndex() {
        this.ui.label.innerText = this.label;
        this.mupNewAttach_change();
        this.bClosePreview_click();
        if (this.ticketId) this.loadAttaches();
    }
    mupNewAttach_change() {
        if (this.muNamedWidget.mupNewAttach) this.muVisible(this.muNamedWidget.mupNewAttach.getAllFiles().length > 0, "pUploadButton");
    }
    async bUploadButton_click() {
        var res = await this.muNamedWidget.mupNewAttach.sendToBackend((ctx, send)=>{
            ctx.url = this.uploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
                ticketId: this.ticketId,
                fileName: ctx.file.name,
                contentType: ctx.file.type,
                size: ctx.file.size
            }));
            send();
        });
        this.loadAttaches();
        this.muNamedWidget.mupNewAttach.clear();
    }
    loadAttaches() {
        // @ts-ignore
        this.cl.getAttachesFotTicketAndRelated(this.ticketId).then((data)=>{
            this.muBindData({
                attachList: data /*.filter(a => a.fileName)*/ 
            });
            this.muVisible(!!data.length || this.upladEnabled, ".");
            this.muVisible(!!this.container.querySelector(".invoice-approval--attach__is-junk"), "pShowJunk");
            this.ui.fullCount.innerText = data.length;
            this.attachesById = (0, $kwZWC.Arrays).ToObject(data, "id");
        });
    }
    showAttach(id) {
        this.ui.bDownload.href = this.attachesById[id].dowloadLink;
        this.cl.getAttachDetail(id, this.ticketId).then((data)=>{
            this.ui.preview.innerHTML = data;
            this.muVisible(true, [
                "preview",
                "previewButtons",
                "pPreviewLabel"
            ]);
        // @ts-ignore
        });
    }
    bClosePreview_click() {
        this.ui.preview.innerHTML = "";
        this.muVisible(false, [
            "preview",
            "previewButtons",
            "pPreviewLabel"
        ]);
    }
    showAttachJunk_change(ev) {
        ev.cancelBubble = true;
        ev.stopPropagation();
        this.container.classList.toggle("attaches__show-is-junk", this.ui.showAttachJunk.checked);
    }
    constructor(...args){
        super(...args);
        this.upladEnabled = false;
        this.ticketId = null;
        this.cl = new (0, $jRjEI.TicketsCL)();
        this.uploadUrl = "/ticket/upload-raw-attach";
        this.label = "P\u0159\xedlohy";
    }
}
class $21b93091ad5d1038$export$7dcf4c2231b2f247 extends (0, $6Taw3.BaseMuWidget) {
    name_click() {
        this.muParent.showAttach(this.id);
    }
    muAfterBindData(data) {
        let isJunk = true;
        const contentType = data.contentType.toLowerCase();
        if (!data.inTextImage) {
            if ([
                "application/msword",
                "application/pdf",
                "application/vnd.ms-excel",
                "application/vnd.ms-office",
                "application/vnd.oasis.opendocument.spreadsheet",
                "application/vnd.oasis.opendocument.text",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ].includes(contentType)) isJunk = false;
            else isJunk = !contentType.startsWith("image/") || data.fileSize < 14336;
        }
        this.container.classList.toggle("invoice-approval--attach__is-junk", isJunk);
        this.isJunk = isJunk;
    }
    constructor(...args){
        super(...args);
        this.isJunk = false;
    }
}

});

parcelRegister("6fLqv", function(module, exports) {

$parcel$export(module.exports, "UiProductImport", () => $381deaf08bd2aa98$export$9b2338f1aa79fe3a);

var $kwZWC = parcelRequire("kwZWC");

var $bxsP3 = parcelRequire("bxsP3");

var $3cBch = parcelRequire("3cBch");

var $6Taw3 = parcelRequire("6Taw3");
class $381deaf08bd2aa98$export$9b2338f1aa79fe3a extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.setPageTitle("Produkty");
        this.container.classList.add("project-import");
        this.muAppendContent(`
			<div class="project-import__src-data" mu-id="pSrcData">
				<div class="row form-group">
					<label class="col-md-3">Firma:</label>
					<div class="col-md-9">
						<div mu-widget="UiRadioList" mu-id="buSubject" class="checkbox"></div>
					</div>
				</div>
				<div class="form-group">
					<label mu-for="srcData">Zdrojov\xe1 data:</label>
					<textarea mu-id="srcData" placeholder="Sem zkop\xedrujte zdrojov\xe1 data" class="form-control"></textarea>
				</div>
				<div class="buttons"><span class="btn btn-primary" mu-id="bCheck">Zkontrolovat</span></div>
			</div>
			<div mu-id="pPreview">
				<h2 class="_icon-before-warning _icon-before--autosize">V\xfdsledek kontroly: <span mu-id="checkResult"></span></h2>
				<div class="buttons">
					<span class="btn btn-primary" mu-id="bImport">Importovat</span>
					<span class="btn btn-default" mu-id="bBack">Zp\u{11B}t</span>
				</div>
				<ul mu-bind="messages:@foreach">
					<li mu-template="message" mu-widget=".">
						<code mu-bind="cellCode"></code>
						<span mu-bind="message;type:className"></span>
					</li>
				</ul>
			</div>
			<div>
				<h2>Aktu\xe1ln\xed data</h2>
				<span class="a icon-before-download" mu-id="bLoad">Na\u{10D}\xedst</span>
				<span class="a icon-before-copy" mu-id="bCopy">Zkop\xedrovat</span>
				<table class="table" mu-id="exampleTable">
					<thead>
						<tr>
							<th>K\xf3d</th>
							<th>N\xe1zev</th>
							<th>Da\u{148}</th>
						</tr>					
					</thead>
					<tbody mu-id="items" mu-bind="items:@foreach">
						<tr mu-template="item" mu-widget=".">
							<td mu-bind="code"></td>
							<td mu-bind="name"></td>
							<td mu-bind="vat" class="number"></td>
						</tr>
					</tbody>
				</table>
			</div>
		`);
    }
    async afterIndex() {
        this.setMode("srcData");
        this.muNamedWidget.buSubject.bindItems((await this.cl.getMyBuSubjects()).write.map((bsu)=>({
                id: bsu.id,
                title: bsu.name
            })));
    }
    async bCheck_click() {
        const buSubjectId = this.muNamedWidget.buSubject.value;
        if (buSubjectId == null) {
            (0, $3cBch.UiFlashMessage).instance.add("Vyberte firmu");
            return;
        }
        if (!this.ui.srcData.value) {
            (0, $3cBch.UiFlashMessage).instance.add("Zadejte zdrojov\xe1 data");
            return;
        }
        const data = await this.cl.checkProductsImport(this.ui.srcData.value, parseInt(buSubjectId));
        this.muBindData(data);
        this.setMode("preview");
        this.muVisible(data.status !== "error", "bImport");
        this.lastStatus = data.status;
        const resMsg = {
            ok: "v po\u0159\xe1dku",
            warning: "drobn\xe9 chyby",
            error: "v\xe1\u017En\xe9 chyby"
        };
        this.ui.checkResult.innerText = resMsg[this.lastStatus];
    }
    async bLoad_click() {
        if (this.muNamedWidget.buSubject.value) {
            const data = await this.cl.getAllProducts(parseInt(this.muNamedWidget.buSubject.value));
            this.muBindData({
                items: data
            });
        } else (0, $kwZWC.flashInfo)("Nejprve vyberte firmu");
    }
    async bImport_click() {
        if (this.lastStatus === "ok" || confirm("V importu jsou drobn\xe9 chyby, chcete p\u0159esto naiportovat?")) {
            const buSubjectId = this.muNamedWidget.buSubject.value;
            // @ts-ignore
            await this.cl.productsImport(this.ui.srcData.value, parseInt(buSubjectId));
            (0, $3cBch.UiFlashMessage).instance.add("Naimportov\xe1no");
        }
    }
    bBack_click() {
        this.setMode("srcData");
    }
    bCopy_click() {
        (0, $kwZWC.copyToClipoard)(this.ui.exampleTable.outerHTML, "html");
    }
    setMode(mode) {
        this.muVisible(mode == "preview", [
            "pPreview",
            "!pSrcData"
        ]);
    }
    constructor(...args){
        super(...args);
        this.cl = new (0, $bxsP3.DmsCL)();
        this.lastStatus = "ok";
    }
}

});

parcelRegister("kclTr", function(module, exports) {

$parcel$export(module.exports, "Attaches2", () => $8334cc5a450f3a87$export$f9a3b03428b00c46);

var $6Taw3 = parcelRequire("6Taw3");

var $kwZWC = parcelRequire("kwZWC");

var $jRjEI = parcelRequire("jRjEI");
class $8334cc5a450f3a87$export$f9a3b03428b00c46 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.container.classList.add("row");
        this.muAppendContent(`
	<div mu-id="treeConatiner" class="overflow-auto">
		<table class="table table-hover" mu-id="tree">
			<thead>
				<tr>
					<th>
						<span class="float-right" mu-id="addContainer">
							P\u{159}idat: 
							<span mu-id="addFolder" class="icon-document-dir"></span>
							<span mu-id="addFile" class="icon-document-file"></span>
						</span>
						Soubor
					</th>
					<th class="mini-hide">Vlo\u{17E}il</th>
					<th class="mini-hide">Vlo\u{17E}eno</th>
					<th class="mini-hide">Typ</th>
					<th class="mini-hide text-right">Velikost</th>
				</tr>
			</thead>
			<tbody mu-noindex="1">
				<tr mu-widget="AttachItem">
					<td mu-id="fileName"></td>
					<td class="mini-hide" mu-id="accountName"></td>
					<td class="mini-hide" mu-id="dtAdd"></td>
					<td class="mini-hide" mu-id="typeTitle"></td>
					<td class="mini-hide text-right" mu-id="fileSize"></td>
				</tr>
			</tbody>
		</table>
	</div>
	<div mu-id="detail" class="col-md-9">
		<h4 class="display-flex">
			<span class="flex-grow-1">Detail <span mu-id="detail_fileName"></span></span>
			<span mu-id="btClose" class="close flex-grow-0">&times;</span>
		</h4>
		<div>
			V <span mu-id="detail_dtAdd"></span> 
			vlo\u{17E}il <strong mu-id="detail_accountName"></strong>, 
			typ <strong mu-id="detail_typeTitle"></strong>, 
			velikost <span mu-id="detail_fileSize"></span>
		</div>
		<div mu-id="detail_description"></div>
		<div>
			<span class="btn btn-primary icon-before-download" mu-id="btDownload"></span>
			<span class="btn btn-default icon-before-edit" mu-id="btEdit"></span>
			<span class="btn btn-danger icon-before-trash" mu-id="btDelete"></span>
		</div>
		<div mu-id="previewBlock" class="preview">
			<h4>N\xe1hled</h4>
			<div mu-id="previewContainer"></div>
		</div>
	</div>
	<div mu-id="editBlock" class="col-md-9">
		<h4 class="display-flex">
			<span mu-id="editTitle" class="close flex-grow-1"></span>
			<span mu-id="btCloseEdit" class="close flex-grow-0">&times;</span>
		</h4>
		<div mu-id="editor" mu-widget=".">
			<div class="row">
				<label mu-for="file" class="col-form-label col-md-3">Soubor(y)</label>
				<div class="col-md-9">
					<div mu="files:MultiUpload"></div>
					<div mu="file:MultiUpload" mu-params='{"single":true}'></div>					
				</div>
			</div>
			<div class="row">
				<label mu-for="fileName" class="col-form-label col-md-3">N\xe1zev</label>
				<div class="col-md-9">
					<input type="text" mu="fileName#fileName" class="form-control" />
				</div>
			</div>
			<div class="row">
				<label mu-for="description" class="col-form-label col-md-3">Popis</label>
				<div class="col-md-9">
					<textarea type="description" mu-bind="description" class="form-control"></textarea>
				</div>
			</div>
		</div>
		<div class="buttons"><span class="btn btn-primary icon-before-yes" mu="bSave">Ulo\u{17E}it</span></div>
	</div>`);
    }
    async afterIndex() {
        this.toggleLayout("list");
        this.tree = $(this.ui.tree).fancytree({
            extensions: [
                "table",
                "dnd"
            ],
            renderColumns: (ev, data)=>this.initRow(ev, data),
            activate: (ev, data)=>this.activateRow(ev, data),
            dnd: {
                autoExpandMS: 400,
                focusOnClick: true,
                preventVoidMoves: true,
                preventRecursiveMoves: true,
                dragStart: (node, data)=>true,
                dragEnter: (node, data)=>true,
                dragDrop: (node, data)=>this.handleDragDrop(node, data)
            }
        }).fancytree("getTree");
        const urlHash = window.location.hash;
        let res1 = null;
        if (res1 = urlHash.match(/id=([^;]+)/)) this.attachId = parseInt(res1[1]);
        else if (res1 = urlHash.match(/attach-([^;]+)/)) this.attachId = parseInt(res1[1]);
        if (Object.keys(this.ids).length) await this.reloadAttaches();
    }
    handleDragDrop(node, data) {
        if (!node.folder) return false;
        this.ajax("move", {
            id: data.otherNode.key,
            parentId: node.key
        }, (responseData)=>{
            if (responseData.errors) this.showError(responseData.errors);
            else data.otherNode.moveTo(node, responseData.hitMode);
        });
    }
    initRow(event, data) {
        this.muActivateWidget(data.node.tr, undefined, {
            node: data.node
        });
    }
    activateRow(event, data) {
        this.bindDetail(data.node);
        this.toggleLayout("detail");
        this.muVisible(data.node.folder, "addContainer");
        this.muVisible(data.node.key !== "root", [
            "btEdit",
            "btDelete"
        ]);
        this.attachId = parseInt(data.node.key);
        window.location.hash = "id=" + data.node.key;
    }
    async addFolder_click() {
        const name = prompt("Zadejte n\xe1zev nov\xe9 slo\u017Eky");
        if (name) {
            await this.cl.createFolder(this.ids, name, this.attachId);
            (0, $kwZWC.flashInfo)("Slo\u017Eka byla vytvo\u0159ena");
            this.reloadAttaches();
        }
    }
    async reloadAttaches() {
        return new Promise(async (resolve, reject)=>{
            const data = await this.cl.getBcmAttachesFor(this.ids);
            this.tree.reload(data).done(()=>{
                let n = this.tree.getNodeByKey(this.attachId?.toString());
                if (n) {
                    n.setActive(true);
                    while(n){
                        n.setExpanded(true);
                        n = n.parent;
                    }
                }
                const rootNode = this.tree.getNodeByKey("root");
                if (rootNode) rootNode.setExpanded(true);
                resolve();
            });
        });
    }
    addFile_click() {
        this.loadEditor(null, this.attachId);
    }
    async bindDetail(node) {
        for(var _i = 0, _arr = [
            "typeTitle",
            "fileSize",
            "accountName",
            "dtAdd",
            "description"
        ]; _i < _arr.length; _i++){
            const k = _arr[_i];
            this.ui["detail_" + k].innerText = node.data[k];
        }
        this.ui.detail_fileName.innerText = node.title;
        this.muVisible(node.data.previewAvailable, "previewBlock");
        this.ui.previewContainer.innerHTML = "Na\u010D\xedt\xe1m n\xe1hled";
        if (node.data.previewAvailable) this.ui.previewContainer.innerHTML = await this.cl.getAttachDetail(parseInt(node.key), null);
    }
    async loadEditor(id, parentId) {
        this.id = id;
        this.parentId = parentId;
        this.toggleLayout("edit");
        let data, label = "";
        if (id) {
            data = await this.cl.getAttachData(parseInt(id), null);
            label = "Upravit " + data.fileName;
        } else {
            data = {
                fileName: "",
                description: "",
                id: null,
                parentId: parentId
            };
            label = "Nov\xe1 p\u0159\xedloha";
        }
        const n = !id;
        const f = data.contentType === ".folder";
        this.muNamedWidget.editor.muVisible(!n && !f, "file");
        this.muNamedWidget.editor.muVisible(n, "files");
        this.muNamedWidget.editor.muVisible(!n || f, "fileName");
        this.ui.editTitle.innerText = label;
        this.muNamedWidget.editor.muBindData(data);
    }
    async bSave_click() {
        const data = this.muNamedWidget.editor.muFetchData();
        if (!this.id) data.parentId = this.parentId;
        const saveAttach = async (data)=>{
            await this.cl.saveAttach(this.id, this.ids, data);
        };
        const prepareAttach = async (context, data)=>{
            context.url = await this.cl.newTempFile();
            data.file = {
                tmpFile: context.url,
                fileName: context.file.name,
                contentType: context.file.type,
                fileSize: context.file.size
            };
        };
        if (this.id) {
            await this.muNamedWidget.editor.muNamedWidget.file.sendToBackend(async (context, send)=>{
                await prepareAttach(context, data);
                await send();
                (0, $kwZWC.flashInfo)("P\u0159\xedloha byla aktualizov\xe1na");
            });
            await saveAttach(data);
        } else await this.muNamedWidget.editor.muNamedWidget.files.sendToBackend(async (context, send)=>{
            const newData = {
                ...data
            };
            await prepareAttach(context, newData);
            await send();
            await saveAttach(newData);
            (0, $kwZWC.flashInfo)("P\u0159\xedloha byla ulo\u017Eena");
        });
        await this.reloadAttaches();
    }
    toggleLayout(state) {
        this.ui.tree.classList.toggle("mini", state != "list");
        this.ui.treeConatiner.classList.toggle("col-md-3", state != "list");
        this.muVisible(state == "detail", "detail");
        this.muVisible(state == "edit", "editBlock");
    }
    btClose_click(event, data) {
        this.toggleLayout("list");
    }
    btCloseEdit_click(event, data) {
        this.toggleLayout("detail");
    }
    btDownload_click() {
        window.open("/attach-download/" + this.attachId + "/0", "_blank");
    }
    btEdit_click() {
        this.loadEditor(this.attachId);
    }
    btReplace_click() {}
    btArchive_click() {}
    btDelete_click() {
        if (confirm("Opravdu smazat?")) this.ajax("delete", {
            id: this.attachId
        }, function(data) {
            if (data.errors) this.showError(data.errors);
            else {
                (0, $kwZWC.flashInfo)("Smaz\xe1no");
                this.attachId = parseInt(this.tree.getNodeByKey("root").parent.key);
                this.reloadAttaches();
            }
        });
    }
    showError(error) {
        if (Array.isArray(error)) {
            var hUl = document.createElement("ul");
            res.errors.forEach((msg)=>{
                var hLi = document.createElement("li");
                hLi.innerText = msg;
                hUl.appendChild(hLi);
            });
            (0, $kwZWC.flashInfo)(hUl, "danger");
        } else (0, $kwZWC.flashInfo)(error, "danger");
    }
    // ajax: (...p: any) => any = Utils.ajax;
    // getUrl: (...p: any) => any = Utils.getUrl;
    // ajaxForm: (...p: any) => any = Utils.ajaxForm;
    hasAnyAttach() {
        return this.tree.rootNode.children.length > 0;
    }
    constructor(...args){
        super(...args);
        this.ids = {};
        this.attachId = null;
        this.cl = new (0, $jRjEI.TicketsCL)();
        this.id = null;
        this.parentId = null;
    }
}

});

parcelRegister("8DbHm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UiTabs = void 0;

var $dMN2n = parcelRequire("dMN2n");
class $648b0a48d10ea07a$var$UiTabs extends $dMN2n.MuWidget {
    constructor(){
        // public tabIds : string[];
        super(...arguments);
        this.labelAtributeName = "tab-label";
        this.tabLabels = {};
        this.liClassName = "nav-item";
        this.aClassName = "nav-link";
        this.aActiveClassName = "nav-link active";
        this.onSelectTab = null;
        this.selectedTabId = null;
    }
    afterIndex() {
        var _a;
        this.container.classList.add("nav", "nav-tabs");
        (_a = this.muParent) === null || _a === void 0 || _a.muOnAfterIndex.push(()=>this.makeTabs());
    }
    makeTabs() {
        this.container.innerHTML = "";
        let firstMuId = null;
        if (this.muParent) {
            for(let muId in this.muParent.ui){
                const tabContent = this.muParent.ui[muId];
                let label = tabContent.getAttribute(this.labelAtributeName);
                if (label === null) continue;
                if (firstMuId == null) firstMuId = muId;
                const hLi = document.createElement("li");
                hLi.className = this.liClassName;
                const hA = document.createElement("span");
                hA.addEventListener("click", ()=>{
                    this.selectTab(muId);
                    if (this.onSelectTab) this.onSelectTab(muId);
                });
                hA.innerText = label;
                hLi.appendChild(hA);
                this.tabLabels[muId] = hA;
                this.container.appendChild(hLi);
            }
            if (firstMuId) this.selectTab(firstMuId);
        }
    }
    selectTab(selectedMuId) {
        var _a;
        for(let muId in this.tabLabels){
            const tabLabel = this.tabLabels[muId];
            let isActive = selectedMuId === muId;
            tabLabel.className = isActive ? this.aActiveClassName : this.aClassName;
            (_a = this.muParent) === null || _a === void 0 || _a.muVisible(isActive, muId);
            if (isActive) this.selectedTabId = muId;
        }
    }
}
module.exports.UiTabs = $648b0a48d10ea07a$var$UiTabs;

});

parcelRegister("8SP6u", function(module, exports) {

$parcel$export(module.exports, "Sandbox", () => $97bebe3ea8cf8d5e$export$aaaea0ead6b8e811);

var $dMN2n = parcelRequire("dMN2n");
class $97bebe3ea8cf8d5e$export$aaaea0ead6b8e811 extends (0, $dMN2n.MuWidget) {
    beforeIndex() {
        this.muAppendContent(`
		<ul mu="treeList:TreeView">
			<li mu=":.@item">
				<span mu-bind="name"></span>
				<ul mu-id="children"></ul>
			</li>
		</ul>
		<div mu="treeLinear:TreeView">
			<div mu=':.@item#plunge|append("em"):style.marginLeft'>
				<span mu-bind="name"></span>
			</div>		
		</div>
		`);
    }
    afterIndex() {
        const data1 = [
            {
                name: "Foo",
                children: [
                    {
                        name: "Bar"
                    },
                    {
                        name: "Baz"
                    }
                ]
            }
        ];
        const data2 = [
            {
                name: "foo",
                id: 1,
                parentId: null
            },
            {
                name: "bar",
                id: 2,
                parentId: 1
            },
            {
                name: "baz",
                id: 3,
                parentId: 2
            },
            {
                name: "eee",
                id: 4,
                parentId: 456
            }
        ];
        this.muNamedWidget.treeList.render(data1, {
            srcStructFormat: "childField",
            outStructType: "plunge"
        });
        this.muNamedWidget.treeLinear.render(data1, {
            srcStructFormat: "childField",
            outStructType: "indent"
        });
        this.muNamedWidget.treeList.render(data2, {
            srcStructFormat: "parentField",
            outStructType: "plunge"
        });
        this.muNamedWidget.treeLinear.render(data2, {
            srcStructFormat: "parentField",
            outStructType: "indent"
        });
    }
}

});

parcelRegister("FHuq7", function(module, exports) {

$parcel$export(module.exports, "UiPqmFilter", () => $f70f796211481121$export$c926a4bc72ed8b86);

var $6Taw3 = parcelRequire("6Taw3");

var $8iO6j = parcelRequire("8iO6j");

var $kwZWC = parcelRequire("kwZWC");
class $f70f796211481121$export$c926a4bc72ed8b86 extends (0, $6Taw3.BaseMuWidget) {
    beforeIndex() {
        this.muRegisterEvent("change");
        this.muAppendContent(`<div mu="tree:TreeSelector"></div>`);
    }
    bindData(data) {
        data = [
            {
                name: "v\u0161e",
                pqmItemId: "none"
            },
            ...data
        ];
        const tree = this.muNamedWidget.tree;
        tree.afterItemRender = (item)=>{
            if (!item.data.pqmItemId) item.ui.title.classList.add("strong");
            else {
                item.ui.title.classList.add("icon-before-document-dir");
                item.muVisible(false, "bCollapse");
            }
            if (item.data.count) item.ui.title.append((0, $kwZWC.createHtmlElement)("span", {
                "class": "badge bg-secondary float-right"
            }, item.data.count.toString()));
        };
        const st = new (0, $8iO6j.SlashTree)(data, "name");
        const treeData = st.exportAs((node)=>{
            return {
                data: node.data,
                id: node.key,
                children: node.items,
                title: node.name
            };
        }, "children").children;
        tree.bindTree(treeData);
    }
    tree_change(ev, a, ti) {
        if (ti.data.pqmItemId) this.muDispatchEvent("change", ti.data.pqmItemId === "none" ? null : ti.data.pqmItemId, ti.data.pqmItems);
        else {
            ti.bCollapse_click();
            this.muNamedWidget.tree.setSelected(this.callMethodInFirstAncestors("getLastPqmItemId"), false);
        }
    }
}

});


var $dMN2n = parcelRequire("dMN2n");

var $bjpdy = parcelRequire("bjpdy");
var $49ce2c16b64b24d3$exports = {};
"use strict";
Object.defineProperty($49ce2c16b64b24d3$exports, "__esModule", {
    value: true
});
$49ce2c16b64b24d3$exports.MuLabelFor = void 0;

var $d4ug8 = parcelRequire("d4ug8");
class $49ce2c16b64b24d3$var$MuLabelFor {
    beforeIndexElement(ev) {
        if (ev.opts.for) {
            const id = ev.opts.for;
            const iddb = $49ce2c16b64b24d3$var$getIdDb(ev.widget);
            if (id.startsWith("error:")) {
                const ids = id.substr(6).split(",").map((s)=>s.trim());
                for (const eid of ids){
                    if (ev.widget.ui[eid]) ev.widget.ui[eid].errorLabel = ev.element;
                    else if (iddb["bind:" + eid]) iddb["bind:" + eid].errorLabel = ev.element;
                    else iddb["error:" + eid] = ev.element;
                }
            } else {
                if (!iddb[id]) iddb[id] = $d4ug8.MuUIDs.next("id");
                const did = iddb[id];
                ev.element.setAttribute("for", did);
                if (ev.widget.ui[id]) ev.widget.ui[id].id = did;
                if (iddb["bind:" + id]) iddb["bind:" + id].id = did;
            }
        }
        if (ev.opts.id || this.alsoUseBind && ev.opts.bind) {
            const id = ev.opts.id || ev.opts.bind;
            const iddb = $49ce2c16b64b24d3$var$getIdDb(ev.widget);
            if (this.alsoUseBind && ev.opts.bind) iddb["bind:" + ev.opts.bind] = ev.element;
            if (iddb[id]) ev.element.id = iddb[id];
            if (iddb["error:" + id]) ev.element.errorLabel = iddb["error:" + id];
        }
        if (ev.opts.name) {
            const iddb = $49ce2c16b64b24d3$var$getIdDb(ev.widget);
            const k = "name:" + ev.opts.name;
            if (!iddb[k]) iddb[k] = $d4ug8.MuUIDs.next("name");
            ev.element.setAttribute("name", iddb[k]);
        }
    }
    static register(muWidget, alsoUseBind = false) {
        const inst = new $49ce2c16b64b24d3$var$MuLabelFor(alsoUseBind);
        muWidget.plugIns.push({
            beforeIndexElement: (ev)=>inst.beforeIndexElement(ev)
        });
    }
    /**
     *
     */ constructor(alsoUseBind = false){
        this.alsoUseBind = alsoUseBind;
    }
}
$49ce2c16b64b24d3$exports.MuLabelFor = $49ce2c16b64b24d3$var$MuLabelFor;
function $49ce2c16b64b24d3$var$getIdDb(widget) {
    if (!widget.muPluginMuLabelFor) widget.muPluginMuLabelFor = {};
    return widget.muPluginMuLabelFor;
}


var $7e9fd3a9db6ce9f3$exports = {};
"use strict";
Object.defineProperty($7e9fd3a9db6ce9f3$exports, "__esModule", {
    value: true
});
$7e9fd3a9db6ce9f3$exports.MuKeyBind = void 0;
class $7e9fd3a9db6ce9f3$var$MuKeyBind {
    static register(muWidget, alsoUseBind = false) {
        const inst = new $7e9fd3a9db6ce9f3$var$MuKeyBind();
        muWidget.plugIns.push({
            afterIndexElement: (ev)=>inst.afterIndexElement(ev)
        });
    }
    afterIndexElement(ev) {
        if (ev.opts.keybind) {
            const defs = this.parseDefs(ev.opts.keybind);
            if (defs.length) ev.element.addEventListener("keyup", (kev)=>{
                for (const def of defs)if (kev.ctrlKey == !!def.modificators.includes("ctrl") && kev.altKey == !!def.modificators.includes("alt") && kev.metaKey == !!def.modificators.includes("meta") && kev.shiftKey == !!def.modificators.includes("shift") && kev.key.toLowerCase() == def.key.toLowerCase()) {
                    kev.preventDefault();
                    kev.stopPropagation();
                    ev.widget.ui[def.controlId].click();
                }
            });
        }
    }
    parseDefs(defs) {
        const res = [];
        for (const def of defs.split(";")){
            const m = / *^((ctrl\+|alt\+|shift\+|meta\+)*)([^:+]+|\+|\:):(.+)? *$/.exec(def);
            if (!m) {
                console.error("Invalid keybind '" + def + "'");
                continue;
            }
            // console.log(m);
            res.push({
                modificators: (m[1] || "").split("+").filter((k)=>!!k),
                key: m[3],
                controlId: m[4]
            });
        }
        return res;
    }
}
$7e9fd3a9db6ce9f3$exports.MuKeyBind = $7e9fd3a9db6ce9f3$var$MuKeyBind;


parcelRequire("3hKcV");
parcelRequire("fdJlN");
class $ca844d8cdf4fa0da$export$474ce348c0234c8b {
    static register() {
        // @ts-ignore
        window.MuInspector = $ca844d8cdf4fa0da$export$474ce348c0234c8b;
    }
    static getClassPath(element) {
        const res = [];
        let pe = true;
        while(element){
            if (element.classList.length > 0) {
                if (!pe) res.push(" > ");
                res.push("." + Array.from(element.classList).join("."));
                pe = false;
            } else pe = true;
            element = element.parentElement;
        }
        return res.reverse().join("");
    }
}



var $bjpdy = parcelRequire("bjpdy");

var $kwZWC = parcelRequire("kwZWC");
function $74dc79f9565e02ec$export$35f05d67fb7add76() {
    (0, $bjpdy.MuBinder).filters.percent = (value)=>value.toString() + "%";
    (0, $bjpdy.MuBinder).filters.percentD = (value)=>(value * 100).toString() + "%";
    (0, $bjpdy.MuBinder).filters.number2d = (value)=>(Math.round(value * 100) / 100).toFixed(2).toLocaleString();
    (0, $bjpdy.MuBinder).filters.date = function(value, ev, format = "date") {
        if (!value) return "";
        if (typeof value === "string") value = new Date(value);
        //todo: format
        const optss = {
            date: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            },
            datetime: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
            }
        };
        return value.toLocaleDateString("cz-CZ", optss[format]);
    };
    (0, $bjpdy.MuBinder).filters.dateTime = (value, ev, format = "d.m.Y H:i")=>{
        if (!value) return "";
        value = (0, $kwZWC.toDate)(value);
        return (0, $kwZWC.formatDate)(format === "auto-date-time" ? value.getHours() || value.getMinutes() || value.getSeconds() ? "d.m.Y H:i" : "d.m.Y" : format, value);
    };
    (0, $bjpdy.MuBinder).filters.snumber = (value)=>{
        let f = true;
        let res = "";
        value = "   " + value.toString().padStart(3, "0");
        res = "," + value.substr(-2);
        for(let p = value.length - 5; p >= 0; p -= 3)res = " " + value.substr(p, 3) + res;
        return res;
    };
    (0, $bjpdy.MuBinder).filters.price = (value)=>value;
    (0, $bjpdy.MuBinder).filters.priceI100 = (value)=>parseInt(value) / 100;
    (0, $bjpdy.MuBinder).filters.priceI100r = (value)=>Math.round(parseFloat(value) * 100);
    (0, $bjpdy.MuBinder).filters.priceV = (value)=>(0, $bjpdy.MuBinder).filters.snumber(Math.round(value * 100));
    (0, $bjpdy.MuBinder).filters.dateToInput = (date, ev, onlyDate)=>{
        if (!date) return "";
        if (typeof date === "string") date = new Date(date);
        else if (date instanceof Date) ;
        else if (typeof date === "object") return onlyDate ? date.date?.substr(0, 10) : date.date?.substr(0, 18)?.replace(" ", "T");
        const timezoneOffset = date.getTimezoneOffset() * 60000;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const localDateFormat = `${year}-${month}-${day}`;
        const localDateTimeFormat = new Date(date - timezoneOffset).toISOString();
        return localDateFormat + (!onlyDate ? `T${localDateTimeFormat.substr(11, 8)}` : "");
    };
    (0, $bjpdy.MuBinder).filters.dateToInputD = (date, ev)=>(0, $bjpdy.MuBinder).filters.dateToInput(date, ev, true);
    (0, $bjpdy.MuBinder).filters.getField = (src, ev, field)=>src ? src[field] : undefined;
    (0, $bjpdy.MuBinder).filters.any = (src)=>src.length > 0;
    (0, $bjpdy.MuBinder).filters.join = (arr, ev, separator = ", ")=>arr.join(separator);
    (0, $bjpdy.MuBinder).filters.bwContrasted = (color)=>((0, $kwZWC.getBrightness)(color) ?? 255) > 160 ? "black" : "white";
}


var $e2f010dce70f61cc$require$setupFilters = $74dc79f9565e02ec$export$35f05d67fb7add76;











































































































(0, $dMN2n.MuWidget).registerAll((parcelRequire("1WNaB")), (parcelRequire("1Svw2")), (parcelRequire("3cBch")), (parcelRequire("faZ90")), (parcelRequire("ao0AT")), (parcelRequire("gpQZH")), (parcelRequire("3cBch")), (parcelRequire("5l93r")), (parcelRequire("9Oenc")), (parcelRequire("cgG2b")), (parcelRequire("ao0AT")), (parcelRequire("aDZtI")), (parcelRequire("5yCCu")), (parcelRequire("60pHU")), (parcelRequire("kvCpk")), (parcelRequire("3n82a")), (parcelRequire("5d8um")), (parcelRequire("dxqmh")), (parcelRequire("5kIEs")), (parcelRequire("b1wkv")), (parcelRequire("jPK1g")), (parcelRequire("b1wkv")), (parcelRequire("l2pJa")), (parcelRequire("9fBpR")), (parcelRequire("9oBmL")), (parcelRequire("6avXl")), (parcelRequire("epeYa")), (parcelRequire("5kIEs")), (parcelRequire("asW3g")), (parcelRequire("hjT8q")), (parcelRequire("9Oenc")), (parcelRequire("EetfQ")), (parcelRequire("kmRqw")), (parcelRequire("iQTdn")), (parcelRequire("gxt3I")), (parcelRequire("g7kTW")), (parcelRequire("lbTwC")), (parcelRequire("5epYV")), (parcelRequire("3Yb7l")), (parcelRequire("ktJgr")), (parcelRequire("75yia")), (parcelRequire("8wyRe")), (parcelRequire("7wRzu")), (parcelRequire("jW8G6")), (parcelRequire("k638V")), (parcelRequire("izbI7")), (parcelRequire("jtPnK")), (parcelRequire("hM3wT")), (parcelRequire("fDXUL")), (parcelRequire("akyCl")), (parcelRequire("2GpDn")), (parcelRequire("fgCVL")), (parcelRequire("9Htj6")), (parcelRequire("4lD3q")), (parcelRequire("jYXU5")), (parcelRequire("chE5m")), (parcelRequire("6dyRm")), (parcelRequire("iF9nm")), (parcelRequire("aMsft")), (parcelRequire("ffuEw")), (parcelRequire("kMzi9")), (parcelRequire("3pvHV")), (parcelRequire("cLxj2")), (parcelRequire("3h4tc")), (parcelRequire("9DsTT")), (parcelRequire("gIRkU")), (parcelRequire("kedEG")), (parcelRequire("1YGhk")), (parcelRequire("1OGiK")), (parcelRequire("f69Td")), (parcelRequire("6cIq5")), (parcelRequire("ekS8C")), (parcelRequire("7tZdD")), (parcelRequire("5OSdp")), (parcelRequire("3uYki")), (parcelRequire("jXacm")), (parcelRequire("fddaE")), (parcelRequire("3hKcV")), (parcelRequire("fudPg")), (parcelRequire("2rQ63")), (parcelRequire("5cJAH")), (parcelRequire("9DFQu")), (parcelRequire("fhHvw")), (parcelRequire("MZo6F")), (parcelRequire("ktZi8")), (parcelRequire("xnjgP")), (parcelRequire("8C0Ku")), (parcelRequire("64s6w")), (parcelRequire("kAYTi")), (parcelRequire("fdJlN")), (parcelRequire("xw3FD")), (parcelRequire("5HXez")), (parcelRequire("bpp3O")), (parcelRequire("iUwjk")), (parcelRequire("6T4bi")), (parcelRequire("f43qp")), (parcelRequire("1Ap5b")), // require("./dms/fields/FieldInput"),
// require("./dms/fields/FieldSelect"),
// require("./dms/fields/FieldTree"),
// require("./dms/fields/FieldSearch"),
// require("./dms/fields/FieldOrgProject"),
// require("./dms/fields/FieldBuSubject"),
(parcelRequire("gd8XR")), (parcelRequire("lfPg5")), (parcelRequire("l8pp6")), (parcelRequire("jDZcV")), (parcelRequire("71Nh7")), (parcelRequire("6fLqv")), (parcelRequire("kclTr")), (parcelRequire("8DbHm")), (parcelRequire("8SP6u")), (parcelRequire("FHuq7")));
(0, $49ce2c16b64b24d3$exports.MuLabelFor).register((0, $dMN2n.MuWidget), true);
$e2f010dce70f61cc$require$setupFilters();

(0, $dMN2n.MuWidget).registerAs((parcelRequire("4hoex")).IMuWidget, ".");
(0, $bjpdy.MuBinder).register((0, $dMN2n.MuWidget));
(0, $dMN2n.MuWidget).fixOldWidgets = "silent";
(0, $7e9fd3a9db6ce9f3$exports.MuKeyBind).register((0, $dMN2n.MuWidget));
(0, $ca844d8cdf4fa0da$export$474ce348c0234c8b).register();
(0, $dMN2n.MuWidget).startup(undefined, function(muRoot) {
    window.rootMuWidget = muRoot;
});

})();
//# sourceMappingURL=index.js.map
